{
  "common": {
    "btn": {
      "create": "បង្កើតថ្មី",
      "create-new": "បង្កើតថ្មី",
      "create-account": "បង្កើតគណនី",
      "later": "ពេលក្រោយ",
      "add": "បន្ថែម",
      "renew": "បន្ត",
      "clone": "ចម្លង",
      "clone-resource": "ចម្លងពីគំរូដើម",
      "update": "កែប្រែ",
      "submit": "បញ្ជូន",
      "sign-in": "ចូល",
      "edit": "កែប្រែ",
      "confirm": "បញ្ជាក់",
      "delete": "លុប",
      "new-record": "កំណត់ត្រាថ្មី",
      "generate": "បង្កើត",
      "close": "បិទ",
      "cancel": "បោះបង់",
      "manage": "គ្រប់គ្រង",
      "print": "បោះពុម្ព",
      "download": "ទាញយក",
      "action": {
        "label": "សកម្មភាព",
        "option": {
          "view": "មើលសេចក្តីលម្អិត",
          "edit": "កែប្រែ",
          "delete": "លុប",
          "manage": "គ្រប់គ្រង"
        }
      }
    },
    "main-header": {
      "edit-profile": "កែប្រែពត៌មានគណនី",
      "change-pwd": "ដូរលេខសម្ងាត់",
      "sign-out": "ចាកចេញ",
      "admin-setting": "ការកំណត់របស់អ្នកគ្រប់គ្រង"
    },
    "footer": {
      "privacy": "ឯកជនភាព",
      "term": "លក្ខខណ្ឌ",
      "support": "ជំនួយ",
      "feedback": "មតិកែលម្អ"
    },
    "aiml-app": {
      "main-header": {
        "my-task": "ភារកិច្ចរបស់ខ្ញុំ",
        "my-applications": "កម្មវិធីរបស់ខ្ញុំ"
      },
      "sub-header1": {
        "title": "កម្មវិធីទាំងអស់"
      }
    },
    "required": "ទាមទារ",
    "confirmation": "ការបញ្ជាក់",
    "a11y": {
      "loading": "កំពុងផ្ទុក…"
    },
    "delete-message-one-item": "លុប មួយ {entity_name}? អី្វដែលត្រូវបានលុបហើយមិនអាចយកមកវិញបានទេ។",
    "delete-message-multiple-items": "លុប {selected_item_count} {entity_name}? អី្វដែលត្រូវបានលុបហើយមិនអាចយកមកវិញបានទេ។"
  },
  "public": {
    "sing-in": {
      "header": "ចូលប្រើប្រាស់កម្មវិធី OptimalHR",
      "email": "អុីម៉េល",
      "password": "លេខសម្ងាត់"
    },
    "register": {
      "header": "បង្កើតគណនីអ្នកប្រើប្រាស់ថ្មី",
      "first-name": {
        "label": "នាមខ្លួន",
        "description": "ឈ្មោះរបស់អ្នក"
      },
      "last-name": {
        "label": "គោត្តនាម",
        "description": "នាមត្រគោលរបស់អ្នក"
      },
      "email": {
        "label": "អុីម៉េល",
        "description": "ប្រអប់សំបុត្រអេឡិកត្រូនិករបស់អ្នក"
      },
      "organization": {
        "label": "ស្ថាប័ន",
        "description": "ឈ្មោះស្ថាប័នរបស់អ្នក (ក្រុមហ៊ុន អង្គការ សាលារៀន ។ល។)"
      },
      "process": {
        "header": "បង្កើតគណនីអ្នកប្រើប្រាស់ថ្មី",
        "title": "AIML SaaS កំពុងបង្កើតគ្រឿងបង្គុំរបស់ប្រព័ន្នដែលចាំបាច់សំរាប់ការកំណត់អត្តសញ្ញាណនិងការដាក់ដោយឡែកនូវទិន្នន័យរបស់គណនីអ្នកប្រើប្រាស់របស់អ្នក។ ដំណើរការនេះមានរយៈពេល ២ ទៅ ៣ នាទី។",
        "create-user-and-identity-directory": "កំពុងបង្កើតបញ្ជីអ្នកប្រើប្រាស់និងបញ្ជីអត្តសញ្ញាណ",
        "create-policy-and-role": "កំពុងបង្កើតគោលការណ៍នៃការកំណត់អត្តសញ្ញាណនិងការដាក់ដោយឡែក ព្រមទាំងតួនាទីគោលសំរាប់អ្នកប្រើប្រាស់",
        "apply-policy-and-role": "កំពុងភ្ជាប់គោលការណ៍ទាំងនោះជាមួយតួនាទី",
        "create-admin-user-and-tenant-records": "កំពុងបង្កើតគណនីគ្រប់គ្រងនិងទិន្នន័យផ្សេងទៀតដែលចាំបាច់សំរាប់ការចាប់ផ្តើមប្រើប្រាស់របស់អ្នក",
        "message": "រួចរាល់! ពត៌មានសំរាប់ចូលប្រើប្រាស់ត្រូវបានបញ្ជូនទៅអុីម៉េល {email_address}",
        "back": "ទៅកាន់",
        "login-screen": "អេក្រង់ចូលប្រើប្រាស់"
      }
    },
    "confirm-tenant": {
      "main-title": "អបអរសាទរសំរាប់ការចូលប្រើប្រាស់បានជោគជ័យ!",
      "description": "សូមប្តូរលេខសម្ងាត់របស់អ្នកមុននឹងបន្ត",
      "current-password": {
        "title": "លេខសម្ងាត់បច្ចុប្បន្ន",
        "description": "លេខសម្ងាត់បណ្តោះអាសន្នដែលត្រូវបានផ្ញើទៅកាន់អុីម៉េលរបស់អ្នក"
      },
      "new-password": {
        "title": "លេខសម្ងាត់ថ្មី",
        "description": "តិចបំផុត៨តួដែលក្នុងនោះតម្រូវឲ្យមានអក្សរធំ អក្សរតូចនិងលេខ"
      },
      "confirm-password": {
        "title": "បញ្ជាក់លេខសម្ងាត់ថ្មី",
        "description": "បញ្ចូលលេខសម្ងាត់ថ្មីម្តងទៀត"
      },
      "error-messaga": {
        "pwd-not-match": "លេខសម្ងាត់ថ្មីមិនដូចគ្នាទេ",
        "pwd-required": "សូមបញ្ចូលលេខសម្ងាត់បច្ចុប្បន្ន លេខសម្ងាត់ថ្មី និងបញ្ជាក់លេខសម្ងាត់ថ្មី",
        "pwd-required-type": "លេខសម្ងាត់ត្រូវមានប្រវែងតិចបំផុត៨តួដែលក្នុងនោះតម្រូវឲ្យមានអក្សរធំ អក្សរតូចនិងលេខ"
      }
    },
    "change-pwd": {
      "main-title": "Change password",
      "description": " ",
      "current-pwd": {
        "title": "Current password",
        "description": "Your current password login"
      },
      "new-pwd": {
        "title": "New password",
        "description": "Minimum password length is 8. Required uppercase letters, lowercase letters and numbers."
      },
      "confirm-pwd": {
        "title": "Confirm new password",
        "description": "Repeat your new password."
      },
      "error-messaga": {
        "pwd-not-match": "Passwords do not match.",
        "pwd-required": "Current, new, and confirm passwords are required. Please enter these values.",
        "pwd-required-type": "Password must contain uppercase letters, lowercase letters, numbers and 8 characters minimum."
      }
    },
    "edit-profile": {
      "main-title": "Edit profile",
      "description": " ",
      "first-name": "First name",
      "last-name": "Last name"
    }
  },
  "aimlApp": {
    "my-tasks": {
      "main-header": "ភារកិច្ចរបស់ខ្ញុំ",
      "placeholder-search": "ស្វែងរកភារកិច្ចតាមឈ្មោះ"
    },
    "my-applications": {
      "main-header": "កម្មវិធីរបស់ខ្ញុំ",
      "placeholder-search": "ស្វែងរកកម្មវិធីតាមឈ្មោះ",
      "all-apps": {
        "title": "កម្មវិធីទាំងអស់",
        "group-human-capital-management": "ការគ្រប់គ្រងធនធានមនុស្ស",
        "group-administration": "ការគ្រប់គ្រងកម្មវិធី"
      }
    },
    "recently-visited": {
      "title": "កម្មវិធីដែលបានចូលប្រើប្រាស់ថ្មីៗ"
    }
  },
  "acm": {
    "messageProvisionedResources": {
      "header": "",
      "message": ""
    },
    "user": {
      "list": {
        "main-title": "Users",
        "filter-box-placeholder": "Filter by user name, first name, last name, ...",
        "description": " ",
        "table-name": "user",
        "table-header": {
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "role": "Role",
          "create-at": "Created at",
          "create-by": "Created by"
        },
        "filter-key": {
          "user-name": "Filter by User name",
          "first-name": "Filter by First name",
          "last-name": "Filter by Last name",
          "role": "Filter by Role"
        }
      },
      "form": {
        "main-title-create": "Create new user",
        "main-title-edit": "Edit user",
        "description": "",
        "user-identity": {
          "title": "User identity",
          "user-name": {
            "label": "User name",
            "description": "",
            "placeholder": "Must be a valid email address"
          },
          "first-name": {
            "label": "First name",
            "description": " ",
            "placeholder": "For example, Bopha"
          },
          "last-name": {
            "label": "Last name",
            "description": "",
            "placeholder": "For example, CHAN"
          },
          "line-employee": {
            "label": "Linked employee",
            "description": "",
            "placeholder": ""
          }
        },
        "user-permission": {
          "title": "User permission",
          "system-base-role": {
            "label": "System based role",
            "tenant-user": "Tenant user",
            "tenant-admin": "Tenant admin(administers other users)",
            "description": ""
          },
          "job-base-role": {
            "label": "Job based role",
            "description": "",
            "placeholder": "Select an existing role for this user"
          },
          "policy": {
            "label": "Policy",
            "description": "",
            "placeholder": "Select existing policies defining permissions for those users"
          }
        }
      },
      "detail": {
        "main-title": "User details",
        "description": " ",
        "user-identity": {
          "title": "User identity",
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "permission": {
          "title": "User permission",
          "system-based-role": "System based role",
          "job-based-role": "Job based role",
          "policies": "Policies"
        }
      }
    },
    "policy": {
      "list": {
        "main-title": "Policies",
        "filter-box-placeholder": "Filter by policy name",
        "description": " ",
        "table-name": "policy",
        "table-header": {
          "name": "Name",
          "statements": "Statements",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by policy name"
        }
      },
      "form": {
        "main-title-create": "Create policy",
        "main-title-edit": "Edit policy",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Assistant"
          }
        },
        "statements": {
          "title": "Statements",
          "discription": "A policy statement defines a set of permissions used to a assign to a either a Role, User or User Group. A policy can have multiple statements, e.g. Statement 1 define permissions to access resources under Directory service while Statement 2 is for Employees service",
          "statement-name": {
            "label": "Statement name",
            "description": "",
            "placeholder": "E.g. Directory Service"
          },
          "serviec-name": {
            "label": "Service name",
            "description": "",
            "placeholder": "Select the service to which you want to have access control"
          },
          "resources": {
            "label": "Resources",
            "description": "",
            "placeholder": "Select those resource(s) to which you want to have access control"
          },
          "action": {
            "label": "Actions",
            "description": "",
            "placeholder": "Select those action(operations) to include in this statement"
          },
          "effect": {
            "label": "Effect",
            "description": "Specify whether to Allow or Deny above Actions/Operations under this statement",
            "allow": "Allow",
            "deny": "Deny"
          }
        }
      },
      "detail": {
        "main-title": "Policy details",
        "description": "",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Policy type",
          "policy-name": "Policy name",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "statement": {
          "title": "Statements",
          "name": "Name",
          "service": "Service",
          "details": {
            "view-detail": "View details",
            "title": "Statement details",
            "name": "Name",
            "service": "Service",
            "effect": "Effect",
            "resources": "Resources",
            "actions": "Actions"
          }
        }
      }
    },
    "role": {
      "list": {
        "main-title": "Roles",
        "filter-box-placeholder": "Filter by role name",
        "description": " ",
        "table-name": "role",
        "table-header": {
          "name": "Name",
          "statements": "Policies",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by role name"
        }
      },
      "form": {
        "main-title-create": "Create role",
        "main-title-edit": "Edit role",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Executive"
          }
        },
        "permissions": {
          "title": "Permissions",
          "policies": {
            "label": "Policies",
            "description": "",
            "placeholder": "Select one or more existing policies to define permissions"
          }
        }
      },
      "detail": {
        "main-title": "Role details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Role name",
          "policy-name": "Role type",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "permission": {
          "title": "Permission",
          "policies": "Policies"
        }
      }
    },
    "user-group": {
      "list": {
        "main-title": "User groups",
        "filter-box-placeholder": "Filter by group name",
        "description": " ",
        "table-name": "user group",
        "table-header": {
          "group-name": "Group name",
          "user": "User",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by group name"
        }
      },
      "form": {
        "main-title-create": "Create user group",
        "main-title-edit": "Edit user group",
        "description": "",
        "group-name": {
          "label": "Group name",
          "description": "",
          "placeholder": "For example, HR Interns"
        },
        "group-members": {
          "label": "Group members",
          "description": "",
          "placeholder": "Select existing users to become members of the group"
        },
        "group-permissions": {
          "label": "Group permissions",
          "description": "",
          "placeholder": "Select existing policies defining permissions for those users"
        }
      },
      "detail": {
        "main-title": "User group details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "group-name": "Group name",
          "group-members": "Group members",
          "group-permission": "Group permission",
          "created-at": "Created at",
          "created-by": "Created by"
        }
      }
    }
  },
  "directory": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "",
      "people": "",
      "organizations": "",
      "data-migrations": ""
    },
    "people": {
      "list": {
        "main-title": "",
        "filter-box-placeholder": "",
        "table-header": {
          "full-name": "",
          "sex": "",
          "nationality": "",
          "contact-info": ""
        },
        "filter-key": {
          "full-name": "",
          "middle-name": "",
          "last-name": ""
        }
      },
      "form": {
        "main-title-create": "",
        "main-title-edit": "",
        "personal-data": {
          "sub-title": "",
          "title": {
            "label": "",
            "description": ""
          },
          "full-name": {
            "label": "",
            "description": ""
          },
          "first-name": {
            "label": "First name",
            "description": " "
          },
          "last-name": {
            "label": "",
            "description": ""
          },
          "middle-name": {
            "label": "",
            "description": ""
          },
          "gender": {
            "label": "",
            "description": "",
            "options": {
              "male": "",
              "female": ""
            }
          },
          "date-of-birth": {
            "label": "",
            "description": ""
          },
          "country-of-birth": {
            "label": "",
            "description": " "
          },
          "province-of-birth": {
            "label": "",
            "description": ""
          },
          "nationality": {
            "label": "",
            "description": ""
          },
          "national-id": {
            "label": "National id",
            "description": " "
          },
          "marital-status": {
            "label": "",
            "description": ""
          },
          "profile-photo": {
            "label": "",
            "description": ""
          },
          "profile-summary": {
            "label": "",
            "description": ""
          },
          "achievement": {
            "label": "",
            "description": ""
          }
        },
        "contact-info": {
          "sub-title": "",
          "contact-type": {
            "label": "",
            "description": ""
          },
          "contact-value": {
            "label": "",
            "description": ""
          }
        }
      },
      "details": {
        "main-title": "",
        "personal-data": {
          "sub-title": "",
          "first-name": "",
          "middle-name": "",
          "last-name": "",
          "gender": "",
          "date-of-birth": "",
          "place-of-birth": "",
          "nationality": "",
          "marital-status": ""
        },
        "contact-info": {
          "sub-title": ""
        }
      }
    },
    "organizations": {
      "basic-form": {
        "main-header-create": "Create organization profile",
        "main-header-edit": "Edit organization profile",
        "basic-data": {
          "title": "Basic data",
          "offical-name": "Official name",
          "short-name": "Short name",
          "nature": "Nature",
          "industry": "Industry"
        }
      }
    }
  },
  "employment": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "employer": "និយោជក"
    },
    "employer": {
      "executiveOversight": {
        "search": "ស្វែងរកតាមគម្រោង ឬអ្នកត្រួតពិនិត្យ...",
        "executiveOversightForm": {
          "title": "កំណត់អ្នកត្រួតពិនិត្យប្រតិបត្តិ",
          "editForm": {
            "title": "កែប្រែការចាត់តាំងត្រួតពិនិត្យ"
          },
          "outsourcingProject": {
            "title": "គម្រោង / ក្រុមហ៊ុន Outsourcing",
            "description": "ជ្រើសរើសក្រុមហ៊ុនដែលត្រូវគ្រប់គ្រងសម្រាប់ការចាត់តាំងត្រួតពិនិត្យ",
            "search": "-- ជ្រើសរើសគម្រោង --"
          },
          "SLTMembers": {
            "title": "សមាជិក SLT",
            "description": "ជ្រើសរើសសមាជិក SLT ម្នាក់ ឬច្រើននាក់ដើម្បីចាត់តាំង",
            "search": "ស្វែងរកបុគ្គលិក..."
          }
        },
        "assignOverseer": "អ្នកត្រួតពិនិត្យដែលបានចាត់តាំង",
        "noAssignOverseer": "មិនទាន់មានអ្នកត្រួតពិនិត្យ",
        "alreadyAssigned": "បានកំណត់រួចហើយ"
      },
      "list": {
        "main-title": "និយោជក",
        "filter-box-placeholder": " ",
        "description": "ប្រសិនបើអ្នកកំពុងគ្រប់គ្រងអាជីវកម្ម សាខា ឬគម្រោងច្រើន អ្នកអាចបង្កើតនិយោជកផ្សេងៗគ្នាសំរាប់ការគ្រប់គ្រងបុគ្គលិក បញ្ជីប្រាក់ខែ និងទិន្នន័យដទៃទៀតរបស់ពួកគេទាំងអស់នៅក្នុងគណនីអ្នកប្រើប្រាស់ (Tenant account) របស់អ្នកតែមួយ។ ចំណាំ៖ និយោជកឈ្មោះ  {organization_name} គឺត្រូវបានបង្កើតឡើងដោយស្វ័យប្រវត្តិសម្រាប់អ្នក។",
        "table-name": "និយោជក",
        "table-header": {
          "full-name": "ឈ្មោះពេញ",
          "abbreviated-name": "ឈ្មោះកាត់",
          "employee-id-format": "ទំរង់លេខកូដបុគ្គលិក",
          "type": "ប្រភេទនិយោជក",
          "active-employee": "ចំនួនបុគ្គលិកកំពុងបម្រើការងារ"
        },
        "filter-key": {
          "full-name": "ច្រោះតាមរយៈឈ្មោះពេញ",
          "abbreviated-name": "ច្រោះតាមរយៈឈ្មោះកាត់",
          "type": "ច្រោះតាមរយះប្រភេទនិយោជក"
        }
      },
      "delete-message": "លុបនិយោជកនេះនឹងលុបទិន្នន័យដទៃទៀតទាំងអស់របស់គាត់ ឧទាហរណ៍បុគ្គលិកទាំងអស់នៅក្រោមនិយោជកនេះនឹងបានត្រូវលុបផងដែរ។ តើអ្នកពិតជាចង់លុបមែនឬ?",
      "detail": {
        "main-title": "ពត៌មាននិយោជក",
        "sub-title1": {
          "title": "ពត៌មានទូទៅ",
          "full-name": "ឈ្មោះពេញ",
          "abbreviated-name": "ឈ្មោះខ្លី",
          "employee-id-format": "ទំរង់លេខកូដបុគ្គលិក",
          "created-at": "បង្កើតឡើងនៅ",
          "created-by": "បង្កើតឡើងដោយ",
          "updated-at": "ធ្វើបច្ចុប្បន្នភាពនៅ",
          "updated-by": "ធ្វើបច្ចុប្បន្នភាពដោយ"
        },
        "sub-title2": {
          "title": "ពត៌មានដទៃទៀត",
          "phone-number": "លេខទូរស័ព្ទ",
          "email-address": "អុីម៉េល",
          "street-address": "អសយដ្ឋាន",
          "website": "គេហទំព័រ",
          "logo": " "
        }
      },
      "form": {
        "main-title-create": "បង្កើតនិយោជកថ្មី",
        "main-title-edit": "កែប្រែពត័មាននិយោជក",
        "description": "For a quick creation, you enter just the basic data first while other datails could be entered any time later.",
        "general-info": {
          "title": "ពត៌មានទូទៅ",
          "full-name": {
            "label": "ឈ្មោះពេញ",
            "description": "What is the full name of the employer entity? E.g. Angkor Brilliant Consulting."
          },
          "abbreviated-name": {
            "label": "ឈ្មោះខ្លី",
            "description": "What is its short name? E.g. ABC"
          },
          "employee-id-format": {
            "label": "ទំរង់លេខកូដបុគ្គលិក",
            "description": "The placeholder of employee ID. E.g. ABC-00000"
          }
        },
        "details": {
          "title": "Other info",
          "phone-number": {
            "label": "Phone number(s)",
            "description": "One or more phone numbers"
          },
          "email-address": {
            "label": "Email address(es)",
            "description": "One or more email addresses."
          },
          "street-address": {
            "label": "Address",
            "description": "Street address."
          },
          "website": {
            "label": "Website",
            "description": "Website URL e.g www.abc-consulting.com"
          },
          "logo": {
            "label": "Logo",
            "description": "Image(.jpeg or .png)."
          }
        }
      },
      "manage": {
        "main-title": "ការគ្រប់គ្រងរបស់និយោជក",
        "description": "ខាងក្រោមគឺជាផ្នែកផ្សេងៗនៃការគ្រប់គ្រងនិយោជករបស់អ្នក។ ជ្រើសរើសផ្នែកណាមួយដើម្បីចូលមើលសេចក្តីលម្អិតរបស់វា។",
        "app-sections": {
          "employee": {
            "title": "Employees",
            "description": "គ្រប់គ្រងសំណុំឯកសារបុគ្គលិក",
            "active": "Active"
          },
          "department": {
            "title": "Departments",
            "description": "គ្រប់គ្រងនាយកដ្ឋានរឺផែ្នក",
            "active": "Active"
          },
          "job-profile": {
            "title": "Job Profiles",
            "description": "គ្រប់គ្រងសំណុំឯកសារមុខងារ",
            "active": "Active"
          }
        }
      }
    },
    "employee": {
      "list": {
        "main-title": "Employees",
        "filter-box-placeholder": "Filter by full name, job title, ...",
        "description": " ",
        "table-name": "employee",
        "table-header": {
          "employee-id": "Employee ID",
          "employee-name": "Full name",
          "employee-status": "Status",
          "job-title": "Job title",
          "department": "Department",
          "work-contacts": "Work contacts"
        },
        "filter-key": {
          "employee-id": "Filter by Employee ID",
          "employee-name": "Filter by Full name",
          "employee-status": "Filter by Status",
          "job-title": "Filter by Job title",
          "department": "Filter by Department",
          "work-email": "Filter by Work email"
        }
      },
      "delete-message": "Deleting this employee will delete all his/her related data. Are you sure you want to delete this employee?",
      "form": {
        "main-title-create": "Create new employee",
        "main-title-edit": "Edit employee",
        "description": "For a quick creation, you enter just the employee's personal and job summaries while their other details could be added any time later.",
        "personal-summary": {
          "title": "Personal summary",
          "full-name": {
            "label": "Full name",
            "description": "You can enter their family name and given name, for example SOK Sovatha"
          },
          "gender": {
            "label": "Gender",
            "description": " ",
            "male": "Male",
            "female": "Female"
          },
          "phone-number": {
            "label": "Phone number",
            "description": "Mobile number(s)"
          },
          "email-address": {
            "label": "Email",
            "description": "Email address(es)"
          }
        },
        "job-summary": {
          "title": "Job summary",
          "hire-data": {
            "label": "Hire date",
            "description": "The exact data the employee starts working. Note that this could be different from the date you create this record."
          },
          "employee-classification": {
            "label": "Employee classification",
            "description1": "Employees with fixed duration contracts (FDCs) or undetermined duration contracts (UDCs). \n",
            "description2": "Employees performing work temporarily, intermittently or seasonally.",
            "regular": "Regular",
            "casual": "Casual"
          }
        }
      },
      "detail": {
        "main-title": "Employee details",
        "description": "To have more accurate profile, you need to update the following sections to reflect the employee's current job. To edit data for a section, click on Edit button on the right of the section title.",
        "summaries": {
          "title": "Summaries",
          "employee-id": "Employee ID",
          "full-name": "Full name",
          "employment-status": "Employment status",
          "employee-classification": "Employee classification",
          "position": "Position",
          "department": "Department",
          "hire-date": "Hire date",
          "end-date": "End date",
          "phone-number": "Phone number"
        },
        "employment-detail": {
          "employment-detail": {
            "title": "Employment Details",
            "subsection": {
              "current-job": "Current Job",
              "compensation": "Compensation and Benefits",
              "employment-contract": "Contracts",
              "bank-info": "Bank Information",
              "family-member": "Family Members",
              "work-contact": "Contacts",
              "insurance": "Insurance"
            }
          },
          "personal-detail": {
            "title": "Personal Details",
            "subsection": {
              "bio-data": "Bio Data",
              "contact": "Contacts",
              "dependent": "Dependents",
              "parent": "Parent Information",
              "insurance": "Insurance Membership/NSSF",
              "work-permit": "Workbook/Work Permit"
            }
          },
          "employment-contract": {
            "list": {
              "main-title": "Employment contracts",
              "filter-box-placeholder": "Filter by Job Title, Type, ... ",
              "table-name": "employment contract",
              "table-header": {
                "job-title": "Job title",
                "type": "Type",
                "status": "Status",
                "start-date": "Start date",
                "end-date": "End date"
              },
              "filter-key": {
                "job-title": "Filter by Job Title",
                "type": "Filter by Type",
                "status": "Filter by Status",
                "start-date": "Filter by Start Date",
                "end-date": "Filter by End Date"
              }
            },
            "form": {
              "enable-reminder": "",
              "send-email-reminder": "",
              "send-to": "",
              "main-title-create": "Create new contract",
              "main-title-edit": "Edit contract",
              "main-title-renew": "Renew contract",
              "type": {
                "label": "Type",
                "description": "FDC: Fixed Duration Contract, UDC: Undetermined Duration Contract, Select PROBATION if the contract for the employee covers just the probation period."
              },
              "employment-type": {
                "label": "Employment type",
                "description": " "
              },
              "start-date": {
                "label": "Start date",
                "description": " "
              },
              "end-date": {
                "label": "End date",
                "description": " "
              },
              "period": "With probation period, end date",
              "job-role": {
                "label": "Job role",
                "description": " ",
                "placeholder": "Select a job profile"
              },
              "department": {
                "label": "Department",
                "description": " ",
                "placeholder": "Select a department"
              },
              "line-manager": {
                "label": "Line manager",
                "description": " ",
                "placeholder": "Select line manager"
              },
              "basic-salary": {
                "label": "Basic salary (monthly)",
                "description": " ",
                "placeholder": " "
              },
              "upload-document": {
                "label": "Upload document",
                "description": " "
              }
            },
            "detail": {
              "main-title": "Employment contract details",
              "overview": {
                "enable-reminder": "",
                "send-email-reminder": "",
                "send-to": "",
                "sub-title": "Overview",
                "contract-type": "Contract type",
                "employment-type": "Employment type",
                "job-role": "Job role",
                "department": "Department",
                "line-manager": "Line manager",
                "start-date": "Start date",
                "end-date": "End date",
                "period": "Probation period end date"
              },
              "related-events": {
                "list": {
                  "main-title": "Employment changes",
                  "table-name": "employment change",
                  "table-header": {
                    "type": "Change type",
                    "effective-date": "Effective date",
                    "description": "Description",
                    "created-date": "Created at",
                    "Created-by": "Created by"
                  }
                },
                "form": {
                  "main-title-create": "Create new employment change",
                  "main-title-edit": "Edit employment change",
                  "description": "Fill in those required and any of optional fields below to soundly reflect this change for the employee.",
                  "type": {
                    "label": "Type",
                    "description": "Select a type applicable to change"
                  },
                  "employment-type": {
                    "label": "Employment type",
                    "description": "Specify a employment type"
                  },
                  "effective-date": {
                    "label": "Effective date",
                    "description": "Specify the date from which the change takes effect."
                  },
                  "reason": {
                    "label": "Reason",
                    "description": "What is the motive for the change?"
                  },
                  "job-role": {
                    "label": "Job role",
                    "description": "If the change affects new job role, specify it one below."
                  },
                  "basic-salary": {
                    "label": "Basic salary (monthly)",
                    "description": "If the change affects new basic salary, specify it below."
                  },
                  "department": {
                    "label": "Department",
                    "description": "If the change affects new department/section, specify it below."
                  },
                  "line-manager": {
                    "label": "Line manager",
                    "description": "If the change affects new line manager, specify it below."
                  }
                },
                "detail": {
                  "main-title": "Employment change details",
                  "desciprtion": "",
                  "type": "Change type",
                  "reason": "Reason",
                  "effective-date": "Effective date",
                  "employment-type": "Employment type",
                  "job-role": "Job role",
                  "department": "Department",
                  "line-manager": "Line manager",
                  "created-at": "Created at",
                  "created-by": "Created by",
                  "updated-at": "Updated at",
                  "updated-by": "Updated by",
                  "benefits": {
                    "sub-title": "Benefits"
                  }
                }
              }
            }
          },
          "current-job": {
            "main-title": "Current job",
            "description": " ",
            "job-profile": {
              "see-detail": "See details",
              "sub-titile": "Job profile",
              "position": "Position",
              "grade": "Grade",
              "level": "Level",
              "working-hours-per-week": "Working hours per week",
              "responsibilities": "Responsibilities",
              "requirements": "Requirements",
              "job-description": "Job description"
            },
            "organizational-structure": {
              "sub-titile": "Organizational structure",
              "department": "Department",
              "number-of-subordinates": "Subordinates",
              "line-manager": "Line manager"
            },
            "employment": {
              "sub-titile": "Employment",
              "status": "Status",
              "type": "Type",
              "contract": "Contract",
              "basic-salary": "Basic salary (monthly)",
              "work-schedule": "Work schedule",
              "annual-leave-balance": "Annual leave balance"
            }
          }
        },
        "responsibilities": {
          "responsibilitiesDescription": "Describe the key duties and accountabilities of this role."
        },
        "requirements": {
          "requirementsDescription": "List required skills, experience and qualifications."
        },
        "jobGradeDescription": "Used for compensation and career progression.",
        "employmentLevelDescription": "Defines seniority and role classification.",
        "day": "Days",
        "entitlementType": {
          "title": "Entitlements",
          "entitlementType": "Entitlement Type",
          "column": {
            "daysEarned": "Days Earned",
            "notes": "Notes",
            "openingBalance": "Opening Balance",
            "carriedForward": "Carried Forward",
            "monthlyAccrual": "Monthly Accrual",
            "seniorityAccrual": "Seniority Accrual"
          }
        }
      },
      "employmentDetails": "Employment Details",
      "jobTitle": "Job Title",
      "jobGrade": "Job Grade",
      "employmentLevel": "Employment Level",
      "baseSalary": "Base Salary",
      "workingHoursPerWeek": "Working Hours per Week",
      "workLocation": "Work Location",
      "scheduleName": "Schedule Name",
      "responsibilities": "Responsibilities",
      "requirements": "Requirements",
      "reportingStructure": "Reporting Structure",
      "directManager": "Direct Manager",
      "reports": "Reports",
      "viewReports": "View Reports",
      "organizationalUnit": "Organizational Unit",
      "organizationalLayer": "Organizational Layer",
      "workingSchedule": "Working Schedule",
      "workingDays": "Working Days",
      "totalWeeklyHours": "Total Weekly Hours"
    },
    "leave": {
      "entitlementsSummary": "Leave Entitlements Summary",
      "totalEntitlement": "Total Entitlement",
      "annualLeaveTaken": "Annual Leave Taken",
      "annualLeaveBalance": "Annual Leave Balance",
      "periodSummary": "Leave Period Summary"
    },
    "job-profile": {
      "list": {
        "main-title": "Job profiles",
        "filter-box-placeholder": "Filter by position, level, grade....",
        "description": " ",
        "table-name": "Job profile",
        "table-header": {
          "position-title": "Position title",
          "level": "Level",
          "grade": "Grade",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hours": "Working hours"
        },
        "filter-key": {
          "position-title": "Filter by Position title",
          "level": "Filter by Level",
          "grade": "Filter byGrade",
          "min-salary": "Filter by Min salary",
          "max-salary": "Filter byMax salary",
          "working-hours": "Filter byWorking hours"
        }
      },
      "form": {
        "main-title-create": "Create new job profile",
        "main-title-edit": "Edit job profile",
        "description": " ",
        "general-info": {
          "sub-title": "General information",
          "position": {
            "label": "Position",
            "description": " ",
            "placeholder": "Select a position"
          },
          "job-grade": {
            "label": "Job grade",
            "description": " ",
            "placeholder": "Select a job grade"
          },
          "job-level": {
            "label": "Job level",
            "description": " ",
            "placeholder": "Select a job level"
          },
          "min-salary": {
            "label": "Min. salary",
            "description": " ",
            "placeholder": " "
          },
          "max-salary": {
            "label": "Max. salary",
            "description": " ",
            "placeholder": " "
          },
          "base-currency": {
            "label": "Base currency",
            "description": " ",
            "placeholder": "Select a base currency"
          },
          "working-hours-per-week": {
            "label": "Working hours/per week",
            "description": " ",
            "placeholder": " "
          }
        },
        "responsibilities": {
          "sub-title": "Responsibilities"
        },
        "requirements": {
          "sub-title": "Requirements"
        },
        "required-competency": {
          "sub-title": "Required competencies",
          "description": " "
        },
        "competencies": {
          "sub-title": "Competencies"
        }
      },
      "detail": {
        "main-title": "Job profile details",
        "general-info": {
          "sub-title": "General information",
          "position-title": "Position title",
          "grade": "Grade",
          "level": "Level",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hour": "Working hour",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "responsibilities": "Responsibilities",
        "requirements": "Requirements"
      }
    },
    "department": {
      "list": {
        "main-title": "Departments",
        "filter-box-placeholder": "Filter by full name, abbreviated name, ...",
        "description": " ",
        "table-name": "department",
        "table-header": {
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "status": "Status",
          "parent-department": "Parent department"
        },
        "filter-key": {
          "full-name": "Filter by Full name",
          "abbreviated-name": "Filter by  Abbreviated name",
          "status": "Filter by Status",
          "parent-department": "Filter by Parent department"
        }
      },
      "form": {
        "main-title-create": "Create new department",
        "main-title-edit": "Edit department",
        "full-name": {
          "label": "Full name",
          "description": "Full name for the department/section",
          "placeholder": " "
        },
        "abbreviated-name": {
          "label": "Abbreviated Name",
          "description": "Select an abbreviated name for the department/section",
          "placeholder": " "
        },
        "parent-department": {
          "label": "Parent department",
          "description": "Select a parent for the department/section",
          "placeholder": "Select a parent for the department/section"
        }
      },
      "delete-message": "Are you sure want to delete this department?",
      "detail": {
        "general-info": {
          "sub-title": "General information",
          "full-name": "Full name",
          "status": "Status",
          "abbreviated-name": "Abbreviated name",
          "parent-department": "Parent department",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      }
    },
    "compensation": {
      "detail": {
        "main-title": "Compensation and benefits",
        "description": "You use this section to record those compensation and benefits offered to the employee.",
        "basic-salary": {
          "sub-title": "Base salary",
          "salary": "Basic salary (monthly)"
        },
        "pay-structure": {
          "sub-title": "Pay structure",
          "pay-structure": "Linked pay structure"
        },
        "pay-structure-form": {
          "main-title": "Edit employee pay structure",
          "description": "The selected pay structure below will be assigned to the {count_employee} selected employee(s).",
          "pay-structure": {
            "label": "Pay structure",
            "description": " "
          }
        }
      }
    },
    "bank-info": {
      "main-title": "Bank information details",
      "sub-header": "Bank information",
      "full-name": "Full name",
      "short-name": "Short name",
      "account-name": "Account name",
      "account-number": "Account number",
      "form": {
        "main-title": "Edit bank information",
        "bank-full-name": "Bank full name",
        "account-name": "Account name",
        "account-number": "Account number"
      }
    },
    "family-member": {
      "main-title": "Family members",
      "spouse": "Spouse",
      "children": "Children",
      "parent": "Parents",
      "table-name-spouse": "spouse",
      "table-name-child": "child",
      "table-name-parent": "parent",
      "btn-lable-spouse": "Edit spouse",
      "btn-lable-children": "Edit children",
      "btn-lable-parent": "Edit parent",
      "table": {
        "name": "Full name",
        "gender": "Gender",
        "date-of-birth": "Date of birth",
        "dependent": "Dependent"
      },
      "form": {
        "edit-spouse": "Edit spouse",
        "edit-child": "Edit child",
        "edit-parent": "Create parent",
        "name": "Full name",
        "gender": "Gender",
        "dependent": {
          "title": "Dependent",
          "true": "True",
          "false": "False"
        }
      }
    },
    "work-contact": {
      "main-title": "Contacts",
      "description": " ",
      "list": {
        "main-title": "Work contacts",
        "description": " ",
        "table": {
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "form": {
        "main-title": "Edit work contacts",
        "contact-type": "Contact type",
        "contact-value": "Contact value"
      }
    },
    "personal-detail": {
      "personal-contact": {
        "main-title": "Contacts",
        "description": " ",
        "list": {
          "title": "Personal contacts",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit personal contact",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "emergency-contact": {
        "main-title": "Emergency contacts",
        "description": " ",
        "list": {
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit emergency contact",
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      }
    },
    "job-grade": {
      "mainTabelHeader": "Job Grades & Salary Bands",
      "column": {
        "grade": "Grade Level",
        "level": "Level",
        "typical-titles": "Typical Job Titles",
        "salary-range-currency": "Salary Currency",
        "salary-ranges": "Salary Band"
      },
      "filter-text": "Search by grade level, or job title…"
    }
  },
  "leave": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "leave": "Leave"
    },
    "leave-type": {
      "list": {
        "main-title": "Leave Types",
        "filter-box-placeholder": "Filter by Name, Code, ...",
        "description": "Leave types refers to the different categories or types of leave that employees can take from work. Some common types of leave are vacation leave, sick leave, personal leave or emergency leave, parental or family leave, and bereavement leave.",
        "table-header": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status"
        },
        "filter-key": {
          "title": "Filter by Title:",
          "code": "Filter by Code:"
        }
      },
      "delete-message": "Are you sure want to delete this leave type?",
      "detail": {
        "main-title": "Leave type details",
        "general": "General Information",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      },
      "form": {
        "main-title-create": "Create leave type",
        "main-title-edit": "Edit leave type",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "availability-des": "ON_AVAILABLE generally applies to ANNUAL_LEAVE, ON_GRANTED generally applies to MATERNITY_LEAVE, ALWAYS generally applies to SICK_LEAVE.",
          "status": "Status",
          "on-available": "ON_AVAILABLE",
          "on-granted": "ON_GRANTED",
          "always": "ALWAYS",
          "active": "Active",
          "inactive": "Inactive"
        }
      }
    },
    "leave-request": {
      "list": {
        "main-title": "Leave Requests",
        "filter-box-placeholder": "Filter by LeaveType.Code, Status, ...",
        "description": " Leave request is an important part of workforce management, as it helps ensure that employees have access to the time off they need while also ensuring that the business can continue to operate effectively.",
        "table-header": {
          "employee-name": "Employee Name",
          "leave-type": "Leave Type",
          "from-date": "From Date",
          "to-date": "To Date",
          "status": "Status"
        },
        "table-field": {
          "employee-name": "Employee.Name",
          "leave-type": "LeaveType.Title",
          "from-date": "FromDate",
          "to-date": "ToDate",
          "status": "Status"
        },
        "filter-key": {
          "code": "Filter by LeaveType.Code:",
          "status": "Filter by Status:"
        }
      },
      "delete-message": "Are you sure want to delete this leave request?",
      "delete-applied-date-message": "Are you sure want to delete this applied date?",
      "submit-message": "Are you sure want to submit this leave request?",
      "approve-message": "Are you sure want to approve this leave request?",
      "detail": {
        "main-title": "Leave request details",
        "general": "General Information",
        "approve": "Approve",
        "reject": "Reject",
        "reason": "Reason",
        "cancel": "Cancel",
        "general-info": {
          "employee-name": "Employee name",
          "leave-type": "Leave type",
          "date": "Date",
          "reason": "Reason",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by",
          "validated-at": "Validated at",
          "validated-by": "Validated by"
        }
      },
      "form": {
        "main-title-create": "Create Leave Request",
        "main-title-edit": "Edit Leave Request",
        "general-info": {
          "leave-type": "Leave Type",
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "date": "Date",
          "period-day": "Period of day",
          "whole-day": "WHOLE DAY",
          "whole-day-value": "WHOLE_DAY",
          "apply-date-create": "Create apply dates",
          "apply-date-edit": "Edit applied date",
          "morning": "MORNING",
          "afternoon": "AFTERNOON",
          "on-available": "ON_AVAILABLE",
          "on-available-des": "This generally applies to ANNUAL_LEAVE",
          "on-granted": "ON_GRANTED",
          "on-granted-des": "This generally applies to MATERNITY_LEAVE, etc.",
          "always": "ALWAYS",
          "always-des": "This generally applies to SICK_LEAVE, etc.",
          "active": "Active",
          "inactive": "Inactive",
          "leave-balance": "Remaining Leave",
          "reasons": "Reason",
          "manager": "Line Manager",
          "cc": "Line Manager CC"
        }
      }
    }
  },
  "payroll": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "employer": {
      "list": {
        "main-title": "Employers",
        "element": {
          "active-employee": "Active employees",
          "pay-structure": "Pay structures",
          "created-payrolls": "Created payrolls"
        }
      },
      "details": {
        "main-title": "Employer details",
        "employees": {
          "title": "Employees",
          "active": "Active"
        },
        "payrolls": {
          "title": "Payrolls",
          "created-payrolls": "Created payrolls"
        },
        "pay-structures": {
          "title": "Pay structures",
          "created-pay-structure": "Created pay structures"
        }
      }
    },
    "payroll": {
      "list": {
        "main-title": "Payrolls",
        "description": "",
        "table-name": "payroll",
        "filter-box-placeholder": "Filter by pay structure name, ...",
        "table-header": {
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "staff": "Staff",
          "status": "Status"
        },
        "filter-key": {
          "pay-structure": "Filter by pay structure name"
        }
      },
      "delete-message": "Are you sure want to delete this payroll?",
      "detail": {
        "main-title": "Payroll details",
        "general-info": {
          "title": "General Information",
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "template": "Template name",
          "exchange-rate": "Exchange rates",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "process-status": {
          "title": "Process status"
        },
        "current-step": {
          "title": "Current step",
          "step-status": "Step Status"
        },
        "step-detail": {
          "title": "Current Step details",
          "pay-structure": "Pay structure",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "exchange-rate": "Exchange rates",
          "document": "Document"
        },
        "validate-employee": {
          "result": "Results",
          "included-emloyee": "Found {value} employee(s) included in this payroll",
          "excluded-employee": "Found {value} employee(s) excluded from this payroll"
        }
      },
      "form": {
        "main-title-create": "Create new payroll",
        "main-title-edit": "Edit payroll",
        "description": "The following data are used to identify a payroll based on its Pay Structure, Pay Period and Pay Frequency under a specific Employer.",
        "pay-structure": {
          "label": "Pay structure",
          "description": "What is the pay structure of the payroll entity? E.g. Default Pay Structure."
        },
        "pay-period": {
          "label": "Pay period",
          "description": "What is its pay period? E.g. January"
        },
        "payroll-tempate": {
          "label": "Payroll template",
          "description": "What is its payroll template? E.g. First Payroll Template"
        },
        "exchange-rate": {
          "label": "Exchange rates",
          "description": "Input exchange rates (US$ : KHR) to apply in this payroll. E.g. 1$ = 4000R"
        }
      }
    },
    "employee-incomes-expense": {
      "list": {
        "main-title": "Employees' Incomes/Expenses",
        "table-name": "incomes/expenses",
        "description": " ",
        "filter-key": {
          "employee-name": "Filter by employee name",
          "employee-id": "Filter by employee id"
        },
        "label-btn": {
          "download-record-template": "Download record template (.xlsx)",
          "upload-record": "Upload records (.xlsx)",
          "new-record-manual-input": "New record (manual input)"
        }
      },
      "form": {
        "main-title-create": "Employees' income/expense",
        "employee-name": {
          "label": "Employee name",
          "description": " ",
          "placeholder": "Select the employee needed to add a component pay record"
        },
        "employee-id": {
          "label": "Employee ID",
          "description": " "
        },
        "table": {
          "pay-component": "Pay Component",
          "amount": "Amount (USD)",
          "description": "Description",
          "document": "Document"
        },
        "main-title-edit": "Edit Employees' income/expense",
        "component": {
          "label": "Component",
          "placeholder": "Select a user-input component to record income/expense"
        },
        "amount": "Amount (USD)",
        "description": "Description",
        "upload-document": "Upload document"
      }
    },
    "employee-pay-record": {
      "list": {
        "main-title": "Employee pay records",
        "table-name": "employee pay record"
      },
      "detail-history": {
        "main-title": "Pay record edit history",
        "employee": "Employee",
        "table": {
          "data-time": "Edited at",
          "edited-by": "Edited by",
          "component": "Component",
          "from": "From",
          "to": "To",
          "reason": "Reason"
        }
      }
    },
    "pay-structure": {
      "list": {
        "main-title": "Pay Structures",
        "description": "If you don't have any pay structures yet, you can create one by making an identical copy of the general template from AIML SaaS system. Click <b> Clone  </b> button to create new one for your tenant.",
        "table-name": "pay structure",
        "filter-box-placeholder": "Filter by name, ...",
        "table-header": {
          "name": "Name",
          "employee": "Employee",
          "pay-interval": "Pay Interval",
          "pay-component": "Pay Component",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "delete-message": "Are you sure want to delete this pay structure?",
      "detail": {
        "main-title": "Pay structure details",
        "basic-info": {
          "title": "Basic Information",
          "name": "Name",
          "legal-requirement": "Legal requirement",
          "pay-method": "Pay method",
          "pay-interval": "Pay Interval",
          "pay-frequency": "Pay frequency",
          "pay-date": "Pay date",
          "pay-process": "Pay process",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "menu": {
          "pay-roll-component": "Payroll Components",
          "pay-period": "Pay Periods",
          "payroll-template": "Payroll Templates",
          "payroll-exchange-rate": "Exchange Rates"
        }
      },
      "form": {
        "main-title-create": "Create new pay structure",
        "main-title-edit": "Edit pay structure",
        "description": "",
        "legal-requirement": {
          "label": "Legal requirement",
          "description": " "
        },
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-method": {
          "label": "Pay method",
          "description": " "
        },
        "pay-interval": {
          "label": "Pay interval",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-date": {
          "label": "Pay date",
          "description": " "
        },
        "pay-process": {
          "label": "Pay process",
          "description": " "
        }
      }
    },
    "payroll-component": {
      "list": {
        "main-title": "Payroll Components",
        "table-name": "payroll component",
        "filter-box-placeholder": "",
        "table-header": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order",
          "currency-conversion": "Currency conversion",
          "exchange-rate": "Exchange rate",
          "actions": "Actions"
        },
        "filter-key": {
          "title": "Filter by title",
          "type": "Filter by type",
          "category": "Filter by category",
          "tax-applicability": "Filter by tax applicability",
          "status": "Filter by status",
          "currency-conversion": "Filter by currency conversion",
          "exchange-rate": "Filter by exchange rate"
        }
      },
      "form": {
        "main-title-create": "Create payroll component",
        "main-title-edit": "Edit payroll component",
        "title": {
          "title": "Title",
          "placeholder": "E.g. Salary Deduction"
        },
        "group": {
          "title": "Group",
          "placeholder": "Select a group for the component"
        },
        "category": {
          "title": "Category"
        },
        "tax-applicability": {
          "title": "Tax applicability"
        },
        "code": {
          "title": "Code"
        },
        "source-of-value": {
          "title": "Source of value"
        },
        "reference": {
          "title": "Reference"
        },
        "use-as": {
          "title": "Use as"
        },
        "currency": {
          "title": "Currency"
        },
        "status": {
          "title": "Status"
        }
      }
    },
    "payroll-process": {
      "list": {
        "main-title": "Payroll Processes",
        "description": " ",
        "table-name": "payroll process",
        "filter-box-placeholder": "Filter by name, status ...",
        "table-header": {
          "name": "Name",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this payroll process?",
      "detail": {
        "main-title": "Payroll process details",
        "name": "Name",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new payroll process",
        "main-title-edit": "Edit payroll process",
        "description": "",
        "overview": {
          "title": "Overview",
          "name": {
            "label": "Name",
            "description": " "
          },
          "status": {
            "label": "Status",
            "description": " "
          }
        }
      }
    },
    "pay-period": {
      "list": {
        "main-title": "Pay Periods",
        "description": "",
        "table-name": "pay period",
        "filter-box-placeholder": "Filter by title, status ...",
        "table-header": {
          "period-name": "Title",
          "start-date": "Start date",
          "end-date": "End date",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by title",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this pay period?",
      "detail": {
        "main-title": "Pay period details",
        "title": "Title",
        "start-date": "Start date",
        "end-date": "End date",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new pay period",
        "main-title-edit": "Edit pay period",
        "description": "",
        "title": {
          "label": "Title",
          "description": " "
        },
        "start-date": {
          "label": "Start date",
          "description": " "
        },
        "end-date": {
          "label": "End date",
          "description": " "
        },
        "status": {
          "label": "Status",
          "description": " "
        }
      }
    },
    "payroll-template": {
      "list": {
        "main-title": "Payroll Templates",
        "description": "",
        "table-name": "payroll template",
        "filter-box-placeholder": "Filter by name, pay frequency ...",
        "table-header": {
          "name": "Name",
          "pay-frequency": "Pay frequency",
          "created-by": "Created by",
          "created-at": "Created at"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by pay frequency"
        }
      },
      "delete-message": "Are you sure want to delete this payroll template?",
      "detail": {
        "main-title": "Payroll template details",
        "overview": "Overview",
        "components": "Components",
        "name": "Name",
        "pay-frequency": "Pay frequency",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by",
        "table": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order"
        }
      },
      "form": {
        "main-title-create": "Create new template",
        "main-title-edit": "Edit template",
        "description": "",
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-component": {
          "label": "Pay component",
          "description": " "
        }
      }
    },
    "payroll-comparison": {
      "list": {
        "main-title": "Comparison",
        "btn-label": "Get Comparison"
      }
    },
    "exchange-rate": {
      "list": {
        "main-title": "Exchange Rates",
        "description": "",
        "table-name": "Exchange rate",
        "filter-box-placeholder": "Filter by title ...",
        "table-header": {
          "name": "Name",
          "default": "Default",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "detail": {
        "main-title": "Exchange rate details",
        "title": "Name",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new exchange rate",
        "main-title-edit": "Edit exchange rate",
        "description": "",
        "name": {
          "label": "Name",
          "description": "The name of exchange rate, e.g. GDT for that received from General Department of Taxation, NSSF for that received from NSSF."
        },
        "default-status": {
          "label": "Default",
          "description": "When set to “true”, this exchange rate will be selected by default when used with a pay component having Currency Conversion set to “true”"
        }
      }
    }
  },
  "v2": {
    "app": {
      "name": "OptimalHR"
    },
    "ui": {
      "column-customizer": {
        "title": "កំណត់តារាង",
        "subtitle": "ជ្រើសរើសជួរឈរដែលត្រូវបង្ហាញ និងអូសដើម្បីរៀបលំដាប់ឡើងវិញ។ ជួរឈរដែលត្រូវការមិនអាចលាក់បានទេ។",
        "summary": "ជួរឈរបានជ្រើស · អូសដើម្បីរៀបលំដាប់ | ជួរឈរបានជ្រើស · អូសដើម្បីរៀបលំដាប់",
        "required": "ត្រូវការ",
        "locked": "ចាក់សោ",
        "reset": "កំណត់ឡើងវិញ",
        "apply": "អនុវត្ត",
        "drag-hint": "អូសដើម្បីរៀបលំដាប់",
        "cannot-reorder": "មិនអាចរៀបលំដាប់",
        "move-up": "ផ្លាស់ {label} ឡើងលើ",
        "move-down": "ផ្លាស់ {label} ចុះក្រោម",
        "toggle-aria": "{label} — {state}",
        "shown": "បង្ហាញ",
        "hidden": "លាក់"
      },
      "column-chooser": {
        "button": "ជួរឈរ",
        "button-aria": "ជ្រើសរើសជួរឈរ (បង្ហាញ {shown} ក្នុងចំណោម {total})",
        "title": "បង្ហាញជួរឈរ",
        "required": "(បង្ហាញជានិច្ច)",
        "summary": "បង្ហាញ {shown} ក្នុងចំណោម {total}",
        "reset": "កំណត់ឡើងវិញ"
      },
      "edit-history": {
        "title": "ប្រវត្តិកែប្រែ",
        "loading": "កំពុងផ្ទុកប្រវត្តិកែប្រែ",
        "error-title": "មិនអាចផ្ទុកប្រវត្តិកែប្រែបានទេ",
        "error-body": "មានបញ្ហាកើតឡើង។ សូមព្យាយាមម្តងទៀត។",
        "retry": "ព្យាយាមម្តងទៀត",
        "empty-title": "មិនទាន់មានការកែប្រែនៅឡើយ",
        "empty-body": "ការកែប្រែលើកំណត់ត្រានេះនឹងបង្ហាញនៅទីនេះ។",
        "unavailable-title": "ប្រវត្តិកែប្រែមិនទាន់មាននៅទីនេះទេ",
        "unavailable-body": "កំណត់ត្រាសវនកម្មមិនទាន់បានបើកនៅក្នុងបរិស្ថាននេះនៅឡើយទេ។",
        "count": "ការកែប្រែ {count} | ការកែប្រែ {count}",
        "load-more": "ផ្ទុកបន្ថែម",
        "col": {
          "when": "ពេលវេលា",
          "who": "អ្នកកែប្រែ",
          "field": "វាល",
          "change": "ចាស់ → ថ្មី"
        },
        "old": "ចាស់",
        "new": "ថ្មី",
        "value-hidden": "លាក់ (ព័ត៌មានរសើប)",
        "value-not-kept": "ធំពេកមិនអាចបង្ហាញបាន",
        "system-actor": "ប្រព័ន្ធ",
        "action": {
          "create": "បានបង្កើត",
          "update": "បានកែប្រែ",
          "delete": "បានលុប",
          "unknown": "បានផ្លាស់ប្តូរ"
        },
        "close": "បិទ",
        "forbidden-title": "អ្នកមិនមានសិទ្ធិមើលប្រវត្តិនេះទេ",
        "forbidden-body": "សូមសួរអ្នកគ្រប់គ្រង ប្រសិនបើអ្នកត្រូវការដឹងថាអ្នកណាបានកែប្រែកំណត់ត្រានេះ។",
        "id-ref": "(លេខសម្គាល់)",
        "id-refs": "(លេខសម្គាល់ {count}) | (លេខសម្គាល់ {count})",
        "fields": {
          "Name": "ឈ្មោះ",
          "NameKm": "ឈ្មោះ (ខ្មែរ)",
          "Code": "កូដ",
          "Title": "ចំណងជើង",
          "Description": "ការពិពណ៌នា",
          "Status": "ស្ថានភាព",
          "EmployerId": "ក្រុមហ៊ុន",
          "ParentId": "មេ",
          "OrgUnitId": "អង្គភាព",
          "LocationId": "ទីតាំង",
          "Version": "កំណែ",
          "CreatedAt": "បានបង្កើតនៅ",
          "CreatedBy": "បានបង្កើតដោយ",
          "UpdatedAt": "បានកែប្រែនៅ",
          "UpdatedBy": "បានកែប្រែដោយ",
          "DeactivatedAt": "បានបិទដំណើរការនៅ",
          "DeactivatedBy": "បានបិទដំណើរការដោយ",
          "ReactivatedAt": "បានបើកដំណើរការឡើងវិញនៅ",
          "ReactivatedBy": "បានបើកដំណើរការឡើងវិញដោយ",
          "RemovedAt": "បានដកចេញនៅ",
          "RemovedBy": "បានដកចេញដោយ"
        }
      }
    },
    "shell": {
      "org-chip": {
        "switch": "ប្តូរវិសាលភាព",
        "loading": "កំពុងផ្ទុកវិសាលភាព…",
        "empty": "មិនមានវិសាលភាពទេ",
        "global-label": "វិសាលភាពទាំងអស់",
        "global-sub": "ការត្រួតពិនិត្យឆ្លងវិសាលភាព",
        "global-short": "វិសាលភាពទាំងអស់",
        "companies": "ក្រុមហ៊ុន",
        "projects": "គម្រោង",
        "clients": "អតិថិជន",
        "vendors": "អ្នកផ្គត់ផ្គង់",
        "direct": "ផ្ទាល់",
        "company-group": "ក្រុមហ៊ុន",
        "company-tag": "ក្រុមហ៊ុន",
        "clients-projects": "អតិថិជន ▸ គម្រោង",
        "vendors-projects": "អ្នកផ្គត់ផ្គង់ ▸ គម្រោង",
        "oversight": "ការត្រួតពិនិត្យ",
        "context-client": "អតិថិជន",
        "context-vendor": "អ្នកផ្គត់ផ្គង់",
        "context-project": "គម្រោង",
        "context-company": "ក្រុមហ៊ុន",
        "show-more": "បង្ហាញបន្ថែម ({count})",
        "show-less": "បង្ហាញតិច",
        "create-company": "បង្កើតក្រុមហ៊ុនថ្មី",
        "direct-workforce": "កម្លាំងពលកម្មផ្ទាល់",
        "direct-short": "ផ្ទាល់",
        "direct-sub": "{company} · កម្លាំងពលកម្មផ្ទាល់ខ្លួន",
        "company-sub": "{company} · ក្រុមហ៊ុន"
      },
      "search": {
        "label": "Search"
      },
      "notifications": {
        "label": "Notifications"
      },
      "resume-pill": {
        "label": "បន្តដំណើរការប្រាក់ខែ",
        "title": "បន្តដំណើរការប្រាក់ខែដែលកំពុងធ្វើ"
      },
      "user-menu": {
        "profile": "Profile",
        "change-password": "Change password",
        "switch-language": "Switch language",
        "sign-out": "Sign out"
      },
      "nav": {
        "home": "ផ្ទះ",
        "people": "បុគ្គលិក",
        "work": "ប្រតិបត្តិការ HR",
        "pay": "បើកប្រាក់ខែ",
        "billing": "វិក្កយបត្រ",
        "workmgmt": "គ្រប់គ្រងការងារ",
        "perform": "ការអនុវត្តន៍",
        "fieldops": "ប្រតិបត្តិការវាល",
        "insights": "ការវិភាគ",
        "moreapps": "កម្មវិធីបន្ថែម",
        "organization": "អង្គភាព"
      }
    },
    "auth": {
      "brand-panel": {
        "tagline": "ប្រតិបត្តិការធនធានមនុស្ស · កម្ពុជា",
        "hero-title": "សូមស្វាគមន៍ការត្រឡប់មកវិញ",
        "hero-lede": "ចូលគណនីដើម្បីគ្រប់គ្រងវត្តមាន ច្បាប់ឈប់សម្រាក ការងារបន្ថែមម៉ោង ការធ្វើដំណើរ ការចំណាយ និងបើកប្រាក់ខែសម្រាប់ក្រុមរបស់អ្នក — ទាំងអស់នៅកន្លែងតែមួយ។",
        "bullets": {
          "compliance": "បានបំពាក់នូវច្បាប់ការងារកម្ពុជា — បសស ពន្ធលើប្រាក់ខែ និងថ្ងៃឈប់សម្រាកផ្លូវការ",
          "outsourced": "ផ្លូវអនុម័តសម្រាប់បុគ្គលិកឲ្យប្រើខាងក្រៅ និងអ្នកគ្រប់គ្រងជួរខាងក្រៅ",
          "mobile": "សេវាបុគ្គលិកដោយខ្លួនឯងតាមទូរស័ព្ទ — ស្នើ និងអនុម័តគ្រប់ទីកន្លែង"
        },
        "copyright": "© {year} OptimalHR · ផលិតផលរបស់ Optimal P HR Strategic Partner Co., Ltd.",
        "address": "ភ្នំពេញ កម្ពុជា · {email}"
      },
      "aria": {
        "locale-switcher": "ប្ដូរភាសា"
      },
      "welcome": {
        "title": "សូមស្វាគមន៍",
        "subtitle": "បញ្ចូលកន្លែងធ្វើការរបស់អ្នកដើម្បីបន្ត។",
        "workspace-label": "កន្លែងធ្វើការ",
        "workspace-placeholder": "optimalp",
        "workspace-hint": "តួអក្សរអក្ខរក្រមតូច លេខ និងសញ្ញាដាច់ៗប៉ុណ្ណោះ។ ផ្ដល់ដោយអ្នកគ្រប់គ្រងធនធានមនុស្សរបស់អ្នក។",
        "continue": "បន្ត",
        "continuing": "កំពុងផ្ទុកកន្លែងធ្វើការ…",
        "recent-label": "កន្លែងធ្វើការថ្មីៗ",
        "find-prefix": "មិនដឹងកន្លែងធ្វើការរបស់អ្នកទេ?",
        "find-link": "ស្វែងរកកន្លែងធ្វើការ",
        "find-toast": "ទាក់ទងអ្នកគ្រប់គ្រងធនធានមនុស្សរបស់អ្នកដើម្បីដឹងឈ្មោះកន្លែងធ្វើការ",
        "privacy": {
          "title": "តើកន្លែងធ្វើការរបស់ខ្ញុំត្រូវបានការពារយ៉ាងដូចម្ដេច?",
          "intro": "ឈ្មោះកន្លែងធ្វើការរបស់អ្នកគឺជាអាសយដ្ឋានសាធារណៈ — ដូចជា {hostExample}។ ដឹងឈ្មោះមិនមែនជាការផ្ដល់សិទ្ធិចូលដំណើរការទេ។ គណនីរបស់អ្នកនៅតែសុវត្ថិភាពតាមរយៈ៖",
          "items": {
            "mfa": {
              "title": "ពាក្យសម្ងាត់ + MFA",
              "desc": "អ្នកគ្រប់គ្រងធនធានមនុស្ស និងតួនាទីប្រាក់ខែតម្រូវឲ្យប្រើការផ្ទៀងផ្ទាត់ច្រើនកត្តា។"
            },
            "monitoring": {
              "title": "ការតាមដានឆ្លាតវៃ",
              "desc": "ការកំណត់អត្រា និងការចាក់សោគណនី បិទការវាយប្រហារដោយស្វ័យប្រវត្តិ; ការចូលគណនីដែលគ្មានគុណលក្ខណៈធម្មតានឹងបង្កើតការជូនដំណឹង។"
            },
            "audit": {
              "title": "កំណត់ហេតុសវនកម្មពេញលេញ",
              "desc": "ការចូលគណនីនីមួយៗ (ជោគជ័យ និងបរាជ័យ) ត្រូវបានកត់ត្រា និងមើលឃើញដោយអ្នកគ្រប់គ្រងរបស់អ្នក។"
            },
            "hidden": {
              "title": "របៀបកន្លែងធ្វើការឯកជន",
              "desc": "អតិថិជនសហគ្រាសអាចលាក់ទំព័រចូលគណនីរបស់ពួកគេទាំងស្រុង — ចូលដំណើរការតែតាមរយៈតំណរអញ្ជើញដែលបានចុះហត្ថលេខាប៉ុណ្ណោះ។"
            }
          },
          "footer": "មានសំណួរ? ទាក់ទង {email}"
        },
        "errors": {
          "workspace-required": "បញ្ចូលកន្លែងធ្វើការដើម្បីបន្ត។",
          "workspace-invalid": "ប្រើតែតួអក្សរអក្ខរក្រមតូច លេខ និងសញ្ញាដាច់ៗប៉ុណ្ណោះ។",
          "workspace-not-found": "យើងមិនអាចរកឃើញកន្លែងធ្វើការនោះទេ។ សូមពិនិត្យអក្ខរាវិរុទ្ធ ហើយព្យាយាមម្ដងទៀត។"
        }
      },
      "sign-in": {
        "switch-workspace": "← ប្ដូរកន្លែងធ្វើការ",
        "title-template": "ចូលគណនី {name}",
        "subtitle": "សូមស្វាគមន៍ការត្រឡប់មកវិញ។ បញ្ចូលព័ត៌មានរបស់អ្នកដើម្បីចូលប្រើគណនី។",
        "method-email": "អុីមែល",
        "method-phone": "ទូរស័ព្ទ + OTP",
        "work-email": "អុីមែលការងារ",
        "email-placeholder": "you\\@optimal-p.com",
        "password": "ពាក្យសម្ងាត់",
        "forgot": "ភ្លេច?",
        "remember": "ចងចាំខ្ញុំសម្រាប់ 30 ថ្ងៃ",
        "submit": "ចូលគណនី",
        "submitting": "កំពុងចូល…",
        "fine-print": "ដោយចូលគណនី អ្នកយល់ព្រមនឹង{terms} និង{privacy}។",
        "errors": {
          "fields-required": "អុីមែល និងពាក្យសម្ងាត់ត្រូវតែបំពេញ",
          "workspace-required": "លេខសម្គាល់កន្លែងធ្វើការត្រូវតែបំពេញ",
          "workspace-not-found": "រកមិនឃើញកន្លែងធ្វើការ"
        },
        "reset-success": "ពាក្យសម្ងាត់របស់អ្នកត្រូវបានកំណត់ឡើងវិញ។ សូមចូលគណនីដោយប្រើពាក្យសម្ងាត់ថ្មី។"
      },
      "forgot": {
        "title": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
        "subtitle": "បញ្ចូលអុីមែលការងារដែលភ្ជាប់នឹងគណនីរបស់អ្នក ហើយយើងនឹងផ្ញើកូដបញ្ជាក់ជូន។",
        "send-code": "ផ្ញើកូដ",
        "sending": "កំពុងផ្ញើ…",
        "back-to-sign-in": "← ត្រឡប់ទៅចូលគណនី",
        "errors": {
          "email-required": "អុីមែលត្រូវតែបំពេញ",
          "code-mismatch": "កូដនេះមិនត្រឹមត្រូវ។ សូមពិនិត្យអុីមែល ហើយព្យាយាមម្ដងទៀត។",
          "expired-code": "កូដនេះផុតកំណត់ហើយ។ សូមស្នើកូដថ្មីខាងក្រោម។",
          "limit-exceeded": "ការព្យាយាមច្រើនពេក។ សូមរង់ចាំពីរបីនាទី ហើយព្យាយាមម្ដងទៀត។",
          "user-not-found": "យើងរកមិនឃើញគណនីសម្រាប់អុីមែលនេះទេ។",
          "invalid-password": "ពាក្យសម្ងាត់នេះមិនត្រូវតាមលក្ខខណ្ឌ។ សូមប្រើយ៉ាងតិច 8 តួអក្សរ ដែលមានអក្សរ លេខ និងនិមិត្តសញ្ញា។",
          "generic": "មានបញ្ហាមួយកើតឡើង។ សូមព្យាយាមម្ដងទៀត។"
        },
        "work-email": "អុីមែលការងារ",
        "contact-hint": "នៅតែជាប់ឬ? សូមទាក់ទងអ្នកគ្រប់គ្រង HR របស់អ្នកដើម្បីសង្គ្រោះគណនី។",
        "strength": {
          "empty": "កម្រិត៖ ទទេ",
          "weak": "កម្រិត៖ ខ្សោយ",
          "medium": "កម្រិត៖ មធ្យម",
          "strong": "កម្រិត៖ ខ្លាំង",
          "excellent": "កម្រិត៖ ល្អបំផុត"
        }
      },
      "confirm-forgot": {
        "title": "កំណត់ពាក្យសម្ងាត់ថ្មី",
        "code": "កូដបញ្ជាក់",
        "new-password": "ពាក្យសម្ងាត់ថ្មី",
        "confirm-password": "បញ្ជាក់ពាក្យសម្ងាត់",
        "submit": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
        "submitting": "កំពុងកំណត់ឡើងវិញ…",
        "errors": {
          "code-required": "កូដបញ្ជាក់ត្រូវតែបំពេញ",
          "mismatch": "ពាក្យសម្ងាត់មិនត្រូវគ្នា",
          "weak-password": "សូមជ្រើសរើសពាក្យសម្ងាត់ខ្លាំងជាង — យ៉ាងតិច 8 តួអក្សរ ដែលលាយអក្សរ លេខ និងនិមិត្តសញ្ញា។",
          "missing-username": "វគ្គកំណត់ឡើងវិញរបស់អ្នកផុតកំណត់ហើយ។ សូមចាប់ផ្ដើមឡើងវិញពីអេក្រង់ភ្លេចពាក្យសម្ងាត់។",
          "code-mismatch": "កូដនេះមិនត្រឹមត្រូវ។ សូមពិនិត្យអុីមែល ហើយព្យាយាមម្ដងទៀត។",
          "expired-code": "កូដនេះផុតកំណត់ហើយ។ សូមស្នើកូដថ្មីខាងក្រោម។",
          "limit-exceeded": "ការព្យាយាមច្រើនពេក។ សូមរង់ចាំពីរបីនាទី ហើយព្យាយាមម្ដងទៀត។",
          "user-not-found": "យើងរកមិនឃើញគណនីសម្រាប់អុីមែលនេះទេ។",
          "invalid-password": "ពាក្យសម្ងាត់នេះមិនត្រូវតាមលក្ខខណ្ឌ។ សូមប្រើយ៉ាងតិច 8 តួអក្សរ ដែលមានអក្សរ លេខ និងនិមិត្តសញ្ញា។",
          "generic": "មានបញ្ហាមួយកើតឡើង។ សូមព្យាយាមម្ដងទៀត។"
        },
        "subtitle": "យើងបានផ្ញើកូដទៅ {email}។ សូមបញ្ចូលវាខាងក្រោម ជាមួយពាក្យសម្ងាត់ថ្មីដែលអ្នកមិនធ្លាប់ប្រើ។",
        "start-over": "← ចាប់ផ្ដើមឡើងវិញ",
        "no-code": "មិនបានទទួលកូដឬ?",
        "resend": "ផ្ញើកូដម្ដងទៀត",
        "resending": "កំពុងផ្ញើឡើងវិញ…",
        "resent": "កូដថ្មីកំពុងផ្ញើទៅ — សូមពិនិត្យប្រអប់សំបុត្ររបស់អ្នក។",
        "success-title": "ពាក្យសម្ងាត់ត្រូវបានធ្វើបច្ចុប្បន្នភាព",
        "success-subtitle": "ពាក្យសម្ងាត់របស់អ្នកត្រូវបានកំណត់ឡើងវិញ។ ឥឡូវនេះអ្នកអាចចូលគណនីដោយប្រើពាក្យសម្ងាត់ថ្មី។",
        "success-cta": "បន្តទៅចូលគណនី"
      },
      "force-change": {
        "title": "កំណត់ពាក្យសម្ងាត់ថ្មី",
        "subtitle": "គណនីរបស់អ្នកត្រូវការពាក្យសម្ងាត់ថ្មីមុនពេលបន្ត។",
        "submit": "បន្ត",
        "submitting": "កំពុងរក្សាទុក…"
      },
      "mfa": {
        "title": "ការផ្ទៀងផ្ទាត់ពីរជំហាន",
        "subtitle-sms": "បញ្ចូលកូដ 6 ខ្ទង់ដែលបានផ្ញើទៅទូរសព្ទរបស់អ្នក។",
        "subtitle-totp": "បញ្ចូលកូដ 6 ខ្ទង់ពីកម្មវិធីផ្ទៀងផ្ទាត់របស់អ្នក។",
        "code": "កូដ 6 ខ្ទង់",
        "submit": "ផ្ទៀងផ្ទាត់",
        "submitting": "កំពុងផ្ទៀងផ្ទាត់…",
        "errors": {
          "code-required": "កូដត្រូវតែបំពេញ"
        }
      },
      "change-password": {
        "title": "ប្ដូរពាក្យសម្ងាត់",
        "current-password": "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
        "save": "រក្សាទុក",
        "saving": "កំពុងរក្សាទុក…",
        "cancel": "បោះបង់",
        "success-toast": "ពាក្យសម្ងាត់បានធ្វើបច្ចុប្បន្នភាព",
        "errors": {
          "fields-required": "វាលទាំងអស់ត្រូវតែបំពេញ",
          "mismatch": "ពាក្យសម្ងាត់ថ្មីមិនត្រូវគ្នា"
        }
      },
      "legal-links": {
        "terms": "លក្ខខណ្ឌប្រើប្រាស់",
        "privacy": "គោលនយោបាយឯកជនភាព"
      }
    },
    "home": {
      "welcome-fallback": "អ្នកប្រើ",
      "global": {
        "title": "វិសាលភាពទាំងអស់",
        "subtitle": "ទិដ្ឋភាពរួមបញ្ចូលគ្នាលើគ្រប់ក្រុមហ៊ុន អតិថិជន អ្នកផ្គត់ផ្គង់ និងគម្រោងទាំងអស់។",
        "error": "មិនអាចផ្ទុកទិដ្ឋភាពឆ្លងវិសាលភាពបានទេ។",
        "retry": "ព្យាយាមម្តងទៀត",
        "empty-title": "មិនទាន់មានអ្វីបង្ហាញនៅឡើយ",
        "empty-desc": "នៅពេលវិសាលភាពមានបុគ្គលិក និងកិច្ចសន្យា សូចនាករรួមរបស់ពួកគេនឹងបង្ហាញនៅទីនេះ។",
        "preview-note": "មើលជាមុន · ទិន្នន័យគំរូបង្ហាញខាងក្រោម រហូតដល់ទិន្នន័យឆ្លងវិសាលភាពត្រូវបានភ្ជាប់",
        "kpi": {
          "expiring": "កិច្ចសន្យាផុតកំណត់ ≤៣០ថ្ងៃ",
          "understaffed": "គម្រោងខ្វះបុគ្គលិក",
          "probation": "កំពុងសាកល្បង",
          "onboarding": "ការចូលធ្វើការកំពុងដំណើរការ",
          "headcount": "ចំនួនបុគ្គលិកសកម្ម"
        },
        "persona": {
          "clients": "អតិថិជន",
          "vendors": "អ្នកផ្គត់ផ្គង់",
          "projects": "គម្រោងសកម្ម {count}"
        }
      },
      "hero": {
        "greeting": "សូមស្វាគមន៍ការត្រឡប់មកវិញ",
        "today-pill": "ថ្ងៃនេះ",
        "subtitle-tail": "ផ្ទាំងព័ត៌មានសម្រាប់ថ្ងៃនេះរបស់អ្នក",
        "announce": "ប្រកាស",
        "quick-add": "បន្ថែមរហ័ស"
      },
      "toasts": {
        "announce": "ប្រកាស — ផ្ញើដល់បុគ្គលិកទាំងអស់",
        "quick-add": "បន្ថែមរហ័ស — ជ្រើសរើសបុគ្គលិក / ម៉ោង / ច្បាប់ / ការចំណាយ"
      },
      "alert": {
        "compliance": {
          "text": "មាន {count} ធាតុការអនុលោមដល់កំណត់ ឬហួសកាលកំណត់ក្នុងរយៈពេល ៧ ថ្ងៃខាងមុខ",
          "cta": "មើលការអនុលោម"
        }
      },
      "action-center": {
        "title": "មជ្ឈមណ្ឌលសកម្មភាព",
        "subtitle": "អ្វីដែលត្រូវការការយកចិត្តទុកដាក់ឥឡូវនេះ"
      },
      "action-tiles": {
        "approvals": "ការអនុម័តរង់ចាំ",
        "compliance": "ការអនុលោម · ៧ ថ្ងៃ",
        "payroll": "ឧបសគ្គបើកប្រាក់ខែ",
        "issues": "បញ្ហាត្រូវដោះស្រាយ"
      },
      "kpi": {
        "attendance": {
          "label": "វត្តមានថ្ងៃនេះ",
          "title": "បើកវត្តមាន · សង្ខេបប្រចាំថ្ងៃ",
          "detail": "{present} ក្នុង {total} មានវត្តមាន",
          "vs-yesterday": "ធៀបនឹងម្សិលមិញ"
        },
        "payroll": {
          "label": "វដ្តប្រាក់ខែ",
          "title": "បើកប្រាក់ខែ · វដ្តបច្ចុប្បន្ន",
          "step": "ជំហាន {step}/{total}",
          "cutoff-in": "កាលបរិច្ឆេទកំណត់នៅសល់",
          "cutoff-days": "{days} ថ្ងៃ"
        },
        "eor": {
          "label": "សន្ទស្សន៍ EOR",
          "title": "បើកកម្លាំងពលកម្មក្រៅ",
          "detail": "បុគ្គលិកក្រៅ · {projects} គម្រោងសកម្ម",
          "stale": "{count} ប្រធានគណបក្សក្រៅហួសសម័យ"
        },
        "compliance": {
          "label": "ពិន្ទុការអនុលោម",
          "title": "បើកការអនុលោម"
        }
      },
      "people-card": {
        "title": "មនុស្ស — សប្ដាហ៍នេះ",
        "count": "{count} ព្រឹត្តិការណ៍",
        "more": "ផ្សេងទៀត",
        "empty": "គ្មានព្រឹត្តិការណ៍សំខាន់ក្នុងសប្ដាហ៍នេះ"
      },
      "people-events": {
        "joining": "ចូលធ្វើការសប្ដាហ៍នេះ",
        "separating": "បានឆ្លៀតសប្ដាហ៍នេះ (ត្រូវប្រកាស MOL)",
        "upcoming-exit": "ចេញនាពេលខាងមុខ (៣០ ថ្ងៃ)",
        "probation-due": "ការវាយតម្លៃសាកល្បងដល់ពេល (៣០ ថ្ងៃ)",
        "on-leave-today": "សម្រាកថ្ងៃនេះ",
        "on-leave-static": "សម្រាករយៈពេលវែង (ស្ថានភាព)",
        "returning-today": "វិលត្រឡប់ថ្ងៃនេះ"
      },
      "activity-card": {
        "title": "សកម្មភាពថ្មីៗ",
        "count": "{count} ព្រឹត្តិការណ៍",
        "empty": "គ្មានសកម្មភាពថ្មីៗ",
        "open": "បើកការអនុលោម"
      },
      "payroll-card": {
        "title": "វដ្តប្រាក់ខែ",
        "cutoff": "កាលបរិច្ឆេទកំណត់ {date}",
        "pay-date": "ថ្ងៃបើកប្រាក់ {date}",
        "blockers": "{count} ឧបសគ្គ",
        "clear-before": "ដោះស្រាយមុនកាលបរិច្ឆេទកំណត់",
        "no-blockers": "គ្មានឧបសគ្គ",
        "resume": "បន្តប្រាក់ខែ"
      },
      "calendar-card": {
        "title": "សប្ដាហ៍នេះ",
        "count": "{count} ព្រឹត្តិការណ៍",
        "empty": "គ្មានព្រឹត្តិការណ៍ក្នុងសប្ដាហ៍នេះ",
        "open": "បើកការអនុលោម"
      }
    },
    "shared": {
      "stub-panel": {
        "v6-tag": "v6 stub",
        "tbd-tag": "ការរចនាលម្អិតមិនទាន់មាន"
      }
    },
    "work": {
      "title": "HR Ops",
      "subtitle": "Optimal P · មេសា 2026 · ប្រតិបត្តិការ HR",
      "tabs": {
        "attendance": "វត្តមាន",
        "leave": "ច្បាប់ឈប់សម្រាក",
        "overtime": "ម៉ោងបន្ថែម",
        "travel": "ការធ្វើដំណើរ",
        "expenses": "ចំណាយ",
        "approvals": "ការអនុម័ត",
        "approvals-count": "ការអនុម័ត ({count})",
        "scheduling": "ការរៀបចំកាលវិភាគ"
      },
      "attendance": {
        "pills": {
          "snapshot": "រូបភាពប្រចាំថ្ងៃ",
          "reports": "របាយការណ៍វត្តមាន",
          "records": "កំណត់ត្រាម៉ោងលម្អិត",
          "attrec": "កំណត់ត្រាវត្តមាន",
          "rostersrc": "ប្រភពវេនការងារ"
        },
        "error": "មិនអាចផ្ទុកទិន្នន័យវត្តមានបានទេ។",
        "retry": "ព្យាយាមម្ដងទៀត",
        "loading": "កំពុងផ្ទុកវត្តមាន…",
        "focus": {
          "present": "មានវត្តមាន",
          "absent": "អវត្តមាន / គ្មានការចុះម៉ោងចូល",
          "onleave": "កំពុងឈប់សម្រាក",
          "exception": "ករណីលើកលែង"
        },
        "dow": {
          "sun": "អា",
          "mon": "ច",
          "tue": "អ",
          "wed": "ពុ",
          "thu": "ព្រ",
          "fri": "សុ",
          "sat": "ស"
        },
        "lock": {
          "open": "ចាក់សោរយៈពេលវត្តមាន",
          "count": "រយៈពេលចាក់សោ {n} | រយៈពេលចាក់សោ {n}",
          "title": "ចាក់សោរយៈពេលវត្តមាន",
          "records": "កំណត់ត្រា {n}",
          "unresolved": "ករណីលើកលែងមិនទាន់ដោះស្រាយ {n}",
          "cancel": "បោះបង់",
          "confirm": "ចាក់សោរយៈពេល",
          "anyway": "ចាក់សោទោះយ៉ាងណា — បង្កក {n} ដែលមិនទាន់ដោះស្រាយ",
          "ack": "**ត្រូវការការទទួលស្គាល់៖** ករណីលើកលែងមិនទាន់ដោះស្រាយ {n} នឹងត្រូវបង្កកក្នុងរូបភាពបើកប្រាក់បៀវត្ស ហើយមិនអាចកែតម្រូវបានទៀតទេ។ ផ្នែកបើកប្រាក់បៀវត្សនឹងទទួលវាដូចដែលមាន។ ចុច **ចាក់សោទោះយ៉ាងណា** ដើម្បីបញ្ជាក់ ឬបោះបង់ ហើយដោះស្រាយវាជាមុនសិន។",
          "note": "ការចាក់សោបិទរយៈពេលវត្តមាននេះជាផ្លូវការ ហើយបង្កករូបភាពរបស់វាសម្រាប់ការបើកប្រាក់បៀវត្ស។ កំណត់ត្រាក្នុងរយៈពេលដែលបានចាក់សោមិនអាចកែតម្រូវ អនុម័ត ឬបញ្ជូនទៅម៉ោងបន្ថែមបានទៀតទេ។ វិសាលភាពត្រួតពិនិត្យអានតែរូបភាពដែលបានចាក់សោប៉ុណ្ណោះ។"
        },
        "snapshot": {
          "title": "រូបភាពប្រចាំថ្ងៃ",
          "prev": "ថ្ងៃមានវេនមុន",
          "next": "ថ្ងៃមានវេនបន្ទាប់",
          "date": "កាលបរិច្ឆេទរូបភាព",
          "empty": "គ្មានបុគ្គលិកត្រូវមកធ្វើការនៅថ្ងៃ {date} ក្នុងក្រុមហ៊ុននេះទេ — គ្មានវេនការងារដែលបានផ្សព្វផ្សាយគ្របដណ្ដប់ ហើយគ្មានកាលវិភាគថេរ/បត់បែនណាមានម៉ោងធ្វើការនៅថ្ងៃនោះទេ។",
          "empty-hint": "ពិនិត្យការចាត់កាលវិភាគ (ប្រតិបត្តិការធនធានមនុស្ស → ការរៀបចំកាលវិភាគ) ផ្សព្វផ្សាយវេនការងារសម្រាប់បុគ្គលិកវេនបង្វិល។",
          "empty-hint-range": "ពិនិត្យការចាត់កាលវិភាគ (ប្រតិបត្តិការធនធានមនុស្ស → ការរៀបចំកាលវិភាគ) ផ្សព្វផ្សាយវេនការងារសម្រាប់បុគ្គលិកវេនបង្វិល ឬជ្រើសថ្ងៃមានវេន ({from} – {to})។",
          "rosters": "វេនការងារដែលបានផ្សព្វផ្សាយគ្របដណ្ដប់ថ្ងៃនេះ",
          "ot": "សំណើម៉ោងបន្ថែមនៅថ្ងៃនេះ",
          "kpi-title": {
            "present": "មើលអ្នកមានវត្តមាន — បើកកំណត់ត្រាវត្តមាន",
            "absent": "មើលអ្នកអវត្តមាន — បើកកំណត់ត្រាវត្តមាន",
            "onleave": "មើលអ្នកកំពុងឈប់សម្រាក — បើកកំណត់ត្រាវត្តមាន",
            "exception": "មើលករណីលើកលែង — បើកកំណត់ត្រាវត្តមាន"
          },
          "expected": "រំពឹងថ្ងៃនេះ៖",
          "rostered": "{n} តាមវេន",
          "fixed": "{n} កាលវិភាគថេរ",
          "flexible": "{n} បត់បែន",
          "rotation-note": "· បុគ្គលិកវេនបង្វិលបង្ហាញនៅពេលវេនការងាររបស់ពួកគេត្រូវបានផ្សព្វផ្សាយ",
          "exc-title": "ករណីលើកលែងនៅថ្ងៃនេះ",
          "need-action": "{n} ត្រូវការសកម្មភាព",
          "all-clear": "គ្មានបញ្ហា — គ្មានករណីលើកលែងត្រូវដោះស្រាយនៅថ្ងៃនេះទេ។",
          "group": {
            "late": "មកយឺតធៀបនឹងម៉ោងចាប់ផ្ដើមគ្រោងទុក",
            "absent": "គ្មានការចុះម៉ោងចូល (អវត្តមាន)",
            "early": "ចេញមុនធៀបនឹងម៉ោងបញ្ចប់គ្រោងទុក",
            "returning": "ត្រឡប់ពីការឈប់សម្រាកថ្ងៃនេះ"
          },
          "pending-lm": "រង់ចាំប្រធានផ្ទាល់",
          "resolved": "បានដោះស្រាយ",
          "send-reminder": "ផ្ញើការរំលឹក",
          "on-behalf": "ដាក់ស្នើជំនួស",
          "on-behalf-title": "ដាក់ស្នើជំនួស — ជម្រើសបម្រុងសម្រាប់បុគ្គលិកដែលគ្មានទូរសព្ទ",
          "reminded-just-now": "បានរំលឹកមុននេះបន្តិច",
          "reminded-m": "បានរំលឹក {n} នាទីមុន",
          "reminded-h": "បានរំលឹក {n} ម៉ោងមុន",
          "reminded-d": "បានរំលឹក {n} ថ្ងៃមុន",
          "exc-note": "ករណីលើកលែងដូចគ្នានឹងផ្ទាំងកំណត់ត្រាវត្តមាន — ដោះស្រាយមុនវដ្តបើកប្រាក់បៀវត្ស ដើម្បីជៀសវាងការរាំងស្ទះ។",
          "feed-title": "លំហូរការចុះម៉ោង",
          "simulated": "ក្លែងធ្វើ",
          "view-all": "មើលកំណត់ត្រាទាំងអស់ →",
          "no-punches": "គ្មានការចុះម៉ោងនៅថ្ងៃនេះទេ។",
          "clocked-in": "បានចុះម៉ោងចូល",
          "clocked-out": "បានចុះម៉ោងចេញ",
          "tone-late": "យឺត",
          "tone-early": "ចេញមុន",
          "tone-ok": "ទាន់ពេល",
          "feed-note": "ថ្មីបំផុតមុន · ទាញចេញពីកំណត់ត្រាវត្តមានរបស់ថ្ងៃនេះ (ការចុះម៉ោងក្លែងធ្វើ)។",
          "dept-title": "វត្តមានតាមអង្គភាព · {date}",
          "rate": "អត្រា (នៃអ្នកត្រូវមក)៖",
          "legend-healthy": "≥80% ល្អ",
          "legend-watch": "60–79% តាមដាន",
          "legend-concern": "<60% គួរបារម្ភ",
          "dept-note": "រកក្រុមដែលត្រូវការការជំរុញពីអ្នកគ្រប់គ្រង · ភាគបែង = បុគ្គលិកដែលត្រូវមកនៅថ្ងៃនេះ។",
          "footnote": "ចំនួនទាញចេញពី **វេនការងារដែលបានផ្សព្វផ្សាយ** (គ្រោងទុក) និងម៉ាស៊ីនគណនាតាមកំណត់ត្រាដូចគ្នានឹងផ្ទាំង **កំណត់ត្រាវត្តមាន** (ជាក់ស្ដែង)។ ការចុះម៉ោងជា **ការក្លែងធ្វើ** សម្រាប់ការមើលជាមុន — ការភ្ជាប់ឧបករណ៍កំពុងរង់ចាំ គ្មានផលប៉ះពាល់លើប្រាក់បៀវត្សទេ។"
        },
        "grid": {
          "from": "ពី",
          "to": "ដល់",
          "days": "{n} ថ្ងៃ | {n} ថ្ងៃ",
          "capped": "(កំណត់ត្រឹម — បង្រួមចន្លោះ ឬប្រើផ្ទាំងរបាយការណ៍សម្រាប់ពេញមួយខែ)",
          "filters": "តម្រង",
          "filters-n": "តម្រង ({n})",
          "only-issues": "បង្ហាញតែបញ្ហា ({n})",
          "clear": "សម្អាតតម្រង",
          "employee": "បុគ្គលិក",
          "all-employees": "បុគ្គលិកទាំងអស់ ({n})",
          "org": "អង្គភាព",
          "all-org": "អង្គភាពទាំងអស់",
          "location": "ទីតាំង",
          "all-locations": "ទីតាំងទាំងអស់",
          "no-locations": "(គ្មានទីតាំងក្នុងវេនការងារ)",
          "type": "ប្រភេទការងារ",
          "all-types": "ប្រភេទទាំងអស់",
          "status": "ស្ថានភាព",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "note-reports": "តម្រងអនុវត្តលើគំនូសតាងរង្វង់ និងតារាងកំណត់ត្រាក្នុងពេលតែមួយ។",
          "note-records": "តម្រង និងចន្លោះកាលបរិច្ឆេទចែករំលែកជាមួយរបាយការណ៍វត្តមាន — ប្ដូរផ្ទាំងដើម្បីមើលសំណុំដែលបានត្រងដូចគ្នា។",
          "no-match": "គ្មានបុគ្គលិកត្រូវនឹងតម្រងទាំងនេះទេ។",
          "col": {
            "name": "ឈ្មោះពេញ",
            "code": "លេខសម្គាល់បុគ្គលិក",
            "org": "អង្គភាព",
            "shift": "វេន",
            "issues": "បញ្ហា"
          },
          "totals": "សរុប",
          "issues-n": "បញ្ហា · {n}",
          "remind-title": "ផ្ញើការរំលឹកទៅ {name} តាមទូរសព្ទ",
          "ok": "ល្អ",
          "legend": "សញ្ញា៖"
        },
        "reports": {
          "donut-label": "ការបែងចែកវត្តមាន · សរុប {n} ចន្លោះ",
          "total-slots": "ចន្លោះសរុប",
          "seg": {
            "on-time": "ទាន់ពេល",
            "late-in": "ចូលយឺត",
            "missed-clock-out": "ភ្លេចចុះម៉ោងចេញ",
            "absent": "អវត្តមាន",
            "leave": "ឈប់សម្រាក",
            "day-off": "ថ្ងៃឈប់",
            "ph": "ថ្ងៃបុណ្យ"
          },
          "records": "កំណត់ត្រាវត្តមាន ({n})",
          "records-of": "កំណត់ត្រាវត្តមាន ({n} / {total})",
          "totals-range": "សរុប (ក្នុងចន្លោះនេះ)",
          "legend": {
            "present": "មានវត្តមាន (P)",
            "late": "ចូលយឺត (La)",
            "missed": "ភ្លេចចុះម៉ោងចេញ (Mc)",
            "absent": "អវត្តមាន",
            "leave": "ឈប់សម្រាក",
            "day-off": "ថ្ងៃឈប់",
            "ph": "ថ្ងៃបុណ្យសាធារណៈ"
          },
          "note": "**បញ្ហា** = ថ្ងៃអវត្តមាន + ភ្លេចចុះម៉ោងចេញ ដែលមិនទាន់ដោះស្រាយ។ ត្រូវតែផ្ទៀងផ្ទាត់ (អនុម័តអវត្តមានជាការឈប់សម្រាក កែការចុះម៉ោងចេញ ឬសម្គាល់ថាគ្មានប្រាក់) មុនពេលបិទប្រាក់បៀវត្ស។ ចុចលើស្លាក \"បញ្ហា · N\" ណាមួយ ដើម្បីបើកការផ្ទៀងផ្ទាត់របស់បុគ្គលិកនោះ។"
        },
        "detail": {
          "title": "កំណត់ត្រាម៉ោង ({n})",
          "title-of": "កំណត់ត្រាម៉ោង ({n} / {total})",
          "issues": "បញ្ហា ({n})",
          "col": {
            "status": "ស្ថានភាព",
            "in": "ម៉ោងចូល",
            "out": "ម៉ោងចេញ",
            "duration": "រយៈពេល",
            "remark": "កំណត់សម្គាល់",
            "hrs": "ម៉ោង"
          },
          "remark": {
            "day-off": "ថ្ងៃឈប់",
            "public-holiday": "ថ្ងៃបុណ្យសាធារណៈ",
            "on-leave": "ឈប់សម្រាក (LV)",
            "absence": "អវត្តមាន",
            "on-time": "ទាន់ពេល",
            "late-23": "យឺត 23 នាទី",
            "missed-clock-out": "ភ្លេចចុះម៉ោងចេញ"
          },
          "note": "ទិដ្ឋភាពលម្អិតកំណត់ត្រឹម **អតិបរមា 14 ថ្ងៃ** ដើម្បីងាយអាន (ថ្ងៃនីមួយៗមាន 5 ជួរឈរ)។ សម្រាប់ចន្លោះធំជាងនេះ សូមប្រើ **របាយការណ៍វត្តមាន** ដែលបង្រួមមកមួយក្រឡាក្នុងមួយថ្ងៃ។ បញ្ហា = អវត្តមាន + ភ្លេចចុះម៉ោងចេញ — ត្រូវផ្ទៀងផ្ទាត់មុនពេលបិទប្រាក់បៀវត្ស។"
        },
        "rec": {
          "banner": "**កំណត់ត្រាវត្តមាន (គំរូ)។** វដ្តជីវិត៖ បានរកឃើញ → បានពិនិត្យ → រង់ចាំការអនុម័ត → បានដោះស្រាយ → បានចាក់សោ។ សំណើដោះស្រាយត្រូវបញ្ជូនតាមប្រភេទកម្លាំងពលកម្ម ហើយមិនដែលកែកំណត់ត្រាទេ។ ការចុះម៉ោងជាក់ស្ដែងជាការក្លែងធ្វើ — គ្មានឧបករណ៍ គ្មានផលប៉ះពាល់លើប្រាក់បៀវត្សទេ។",
          "focus": "កំពុងបង្ហាញ **{label}** · {date} (ពីសូចនាករនៃរូបភាពប្រចាំថ្ងៃ)",
          "clear-focus": "សម្អាតតម្រង",
          "focus-empty": "គ្មានកំណត់ត្រា {label} នៅថ្ងៃ {date} ទេ។",
          "view-as": "មើលជា៖",
          "lens-note": "(កែវតួនាទីគំរូ — មើលសមត្ថភាពជាមុនប៉ុណ្ណោះ)",
          "cap-title": "តារាងសមត្ថភាព",
          "cap-active": "សកម្ម",
          "cap-note": "— អ្នកគ្រប់គ្រងធនធានមនុស្សជាម្ចាស់កំណត់ត្រា ប្រធានផ្ទាល់របស់អតិថិជនខាងក្រៅអាចតែអនុម័តសម្រាប់បុគ្គលិកជួលពីខាងក្រៅ",
          "cap": {
            "role": "តួនាទី",
            "capture": "ចាប់យក",
            "correct": "កែតម្រូវ",
            "approve": "អនុម័ត",
            "own": "ម្ចាស់",
            "lock": "ចាក់សោ",
            "rollup": "មើលសរុប",
            "payroll": "បញ្ជូនទៅប្រាក់បៀវត្ស"
          },
          "vis": {
            "line": "ភាពមើលឃើញ — {role}៖ {label} · មើលឃើញកំណត់ត្រា **{n}**",
            "hradmin": "កំណត់ត្រាទាំងអស់ក្នុងក្រុមហ៊ុន / វិសាលភាពសកម្ម",
            "supervisor": "ទីតាំង / តំបន់៖ **{area}**",
            "clientlm": "តែកម្លាំងពលកម្មជួលពីខាងក្រៅ · **{client} ▸ {project}** (គ្មានបុគ្គលិកផ្ទាល់)",
            "pm": "តែការសរុបគម្រោង · **{project}**",
            "employee": "តែកំណត់ត្រាផ្ទាល់ខ្លួន"
          },
          "empty-role": "គ្មានកំណត់ត្រាដែល {role} អាចមើលឃើញក្នុងវិសាលភាពដែលបានចាត់តាំងទេ។",
          "empty": "មិនទាន់មានកំណត់ត្រាវត្តមានទេ។ ផ្សព្វផ្សាយវេនការងារ (ការរៀបចំកាលវិភាគ → វេនស្វ័យប្រវត្តិ) ឬជ្រើសក្រុមហ៊ុនដែលមានបុគ្គលិកសកម្ម ដើម្បីបង្កើតកំណត់ត្រា។",
          "kpi": {
            "records": "កំណត់ត្រា",
            "exceptions": "ករណីលើកលែង",
            "pending": "រង់ចាំការអនុម័ត",
            "resolved": "បានដោះស្រាយ",
            "locked": "បានចាក់សោ"
          },
          "pm": {
            "title": "ការសរុបគម្រោង / ទីតាំង — **អានតែប៉ុណ្ណោះ** (ទិដ្ឋភាពប្រធានគម្រោង)",
            "col": {
              "scope": "អតិថិជន · គម្រោង · ទីតាំង",
              "pending": "រង់ចាំ"
            },
            "empty": "គ្មានកំណត់ត្រាក្នុងវិសាលភាពទេ។"
          },
          "pay": {
            "title": "ម៉ោងត្រូវបង់ · ទិន្នន័យប្រាក់ផ្អែកលើវត្តមាន",
            "bases": "មូលដ្ឋានអត្រាតាមម៉ោង / ថ្ងៃ",
            "staff": "បុគ្គលិក {n}",
            "empty": "គ្មានបុគ្គលិកដែលគិតប្រាក់តាមម៉ោង/ថ្ងៃក្នុងទិដ្ឋភាពនេះទេ។ បុគ្គលិកប្រាក់ខែត្រូវការតែការដោះស្រាយករណីលើកលែង — ប្រាក់របស់ពួកគេមិនប្រែប្រួលតាមឯកតាវត្តមានទេ។",
            "per-case": "បានដកកម្មករតាមករណី (សេវាកម្ម) **{n}** ចេញ — បង់តាមភារកិច្ចដែលបានបញ្ចប់ មិនមែនតាមឯកតាវត្តមានទេ។",
            "col": {
              "employee": "បុគ្គលិក",
              "basis": "មូលដ្ឋានអត្រា",
              "units": "ឯកតាត្រូវបង់",
              "locked": "ក្នុងនោះបានចាក់សោ",
              "rate": "អត្រាក្នុងមួយឯកតា",
              "amount": "ចំនួនប៉ាន់ស្មាន",
              "ready": "ការត្រៀមសម្រាប់ប្រាក់បៀវត្ស"
            },
            "hours": "{n} ម៉ោង",
            "days": "{n} ថ្ងៃ | {n} ថ្ងៃ",
            "day": "ថ្ងៃ",
            "locked-amt": "(${amt} បានចាក់សោ)",
            "ready": "ត្រៀមសម្រាប់ប្រាក់បៀវត្ស",
            "n-locked": "{n}/{total} បានចាក់សោ",
            "foot": "ទិន្នន័យប្រាក់សម្រាប់ជាឧទាហរណ៍ **មិនមែនប័ណ្ណប្រាក់ខែទេ**៖ ឯកតាពីការចុះម៉ោងក្លែងធ្វើ (ម៉ោង = ចន្លោះចូល–ចេញ មិនដកម៉ោងសម្រាកក្នុងគំរូ) ចំនួនទឹកប្រាក់មិនត្រូវបានរក្សាទុកទេ។ មានតែកំណត់ត្រា **បានចាក់សោ** ទេដែលរាប់ថាត្រៀមសម្រាប់ប្រាក់បៀវត្ស — ការបញ្ជូនទៅប្រាក់បៀវត្សត្រូវបានពន្យារ (PAY-BL1)។",
            "foot-per-case": "បានដកកម្មករតាមករណី (សេវាកម្ម) {n} ចេញ — បង់តាមភារកិច្ចដែលបានបញ្ចប់ (ពន្ធកាត់ទុក 15%) មិនមែនតាមឯកតាវត្តមានទេ។"
          },
          "count": "កំណត់ត្រា {n} · តាមវេន + បើក/ដើម · រក្សាអតិថិជន▸គម្រោង▸ទីតាំងសម្រាប់ការសរុប",
          "count-capped": "កំណត់ត្រា {n} (បង្ហាញ {cap}) · តាមវេន + បើក/ដើម · រក្សាអតិថិជន▸គម្រោង▸ទីតាំងសម្រាប់ការសរុប",
          "col": {
            "employee": "បុគ្គលិក",
            "date": "កាលបរិច្ឆេទ",
            "mode": "របៀប",
            "expected": "រំពឹង",
            "actual": "ជាក់ស្ដែង",
            "provenance": "ប្រភព",
            "exception": "ករណីលើកលែង",
            "lifecycle": "វដ្តជីវិត",
            "action": "សកម្មភាព"
          },
          "direct": "ផ្ទាល់",
          "ok": "ល្អ",
          "open": "បើក",
          "open-aria": "បើកការពិនិត្យករណីលើកលែងសម្រាប់ {name} នៅថ្ងៃ {date}",
          "ot": {
            "sanctioned": "ម៉ោងបន្ថែមបានអនុញ្ញាត",
            "requested": "បានស្នើម៉ោងបន្ថែម",
            "detected": "រកឃើញម៉ោងបន្ថែម (ពិនិត្យ)"
          }
        },
        "drawer": {
          "title": "ការពិនិត្យករណីលើកលែង",
          "close": "បិទ",
          "outside-title": "នៅក្រៅវិសាលភាពមើលឃើញរបស់អ្នក",
          "outside": "កំណត់ត្រានេះមិនអាចមើលឃើញដោយ {role} ទេ។",
          "facts": "ការពិតដែលបានរកឃើញ (អានតែប៉ុណ្ណោះ)",
          "fact": {
            "employee": "បុគ្គលិក",
            "workforce": "កម្លាំងពលកម្ម",
            "cps": "អតិថិជន ▸ គម្រោង ▸ ទីតាំង",
            "date": "កាលបរិច្ឆេទ",
            "mode": "របៀប",
            "expected": "រំពឹង",
            "actual": "ជាក់ស្ដែង",
            "provenance": "ប្រភព",
            "exception": "ករណីលើកលែង",
            "ot": "ការណែនាំម៉ោងបន្ថែម"
          },
          "absent-no-punch": "អវត្តមាន (គ្មានការចុះម៉ោង)",
          "ot": {
            "sanctioned": "បានអនុញ្ញាត",
            "requested": "បានស្នើ (រង់ចាំ)",
            "detected": "បានរកឃើញ (ពិនិត្យ គ្មានប្រាក់)"
          },
          "lifecycle": "វដ្តជីវិត",
          "routing": "ផ្លូវអនុម័ត ({wf})",
          "next": "សកម្មភាពបន្ទាប់៖",
          "ot-title": "ការណែនាំម៉ោងបន្ថែម",
          "ot-detected": "ការចុះម៉ោងបង្ហាញថាធ្វើការហួសម៉ោងបញ្ចប់គ្រោងទុក",
          "ot-pay-note": "ម៉ោងបន្ថែមបង់តែតាមរយៈសំណើម៉ោងបន្ថែមដែលបានផ្ទៀងផ្ទាត់ប៉ុណ្ណោះ។",
          "ot-create": "បង្កើតសំណើម៉ោងបន្ថែមពីការចុះម៉ោង",
          "ot-requested": "សំណើម៉ោងបន្ថែមកំពុងរង់ចាំសម្រាប់ថ្ងៃនេះ — ផ្ទៀងផ្ទាត់នៅក្នុងម៉ូឌុលម៉ោងបន្ថែម។",
          "ot-sanctioned": "ម៉ោងបន្ថែមត្រូវបានអនុញ្ញាតសម្រាប់ថ្ងៃនេះ (សំណើបានអនុម័ត)។",
          "raise-title": "ដាក់សំណើដោះស្រាយ",
          "select-type": "— ជ្រើសប្រភេទសំណើ —",
          "raise": "ដាក់សំណើ",
          "timeline": "ពេលវេលាសកម្មភាព",
          "adr": "យោងតាម ATT-ADR-1៖ ការរកឃើញជាអានតែប៉ុណ្ណោះ សំណើ/ការអនុម័តសរសេរតែទៅលំហូរការងារក្នុងវគ្គប៉ុណ្ណោះ — កំណត់ត្រាមិនដែលត្រូវបានកែទេ។",
          "adr-open": "គ្មានផលប៉ះពាល់លើប្រាក់បៀវត្សទេ។",
          "adr-locked": "កំណត់ត្រានេះ **បានចាក់សោ** (ត្រៀមចាក់សោប្រាក់បៀវត្ស) — មិនអាចផ្លាស់ប្ដូរទៀតទេ។ ការភ្ជាប់ប្រាក់បៀវត្សត្រូវបានពន្យារ។",
          "readonly": "អានតែប៉ុណ្ណោះនៅគ្រប់វិសាលភាព — ប្ដូរទៅកន្លែងធ្វើការរបស់ក្រុមហ៊ុន។",
          "locked": "បានចាក់សោ — មិនអាចផ្លាស់ប្ដូរទៀតទេ។",
          "review": "សម្គាល់ថាបានពិនិត្យ",
          "approve": "អនុម័ត",
          "reject": "បដិសេធ",
          "lock": "ចាក់សោ (ប្រាក់បៀវត្ស)",
          "blk": {
            "review": "ការពិនិត្យជាកម្មសិទ្ធិរបស់អ្នកគ្រប់គ្រងទីតាំង / ធនធានមនុស្ស",
            "approve-ext": "ការអនុម័តជាកម្មសិទ្ធិរបស់ប្រធានផ្ទាល់អតិថិជនខាងក្រៅ",
            "approve-sup": "ការអនុម័តជាកម្មសិទ្ធិរបស់អ្នកគ្រប់គ្រងទីតាំង / ធនធានមនុស្ស",
            "lock": "ការចាក់សោជាកម្មសិទ្ធិរបស់អ្នកគ្រប់គ្រងធនធានមនុស្ស"
          },
          "no-action": "គ្មានសកម្មភាពសម្រាប់តួនាទីនេះនៅដំណាក់កាលនេះទេ។"
        },
        "resolve": {
          "title": "ដោះស្រាយបញ្ហាវត្តមាន",
          "staff": "បុគ្គលិក {n}",
          "subtitle": "ដាក់ស្នើសុំការអនុម័តពីប្រធានផ្ទាល់ · {date}",
          "best-title": "ការអនុវត្តល្អ៖ ស្នើឱ្យបុគ្គលិកដោះស្រាយដោយខ្លួនឯងតាមទូរសព្ទ",
          "best-text": "អេក្រង់នេះសម្រាប់ **ដាក់ស្នើជំនួស** — ប្រើតែនៅពេលដែលការបម្រើខ្លួនឯងមិនអាចធ្វើបាន (គ្មានស្មាតហ្វូន កំពុងឈប់សម្រាក នៅរោងចក្រ ។ល។)។ ការដាក់ស្នើនៅទីនេះត្រូវបានកត់ត្រាជា **hr-on-behalf** ក្នុងកំណត់ត្រាសវនកម្ម។",
          "remind-instead": "ផ្ញើការរំលឹកជំនួសវិញ",
          "detected": "បានរកឃើញ {type}",
          "type": {
            "missed-out": "ភ្លេចចុះម៉ោងចេញ",
            "absent": "អវត្តមាន",
            "wrong-location": "ទីតាំងខុស",
            "system-error": "កំហុសប្រព័ន្ធ"
          },
          "desc": {
            "missed-out": "គ្មានការចុះម៉ោងចេញ។ សូមផ្ដល់ម៉ោងបញ្ចប់ត្រឹមត្រូវ។",
            "absent": "គ្មានការចុះម៉ោងចូលសម្រាប់ថ្ងៃនេះ។ ជ្រើសរើសវិធីដោះស្រាយ។",
            "wrong-location": "ប្រព័ន្ធបានកត់ត្រាទីតាំងខុសសម្រាប់ការចុះម៉ោងនេះ។",
            "system-error": "បានកត់ត្រាការចុះម៉ោង ប៉ុន្តែទិន្នន័យខុស (ម៉ោង ឧបករណ៍ ឬបញ្ហាធ្វើសមកាលកម្ម)។"
          },
          "res": {
            "use-scheduled": "ប្រើម៉ោងបញ្ចប់តាមកាលវិភាគ — លំនាំដើមជាម៉ោងបញ្ចប់វេន (ទូទៅបំផុត)",
            "set-actual": "កំណត់ម៉ោងជាក់ស្ដែង — វាយម៉ោងដែលបុគ្គលិកចាកចេញពិតប្រាកដ",
            "half-day": "ប្ដូរទៅជាអវត្តមានកន្លះថ្ងៃ — បុគ្គលិកចេញមុនដោយមិនចុះម៉ោងចេញ",
            "convert-leave": "ប្ដូរទៅជាការឈប់សម្រាក — ប្រើសមតុល្យច្បាប់ — បើកសំណើឈប់សម្រាក",
            "approved-exc": "ករណីលើកលែងដែលបានអនុម័ត — បន្ទាន់ គ្រួសារ ឬហេតុផលដែលបានព្រមព្រៀងមុន",
            "unpaid": "បញ្ជាក់ជាអវត្តមានគ្មានប្រាក់ — លំនាំដើម — មិនប្រើសមតុល្យច្បាប់",
            "fix-location": "កែទីតាំង — ជ្រើសទីតាំងត្រឹមត្រូវ",
            "note-only": "កត់ចំណាំតែប៉ុណ្ណោះ — IT ឬធនធានមនុស្សនឹងស៊ើបអង្កេត គ្មានការប្ដូរម៉ោង"
          },
          "issue-type": "ប្រភេទបញ្ហា",
          "type-locked": "🔒 បានបំពេញជាមុនពីកំណត់ត្រាវត្តមាន — មិនអាចប្ដូរបានទេ",
          "apply-all": "អនុវត្តការដោះស្រាយដូចគ្នាចំពោះបុគ្គលិកទាំង {n}",
          "apply-all-on": "កំណត់ការដោះស្រាយ + ហេតុផលម្ដងខាងក្រោម។ សំណើនីមួយៗនៅតែបញ្ជូនទៅប្រធានផ្ទាល់របស់ខ្លួន។",
          "apply-all-off": "បុគ្គលិកម្នាក់ៗមានជួរដោះស្រាយផ្ទាល់ខ្លួនខាងក្រោម។",
          "bulk-title": "ការដោះស្រាយ (អនុវត្តចំពោះទាំង {n})",
          "resolution": "ការដោះស្រាយ",
          "default-in": "ម៉ោងចូលលំនាំដើម",
          "default-out": "ម៉ោងចេញលំនាំដើម",
          "reason": "ហេតុផល / ចំណាំ",
          "reason-all-ph": "ការពន្យល់ខ្លី — អនុវត្តចំពោះទាំងអស់",
          "reason-ph": "ហេតុផលខ្លី — ចាំបាច់",
          "affected": "បុគ្គលិកដែលរងផលប៉ះពាល់",
          "affected-routing": "បុគ្គលិកដែលរងផលប៉ះពាល់ និងផ្លូវបញ្ជូន",
          "already": "បានដាក់ស្នើរួចជា {id} · ស្ថានភាព៖ **{status}**",
          "skip": "រំលង",
          "routes-to": "បញ្ជូនទៅ៖",
          "external-lm": "ប្រធានផ្ទាល់ខាងក្រៅ",
          "escalates": "បញ្ជូនបន្ត",
          "no-primary": "(គ្មានប្រធានផ្ទាល់ចម្បង — បញ្ជូនទៅធនធានមនុស្ស)",
          "no-manager": "(គ្មានអ្នកគ្រប់គ្រងផ្ទាល់ — បញ្ជូនទៅធនធានមនុស្ស)",
          "clock-in": "ម៉ោងចូល (មានស្រាប់)",
          "clock-out": "ម៉ោងចេញ",
          "routing-note": "សំណើនីមួយៗត្រូវបញ្ជូនដាច់ដោយឡែកទៅប្រធានផ្ទាល់របស់បុគ្គលិក។ **បុគ្គលិកផ្ទាល់** បញ្ជូនទៅអ្នកគ្រប់គ្រងផ្ទាល់របស់ខ្លួន។ **បុគ្គលិកជួលពីខាងក្រៅ** បញ្ជូនទៅប្រធានផ្ទាល់ខាងក្រៅចម្បងរបស់គម្រោង (ឬបម្រុង ប្រសិនបើចម្បងមិនទំនេរ)។ ស្ថានភាព៖ រង់ចាំប្រធានផ្ទាល់ → អនុម័ត/បដិសេធ។ ធនធានមនុស្សទទួលបានការជូនដំណឹងពេលដោះស្រាយ។",
          "reason-required": "⚠ ត្រូវការហេតុផល",
          "clockout-required": "⚠ ត្រូវការម៉ោងចេញលំនាំដើម",
          "cancel": "បោះបង់",
          "submit": "ដាក់ស្នើសុំការអនុម័ត"
        },
        "src": {
          "empty": "ក្រុមហ៊ុននេះមិនទាន់មាន **វេនការងារដែលបានផ្សព្វផ្សាយ** នៅឡើយទេ។ ផ្សព្វផ្សាយវេនការងារក្នុងកាលវិភាគ → វេនស្វ័យប្រវត្តិ ដើម្បីមើលវត្តមានគ្រោងទុកធៀបនឹងជាក់ស្ដែងនៅទីនេះ។",
          "empty-note": "វេនការងារព្រាងមិនត្រូវបានបង្ហាញទេ។",
          "banner": "**ប្រភពវេនការងារ (អានតែប៉ុណ្ណោះ / ណែនាំ)។** វេនគ្រោងទុកមកពី **វេនការងារដែលបានផ្សព្វផ្សាយ** ក្នុងម៉ូឌុលកាលវិភាគ។ ការចុះម៉ោងជាក់ស្ដែងជាការក្លែងធ្វើសម្រាប់មើលជាមុន (ការភ្ជាប់ឧបករណ៍កំពុងរង់ចាំ) — គ្មានផលប៉ះពាល់លើប្រាក់បៀវត្សទេ។",
          "kpi": {
            "planned": "វេនគ្រោងទុក",
            "on-time": "ទាន់ពេល",
            "exceptions": "ករណីលើកលែង",
            "on-leave": "កំពុងឈប់សម្រាក"
          },
          "planned": "វេនគ្រោងទុកធៀបនឹងវត្តមានជាក់ស្ដែង · វេនគ្រោងទុក {n}",
          "planned-capped": "វេនគ្រោងទុកធៀបនឹងវត្តមានជាក់ស្ដែង · វេនគ្រោងទុក {n} (បង្ហាញ {cap})",
          "col": {
            "employee": "បុគ្គលិក",
            "date": "កាលបរិច្ឆេទ",
            "shift": "វេនគ្រោងទុក",
            "time": "ម៉ោងគ្រោងទុក",
            "status": "ស្ថានភាពវត្តមាន",
            "exception": "ករណីលើកលែង"
          },
          "night": "យប់",
          "on-time": "ទាន់ពេល",
          "unplanned-title": "ករណីលើកលែងវត្តមាននៅថ្ងៃសម្រាក និងមិនបានគ្រោងទុក",
          "no-unplanned": "គ្មានករណីលើកលែងវត្តមាននៅថ្ងៃសម្រាក / មិនបានគ្រោងទុកទេ។"
        },
        "port": {
          "label": "ការត្រួតពិនិត្យវត្តមាន",
          "sub-tenant": "គ្រប់វិសាលភាព · ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការវត្តមានថ្នាក់នាយក · សូចនាករសរុប + រូបភាពដែលបានចាក់សោ · អានតែប៉ុណ្ណោះ",
          "sub-client": "{name} · ការសរុបវត្តមាន · អានតែប៉ុណ្ណោះ",
          "sub-company": "{name} · ឋានានុក្រមវត្តមាន · អានតែប៉ុណ្ណោះ (ប្រតិបត្តិការនៅវិសាលភាពម្ចាស់)",
          "client": "អតិថិជន",
          "all-scopes": "គ្រប់វិសាលភាព",
          "direct": "កម្លាំងពលកម្មផ្ទាល់",
          "direct-sub": "ម្ចាស់វត្តមាន · បុគ្គលិករបស់ក្រុមហ៊ុន",
          "project-sub": "{id} · ម្ចាស់វត្តមាន",
          "rollup": "ការសរុបអតិថិជន · អានតែប៉ុណ្ណោះ",
          "kpi": {
            "workspaces": "កន្លែងធ្វើការ",
            "units": "អង្គភាព",
            "attention": "{label} ដែលត្រូវយកចិត្តទុកដាក់",
            "attention-tip": "{label} ដែលមានសូចនាករហានិភ័យពណ៌លឿងទុំ ឬក្រហម",
            "employees": "បុគ្គលិករងផលប៉ះពាល់",
            "employees-tip": "បុគ្គលិកដែលមានករណីលើកលែងវត្តមានមិនទាន់ដោះស្រាយយ៉ាងហោចណាស់មួយ",
            "completion": "ការបញ្ចប់វត្តមាន",
            "completion-tip": "ថ្ងៃដែលបានចាក់សោ ÷ ថ្ងៃរំពឹងក្នុងរយៈពេលរកប្រាក់វត្តមាន (មិនមែនរយៈពេលបើកប្រាក់បៀវត្សទេ) ({locked}/{total})",
            "oldest": "ករណីលើកលែងចាស់ជាងគេដែលនៅសល់",
            "oldest-tip": "បើកតាំងពី {date}{name}",
            "oldest-none": "គ្មានករណីលើកលែងនៅសល់ទេ"
          },
          "days": "{n}ថ្ងៃ",
          "top": "អាទិភាពខ្ពស់បំផុត",
          "cut-chip": "ថ្ងៃផុតកំណត់ {date} ({n}ថ្ងៃ)",
          "cut-tip": "{label} · ថ្ងៃបើកប្រាក់ {pay}",
          "review": "ពិនិត្យ",
          "review-tip": "ចូលលម្អិតកន្លែងធ្វើការនេះ",
          "ready": {
            "ready": "✅ រួចរាល់",
            "waiting": "⚠ កំពុងរង់ចាំ",
            "blocked": "❌ ត្រូវបានរាំងស្ទះ"
          },
          "ready-tip": {
            "ready": "គ្រប់ថ្ងៃរំពឹងនៃរយៈពេលរកប្រាក់វត្តមានត្រូវបានចាក់សោ (ឬគ្មានថ្ងៃរំពឹង) — រូបភាពត្រូវបានបង្កកសម្រាប់ប្រាក់បៀវត្ស",
            "waiting": "រយៈពេលមិនទាន់ចាក់សោពេញលេញ — គ្មានករណីលើកលែងរាំងស្ទះ",
            "blocked": "ករណីលើកលែងវត្តមានមិនទាន់ដោះស្រាយត្រូវតែដោះស្រាយមុនថ្ងៃផុតកំណត់ប្រាក់បៀវត្ស"
          },
          "col": {
            "workspace": "កន្លែងធ្វើការ",
            "scope": "វិសាលភាព",
            "risk": "ហានិភ័យ",
            "employees": "បុគ្គលិក",
            "exc": "ករណីលើកលែងកំពុងដំណើរការ",
            "pending": "ការអនុម័តកំពុងរង់ចាំ",
            "progress": "វឌ្ឍនភាព (ថ្ងៃបានចាក់សោ)",
            "ready": "ត្រៀមប្រាក់បៀវត្ស",
            "trend": "និន្នាការ",
            "cutoff": "ថ្ងៃផុតកំណត់បន្ទាប់ (អាស្រ័យលើវត្តមាន)",
            "cutoff-tip": "ការបើកប្រាក់បៀវត្សបន្ទាប់ដែលប្រើវត្តមាន (រំលងការបើកប្រាក់មុន)",
            "locks": "រយៈពេលបានចាក់សោ",
            "period": "រយៈពេលវត្តមាន",
            "records": "កំណត់ត្រា",
            "present": "មានវត្តមាន",
            "absent": "អវត្តមាន",
            "onleave": "កំពុងឈប់សម្រាក",
            "exceptions": "ករណីលើកលែង",
            "locked": "បានចាក់សោ",
            "status": "ស្ថានភាព",
            "date": "កាលបរិច្ឆេទ",
            "employee": "បុគ្គលិក",
            "project": "គម្រោង",
            "expected": "រំពឹង",
            "in": "ចូល",
            "out": "ចេញ",
            "exception": "ករណីលើកលែង",
            "state": "សភាព"
          },
          "affected": "បុគ្គលិករងផលប៉ះពាល់ {n}",
          "progress-tip": "{locked} ក្នុងចំណោម {total} ថ្ងៃបានចាក់សោក្នុងរយៈពេលរកប្រាក់វត្តមាន",
          "trend": "{n}% ធៀបនឹងរយៈពេលមុន",
          "trend-none": "មិនមានប្រវត្តិគ្រប់គ្រាន់សម្រាប់និន្នាការទេ",
          "no-calendar": "មិនបានកំណត់ប្រតិទិនប្រាក់បៀវត្សទេ",
          "open": "បើក",
          "open-co-tip": "បើកកន្លែងធ្វើការរបស់ក្រុមហ៊ុន — ប្រតិបត្តិការវត្តមាននៅវិសាលភាពម្ចាស់របស់វា",
          "open-unit-tip": "បើកកន្លែងធ្វើការវត្តមាន — វិសាលភាពម្ចាស់ (ប្រតិបត្តិការ)",
          "summary": "សេចក្ដីសង្ខេប",
          "summary-tip": "មើលរូបភាពដែលបានចាក់សោចុងក្រោយ (អានតែប៉ុណ្ណោះ)",
          "locks-tip": "រយៈពេលវត្តមានដែលបានចាក់សោសម្រាប់អង្គភាពនេះ",
          "l1-empty": "គ្មានកន្លែងធ្វើការត្រូវនឹងតម្រងនេះទេ។",
          "foot-l1": "ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការវត្តមានថ្នាក់នាយក · គិតត្រឹម {asOf} (កាលបរិច្ឆេទវត្តមានចុងក្រោយ) · ថ្ងៃផុតកំណត់ = ការបើកប្រាក់បៀវត្សបន្ទាប់ដែលអាស្រ័យលើវត្តមានពីប្រតិទិនដំណើរការប្រាក់បៀវត្ស (រំលងការបើកប្រាក់មុន) · សូចនាករសរុបតែប៉ុណ្ណោះ — ប្រតិបត្តិការនៅវិសាលភាពម្ចាស់ · ជួរតម្រៀបតាមហានិភ័យ · ចុចលើជួរដើម្បីចូលលម្អិត",
          "l2-lead": "ប្រតិបត្តិការវត្តមាននៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង)។",
          "l2-text": "កម្រិតនេះបង្ហាញតែសូចនាករសរុបកំពុងដំណើរការ និងរូបភាពរយៈពេលដែលបានចាក់សោប៉ុណ្ណោះ។ ជួរអតិថិជនជាការសរុបរួម (អានតែប៉ុណ្ណោះ)។",
          "cut": "{date} · {label} ({n}ថ្ងៃ បើកប្រាក់ {pay})",
          "window": "រយៈពេលរកប្រាក់វត្តមាន ({from} → {to}]",
          "foot-l2": "ថ្ងៃផុតកំណត់ប្រាក់បៀវត្សបន្ទាប់ដែលអាស្រ័យលើវត្តមាន៖ {cut}{window} · គិតត្រឹម {asOf} · ចុចលើជួរដើម្បីមើលរយៈពេលដែលបានចាក់សោ",
          "l3-empty": "វិសាលភាពនេះមិនទាន់មានរយៈពេលវត្តមានដែលបានចាក់សោទេ — កន្លែងធ្វើការម្ចាស់បិទរយៈពេលតាមរយៈ “ចាក់សោរយៈពេលវត្តមាន”។",
          "l3-foot": "ចុចលើរយៈពេលដើម្បីបើករូបភាពដែលបានបង្កក (អានតែប៉ុណ្ណោះ)",
          "l4-missing": "រកមិនឃើញរូបភាពដែលបានចាក់សោទេ។",
          "l4-lead": "រយៈពេលវត្តមានដែលបានចាក់សោ — រូបភាពដែលបានបង្កក (អានតែប៉ុណ្ណោះ)។",
          "l4-text": "បានចាក់សោ {at} ដោយ {by} · កំណត់ត្រា {recs} · ករណីលើកលែង {exc} ({unresolved} មិនទាន់ដោះស្រាយពេលចាក់សោ)។ រូបភាពនេះគឺជាអ្វីដែលប្រាក់បៀវត្សប្រើ គ្មានប្រតិបត្តិការវត្តមាននៅវិសាលភាពត្រួតពិនិត្យទេ។"
        },
        "data": {
          "state": {
            "detected": "បានរកឃើញ",
            "reviewed": "បានពិនិត្យ",
            "pending-approval": "រង់ចាំការអនុម័ត",
            "resolved": "បានដោះស្រាយ",
            "locked": "បានចាក់សោ"
          },
          "mode": {
            "roster-based": "តាមវេន",
            "fixed": "ថេរ",
            "flexible": "បត់បែន",
            "open": "បើក"
          },
          "status": {
            "present": "មានវត្តមាន",
            "absent": "អវត្តមាន",
            "on-leave": "ឈប់សម្រាក",
            "exception": "ករណីលើកលែង"
          },
          "exception": {
            "missing-clock-in": "គ្មានការចុះម៉ោងចូល",
            "missing-clock-out": "គ្មានការចុះម៉ោងចេញ",
            "late-against-planned-start": "យឺតធៀបនឹងម៉ោងចាប់ផ្ដើមគ្រោងទុក",
            "early-leave": "ចេញមុន",
            "worked-on-rest-off-day": "ធ្វើការនៅថ្ងៃសម្រាក/ថ្ងៃឈប់",
            "unplanned-attendance": "វត្តមានមិនបានគ្រោងទុក"
          },
          "provenance": {
            "leave-overlay": "ការឈប់សម្រាកត្រួតលើ",
            "correction-request": "សំណើកែតម្រូវ",
            "device-punch-sim": "ការចុះម៉ោងតាមឧបករណ៍ (ក្លែងធ្វើ)"
          },
          "action": {
            "review-site-supervisor-hr": "ពិនិត្យ — អ្នកគ្រប់គ្រងទីតាំង / ធនធានមនុស្ស",
            "raise-correction-employee-supervisor-or-send-to-approval": "ដាក់ការកែតម្រូវ (បុគ្គលិក / អ្នកគ្រប់គ្រង) ឬបញ្ជូនទៅអនុម័ត",
            "approve-external-client-lm-optimal-hr": "អនុម័ត — ប្រធានផ្ទាល់អតិថិជនខាងក្រៅ → Optimal HR",
            "approve-site-supervisor-hr": "អនុម័ត — អ្នកគ្រប់គ្រងទីតាំង / ធនធានមនុស្ស",
            "lock-hr-admin": "ចាក់សោ — អ្នកគ្រប់គ្រងធនធានមនុស្ស",
            "none-locked": "គ្មាន (បានចាក់សោ)"
          },
          "stage": {
            "detection": "ការរកឃើញ",
            "review": "ការពិនិត្យ",
            "request": "សំណើ",
            "approval": "ការអនុម័ត",
            "resolution": "ការដោះស្រាយ",
            "rejected": "បានបដិសេធ",
            "locked": "បានចាក់សោ",
            "employee": "បុគ្គលិក",
            "external-client-lm": "ប្រធានផ្ទាល់អតិថិជនខាងក្រៅ",
            "supervisor": "អ្នកគ្រប់គ្រង",
            "hr": "ធនធានមនុស្ស"
          },
          "workforce": {
            "direct": "ផ្ទាល់",
            "outsourced": "ជួលពីខាងក្រៅ"
          },
          "source": {
            "schedule": "កាលវិភាគ",
            "roster": "វេនការងារ"
          },
          "request": {
            "missing-punch": "ភ្លេចចុះម៉ោង",
            "wrong-punch": "ចុះម៉ោងខុស",
            "late-arrival": "មកយឺត",
            "early-departure": "ចេញមុន",
            "ot-dispute": "វិវាទម៉ោងបន្ថែម"
          },
          "role": {
            "hradmin": "អ្នកគ្រប់គ្រងធនធានមនុស្ស",
            "supervisor": "អ្នកគ្រប់គ្រងទីតាំង",
            "clientlm": "ប្រធានផ្ទាល់អតិថិជនខាងក្រៅ",
            "pm": "ប្រធានគម្រោង",
            "employee": "បុគ្គលិក (ESS)"
          }
        }
      },
      "schedules": {
        "pills": {
          "schedules": "កាលវិភាគ",
          "holidays": "ថ្ងៃឈប់សម្រាក",
          "meals": "ការសម្រាកអាហារ"
        },
        "create": {
          "schedule": "កាលវិភាគថ្មី",
          "holiday": "ថ្ងៃឈប់សម្រាកថ្មី",
          "meal": "ការសម្រាកអាហារថ្មី"
        },
        "create-toast": "{name} — អ្នកមគ្គទេសក៍នឹងមកដល់ក្នុងស្រាប់ៗ",
        "created-toast": "បានបង្កើត {name}",
        "search": {
          "schedules": "ស្វែងរកតាមឈ្មោះ ប្រភេទ ឬថ្ងៃឈប់…",
          "holidays": "ស្វែងរកតាមឈ្មោះ កូដ ឬឆ្នាំ…",
          "meals": "ស្វែងរកតាមឈ្មោះ…"
        },
        "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} {kind}",
        "kind": {
          "schedules": "កាលវិភាគ",
          "holidays": "បញ្ជីថ្ងៃឈប់សម្រាក",
          "meals": "ការសម្រាកអាហារ"
        },
        "kpi": {
          "schedules": "កាលវិភាគ",
          "employees-assigned": "បុគ្គលិកដែលបានកំណត់",
          "unused-templates": "គំរូមិនបានប្រើ",
          "avg-hours": "ម៉ោងជាមធ្យម/សប្ដាហ៍",
          "holiday-lists": "បញ្ជីថ្ងៃឈប់សម្រាក",
          "active": "សកម្ម",
          "total-dates": "កាលបរិច្ឆេទសរុប",
          "current-year": "ឆ្នាំបច្ចុប្បន្ន ({year})",
          "meal-breaks": "ការសម្រាកអាហារ",
          "schedules-using-breaks": "កាលវិភាគប្រើការសម្រាក",
          "avg-duration": "រយៈពេលជាមធ្យម",
          "cambodia-standard": "ស្ដង់ដារកម្ពុជា"
        },
        "filters": {
          "all": "ទាំងអស់",
          "all-years": "គ្រប់ឆ្នាំ",
          "all-statuses": "គ្រប់ស្ថានភាព",
          "active": "សកម្ម",
          "inactive": "មិនសកម្ម"
        },
        "actions": {
          "clear-filters": "សម្អាតការត្រង",
          "export": "នាំចេញ",
          "edit": "កែសម្រួល",
          "delete": "លុប"
        },
        "schedules-table": {
          "name": "ឈ្មោះ",
          "type": "ប្រភេទ",
          "weekly-day-off": "ថ្ងៃឈប់ប្រចាំសប្ដាហ៍",
          "hours-week": "ម៉ោងតាមកាលវិភាគ",
          "employees": "បុគ្គលិក",
          "edit": "កែសម្រួល",
          "empty": "គ្មានកាលវិភាគណាមួយស៊ីគ្នានឹងការត្រងនេះទេ",
          "info": "កាលវិភាគគឺជាគំរូ — HR ភ្ជាប់មួយពេលធ្វើបេសកកម្មបញ្ចូលបុគ្គលិក (ជំហានទី ២ នៃជំនួយការ Add Person)។ ការកែប្រែនៅទីនេះនឹងធ្វើបច្ចុប្បន្នភាពបុគ្គលិកដែលបានភ្ជាប់ទាំងអស់ឆ្ពោះទៅមុខ។",
          "empty-none": "មិនទាន់មានកាលវិភាគទេ — បង្កើតមួយដើម្បីកំណត់សប្ដាហ៍ធ្វើការ។"
        },
        "holidays-table": {
          "name": "ឈ្មោះ",
          "code": "កូដ",
          "year": "ឆ្នាំ",
          "type": "ប្រភេទ",
          "dates": "កាលបរិច្ឆេទ",
          "status": "ស្ថានភាព",
          "edit": "កែសម្រួល",
          "empty": "គ្មានថ្ងៃឈប់សម្រាកណាមួយស៊ីគ្នានឹងការត្រងនេះទេ",
          "info": "បញ្ជី PH ស្តង់ដារត្រូវបានថែទាំដោយ Optimal HR។ អតិថិជនអាចចម្លងឆ្នាំមួយ ហើយកែតម្រូវខ្លួនឯងបាន (បន្ថែម/លុបកាលបរិច្ឆេទ រឺវ៉ារ្យ៉ង់តាមតំបន់)។ កម្ពុជាមាន PH ~22 ក្នុងមួយឆ្នាំ — ការធ្វើបច្ចុប្បន្នភាពប្រចាំឆ្នាំនៅខែមករា។",
          "empty-none": "មិនទាន់មានបញ្ជីថ្ងៃឈប់សម្រាកទេ — បង្កើតមួយសម្រាប់ឆ្នាំប្រតិទិន។"
        },
        "meals-table": {
          "name": "ឈ្មោះ",
          "start": "ម៉ោងចាប់ផ្តើម",
          "end": "ម៉ោងបញ្ចប់",
          "duration": "រយៈពេល",
          "schedules-using": "កាលវិភាគដែលប្រើ",
          "edit": "កែសម្រួល",
          "minutes": "{n} នាទី",
          "empty": "គ្មានការសម្រាកអាហារណាមួយស៊ីគ្នានឹងការស្វែងរកនេះទេ",
          "info": "ការសម្រាកអាហារអាចប្រើឡើងវិញ — ជ្រើសរើសមួយពេលអ្នកបង្កើតកាលវិភាគ។ កាលវិភាគ Optimal P ភាគច្រើនប្រើពេលសម្រាកអាហារ ៦០ នាទី (១២:០០–១៣:០០)។ ច្បាប់ការងារកម្ពុជាមិនបង្ខំទេ ប៉ុន្តែ ៦០ នាទីគឺជាស្ដង់ដារឧស្សាហកម្ម។",
          "empty-none": "មិនទាន់មានពេលសម្រាកអាហារទេ។"
        },
        "drawer": {
          "close": "បិទ",
          "fields": {
            "type": "ប្រភេទ",
            "days-off": "ថ្ងៃឈប់ប្រចាំសប្ដាហ៍",
            "hours-week": "ម៉ោង / សប្ដាហ៍",
            "assigned": "បុគ្គលិកដែលបានកំណត់",
            "public-holiday": "បញ្ជីថ្ងៃឈប់សាធារណៈ",
            "other-holidays": "ថ្ងៃឈប់ដទៃ",
            "year": "ឆ្នាំ",
            "code": "កូដ",
            "status": "ស្ថានភាព",
            "dates": "កាលបរិច្ឆេទ",
            "start": "ចាប់ផ្តើម",
            "end": "បញ្ចប់",
            "duration": "រយៈពេល",
            "schedules-using": "កាលវិភាគដែលប្រើការសម្រាកនេះ",
            "activity": "សកម្មភាព",
            "weekly-hours": "ម៉ោងក្នុងសប្ដាហ៍"
          },
          "no-value": "—"
        },
        "modal": {
          "schedule": {
            "title": "បង្កើតកាលវិភាគ",
            "lede": "គំរូសប្ដាហ៍ការងារ",
            "fields": {
              "name": "ឈ្មោះ",
              "type": "ប្រភេទ"
            },
            "placeholders": {
              "name": "ឧ. OP_Field_Crew"
            },
            "validation": {
              "name-required": "ត្រូវការឈ្មោះកាលវិភាគ។"
            }
          },
          "holiday": {
            "title": "បង្កើតបញ្ជីថ្ងៃឈប់សម្រាក",
            "lede": "បញ្ជីថ្ងៃឈប់សាធារណៈសម្រាប់ឆ្នាំប្រតិទិន",
            "fields": {
              "name": "ឈ្មោះ",
              "code": "កូដ",
              "year": "ឆ្នាំ"
            },
            "placeholders": {
              "name": "ឧ. បញ្ជីថ្ងៃឈប់សម្រាកស្ដង់ដារសម្រាប់ឆ្នាំ ២០២៧",
              "code": "Standard / Custom-XX"
            },
            "validation": {
              "name-required": "ត្រូវការឈ្មោះបញ្ជី។",
              "code-required": "ត្រូវការកូដ។",
              "year-invalid": "ឆ្នាំត្រូវតែជាលេខ ៤ ខ្ទង់។"
            }
          },
          "meal": {
            "title": "បង្កើតការសម្រាកអាហារ",
            "lede": "ការសម្រាកអាហារដែលអាចប្រើឡើងវិញ",
            "fields": {
              "name": "ឈ្មោះ",
              "start": "ម៉ោងចាប់ផ្តើម",
              "end": "ម៉ោងបញ្ចប់"
            },
            "placeholders": {
              "name": "ឧ. OP_Field_Lunch Break"
            },
            "validation": {
              "name-required": "ត្រូវការឈ្មោះការសម្រាក។",
              "time-required": "ត្រូវការម៉ោងចាប់ផ្តើម និងបញ្ចប់។",
              "time-order": "ម៉ោងបញ្ចប់ត្រូវមកក្រោយម៉ោងចាប់ផ្តើម។"
            }
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើត"
        },
        "error": "មិនអាចផ្ទុកទិន្នន័យបានទេ។",
        "retry": "ព្យាយាមម្ដងទៀត",
        "deleted-toast": "បានលុប {name}",
        "action-failed": "មានបញ្ហាមួយ។ សូមព្យាយាមម្ដងទៀត។",
        "col-extra": {
          "status": "ស្ថានភាព",
          "calendar": "ប្រតិទិនថ្ងៃឈប់សម្រាក",
          "paid": "មានប្រាក់ / គ្មានប្រាក់"
        },
        "export": {
          "xlsx": "Excel (.xlsx)",
          "csv": "CSV (.csv)",
          "empty": "គ្មានអ្វីសម្រាប់នាំចេញទេ",
          "file": {
            "schedules": "កាលវិភាគការងារ",
            "holidays": "ប្រតិទិនថ្ងៃឈប់សម្រាក",
            "meals": "ពេលសម្រាកអាហារ"
          }
        },
        "history": {
          "action": "ប្រវត្តិកែសម្រួល",
          "aria": "ប្រវត្តិកែសម្រួលរបស់ {name}",
          "title": "ប្រវត្តិកែសម្រួល — {name}",
          "fields": {
            "Name": "ឈ្មោះ",
            "Type": "ប្រភេទ",
            "Status": "ស្ថានភាព",
            "Days": "ថ្ងៃធ្វើការ",
            "WeeklyOffDays": "ថ្ងៃឈប់ប្រចាំសប្ដាហ៍",
            "MealBreakIds": "ពេលសម្រាកអាហារ",
            "PublicHolidayListId": "ប្រតិទិនថ្ងៃឈប់សម្រាកសាធារណៈ",
            "OtherHolidayListIds": "ប្រតិទិនថ្ងៃឈប់សម្រាកផ្សេងទៀត",
            "ScheduleKind": "ប្រភេទកាលវិភាគ",
            "Code": "កូដ",
            "Year": "ឆ្នាំ",
            "Region": "តំបន់",
            "Start": "ចាប់ផ្ដើម",
            "End": "បញ្ចប់",
            "Paid": "មានប្រាក់"
          }
        }
      },
      "leave": {
        "new-request": "សំណើច្បាប់ឈប់សម្រាកថ្មី",
        "views": {
          "records": "កំណត់ត្រា",
          "calendar": "ប្រតិទិន",
          "balances": "សមតុល្យ"
        },
        "kpi": {
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត (ក្នុងចន្លោះ)",
          "active-today": "ឈប់សម្រាកថ្ងៃនេះ",
          "rejected": "បានបដិសេធ"
        },
        "filters": {
          "toggle": "តម្រង",
          "toggle-n": "តម្រង ({n})",
          "remove": "ដកតម្រង {label}",
          "clear": "សម្អាតតម្រង",
          "org": "អង្គភាព",
          "all-orgs": "អង្គភាពទាំងអស់",
          "employee": "បុគ្គលិក",
          "all-employees": "បុគ្គលិកទាំងអស់",
          "type": "ប្រភេទ",
          "all-types": "ប្រភេទទាំងអស់",
          "status": "ស្ថានភាព",
          "all-statuses": "ស្ថានភាពទាំងអស់"
        },
        "include-outsourced": "រួមបញ្ចូលបុគ្គលិកជួលក្រៅ",
        "by-type": "ថ្ងៃដែលបានអនុម័តក្នុងចន្លោះ — តាមប្រភេទ",
        "type": {
          "annual-leave": "ច្បាប់ឈប់សម្រាកប្រចាំឆ្នាំ",
          "sick-leave": "ច្បាប់ឈប់សម្រាកព្យាបាលជំងឺ",
          "special-leave": "ច្បាប់ឈប់សម្រាកពិសេស",
          "maternity-leave": "ច្បាប់ឈប់សម្រាកលំហែមាតុភាព",
          "paternity-leave": "ច្បាប់ឈប់សម្រាកបិតុភាព",
          "unpaid-leave": "ច្បាប់ឈប់សម្រាកគ្មានប្រាក់ឈ្នួល"
        },
        "type-short": {
          "annual-leave": "ប្រចាំឆ្នាំ",
          "sick-leave": "ជំងឺ",
          "special-leave": "ពិសេស",
          "maternity-leave": "មាតុភាព",
          "paternity-leave": "បិតុភាព",
          "unpaid-leave": "គ្មានប្រាក់ឈ្នួល"
        },
        "status": {
          "pending-lm": "រង់ចាំប្រធានផ្ទាល់",
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "rejected": "បានបដិសេធ",
          "cancelled": "បានលុបចោល"
        },
        "outsourced-note": "សម្រាប់បុគ្គលិកជួលក្រៅ៖ ច្បាប់ឈប់សម្រាកត្រូវបានផ្តល់តាមគោលការណ៍ Optimal HR ហើយប្រធានផ្ទាល់ខាងក្រៅជាអ្នកអនុម័តសំណើ (Optimal ជាម្ចាស់ទំនាក់ទំនងការងារ)។ បុគ្គលិកផ្ទាល់ត្រូវបញ្ជូនទៅប្រធានផ្ទាល់របស់ខ្លួន។",
        "exported": "✓ បាននាំចេញសំណើច្បាប់ {n} → {name}",
        "records": {
          "title": "កំណត់ត្រាច្បាប់ឈប់សម្រាក",
          "labels": "ស្លាក៖",
          "fh": "FH — ពាក់កណ្តាលថ្ងៃដំបូង",
          "sh": "SH — ពាក់កណ្តាលថ្ងៃទីពីរ",
          "fd": "FD — ពេញមួយថ្ងៃ",
          "open-approvals": "បើកការអនុម័ត",
          "export": "នាំចេញ",
          "empty": "គ្មានសំណើច្បាប់ដែលត្រូវនឹងតម្រងទាំងនេះទេ។",
          "eor": "EOR",
          "demo": "សាកល្បង",
          "demo-tip": "ទិន្នន័យសាកល្បង",
          "locked-tip": "នៅក្នុងរយៈពេលច្បាប់ដែលបានចាក់សោ — អានតែប៉ុណ្ណោះ",
          "escalates": "បញ្ជូនបន្ត"
        },
        "col": {
          "request": "លេខសំណើ",
          "name": "ឈ្មោះពេញ",
          "employee-id": "លេខសម្គាល់បុគ្គលិក",
          "org": "អង្គភាព",
          "requested": "ថ្ងៃស្នើ",
          "details": "ព័ត៌មានលម្អិតនៃសំណើ",
          "total": "សរុប",
          "approver": "អ្នកអនុម័ត",
          "status": "ស្ថានភាព",
          "type": "ប្រភេទ",
          "date": "កាលបរិច្ឆេទ",
          "duration": "រយៈពេល"
        },
        "calendar": {
          "pending-suffix": "(កំពុងរង់ចាំ)",
          "dow": {
            "sun": "អា",
            "mon": "ច",
            "tue": "អ",
            "wed": "ពុ",
            "thu": "ព្រ",
            "fri": "សុ",
            "sat": "ស"
          },
          "more": "+{n} ទៀត",
          "today": "ថ្ងៃនេះ",
          "pending": "រង់ចាំប្រធានផ្ទាល់ (ស៊ុមដាច់ៗ)",
          "hint": "ចុចលើស្លាកច្បាប់ ដើម្បីបើកព័ត៌មានលម្អិតនៃសំណើ។"
        },
        "balances": {
          "title": "សមតុល្យច្បាប់ · តាមបុគ្គលិក × តាមប្រភេទ",
          "policy-line": "ស្របតាម SRS · {method} · អតីតភាព +{d}ថ្ងៃ/{y}ឆ្នាំ (មាត្រា 166) · {year}",
          "yearly-grant": "ផ្តល់ប្រចាំឆ្នាំ AL {d}ថ្ងៃ",
          "year-type": {
            "calendar_year": "ឆ្នាំប្រតិទិន",
            "fiscal_year": "ឆ្នាំសារពើពន្ធ"
          },
          "employee": "បុគ្គលិក",
          "type": "ប្រភេទ",
          "service": "អតីតភាព",
          "years": "{n}ឆ្នាំ",
          "on-demand": "តាមតម្រូវការ",
          "cell": "{alloc}{bonus} បានផ្តល់ · {used} បានប្រើ",
          "cfwd": " · {n} យោងបន្ត",
          "empty": "គ្មានបុគ្គលិកដែលមានសិទ្ធិក្នុងវិសាលភាពនេះទេ។",
          "outsourced": "ជួលក្រៅ",
          "direct": "ផ្ទាល់",
          "reading-lead": "របៀបអានក្រឡា៖",
          "reading": "លេខធំ = សមតុល្យនៅសល់ · បន្ទាត់តូចបង្ហាញចំនួនបានផ្តល់ (ប្រាក់រង្វាន់អតីតភាពក្នុងវង់ក្រចក) ចំនួនបានប្រើ និងចំនួនយោងបន្តពីឆ្នាំមុន។",
          "defaults-lead": "តម្លៃលំនាំដើម៖",
          "defaults": "AL {al}ថ្ងៃ/ឆ្នាំ · ជំងឺ {sick}ថ្ងៃ/ឆ្នាំ · ពិសេស {special}ថ្ងៃ/ឆ្នាំ (កាត់ពី AL) · មាតុភាព {maternity}ថ្ងៃ · បិតុភាព {paternity}ថ្ងៃ។ អាចកំណត់បានទាំងអស់ក្នុងការកំណត់ច្បាប់ឈប់សម្រាក។"
        },
        "detail": {
          "title": "សំណើច្បាប់ {id} · {name}",
          "subtitle": "{type} · {days} ថ្ងៃ · {status}",
          "approved-on": "បានអនុម័តនៅ {at}",
          "rejected-on": "បានបដិសេធនៅ {at}",
          "submitted": "បានដាក់ស្នើ {at} · កំពុងរង់ចាំប្រធានផ្ទាល់",
          "approve": "អនុម័ត",
          "reject": "បដិសេធ",
          "locked": "រយៈពេលបានចាក់សោ",
          "details": "ព័ត៌មានលម្អិតនៃសំណើ",
          "employee": "បុគ្គលិក៖",
          "org": "អង្គភាព៖",
          "type": "ប្រភេទ៖",
          "total": "សរុប៖",
          "days-unit": "ថ្ងៃ",
          "routes-to": "បញ្ជូនទៅ៖",
          "external-lm": "ប្រធានផ្ទាល់ខាងក្រៅ",
          "escalates": "បញ្ជូនបន្តទៅធនធានមនុស្ស",
          "reason": "មូលហេតុ៖",
          "dates": "កាលបរិច្ឆេទ ({n})",
          "history": "ប្រវត្តិសវនកម្ម ({n})",
          "no-history": "គ្មានប្រវត្តិ។",
          "by": "{action} ដោយ {who}",
          "action": {
            "approved": "បានអនុម័ត",
            "rejected": "បានបដិសេធ",
            "submitted": "បានដាក់ស្នើ",
            "cancelled": "បានលុបចោល"
          },
          "approve-reason": "មូលហេតុអនុម័ត (តម្រូវដោយគោលការណ៍)៖",
          "reject-reason": "មូលហេតុបដិសេធ (ត្រូវការ)៖"
        },
        "new": {
          "title": "សំណើច្បាប់ឈប់សម្រាកថ្មី",
          "subtitle": "ដាក់ស្នើជំនួសបុគ្គលិក · បញ្ជូនទៅប្រធានផ្ទាល់",
          "bp-title": "ការអនុវត្តល្អ៖ សូមឲ្យបុគ្គលិកដាក់ស្នើដោយខ្លួនឯងតាមទូរស័ព្ទ",
          "bp-body": "អេក្រង់នេះសម្រាប់ដាក់ស្នើជំនួស — ប្រើតែនៅពេលបុគ្គលិកមិនអាចដាក់ស្នើដោយខ្លួនឯងបាន។ ការដាក់ស្នើនៅទីនេះត្រូវបានកត់ត្រាជា hr-on-behalf ក្នុងកំណត់ត្រាសវនកម្ម។",
          "employee": "បុគ្គលិក",
          "select-employee": "— ជ្រើសរើសបុគ្គលិក —",
          "type": "ប្រភេទច្បាប់",
          "special-lead": "ច្បាប់ពិសេសត្រូវកាត់ពីសមតុល្យច្បាប់ប្រចាំឆ្នាំតាមច្បាប់។",
          "special-al": "សមតុល្យ AL បច្ចុប្បន្នរបស់បុគ្គលិក៖ {n} ថ្ងៃ។",
          "special-block": "⚠ មិនអាចបន្តបានទេ — AL មិនគ្រប់គ្រាន់ ហើយគោលការណ៍មិនអនុញ្ញាតច្បាប់ពិសេសបន្ថែម។",
          "sick-lead": "ត្រូវការវិញ្ញាបនបត្រវេជ្ជសាស្ត្រ។",
          "sick-body": "ច្បាប់ជំងឺលើស {n} ថ្ងៃ ត្រូវភ្ជាប់វិញ្ញាបនបត្រវេជ្ជសាស្ត្រពេលដាក់ស្នើ។ ជំងឺយូរ (>{long}ថ្ងៃ) អនុវត្តតាមរចនាសម្ព័ន្ធបង់ប្រាក់ ILO៖ ខែ1 {m1}% · ខែ2-3 {m2}% · ខែ4-6 {m4}%។",
          "unpaid-lead": "ច្បាប់គ្មានប្រាក់ឈ្នួល។",
          "unpaid-body": "មិនបើកប្រាក់ឈ្នួលសម្រាប់រយៈពេលឈប់សម្រាកនេះទេ។ ប្រើនៅពេលប្រភេទច្បាប់ផ្សេងៗអស់ ឬមិនសមស្រប។",
          "maternity-lead": "ច្បាប់លំហែមាតុភាព — {n} ថ្ងៃ (ច្បាប់ការងារកម្ពុជា)។",
          "paternity-lead": "ច្បាប់បិតុភាព — {n} ថ្ងៃ។",
          "event-body": "ជ្រើសរើសថ្ងៃចាប់ផ្តើម ប្រព័ន្ធនឹងបំពេញ {n} ថ្ងៃជាប់គ្នា។",
          "advance-grant": "ធនធានមនុស្សអាចផ្តល់ជាមុនបាន។",
          "al-insufficient": "⚠ សមតុល្យច្បាប់ប្រចាំឆ្នាំមិនគ្រប់គ្រាន់",
          "al-short": "សមតុល្យបច្ចុប្បន្នរបស់ {name}៖ {balance} ថ្ងៃ · សំណើនេះ៖ {days} ថ្ងៃ · ខ្វះ៖ {short} ថ្ងៃ",
          "al-policy": "គោលការណ៍ allowAlInAdvance ត្រូវបានបិទ — មិនអាចបង្កើតសមតុល្យអវិជ្ជមានបានទេ។",
          "switch-unpaid": "ប្តូរទៅច្បាប់គ្មានប្រាក់ឈ្នួល",
          "switched": "បានប្តូរទៅច្បាប់គ្មានប្រាក់ឈ្នួល",
          "badge": {
            "female-only": "សម្រាប់ស្ត្រីតែប៉ុណ្ណោះ",
            "male-only": "សម្រាប់បុរសតែប៉ុណ្ណោះ",
            "deducts-al": "កាត់ពី AL",
            "advance-exempt": "គ្មានច្បាប់ដាក់ស្នើជាមុន",
            "no-balance": "គ្មានសមតុល្យ"
          },
          "balance-line": "សមតុល្យបច្ចុប្បន្ន៖ {balance} ថ្ងៃ · សំណើនេះ៖ {days} ថ្ងៃ · បន្ទាប់ពី៖ {after} ថ្ងៃ",
          "overdraft": "⚠ ការព្រមានសមតុល្យអវិជ្ជមាន",
          "routes-to": "បញ្ជូនទៅ៖",
          "no-lm": "គ្មានប្រធានផ្ទាល់ — បញ្ជូនបន្តទៅធនធានមនុស្ស",
          "unpaid-line": "សំណើនេះ៖ {days} ថ្ងៃ · មិនពិនិត្យសមតុល្យ (គ្មានប្រាក់ឈ្នួល)",
          "start": "ថ្ងៃចាប់ផ្តើម",
          "policy-days": "ចំនួនថ្ងៃ (តាមគោលការណ៍)",
          "end": "ថ្ងៃបញ្ចប់ (ស្វ័យប្រវត្តិ)",
          "return": "នឹងត្រឡប់មកធ្វើការវិញនៅ {date}។ {n} ថ្ងៃប្រតិទិនជាប់គ្នា — បំពេញស្វ័យប្រវត្តិពីថ្ងៃចាប់ផ្តើម។",
          "select-dates": "ជ្រើសរើសកាលបរិច្ឆេទ",
          "selected": "(បានជ្រើស {n} · សរុប {days} ថ្ងៃ)",
          "half-on": "អនុញ្ញាតពាក់កណ្តាលថ្ងៃ · ជ្រើស FD / FH / SH សម្រាប់ថ្ងៃនីមួយៗ",
          "half-off": "ពេញមួយថ្ងៃតែប៉ុណ្ណោះ (គោលការណ៍បិទពាក់កណ្តាលថ្ងៃ)",
          "date-n": "កាលបរិច្ឆេទ {n}",
          "duration-n": "រយៈពេលនៃកាលបរិច្ឆេទ {n}",
          "remove-date": "ដកកាលបរិច្ឆេទ {n}",
          "add-date": "បន្ថែមកាលបរិច្ឆេទ",
          "reason": "មូលហេតុ / កំណត់សម្គាល់",
          "reason-ph": "មូលហេតុសង្ខេបនៃការឈប់សម្រាកនេះ",
          "after-note": "បន្ទាប់ពីដាក់ស្នើ សំណើនឹងបង្ហាញក្នុងជួរអនុម័តរបស់ប្រធានផ្ទាល់ ជាមួយស្ថានភាព «រង់ចាំប្រធានផ្ទាល់»។ ពេលអនុម័ត ចំនួនថ្ងៃនឹងត្រូវកាត់ពីសមតុល្យបុគ្គលិកដោយស្វ័យប្រវត្តិ។",
          "advance-note": "តម្រូវឲ្យដាក់ស្នើជាមុនយ៉ាងតិច {n} ថ្ងៃ សម្រាប់ {type}។",
          "required": "* ត្រូវការ",
          "submit": "ដាក់ស្នើសុំអនុម័ត",
          "submitted": "✓ បានដាក់ស្នើសំណើច្បាប់ {id} · {days} ថ្ងៃ · បញ្ជូនទៅ {to}",
          "block": {
            "employee": "⚠ ត្រូវការបុគ្គលិក",
            "type": "⚠ ត្រូវការប្រភេទច្បាប់",
            "reason": "⚠ ត្រូវការមូលហេតុ",
            "dates": "⚠ បន្ថែមកាលបរិច្ឆេទយ៉ាងតិចមួយ",
            "start": "⚠ ត្រូវការថ្ងៃចាប់ផ្តើម",
            "al-insufficient": "⚠ សមតុល្យច្បាប់ប្រចាំឆ្នាំមិនគ្រប់គ្រាន់ · គោលការណ៍មិនអនុញ្ញាតផ្តល់ជាមុន។ សូមប្រើប៊ូតុង «ប្តូរទៅច្បាប់គ្មានប្រាក់ឈ្នួល»។",
            "special-al": "⚠ ច្បាប់ពិសេសត្រូវកាត់ពី AL តាមច្បាប់ សមតុល្យ AL {avail}ថ្ងៃ មិនគ្រប់គ្រាន់សម្រាប់ {days}ថ្ងៃ (ការកំណត់ allowAdditionalSpecialLeave ត្រូវបានបិទ)"
          }
        }
      },
      "overtime": {
        "send-reminder": "ផ្ញើការរំលឹក",
        "new-request": "សំណើម៉ោងបន្ថែមថ្មី",
        "kpi": {
          "action": "ត្រូវការសកម្មភាពរបស់អ្នក",
          "action-sub": "{v} ត្រូវផ្ទៀងផ្ទាត់ · {i} មានបញ្ហា",
          "pending": "រង់ចាំការអនុម័ត",
          "pending-sub": "ប៉ាន់ស្មាន {amount}",
          "progress": "កំពុងដំណើរការ / បានអនុម័ត",
          "progress-sub": "{now} កំពុងធ្វើឥឡូវ · {sch} បានគ្រោងទុក",
          "paid": "បានផ្ទៀងផ្ទាត់ / បានបង់ (រយៈពេល)",
          "paid-sub": "សរុប {amount}"
        },
        "chips-label": "ស្ថានភាពម៉ោងបន្ថែម",
        "chip": {
          "all": "ទាំងអស់",
          "needs-action": "⚑ ត្រូវការសកម្មភាព",
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "in-progress": "កំពុងដំណើរការ",
          "needs-verify": "ត្រូវផ្ទៀងផ្ទាត់",
          "issue": "បញ្ហាត្រូវដោះស្រាយ",
          "verified": "បានផ្ទៀងផ្ទាត់",
          "paid": "បានបង់",
          "rejected": "បានបដិសេធ"
        },
        "search": "ត្រងតាមឈ្មោះបុគ្គលិក…",
        "search-clear": "សម្អាតការស្វែងរក",
        "showing": "បង្ហាញ {n} ក្នុងចំណោម {total}",
        "col": {
          "id": "លេខសម្គាល់",
          "employee": "បុគ្គលិក",
          "date": "កាលបរិច្ឆេទ",
          "time": "ម៉ោង",
          "day-type": "ប្រភេទថ្ងៃ",
          "hours": "ម៉ោង",
          "amount": "ចំនួនទឹកប្រាក់",
          "status": "ស្ថានភាព"
        },
        "payable": "ត្រូវបង់ {v}",
        "payable-tip": "ត្រូវបង់តាមការស្កេនពិត + ការកែតម្រូវរបស់ធនធានមនុស្ស (អ្វីដែលរូបថតចាក់សោម៉ោងបន្ថែម និងប្រាក់បៀវត្សប្រើ)",
        "locked-tip": "នៅក្នុងរយៈពេលម៉ោងបន្ថែមដែលបានចាក់សោ — អានតែប៉ុណ្ណោះ",
        "demo-tip": "ទិន្នន័យសាកល្បង",
        "empty": "គ្មានសំណើម៉ោងបន្ថែមដែលត្រូវនឹងតម្រងនេះទេ។",
        "multipliers-lead": "មេគុណម៉ោងបន្ថែមកម្ពុជា៖",
        "multipliers": "ថ្ងៃធ្វើការពេលថ្ងៃ 1.5× · ពេលយប់ (22:00–06:00) 2.0× · ចុងសប្តាហ៍ / ថ្ងៃឈប់ 2.0× · ថ្ងៃបុណ្យលើថ្ងៃឈប់ 2.0× · ថ្ងៃបុណ្យលើថ្ងៃធ្វើការ 1.0× (ប្រាក់ឈ្នួលថ្ងៃបុណ្យបានបង់រួចហើយ)។ គ្មានដែនកំណត់តឹងរ៉ឹង (អាចកំណត់បានក្នុងការកំណត់)។",
        "status": {
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "rejected": "បានបដិសេធ",
          "in-progress": "កំពុងដំណើរការ",
          "needs-verification": "ត្រូវផ្ទៀងផ្ទាត់",
          "issue-to-resolve": "បញ្ហាត្រូវដោះស្រាយ",
          "verified": "បានផ្ទៀងផ្ទាត់",
          "paid": "បានបង់",
          "cancelled": "បានលុបចោល"
        },
        "day-type": {
          "weekday": "ថ្ងៃធ្វើការ",
          "weekend": "ចុងសប្តាហ៍",
          "dayoff": "ថ្ងៃឈប់",
          "ph-working": "ថ្ងៃបុណ្យ (ថ្ងៃធ្វើការ)",
          "ph-dayoff": "ថ្ងៃបុណ្យ (ថ្ងៃឈប់)"
        },
        "issue": {
          "missed-clockout": "ភ្លេចស្កេនចេញ",
          "no-show": "មិនបានមក",
          "outside-window": "ក្រៅចន្លោះពេល",
          "excessive-drift": "គម្លាតលើសកំណត់"
        },
        "detail": {
          "title": "ព័ត៌មានលម្អិតនៃសំណើម៉ោងបន្ថែម",
          "issue": "បញ្ហា៖ {label}",
          "needs-verify": "ត្រូវផ្ទៀងផ្ទាត់",
          "needs-verify-note": "ម៉ោងពិតខុសពីម៉ោងគ្រោងទុក — សូមបញ្ជាក់មុនប្រាក់បៀវត្ស។",
          "verified": "បានផ្ទៀងផ្ទាត់{on}{by} — រួចរាល់សម្រាប់ប្រាក់បៀវត្ស។",
          "on": " នៅ {at}",
          "by": " ដោយ {name}",
          "paid": "បានបង់",
          "in-run": " ក្នុងការបើកប្រាក់",
          "in-progress": "ចន្លោះពេលម៉ោងបន្ថែមកំពុងបើកឥឡូវនេះ។ បុគ្គលិកបានស្កេនចូលនៅ {at}។",
          "request": "សំណើ",
          "date": "កាលបរិច្ឆេទ៖",
          "project": "គម្រោង៖",
          "internal": "ផ្ទៃក្នុង",
          "reason": "មូលហេតុ៖",
          "pva": "គ្រោងទុក ធៀបនឹង ពិតប្រាកដ",
          "planned": "គ្រោងទុក",
          "actual": "ពិតប្រាកដ (ពីការស្កេន)",
          "not-clocked": "កំពុងរង់ចាំ — មិនទាន់ស្កេន",
          "payable": "ត្រូវបង់ (ពិតប្រាកដ + ការកែតម្រូវ)៖ {h} · {a}",
          "slice2": "ការភ្ជាប់ចន្លោះពេលម៉ោងបន្ថែម និងការផ្ទៀងផ្ទាត់ម៉ោងស្កេន នឹងមកដល់ក្នុងដំណាក់កាលទី 2។",
          "calc": "ការគណនាលម្អិត",
          "rate": "អត្រាក្នុងមួយម៉ោង {hourly} = {gross} / ({weekly}ម៉ោង × 52 / 12 = {monthly}ម៉ោង/ខែ)",
          "segment": "ផ្នែក",
          "multiplier": "មេគុណ",
          "hourly": "ក្នុងមួយម៉ោង",
          "night": "ពេលយប់ (22:00–06:00)",
          "day": "ពេលថ្ងៃ (06:00–22:00)",
          "total": "សរុប",
          "chain": "ខ្សែសង្វាក់អនុម័ត",
          "requested-by": "ស្នើដោយ៖",
          "ext-lm": "ប្រធានផ្ទាល់ខាងក្រៅ៖",
          "lm": "ប្រធានផ្ទាល់៖",
          "external-lm-name": "{name} (ប្រធានផ្ទាល់ខាងក្រៅ)",
          "reject-reason": "មូលហេតុបដិសេធ៖ {reason}",
          "activity": "កំណត់ហេតុសកម្មភាព",
          "no-activity": "មិនទាន់មានសកម្មភាព។",
          "computed": "គណនានៅ {at} · ស្ថិតក្រោមការអនុម័តចុងក្រោយរបស់ធនធានមនុស្ស"
        },
        "new": {
          "title": "សំណើម៉ោងបន្ថែមថ្មី",
          "subtitle": "ជ្រើសរើសកាលបរិច្ឆេទ និងចន្លោះម៉ោង · គណនាមេគុណ និងចំនួនទឹកប្រាក់ភ្លាមៗ",
          "project": "គម្រោង",
          "shift-none": "ច–សុ 08:00–17:00",
          "shift-default": "ច–សុ 08:00–17:00 (លំនាំដើម)",
          "rule-shift": "វេនធម្មតា (ពីកាលវិភាគ)៖",
          "rule-shift-tail": "ម៉ោងបន្ថែមត្រូវនៅក្រៅចន្លោះពេលនេះ",
          "rule-ll": "ច្បាប់ការងារកម្ពុជា៖ ម៉ោងបន្ថែមអតិបរមា 12 ម៉ោង / សប្តាហ៍ · មេគុណ៖ ថ្ងៃធ្វើការ 1.5× ពេលថ្ងៃ / 2.0× ពេលយប់ · ចុងសប្តាហ៍ និងថ្ងៃឈប់ 2.0× · ថ្ងៃបុណ្យលើថ្ងៃឈប់ 2.0× · ថ្ងៃបុណ្យលើថ្ងៃធ្វើការ 1.0×",
          "rule-clock": "គម្លាតម៉ោងស្កេន៖ ±15 នាទី · ចន្លោះពេលម៉ោងបន្ថែមសម្គាល់ការស្កេនក្រៅចន្លោះដែលបានអនុម័តដោយស្វ័យប្រវត្តិ",
          "select-dates": "ជ្រើសរើសកាលបរិច្ឆេទម៉ោងបន្ថែម",
          "dates-count": "({d} កាលបរិច្ឆេទ · {s} ចន្លោះ)",
          "date": "កាលបរិច្ឆេទម៉ោងបន្ថែម",
          "add-date": "បន្ថែមកាលបរិច្ឆេទ",
          "totals-lead": "{d} ថ្ងៃ · {s} ចន្លោះ",
          "hrs": "ម៉ោង",
          "estimated": "ប៉ាន់ស្មាន",
          "warn-overlap": "⛔ ចន្លោះម៉ោងមួយ ឬច្រើនជាន់ពេលវេនធម្មតា។ សូមកែសម្រួលមុនដាក់ស្នើ។",
          "warn-ll": "⚠ ម៉ោងបន្ថែមសរុបលើស 12 ម៉ោង/សប្តាហ៍ យ៉ាងហោចណាស់មួយសប្តាហ៍ — ដែនកំណត់ច្បាប់ការងារកម្ពុជា។ ប្រធាន និងធនធានមនុស្សនឹងទទួលដំណឹងពេលអនុម័ត។",
          "slots": "ចន្លោះម៉ោង",
          "no-dates": "បន្ថែមកាលបរិច្ឆេទម៉ោងបន្ថែមខាងលើ ដើម្បីបន្ថែមចន្លោះម៉ោង",
          "kind": {
            "holiday": "ថ្ងៃបុណ្យ",
            "weekend": "ចុងសប្តាហ៍",
            "weekday": "ថ្ងៃធ្វើការ"
          },
          "add-slot": "បន្ថែមចន្លោះ",
          "slot-start": "ចាប់ផ្តើមចន្លោះ {n} នៅ {d}",
          "slot-end": "បញ្ចប់ចន្លោះ {n} នៅ {d}",
          "overlaps": "⛔ ជាន់វេន",
          "remove-slot": "ដកចន្លោះ",
          "objective": "គោលបំណងនៃសំណើ",
          "objective-ph": "ពិពណ៌នាមូលហេតុដែលត្រូវការម៉ោងបន្ថែម (ឧ. ដាក់ឲ្យដំណើរការផលិតកម្ម រៀបចំបង្ហាញអតិថិជន បិទបញ្ជីចុងខែ)",
          "route-note": "ការអនុម័តត្រូវបញ្ជូនទៅប្រធានផ្ទាល់របស់បុគ្គលិក។ ពេលអនុម័ត ចន្លោះពេលម៉ោងបន្ថែមត្រូវបានបង្កើត ដើម្បីឲ្យបុគ្គលិកស្កេនចូល/ចេញក្នុងរយៈពេលនោះ ការស្កេនក្រៅចន្លោះនឹងត្រូវសម្គាល់។",
          "route-note-ext": "ការអនុម័តត្រូវបញ្ជូនទៅប្រធានផ្ទាល់របស់បុគ្គលិក (ប្រធានផ្ទាល់ខាងក្រៅសម្រាប់បុគ្គលិកជួលក្រៅ)។ ពេលអនុម័ត ចន្លោះពេលម៉ោងបន្ថែមត្រូវបានបង្កើត ដើម្បីឲ្យបុគ្គលិកស្កេនចូល/ចេញក្នុងរយៈពេលនោះ ការស្កេនក្រៅចន្លោះនឹងត្រូវសម្គាល់។",
          "error": {
            "employee": "⚠ សូមជ្រើសរើសបុគ្គលិក",
            "reason": "⚠ គោលបំណងត្រូវមានយ៉ាងតិច 10 តួអក្សរ",
            "dates": "⚠ ជ្រើសរើសកាលបរិច្ឆេទ និងចន្លោះម៉ោងយ៉ាងតិចមួយ",
            "slot": "⚠ បន្ថែមចន្លោះម៉ោងយ៉ាងតិចមួយ"
          },
          "submitted": "✓ បានដាក់ស្នើសំណើម៉ោងបន្ថែម {id} (ប៉ាន់ស្មាន {hours} ម៉ោង)"
        }
      },
      "lvot": {
        "locked-periods": "រយៈពេលបានចាក់សោ {n} | រយៈពេលបានចាក់សោ {n}",
        "from": "ពី",
        "to": "ដល់",
        "cancel": "បោះបង់",
        "lock-period": "ចាក់សោរយៈពេល",
        "ack-lead": "ត្រូវការការទទួលស្គាល់៖",
        "lock-anyway-word": "ចាក់សោទោះយ៉ាងណា",
        "client-fallback": "សរុបអតិថិជន",
        "all-scopes": "វិសាលភាពទាំងអស់",
        "direct": "កម្លាំងពលកម្មផ្ទាល់",
        "kpi": {
          "attention-workspaces": "កន្លែងធ្វើការដែលត្រូវយកចិត្តទុកដាក់",
          "attention-units": "អង្គភាពដែលត្រូវយកចិត្តទុកដាក់",
          "attention-workspaces-tip": "កន្លែងធ្វើការដែលមានសញ្ញាហានិភ័យពណ៌លឿង ឬក្រហម",
          "attention-units-tip": "អង្គភាពដែលមានសញ្ញាហានិភ័យពណ៌លឿង ឬក្រហម",
          "waiting": "បុគ្គលិកកំពុងរង់ចាំ",
          "submitted": "បានដាក់ស្នើ {date}{name}"
        },
        "col": {
          "workspace": "កន្លែងធ្វើការ",
          "risk": "ហានិភ័យ",
          "employees": "បុគ្គលិក",
          "progress": "វឌ្ឍនភាព (ថ្ងៃបានចាក់សោ)",
          "ready": "រួចរាល់សម្រាប់ប្រាក់បៀវត្ស",
          "trend": "និន្នាការ",
          "scope": "វិសាលភាព",
          "locked-periods": "រយៈពេលបានចាក់សោ",
          "requests": "សំណើ",
          "locked": "បានចាក់សោ",
          "status": "ស្ថានភាព",
          "employee": "បុគ្គលិក",
          "type": "ប្រភេទ",
          "status-at-lock": "ស្ថានភាពពេលចាក់សោ"
        },
        "cut-line": "{date} · {label} ({days}ថ្ងៃ, បើកប្រាក់ {pay})",
        "top-priority": "អាទិភាពខ្ពស់",
        "cut-tip": "{label} · ថ្ងៃបើកប្រាក់ {pay}",
        "cut-chip": "ថ្ងៃកាត់ {date} ({days}ថ្ងៃ)",
        "cut-none": "មិនទាន់កំណត់ប្រតិទិនប្រាក់បៀវត្ស",
        "review": "ពិនិត្យ",
        "review-tip": "ចូលលម្អិតកន្លែងធ្វើការនេះ",
        "no-match": "គ្មានកន្លែងធ្វើការដែលត្រូវនឹងតម្រងនេះទេ។",
        "waiting-tip": "បុគ្គលិក {n} នាក់កំពុងរង់ចាំ",
        "trend": "{arrow}{pct}% ធៀបនឹងរយៈពេលមុន",
        "trend-none": "ប្រវត្តិមិនគ្រប់គ្រាន់សម្រាប់និន្នាការ",
        "trend-tip": "សំណើ៖ {prev} ({prevMonth}) → {cur} ({curMonth})",
        "open": "បើក",
        "l2-banner": "កម្រិតនេះបង្ហាញតែ KPI សរុបនៃការងារកំពុងដំណើរការ និងរូបថតរយៈពេលដែលបានចាក់សោប៉ុណ្ណោះ។ ជួរអតិថិជនជាការសរុបរួម (អានតែប៉ុណ្ណោះ)។",
        "rollup-chip": "សរុបអតិថិជន · អានតែប៉ុណ្ណោះ",
        "summary": "សង្ខេប",
        "summary-tip": "មើលរូបថតចាក់សោចុងក្រោយ (អានតែប៉ុណ្ណោះ)",
        "l3-foot": "ចុចលើរយៈពេលដើម្បីបើករូបថតបង្កករបស់វា (អានតែប៉ុណ្ណោះ)",
        "locked": "បានចាក់សោ",
        "frozen": "(បានបង្កក)",
        "l4-no-rows": "គ្មានសំណើក្នុងរយៈពេលនេះទេ។",
        "ready": {
          "ready": "រួចរាល់",
          "waiting": "កំពុងរង់ចាំ",
          "blocked": "ត្រូវរារាំង"
        },
        "risk": {
          "leave": {
            "cutoff": "សំណើកំពុងរង់ចាំ {n} · ថ្ងៃកាត់ប្រាក់បៀវត្សក្នុង {days}ថ្ងៃ",
            "oldest": "សំណើរង់ចាំចាស់ជាងគេ {age}ថ្ងៃ",
            "rate": "{pct}% នៃបុគ្គលិកកំពុងរង់ចាំ",
            "open": "សំណើកំពុងរង់ចាំ {n}",
            "open-cutoff": "សំណើកំពុងរង់ចាំ {n} · ថ្ងៃកាត់ក្នុង {days}ថ្ងៃ",
            "not-locked": "រយៈពេលមិនទាន់ចាក់សោ · ថ្ងៃកាត់ក្នុង {days}ថ្ងៃ",
            "none": "គ្មានសំណើច្បាប់កំពុងរង់ចាំ"
          },
          "ot": {
            "cutoff": "សំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយ {n} · ថ្ងៃកាត់ប្រាក់បៀវត្សក្នុង {days}ថ្ងៃ",
            "oldest": "សំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយចាស់ជាងគេ {age}ថ្ងៃ",
            "rate": "{pct}% នៃបុគ្គលិកកំពុងរង់ចាំ",
            "open": "សំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយ {n}",
            "open-cutoff": "សំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយ {n} · ថ្ងៃកាត់ក្នុង {days}ថ្ងៃ",
            "not-locked": "រយៈពេលមិនទាន់ចាក់សោ · ថ្ងៃកាត់ក្នុង {days}ថ្ងៃ",
            "none": "គ្មានសំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយ"
          }
        },
        "leave": {
          "lock-btn": "ចាក់សោរយៈពេលច្បាប់",
          "sub-tenant": "វិសាលភាពទាំងអស់ · ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការច្បាប់ឈប់សម្រាកសម្រាប់ថ្នាក់ដឹកនាំ · KPI សរុប + រូបថតដែលបានចាក់សោ · អានតែប៉ុណ្ណោះ",
          "sub-client": "{name} · សរុបច្បាប់ឈប់សម្រាក · អានតែប៉ុណ្ណោះ",
          "sub-company": "{name} · ឋានានុក្រមច្បាប់ឈប់សម្រាក · អានតែប៉ុណ្ណោះ (ប្រតិបត្តិការធ្វើនៅវិសាលភាពម្ចាស់)",
          "kpi": {
            "waiting-tip": "បុគ្គលិកដែលមានសំណើច្បាប់កំពុងរង់ចាំយ៉ាងតិចមួយ",
            "completion": "ភាពបញ្ចប់ច្បាប់",
            "completion-tip": "ថ្ងៃបានចាក់សោ ÷ ថ្ងៃរំពឹងទុកនៃរយៈពេលរកបានច្បាប់ ({locked}/{total}) — អង្គភាពដែលគ្មានច្បាប់បានអនុម័តក្នុងរយៈពេលនោះ ចាត់ទុកថាបានបញ្ចប់",
            "oldest": "សំណើរង់ចាំចាស់ជាងគេ",
            "oldest-none": "គ្មានសំណើច្បាប់កំពុងរង់ចាំ"
          },
          "col": {
            "open": "សំណើកំពុងរង់ចាំ",
            "cutoff": "ថ្ងៃកាត់បន្ទាប់ (ពឹងលើច្បាប់)",
            "cutoff-tip": "ការបើកប្រាក់បៀវត្សបន្ទាប់ដែលប្រើទិន្នន័យច្បាប់ (រំលងការបើកជាមុន)",
            "approved-days": "ថ្ងៃបានអនុម័ត",
            "liability": "បំណុល (ថ្ងៃ)",
            "period": "រយៈពេលច្បាប់",
            "approved": "បានអនុម័ត",
            "pending-frozen": "រង់ចាំដែលបានបង្កក",
            "days": "ថ្ងៃ",
            "by-type": "តាមប្រភេទ",
            "dates-in-period": "កាលបរិច្ឆេទក្នុងរយៈពេល",
            "balance-snapshot": "រូបថតសមតុល្យពេលចាក់សោ"
          },
          "owner-direct": "ម្ចាស់ច្បាប់ · បុគ្គលិករបស់ក្រុមហ៊ុន",
          "owner-project": "{id} · ម្ចាស់ច្បាប់",
          "l1-foot": "ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការច្បាប់ឈប់សម្រាកសម្រាប់ថ្នាក់ដឹកនាំ · គិតត្រឹម {asOf} (ថ្ងៃស្នើចុងក្រោយ) · ថ្ងៃកាត់ = ការបើកប្រាក់បៀវត្សបន្ទាប់ដែលពឹងលើច្បាប់ឈប់សម្រាក ពីប្រតិទិនដំណើរការប្រាក់បៀវត្ស (រំលងការបើកជាមុន) · KPI សរុបតែប៉ុណ្ណោះ — ប្រតិបត្តិការធ្វើនៅវិសាលភាពម្ចាស់ · ជួរដេកតម្រៀបតាមហានិភ័យ · ចុចលើជួរដើម្បីចូលលម្អិត",
          "l2-foot": "ថ្ងៃកាត់ប្រាក់បៀវត្សបន្ទាប់ដែលពឹងលើច្បាប់ឈប់សម្រាក៖ {cut}{win} · គិតត្រឹម {asOf} · ចុចលើជួរដើម្បីមើលរយៈពេលដែលបានចាក់សោ",
          "win-line": " · រយៈពេលរកបានច្បាប់ឈប់សម្រាក ({from} → {to}]",
          "l2-banner-lead": "ប្រតិបត្តិការច្បាប់ឈប់សម្រាកធ្វើនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង)។",
          "l3-empty": "មិនទាន់មានរយៈពេលច្បាប់ឈប់សម្រាកដែលបានចាក់សោសម្រាប់វិសាលភាពនេះទេ — វិសាលភាពម្ចាស់បិទរយៈពេលតាមរយៈ «ចាក់សោរយៈពេលច្បាប់»។",
          "l4-lead": "រយៈពេលច្បាប់ឈប់សម្រាកបានចាក់សោ — រូបថតបង្កក (អានតែប៉ុណ្ណោះ)។",
          "l4-banner": "បានចាក់សោ {at} ដោយ {by} · {reqs} សំណើ · {days} ថ្ងៃបានអនុម័ត{tail}។ រូបថតនេះ — ច្បាប់បានអនុម័ត + សមតុល្យ — គឺជាអ្វីដែលប្រាក់បៀវត្សប្រើ គ្មានប្រតិបត្តិការច្បាប់នៅវិសាលភាពត្រួតពិនិត្យទេ។",
          "l4-frozen": " · {n} រង់ចាំដែលបានបង្កក (បានទទួលស្គាល់ពេលចាក់សោ)",
          "progress-tip": "{locked} ក្នុងចំណោម {total} ថ្ងៃនៃរយៈពេលរកបានច្បាប់ត្រូវបានចាក់សោ",
          "ready-tip": {
            "ready": "ច្បាប់បានអនុម័តនៃរយៈពេលរកបានត្រូវបានចាក់សោ (ឬគ្មានអ្វីត្រូវប្រើ) — រូបថតបានបង្កកសម្រាប់ប្រាក់បៀវត្ស",
            "waiting": "ច្បាប់បានអនុម័តក្នុងរយៈពេលរកបានមិនទាន់ចាក់សោ — គ្មានសំណើរង់ចាំរារាំង",
            "blocked": "សំណើច្បាប់កំពុងរង់ចាំត្រូវសម្រេចមុនថ្ងៃកាត់ប្រាក់បៀវត្ស"
          },
          "open-company-tip": "បើកកន្លែងធ្វើការរបស់ក្រុមហ៊ុន — ប្រតិបត្តិការច្បាប់ឈប់សម្រាកធ្វើនៅវិសាលភាពម្ចាស់របស់វា",
          "open-unit-tip": "បើកកន្លែងធ្វើការច្បាប់ឈប់សម្រាក — វិសាលភាពម្ចាស់ (ប្រតិបត្តិការ)",
          "locked-periods-tip": "រយៈពេលច្បាប់ឈប់សម្រាកដែលបានចាក់សោសម្រាប់អង្គភាពនេះ",
          "draft-title": "ចាក់សោរយៈពេលច្បាប់ — {company} · {unit}",
          "draft-counts": "{n} សំណើបានអនុម័ត · {days} ថ្ងៃ",
          "draft-unresolved": "{n} សំណើកំពុងរង់ចាំ",
          "lock-anyway": "ចាក់សោទោះយ៉ាងណា — បង្កក {n} រង់ចាំ",
          "ack": "{lead} សំណើកំពុងរង់ចាំ {n} ក្នុងចន្លោះនេះនឹងត្រូវបង្កកដោយមិនបានសម្រេច — ប្រាក់បៀវត្សប្រើរូបថតដោយគ្មានសំណើទាំងនោះ ហើយមិនអាចអនុម័ត ឬបដិសេធសម្រាប់កាលបរិច្ឆេទទាំងនេះបានទៀតទេ។ ចុច {anyway} ដើម្បីបញ្ជាក់ ឬបោះបង់ ហើយសម្រេចវាជាមុនសិន។",
          "draft-note": "ការចាក់សោបិទរយៈពេលច្បាប់នេះជាផ្លូវការ៖ ច្បាប់បានអនុម័ត និងរូបថតសមតុល្យត្រូវបានបង្កកសម្រាប់ប្រាក់បៀវត្ស។ សំណើដែលប៉ះរយៈពេលបានចាក់សោ មិនអាចដាក់ស្នើ អនុម័ត ឬបដិសេធបានទៀតទេ។ វិសាលភាពត្រួតពិនិត្យអានតែរូបថតដែលបានចាក់សោប៉ុណ្ណោះ។",
          "l4-no-balances": "មិនបានរក្សាទុកសមតុល្យទេ។"
        },
        "ot": {
          "lock-btn": "ចាក់សោរយៈពេលម៉ោងបន្ថែម",
          "sub-tenant": "វិសាលភាពទាំងអស់ · ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការម៉ោងបន្ថែមសម្រាប់ថ្នាក់ដឹកនាំ · KPI សរុប + រូបថតដែលបានចាក់សោ · អានតែប៉ុណ្ណោះ",
          "sub-client": "{name} · សរុបម៉ោងបន្ថែម · អានតែប៉ុណ្ណោះ",
          "sub-company": "{name} · ឋានានុក្រមម៉ោងបន្ថែម · អានតែប៉ុណ្ណោះ (ប្រតិបត្តិការធ្វើនៅវិសាលភាពម្ចាស់)",
          "kpi": {
            "waiting-tip": "បុគ្គលិកដែលមានសំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយយ៉ាងតិចមួយ",
            "completion": "ភាពបញ្ចប់ម៉ោងបន្ថែម",
            "completion-tip": "ថ្ងៃបានចាក់សោ ÷ ថ្ងៃរំពឹងទុកនៃរយៈពេលរកបានម៉ោងបន្ថែម ({locked}/{total}) — អង្គភាពដែលគ្មានម៉ោងបន្ថែមបានផ្ទៀងផ្ទាត់ ចាត់ទុកថាបានបញ្ចប់ មិនមែនរយៈពេលបើកប្រាក់បៀវត្សទេ",
            "oldest": "សំណើមិនទាន់ដោះស្រាយចាស់ជាងគេ",
            "oldest-none": "គ្មានសំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយ"
          },
          "col": {
            "open": "មិនទាន់ដោះស្រាយ",
            "cutoff": "ថ្ងៃកាត់បន្ទាប់ (ពឹងលើម៉ោងបន្ថែម)",
            "cutoff-tip": "ការបើកប្រាក់បៀវត្សបន្ទាប់ដែលប្រើទិន្នន័យម៉ោងបន្ថែម (រំលងការបើកជាមុន)",
            "verified-hrs": "ម៉ោងបានផ្ទៀងផ្ទាត់",
            "amount": "ចំនួនទឹកប្រាក់",
            "period": "រយៈពេលម៉ោងបន្ថែម",
            "verified": "បានផ្ទៀងផ្ទាត់",
            "unresolved-frozen": "មិនទាន់ដោះស្រាយដែលបានបង្កក",
            "hours": "ម៉ោង",
            "date": "កាលបរិច្ឆេទ",
            "time": "ម៉ោង",
            "payable-hrs": "ម៉ោងត្រូវបង់",
            "occurrence": "រយៈពេលកើតឡើង"
          },
          "owner-direct": "ម្ចាស់ម៉ោងបន្ថែម · បុគ្គលិករបស់ក្រុមហ៊ុន",
          "owner-project": "{id} · ម្ចាស់ម៉ោងបន្ថែម",
          "l1-foot": "ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការម៉ោងបន្ថែមសម្រាប់ថ្នាក់ដឹកនាំ · គិតត្រឹម {asOf} (ថ្ងៃម៉ោងបន្ថែមចុងក្រោយ) · ថ្ងៃកាត់ = ការបើកប្រាក់បៀវត្សបន្ទាប់ដែលពឹងលើម៉ោងបន្ថែម ពីប្រតិទិនដំណើរការប្រាក់បៀវត្ស (រំលងការបើកជាមុន) · KPI សរុបតែប៉ុណ្ណោះ — ប្រតិបត្តិការធ្វើនៅវិសាលភាពម្ចាស់ · ជួរដេកតម្រៀបតាមហានិភ័យ · ចុចលើជួរដើម្បីចូលលម្អិត",
          "l2-foot": "ថ្ងៃកាត់ប្រាក់បៀវត្សបន្ទាប់ដែលពឹងលើម៉ោងបន្ថែម៖ {cut}{win} · គិតត្រឹម {asOf} · ចុចលើជួរដើម្បីមើលរយៈពេលដែលបានចាក់សោ",
          "win-line": " · រយៈពេលរកបានម៉ោងបន្ថែម ({from} → {to}]",
          "l2-banner-lead": "ប្រតិបត្តិការម៉ោងបន្ថែមធ្វើនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង)។",
          "l3-empty": "មិនទាន់មានរយៈពេលម៉ោងបន្ថែមដែលបានចាក់សោសម្រាប់វិសាលភាពនេះទេ — វិសាលភាពម្ចាស់បិទរយៈពេលតាមរយៈ «ចាក់សោរយៈពេលម៉ោងបន្ថែម»។",
          "l4-lead": "រយៈពេលម៉ោងបន្ថែមបានចាក់សោ — រូបថតបង្កក (អានតែប៉ុណ្ណោះ)។",
          "l4-banner": "បានចាក់សោ {at} ដោយ {by} · {reqs} សំណើ · {hours}ម៉ោង បានផ្ទៀងផ្ទាត់ · {amount}{tail}។ រូបថតនេះ — ម៉ោង និងចំនួនទឹកប្រាក់ម៉ោងបន្ថែមបានផ្ទៀងផ្ទាត់ — គឺជាអ្វីដែលប្រាក់បៀវត្សប្រើ គ្មានប្រតិបត្តិការម៉ោងបន្ថែមនៅវិសាលភាពត្រួតពិនិត្យទេ។",
          "l4-frozen": " · {n} មិនទាន់ដោះស្រាយដែលបានបង្កក (បានទទួលស្គាល់ពេលចាក់សោ)",
          "progress-tip": "{locked} ក្នុងចំណោម {total} ថ្ងៃនៃរយៈពេលរកបានម៉ោងបន្ថែមត្រូវបានចាក់សោ (មិនមែនរយៈពេលបើកប្រាក់បៀវត្សទេ)",
          "ready-tip": {
            "ready": "ម៉ោងបន្ថែមបានផ្ទៀងផ្ទាត់នៃរយៈពេលរកបានត្រូវបានចាក់សោ (ឬគ្មានអ្វីត្រូវប្រើ) — រូបថតបានបង្កកសម្រាប់ប្រាក់បៀវត្ស",
            "waiting": "ម៉ោងបន្ថែមបានផ្ទៀងផ្ទាត់ក្នុងរយៈពេលរកបានមិនទាន់ចាក់សោ — គ្មានសំណើមិនទាន់ដោះស្រាយរារាំង",
            "blocked": "សំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយត្រូវសម្រេចមុនថ្ងៃកាត់ប្រាក់បៀវត្ស"
          },
          "open-company-tip": "បើកកន្លែងធ្វើការរបស់ក្រុមហ៊ុន — ប្រតិបត្តិការម៉ោងបន្ថែមធ្វើនៅវិសាលភាពម្ចាស់របស់វា",
          "open-unit-tip": "បើកកន្លែងធ្វើការម៉ោងបន្ថែម — វិសាលភាពម្ចាស់ (ប្រតិបត្តិការ)",
          "locked-periods-tip": "រយៈពេលម៉ោងបន្ថែមដែលបានចាក់សោសម្រាប់អង្គភាពនេះ",
          "draft-title": "ចាក់សោរយៈពេលម៉ោងបន្ថែម — {company} · {unit}",
          "draft-counts": "{n} សំណើបានផ្ទៀងផ្ទាត់ · {hours}ម៉ោង · {amount}",
          "draft-unresolved": "{n} សំណើមិនទាន់ដោះស្រាយ",
          "lock-anyway": "ចាក់សោទោះយ៉ាងណា — បង្កក {n} មិនទាន់ដោះស្រាយ",
          "ack": "{lead} សំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយ {n} ក្នុងចន្លោះនេះនឹងត្រូវបង្កកដោយមិនបានសម្រេច — ប្រាក់បៀវត្សប្រើរូបថតដែលបានផ្ទៀងផ្ទាត់ដោយគ្មានសំណើទាំងនោះ ហើយមិនអាចអនុម័ត ផ្ទៀងផ្ទាត់ ឬដោះស្រាយសម្រាប់កាលបរិច្ឆេទទាំងនេះបានទៀតទេ។ ចុច {anyway} ដើម្បីបញ្ជាក់ ឬបោះបង់ ហើយសម្រេចវាជាមុនសិន។",
          "draft-note": "ការចាក់សោបិទរយៈពេលរកបានម៉ោងបន្ថែមនេះជាផ្លូវការ៖ ម៉ោងបន្ថែមបានផ្ទៀងផ្ទាត់ និងរូបថតម៉ោង/ចំនួនទឹកប្រាក់ត្រូវបានបង្កកសម្រាប់ប្រាក់បៀវត្ស។ សំណើដែលមានកាលបរិច្ឆេទក្នុងរយៈពេលបានចាក់សោ មិនអាចដាក់ស្នើ អនុម័ត ផ្ទៀងផ្ទាត់ ឬដោះស្រាយបានទៀតទេ។ វិសាលភាពត្រួតពិនិត្យអានតែរូបថតដែលបានចាក់សោប៉ុណ្ណោះ។",
          "override": "កែតម្រូវ {h}ម៉ោង",
          "override-tip": "បានផ្ទៀងផ្ទាត់ជាមួយការកែតម្រូវ",
          "occurrence-tip": "រយៈពេលកើតឡើង — ពេលដែលម៉ោងបន្ថែមត្រូវបានធ្វើ (មិនត្រូវសរសេរជាន់ដោយរយៈពេលទទួលយកប្រាក់បៀវត្សទេ)"
        }
      },
      "notice": {
        "item": {
          "not-found": "រកមិនឃើញធាតុ"
        },
        "reason-required": "⚠ ត្រូវការមូលហេតុ",
        "reject": {
          "reason-required": "⚠ ការបដិសេធត្រូវបានបោះបង់ — ត្រូវការមូលហេតុ"
        },
        "lock": {
          "invalid-range": "ចន្លោះកាលបរិច្ឆេទមិនត្រឹមត្រូវ។"
        },
        "handoff": {
          "oversight": "ការប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុ ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។"
        },
        "att": {
          "oversight": "ការពិនិត្យវត្តមាន ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការពិនិត្យមើលប៉ុណ្ណោះ។",
          "locked": "រយៈពេលវត្តមាននេះត្រូវបានចាក់សោ — មិនអាចកែប្រែបន្ថែមបានទេ។",
          "request-type-required": "សូមជ្រើសរើសប្រភេទសំណើ។",
          "wrong-state": {
            "review": "កំណត់ត្រានេះមិនកំពុងរង់ចាំការពិនិត្យទេ។",
            "request": "សំណើដោះស្រាយអាចដាក់បានតែលើកំណត់ត្រាដែលបានរកឃើញ ឬបានពិនិត្យរួចប៉ុណ្ណោះ។",
            "approval": "កំណត់ត្រានេះមិនកំពុងរង់ចាំការអនុម័តទេ។",
            "lock": "អាចចាក់សោបានតែកំណត់ត្រាដែលបានដោះស្រាយរួចប៉ុណ្ណោះ។"
          },
          "ot": {
            "duplicate": "សំណើម៉ោងបន្ថែម {id} មានរួចហើយសម្រាប់ {name} នៅថ្ងៃ {date}",
            "no-planned-end": "កំណត់ត្រានេះគ្មានម៉ោងបញ្ចប់តាមផែនការទេ — សូមដាក់សំណើម៉ោងបន្ថែមពីផ្ទាំងម៉ោងបន្ថែម។",
            "created": "បានបង្កើតសំណើម៉ោងបន្ថែម (កំពុងរង់ចាំ) — បំពេញជាមុនពីការស្កេនវត្តមាន"
          },
          "lock": {
            "oversight": "ការចាក់សោវត្តមាន ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការពិនិត្យមើលប៉ុណ្ណោះ។",
            "overlap": "ចន្លោះនេះត្រួតលើរយៈពេលដែលបានចាក់សោរួចហើយ។",
            "empty": "គ្មានកំណត់ត្រាវត្តមានក្នុងចន្លោះនេះទេ — គ្មានអ្វីត្រូវចាក់សោ។",
            "ack-required": "ករណីលើកលែងដែលមិនទាន់ដោះស្រាយចំនួន {count} នឹងត្រូវបង្កកក្នុងរូបថតសម្រាប់ប្រាក់បៀវត្សរ៍ ហើយមិនអាចកែតម្រូវបានទៀតទេ។ ផ្នែកប្រាក់បៀវត្សរ៍នឹងទទួលវាដូចដែលមាន។",
            "done": "បានចាក់សោរយៈពេលវត្តមាន — រូបថតត្រូវបានបង្កកសម្រាប់ប្រាក់បៀវត្សរ៍"
          },
          "resolve": {
            "submitted": "✓ បានដាក់ស្នើ {submitted} ទៅប្រធានផ្ទាល់ · កំពុងរង់ចាំការអនុម័ត",
            "submitted-skipped": "✓ បានដាក់ស្នើ {submitted} ទៅប្រធានផ្ទាល់ · {skipped} កំពុងដំណើរការរួចហើយ",
            "none": "មិនបានជ្រើសបុគ្គលិកទេ។",
            "reason-required": "⚠ ត្រូវការហេតុផលសម្រាប់ {name}",
            "clock-out-required": "⚠ ត្រូវការម៉ោងចេញសម្រាប់ {name}"
          },
          "reminder": {
            "sent": "✓ បានផ្ញើការរំលឹកទៅបុគ្គលិក {sent} តាមការជូនដំណឹងទូរសព្ទ",
            "sent-skipped": "✓ បានផ្ញើការរំលឹកទៅបុគ្គលិក {sent} តាមទូរសព្ទ · {skipped} បានដាក់ស្នើរួច (រំលង)",
            "none": "ទាំងអស់ក្នុងក្រុមនេះបានដាក់ស្នើរួចហើយ — គ្មានអ្វីត្រូវរំលឹកទេ"
          }
        },
        "attendance": {
          "oversight": "ការអនុម័តវត្តមាន ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការពិនិត្យមើលប៉ុណ្ណោះ។",
          "approved": "✓ បានអនុម័តវត្តមាន {id}",
          "rejected": "✕ បានបដិសេធវត្តមាន {id}"
        },
        "leave": {
          "oversight": "ការអនុម័តច្បាប់ ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "oversight-decision": "ការសម្រេចលើច្បាប់ ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "locked": "សំណើនេះស្ថិតក្នុងរយៈពេលច្បាប់ដែលបានចាក់សោ — រយៈពេលនេះត្រូវបានបិទសម្រាប់ប្រាក់បៀវត្សរ៍។",
          "reason-required": "⚠ គោលការណ៍តម្រូវឱ្យមានមូលហេតុពេលអនុម័ត",
          "approved": "✓ បានអនុម័តច្បាប់ {id} · កាត់ {days} ថ្ងៃចេញពីសមតុល្យ",
          "rejected": "✕ បានបដិសេធច្បាប់ {id} · បានបញ្ជូនត្រឡប់ទៅធនធានមនុស្ស/និយោជិក",
          "cancelled": "✓ បានលុបចោល {id} · សមតុល្យត្រូវបានស្ដារវិញ",
          "cancel-disabled": "⚠ ការលុបចោលត្រូវបានបិទដោយគោលការណ៍",
          "already-cancelled": "បានលុបចោលរួចហើយ",
          "submit": {
            "incomplete": "ត្រូវការនិយោជិក ប្រភេទច្បាប់ និងកាលបរិច្ឆេទយ៉ាងហោចណាស់មួយ។",
            "oversight": "សំណើច្បាប់ថ្មីត្រូវបានបង្កើតនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
            "locked": "កាលបរិច្ឆេទមួយ ឬច្រើនស្ថិតក្នុងរយៈពេលច្បាប់ដែលបានចាក់សោ — រយៈពេលនេះត្រូវបានបិទ។",
            "reason-required": "⚠ សំណើច្បាប់ត្រូវការមូលហេតុ (គោលការណ៍)"
          },
          "submitted": "✓ បានដាក់ស្នើច្បាប់ {id}",
          "lock": {
            "oversight": "ការចាក់សោច្បាប់ ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការពិនិត្យមើលប៉ុណ្ណោះ។",
            "overlap": "ចន្លោះនេះត្រួតលើរយៈពេលច្បាប់ដែលបានចាក់សោរួចហើយ។",
            "empty": "គ្មានសំណើច្បាប់ក្នុងចន្លោះនេះទេ — គ្មានអ្វីត្រូវចាក់សោ។",
            "ack-required": "សំណើកំពុងរង់ចាំចំនួន {count} ក្នុងចន្លោះនេះនឹងត្រូវបង្កកដោយមិនទាន់សម្រេច — ផ្នែកប្រាក់បៀវត្សរ៍ប្រើរូបថតដោយគ្មានសំណើទាំងនោះ ហើយវាមិនអាចអនុម័ត ឬបដិសេធសម្រាប់កាលបរិច្ឆេទទាំងនេះបានទៀតទេ។",
            "done": "បានចាក់សោរយៈពេលច្បាប់ — ច្បាប់ដែលបានអនុម័ត និងរូបថតសមតុល្យត្រូវបានបង្កកសម្រាប់ប្រាក់បៀវត្សរ៍"
          }
        },
        "ot": {
          "oversight": "ការអនុម័តម៉ោងបន្ថែម ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "oversight-decision": "ការសម្រេចលើម៉ោងបន្ថែម ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "locked": "សំណើម៉ោងបន្ថែមនេះស្ថិតក្នុងរយៈពេលម៉ោងបន្ថែមដែលបានចាក់សោ — មិនអាចកែប្រែបន្ថែមបានទេ។",
          "not-pending": "អាចអនុម័តបានតែសំណើម៉ោងបន្ថែមដែលកំពុងរង់ចាំប៉ុណ្ណោះ (ស្ថានភាពបច្ចុប្បន្ន៖ {status})។",
          "approved": "✓ បានអនុម័តម៉ោងបន្ថែម {id}",
          "rejected": "✕ បានបដិសេធម៉ោងបន្ថែម {id}",
          "lock": {
            "oversight": "ការចាក់សោម៉ោងបន្ថែម ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការពិនិត្យមើលប៉ុណ្ណោះ។",
            "overlap": "ចន្លោះនេះត្រួតលើរយៈពេលម៉ោងបន្ថែមដែលបានចាក់សោរួចហើយ។",
            "empty": "គ្មានសំណើម៉ោងបន្ថែមក្នុងចន្លោះនេះទេ — គ្មានអ្វីត្រូវចាក់សោ។",
            "ack-required": "សំណើម៉ោងបន្ថែមមិនទាន់ដោះស្រាយចំនួន {count} ក្នុងចន្លោះនេះនឹងត្រូវបង្កកដោយមិនទាន់សម្រេច — ផ្នែកប្រាក់បៀវត្សរ៍ប្រើរូបថតដែលបានផ្ទៀងផ្ទាត់ដោយគ្មានសំណើទាំងនោះ ហើយវាមិនអាចអនុម័ត ផ្ទៀងផ្ទាត់ ឬដោះស្រាយសម្រាប់កាលបរិច្ឆេទទាំងនេះបានទៀតទេ។",
            "done": "បានចាក់សោរយៈពេលម៉ោងបន្ថែម — ម៉ោងបន្ថែមដែលបានផ្ទៀងផ្ទាត់ និងរូបថតម៉ោង/ចំនួនទឹកប្រាក់ត្រូវបានបង្កកសម្រាប់ប្រាក់បៀវត្សរ៍"
          },
          "submitted": "✓ បានដាក់ស្នើសំណើម៉ោងបន្ថែម {id}",
          "submit": {
            "oversight": "សំណើម៉ោងបន្ថែមថ្មីត្រូវបង្កើតនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — វិសាលភាពត្រួតពិនិត្យអានតែប៉ុណ្ណោះ។",
            "locked": "កាលបរិច្ឆេទនេះនៅក្នុងរយៈពេលម៉ោងបន្ថែមដែលបានចាក់សោ — មិនអាចស្នើម៉ោងបន្ថែមបន្ថែមទៀតបានទេ។"
          }
        },
        "travel": {
          "oversight": "ការអនុម័តបេសកកម្ម ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "oversight-decision": "ការសម្រេចលើបេសកកម្ម ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "not-pending": "អាចអនុម័តបានតែសំណើបេសកកម្មដែលកំពុងរង់ចាំប៉ុណ្ណោះ (ស្ថានភាពបច្ចុប្បន្ន៖ {status})។",
          "not-approved": "អាចប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុបានតែសំណើបេសកកម្មដែលបានអនុម័តប៉ុណ្ណោះ (ស្ថានភាពបច្ចុប្បន្ន៖ {status})។",
          "approved": "✓ បានអនុម័តបេសកកម្ម {id}",
          "rejected": "✕ បានបដិសេធបេសកកម្ម {id}",
          "handed": "✓ បានប្រគល់បេសកកម្ម {id} ទៅផ្នែកហិរញ្ញវត្ថុ — ការទូទាត់បន្តនៅក្នុង TRV/EXP-FIN",
          "saved": "✓ បានរក្សាទុកសំណើបេសកកម្ម"
        },
        "expense": {
          "oversight": "ការអនុម័តចំណាយ ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "oversight-decision": "ការសម្រេចលើចំណាយ ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "not-pending": "អាចអនុម័តបានតែការទាមទារចំណាយដែលកំពុងរង់ចាំប៉ុណ្ណោះ (ស្ថានភាពបច្ចុប្បន្ន៖ {status})។",
          "not-approved": "អាចប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុបានតែការទាមទារចំណាយដែលបានអនុម័តប៉ុណ្ណោះ (ស្ថានភាពបច្ចុប្បន្ន៖ {status})។",
          "approved": "✓ បានអនុម័តចំណាយ {id}",
          "rejected": "✕ បានបដិសេធចំណាយ {id}",
          "handed": "✓ បានប្រគល់ចំណាយ {id} ទៅផ្នែកហិរញ្ញវត្ថុ — ការទូទាត់បន្តនៅក្នុង TRV/EXP-FIN",
          "saved": "✓ បានរក្សាទុកការទាមទារចំណាយ"
        },
        "policy": {
          "company-only": "គោលការណ៍បេសកកម្ម និងចំណាយជាកម្មសិទ្ធិរបស់ក្រុមហ៊ុន — សូមគ្រប់គ្រងវានៅក្នុងបរិបទក្រុមហ៊ុន (ឫសក្រុមហ៊ុន)។",
          "saved": "✓ បានរក្សាទុកគោលការណ៍"
        },
        "sched": {
          "no-company": "សូមជ្រើសរើសកន្លែងធ្វើការរបស់ក្រុមហ៊ុន។",
          "oversight": "ប្រតិបត្តិការតារាងវេនធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការមើលប៉ុណ្ណោះ។",
          "shift": {
            "saved": "✓ បានរក្សាទុកវេន",
            "deleted": "✓ បានលុបវេន"
          },
          "rule": {
            "saved": "✓ បានរក្សាទុកច្បាប់កាលវិភាគ",
            "deleted": "✓ បានលុបច្បាប់កាលវិភាគ"
          },
          "pattern": {
            "saved": "✓ បានរក្សាទុកលំនាំការងារ",
            "deleted": "✓ បានលុបលំនាំការងារ"
          },
          "coverage": {
            "saved": "✓ បានរក្សាទុកផែនការគ្របដណ្តប់",
            "deleted": "✓ បានលុបផែនការគ្របដណ្តប់"
          },
          "roster": {
            "saved": "✓ បានរក្សាទុកតារាងវេន",
            "deleted": "✓ បានលុបតារាងវេន"
          },
          "pool": {
            "saved": "✓ បានរក្សាទុកក្រុមបុគ្គលិក",
            "deleted": "✓ បានលុបក្រុមបុគ្គលិក"
          },
          "rw": {
            "locked": "តារាងវេនដែលបានផ្សព្វផ្សាយផ្លាស់ប្តូរតាមការកែប្រែដែលកត់ត្រាតែប៉ុណ្ណោះ",
            "published-locked": "តារាងវេនដែលបានផ្សព្វផ្សាយត្រូវបានចាក់សោ — ប្រើការកែប្រែដែលកត់ត្រា ឬផ្សព្វផ្សាយកំណែថ្មី។",
            "must-approve": "តារាងវេនត្រូវតែអនុម័តមុនផ្សព្វផ្សាយ",
            "title-required": "ត្រូវការចំណងជើងតារាងវេន — ដាក់ឈ្មោះតារាងវេននេះមុនផ្សព្វផ្សាយ",
            "cell-set": "{name} · {day} → {value}",
            "cell-removed": "{name} ត្រូវបានដកចេញ · {day} (ចន្លោះបើកដើម្បីបំពេញឡើងវិញ)",
            "cell-reset": "{name} · {day} កំណត់ឡើងវិញដូចដើម",
            "already": "{name} ត្រូវបានចាត់តាំងនៅថ្ងៃនោះរួចហើយ",
            "filled": "{name} ត្រូវបានចាត់តាំងទៅ {group}",
            "filled-ot": "{name} ត្រូវបានបន្ថែមជាម៉ោងបន្ថែម · {group}",
            "filled-oc": "{name} ត្រូវបានហៅចូល (ហៅបម្រុង) · {group}",
            "filled-amend": "{name} ត្រូវបានចាត់តាំង — កត់ត្រាជាការកែប្រែក្រោយផ្សព្វផ្សាយ",
            "fill-removed": "{name} ត្រូវបានដកចេញពី {group}",
            "regenerated": "បានបង្កើតឡើងវិញ · សេចក្តីព្រាងថ្មី v{ver}",
            "submit-blocked": "ដោះស្រាយបញ្ហាដែលត្រូវតែជួសជុល {n} មុនដាក់ស្នើ",
            "submitted": "បានដាក់ស្នើសុំការអនុម័ត",
            "approved": "តារាងវេនបានអនុម័ត · រួចរាល់សម្រាប់ផ្សព្វផ្សាយ",
            "sent-back": "បានផ្ញើត្រឡប់ទៅសេចក្តីព្រាង — បានបន្ថែមកំណត់ចំណាំសវនកម្ម",
            "sent-back-run": "បានផ្ញើត្រឡប់ទៅសេចក្តីព្រាង — បានបន្ថែមកំណត់ចំណាំសវនកម្ម",
            "withdrawn": "បានដកការដាក់ស្នើវិញ — ត្រឡប់ទៅសេចក្តីព្រាង",
            "voided": "ការអនុម័តត្រូវបានលុបចោល — ត្រឡប់ទៅសេចក្តីព្រាង · បានបន្ថែមកំណត់ចំណាំសវនកម្ម",
            "published": "តារាងវេនបានផ្សព្វផ្សាយ និងរក្សាទុក · v{ver}",
            "fresh": "កន្លែងធ្វើការថ្មីរួចរាល់",
            "parked": "ការដំណើរការត្រូវបានទុកក្នុងតារាងវេនទាំងអស់ ({status}) · កន្លែងធ្វើការថ្មីរួចរាល់",
            "resumed": "បានបន្ត \"{title}\" · {status}",
            "resumed-current": "បានបន្ត",
            "no-run": "តារាងវេននេះគ្មានទិន្នន័យការដំណើរការដែលបានរក្សាទុកទេ",
            "reopened": "បានបើកតារាងវេនដែលបានផ្សព្វផ្សាយឡើងវិញ · {week}",
            "waived": "បញ្ហាត្រូវបានទទួលយក · កត់ត្រាក្នុងកំណត់ត្រាសវនកម្ម",
            "surplus-removed": "វេនលើសត្រូវបានលុប — សន្សំថ្លៃពលកម្ម"
          },
          "not-built": "ផ្នែកនេះនៃការរៀបចំកាលវិភាគ មិនទាន់អាចប្រើបាននៅឡើយទេ។"
        }
      },
      "header": {
        "subtitle": "{company} · ប្រតិបត្តិការធនធានមនុស្ស",
        "all-companies": "ក្រុមហ៊ុនទាំងអស់ (ការត្រួតពិនិត្យ)",
        "this-company": "ក្រុមហ៊ុននេះ"
      },
      "empty-notice": "គ្មានកំណត់ត្រា {label} សម្រាប់ {company} ទេ។ ទាំងនេះត្រូវបានកត់ត្រាតាមក្រុមហ៊ុនប្រតិបត្តិការនីមួយៗ — ក្រុមហ៊ុននេះគ្មាននៅក្នុងទិន្នន័យគំរូទេ។ សូមប្តូរទៅក្រុមហ៊ុនប្រតិបត្តិការ (ឧ. Optimal P) ឬ វិសាលភាពទាំងអស់។",
      "tx": {
        "close": "បិទ",
        "cancel": "បោះបង់",
        "ok": "យល់ព្រម",
        "remove": "លុបចេញ",
        "loading": "កំពុងផ្ទុក…",
        "load-error": "មិនអាចផ្ទុកកំណត់ត្រាទាំងនេះបានទេ។",
        "retry": "ព្យាយាមម្តងទៀត",
        "settings": "ការកំណត់",
        "export": "នាំចេញ",
        "hand": "ប្រគល់ទៅហិរញ្ញវត្ថុ →",
        "resolve": "ដោះស្រាយ",
        "issue": "បញ្ហា៖ {label}",
        "with-finance-b": "នៅផ្នែកហិរញ្ញវត្ថុ",
        "open-id": "បើក {id}",
        "open-record": "បើក {id}",
        "recovered": "បានទាមទារ {amount} ពីបុគ្គលិក",
        "paid-out": "បានបង់ {amount} ឱ្យបុគ្គលិក",
        "zero-balance": "សមតុល្យសូន្យ",
        "rejected-reason": "បានបដិសេធ៖ {reason}",
        "cancelled-reason": "បានលុបចោល៖ {reason}",
        "request": "សំណើ",
        "purpose": "គោលបំណង",
        "purpose-reason": "គោលបំណង / មូលហេតុអាជីវកម្ម",
        "net-balance": "សមតុល្យសុទ្ធ",
        "owed-by-employee": "(បុគ្គលិកជំពាក់)",
        "due-to-employee": "(ត្រូវបង់ឱ្យបុគ្គលិក)",
        "zero": "(សូន្យ)",
        "owed": "ជំពាក់",
        "due": "ត្រូវបង់",
        "requested-by": "ស្នើដោយ៖",
        "approver": "អ្នកអនុម័ត៖",
        "external-lm": "អ្នកគ្រប់គ្រងផ្ទាល់ខាងក្រៅ៖",
        "approver-external": "{name} (អ្នកគ្រប់គ្រងខាងក្រៅ)",
        "approver-self-md": "អនុម័តដោយខ្លួនឯង (MD)",
        "advance-disbursed": "ប្រាក់បុរេប្រទានបានបើក៖",
        "amount-via": "{amount} តាម {via}",
        "via": "តាម {via}",
        "activity": "កំណត់ហេតុសកម្មភាព",
        "no-activity": "មិនទាន់មានសកម្មភាពទេ។",
        "employee": "បុគ្គលិក",
        "select-employee": "— ជ្រើសរើសបុគ្គលិក —",
        "submit-approval": "ដាក់ស្នើសុំការអនុម័ត",
        "save-changes": "រក្សាទុកការផ្លាស់ប្តូរ",
        "settings-foot": "ការផ្លាស់ប្តូរអនុវត្តសម្រាប់វគ្គនេះតែប៉ុណ្ណោះ · ការរក្សាទុកតាមអតិថិជនពេញលេញនឹងមកជាមួយការកំណត់អ្នកគ្រប់គ្រង",
        "include-outsourced": "រួមបញ្ចូលបុគ្គលិកជួលខាងក្រៅ",
        "showing": "បង្ហាញ {n} នៃ {total}",
        "search-ph": "ត្រងតាមឈ្មោះបុគ្គលិក…",
        "clear-search": "សម្អាតការស្វែងរក",
        "clear-filters": "សម្អាតតម្រង",
        "outsourced": "ជួលខាងក្រៅ",
        "demo": "សាកល្បង",
        "demo-tip": "ទិន្នន័យសាកល្បង · TRVEXP-OWN-104",
        "col": {
          "id": "លេខសម្គាល់",
          "employee": "បុគ្គលិក",
          "status": "ស្ថានភាព"
        },
        "kpi": {
          "needs-action": "ត្រូវការសកម្មភាពរបស់អ្នក",
          "pending": "រង់ចាំការអនុម័ត",
          "advance-outstanding": "ប្រាក់បុរេប្រទាននៅសល់"
        },
        "who": {
          "hr-system": "ប្រព័ន្ធធនធានមនុស្ស",
          "system": "ប្រព័ន្ធ"
        },
        "status": {
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "disbursed": "បានបើកប្រាក់",
          "in-travel": "កំពុងធ្វើដំណើរ",
          "returned": "បានត្រឡប់មកវិញ",
          "awaiting-settlement": "រង់ចាំទូទាត់",
          "handed-to-finance": "បានប្រគល់ទៅហិរញ្ញវត្ថុ",
          "closed": "បានបិទ",
          "rejected": "បានបដិសេធ",
          "cancelled": "បានលុបចោល",
          "issue-to-resolve": "បញ្ហាត្រូវដោះស្រាយ",
          "clearance-submitted": "បានដាក់ការទូទាត់",
          "clearance-overdue": "ការទូទាត់ហួសកំណត់",
          "reimbursed": "បានសងវិញ",
          "settled": "បានទូទាត់រួច",
          "awaiting-approval": "រង់ចាំការអនុម័ត",
          "paid": "បានបង់",
          "submitted": "បានដាក់ស្នើ",
          "verified": "បានផ្ទៀងផ្ទាត់",
          "overdue": "ហួសកំណត់"
        },
        "policy": {
          "owned": "គោលការណ៍ជាកម្មសិទ្ធិក្រុមហ៊ុន",
          "effective-from": "មានសុពលភាពពី",
          "each-save": "ការរក្សាទុកនីមួយៗបន្ថែមកំណែមួយដែលបានសវនកម្ម និងមានកាលបរិច្ឆេទមានសុពលភាព។",
          "readonly": "អានបានតែប៉ុណ្ណោះនៅទីនេះ — ការកែសម្រួលត្រូវបានកំណត់សម្រាប់តួនាទីគោលការណ៍កម្រិតក្រុមហ៊ុនក្នុងកន្លែងធ្វើការរបស់ក្រុមហ៊ុន។ វិសាលភាពប្រតិបត្តិការ (ផ្ទាល់ / គម្រោង) ប្រើគោលការណ៍ដែលអនុវត្តបានដោយអានតែប៉ុណ្ណោះ; ការបដិសេធតាមអតិថិជន/គម្រោងទាមទារគំរូបដិសេធច្បាស់លាស់ (ផ្នែកនាពេលអនាគត)។",
          "version": "មានសុពលភាព {eff} — បានរក្សាទុក {at} ដោយ {by}",
          "no-versions": "មិនទាន់មានកំណែក្រុមហ៊ុនបានរក្សាទុកទេ — បង្ហាញតម្លៃលំនាំដើមនៃវគ្គ។"
        },
        "port": {
          "readonly": "ស្រទាប់តាមដានអានបានតែប៉ុណ្ណោះ",
          "travel": {
            "title": "ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការធ្វើដំណើរសម្រាប់ថ្នាក់ដឹកនាំ",
            "note": "ការធ្វើដំណើរជាម៉ូឌុលហិរញ្ញវត្ថុ/គណនីត្រូវបង់ — គ្មានការប្រើប្រាស់ក្នុងបៀវត្សរ៍ ថ្ងៃផុតកំណត់ ឬការចាក់សោរយៈពេលទេ។ ធនធានមនុស្សប្រគល់សំណើដែលបានអនុម័តទៅហិរញ្ញវត្ថុ; ផ្ទៀងផ្ទាត់ → បើកប្រាក់ → ទូទាត់ → បញ្ចប់ បន្តក្នុងម៉ូឌុលហិរញ្ញវត្ថុ (TRV/EXP-FIN)។ ប្រតិបត្តិការកើតឡើងនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង)។"
          },
          "expense": {
            "title": "ផ្ទាំងគ្រប់គ្រងប្រតិបត្តិការចំណាយសម្រាប់ថ្នាក់ដឹកនាំ",
            "note": "ចំណាយជាម៉ូឌុលសងប្រាក់ហិរញ្ញវត្ថុ/គណនីត្រូវបង់ — គ្មានការប្រើប្រាស់ក្នុងបៀវត្សរ៍ ឬការចាក់សោរយៈពេលទេ។ ធនធានមនុស្សប្រគល់ពាក្យទាមទារដែលបានអនុម័តទៅហិរញ្ញវត្ថុ; ផ្ទៀងផ្ទាត់ → បើកប្រាក់ → ទូទាត់/សងវិញ → បញ្ចប់ បន្តក្នុងម៉ូឌុលហិរញ្ញវត្ថុ (TRV/EXP-FIN)។ ប្រតិបត្តិការកើតឡើងនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង)។"
          },
          "kpi": {
            "inflight": "កំពុងដំណើរការ (ចំនួនតែប៉ុណ្ណោះ)",
            "inflight-tip": "ការងារមុនពេលប្រគល់ជារបស់វិសាលភាពម្ចាស់ — ព័ត៌មានលម្អិតនៃកំណត់ត្រាមិនត្រូវបានបង្ហាញទៅខាងលើទេ (PO D1)",
            "committed": "ចំណាយដែលបានសន្យា",
            "committed-sub": "បានអនុម័ត · រង់ចាំការប្រគល់",
            "committed-tip": "KPI សរុបតែប៉ុណ្ណោះ — គ្មានព័ត៌មានលម្អិតប្រតិបត្តិការរង់ចាំទៅខាងលើទេ (PO D1)",
            "handed": "បានប្រគល់ទៅហិរញ្ញវត្ថុ",
            "handed-sub": "{amount} · នៅផ្នែកហិរញ្ញវត្ថុ (TRV/EXP-FIN)",
            "handed-tip": "ស្ថានភាពប្រគល់ចុងក្រោយរបស់ធនធានមនុស្ស — បង្ហាញជា \"បានប្រគល់ទៅហិរញ្ញវត្ថុ\" (PO D2)",
            "done": "ហិរញ្ញវត្ថុបានបញ្ចប់ / បានបដិសេធ",
            "done-sub": "{done} បានទូទាត់ · {rej} បានបដិសេធ/លុបចោល",
            "done-tip": "កំណត់ត្រាសាកល្បងដែលហិរញ្ញវត្ថុបានបញ្ចប់ + សំណើដែលបានបដិសេធ"
          },
          "oldest": "ចាស់បំផុត {n}ថ្ងៃ",
          "col": {
            "unit": "អង្គភាពម្ចាស់",
            "inflight": "កំពុងដំណើរការ",
            "committed": "បានសន្យា",
            "handed": "បានប្រគល់ទៅហិរញ្ញវត្ថុ",
            "done": "បានបញ្ចប់/បានបដិសេធ",
            "actions": "សកម្មភាព"
          },
          "direct": "កម្លាំងពលកម្មផ្ទាល់",
          "inflight-cell-tip": "កំណត់ត្រាកំពុងដំណើរការបង្ហាញជាចំនួនតែប៉ុណ្ណោះនៅខាងលើវិសាលភាពម្ចាស់ (PO D1) — គ្មានការមើលលម្អិតមុនពេលប្រគល់ទៅហិរញ្ញវត្ថុទេ",
          "committed-cell-tip": "ចំណាយដែលបានសន្យា (បានអនុម័ត រង់ចាំការប្រគល់) — ចំនួនសរុបតែប៉ុណ្ណោះ",
          "records": "កំណត់ត្រា",
          "hide": "លាក់",
          "counts-only": "ចំនួនតែប៉ុណ្ណោះ",
          "counts-only-tip": "មិនទាន់មានកំណត់ត្រាចុងក្រោយរបស់ធនធានមនុស្សសម្រាប់ពិនិត្យទេ",
          "no-terminal": "មិនទាន់មានកំណត់ត្រាចុងក្រោយរបស់ធនធានមនុស្សទេ — ការងារកំពុងដំណើរការនៅតែនៅវិសាលភាពម្ចាស់រហូតដល់ប្រគល់ទៅហិរញ្ញវត្ថុ។",
          "empty": "គ្មានកំណត់ត្រាក្នុងវិសាលភាពទេ។"
        }
      },
      "travel": {
        "new-request": "សំណើថ្មី",
        "empty": "គ្មានសំណើធ្វើដំណើរដែលត្រូវនឹងតម្រងនេះទេ។",
        "exported": "✓ បាននាំចេញ {n} ជួរ → {name}",
        "totals": "សរុប ({n} នៃ {total})",
        "tracking-note": "ផែនការ → អនុញ្ញាត → ធ្វើដំណើរ → របាយការណ៍ចំណាយ → ទូទាត់រួច។ ជួរ \"ជាក់ស្តែង\" និង \"សមតុល្យ\" ទាញពីរបាយការណ៍ចំណាយដែលភ្ជាប់ (ប្រភពតែមួយនៃការពិត)។",
        "flow-note-b": "លំហូររួមបញ្ចូលថ្មី៖",
        "flow-note": "ការធ្វើដំណើរគ្រប់គ្រងការអនុញ្ញាត + ប្រាក់បុរេប្រទាន។ បន្ទាប់ពីដំណើរ បុគ្គលិកដាក់{report}សម្រាប់បង្កាន់ដៃជាក់ស្តែង (ប្រភពតែមួយនៃការចំណាយ)។ សមតុល្យដែលគណនានៅទីនោះត្រឡប់មកស្ថានភាពធ្វើដំណើរវិញ (បានត្រឡប់មកវិញ → រង់ចាំទូទាត់ → បានបិទ)។",
        "view": {
          "requests": "សំណើទាំងអស់",
          "tracking": "របាយការណ៍តាមដាន"
        },
        "kind": {
          "local": "ក្នុងស្រុក",
          "overseas": "ក្រៅប្រទេស"
        },
        "accom": {
          "shared": "បន្ទប់រួម",
          "dedicated": "បន្ទប់ផ្ទាល់ខ្លួន"
        },
        "kpi": {
          "needs-sub": "{submit} ត្រូវដាក់ · {verifying} កំពុងផ្ទៀងផ្ទាត់ · {issue} បញ្ហា",
          "pending-sub": "រង់ចាំការពិនិត្យពីអ្នកគ្រប់គ្រង/នាយក",
          "in-travel": "កំពុងធ្វើដំណើរ / បានបើកប្រាក់",
          "in-travel-sub": "{trip} កំពុងធ្វើដំណើរ · {pre} មុនចេញដំណើរ",
          "advance-sub": "បានបង់ ប៉ុន្តែដំណើរមិនទាន់បិទ"
        },
        "chip": {
          "all": "ទាំងអស់",
          "needs-action": "ត្រូវការសកម្មភាព",
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "handed": "បានប្រគល់ទៅហិរញ្ញវត្ថុ",
          "disbursed": "បានបើកប្រាក់",
          "in-travel": "កំពុងធ្វើដំណើរ",
          "returned": "បានត្រឡប់មកវិញ",
          "awaiting-settlement": "រង់ចាំទូទាត់",
          "closed": "បានបិទ",
          "issue": "បញ្ហា",
          "rejected": "បានបដិសេធ",
          "cancelled": "បានលុបចោល"
        },
        "col": {
          "destination": "គោលដៅ",
          "dates": "កាលបរិច្ឆេទ",
          "plan-dates": "កាលបរិច្ឆេទគ្រោង",
          "estimate": "ការប៉ាន់ស្មាន",
          "advance": "ប្រាក់បុរេប្រទាន",
          "exp-rpt": "របាយការណ៍ចំណាយ",
          "expense-rpt": "របាយការណ៍ចំណាយ",
          "adv-status": "ស្ថានភាពបុរេប្រទាន",
          "actual": "ជាក់ស្តែង",
          "balance": "សមតុល្យ",
          "trip-status": "ស្ថានភាពដំណើរ"
        },
        "meal": {
          "breakfast": "អាហារពេលព្រឹក",
          "lunch": "អាហារថ្ងៃត្រង់",
          "dinner": "អាហារពេលល្ងាច"
        },
        "line": {
          "mission": "ប្រាក់ឧបត្ថម្ភបេសកកម្ម (អតិថិជនចេញថ្លៃធ្វើដំណើរ) — {rate}/ថ្ងៃ × {days} ថ្ងៃ",
          "meals-daytrip": "អាហារ (ដំណើរមួយថ្ងៃ ចេញ {time}) — {meals} = {amount}",
          "meals-day1": "អាហារ — ថ្ងៃទី១ (ចេញ {time})៖ {meals}",
          "meals-inter": "អាហារ — ថ្ងៃកណ្តាល (ព្រឹក+ថ្ងៃ+ល្ងាច × {days} ថ្ងៃ)",
          "meals-return": "អាហារ — ថ្ងៃត្រឡប់ (ត្រឡប់ {time}, {km}គ.ម)៖ {meals}",
          "transport": "ការដឹកជញ្ជូន (ទៅមកកាន់ {dest}, {km}គ.ម)",
          "in-area": "ការធ្វើដំណើរក្នុងតំបន់ — {rate}/ថ្ងៃ × {days} ថ្ងៃ",
          "company-car": "ការដឹកជញ្ជូន — យានយន្តក្រុមហ៊ុន (គ្មានប្រាក់ឧបត្ថម្ភតាមគោលការណ៍ 3.3)",
          "accom-shared": "កន្លែងស្នាក់នៅ (រួម) — {rate}/យប់ × {nights} យប់",
          "accom-dedicated": "កន្លែងស្នាក់នៅ (ផ្ទាល់ខ្លួន) — {rate}/យប់ × {nights} យប់",
          "per-diem-single-half": "ប្រាក់ឧបត្ថម្ភប្រចាំថ្ងៃ ({tier} {label}) — ½ ថ្ងៃ × {rate}/ថ្ងៃ",
          "per-diem-single-full": "ប្រាក់ឧបត្ថម្ភប្រចាំថ្ងៃ ({tier} {label}) — ១ ថ្ងៃ × {rate}/ថ្ងៃ",
          "per-diem-full": "ប្រាក់ឧបត្ថម្ភប្រចាំថ្ងៃ ({label}) — {days} ថ្ងៃពេញ × {rate}/ថ្ងៃ",
          "per-diem-return-half": "ប្រាក់ឧបត្ថម្ភប្រចាំថ្ងៃ — ថ្ងៃត្រឡប់ (មកវិញ {time} ម៉ោងក្នុងស្រុក) — ½ ថ្ងៃ",
          "per-diem-return-full": "ប្រាក់ឧបត្ថម្ភប្រចាំថ្ងៃ — ថ្ងៃត្រឡប់ (មកវិញ {time} ម៉ោងក្នុងស្រុក) — ថ្ងៃពេញ",
          "accom-ceiling": "កន្លែងស្នាក់នៅ (ពិដាន) — {rate}/យប់ × {nights} យប់",
          "airport": "ការដឹកជញ្ជូនអាកាសយានដ្ឋាន (ទៅមក ពិដាន) — {rate} × 2",
          "flight": "ជើងហោះហើរ (ថ្នាក់សេដ្ឋកិច្ច ប៉ាន់ស្មាន)",
          "visa": "ថ្លៃទិដ្ឋាការ",
          "insurance": "ធានារ៉ាប់រងការធ្វើដំណើរ",
          "roaming": "រ៉ូមីង / ស៊ីម (កំណត់ {cap})",
          "baggage": "ឥវ៉ាន់លើស (ទាក់ទងការងារ)"
        },
        "detail": {
          "title": "ព័ត៌មានលម្អិតសំណើធ្វើដំណើរ",
          "foot": "ទម្រង់ទូទាត់ (បុគ្គលិកដាក់ចំណាយជាក់ស្តែង + បង្កាន់ដៃ) នឹងមកក្នុងផ្នែក 2b",
          "approved-b": "បានអនុម័ត",
          "approved": "រង់ចាំការប្រគល់ពីធនធានមនុស្ស។ ប្រគល់សំណើនេះទៅហិរញ្ញវត្ថុសម្រាប់ការបើកប្រាក់បុរេប្រទាន និងការទូទាត់ (បន្តក្នុងម៉ូឌុលហិរញ្ញវត្ថុ · TRV/EXP-FIN)។",
          "with-finance": "បានប្រគល់ទៅហិរញ្ញវត្ថុនៅ {at}។ ផ្ទៀងផ្ទាត់ → បើកប្រាក់ → ទូទាត់ → បញ្ចប់ បន្តក្នុងម៉ូឌុលហិរញ្ញវត្ថុ (TRV/EXP-FIN)។ ប្រតិបត្តិការធនធានមនុស្សលែងមានសកម្មភាពលើកំណត់ត្រានេះទៀតហើយ។",
          "returned-b": "បានត្រឡប់មកវិញ",
          "returned": "ដាក់របាយការណ៍ចំណាយជាមួយបង្កាន់ដៃជាក់ស្តែងក្នុងរយៈពេល {days} ថ្ងៃធ្វើការ។ រាល់ការចំណាយទាក់ទងនឹងការធ្វើដំណើរឥឡូវនេះត្រូវបានផ្ទៀងផ្ទាត់តាមរយៈចំណាយ (ប្រភពតែមួយនៃការពិត)។",
          "submit-exp": "ដាក់របាយការណ៍ចំណាយ →",
          "awaiting-b": "បានដាក់របាយការណ៍ចំណាយ {id}",
          "awaiting": "ជាក់ស្តែង {actual} ធៀបនឹងបុរេប្រទាន {advance}។ រង់ចាំការផ្ទៀងផ្ទាត់ពីហិរញ្ញវត្ថុ។",
          "closed-b": "ដំណើរបានបិទ",
          "closed-1": "បានទូទាត់តាមរបាយការណ៍ចំណាយ",
          "closed-2": "ជាក់ស្តែង {actual} ធៀបនឹងបុរេប្រទាន {advance} →",
          "in-travel": "កំពុងធ្វើដំណើរ។ ត្រឡប់មកវិញ {date}។",
          "disbursed": "ប្រាក់បុរេប្រទាន {amount} បានបើកនៅ {at} តាម {via}។ ដំណើរចាប់ផ្តើម {start}។",
          "trip": "ដំណើរ",
          "advance": "ប្រាក់បុរេប្រទាន",
          "expense-report": "របាយការណ៍ចំណាយ",
          "country": "ប្រទេស",
          "destination": "គោលដៅ",
          "itinerary": "កម្មវិធីដំណើរ",
          "start": "ចាប់ផ្តើម",
          "end": "បញ្ចប់",
          "days": "ថ្ងៃ",
          "return-time": "ម៉ោងត្រឡប់",
          "depart-time": "ម៉ោងចេញដំណើរ",
          "departure-time": "ម៉ោងចាកចេញ",
          "accommodation": "កន្លែងស្នាក់នៅ",
          "nights": "{n} យប់",
          "company-car": "យានយន្តក្រុមហ៊ុន — គ្មានប្រាក់ឧបត្ថម្ភដឹកជញ្ជូន / ក្នុងតំបន់តាមគោលការណ៍ 3.3",
          "client-pays": "អតិថិជនចេញថ្លៃធ្វើដំណើរ — ប្រាក់ឧបត្ថម្ភបេសកកម្មតែប៉ុណ្ណោះ",
          "estimate": "ការប៉ាន់ស្មានសម្រាប់ការអនុញ្ញាត (គោលការណ៍ Optimal P)",
          "estimate-overseas": "ក្រៅប្រទេស — ប្រាក់ឧបត្ថម្ភប្រចាំថ្ងៃ + ពិដានកន្លែងស្នាក់នៅ + ការដឹកជញ្ជូន + ធាតុផ្សេងៗ",
          "estimate-local": "ក្នុងស្រុក — អាហារ + ការដឹកជញ្ជូន + កន្លែងស្នាក់នៅ + ការធ្វើដំណើរក្នុងតំបន់",
          "ceiling": " (ពិដាន — ជាក់ស្តែងត្រូវបានកំណត់)",
          "total-estimate": "ការប៉ាន់ស្មានសរុប",
          "cash-advance": "ប្រាក់បុរេប្រទានសាច់ប្រាក់ ({pct}%)",
          "actual-spent": "ចំណាយជាក់ស្តែង (ពីរបាយការណ៍ចំណាយ",
          "chain-overseas": "ខ្សែសង្វាក់អនុម័ត (អ្នកគ្រប់គ្រង → ប្រធាននាយកដ្ឋាន → នាយក → ហិរញ្ញវត្ថុ)",
          "chain-local": "ខ្សែសង្វាក់អនុម័ត (អ្នកគ្រប់គ្រង → នាយក)",
          "resolve-later": "លំហូរដោះស្រាយការធ្វើដំណើរ — នឹងមកពេលក្រោយ",
          "not-found": "រកមិនឃើញកំណត់ត្រាធ្វើដំណើរ"
        },
        "new": {
          "title": "ការអនុញ្ញាតធ្វើដំណើរថ្មី",
          "subtitle": "ថ្លៃលម្អិតគណនាស្វ័យប្រវត្តិពីគោលការណ៍ Optimal P។ ប្រាក់បុរេប្រទាន {pct}% បើកបន្ទាប់ពីការអនុម័ត។",
          "type": "ប្រភេទការធ្វើដំណើរ៖",
          "local": "ក្នុងស្រុក (កម្ពុជា)",
          "overseas": "ក្រៅប្រទេស",
          "select-province": "— ជ្រើសរើសខេត្ត —",
          "select-country": "— ជ្រើសរើសប្រទេស —",
          "transport": "ដឹកជញ្ជូន",
          "tier-group": "{label} — {perDiem}/ថ្ងៃ · ស្នាក់នៅ {accom}",
          "start": "ថ្ងៃចាប់ផ្តើម",
          "end": "ថ្ងៃបញ្ចប់",
          "depart-origin": "ម៉ោងចេញដំណើរ (ម៉ោងនៅដើមទី)",
          "nights": "ចំនួនយប់",
          "company-car": "ប្រើយានយន្តក្រុមហ៊ុន (គ្មានប្រាក់ឧបត្ថម្ភដឹកជញ្ជូន/ក្នុងតំបន់)",
          "client-pays": "អតិថិជនចេញថ្លៃធ្វើដំណើរ (ប្រាក់ឧបត្ថម្ភបេសកកម្មតែប៉ុណ្ណោះ)",
          "visa": "ថ្លៃទិដ្ឋាការ (USD)",
          "insurance": "ធានារ៉ាប់រង (USD)",
          "roaming": "រ៉ូមីង/ស៊ីម (USD)",
          "baggage": "ឥវ៉ាន់លើស (USD)",
          "flight": "ថ្លៃជើងហោះហើរប៉ាន់ស្មាន (ថ្នាក់សេដ្ឋកិច្ច)",
          "airport": "រួមបញ្ចូលការដឹកជញ្ជូនអាកាសយានដ្ឋានទៅមក (ពិដានតាមកម្រិត)",
          "live": "ការប៉ាន់ស្មានថ្លៃ (ផ្ទាល់)",
          "total": "សរុប៖",
          "pick-dest-hint": "ជ្រើសរើសគោលដៅដើម្បីមើលលម្អិត",
          "pick-country-hint": "ជ្រើសរើសប្រទេសដើម្បីមើលលម្អិត",
          "advance": "ប្រាក់បុរេប្រទានដែលនឹងបើក ({pct}%)៖",
          "purpose-ph": "ឧ. ការទៅជួបអតិថិជនត្រីមាសទី២ — ជួបអតិថិជនសក្តានុពល ៤ នាក់",
          "itinerary": "កម្មវិធីដំណើរ (ស្រេចចិត្ត)",
          "itinerary-ph": "ថ្ងៃទី១៖ ធ្វើដំណើរ + ប្រជុំ។ ថ្ងៃទី២៖ ចុះទីតាំង។ ថ្ងៃទី៣៖ របាយការណ៍ + ត្រឡប់។",
          "policy-note": "រយៈពេលមុនតាមគោលការណ៍៖ ៥ ថ្ងៃធ្វើការ (ក្នុងស្រុក) / ១០ (ក្រៅប្រទេស)។ ខ្សែសង្វាក់អនុម័ត៖ អ្នកគ្រប់គ្រង → នាយក (ក្នុងស្រុក) · អ្នកគ្រប់គ្រង → ប្រធាននាយកដ្ឋាន → នាយក → ហិរញ្ញវត្ថុ (ក្រៅប្រទេស)។ បុគ្គលិកជួលខាងក្រៅបញ្ជូនទៅអ្នកគ្រប់គ្រងខាងក្រៅ។",
          "submitted": "✓ បានដាក់សំណើធ្វើដំណើរ — រង់ចាំការអនុម័តពីអ្នកគ្រប់គ្រង",
          "err": {
            "pick-employee": "⚠ សូមជ្រើសរើសបុគ្គលិក",
            "enter-dates": "⚠ សូមបញ្ចូលកាលបរិច្ឆេទ",
            "purpose": "⚠ ត្រូវការគោលបំណង",
            "pick-dest": "⚠ សូមជ្រើសរើសគោលដៅ",
            "pick-country": "⚠ សូមជ្រើសរើសប្រទេស",
            "end-before-start": "⚠ ថ្ងៃបញ្ចប់មិនអាចមុនថ្ងៃចាប់ផ្តើមទេ"
          }
        },
        "settings": {
          "title": "ការកំណត់ការធ្វើដំណើរ",
          "subtitle": "អត្រាប្រាក់ឧបត្ថម្ភប្រចាំថ្ងៃ % បុរេប្រទាន រយៈពេលមុន និងរយៈពេលទូទាត់ដែលអតិថិជនអាចកំណត់",
          "globals": "ទូទៅ",
          "advance-pct": "% បុរេប្រទាន",
          "advance-pct-hint": "% នៃការប៉ាន់ស្មានបង់ជាមុន",
          "lead-local": "រយៈពេលមុនក្នុងស្រុក (ថ្ងៃ)",
          "lead-overseas": "រយៈពេលមុនក្រៅប្រទេស (ថ្ងៃ)",
          "cancel-return": "ការសងពេលលុបចោល (ថ្ងៃ)",
          "cancel-return-hint": "ចំនួនថ្ងៃដើម្បីសងប្រាក់បុរេប្រទានពេលលុបចោល",
          "clear-local": "រយៈពេលទូទាត់ក្នុងស្រុក",
          "clear-overseas": "រយៈពេលទូទាត់ក្រៅប្រទេស",
          "clear-hint": "ថ្ងៃធ្វើការបន្ទាប់ពីត្រឡប់មកវិញ",
          "local-meals": "ក្នុងស្រុក — អាហារ + ក្នុងតំបន់ + ប្រាក់ឧបត្ថម្ភបេសកកម្ម",
          "breakfast": "អាហារពេលព្រឹក (USD)",
          "lunch": "អាហារថ្ងៃត្រង់ (USD)",
          "dinner": "អាហារពេលល្ងាច (USD)",
          "in-area": "ការធ្វើដំណើរក្នុងតំបន់/ថ្ងៃ",
          "mission-local": "បេសកកម្ម /ថ្ងៃ (អតិថិជនបង់)",
          "destinations": "គោលដៅក្នុងស្រុក ({n})",
          "add-destination": "បន្ថែមគោលដៅ",
          "transport-rt": "ដឹកជញ្ជូន (ទៅមក)",
          "accom-ded": "ស្នាក់នៅ (ផ្ទាល់ខ្លួន)",
          "accom-shr": "ស្នាក់នៅ (រួម)",
          "tiers": "ក្រៅប្រទេស — អត្រាតាមកម្រិត",
          "tier": "កម្រិត",
          "per-diem": "ប្រាក់ឧបត្ថម្ភ/ថ្ងៃ",
          "accom-ceiling": "ពិដានស្នាក់នៅ/យប់",
          "airport": "ការដឹកជញ្ជូនអាកាសយានដ្ឋាន (ម្តងៗ)",
          "mission-overseas": "ប្រាក់ឧបត្ថម្ភបេសកកម្ម (អតិថិជនបង់ ក្រៅប្រទេស)៖",
          "mission-overseas-tail": "ក្នុងមួយថ្ងៃ · កំណត់រ៉ូមីង/ស៊ីម៖ T1–2 $20, T3 $40",
          "countries": "ប្រទេសក្រៅប្រទេស ({n})",
          "add-country": "បន្ថែមប្រទេស",
          "source": "គោលការណ៍ប្រភព៖ គោលការណ៍ធ្វើដំណើរក្នុងស្រុក + ក្រៅប្រទេសរបស់ Optimal P។ ការកែគោលដៅ/ប្រទេសតាមជួរនឹងមកជាមួយការកំណត់អ្នកគ្រប់គ្រងពេញលេញ។",
          "later": "បន្ថែម/កែ/លុប — នឹងមកជាមួយការកំណត់អ្នកគ្រប់គ្រង",
          "refused": "គោលការណ៍ធ្វើដំណើរជាកម្មសិទ្ធិក្រុមហ៊ុន — ការកែសម្រួលត្រូវបានកំណត់សម្រាប់តួនាទីគោលការណ៍កម្រិតក្រុមហ៊ុន (បើកកន្លែងធ្វើការរបស់ក្រុមហ៊ុន)។",
          "saved": "✓ បានរក្សាទុកគោលការណ៍ធ្វើដំណើរទៅកន្លែងធ្វើការរបស់ក្រុមហ៊ុន (មានកាលបរិច្ឆេទមានសុពលភាព)"
        }
      },
      "expenses": {
        "new-claim": "ពាក្យទាមទារថ្មី",
        "empty": "គ្មានពាក្យទាមទារដែលត្រូវនឹងតម្រងនេះទេ។",
        "internal": "ផ្ទៃក្នុង",
        "linked": "ភ្ជាប់ {id}",
        "days-overdue": "ហួសកំណត់ {n} ថ្ងៃ",
        "kind-filter": "ប្រភេទពាក្យទាមទារ",
        "kind": {
          "both": "ទាំងពីរប្រភេទ",
          "advance-only": "បុរេប្រទានតែប៉ុណ្ណោះ",
          "reimb-only": "ការសងវិញតែប៉ុណ្ណោះ"
        },
        "kind-chip": {
          "advance": "បុរេប្រទាន",
          "reimb": "សងវិញ"
        },
        "flows-b": "លំហូរពីរ។",
        "flows-adv-b": "បុរេប្រទាន",
        "flows-adv": "ស្នើបុរេប្រទាន → អ្នកគ្រប់គ្រងអនុម័ត → ហិរញ្ញវត្ថុបើកប្រាក់ → បុគ្គលិកចំណាយ → ដាក់ការទូទាត់ជាមួយបង្កាន់ដៃ → ហិរញ្ញវត្ថុផ្ទៀងផ្ទាត់ → ទូទាត់សមតុល្យ (ទាមទារពី ឬបង់ឱ្យបុគ្គលិក)។",
        "flows-reimb-b": "ការសងវិញ",
        "flows-reimb": "បុគ្គលិកចំណាយផ្ទាល់ → ដាក់បង្កាន់ដៃ → អ្នកគ្រប់គ្រងអនុម័ត → ហិរញ្ញវត្ថុសងវិញតាមបៀវត្សរ៍/សាច់ប្រាក់/ធនាគារ។",
        "flows-tail": "ទាំងពីរអាចភ្ជាប់ទៅគម្រោង និងអាចភ្ជាប់ទៅសំណើធ្វើដំណើរ (TA-xxx)។",
        "kpi": {
          "needs-sub": "{overdue} ហួសកំណត់ · {issue} បញ្ហា",
          "pending-sub": "រង់ចាំការពិនិត្យពីអ្នកគ្រប់គ្រង",
          "advance-sub": "បានបង់ ប៉ុន្តែមិនទាន់ទូទាត់",
          "reimb": "ការសងវិញកំពុងរង់ចាំ",
          "reimb-sub": "បានអនុម័ត ឬរង់ចាំការអនុម័ត"
        },
        "chip": {
          "all": "ទាំងអស់",
          "needs-action": "ត្រូវការសកម្មភាព",
          "pending": "កំពុងរង់ចាំ",
          "approved": "បានអនុម័ត",
          "handed": "បានប្រគល់ទៅហិរញ្ញវត្ថុ",
          "disbursed": "បានបើកប្រាក់",
          "returned": "បានត្រឡប់មកវិញ",
          "clearance-submitted": "បានដាក់ការទូទាត់",
          "clearance-overdue": "ការទូទាត់ហួសកំណត់",
          "reimbursed": "បានសងវិញ",
          "settled": "បានទូទាត់រួច",
          "issue": "បញ្ហា",
          "rejected": "បានបដិសេធ",
          "cancelled": "បានលុបចោល"
        },
        "col": {
          "kind": "ប្រភេទ",
          "purpose": "គោលបំណង / គម្រោង",
          "date": "កាលបរិច្ឆេទ",
          "requested": "បានស្នើ",
          "paid-out": "បានបង់ចេញ",
          "actual": "ជាក់ស្តែង"
        },
        "detail": {
          "title": "ព័ត៌មានលម្អិតពាក្យទាមទារចំណាយ",
          "foot": "សកម្មភាពអនុម័ត / បដិសេធ / ទូទាត់ / សងវិញ នឹងមកក្នុងផ្នែកទី២",
          "resolve-later": "លំហូរដោះស្រាយបញ្ហា — ផ្នែកទី២",
          "clearance-later": "ទម្រង់ទូទាត់ — ផ្នែកទី២",
          "overdue": "ការទូទាត់ហួសកំណត់",
          "overdue-days": "({n} ថ្ងៃ)",
          "overdue-note": "ហួសរយៈពេលទូទាត់ {days} ថ្ងៃធ្វើការ។ អាចត្រូវទាមទារតាមបណ្តាញទូទាត់ដែលបានកំណត់ ប្រសិនបើមិនទូទាត់។",
          "settle": "ទូទាត់",
          "returned": "ការចំណាយបានបញ្ចប់ — ត្រូវទូទាត់ក្នុងរយៈពេល {days} ថ្ងៃធ្វើការ។ សូមដាក់បង្កាន់ដៃជាក់ស្តែង។",
          "clr-submitted": "បានដាក់ការទូទាត់នៅ {at} (ជាក់ស្តែង {amount}) — រង់ចាំការផ្ទៀងផ្ទាត់ពីហិរញ្ញវត្ថុ។",
          "with-finance-chip": "នៅផ្នែកហិរញ្ញវត្ថុ · TRV/EXP-FIN",
          "with-finance-tip": "ការផ្ទៀងផ្ទាត់ហិរញ្ញវត្ថុបន្តក្នុងម៉ូឌុលហិរញ្ញវត្ថុ (TRV/EXP-FIN)",
          "disbursed": "ប្រាក់បុរេប្រទាន {amount} បានបើកនៅ {at} តាម {via}។ ដាក់ការទូទាត់បន្ទាប់ពីចំណាយ។",
          "settled": "បានទូទាត់ — ជាក់ស្តែង {actual} ធៀបនឹងបុរេប្រទាន {advance} → {result} តាម {via}។",
          "reimbursed": "បានសងវិញ {amount} នៅ {at} តាម {via}។",
          "with-finance": "បានប្រគល់ទៅហិរញ្ញវត្ថុនៅ {at}។ ផ្ទៀងផ្ទាត់ → បើកប្រាក់ → ទូទាត់/សងវិញ → បញ្ចប់ បន្តក្នុងម៉ូឌុលហិរញ្ញវត្ថុ (TRV/EXP-FIN)។ ប្រតិបត្តិការធនធានមនុស្សលែងមានសកម្មភាពលើកំណត់ត្រានេះទៀតហើយ។",
          "approved-advance": "ប្រគល់ទៅហិរញ្ញវត្ថុសម្រាប់ការបើកប្រាក់បុរេប្រទាន ({amount}) · បន្តក្នុង TRV/EXP-FIN។",
          "approved-reimb": "ប្រគល់ទៅហិរញ្ញវត្ថុសម្រាប់ការសងវិញ ({amount}) · បន្តក្នុង TRV/EXP-FIN។",
          "authorized-by": "អនុញ្ញាតដោយការធ្វើដំណើរ",
          "clearance-kind": "ប្រភេទទូទាត់ការធ្វើដំណើរ — ផ្ទៀងផ្ទាត់ជាមួយប្រាក់បុរេប្រទានធ្វើដំណើរចំនួន",
          "trip-dates": "កាលបរិច្ឆេទដំណើរ {start} → {end}។",
          "overall": "ទាំងមូល",
          "clearance": "ការទូទាត់",
          "reimbursement": "ការសងវិញ",
          "kind": "ប្រភេទ",
          "kind-advance": "សំណើបុរេប្រទាន",
          "kind-reimb": "ការសងវិញផ្ទាល់",
          "project": "គម្រោង",
          "linked-travel": "ការធ្វើដំណើរដែលភ្ជាប់",
          "amounts": "ចំនួនទឹកប្រាក់",
          "requested-advance": "បុរេប្រទានដែលបានស្នើ",
          "disbursed-lbl": "បានបើកប្រាក់",
          "actual-receipts": "ជាក់ស្តែង (ពីបង្កាន់ដៃ)",
          "reimb-requested": "ការសងវិញដែលបានស្នើ",
          "status": "ស្ថានភាព",
          "paid-on": "បង់នៅ",
          "paid-via": "បង់តាម",
          "line-items": "ធាតុលម្អិត",
          "none-yet": "(មិនទាន់មាន)",
          "line-items-sub": "ជួរនីមួយៗមានគណនី GL ផ្ទាល់ខ្លួន; បង្កាន់ដៃភ្ជាប់ដាច់ដោយឡែក",
          "lines-total": "សរុបជួរ៖",
          "category": "ប្រភេទចំណាយ",
          "description": "ការពិពណ៌នា",
          "receipt": "បង្កាន់ដៃ",
          "amount": "ចំនួនទឹកប្រាក់",
          "has-receipt": "មានបង្កាន់ដៃភ្ជាប់",
          "no-receipt": "គ្មានបង្កាន់ដៃ",
          "no-lines": "មិនទាន់មានធាតុលម្អិតទេ (បុរេប្រទានមិនទាន់ទូទាត់)",
          "chain": "ខ្សែសង្វាក់អនុម័ត",
          "approver-lm": "អ្នកអនុម័ត (អ្នកគ្រប់គ្រង)៖",
          "verified-by": "ការទូទាត់ផ្ទៀងផ្ទាត់ដោយ៖",
          "reimbursed-lbl": "បានសងវិញ៖"
        },
        "new": {
          "title": "ពាក្យទាមទារចំណាយថ្មី",
          "subtitle": "ស្នើបុរេប្រទានជាមុន ឬទាមទារសងវិញបន្ទាប់ពីចំណាយ",
          "type": "ប្រភេទពាក្យទាមទារ៖",
          "link-travel": "ភ្ជាប់ទៅសំណើធ្វើដំណើរ (ស្រេចចិត្ត)",
          "none": "— គ្មាន —",
          "purpose-ph": "ឧ. អាហារពេលល្ងាចទទួលភ្ញៀវអតិថិជនសក្តានុពល Acme",
          "advance-request": "សំណើបុរេប្រទាន",
          "requested-amount": "ចំនួនទឹកប្រាក់ស្នើ (USD)",
          "advance-note": "បន្ទាប់ពីការអនុម័ត ហិរញ្ញវត្ថុបើក {pct}% នៃចំនួននេះ។ អ្នកដាក់ការទូទាត់ជាមួយបង្កាន់ដៃជាក់ស្តែងបន្ទាប់ពីចំណាយ។",
          "reimb-lines": "ការសងវិញ — ធាតុលម្អិត",
          "add-line": "បន្ថែមជួរ",
          "remove-line": "លុបជួរ",
          "line-ph": "ចំណាយនេះសម្រាប់អ្វី?",
          "amount-usd": "ចំនួនទឹកប្រាក់ (USD)",
          "total-reimburse": "សរុបត្រូវសងវិញ៖",
          "routing-note": "ការអនុម័តបញ្ជូនទៅអ្នកគ្រប់គ្រងផ្ទាល់របស់អ្នក (ឬអ្នកគ្រប់គ្រងខាងក្រៅសម្រាប់បុគ្គលិកជួលខាងក្រៅ)។ ហិរញ្ញវត្ថុផ្ទៀងផ្ទាត់ និងបង់/បើកប្រាក់បន្ទាប់ពីអ្នកគ្រប់គ្រងអនុម័ត។",
          "linked-to": "ភ្ជាប់ទៅ {id}",
          "linked-note": "បានបំពេញជាមុនជាមួយការបែងចែកប្រាក់ឧបត្ថម្ភប៉ាន់ស្មានតាមគោលការណ៍។ កែជួរនីមួយៗឱ្យត្រូវនឹងបង្កាន់ដៃជាក់ស្តែង។ បុរេប្រទានសម្រាប់ផ្ទៀងផ្ទាត់៖",
          "clearance-purpose": "ការទូទាត់ការធ្វើដំណើរសម្រាប់ {id} {dest}",
          "submitted": "✓ បានដាក់ពាក្យទាមទារ — រង់ចាំការអនុម័តពីអ្នកគ្រប់គ្រង",
          "err": {
            "pick-employee": "⚠ សូមជ្រើសរើសបុគ្គលិក",
            "purpose": "⚠ ត្រូវការគោលបំណង",
            "advance-amount": "⚠ ចំនួនបុរេប្រទានត្រូវតែ > 0",
            "add-line": "⚠ បន្ថែមធាតុលម្អិតយ៉ាងហោចណាស់មួយដែលមានចំនួនទឹកប្រាក់"
          }
        },
        "settings": {
          "title": "ការកំណត់ចំណាយ",
          "subtitle": "ប្រភេទចំណាយ កម្រិតអនុម័ត គោលការណ៍បុរេប្រទាន/សងវិញ ច្បាប់បង្កាន់ដៃ ការជូនដំណឹង គម្រោង និងរូបិយប័ណ្ណ ដែលអតិថិជនអាចកំណត់",
          "tab": {
            "cats": "ប្រភេទចំណាយ",
            "approval": "កម្រិតអនុម័ត",
            "policy": "បុរេប្រទាន / សងវិញ",
            "receipt": "ច្បាប់បង្កាន់ដៃ",
            "notif": "ការជូនដំណឹង",
            "projects": "គម្រោង",
            "fx": "រូបិយប័ណ្ណ / អត្រាប្តូរប្រាក់"
          },
          "categories": "ប្រភេទចំណាយ ({n})",
          "categories-sub": "គ្រប់គ្រងស្លាក គណនី GL ដែនកំណត់តាមប្រភេទ កម្រិតបង្កាន់ដៃ (−1 = ប្រើសកល) និងវិធីបង់ប្រាក់លំនាំដើម",
          "add-category": "បន្ថែមប្រភេទ",
          "new-category": "ប្រភេទថ្មី",
          "remove-category-confirm": "លុបប្រភេទនេះ? (ពាក្យទាមទារចាស់រក្សាឯកសារយោងរបស់ពួកវា)",
          "receipt-inherit": "-1 = ប្រើកម្រិតសកល",
          "categories-note": "ការបិទប្រភេទរក្សាប្រវត្តិ។ ដែនកំណត់ជាជម្រើស (ទទេ = គ្មានដែនកំណត់)។ កម្រិតបង្កាន់ដៃ −1 មានន័យថាទទួលយកតម្លៃសកល ({amount})។",
          "col": {
            "label": "ស្លាក",
            "active": "សកម្ម",
            "cap": "ដែនកំណត់ (USD)",
            "receipt": "បង្កាន់ដៃ ≥",
            "method": "វិធីលំនាំដើម",
            "project": "ឈ្មោះគម្រោង",
            "budget": "ដែនកំណត់ថវិកា (USD)",
            "claimants": "អ្នកទាមទារដែលអនុញ្ញាត"
          },
          "tiered": "ការអនុម័តតាមកម្រិតចំនួនទឹកប្រាក់",
          "tiered-sub": "អ្នកអនុម័តដែលត្រូវការផ្អែកលើចំនួនសរុបនៃពាក្យទាមទារ។",
          "up-to": "រហូតដល់ (USD)",
          "required": "អ្នកអនុម័តដែលត្រូវការ",
          "tier-n": "កម្រិត {n}",
          "no-upper": "គ្មានដែនកំណត់ខាងលើ",
          "add-tier": "បន្ថែមកម្រិត",
          "overrides": "ការបដិសេធតាមប្រភេទ",
          "overrides-sub": "តែងតែទាមទារអ្នកអនុម័តទាំងនេះសម្រាប់ប្រភេទ ដោយមិនគិតពីចំនួនទឹកប្រាក់ (បន្ថែមលើកម្រិត)។",
          "override-approvers": "អ្នកអនុម័តបដិសេធ (បន្ថែម)",
          "role": {
            "LM": "អ្នកគ្រប់គ្រងផ្ទាល់",
            "DH": "ប្រធាននាយកដ្ឋាន",
            "MD": "នាយកគ្រប់គ្រង",
            "FIN": "ហិរញ្ញវត្ថុ"
          },
          "advance-policy": "គោលការណ៍បុរេប្រទាន",
          "adv-pct": "% បុរេប្រទាននៃសំណើ",
          "adv-pct-hint": "% នៃចំនួនស្នើដែលបានបើក",
          "max-adv": "បុរេប្រទានអតិបរមាក្នុងមួយសំណើ",
          "max-adv-hint": "ពិដាន USD ក្នុងមួយសំណើ",
          "clr-window": "រយៈពេលទូទាត់ (ថ្ងៃ)",
          "clr-window-hint": "ថ្ងៃធ្វើការបន្ទាប់ពីចំណាយ",
          "overdue": "កម្រិតហួសកំណត់ (ថ្ងៃ)",
          "overdue-hint": "ចំនួនថ្ងៃហួសរយៈពេលមុនត្រូវបានសម្គាល់",
          "max-conc": "បុរេប្រទានព្រមគ្នាអតិបរមាក្នុងមួយបុគ្គលិក",
          "auto-recover": "ទាមទារបុរេប្រទានហួសកំណត់ដោយស្វ័យប្រវត្តិតាមបៀវត្សរ៍បន្ទាប់",
          "reimb-policy": "គោលការណ៍សងវិញ",
          "reimb-target": "គោលដៅថ្ងៃសងវិញ",
          "reimb-target-hint": "ពីការដាក់ស្នើដល់ការបង់",
          "monthly-cap": "ដែនកំណត់ទាមទារប្រចាំខែក្នុងមួយបុគ្គលិក",
          "def-method": "វិធីបង់ប្រាក់លំនាំដើម",
          "allowed-methods": "វិធីបង់ប្រាក់ដែលអនុញ្ញាត",
          "receipt-thresh": "កម្រិតបង្កាន់ដៃចាំបាច់ (USD)",
          "receipt-thresh-hint": "ជួរណាមួយ ≥ នេះទាមទារបង្កាន់ដៃ",
          "receipt-max": "ទំហំឯកសារអតិបរមា (MB)",
          "formats": "ទម្រង់ឯកសារដែលអនុញ្ញាត",
          "ocr": "បើកការទាញយកស្វ័យប្រវត្តិ OCR សម្រាប់បង្កាន់ដៃ",
          "ocr-later": "(នឹងមកជាមួយ v7)",
          "receipt-note": "កម្រិតបង្កាន់ដៃតាមប្រភេទបដិសេធតម្លៃសកល។ កំណត់កម្រិតរបស់ប្រភេទទៅ −1 ដើម្បីទទួលយកការកំណត់សកលនេះ។",
          "lm-mode": "របៀបជូនដំណឹងអ្នកគ្រប់គ្រង",
          "immediate": "ភ្លាមៗ (ជូនដំណឹង + អ៊ីមែល)",
          "digest": "សង្ខេបប្រចាំថ្ងៃ (អ៊ីមែលមួយក្នុងមួយថ្ងៃ)",
          "overdue-every": "ការរំលឹកហួសកំណត់ (រៀងរាល់ N ថ្ងៃ)",
          "escalate": "បញ្ជូនទៅនាយកពេលហួសកំណត់ > (ថ្ងៃ)",
          "notify-approve": "ជូនដំណឹងបុគ្គលិកពេលពាក្យទាមទារត្រូវបានអនុម័ត",
          "notify-reject": "ជូនដំណឹងបុគ្គលិកពេលពាក្យទាមទារត្រូវបានបដិសេធ (មានមូលហេតុ)",
          "projects": "គម្រោង ({n})",
          "projects-sub": "គ្រប់គ្រងបញ្ជីគម្រោង ដែនកំណត់ថវិកា (ទទេ = គ្មានកំណត់) និងអ្នកទាមទារដែលមានសិទ្ធិ",
          "add-project": "បន្ថែមគម្រោង",
          "new-project": "គម្រោងថ្មី",
          "remove-project-confirm": "លុបគម្រោងនេះ?",
          "projects-note": "ការបិទរក្សាប្រវត្តិ។ \"អ្នកទាមទារដែលអនុញ្ញាត\" អាចជា \"All\" ឬការពិពណ៌នាសេរី (ការជ្រើសរើសបុគ្គលិកនឹងមកក្នុងការកំណត់អ្នកគ្រប់គ្រង)។",
          "fx-title": "រូបិយប័ណ្ណ និងអត្រាប្តូរប្រាក់",
          "base-currency": "រូបិយប័ណ្ណមូលដ្ឋាន",
          "fx-source": "ប្រភពអត្រាប្តូរប្រាក់",
          "fx-nbc": "NBC ប្រចាំថ្ងៃ (កម្ពុជា)",
          "fx-open": "OpenExchange Rates API",
          "fx-manual": "បញ្ចូលដោយដៃតាមពាក្យទាមទារ",
          "multi-currency": "ទទួលពាក្យទាមទាររូបិយប័ណ្ណច្រើន",
          "accepted": "រូបិយប័ណ្ណដែលទទួល (សម្រាប់ការបញ្ចូលពាក្យទាមទារ)",
          "fx-note": "ពាក្យទាមទារមិនមែនរូបិយប័ណ្ណមូលដ្ឋានត្រូវបានប្តូរតាមអត្រានៅថ្ងៃទាមទារ។ ប្រសិនបើជ្រើស \"ដោយដៃ\" បុគ្គលិកបញ្ចូលអត្រាតាមជួរ។",
          "gov-readonly": "គោលការណ៍ជាកម្មសិទ្ធិក្រុមហ៊ុន — អានបានតែប៉ុណ្ណោះនៅទីនេះ ({history})។ កែក្នុងកន្លែងធ្វើការរបស់ក្រុមហ៊ុនដោយមានតួនាទីគោលការណ៍។",
          "gov-version": "· មានសុពលភាព {eff} ({at})",
          "gov-none": "គ្មានកំណែបានរក្សាទុក",
          "refused": "គោលការណ៍ចំណាយជាកម្មសិទ្ធិក្រុមហ៊ុន — ការកែសម្រួលត្រូវបានកំណត់សម្រាប់តួនាទីគោលការណ៍កម្រិតក្រុមហ៊ុន (បើកកន្លែងធ្វើការរបស់ក្រុមហ៊ុន)។",
          "saved": "✓ បានរក្សាទុកគោលការណ៍ចំណាយទៅកន្លែងធ្វើការរបស់ក្រុមហ៊ុន (មានកាលបរិច្ឆេទមានសុពលភាព)"
        }
      },
      "approvals": {
        "title-oversight": "ការអនុម័ត — ការត្រួតពិនិត្យធនធានមនុស្ស",
        "title-queue": "ជួររបស់ខ្ញុំ",
        "acting-as": "(ធ្វើការជំនួស {name})",
        "sub-oversight": "ទិដ្ឋភាពទូទាំងក្រុមហ៊ុនលើអ្នកអនុម័តទាំងអស់។ រំលឹក បដិសេធ ឬចូលទៅក្នុងជួរ។",
        "sub-queue": "ធាតុដែលបានបញ្ជូនទៅ {who} សម្រាប់ការអនុម័តផ្ទាល់។ ចុចជួរណាមួយដើម្បីមើលលម្អិត។",
        "you": "អ្នក",
        "view": {
          "oversight": "ការត្រួតពិនិត្យ",
          "queue": "ជួររបស់ខ្ញុំ"
        },
        "kpi": {
          "total": "សរុបកំពុងរង់ចាំ",
          "total-sub": "លើអ្នកអនុម័ត {n} នាក់",
          "aging": "ចាស់ជាង ៥ ថ្ងៃ",
          "aging-sub": "{mid} ទៀតក្នុងចន្លោះ ៣–៥ ថ្ងៃ · {fresh} ថ្មី (≤២ ថ្ងៃ)",
          "blocking": "រារាំងបៀវត្សរ៍",
          "blocking-sub": "វត្តមាន + ម៉ោងបន្ថែម — ត្រូវដោះស្រាយមុនថ្ងៃផុតកំណត់",
          "external": "អ្នកគ្រប់គ្រងខាងក្រៅ",
          "external-sub": "អ្នកអនុម័តខាងអតិថិជនដែលមានធាតុរង់ចាំ"
        },
        "kind": {
          "all": "ទាំងអស់",
          "attendance": "វត្តមាន",
          "leave": "ច្បាប់ឈប់សម្រាក",
          "overtime": "ម៉ោងបន្ថែម",
          "travel": "ការធ្វើដំណើរ",
          "expense": "ចំណាយ"
        },
        "initial": {
          "attendance": "វ",
          "leave": "ច",
          "overtime": "ម",
          "travel": "ដ",
          "expense": "ណ"
        },
        "by-approver": "កំពុងរង់ចាំតាមអ្នកអនុម័ត ({n})",
        "by-approver-sub": "តម្រៀបតាមធាតុរង់ចាំចាស់បំផុត។ ការរំលឹកជូនដំណឹងអ្នកគ្រប់គ្រង; ធ្វើការជំនួសអនុញ្ញាតឱ្យអ្នកដោះស្រាយជួររបស់ពួកគេ។",
        "all-items": "ធាតុរង់ចាំទាំងអស់ ({n})",
        "all-items-sub": "ចុចជួរដើម្បីមើលសំណើពេញលេញ។ ប្រើការបដិសេធតែពេលអ្នកគ្រប់គ្រងមិនអាចទាក់ទងបាន ហើយថ្ងៃផុតកំណត់មានហានិភ័យ។",
        "col": {
          "approver": "អ្នកអនុម័ត",
          "count": "ចំនួន",
          "avg-age": "អាយុមធ្យម",
          "oldest": "ចាស់បំផុត",
          "kinds": "ប្រភេទ",
          "actions": "សកម្មភាព",
          "kind": "ប្រភេទ",
          "summary": "សេចក្តីសង្ខេប",
          "amount": "ចំនួនទឹកប្រាក់",
          "age": "អាយុ",
          "submitted": "បានដាក់ស្នើ"
        },
        "internal-lm": "អ្នកគ្រប់គ្រងផ្ទៃក្នុង",
        "external-lm": "អ្នកគ្រប់គ្រងខាងក្រៅ",
        "self-approval": "អនុម័តដោយខ្លួនឯង",
        "self-short": "ខ្លួនឯង (MD)",
        "external": "ខាងក្រៅ",
        "chase": "រំលឹក",
        "chase-aria": "រំលឹក {name}",
        "chased": "📲 បានផ្ញើការរំលឹកទៅ {name} — បានកត់ត្រាការរំលឹក",
        "act-as": "ធ្វើការជំនួស",
        "act-as-aria": "ធ្វើការជំនួស {name}",
        "acting": "កំពុងធ្វើការជំនួស {name} — ទិដ្ឋភាពបង្ហាញជួររបស់ពួកគេ",
        "exited": "បានចាកចេញពីរបៀបធ្វើការជំនួស",
        "acting-banner-1": "កំពុងធ្វើការជំនួស",
        "acting-banner-2": "— កំពុងមើលជួរផ្ទាល់ខ្លួនរបស់ពួកគេ។ សកម្មភាពអនុម័ត/បដិសេធនៅទីនេះត្រូវបានកត់ត្រាជាធនធានមនុស្សធ្វើជំនួស។",
        "exit-act-as": "ចាកចេញពីការធ្វើជំនួស",
        "none": "គ្មានធាតុរង់ចាំទេ",
        "queue-empty": "ជួរផ្ទាល់ខ្លួនរបស់អ្នកទទេ។ ប្តូរទៅការត្រួតពិនិត្យដើម្បីមើលទិដ្ឋភាពទូទាំងក្រុមហ៊ុន។",
        "view-btn": "មើល",
        "view-aria": "មើល {id}",
        "override": "បដិសេធ",
        "override-tip": "ធនធានមនុស្សអនុម័តបដិសេធជាមួយមូលហេតុ",
        "override-aria": "អនុម័តបដិសេធ {id}",
        "override-prompt": "ការបដិសេធរបស់ធនធានមនុស្ស — សូមផ្តល់មូលហេតុ (ចាំបាច់)៖",
        "override-cancelled": "⚠ បានបោះបង់ការបដិសេធ — ត្រូវការមូលហេតុ",
        "override-approved": "✓ {kind} {id} បានអនុម័តតាមការបដិសេធរបស់ធនធានមនុស្ស",
        "approve": "អនុម័ត",
        "approve-aria": "អនុម័ត {id}",
        "reject": "បដិសេធ",
        "reject-aria": "បដិសេធ {id}",
        "reject-prompt": "មូលហេតុនៃការបដិសេធ (ចាំបាច់)៖",
        "reject-cancelled": "⚠ បានបោះបង់ការបដិសេធ — ត្រូវការមូលហេតុ",
        "owning-only": "វិសាលភាពម្ចាស់តែប៉ុណ្ណោះ",
        "owning-only-tip": "ការសម្រេចចិត្តកើតឡើងនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យអានបានតែប៉ុណ្ណោះ",
        "ago": "{n} ថ្ងៃមុន",
        "days": "{n} ថ្ងៃ",
        "persona-b": "កំណត់ចំណាំតួនាទី៖",
        "persona-note": "តួនាទីធនធានមនុស្សចាប់ផ្តើមនៅការត្រួតពិនិត្យ; អ្នកគ្រប់គ្រងចាប់ផ្តើមនៅជួររបស់ខ្ញុំ។ ប្រើកុងតាក់នៅខាងស្តាំលើដើម្បីប្តូរ។ ធនធានមនុស្សក៏អាចធ្វើការជំនួសអ្នកអនុម័តណាមួយពីការត្រួតពិនិត្យដើម្បីដោះស្រាយការងារកកស្ទះ (ឧ. អ្នកគ្រប់គ្រងឈប់សម្រាក)។",
        "issue": {
          "missed-out": "ភ្លេចចុះម៉ោងចេញ",
          "absent": "អវត្តមាន",
          "wrong-location": "ទីតាំងខុស",
          "system-error": "កំហុសប្រព័ន្ធ"
        },
        "exp-kind": {
          "advance": "បុរេប្រទាន",
          "reimbursement": "សងវិញ",
          "clearance": "ទូទាត់ធ្វើដំណើរ"
        },
        "ar": {
          "title": "សំណើ {id} · {name}",
          "resolved-on": "បានដោះស្រាយនៅ {at}",
          "returned-on": "បានបញ្ជូនត្រឡប់នៅ {at}",
          "submitted": "បានដាក់ស្នើ {at} · រង់ចាំអ្នកគ្រប់គ្រង",
          "details": "ព័ត៌មានលម្អិតសំណើ",
          "org-unit": "អង្គភាព",
          "type": "ប្រភេទ",
          "date": "កាលបរិច្ឆេទរងផលប៉ះពាល់",
          "clock-in": "ចុះម៉ោងចូល",
          "clock-out": "ចុះម៉ោងចេញ",
          "location": "ទីតាំង",
          "routes-to": "បញ្ជូនទៅ",
          "escalates": "បញ្ជូនទៅធនធានមនុស្ស",
          "reason": "មូលហេតុ",
          "history": "ប្រវត្តិសវនកម្ម ({n})",
          "no-history": "គ្មានប្រវត្តិ។",
          "by": "ដោយ",
          "foot": "សំណើ {id} · {status}"
        }
      },
      "sched": {
        "all-companies": "ក្រុមហ៊ុនទាំងអស់",
        "yes": "បាទ/ចាស",
        "no": "ទេ",
        "edit": "កែសម្រួល",
        "edit-named": "កែសម្រួល {name}",
        "view": "មើល",
        "view-named": "មើល {name}",
        "deactivate": "បិទដំណើរការ",
        "deactivate-named": "បិទដំណើរការ {name}",
        "activate": "បើកដំណើរការ",
        "archive": "ទុកក្នុងបណ្ណសារ",
        "archive-named": "ទុក {name} ក្នុងបណ្ណសារ",
        "more": "ច្រើនទៀត",
        "more-named": "សកម្មភាពបន្ថែមសម្រាប់ {name}",
        "duplicate": "ចម្លង / ក្លូន",
        "history": "មើលប្រវត្តិកំណែ",
        "coming-soon-history": "ប្រវត្តិកំណែ — នឹងមកដល់ឆាប់ៗ",
        "save": "រក្សាទុក",
        "create": "បង្កើត",
        "close": "បិទ",
        "saving": "កំពុងរក្សាទុក…",
        "loading": "កំពុងផ្ទុកទិន្នន័យកាលវិភាគ…",
        "no-data": "មិនទាន់មានទិន្នន័យកាលវិភាគសម្រាប់វិសាលភាពនេះនៅឡើយ។",
        "confirm-remove": "លុប \"{name}\" មែនទេ?",
        "col": {
          "actions": "សកម្មភាព",
          "edit": "កែសម្រួល"
        },
        "drawer": {
          "close": "បិទ",
          "cancel": "បោះបង់"
        },
        "status": {
          "Active": "សកម្ម",
          "Inactive": "អសកម្ម",
          "Draft": "សេចក្តីព្រាង",
          "Archived": "បានទុកក្នុងបណ្ណសារ"
        },
        "group": {
          "Fixed": "ថេរ",
          "Rotation": "វេនបង្វិល",
          "Flexible": "បត់បែន"
        },
        "toast": {
          "select-company": "សូមជ្រើសរើសកន្លែងធ្វើការរបស់ក្រុមហ៊ុន។",
          "no-permission-coverage": "គ្មានសិទ្ធិគ្រប់គ្រងការគ្របដណ្តប់នៅទីនេះទេ។",
          "oversight": "ប្រតិបត្តិការតារាងវេនធ្វើនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺអានបានតែប៉ុណ្ណោះ។"
        },
        "nav": {
          "label": "កាលវិភាគ",
          "dashboard": "ផ្ទាំងគ្រប់គ្រង",
          "setup": "ការរៀបចំ",
          "templates": "គំរូ",
          "schedules": "កាលវិភាគការងារ",
          "planning": "ការធ្វើផែនការ",
          "coverage": "ផែនការគ្របដណ្តប់",
          "pools": "ក្រុមបុគ្គលិក",
          "rosters": "តារាងវេន",
          "roster": "កន្លែងធ្វើតារាងវេន",
          "all": "តារាងវេនទាំងអស់"
        },
        "tpl": {
          "shifts": "វេន",
          "patterns": "លំនាំការងារ",
          "meals": "ពេលសម្រាកអាហារ",
          "holidays": "ថ្ងៃឈប់សម្រាក",
          "rules": "ច្បាប់ និងគោលការណ៍"
        },
        "new": {
          "schedule": "កាលវិភាគថ្មី",
          "coverage": "ផែនការគ្របដណ្តប់ថ្មី",
          "shift": "វេនថ្មី",
          "pattern": "លំនាំការងារថ្មី",
          "meal": "ពេលសម្រាកអាហារថ្មី",
          "holiday": "ថ្ងៃឈប់សម្រាកថ្មី",
          "rule": "ច្បាប់ / គោលការណ៍ថ្មី"
        },
        "dash": {
          "title": "ផ្ទាំងគ្រប់គ្រង",
          "sub": "ស្ថានភាពកាលវិភាគសម្រាប់ {company} — ផ្ទាល់ពីបណ្ណាល័យ ការដំណើរការ និងតារាងវេនដែលបានផ្សព្វផ្សាយរបស់ក្រុមហ៊ុននេះ។",
          "fixed": "កាលវិភាគថេរ",
          "fixed-sub": "លំនាំច័ន្ទ–សុក្រ ការិយាល័យខាងក្រោយ",
          "on-fixed": "បុគ្គលិកកាលវិភាគថេរ",
          "unassigned": "មិនទាន់កំណត់កាលវិភាគ",
          "unassigned-tip": "សេវាកាលវិភាគមិនទាន់រាយការណ៍ពីបុគ្គលិកដែលមិនទាន់កំណត់កាលវិភាគនៅឡើយ។",
          "flex": "កាលវិភាគបត់បែន",
          "flex-sub": "ផ្អែកលើវត្តមាន ម៉ោងសរុប",
          "on-flex": "បុគ្គលិកកាលវិភាគបត់បែន",
          "hours": "ម៉ោង",
          "hours-att": "តាមដានក្នុងវត្តមាន",
          "rot": "កាលវិភាគវេនបង្វិល",
          "rot-sub": "វេន 24/7 ត្រូវការតារាងវេន",
          "on-rot": "បុគ្គលិកវេនបង្វិល",
          "coverage": "ការគ្របដណ្តប់",
          "gaps-runs": "ចន្លោះនៅសល់ / ការដំណើរការមិនទាន់ផ្សព្វផ្សាយ",
          "rot-gaps": "វេនបង្វិល — ចន្លោះតារាងវេន និងការគ្របដណ្តប់",
          "by-plan": "ការគ្របដណ្តប់តាមផែនការ ({company})",
          "no-roster": "— មិនទាន់មានតារាងវេន",
          "no-plans": "មិនទាន់មានផែនការគ្របដណ្តប់ក្នុងក្រុមហ៊ុននេះទេ — បង្កើតមួយក្នុងផែនការគ្របដណ្តប់។",
          "attention": "តារាងវេនដែលត្រូវយកចិត្តទុកដាក់",
          "no-inflight": "គ្មានតារាងវេនកំពុងដំណើរការទេ — ទាំងអស់បានផ្សព្វផ្សាយ ឬមិនទាន់ចាប់ផ្តើម។",
          "open-roster": "បើកកន្លែងធ្វើតារាងវេន"
        },
        "shift": {
          "kpi": {
            "shifts": "វេន",
            "day": "វេនថ្ងៃ",
            "night": "វេនយប់",
            "cross": "ឆ្លងកាត់អធ្រាត្រ"
          },
          "note": "មេវេនប្រើឡើងវិញបាន — ប្រើដោយកាលវិភាគ និង (ក្រោយមក) លំនាំវេនបង្វិល · ការធ្វើផែនការគ្របដណ្តប់ · តារាងវេនស្វ័យប្រវត្តិ។ ថ្ងៃ/យប់ ត្រូវបានគណនាពីម៉ោង មិនមែនកំណត់ដោយដៃទេ។",
          "col": {
            "shift": "វេន",
            "start": "ចាប់ផ្តើម",
            "end": "បញ្ចប់",
            "duration": "រយៈពេល",
            "cross": "ឆ្លងកាត់អធ្រាត្រ",
            "night": "ម៉ោងយប់"
          },
          "empty": "មិនទាន់កំណត់វេនសម្រាប់ក្រុមហ៊ុននេះទេ។ ចុច {cta}។",
          "cta": "+ វេនថ្មី",
          "break": "សម្រាក៖ {name}",
          "new": "វេនថ្មី",
          "edit": "កែសម្រួលវេន",
          "subtitle": "{company} · មេវេនប្រើឡើងវិញបាន",
          "create": "បង្កើតវេន",
          "save": "រក្សាទុកវេន",
          "sec": {
            "info": "1 · ព័ត៌មានវេន",
            "hours": "2 · ម៉ោងធ្វើការ",
            "indicators": "3 · សូចនាករប្រព័ន្ធ (អានបានតែប៉ុណ្ណោះ)",
            "notes": "4 · កំណត់ចំណាំ"
          },
          "f": {
            "name": "ឈ្មោះវេន",
            "name-ph": "ឧ. ព្រឹក យប់ ជំនួស",
            "code": "លេខកូដវេន (ស្វ័យប្រវត្តិ)",
            "code-empty": "— បង្កើតពីឈ្មោះ —",
            "code-hint": "បង្កើតពីឈ្មោះ។ មិនអាចកែបានទេ។",
            "start": "ម៉ោងចាប់ផ្តើម",
            "end": "ម៉ោងបញ្ចប់",
            "meal": "ពេលសម្រាកអាហារ",
            "meal-none": "— គ្មាន —"
          },
          "ind": {
            "duration": "រយៈពេល",
            "cross": "ឆ្លងកាត់អធ្រាត្រ",
            "night": "ម៉ោងយប់ (22:00–06:00)",
            "full": "ចាប់ផ្តើម = បញ្ចប់ → វេន 24 ម៉ោងពេញ (អតិបរមា)។ ផ្គូផ្គងវាជាមួយថ្ងៃសម្រាកក្នុងលំនាំវេនបង្វិល។",
            "hint": "គណនាស្វ័យប្រវត្តិពីម៉ោងចាប់ផ្តើម/បញ្ចប់។ ម៉ោងប្រចាំសប្តាហ៍ វដ្តបង្វិល និងការគ្របដណ្តប់ ត្រូវកំណត់ក្រោយដោយកាលវិភាគ / វេនបង្វិល មិនមែនមេវេនទេ។"
          },
          "required": "សូមបំពេញវាលដែលត្រូវការ (ឈ្មោះ ចាប់ផ្តើម បញ្ចប់)។",
          "dur-tag": {
            "full": "ការងារ 24 ម៉ោងពេញ",
            "extended": "ការងារបន្ថែមរយៈពេល",
            "long": "វេនវែង"
          },
          "usage": {
            "named": "លំនាំការងារ {count}៖ {names}",
            "count": "លំនាំការងារ {count}"
          },
          "confirm": {
            "edit-title": "រក្សាទុកការផ្លាស់ប្តូរលើវេនដែលកំពុងប្រើ?",
            "edit-body": "“{name}” កំពុងត្រូវបានប្រើដោយ {patterns}។ ការរក្សាទុកនឹងផ្លាស់ប្តូរផែនការរបស់បុគ្គលិក {employees} នាក់ដែលនៅលើលំនាំទាំងនោះ រួមទាំងថ្ងៃកន្លងមក។",
            "remove-title": "បិទដំណើរការវេន?",
            "remove-body": "បិទដំណើរការ “{name}” មែនទេ? វានឹងត្រូវលាក់ពីបញ្ជី ហើយមិនអាចបន្ថែមទៅក្នុងលំនាំការងារបានទៀតទេ។",
            "remove-body-used": "បិទដំណើរការ “{name}” មែនទេ? វាកំពុងត្រូវបានប្រើដោយ {patterns} (បុគ្គលិក {employees} នាក់)។ លំនាំទាំងនោះនៅតែប្រើវាបន្ត ប៉ុន្តែវាមិនអាចបន្ថែមទៅក្នុងលំនាំការងារបានទៀតទេ។"
          },
          "conflict-reload": "បញ្ជីត្រូវបានធ្វើឱ្យទាន់សម័យហើយ — បិទផ្ទាំងនេះ ហើយបើកវេនម្តងទៀត ដើម្បីកែសម្រួលកំណែចុងក្រោយ។"
        },
        "rule": {
          "kpi": {
            "total": "ច្បាប់ និងគោលការណ៍",
            "coverage": "ច្បាប់គ្របដណ្តប់",
            "safety": "ច្បាប់សុវត្ថិភាព",
            "mode": "របៀប"
          },
          "advisory": "ប្រឹក្សា",
          "note": "ច្បាប់ប្រឹក្សាបង្ហាញជា {warnings} និង {alerts} (ប្រតិបត្តិការ) មិនមែនការរារាំងដាច់ខាតទេ។",
          "note-warnings": "ការព្រមានតារាងវេន",
          "note-alerts": "ការជូនដំណឹងការគ្របដណ្តប់",
          "col": {
            "rule": "ច្បាប់ / គោលការណ៍",
            "setting": "ការកំណត់",
            "used-for": "ប្រើសម្រាប់"
          },
          "empty": "មិនទាន់កំណត់ច្បាប់សម្រាប់ក្រុមហ៊ុននេះទេ។",
          "new": "ច្បាប់ / គោលការណ៍ថ្មី",
          "edit": "កែសម្រួលច្បាប់ / គោលការណ៍",
          "f": {
            "name": "ឈ្មោះច្បាប់",
            "kind": "ប្រភេទច្បាប់",
            "value": "តម្លៃ",
            "value-ph": "ឧ. 10 ម៉ោង",
            "status": "ស្ថានភាព",
            "used-for": "ប្រើសម្រាប់",
            "used-for-ph": "ឧ. ការផ្ទៀងផ្ទាត់តារាងវេន",
            "notes": "កំណត់ចំណាំ"
          },
          "advisory-note": "សម្រាប់ប្រឹក្សាតែប៉ុណ្ណោះ — នឹងបង្ហាញជាការព្រមានតារាងវេន / ការជូនដំណឹងការគ្របដណ្តប់ពេលក្រោយ។ គ្មានម៉ាស៊ីនអនុវត្តក្នុងកំណែនេះទេ។",
          "required": "ត្រូវការឈ្មោះច្បាប់។",
          "kind": {
            "min_rest": "ម៉ោងសម្រាកអប្បបរមា",
            "max_consec": "ថ្ងៃជាប់គ្នាអតិបរមា",
            "night_elig": "សិទ្ធិធ្វើវេនយប់",
            "ot_holiday": "ម៉ោងបន្ថែម / ថ្ងៃឈប់សម្រាក",
            "coverage": "តម្រូវការគ្របដណ្តប់"
          }
        },
        "pattern": {
          "count": "លំនាំការងារ {n} — លំដាប់វេនថេរ ឬវេនបង្វិល ប្រើដោយកាលវិភាគការងារ / ការធ្វើផែនការគ្របដណ្តប់ / តារាងវេនស្វ័យប្រវត្តិ។",
          "col": {
            "pattern": "លំនាំ",
            "cycle": "វដ្ត",
            "work-rest": "ធ្វើការ/សម្រាក",
            "hours": "ម៉ោង",
            "sequence": "លំដាប់"
          },
          "empty": "មិនទាន់មានលំនាំការងារទេ។ ចុច {cta}។",
          "cta": "+ លំនាំការងារថ្មី",
          "new": "លំនាំការងារថ្មី",
          "edit": "កែសម្រួលលំនាំការងារ",
          "sec": {
            "info": "1 · ព័ត៌មានលំនាំ",
            "cycle": "2 · វដ្ត និងលំដាប់",
            "preview": "3 · ការមើលជាមុនរបស់ប្រព័ន្ធ",
            "notes": "4 · កំណត់ចំណាំ"
          },
          "f": {
            "name": "ឈ្មោះលំនាំ",
            "suggested": "ឈ្មោះកូដដែលបានណែនាំ៖",
            "use": "ប្រើ",
            "type": "ប្រភេទលំនាំ",
            "code": "លេខកូដលំនាំ (ស្វ័យប្រវត្តិ)",
            "code-empty": "— បង្កើតស្វ័យប្រវត្តិពីលំដាប់ —",
            "code-hint": "ប្រព័ន្ធបង្កើតពីវដ្ត និងលំដាប់។ មិនអាចកែបានទេ។",
            "cycle": "ប្រវែងវដ្ត (ថ្ងៃ)",
            "cycle-hint": "កំណត់ស្វ័យប្រវត្តិពេលអ្នកបង្កើតលំដាប់វេនខាងក្រោម — វេន ឬថ្ងៃឈប់នីមួយៗបន្ថែមមួយថ្ងៃទៅវដ្ត។",
            "sequence": "លំដាប់វេន",
            "seq-empty": "មិនទាន់មានធាតុទេ។ បន្ថែមវេន និងថ្ងៃឈប់ (អាចដដែលៗបាន)។",
            "add-shift": "+ បន្ថែមវេន…",
            "add-off": "+ ថ្ងៃឈប់",
            "seq-hint": "ប្រើ ◀ ▶ លើថ្ងៃដើម្បីរៀបឡើងវិញ · ✕ ដើម្បីលុប។ លំដាប់កំណត់វដ្ត។",
            "notes": "កំណត់ចំណាំ",
            "new-shift": "វេនថ្មី",
            "new-shift-title": "បង្កើតវេនថ្មីក្នុងបញ្ជីវេន ហើយបន្ថែមវានៅទីនេះ",
            "cap": "វដ្តមួយអាចមានយ៉ាងច្រើន {n} ថ្ងៃ។"
          },
          "kind": {
            "rotation": "លំនាំវេនបង្វិល",
            "fixed": "លំនាំថេរ",
            "fixed-hint": "ថេរ → បង្កើតកាលវិភាគថេរ (វេនមួយនៅថ្ងៃធ្វើការ ថ្ងៃឈប់ថេរ)។",
            "rotation-hint": "វេនបង្វិល → បង្កើតកាលវិភាគវេនបង្វិល (វដ្តបង្វិលច្រើនថ្ងៃ) · អាចធ្វើតារាងវេនស្វ័យប្រវត្តិ។",
            "flex-hint": "កាលវិភាគបត់បែនមិនត្រូវការលំនាំទេ។"
          },
          "move-earlier": "ផ្លាស់ទៅមុន",
          "move-later": "ផ្លាស់ទៅក្រោយ",
          "remove-entry": "លុប",
          "pv": {
            "cycle": "មើលវដ្តជាមុន៖",
            "work": "ថ្ងៃធ្វើការ៖",
            "rest": "ថ្ងៃសម្រាក៖",
            "hours": "ម៉ោងតាមកាលវិភាគ៖",
            "cross": "ឆ្លងកាត់អធ្រាត្រ៖",
            "night": "យប់៖",
            "empty": "លំដាប់ទទេ។",
            "no-shifts": "មិនមានវេនសម្រាប់ក្រុមហ៊ុននេះទេ — សូមបង្កើតវេនជាមុន។"
          },
          "required": "ត្រូវការឈ្មោះលំនាំ។",
          "move-earlier-n": "ផ្លាស់ថ្ងៃទី {n} ទៅមុន",
          "move-later-n": "ផ្លាស់ថ្ងៃទី {n} ទៅក្រោយ",
          "remove-entry-n": "លុបថ្ងៃទី {n}",
          "need-shift": "សូមបន្ថែមវេនយ៉ាងហោចណាស់មួយទៅលំដាប់វេន។",
          "conflict-reload": "បញ្ជីត្រូវបានធ្វើឱ្យទាន់សម័យ — សូមបិទផ្ទាំងនេះ ហើយបើកលំនាំការងារម្តងទៀត ដើម្បីកែសម្រួលកំណែចុងក្រោយ។",
          "confirm": {
            "edit-title": "រក្សាទុកការផ្លាស់ប្តូរលំនាំការងារដែលកំពុងប្រើ?",
            "edit-body": "“{name}” ត្រូវបានប្រើដោយ {schedules}។ ការរក្សាទុកនឹងផ្លាស់ប្តូរផែនការរបស់បុគ្គលិក {employees} នាក់ លើកាលវិភាគទាំងនោះ រួមទាំងថ្ងៃកន្លងមក។",
            "remove-title": "បិទដំណើរការលំនាំការងារ?",
            "remove-body": "បិទដំណើរការ “{name}”? វានឹងត្រូវលាក់ពីបញ្ជី ហើយមិនអាចភ្ជាប់ទៅកាលវិភាគបានទៀតទេ។",
            "remove-body-used": "បិទដំណើរការ “{name}”? វាត្រូវបានប្រើដោយ {schedules} (បុគ្គលិក {employees} នាក់)។ កាលវិភាគទាំងនោះនៅតែអនុវត្តតាមវា ប៉ុន្តែវាមិនអាចភ្ជាប់ទៅកាលវិភាគបានទៀតទេ។"
          },
          "usage": {
            "named": "កាលវិភាគ {count}៖ {names}",
            "count": "កាលវិភាគ {count}"
          }
        },
        "cov": {
          "kpi": {
            "active": "ផែនការគ្របដណ្តប់សកម្ម",
            "required": "ចំនួនបុគ្គលិកដែលត្រូវការសរុប",
            "sites": "ទីតាំងដែលគ្របដណ្តប់",
            "expiring": "ជិតផុតកំណត់"
          },
          "count": "ផែនការគ្របដណ្តប់ {n} — ចំនួនបុគ្គលិកដែលត្រូវការតាមវេន/ថ្ងៃ ប្រើដោយការជូនដំណឹងការគ្របដណ្តប់ និង (ក្រោយមក) តារាងវេនស្វ័យប្រវត្តិ។",
          "col": {
            "plan": "ផែនការគ្របដណ្តប់",
            "jobs": "មុខតំណែង",
            "hc": "ចំនួនត្រូវការ",
            "shift": "វេន",
            "status": "ស្ថានភាព",
            "action": "សកម្មភាព"
          },
          "empty": "មិនទាន់មានផែនការគ្របដណ្តប់ទេ។ ចុច {cta}។",
          "cta": "+ ផែនការគ្របដណ្តប់ថ្មី",
          "no-jobs": "គ្មានមុខតំណែង — កែសម្រួលដើម្បីបន្ថែម។",
          "total": "សរុប",
          "demo": "សាកល្បង",
          "demo-tip": "ទិន្នន័យសាកល្បង ({tag})",
          "plan": "ផែនការ",
          "duplicated": "បានចម្លងផែនការគ្របដណ្តប់",
          "required": "ត្រូវការឈ្មោះផែនការ។",
          "ed": {
            "new": "បន្ថែមផែនការគ្របដណ្តប់ថ្មី",
            "edit": "កែសម្រួលផែនការគ្របដណ្តប់",
            "view": "មើលផែនការគ្របដណ្តប់",
            "sub": "កំណត់តម្រូវការរំពឹងទុកតាមតួនាទីតាមវេន និងថ្ងៃ។",
            "create": "បង្កើតផែនការគ្របដណ្តប់",
            "save": "រក្សាទុកផែនការគ្របដណ្តប់",
            "details": "ព័ត៌មានលម្អិតផែនការ",
            "name": "ឈ្មោះផែនការ",
            "name-ph": "ឧ. ផែនការគ្របដណ្តប់ថ្ងៃធ្វើការ",
            "period": "រយៈពេលមានសុពលភាព",
            "desc": "ការពិពណ៌នា",
            "desc-ph": "បន្ថែមការពិពណ៌នា (ស្រេចចិត្ត)",
            "jobs": "មុខតំណែង · ជួរដេក",
            "jobs-ms": "មុខតំណែង",
            "jobs-hint": "ពីឋានានុក្រមអង្គភាព។ មុខតំណែងដែលបានជ្រើសបង្ហាញជាជួរដេកខាងក្រោម។",
            "shifts": "វេន · ជួរឈរ",
            "shifts-ms": "វេន",
            "shifts-hint": "វេនដែលបានជ្រើសបង្ហាញជាជួរឈរ (តាមថ្ងៃ) ខាងក្រោម។",
            "matrix": "តារាងការគ្របដណ្តប់ (មុខតំណែង)",
            "matrix-sub": "កំណត់ចំនួនបុគ្គលិកដែលត្រូវការសម្រាប់វេន និងថ្ងៃនីមួយៗ។",
            "copy-mon": "ចម្លងថ្ងៃច័ន្ទ → គ្រប់ថ្ងៃ",
            "job-title": "មុខតំណែង",
            "total-required-1": "សរុប",
            "total-required-2": "ត្រូវការ",
            "total-required": "ត្រូវការសរុប",
            "notes": "កំណត់ចំណាំ (ស្រេចចិត្ត)",
            "notes-ph": "បន្ថែមកំណត់ចំណាំ ឬការណែនាំពិសេសសម្រាប់ផែនការគ្របដណ្តប់នេះ..."
          }
        },
        "pool": {
          "kpi": {
            "total": "ក្រុមសរុប",
            "total-sub": "សកម្ម និងអសកម្មទាំងអស់",
            "employees": "បុគ្គលិកក្នុងក្រុម",
            "employees-sub": "ក្នុងក្រុមទាំងអស់",
            "active": "ក្រុមសកម្ម",
            "active-sub": "កំពុងសកម្ម",
            "unused": "ក្រុមមិនបានប្រើ",
            "unused-sub": "មិនទាន់មានកាលវិភាគ"
          },
          "search": "ស្វែងរកក្រុមតាមឈ្មោះ ប្រភេទ ឬការពិពណ៌នា...",
          "f-status": "ស្ថានភាព",
          "f-based": "ផ្អែកលើ",
          "status-all": "ស្ថានភាព៖ ទាំងអស់",
          "based-all": "ផ្អែកលើ៖ ទាំងអស់",
          "based": {
            "Job Title": "មុខតំណែង",
            "Skill": "ជំនាញ",
            "Work Type": "ប្រភេទការងារ",
            "Contract Type": "ប្រភេទកិច្ចសន្យា",
            "Availability": "ភាពទំនេរ",
            "Criteria": "លក្ខខណ្ឌ"
          },
          "new": "ក្រុមថ្មី",
          "count": "ក្រុម {n} — បុគ្គលិកដែលបានដាក់ជាក្រុម ប្រើដោយតារាងវេនស្វ័យប្រវត្តិ។ មានតែបុគ្គលិកដែលមានសិទ្ធិវេនបង្វិលប៉ុណ្ណោះត្រូវបានដាក់ក្នុងក្រុម។",
          "col": {
            "name": "ឈ្មោះក្រុម",
            "based": "ផ្អែកលើ",
            "desc": "ការពិពណ៌នា",
            "employees": "បុគ្គលិក",
            "used": "ប្រើក្នុង",
            "status": "ស្ថានភាព",
            "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ"
          },
          "used-in": "កាលវិភាគ {n}",
          "last-used": "ប្រើចុងក្រោយ៖ {when}",
          "never": "មិនដែលប្រើ",
          "by": "ដោយ {name}",
          "empty": "គ្មានក្រុមត្រូវនឹងតម្រងទាំងនេះទេ។",
          "required": "ត្រូវការឈ្មោះក្រុម",
          "dr": {
            "new": "បន្ថែមក្រុមបុគ្គលិកថ្មី",
            "edit": "កែសម្រួលក្រុមបុគ្គលិក",
            "sub": "បង្កើតក្រុមបុគ្គលិកសម្រាប់ការធ្វើកាលវិភាគ។",
            "basic": "ព័ត៌មានមូលដ្ឋាន",
            "name": "ឈ្មោះក្រុម",
            "name-ph": "ឧ. ប្រតិបត្តិករផលិតកម្ម",
            "desc": "ការពិពណ៌នា (ស្រេចចិត្ត)",
            "desc-ph": "បន្ថែមការពិពណ៌នា...",
            "based-on": "ផ្អែកលើ",
            "type": "ប្រភេទ",
            "type-hint": "កំណត់លក្ខខណ្ឌសម្រាប់បុគ្គលិកក្នុងក្រុមនេះ។",
            "scope": "វិសាលភាព",
            "dept": "នាយកដ្ឋាន (ស្រេចចិត្ត)",
            "dept-all": "នាយកដ្ឋានទាំងអស់",
            "active-only": "រួមបញ្ចូលតែបុគ្គលិកសកម្ម",
            "rotation-only": "មានតែបុគ្គលិកកាលវិភាគវេនបង្វិលប៉ុណ្ណោះដែលមានសិទ្ធិចូលក្រុម។",
            "status": "ស្ថានភាព",
            "save": "រក្សាទុកក្រុម"
          }
        },
        "hol": {
          "new": "ថ្ងៃឈប់សម្រាកថ្មី",
          "edit": "កែសម្រួលថ្ងៃឈប់សម្រាក",
          "f": {
            "name": "ឈ្មោះប្រតិទិន",
            "year": "ឆ្នាំ",
            "status": "ស្ថានភាព",
            "date": "កាលបរិច្ឆេទថ្ងៃឈប់ {n}",
            "date-name": "ឈ្មោះថ្ងៃឈប់សម្រាក",
            "date-type": "ប្រភេទថ្ងៃឈប់សម្រាក",
            "type": "ប្រភេទប្រតិទិន",
            "region": "តំបន់ (ស្រេចចិត្ត)",
            "name-km": "ឈ្មោះជាភាសាខ្មែរ",
            "from": "ថ្ងៃដំបូងនៃថ្ងៃឈប់សម្រាក {n}",
            "to": "ថ្ងៃចុងក្រោយនៃថ្ងៃឈប់សម្រាក {n} (ស្រេចចិត្ត)"
          },
          "type": {
            "Public": "សាធារណៈ",
            "Company": "ក្រុមហ៊ុន",
            "Regional": "តំបន់"
          },
          "dates": "កាលបរិច្ឆេទថ្ងៃឈប់សម្រាក",
          "no-dates": "មិនទាន់មានកាលបរិច្ឆេទទេ។",
          "add-date": "បន្ថែមកាលបរិច្ឆេទ",
          "remove-date": "លុបកាលបរិច្ឆេទ",
          "required": "ត្រូវការឈ្មោះប្រតិទិន និងឆ្នាំ។",
          "kind": {
            "public": "ប្រតិទិនថ្ងៃឈប់សម្រាកសាធារណៈ",
            "other": "ប្រតិទិនថ្ងៃឈប់សម្រាកផ្សេងទៀត",
            "standard": "បញ្ជីស្តង់ដារ (Optimal HR)"
          },
          "kind-short": {
            "public": "សាធារណៈ",
            "other": "ផ្សេងទៀត",
            "standard": "ស្តង់ដារ"
          },
          "kind-hint": {
            "public": "កាលវិភាគប្រើវាជាប្រតិទិនថ្ងៃឈប់សម្រាកសាធារណៈរបស់ខ្លួន។",
            "other": "ថ្ងៃឈប់របស់ក្រុមហ៊ុន ឬតំបន់ ដែលកាលវិភាគអាចអនុវត្តបន្ថែមលើថ្ងៃឈប់សម្រាកសាធារណៈ។"
          },
          "row": {
            "name": "សូមដាក់ឈ្មោះថ្ងៃឈប់សម្រាកនេះ។",
            "from": "សូមជ្រើសរើសថ្ងៃដំបូង។",
            "to-before-from": "ថ្ងៃចុងក្រោយត្រូវតែស្មើ ឬក្រោយថ្ងៃដំបូង។",
            "too-long": "ថ្ងៃឈប់សម្រាកមួយអាចមានរយៈពេលយ៉ាងច្រើន {n} ថ្ងៃ។",
            "outside-year": "គ្រប់ថ្ងៃត្រូវតែស្ថិតក្នុងឆ្នាំ {year}។",
            "duplicate": "ថ្ងៃនេះមាននៅលើថ្ងៃឈប់សម្រាកមួយផ្សេងទៀតរួចហើយ។"
          },
          "day-total": "{n} ថ្ងៃ",
          "too-many": "ប្រតិទិនមួយអាចរក្សាទុកបានយ៉ាងច្រើន {n} កាលបរិច្ឆេទក្នុងពេលតែមួយ — ប្រតិទិននេះមាន {count}។",
          "loading-dates": "កំពុងផ្ទុកកាលបរិច្ឆេទនៃប្រតិទិននេះ…",
          "load-failed": "មិនអាចផ្ទុកកាលបរិច្ឆេទនៃប្រតិទិននេះបានទេ។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "series": "អនុវត្តផងដែរ៖ {years}",
          "series-hint": "កាលវិភាគដែលប្រើប្រតិទិននេះ ក៏អនុវត្តឆ្នាំផ្សេងទៀតរបស់វាដែរ។",
          "standard-readonly": "បញ្ជីស្តង់ដារត្រូវបានថែទាំដោយ Optimal HR ហើយមិនអាចកែសម្រួលនៅទីនេះបានទេ។",
          "saved-toast": "បានរក្សាទុក {name}",
          "saved-partial": "{name} ត្រូវបានបង្កើតហើយ ប៉ុន្តែកាលបរិច្ឆេទរបស់វាមិនត្រូវបានរក្សាទុកទេ៖ {detail} សូមកែវា ហើយចុច រក្សាទុក ម្ដងទៀត។",
          "reload": "សូមបិទផ្ទាំងនេះ ហើយបើកប្រតិទិនម្ដងទៀត ដើម្បីមើលកំណែចុងក្រោយ។",
          "fill": {
            "action": "បំពេញពីថ្ងៃឈប់សម្រាកសាធារណៈ {year}",
            "none": "មិនទាន់មានថ្ងៃឈប់សម្រាកសាធារណៈយោងសម្រាប់ឆ្នាំ {year} នៅឡើយទេ។",
            "added": "បានបន្ថែមកាលបរិច្ឆេទថ្ងៃឈប់សម្រាកសាធារណៈ {n}។ សូមពិនិត្យ រួចរក្សាទុក។",
            "already": "ថ្ងៃឈប់សម្រាកសាធារណៈឆ្នាំ {year} ទាំងអស់មាននៅលើប្រតិទិននេះរួចហើយ។",
            "failed": "មិនអាចផ្ទុកថ្ងៃឈប់សម្រាកសាធារណៈបានទេ។ សូមព្យាយាមម្ដងទៀត។"
          },
          "import": {
            "action": "នាំចូលថ្ងៃឈប់សម្រាកសាធារណៈ",
            "title": "នាំចូលថ្ងៃឈប់សម្រាកសាធារណៈ",
            "desc": "ចម្លងថ្ងៃឈប់សម្រាកសាធារណៈផ្លូវការរបស់កម្ពុជាសម្រាប់មួយឆ្នាំ ទៅក្នុងប្រតិទិនរបស់ក្រុមហ៊ុន។",
            "year": "ឆ្នាំ",
            "year-invalid": "សូមបញ្ចូលឆ្នាំចន្លោះពី 1970 ដល់ 2999។",
            "loading": "កំពុងផ្ទុកថ្ងៃឈប់សម្រាកសាធារណៈ…",
            "empty": "មិនទាន់មានថ្ងៃឈប់សម្រាកសាធារណៈយោងសម្រាប់ឆ្នាំ {year} នៅឡើយទេ។",
            "error": "មិនអាចផ្ទុកថ្ងៃឈប់សម្រាកសាធារណៈបានទេ។",
            "count": "កាលបរិច្ឆេទថ្ងៃឈប់សម្រាកសាធារណៈ {n} ក្នុងឆ្នាំ {year}",
            "col": {
              "date": "កាលបរិច្ឆេទ",
              "name": "ថ្ងៃឈប់សម្រាក",
              "name-km": "ឈ្មោះជាភាសាខ្មែរ"
            },
            "will-create": "បង្កើតប្រតិទិន “{name}” ជាមួយកាលបរិច្ឆេទទាំងនេះ។",
            "exists": "“{name}” មានរួចហើយសម្រាប់ឆ្នាំ {year}។ ការធ្វើបច្ចុប្បន្នភាពនឹងបន្ថែមកាលបរិច្ឆេទទាំងនេះ និងកែឈ្មោះរបស់វា ចំណែកថ្ងៃផ្សេងទៀតរបស់វានៅដដែល។",
            "create": "បង្កើតប្រតិទិន",
            "update": "ធ្វើបច្ចុប្បន្នភាពកាលបរិច្ឆេទរបស់វា",
            "done-created": "បានបង្កើត {name} ជាមួយកាលបរិច្ឆេទ {n}",
            "done-updated": "បានធ្វើបច្ចុប្បន្នភាពកាលបរិច្ឆេទនៃ {name}"
          },
          "clone": {
            "action": "ចម្លងទៅឆ្នាំបន្ទាប់",
            "aria": "ចម្លង {name} ទៅឆ្នាំផ្សេង",
            "title": "ចម្លងទៅឆ្នាំផ្សេង",
            "desc": "ចម្លង “{name}” និងកាលបរិច្ឆេទរបស់វាទៅឆ្នាំផ្សេង។ ច្បាប់ចម្លងស្ថិតក្នុងស៊េរីប្រតិទិនតែមួយ ដូច្នេះកាលវិភាគដែលប្រើវានឹងអនុវត្តទាំងពីរឆ្នាំ។",
            "name": "ឈ្មោះច្បាប់ចម្លង",
            "name-required": "សូមដាក់ឈ្មោះច្បាប់ចម្លង។",
            "same-year": "សូមជ្រើសរើសឆ្នាំផ្សេងពីឆ្នាំ {year}។",
            "submit": "ចម្លង",
            "exists": "ច្បាប់ចម្លងឆ្នាំ {year} នៃប្រតិទិននេះមានរួចហើយ។",
            "done": "បានបង្កើត {name}",
            "skipped": "មិនបានចម្លង — គ្មានថ្ងៃនេះក្នុងឆ្នាំ {year}៖ {dates}",
            "rename-failed": "ច្បាប់ចម្លងត្រូវបានបង្កើតហើយ ប៉ុន្តែមិនអាចប្ដូរឈ្មោះបានទេ៖ {detail}",
            "name-taken": "ប្រតិទិនឈ្មោះ “{name}” មានរួចហើយសម្រាប់ឆ្នាំ {year}។",
            "rolled-back": "មិនបានចម្លងអ្វីទេ — មិនអាចដាក់ឈ្មោះច្បាប់ចម្លងបានទេ៖ {detail}"
          }
        },
        "meal": {
          "new": "ពេលសម្រាកអាហារថ្មី",
          "edit": "កែសម្រួលពេលសម្រាកអាហារ",
          "f": {
            "name": "ឈ្មោះ",
            "start": "ម៉ោងចាប់ផ្តើម",
            "end": "ម៉ោងបញ្ចប់",
            "paid": "មានប្រាក់ / គ្មានប្រាក់",
            "notes": "កំណត់ចំណាំ"
          },
          "unpaid": "គ្មានប្រាក់",
          "paid": "មានប្រាក់",
          "duration": "រយៈពេល",
          "required": "ត្រូវការឈ្មោះ ម៉ោងចាប់ផ្តើម និងម៉ោងបញ្ចប់។",
          "saved": "បានរក្សាទុកពេលសម្រាកអាហារ “{name}”"
        },
        "all": {
          "title": "តារាងវេនទាំងអស់",
          "sub": "វដ្តជីវិតតារាងវេនពេញលេញ — សេចក្តីព្រាង រង់ចាំការអនុម័ត បានអនុម័ត បានផ្សព្វផ្សាយ បានបិទ។ ទុកការដំណើរការនៅទីនេះ ហើយធ្វើការលើខ្សែច្រើនស្របគ្នា កន្លែងធ្វើការកែការដំណើរការម្តងមួយ។",
          "new": "តារាងវេនថ្មី",
          "filter": "តម្រងតាមស្ថានភាព",
          "empty": "គ្មានតារាងវេនក្នុងតម្រងនេះទេ។",
          "st": {
            "all": "ទាំងអស់",
            "Draft": "សេចក្តីព្រាង",
            "Pending approval": "រង់ចាំការអនុម័ត",
            "Approved": "បានអនុម័ត",
            "Published": "បានផ្សព្វផ្សាយ",
            "Closed": "បានបិទ"
          },
          "col": {
            "period": "រយៈពេលតារាងវេន",
            "scope": "វិសាលភាព",
            "version": "កំណែ",
            "coverage": "ការគ្របដណ្តប់",
            "status": "ស្ថានភាព",
            "by": "ដោយ / ពេល"
          },
          "act": {
            "edit": "កែសម្រួល — បន្តក្នុងកន្លែងធ្វើការ",
            "approve": "អនុម័ត (អ្នកអនុម័ត)",
            "send-back": "ផ្ញើត្រឡប់ (អ្នកអនុម័ត · មានកំណត់ត្រា)",
            "publish": "ផ្សព្វផ្សាយ — ចេញផ្សាយដល់បុគ្គលិក",
            "workspace": "ទៅកន្លែងធ្វើការ — ការកែសម្រួលលុបចោលការអនុម័ត",
            "reopen": "បើកឡើងវិញក្នុងកន្លែងធ្វើការ (កែប្រែ)"
          }
        },
        "rw": {
          "step": {
            "inputs": "ជ្រើសធាតុចូល",
            "draft": "សេចក្តីព្រាង",
            "review": "ពិនិត្យ",
            "approve": "អនុម័ត",
            "publish": "ផ្សព្វផ្សាយ"
          },
          "inputs-title": "ជ្រើសធាតុចូលសម្រាប់ការដំណើរការតារាងវេននេះ",
          "generate": "បង្កើតសេចក្តីព្រាងតារាងវេន",
          "locked": "ធាតុចូលត្រូវបានចាក់សោសម្រាប់ការដំណើរការនេះ · ប្រើបង្កើតឡើងវិញដើម្បីសាងសង់ឡើងវិញ",
          "f": {
            "ws": "កាលវិភាគការងារ",
            "cov": "ការគ្របដណ្តប់",
            "pool": "ក្រុមបុគ្គលិក",
            "dates": "ចន្លោះកាលបរិច្ឆេទ",
            "start": "កាលបរិច្ឆេទចាប់ផ្តើម",
            "end": "កាលបរិច្ឆេទបញ្ចប់",
            "title": "ចំណងជើងតារាងវេន",
            "title-ph": "ឧ. វេនបង្វិលយប់ខ្សែ A",
            "title-hint": "ត្រូវការ · ការណែនាំ៖ ផែនការគ្របដណ្តប់ + រយៈពេល (ឧ. \"{example}\")"
          },
          "not-selected": "មិនទាន់ជ្រើស",
          "add": "+ បន្ថែម",
          "clear-named": "សម្អាត {name}",
          "lib-empty": "មិនទាន់មានអ្វីក្នុងបណ្ណាល័យក្រុមហ៊ុននេះទេ — បង្កើតវាក្នុងផ្ទាំងការរៀបចំខាងលើ (កាលវិភាគការងារ / ផែនការគ្របដណ្តប់ / ក្រុមបុគ្គលិក)។",
          "cp-empty": "គ្មានផែនការគ្របដណ្តប់ដែលបានរក្សាទុកសម្រាប់កាលវិភាគនេះក្នុងក្រុមហ៊ុននេះទេ — បង្កើតមួយក្នុងផែនការគ្របដណ្តប់ ឬប្រើរបៀបរហ័ស / ដោយដៃ។",
          "ws-first": "ជ្រើសកាលវិភាគការងារជាមុនសិន។",
          "prev-first": "ជ្រើសវាលមុនជាមុនសិន។",
          "mode": {
            "plan": "ផែនការដែលបានរក្សាទុក",
            "quick": "រហ័ស",
            "none": "ដោយដៃ"
          },
          "mode-locked": "ចាក់សោសម្រាប់ការដំណើរការនេះ · បង្កើតឡើងវិញដើម្បីផ្លាស់ប្តូរ",
          "quick-hint": "បុគ្គលិកអប្បបរមាក្នុងមួយតំណែង · ជំរុញការរកឃើញចន្លោះ។",
          "manual-hint": "គ្មានគោលដៅ — បង្កើតតារាងវេនដោយដៃ។ ប្រព័ន្ធនឹងមិនសម្គាល់កង្វះការគ្របដណ្តប់ទេ អ្នកនៅតែអាចកែក្រឡាណាមួយក្នុងសេចក្តីព្រាងបាន។",
          "compat": "ធាតុចូលដែលបានជ្រើសទាំងអស់ត្រូវគ្នា · ការបំពេញការគ្របដណ្តប់ប៉ាន់ស្មាន៖",
          "incomplete": "ជ្រើសធាតុចូលដែលត្រូវការ (កាលវិភាគការងារ ក្រុមបុគ្គលិក កាលបរិច្ឆេទ — បូកផែនការគ្របដណ្តប់ ប្រសិនបើប្រើរបៀបផែនការដែលបានរក្សាទុក) ដើម្បីបង្កើត។",
          "empty": "ជ្រើសធាតុចូលខាងលើ រួច {cta} ដើម្បីបង្កើតតារាងវេន។",
          "rotation-only": "សម្រាប់តារាងវេនបង្វិល / វេនតែប៉ុណ្ណោះ — បុគ្គលិកកាលវិភាគថេរកំណត់កាលវិភាគការងារនៅលើកំណត់ត្រាបុគ្គលិក។",
          "required": "ត្រូវការ {n}",
          "bn": {
            "pub": "បានផ្សព្វផ្សាយ · {label}",
            "pub-amended": "បានផ្សព្វផ្សាយ · បានកែប្រែ · {label}",
            "pub-sub": "កំណែ {ver} · បានផ្សព្វផ្សាយ {when} ដោយ {by} · បុគ្គលិក និងអ្នកគ្រប់គ្រងផ្ទាល់ឥឡូវអាចមើលវេនរបស់ពួកគេបាន។",
            "pub-amended-sub": "កំណែ {ver} · ការកែប្រែក្រោយផ្សព្វផ្សាយ {n} · បានកត់ត្រាសម្រាប់សវនកម្ម",
            "submitted": "បានដាក់ស្នើសុំការអនុម័ត",
            "submitted-sub": "សេចក្តីព្រាង v{ver} · ដាក់ស្នើដោយ {by} · ពិនិត្យសេចក្តីព្រាង រួចអនុម័ត ឬផ្ញើត្រឡប់។",
            "approved": "បានអនុម័ត · រួចរាល់សម្រាប់ផ្សព្វផ្សាយ",
            "approved-sub": "សេចក្តីព្រាង v{ver} · បានអនុម័ត · ផ្សព្វផ្សាយដើម្បីធ្វើឱ្យវាក្លាយជាតារាងវេនផ្លូវការ។"
          },
          "tag": {
            "published": "បានផ្សព្វផ្សាយ",
            "submitted": "រង់ចាំការអនុម័ត",
            "approved": "បានអនុម័ត",
            "unpublished": "មិនទាន់ផ្សព្វផ្សាយ",
            "draft": "សេចក្តីព្រាង"
          },
          "act": {
            "view-all": "មើលក្នុងតារាងវេនទាំងអស់",
            "new-run": "ការដំណើរការតារាងវេនថ្មី",
            "approve": "អនុម័ត",
            "send-back": "ផ្ញើត្រឡប់",
            "withdraw": "ដកការដាក់ស្នើវិញ",
            "withdraw-tip": "ដកការដាក់ស្នើត្រឡប់ទៅសេចក្តីព្រាង (មានកំណត់ត្រា)",
            "publish": "ផ្សព្វផ្សាយ",
            "void": "កែសម្រួល (លុបចោលការអនុម័ត)",
            "void-tip": "ការកែសម្រួលតារាងវេនដែលបានអនុម័ត លុបចោលការអនុម័ត — ត្រឡប់ទៅសេចក្តីព្រាងដើម្បីអនុម័តឡើងវិញ (មានកំណត់ត្រា)",
            "save-new": "រក្សាទុក និងចាប់ផ្តើមថ្មី",
            "save-new-tip": "ទុកការដំណើរការនេះក្នុងតារាងវេនទាំងអស់ ហើយចាប់ផ្តើមមួយទៀត — ធ្វើការលើខ្សែច្រើនស្របគ្នា",
            "discard": "បោះបង់សេចក្តីព្រាង",
            "regenerate": "បង្កើតឡើងវិញ",
            "submit": "ដាក់ស្នើសុំការអនុម័ត",
            "submit-soft": "ដាក់ស្នើ · ការព្រមាន {n}",
            "submit-hard": "ដោះស្រាយបញ្ហាច្បាប់ {n} ដើម្បីដាក់ស្នើ",
            "review": "ពិនិត្យបញ្ហា"
          },
          "kpi": {
            "coverage": "ការគ្របដណ្តប់",
            "coverage-tip": "ភាគរយនៃវេនដែលត្រូវការដែលបានបំពេញ។",
            "assigned": "បុគ្គលិកដែលបានចាត់តាំង",
            "assigned-tip": "បុគ្គលិកផ្សេងៗគ្នាដែលបានដាក់លើតារាងវេននេះ។",
            "unfilled": "វេនមិនទាន់បំពេញ",
            "unfilled-tip": "វេនដែលត្រូវការដែលគ្មាននរណាចាត់តាំង។ បំពេញពីក្រុម ឬផ្តល់ម៉ោងបន្ថែម។",
            "rules": "ការបំពានច្បាប់",
            "rules-tip": "ការចាត់តាំងដែលបំពានច្បាប់កាលវិភាគ — នៅទីនេះ ការសម្រាកអប្បបរមារវាងវេន។ ជួសជុលលំនាំ ឬទទួលយក និងកត់ចំណាំ។",
            "rules-tip-pub": "ការចាត់តាំងដែលបំពានច្បាប់កាលវិភាគ។ ចាក់សោ — តារាងវេនដែលបានផ្សព្វផ្សាយផ្លាស់ប្តូរតាមការកែប្រែដែលកត់ត្រា ឬកំណែថ្មី។",
            "over": "បុគ្គលិកលើស",
            "over-tip": "តំណែង-ថ្ងៃដែលមានបុគ្គលិកច្រើនជាងផែនការត្រូវការ — ខាតបង់ថ្លៃពលកម្ម។ ចុចដើម្បីមើលវេនណា និងជួសជុលវា (ផ្ទេរ លុប ឬទទួលយក)។",
            "over-tip-pub": "បុគ្គលិកច្រើនជាងផែនការត្រូវការ។ ចាក់សោ — តារាងវេនដែលបានផ្សព្វផ្សាយផ្លាស់ប្តូរតាមការកែប្រែដែលកត់ត្រា ឬកំណែថ្មី។"
          },
          "range": {
            "full": "តារាងវេន {days} ថ្ងៃ · រយៈពេលពេញ",
            "week": "តារាងវេន {days} ថ្ងៃ · សប្តាហ៍ {w} នៃ {c}",
            "week-n": "សប្តាហ៍ {n}",
            "month": "ពេញមួយខែ",
            "all": "ទាំង {n} ថ្ងៃ",
            "scroll": "រមូរ →",
            "note": "ទិដ្ឋភាពលំនាំប្រចាំសប្តាហ៍៖ ការចាត់តាំង និងការបំពេញចន្លោះធ្វើម្តងទៀតរៀងរាល់សប្តាហ៍ — ការកែសប្តាហ៍ណាមួយកែលំនាំសម្រាប់គ្រប់សប្តាហ៍។ ការប្រែប្រួលតាមថ្ងៃឆ្លងសប្តាហ៍នឹងមកជាមួយការភ្ជាប់ទិន្នន័យពិត។"
          },
          "dh": {
            "draft": "សេចក្តីព្រាងតារាងវេន · កំណែ {ver}",
            "published": "តារាងវេនដែលបានផ្សព្វផ្សាយ · កំណែ {ver}",
            "view": "ទិដ្ឋភាពក្រឡា",
            "coverage": "ការគ្របដណ្តប់",
            "roster": "តារាងវេន"
          },
          "gaps": "ចន្លោះ {n}",
          "one-over": "លើស 1",
          "fully-staffed": "មានបុគ្គលិកគ្រប់ — រួចរាល់សម្រាប់ផ្សព្វផ្សាយ",
          "cg": {
            "position": "តំណែង / វេន",
            "req": "ត្រូវការ",
            "shift": "វេន",
            "coverage": "ការគ្របដណ្តប់ %",
            "status": "ស្ថានភាព",
            "met": "បានបំពេញ",
            "under": "ខ្វះបុគ្គលិក",
            "short": "កង្វះ"
          },
          "grid": {
            "employee": "បុគ្គលិក",
            "tag": "ស្លាក",
            "morning": "ព្រឹក",
            "evening": "ល្ងាច",
            "night": "យប់",
            "set-off": "កំណត់ឈប់",
            "remove": "ដកចេញពីវេន",
            "reset": "កំណត់ឡើងវិញដូចដើម",
            "cell-aria": "កែវេនរបស់ {name} នៅ {day}",
            "replaced": "បានជំនួស",
            "swapped": "បានប្តូរ",
            "ot-tip": "វេនម៉ោងបន្ថែម",
            "plus-ot-tip": "បានទទួលវេនម៉ោងបន្ថែម",
            "on-call": "ហៅបម្រុង",
            "added": "បានបន្ថែម",
            "unfilled": "មិនទាន់បំពេញ",
            "filled": "បានបំពេញ",
            "gap-aria": "បំពេញកន្លែងទំនេរ {n} ក្នុង {group}",
            "qualified": "មានលក្ខណៈសម្បត្តិ និងទំនេរ",
            "no-free": "គ្មានបុគ្គលិកមានលក្ខណៈសម្បត្តិទំនេរ — ផ្តល់ម៉ោងបន្ថែមខាងក្រោម។",
            "on-leave": "ឈប់សម្រាក",
            "already-on": "មានរួចហើយនៅ {group}",
            "not-qualified": "មិនមានលក្ខណៈសម្បត្តិ · {skill}",
            "offer-ot": "នៅថ្ងៃសម្រាក · ផ្តល់ម៉ោងបន្ថែម",
            "rest-ot": "ថ្ងៃសម្រាក → OT",
            "on-call-h": "ហៅបម្រុង · បុគ្គលិកបត់បែន",
            "flex-oc": "បត់បែន → ហៅបម្រុង",
            "lg-m": "M ព្រឹក",
            "lg-e": "E ល្ងាច",
            "lg-n": "N យប់",
            "lg-ot": "ម៉ោងបន្ថែម (រង្វង់លើវេន)",
            "lg-oc": "ហៅបម្រុង",
            "lg-short": "-N = ខ្វះ N · ចុច + ដើម្បីបំពេញ",
            "lg-edit": "ចុចវេនណាមួយដើម្បីកែ"
          },
          "amend-history": "ប្រវត្តិការកែប្រែ",
          "audit": "កំណត់ត្រាសវនកម្ម",
          "al": {
            "title": "ការជូនដំណឹង និងការព្រមាន",
            "none": "គ្មានបញ្ហាបើកចំហទេ — តារាងវេនរួចរាល់សម្រាប់ផ្សព្វផ្សាយ។",
            "cover": "កង្វះការគ្របដណ្តប់ {n}",
            "cover-sub": "វេនដែលត្រូវការនៅតែមិនទាន់បំពេញ — អាចដាក់ស្នើ/ផ្សព្វផ្សាយដោយទទួលស្គាល់ បន្តបំពេញក្រោយផ្សព្វផ្សាយ",
            "skill": "ជំនាញមិនត្រូវគ្នា {n}",
            "skill-sub": "បុគ្គលិកដែលបានចាត់តាំងមិនមានលក្ខណៈសម្បត្តិសម្រាប់តួនាទី",
            "rest": "ការបំពានច្បាប់សម្រាក {n}",
            "rest-sub": "ការសម្រាកខ្លីរវាងវេន — ច្បាប់៖ ជួសជុលលំនាំ ឬទទួលយក និងកត់ចំណាំ (កត់ត្រាហេតុផល)",
            "over": "វេនលើសបុគ្គលិក 1",
            "over-sub": "បុគ្គលិកច្រើនជាងផែនការត្រូវការ · ថ្លៃបន្ថែម",
            "leave": "បុគ្គលិក {n} នាក់ឈប់សម្រាក",
            "leave-sub": "ក្នុងរយៈពេលនេះ · សម្រាប់ជាព័ត៌មាន",
            "fix": "ជួសជុលឥឡូវ",
            "resolved": "បានដោះស្រាយ និងទទួលយក ({n})",
            "undo": "មិនធ្វើវិញ",
            "auto": "ស្វ័យប្រវត្តិ"
          },
          "res": {
            "cover": "ការគ្របដណ្តប់ពេញលេញ",
            "cover-sub": "វេនដែលត្រូវការទាំងអស់បានបំពេញ",
            "manual": "តារាងវេនដោយដៃ",
            "manual-sub": "គ្មានគោលដៅការគ្របដណ្តប់ · វេនបង្កើតដោយដៃ",
            "skill": "ជំនាញមិនត្រូវគ្នា — បានទទួលយក",
            "skill-sub": "បានទទួលយកដោយអ្នកគ្រប់គ្រង",
            "skill-ok": "គ្មានជំនាញមិនត្រូវគ្នា",
            "skill-ok-sub": "ការជ្រើសផ្តល់តែបុគ្គលិកមានលក្ខណៈសម្បត្តិ",
            "rest": "ការពិនិត្យច្បាប់សម្រាក — បានទទួលយក",
            "rest-sub": "បានទទួលយកដោយអ្នកគ្រប់គ្រង",
            "rest-ok": "គ្មានការបំពានច្បាប់សម្រាក",
            "rest-ok-sub": "គោរពការសម្រាកអប្បបរមារវាងវេន",
            "over": "បុគ្គលិកលើស — បានទទួលយក",
            "over-sub": "បានទទួលយកដោយអ្នកគ្រប់គ្រង",
            "over-ok": "បុគ្គលិកលើសត្រូវបានដោះស្រាយ",
            "over-ok-sub": "វេនលើសត្រូវបានលុប"
          },
          "bar": {
            "working": "សេចក្តីព្រាងកំពុងធ្វើ",
            "published": "តារាងវេនដែលបានផ្សព្វផ្សាយ",
            "from": "បង្កើតពី៖",
            "engine": "ម៉ាស៊ីន៖",
            "status": "ស្ថានភាព៖",
            "generated": "បានបង្កើត៖"
          },
          "pub": {
            "title": "ផ្សព្វផ្សាយតារាងវេន",
            "body": "ផ្សព្វផ្សាយតារាងវេន {period} (សេចក្តីព្រាង v{ver}) មែនទេ? វាចាក់សោសេចក្តីព្រាងជាតារាងវេនផ្លូវការ ហើយធ្វើឱ្យបុគ្គលិក និងអ្នកគ្រប់គ្រងផ្ទាល់មើលឃើញវេន។",
            "cov": "ការគ្របដណ្តប់ {n}%",
            "assigned": "បានចាត់តាំង {n}",
            "open": "ការព្រមានបើកចំហ {n}",
            "soft": "ការព្រមានស្រាល {n} នៅតែបើកចំហ — អ្នកអាចផ្សព្វផ្សាយបាន ប៉ុន្តែវាត្រូវបានកត់ត្រាថាមិនទាន់ដោះស្រាយនៅលើតារាងវេន។",
            "confirm": "បញ្ជាក់ និងផ្សព្វផ្សាយ"
          },
          "confirm": {
            "regenerate": "បង្កើតសេចក្តីព្រាងថ្មីមែនទេ? វាបង្កើតកំណែថ្មី ហើយសម្អាតការបំពេញចន្លោះដោយដៃ។",
            "discard": "បោះបង់សេចក្តីព្រាងតារាងវេននេះ និងការផ្លាស់ប្តូរដោយដៃទាំងអស់មែនទេ? អ្នកនឹងត្រឡប់ទៅការជ្រើសធាតុចូល។",
            "withdraw": "ដកការដាក់ស្នើនេះវិញមែនទេ? តារាងវេនត្រឡប់ទៅសេចក្តីព្រាង (កត់ត្រាក្នុងកំណត់ត្រាសវនកម្ម)។",
            "void": "កែសម្រួលតារាងវេនដែលបានអនុម័តនេះមែនទេ? ការកែសម្រួលលុបចោលការអនុម័ត៖ តារាងវេនត្រឡប់ទៅសេចក្តីព្រាង ហើយត្រូវអនុម័តឡើងវិញមុនផ្សព្វផ្សាយ។ វាត្រូវបានកត់ត្រាក្នុងកំណត់ត្រាសវនកម្ម។",
            "dup": "តារាងវេនដែលបានផ្សព្វផ្សាយគ្របដណ្តប់ {scope} · {period} (\"{title}\") រួចហើយ។ ផ្សព្វផ្សាយជាកំណែថ្មី ហើយបិទកំណែដែលមានស្រាប់មែនទេ? (តារាងវេនផ្ទាល់ពីរសម្រាប់វិសាលភាព និងរយៈពេលដូចគ្នានឹងកំណត់វេនបុគ្គលិកពីរដង។)",
            "pool-dup": "ក្រុមបុគ្គលិក \"{pool}\" ត្រូវបានប្តេជ្ញាចំពោះ \"{title}\" សម្រាប់រយៈពេលដូចគ្នារួចហើយ — បុគ្គលិកដូចគ្នាអាចត្រូវកក់ពីរដង។ បន្តទៀតមែនទេ?"
          },
          "iss": {
            "skill-h": "ជំនាញមិនត្រូវគ្នា · ការចាត់តាំង {n}",
            "skill-none": "គ្មានជំនាញមិនត្រូវគ្នាបច្ចុប្បន្នទេ — បុគ្គលិកដែលបានចាត់តាំងទាំងអស់មានលក្ខណៈសម្បត្តិសម្រាប់តួនាទីរបស់ពួកគេ។",
            "skill-needs": "តួនាទីត្រូវការ {need} · បុគ្គលិកមាន {has}",
            "remove": "លុប",
            "rest-h": "ការបំពានច្បាប់សម្រាក · {n}",
            "rest-gap": "សម្រាក {h} · គោលការណ៍អប្បបរមា 11 ម៉ោង",
            "rest-sol": "បញ្ចូលថ្ងៃសម្រាករវាងវេនទាំងពីរ ឬផ្លាស់វេនក្រោយទៅបុគ្គលិកមានលក្ខណៈសម្បត្តិផ្សេង។ ប្រសិនបើបុគ្គលិកយល់ព្រមនឹងការសម្រាកខ្លី ហើយវាស្ថិតក្នុងដែនកំណត់គោលការណ៍ សូមជ្រើសទទួលយក និងកត់ចំណាំ ដើម្បីកត់ត្រាករណីលើកលែង។",
            "over-h": "បុគ្គលិកលើស · តំណែង-ថ្ងៃ 1",
            "over-detail": "ចាត់តាំង 19 ទល់នឹងត្រូវការ 18 · លើស +1 — ទំនងជាលើស Rith Kong (M)",
            "over-sol": "គ្មានកង្វះបើកចំហដើម្បីផ្ទេរទៅទេ ដូច្នេះការលុបវេនលើសគឺជាដំណោះស្រាយថោកបំផុត។ ប្រសិនបើការគ្របដណ្តប់បន្ថែមមានចេតនា (ការបណ្តុះបណ្តាល ឬបម្រុងសម្រាប់អវត្តមានរំពឹងទុក) សូមទទួលយក និងកត់ចំណាំ។",
            "over-sol-gaps": "ផ្ទេរបុគ្គលលើសទៅវេនដែលនៅខ្វះ (បើកចំហ {n}) — បំប្លែងថ្លៃខាតបង់ទៅជាការគ្របដណ្តប់។ បើមិនដូច្នេះ លុបវេនបន្ថែម។ ប្រសិនបើការគ្របដណ្តប់បន្ថែមមានចេតនា (ការបណ្តុះបណ្តាល / អវត្តមានរំពឹងទុក) សូមទទួលយក និងកត់ចំណាំ។",
            "affected": "ដែលរងផលប៉ះពាល់",
            "recommended": "ដំណោះស្រាយដែលបានណែនាំ",
            "remove-surplus": "លុបវេនលើស",
            "accept": "ទទួលយក និងកត់ចំណាំ…",
            "reason": "ហេតុផលសម្រាប់ទទួលយកបញ្ហានេះ (រក្សាទុកក្នុងកំណត់ត្រាសវនកម្ម)៖"
          },
          "no-issues": "គ្មានបញ្ហាបើកចំហទេ — តារាងវេនរួចរាល់។"
        },
        "port": {
          "sub": {
            "tenant": "វិសាលភាពទាំងអស់ · ផ្ទាំងប្រតិបត្តិការកាលវិភាគប្រតិបត្តិ · ការគ្របដណ្តប់ដែលបានផ្សព្វផ្សាយ + ចំនួនកំពុងដំណើរការសរុប · អានបានតែប៉ុណ្ណោះ",
            "client": "{client} · សេចក្តីសង្ខេបកាលវិភាគ · អានបានតែប៉ុណ្ណោះ",
            "company": "{company} · ឋានានុក្រមកាលវិភាគ · អានបានតែប៉ុណ្ណោះ (ប្រតិបត្តិការតារាងវេនធ្វើនៅវិសាលភាពម្ចាស់)"
          },
          "client-rollup": "សេចក្តីសង្ខេបអតិថិជន",
          "client": "អតិថិជន",
          "all-scopes": "វិសាលភាពទាំងអស់",
          "direct": "កម្លាំងពលកម្មផ្ទាល់",
          "direct-sub": "ម្ចាស់តារាងវេន · បុគ្គលិករបស់ក្រុមហ៊ុន",
          "project-sub": "{id} · ម្ចាស់តារាងវេន",
          "snapshot": "រូបថតតារាងវេន",
          "kpi": {
            "attention-workspaces": "កន្លែងធ្វើការដែលត្រូវយកចិត្តទុកដាក់",
            "attention-workspaces-tip": "កន្លែងធ្វើការដែលមានសូចនាករហានិភ័យពណ៌លឿង ឬក្រហម",
            "attention-units": "អង្គភាពដែលត្រូវយកចិត្តទុកដាក់",
            "attention-units-tip": "អង្គភាពដែលមានសូចនាករហានិភ័យពណ៌លឿង ឬក្រហម",
            "uncovered": "វេនខាងមុខមិនទាន់គ្របដណ្តប់",
            "uncovered-tip": "ថ្ងៃផែនការគ្មានតារាងវេនដែលបានផ្សព្វផ្សាយ + កន្លែងវេនមិនទាន់បំពេញក្នុងបង្អួចផែនការ",
            "coverage": "ការគ្របដណ្តប់បង្អួច",
            "coverage-tip": "ការគ្របដណ្តប់ដែលបានផ្សព្វផ្សាយនៃថ្ងៃផែនការក្នុងបង្អួចផែនការ (ប្រតិបត្តិការ — មិនមែនរយៈពេលបើកប្រាក់បៀវត្សទេ)",
            "oldest": "ការដំណើរការចាស់ជាងគេកំពុងដំណើរការ",
            "oldest-tip": "ការដំណើរការតារាងវេនចាស់ជាងគេបានចាប់ផ្តើម {date} · {name}",
            "nothing": "គ្មានអ្វីកំពុងដំណើរការ"
          },
          "top": "អាទិភាពខ្ពស់បំផុត",
          "review": "ពិនិត្យ",
          "ready": {
            "ready": "✅ រួចរាល់",
            "gaps": "❌ មានចន្លោះ"
          },
          "ready-tip": {
            "ready": "ការគ្របដណ្តប់តារាងវេនដែលត្រូវការទាំងអស់ក្នុងបង្អួចផែនការត្រូវបានផ្សព្វផ្សាយ",
            "gaps": "មានចន្លោះការគ្របដណ្តប់ វេនមិនទាន់ចាត់តាំង ឬតារាងវេនមិនទាន់ផ្សព្វផ្សាយក្នុងបង្អួចផែនការ"
          },
          "risk": {
            "uncovered": "ថ្ងៃផែនការ {n} គ្មានតារាងវេនដែលបានផ្សព្វផ្សាយក្នុងបង្អួច {days} ថ្ងៃខាងមុខ",
            "gaps": "កន្លែងវេនមិនទាន់បំពេញ {n} ក្នុងការគ្របដណ្តប់បង្អួចដែលបានផ្សព្វផ្សាយ",
            "inflight": "ការដំណើរការកំពុងដំណើរការ {n}៖ សេចក្តីព្រាង {d} · រង់ចាំការអនុម័ត {p} · បានអនុម័តមិនទាន់ផ្សព្វផ្សាយ {a}",
            "oldest": "ចាស់បំផុត {n} ថ្ងៃ",
            "published": "បង្អួចផែនការបានផ្សព្វផ្សាយពេញលេញ · គ្មានអ្វីកំពុងដំណើរការ",
            "no-plans": "គ្មានផែនការគ្របដណ្តប់ត្រូវការតារាងវេនទេ"
          },
          "inflight-tip": "សេចក្តីព្រាង {d} · រង់ចាំការអនុម័ត {p} · បានអនុម័តមិនទាន់ផ្សព្វផ្សាយ {a} — ចំនួនសរុបតែប៉ុណ្ណោះ ជួរតារាងវេននៅវិសាលភាពម្ចាស់",
          "col": {
            "workspace": "កន្លែងធ្វើការ",
            "scope": "វិសាលភាព",
            "risk": "ហានិភ័យ",
            "employees": "បុគ្គលិក",
            "plans": "ផែនការ",
            "plans-tip": "ផែនការគ្របដណ្តប់សកម្មដែលត្រូវការការគ្របដណ្តប់តាមតារាងវេន",
            "published": "បានផ្សព្វផ្សាយ",
            "published-tip": "តារាងវេនដែលបានផ្សព្វផ្សាយ (ផ្ទាល់)",
            "window": "ការគ្របដណ្តប់បង្អួច",
            "uncovered": "មិនទាន់គ្របដណ្តប់",
            "inflight": "កំពុងដំណើរការ ស · រ · អ",
            "inflight-tip": "សេចក្តីព្រាង · រង់ចាំការអនុម័ត · បានអនុម័តមិនទាន់ផ្សព្វផ្សាយ (ចំនួនតែប៉ុណ្ណោះ — ច្បាប់ PO)",
            "oldest": "ចាស់បំផុត",
            "ready": "រួចរាល់",
            "worst": "វិសាលភាពហានិភ័យខ្ពស់បំផុត",
            "worst-tip": "វិសាលភាពម្ចាស់ដែលមានហានិភ័យកាលវិភាគខ្ពស់បំផុតក្នុងកន្លែងធ្វើការនេះ",
            "roster": "តារាងវេន",
            "period": "រយៈពេល",
            "ver": "កំណែ",
            "coverage": "ការគ្របដណ្តប់",
            "by": "ដោយ / ពេល",
            "status": "ស្ថានភាព",
            "date": "កាលបរិច្ឆេទ",
            "shift": "វេន",
            "assigned": "បានចាត់តាំង"
          },
          "open": "បើក",
          "open-co-tip": "បើកកន្លែងធ្វើការក្រុមហ៊ុន — ប្រតិបត្តិការតារាងវេនធ្វើនៅវិសាលភាពម្ចាស់របស់វា",
          "open-tip": "បើកកន្លែងធ្វើកាលវិភាគ — វិសាលភាពម្ចាស់ (ប្រតិបត្តិការ)",
          "no-open": "អង្គភាពនេះគ្មានដៃគូក្នុងស្ថាប័នរបស់អ្នកដើម្បីបើកទេ។",
          "rosters": "តារាងវេន",
          "rosters-tip": "តារាងវេនដែលបានផ្សព្វផ្សាយ / បិទ (អានបានតែប៉ុណ្ណោះ)",
          "rollup": "សេចក្តីសង្ខេបអតិថិជន · អានបានតែប៉ុណ្ណោះ",
          "n-inflight": "កំពុងដំណើរការ {n}",
          "no-match": "គ្មានកន្លែងធ្វើការត្រូវនឹងតម្រងនេះទេ។",
          "foot-l1": "ផ្ទាំងប្រតិបត្តិការកាលវិភាគប្រតិបត្តិ · បង្អួចផែនការ = {days} ថ្ងៃខាងមុខចាប់ពី {date} (ប្រតិបត្តិការ — មិនមែនរយៈពេលបើកប្រាក់បៀវត្សទេ) · តារាងវេនកំពុងដំណើរការបង្ហាញជាចំនួនសរុបតែប៉ុណ្ណោះ ជួរ ការចាត់តាំង និងសកម្មភាពនៅវិសាលភាពម្ចាស់ · ជួរតម្រៀបតាមហានិភ័យ · ចុចជួរដើម្បីចូលលម្អិត",
          "foot-l2": "បង្អួចផែនការ = {days} ថ្ងៃខាងមុខចាប់ពី {date} · ចុចអង្គភាពសម្រាប់តារាងវេនដែលបានផ្សព្វផ្សាយរបស់វា (អានបានតែប៉ុណ្ណោះ)",
          "l2-lead": "ប្រតិបត្តិការតារាងវេនធ្វើនៅវិសាលភាពម្ចាស់ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង)។",
          "l2-text": "កម្រិតនេះបង្ហាញតែសេចក្តីសង្ខេបដែលបានផ្សព្វផ្សាយ ការគ្របដណ្តប់បង្អួច និងចំនួនកំពុងដំណើរការសរុបប៉ុណ្ណោះ — គ្មានជួរតារាងវេន ការចាត់តាំងបុគ្គលិក ឬសកម្មភាពទេ។ ជួរអតិថិជនជាសេចក្តីសង្ខេបរួម (អានបានតែប៉ុណ្ណោះ)។",
          "l3-empty": "មិនទាន់មានតារាងវេនដែលបានផ្សព្វផ្សាយសម្រាប់វិសាលភាពនេះទេ — កន្លែងធ្វើការម្ចាស់ផ្សព្វផ្សាយតាមកន្លែងធ្វើតារាងវេន។",
          "l3-note": "តែតារាងវេនដែលបានផ្សព្វផ្សាយ និងបានបិទប៉ុណ្ណោះ — ការដំណើរការកំពុងដំណើរការមិនដែលបង្ហាញនៅការត្រួតពិនិត្យទេ (ច្បាប់ PO)។ ចុចតារាងវេនសម្រាប់រូបថតរបស់វា។",
          "not-found": "រកមិនឃើញតារាងវេនដែលបានផ្សព្វផ្សាយទេ។",
          "l4-lead": "តារាងវេនដែលបានផ្សព្វផ្សាយ — រូបថតអានបានតែប៉ុណ្ណោះ។",
          "l4-text": "{title} · {period} · v{ver} · ផ្សព្វផ្សាយដោយ {by} ({when})។ ការកែប្រែធ្វើក្នុងកន្លែងធ្វើការម្ចាស់តាមការកែប្រែតារាងវេនដែលគ្រប់គ្រងជាមួយប្រវត្តិសវនកម្ម — មិនដែលនៅទីនេះទេ។",
          "l4-no-cells": "ព័ត៌មានលម្អិតកម្រិតក្រឡាសម្រាប់តារាងវេននេះនៅក្នុងកន្លែងធ្វើការម្ចាស់។ បើកវិសាលភាពម្ចាស់ — កន្លែងធ្វើតារាងវេន · តារាងវេនទាំងអស់ — ដើម្បីមើលក្រឡាពេញ។",
          "no-cells": "គ្មានក្រឡាក្នុងកំណត់ត្រាតារាងវេននេះទេ។"
        },
        "sa": {
          "new": "កាលវិភាគការងារថ្មី",
          "edit": "កែសម្រួលកាលវិភាគការងារ",
          "delete": "លុប",
          "cancel": "បោះបង់",
          "reload": "ផ្ទុកឡើងវិញ",
          "none": "— គ្មាន —",
          "next-day": "+១ ថ្ងៃ",
          "rolling": "វេនបង្វិល ២៤×៧",
          "rolling-note": "កាលវិភាគវេនបង្វិលមិនមានសប្ដាហ៍ថេរទេ ថ្ងៃរបស់វានៅដដែល លុះត្រាតែអ្នកផ្លាស់ប្ដូរ។",
          "no-meals": "មិនទាន់មានពេលសម្រាកអាហារទេ — បង្កើតមួយនៅ គំរូ › ពេលសម្រាកអាហារ។",
          "no-other": "មិនទាន់មានប្រតិទិនថ្ងៃឈប់សម្រាកផ្សេងទៀតទេ។",
          "sec": {
            "info": "១ · ព័ត៌មានកាលវិភាគ",
            "pattern": "២ · លំនាំការងារ",
            "preview": "៣ · ការមើលជាមុនរបស់ប្រព័ន្ធ"
          },
          "f": {
            "name": "ឈ្មោះកាលវិភាគ",
            "type": "ប្រភេទកាលវិភាគ",
            "status": "ស្ថានភាព",
            "days": "សប្ដាហ៍ធ្វើការ",
            "meal": "ពេលសម្រាកអាហារ",
            "holiday": "ប្រតិទិនថ្ងៃឈប់សម្រាកសាធារណៈ",
            "other": "ប្រតិទិនថ្ងៃឈប់សម្រាកផ្សេងទៀត"
          },
          "type": {
            "FullTime": "ពេញម៉ោង",
            "PartTime": "ក្រៅម៉ោង"
          },
          "status": {
            "Active": "សកម្ម",
            "Inactive": "អសកម្ម"
          },
          "col": {
            "day": "ថ្ងៃ",
            "start": "ចាប់ផ្ដើម",
            "end": "បញ្ចប់",
            "half": "កន្លះថ្ងៃ"
          },
          "day": {
            "Monday": "ថ្ងៃច័ន្ទ",
            "Tuesday": "ថ្ងៃអង្គារ",
            "Wednesday": "ថ្ងៃពុធ",
            "Thursday": "ថ្ងៃព្រហស្បតិ៍",
            "Friday": "ថ្ងៃសុក្រ",
            "Saturday": "ថ្ងៃសៅរ៍",
            "Sunday": "ថ្ងៃអាទិត្យ"
          },
          "day-short": {
            "Mon": "ច",
            "Tue": "អ",
            "Wed": "ព",
            "Thu": "ព្រ",
            "Fri": "សុ",
            "Sat": "ស",
            "Sun": "អា"
          },
          "aria": {
            "working": "{day} ជាថ្ងៃធ្វើការ",
            "start": "ម៉ោងចាប់ផ្ដើម {day}",
            "end": "ម៉ោងបញ្ចប់ {day}",
            "half": "{day} ជាកន្លះថ្ងៃ"
          },
          "err": {
            "name-required": "ត្រូវការឈ្មោះកាលវិភាគ។",
            "name-too-long": "ឈ្មោះកាលវិភាគមិនអាចលើសពី ២០០ តួអក្សរទេ។",
            "name-taken": "មានកាលវិភាគដែលមានឈ្មោះនេះរួចហើយនៅក្នុងក្រុមហ៊ុននេះ។",
            "no-working-day": "សូមធីកយ៉ាងហោចណាស់ថ្ងៃធ្វើការមួយ។",
            "incomplete": "{day}៖ សូមផ្ដល់ទាំងម៉ោងចាប់ផ្ដើម និងម៉ោងបញ្ចប់។",
            "bad-time": "{day}៖ ម៉ោងត្រូវសរសេរជាទម្រង់ ២៤ ម៉ោង ឧ. 08:00។",
            "same-time": "{day}៖ ម៉ោងចាប់ផ្ដើម និងម៉ោងបញ្ចប់មិនអាចដូចគ្នាបានទេ។",
            "half-too-long": "{day}៖ កន្លះថ្ងៃមិនអាចលើសពី ៤ ម៉ោងទេ។",
            "too-many-meals": "កាលវិភាគមួយអាចមានពេលសម្រាកអាហារច្រើនបំផុត ១០។",
            "too-many-other": "កាលវិភាគមួយអាចមានប្រតិទិនថ្ងៃឈប់សម្រាកផ្សេងទៀតច្រើនបំផុត ២០។",
            "version": "កាលវិភាគនេះត្រូវបានអ្នកផ្សេងផ្លាស់ប្ដូរ តាំងពីអ្នកបានបើកវា។ សូមផ្ទុកវាឡើងវិញ ហើយធ្វើការផ្លាស់ប្ដូររបស់អ្នកម្ដងទៀត។",
            "generic": "មិនអាចរក្សាទុកកាលវិភាគបានទេ។ សូមព្យាយាមម្ដងទៀត។"
          },
          "preview": {
            "hours": "ម៉ោង / សប្ដាហ៍",
            "working": "ថ្ងៃធ្វើការ",
            "off": "ថ្ងៃឈប់ប្រចាំសប្ដាហ៍",
            "linked": "បានភ្ជាប់",
            "meal": "អាហារ",
            "holiday": "ថ្ងៃឈប់សម្រាក",
            "other": "ផ្សេងទៀត",
            "assigned": "បានចាត់តាំង",
            "assigned-n": "បុគ្គលិក {n} នាក់នៅលើកាលវិភាគនេះ",
            "assigned-none": "មិនទាន់មានទេ — ចាត់តាំងបុគ្គលិកក្រោយពេលរក្សាទុក"
          },
          "confirm": {
            "edit-title": "ផ្លាស់ប្ដូរកាលវិភាគដែលកំពុងប្រើ?",
            "edit-body": "ការនេះផ្លាស់ប្ដូរផែនការរបស់បុគ្គលិក {n} នាក់ រួមទាំងថ្ងៃកន្លងមក។",
            "edit-ok": "រក្សាទុកការផ្លាស់ប្ដូរ",
            "delete-title": "លុបកាលវិភាគនេះ?",
            "delete-body": "លុប “{name}”? សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
            "delete-body-assigned": "បុគ្គលិក {n} នាក់នៅលើ “{name}”។ សូមផ្ទេរពួកគេទៅកាលវិភាគផ្សេងជាមុនសិន — មិនអាចលុបបានទេ ខណៈមាននរណាម្នាក់នៅលើវា។",
            "remove-title": "លុបធាតុនេះ?",
            "remove-body": "លុប “{name}”? សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
            "remove-body-used": "“{name}” ត្រូវបានប្រើដោយកាលវិភាគ {n}។ សូមដកវាចេញពីកាលវិភាគទាំងនោះជាមុនសិន — មិនអាចលុបបានទេ ខណៈកំពុងប្រើ។"
          },
          "toast": {
            "created": "បានបង្កើតកាលវិភាគ “{name}”",
            "saved": "បានរក្សាទុកកាលវិភាគ “{name}”",
            "deleted": "បានលុប “{name}”",
            "no-changes": "គ្មានអ្វីផ្លាស់ប្ដូរទេ។"
          },
          "rotation": {
            "kind": {
              "fixed": "ថេរ",
              "rotation": "វេនបង្វិល"
            },
            "kind-locked": "មានបុគ្គលិក {n} នាក់នៅលើកាលវិភាគនេះ ដូច្នេះមិនអាចប្តូរប្រភេទរបស់វាបានទេ។ សូមផ្លាស់ពួកគេទៅកាលវិភាគផ្សេងជាមុនសិន។",
            "f": {
              "pattern": "លំនាំវេនបង្វិល",
              "sequence": "លំដាប់វេន",
              "summary": "សេចក្តីសង្ខេបវេនបង្វិល (អានតែប៉ុណ្ណោះ)",
              "holiday": "ប្រតិទិនថ្ងៃឈប់សម្រាក"
            },
            "select-pattern": "— ជ្រើសរើសលំនាំវេនបង្វិល —",
            "stray-pattern": "{name} (លែងផ្តល់ជូនទៀតហើយ)",
            "new-pattern": "លំនាំថ្មី",
            "new-pattern-title": "បង្កើតលំនាំវេនបង្វិលថ្មី ហើយភ្ជាប់វានៅទីនេះ",
            "pattern-hint": "កាលវិភាគនេះប្រើលំដាប់វេន / ថ្ងៃឈប់ និងវដ្តរបស់លំនាំនេះឡើងវិញ។ កែលំនាំ ដើម្បីប្តូរលំដាប់។",
            "linked": "កំណត់ដោយលំនាំវេនបង្វិលដែលបានភ្ជាប់",
            "no-pattern": "ជ្រើសរើស ឬបង្កើតលំនាំវេនបង្វិលខាងលើ — វាកំណត់លំដាប់វេន / ថ្ងៃឈប់ និងវដ្តសម្រាប់កាលវិភាគនេះ។",
            "loading": "កំពុងផ្ទុកលំនាំការងារ…",
            "load-error": "មិនអាចផ្ទុកលំនាំការងារបានទេ។",
            "retry": "ព្យាយាមម្តងទៀត",
            "err": {
              "pattern-required": "កាលវិភាគវេនបង្វិលត្រូវការលំនាំវេនបង្វិល។"
            },
            "sum": {
              "cycle": "រយៈពេលវដ្ត",
              "days": "{n} ថ្ងៃ",
              "sequence": "លំដាប់",
              "working": "ថ្ងៃធ្វើការ",
              "rest": "ថ្ងៃសម្រាក",
              "night": "វេនយប់",
              "cross": "វេនឆ្លងកាត់អធ្រាត្រ",
              "hours": "ម៉ោងតាមកាលវិភាគ",
              "auto": "អនុវត្តចំពោះការរៀបចំវេនស្វ័យប្រវត្តិ",
              "yes": "បាទ/ចាស",
              "no": "ទេ",
              "off": "ថ្ងៃឈប់ / ថ្ងៃសម្រាក",
              "anchor": "ថ្ងៃទី 1 នៃវដ្ត៖ {date} · ធ្វើឡើងវិញរៀងរាល់ {n} ថ្ងៃ",
              "anchor-new": "ថ្ងៃទី 1 នៃវដ្ត៖ ថ្ងៃដែលកាលវិភាគនេះត្រូវបានបង្កើត · ធ្វើឡើងវិញរៀងរាល់ {n} ថ្ងៃ",
              "source": "ទាញចេញពីលំនាំវេនបង្វិលដែលបានភ្ជាប់ · គណនាដោយស្វ័យប្រវត្តិ មិនអាចកែបានទេ។"
            },
            "preview": {
              "type": "ប្រភេទ",
              "pattern": "លំនាំ",
              "line": "វេន {n}, វដ្ត {cycle} ថ្ងៃ",
              "auto": "រៀបចំវេនស្វ័យប្រវត្តិ"
            },
            "warn": {
              "no-pattern": "វេនបង្វិលមិនមានវេនក្នុងលំដាប់របស់វាទេ — សូមភ្ជាប់លំនាំវេនបង្វិល។",
              "no-shifts": "មិនទាន់មានវេនសម្រាប់ក្រុមហ៊ុននេះនៅឡើយទេ — សូមបង្កើតវេនជាមុនសិន។"
            },
            "row": {
              "pattern": "លំនាំ៖ {name}",
              "pattern-cycle": "លំនាំ៖ {name} · វដ្ត {n} ថ្ងៃ"
            }
          }
        },
        "assign": {
          "title": "បុគ្គលិក",
          "count": "{n} នាក់នៅលើកាលវិភាគនេះ",
          "assign-btn": "ចាត់តាំងបុគ្គលិក",
          "search": "ស្វែងរកឈ្មោះ ឬលេខកូដ…",
          "search-aria": "ស្វែងរកបុគ្គលិកនៅលើកាលវិភាគនេះ",
          "col": {
            "code": "លេខកូដ",
            "name": "ឈ្មោះ",
            "since": "មានប្រសិទ្ធភាពពី",
            "actions": "សកម្មភាព"
          },
          "move": "ផ្លាស់ប្ដូរ…",
          "end": "បញ្ចប់…",
          "move-aria": "ផ្លាស់ប្ដូរ {name} ទៅកាលវិភាគផ្សេង",
          "end-aria": "បញ្ចប់ការចាត់តាំងរបស់ {name}",
          "empty": "មិនទាន់មាននរណាម្នាក់នៅលើកាលវិភាគនេះទេ។",
          "empty-search": "គ្មាននរណាម្នាក់នៅលើកាលវិភាគនេះត្រូវនឹង “{q}” ទេ។",
          "loading": "កំពុងផ្ទុកបុគ្គលិក…",
          "error": "មិនអាចផ្ទុកបញ្ជីអ្នកនៅលើកាលវិភាគនេះបានទេ។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "modal": {
            "title": "ចាត់តាំងបុគ្គលិកទៅ {name}",
            "effective": "មានប្រសិទ្ធភាពពី",
            "search": "ស្វែងរកឈ្មោះ លេខកូដ ឬមុខតំណែង…",
            "search-aria": "ស្វែងរកបុគ្គលិក",
            "show-assigned": "បង្ហាញបុគ្គលិកដែលមានកាលវិភាគរួចហើយ ({n}) — មើលបានតែប៉ុណ្ណោះ មិនអាចជ្រើសរើសបានទេ",
            "allow-move": "ផ្លាស់ប្ដូរអ្នកដែលមានកាលវិភាគរួចហើយផងដែរ",
            "on": "នៅលើ {name}",
            "on-this": "នៅលើកាលវិភាគនេះរួចហើយ",
            "help": "អាចជ្រើសរើសបានតែបុគ្គលិកដែលមិនទាន់មានកាលវិភាគប៉ុណ្ណោះ។ បុគ្គលិកម្នាក់អនុវត្តតាមកាលវិភាគការងារតែមួយក្នុងពេលតែមួយ ដូច្នេះបុគ្គលិកដែលមានកាលវិភាគរួចហើយត្រូវបានលាក់តាមលំនាំដើម; សូមធីកប្រអប់ខាងលើដើម្បីមើលពួកគេ (ជាប់សោ)។",
            "selected": "បានជ្រើសរើស {n}",
            "select-all": "ជ្រើសរើសទាំងអស់ដែលបង្ហាញ",
            "clear": "សម្អាតការជ្រើសរើស",
            "none": "គ្មានបុគ្គលិកដែលមិនទាន់ចាត់តាំងទេ — សូមធីក “បង្ហាញបុគ្គលិកដែលមានកាលវិភាគរួចហើយ” ដើម្បីមើលអ្នកដែលបានចាត់តាំង។",
            "no-match": "គ្មានបុគ្គលិកត្រូវនឹង “{q}” ទេ។",
            "too-many": "កំពុងបង្ហាញ {n} នាក់ដំបូង — សូមកែលម្អការស្វែងរកដើម្បីមើលអ្នកដែលនៅសល់។",
            "submit": "ចាត់តាំង {n}",
            "cancel": "បោះបង់",
            "done": "រួចរាល់",
            "progress": "កំពុងចាត់តាំង… {done} នៃ {total}",
            "loading": "កំពុងផ្ទុកបុគ្គលិក…",
            "error": "មិនអាចផ្ទុកបុគ្គលិកបានទេ។",
            "retry": "ព្យាយាមម្ដងទៀត",
            "date-required": "សូមជ្រើសរើសកាលបរិច្ឆេទដែលកាលវិភាគចាប់ផ្ដើម។",
            "list-label": "បុគ្គលិកដែលត្រូវចាត់តាំង"
          },
          "result": {
            "title": "លទ្ធផល",
            "assigned": "បានចាត់តាំង {n}",
            "unchanged": "{n} នៅលើកាលវិភាគនេះរួចហើយ",
            "skipped": "បានរំលង {n}",
            "stopped": "បានបញ្ឈប់៖ {detail} {n} មិនបានផ្ញើទេ។"
          },
          "reason": {
            "NOT_FOUND": "រកមិនឃើញនៅក្នុងក្រុមហ៊ុននេះទេ",
            "MODE_NOT_CLASSIC": "ស្ថិតនៅលើគំរូកាលវិភាគផ្សេង",
            "BACKDATE_BEFORE_CURRENT": "កាលបរិច្ឆេទមុនពេលកាលវិភាគបច្ចុប្បន្នរបស់ពួកគេចាប់ផ្ដើម",
            "Unknown": "មិនបានចាត់តាំងទេ"
          },
          "change": {
            "move-title": "ផ្លាស់ប្ដូរ {name}",
            "assign-title": "ចាត់តាំងកាលវិភាគការងារឱ្យ {name}",
            "end-title": "បញ្ចប់កាលវិភាគរបស់ {name}",
            "schedule": "កាលវិភាគការងារ",
            "from": "មានប្រសិទ្ធភាពពី",
            "to": "ថ្ងៃចុងក្រោយនៅលើកាលវិភាគ",
            "end-body": "{name} ចាកចេញពី {schedule} បន្ទាប់ពីថ្ងៃនេះ។ ប្រវត្តិរក្សាទុករយៈពេលនោះ។",
            "choose": "ជ្រើសរើសកាលវិភាគ",
            "no-templates": "គ្មានកាលវិភាគសកម្មផ្សេងទៀតសម្រាប់ជ្រើសរើសទេ។",
            "submit-move": "ផ្លាស់ប្ដូរ",
            "submit-assign": "ចាត់តាំង",
            "submit-end": "បញ្ចប់ការចាត់តាំង",
            "required": "សូមជ្រើសរើសកាលវិភាគ និងកាលបរិច្ឆេទ។",
            "date-required": "សូមជ្រើសរើសកាលបរិច្ឆេទ។"
          },
          "toast": {
            "assigned": "បានចាត់តាំង {n} ទៅ {name}",
            "moved": "បានផ្លាស់ប្ដូរ {name} ទៅ {schedule}",
            "ended": "កាលវិភាគរបស់ {name} បានបញ្ចប់"
          },
          "err": {
            "generic": "ការផ្លាស់ប្ដូរត្រូវបានបដិសេធ។ សូមព្យាយាមម្ដងទៀត។"
          },
          "upcoming-from": "ចាប់ពី {date}",
          "upcoming-title": "ផ្លាស់មកកាលវិភាគនេះនៅថ្ងៃ {date}",
          "until": "រហូតដល់ {date}"
        },
        "monthly": {
          "nav": "កាលវិភាគប្រចាំខែ",
          "title": "កាលវិភាគប្រចាំខែ",
          "subtitle": "ថ្ងៃធ្វើការដែលបានគ្រោងទុករបស់បុគ្គលិកទាំងអស់ដែលប្រើកាលវិភាគការងារបុរាណ។",
          "prev": "ខែមុន",
          "next": "ខែបន្ទាប់",
          "this-month": "ខែនេះ",
          "from": "ពី",
          "to": "ដល់",
          "range": "{from} – {to}",
          "window-error": {
            "invalid": "សូមបញ្ចូលកាលបរិច្ឆេទចាប់ផ្ដើម និងបញ្ចប់ឱ្យបានត្រឹមត្រូវ។",
            "order": "កាលបរិច្ឆេទចាប់ផ្ដើមមិនត្រូវនៅក្រោយកាលបរិច្ឆេទបញ្ចប់ទេ។",
            "too-long": "សូមជ្រើសរើសមិនលើសពី {max} ថ្ងៃ។ ចន្លោះនេះមាន {days} ថ្ងៃ។"
          },
          "schedule": "កាលវិភាគការងារ",
          "schedule-all": "កាលវិភាគការងារទាំងអស់",
          "search-label": "ស្វែងរកបុគ្គលិក",
          "search": "ឈ្មោះ លេខកូដ ឬកាលវិភាគ",
          "excluded": "បុគ្គលិក {n} នាក់ដែលប្រើគំរូការិយាល័យ ឬតារាងវេន មិនត្រូវបានបង្ហាញនៅទីនេះទេ។ | បុគ្គលិក {n} នាក់ដែលប្រើគំរូការិយាល័យ ឬតារាងវេន មិនត្រូវបានបង្ហាញនៅទីនេះទេ។",
          "showing": "កំពុងបង្ហាញ {shown} ក្នុងចំណោមបុគ្គលិក {loaded} នាក់ដែលបានផ្ទុក",
          "updating": "កំពុងធ្វើបច្ចុប្បន្នភាព…",
          "more-available": "នៅមានបុគ្គលិកទៀត។ សូមផ្ទុកបន្ថែម ដើម្បីបញ្ចូលពួកគេក្នុងតារាង និងការនាំចេញ។",
          "load-more": "ផ្ទុកបន្ថែម",
          "chip": {
            "schedule": "កាលវិភាគ៖ {name}",
            "search": "ស្វែងរក៖ {q}",
            "remove": "ដកតម្រង {label}"
          },
          "clear-filters": "សម្អាតតម្រង",
          "empty": "មិនមានបុគ្គលិកកាលវិភាគបុរាណក្នុងចន្លោះពេលនេះទេ។",
          "empty-filtered": "មិនមានបុគ្គលិកត្រូវនឹងតម្រងទាំងនេះទេ។",
          "error": "មិនអាចផ្ទុកកាលវិភាគប្រចាំខែបានទេ។",
          "retry": "ព្យាយាមម្តងទៀត",
          "scroll-label": "តារាងកាលវិភាគប្រចាំខែ អាចរំកិលបាន",
          "grid-label": "កាលវិភាគប្រចាំខែពី {from} ដល់ {to}",
          "hours-short": "{h} ម៉ោង",
          "col": {
            "employee": "បុគ្គលិក",
            "code": "លេខកូដបុគ្គលិក",
            "name": "ឈ្មោះ",
            "schedule": "កាលវិភាគការងារ",
            "hours": "ម៉ោង",
            "work-days": "ថ្ងៃធ្វើការ",
            "ph": "ថ្ងៃបុណ្យ",
            "off": "ថ្ងៃសម្រាក"
          },
          "foot": {
            "working": "ធ្វើការ · ម៉ោង",
            "day": "{n} នាក់ធ្វើការ · {h} ម៉ោង"
          },
          "code": {
            "half": "½",
            "off": "សម្រាក",
            "ph": "បុណ្យ",
            "ovr": "កែ",
            "none": "—",
            "unknown": "?"
          },
          "legend": {
            "work": "ថ្ងៃធ្វើការ",
            "half": "កន្លះថ្ងៃ",
            "off": "ថ្ងៃសម្រាក",
            "ph": "ថ្ងៃបុណ្យសាធារណៈ",
            "ovr": "ថ្ងៃដែលបានកែប្រែ",
            "none": "មិនមានកាលវិភាគនៅថ្ងៃនោះ",
            "weekend": "ចុងសប្ដាហ៍"
          },
          "ovr": {
            "CHANGE_DAY_OFF": "ថ្ងៃសម្រាកត្រូវបានផ្លាស់ប្ដូរ",
            "DAY_CHANGE": "ម៉ោងត្រូវបានផ្លាស់ប្ដូរ",
            "DAY_OFF": "ថ្ងៃសម្រាកបន្ថែម",
            "WORKING_DAY": "ថ្ងៃធ្វើការបន្ថែម",
            "HOLIDAY_WORK": "ធ្វើការនៅថ្ងៃបុណ្យ",
            "Unknown": "ថ្ងៃដែលបានកែប្រែ"
          },
          "dow": {
            "0": "អា",
            "1": "ច",
            "2": "អ",
            "3": "ពុ",
            "4": "ព្រ",
            "5": "សុ",
            "6": "ស"
          },
          "months": {
            "1": "មករា",
            "2": "កុម្ភៈ",
            "3": "មីនា",
            "4": "មេសា",
            "5": "ឧសភា",
            "6": "មិថុនា",
            "7": "កក្កដា",
            "8": "សីហា",
            "9": "កញ្ញា",
            "10": "តុលា",
            "11": "វិច្ឆិកា",
            "12": "ធ្នូ"
          },
          "rotation": {
            "legend": "វេនការងារតាមវដ្ត — លេខកូដវេននៅពីលើម៉ោង",
            "pattern": "លំនាំ៖ {name}",
            "cycle-day": "ថ្ងៃទី {n} នៃវដ្ត",
            "shift": "វេន៖ {code}",
            "shift-named": "វេន៖ {code} ({name})",
            "planned": "វេនដែលបានគ្រោង៖ {code} {time}",
            "missing-shift": "រកមិនឃើញវេនរបស់លំនាំសម្រាប់ថ្ងៃនេះទេ",
            "missing-pattern": "មិនអាចអានលំនាំវដ្តបានទេ"
          }
        },
        "live": {
          "not-built": {
            "title": "មិនទាន់អាចប្រើបាននៅឡើយ",
            "body": "វេន និងលំនាំការងារ កំពុងត្រូវបានភ្ជាប់ទៅសេវាកម្មផ្ទាល់។ ពួកវានឹងបង្ហាញនៅទីនេះ ភ្លាមៗនៅពេលការងារនោះត្រូវបានចេញផ្សាយ។"
          },
          "error": "មិនអាចផ្ទុកបញ្ជីបានទេ។",
          "retry": "ព្យាយាមម្តងទៀត"
        }
      }
    },
    "workmgmt": {
      "title": "ការគ្រប់គ្រងការងារ",
      "subtitle": "{scope} · {active} ធាតុការងារសកម្ម · {critical} សំខាន់",
      "tabs": {
        "dashboard": "ផ្ទាំងព័ត៌មាន",
        "mywork": "ការងាររបស់ខ្ញុំ",
        "teamwork": "ការងារក្រុម",
        "queues": "ជួរការងារ",
        "recurring": "ការងារដែលកើតឡើងឡើងវិញ",
        "reviews": "ការវាយតម្លៃ",
        "reports": "របាយការណ៍"
      },
      "dashboard": {
        "heading": "ទិដ្ឋភាពប្រតិបត្តិការ",
        "heading-sub": "{review} កំពុងរង់ចាំការវាយតម្លៃ · {overdue} ហួសកាលកំណត់ · {critical} សំខាន់ · {active} សកម្ម",
        "request-work": "ស្នើសុំការងារ",
        "new-work": "ការងារថ្មី",
        "create-toast": "អ្នកមគ្គទេសក៍បង្កើតការងារនឹងមកដល់ក្នុងស្រាប់ៗ",
        "request-toast": "ទម្រង់ស្នើសុំការងារនឹងមកដល់ក្នុងស្រាប់ៗ",
        "banner-lead": "ការគ្រប់គ្រងការងារ",
        "banner-body": "រៀបចំការអនុវត្តប្រតិបត្តិការ។ ការអនុម័តនៅតែស្ថិតក្នុងម៉ូឌុលប្រភពរបស់ខ្លួន (ច្បាប់ / OT / ការធ្វើដំណើរ / ការចំណាយ)។ អ្នកវាយតម្លៃអាចវាយដំណើរការនៃការងារដែលបានបញ្ចប់ — ការវាយតម្លៃគឺជាជម្រើស និងផ្ដល់ដល់ Contribution Score សម្រាប់ការគ្រប់គ្រងការអនុវត្តន៍។",
        "view-all": "មើលទាំងអស់",
        "kpi": {
          "my-open": "ការងារបើករបស់ខ្ញុំ",
          "my-open-meta": "កំពុងដំណើរការ + បើក",
          "awaiting-review": "កំពុងរង់ចាំការវាយតម្លៃ",
          "awaiting-review-meta": "បានដាក់ស្នើ ជាមួយអ្នកវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់",
          "overdue-meta": "ត្រូវការការយកចិត្តទុកដាក់",
          "contribution": "ពិន្ទុការរួមចំណែករបស់ខ្ញុំ",
          "contribution-meta": "ពិន្ទុរំកិលត្រីមាស",
          "vs-prev": "ធៀបនឹង ៩០ ថ្ងៃមុន",
          "no-rated": "មិនទាន់មានការងារបានវាយតម្លៃ"
        },
        "table": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "អ្នកទទួលការងារ",
          "due": "កំណត់"
        },
        "awaiting": {
          "heading": "កំពុងរង់ចាំការវាយតម្លៃរបស់ខ្ញុំ",
          "sub": "{pending} កំពុងរង់ចាំ · {active} កំពុងដំណើរការ",
          "empty": "មិនមានការងារកំពុងរង់ចាំការវាយតម្លៃ។"
        },
        "workload": {
          "heading": "បន្ទុកការងារក្រុម",
          "sub": "ការងារសកម្មក្នុងម្នាក់ៗ",
          "view-team": "មើលក្រុម",
          "active": "{n} សកម្ម",
          "overdue": "{n} ហួសកាលកំណត់",
          "empty": "មិនមានសមាជិកក្រុមនៅក្នុងវិសាលភាព។"
        },
        "contributors": {
          "heading": "អ្នករួមចំណែកកំពូល (៩០ ថ្ងៃ)",
          "sub": "តម្រៀបតាមពិន្ទុការរួមចំណែក",
          "all-scores": "ពិន្ទុទាំងអស់",
          "rated": "បានវាយតម្លៃ {n}",
          "empty": "មិនទាន់មានការងារបានវាយតម្លៃ។"
        },
        "activity": {
          "heading": "សកម្មភាពកន្លែងធ្វើការ",
          "sub": "៣០ ថ្ងៃចុងក្រោយ",
          "active": "ការងារសកម្ម",
          "completed": "បានបញ្ចប់ (៣០ថ្ងៃ)",
          "overdue": "ហួសកាលកំណត់",
          "avg-score": "ពិន្ទុរួមចំណែកជាមធ្យម"
        },
        "recent": {
          "heading": "ការងារថ្មីៗរបស់ខ្ញុំ",
          "sub": "បើក + កំពុងដំណើរការ + កំពុងរង់ចាំការវាយតម្លៃ",
          "empty": "មិនមានការងារថ្មីៗក្នុងជួរអ្នក។"
        },
        "drawer": {
          "assignee": "អ្នកទទួលការងារ",
          "reviewer": "អ្នកវាយតម្លៃ",
          "assigner": "អ្នកប្រគល់ការងារ",
          "due": "កំណត់",
          "dept": "នាយកដ្ឋាន",
          "linked-module": "ម៉ូឌុលភ្ជាប់",
          "rating": "ការវាយតម្លៃរួមចំណែក",
          "review-comment": "មតិយោបល់របស់អ្នកវាយតម្លៃ",
          "close": "បិទ"
        }
      },
      "mywork": {
        "heading": "ការងាររបស់ខ្ញុំ",
        "heading-sub": "{total} សរុប",
        "self-work": "ការងារខ្លួនឯង",
        "create-toast": "ទម្រង់បង្កើតការងារខ្លួនឯងនឹងមកដល់ក្នុងស្រាប់ៗ",
        "kpi": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "ការវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់"
        },
        "filters": {
          "search-placeholder": "ស្វែងរកតាមចំណងជើង ឬ ID…",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "status-open": "បើក",
          "status-progress": "កំពុងដំណើរការ",
          "status-review": "ការវាយតម្លៃ",
          "status-done": "បានបញ្ចប់",
          "all-types": "ប្រភេទការងារទាំងអស់",
          "type-adhoc": "Ad-hoc",
          "type-recurring": "កើតឡើងវិញ",
          "all-priorities": "អាទិភាពទាំងអស់",
          "priority-high": "ខ្ពស់",
          "priority-med": "មធ្យម",
          "priority-low": "ទាប"
        },
        "stub": {
          "title": "វត្ថុការងាររបស់ខ្ញុំ",
          "lede": "ក្ដារការងារផ្ទាល់ខ្លួនដាក់ជាក្រុមតាមស្ថានភាព ជាមួយ badge ហួសកាលកំណត់ ស្នាមជើងកើតឡើងវិញ និង callback វាយតម្លៃការរួមចំណែក។ ទិដ្ឋភាព grid និង drawer នឹងមកដល់ក្នុងស្រាប់ៗ។"
        }
      },
      "teamwork": {
        "heading": "ការងារក្រុម",
        "heading-sub": "ការងារដែលអ្នកវាយតម្លៃ · {total} សរុប",
        "heading-sub-admin": "ការងារទាំងអស់ក្នុងកន្លែងធ្វើការ · {total} សរុប",
        "assign-work": "ផ្ដល់ការងារ",
        "create-toast": "ទម្រង់ផ្ដល់ការងារនឹងមកដល់ក្នុងស្រាប់ៗ",
        "result-count": "ការងារ {n}",
        "kpi": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "ការវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់"
        },
        "filters": {
          "search-placeholder": "ស្វែងរក…",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "all-types": "ប្រភេទការងារទាំងអស់",
          "all-assignees": "បុគ្គលិកទាំងអស់"
        },
        "table": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "due": "កាលកំណត់"
        },
        "empty": {
          "title": "មិនមានការងារត្រូវនឹងតម្រង",
          "lede": "សូមបន្ធូរតម្រងមួយ ឬសម្អាតការស្វែងរក ដើម្បីមើលការងារបន្ថែម។"
        },
        "drawer": {
          "close": "បិទផ្ទាំង",
          "dept": "នាយកដ្ឋាន · {dept}",
          "description": "ការពិពណ៌នា",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "reviewer": "អ្នកវាយតម្លៃ",
          "assigner": "ផ្ដល់ដោយ",
          "due": "កាលកំណត់",
          "start": "ចាប់ផ្ដើម",
          "linked": "ភ្ជាប់ទៅ",
          "tags": "ស្លាក"
        }
      },
      "queues": {
        "heading": "ជួរការងារ",
        "heading-sub": "Optimal P · {total} វត្ថុការងារសកម្មនៅទូទាំងជួរ",
        "banner-lead": "ជួរការងារ",
        "banner-body": "ដាក់ការងារសកម្មជាក្រុមតាមតំបន់ប្រតិបត្តិការសម្រាប់ការត្រួតពិនិត្យ។ ជួរសំខាន់បង្ហាញនូវវត្ថុហួសកាលកំណត់ និងប្រឈមនឹងហានិភ័យដែលត្រូវការការយកចិត្តទុកដាក់ភ្លាមៗ។",
        "view-all": "មើលទាំងអស់ក្នុងជួរ",
        "all-clear": "គ្មានការងារសំខាន់ក្នុងជួរនេះទេ",
        "card-aria": "បើកព័ត៌មានលម្អិតរបស់ {name}",
        "counts": {
          "active": "សកម្ម",
          "at-risk": "ប្រឈមនឹងហានិភ័យ",
          "overdue": "ហួសកាលកំណត់"
        },
        "cards": {
          "payroll": {
            "name": "ជួរប្រាក់ខែ",
            "desc": "ប្រតិបត្តិការប្រាក់ខែ និងការតាមដាន"
          },
          "hrops": {
            "name": "ជួរប្រតិបត្តិការ HR",
            "desc": "ប្រតិបត្តិការ HR ការទទួលបុគ្គលិកថ្មី និងការផ្លាស់ប្ដូរបុគ្គលិក"
          },
          "compliance": {
            "name": "ជួរការអនុលោម",
            "desc": "ការប្រកាសច្បាប់ ការត្រួតពិនិត្យ និងលិខិតអនុញ្ញាត"
          },
          "fieldops": {
            "name": "ជួរប្រតិបត្តិការវាល",
            "desc": "ការពិនិត្យកន្លែង និងប្រតិបត្តិការវាល"
          },
          "critical": {
            "name": "ជួរសំខាន់",
            "desc": "ត្រូវការការយកចិត្តទុកដាក់បន្ទាន់ (ហួសកាលកំណត់ ប្រឈមនឹងហានិភ័យ សំខាន់)"
          }
        },
        "drawer": {
          "sub": "{n} សកម្ម",
          "empty": "គ្មានការងារសកម្មក្នុងជួរនេះទេ។",
          "close": "បិទផ្ទាំងជ្រើស",
          "cols": {
            "work-item": "វត្ថុការងារ",
            "status": "ស្ថានភាព",
            "assignee": "អ្នកទទួលបន្ទុក",
            "due": "កាលកំណត់"
          }
        }
      },
      "recurring": {
        "heading": "ការងារដែលកើតឡើងឡើងវិញ",
        "heading-sub": "បង្កើតដោយស្វ័យប្រវត្តិតាមកាលវិភាគពីគំរូប្រតិបត្តិការ · សកម្ម {total}",
        "new-template": "គំរូថ្មី",
        "create-toast": "កម្មវិធីកែសម្រួលគំរូនឹងមកដល់ក្នុងស្រាប់ៗ",
        "banner": "គំរូបង្កើតការងារប្រតិបត្តិការតាមកាលវិភាគ (ឧ. ការប្រកាស NSSF ប្រចាំខែ, ការពិនិត្យកន្លែងប្រចាំសប្ដាហ៍)។ កម្មវិធីកែសម្រួលសម្រាប់ checklists, ច្បាប់អ្នកវាយតម្លៃ, និងលំនាំដើម SLA នឹងមកដល់ក្នុងស្រាប់ៗ។",
        "result-count": "ការងារ {n}",
        "kpi": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "ការវាយតម្លៃ",
          "overdue": "ហួសកាលកំណត់"
        },
        "filters": {
          "search-placeholder": "ស្វែងរក…",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "all-priorities": "អាទិភាពទាំងអស់",
          "all-assignees": "បុគ្គលិកទាំងអស់"
        },
        "table": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "due": "កាលកំណត់"
        },
        "empty": {
          "title": "មិនមានការងារដែលកើតឡើងវិញត្រូវនឹងតម្រង",
          "lede": "សូមបន្ធូរតម្រងមួយ ឬសម្អាតការស្វែងរក ដើម្បីមើលការងារកើតឡើងវិញបន្ថែម។"
        },
        "drawer": {
          "close": "បិទផ្ទាំង",
          "dept": "នាយកដ្ឋាន · {dept}",
          "description": "ការពិពណ៌នា",
          "assignee": "បុគ្គលិកទទួលបន្ទុក",
          "reviewer": "អ្នកវាយតម្លៃ",
          "assigner": "ផ្ដល់ដោយ",
          "due": "កាលកំណត់",
          "start": "ចាប់ផ្ដើម",
          "linked": "ភ្ជាប់ទៅ",
          "tags": "ស្លាក"
        }
      },
      "reviews": {
        "heading": "ការវាយតម្លៃ",
        "heading-sub": "{pending} កំពុងរង់ចាំការវាយតម្លៃរបស់អ្នក",
        "export-evidence": "នាំចេញកញ្ចប់ភស្តុតាង",
        "export-toast": "កញ្ចប់ភស្តុតាងការអនុវត្តន៍ — នឹងមកដល់ជាមួយម៉ូឌុលការអនុវត្តន៍",
        "banner-lead": "ការវាយតម្លៃភាពចូលរួម៖",
        "banner-body": "នៅពេលអ្នកវាយតម្លៃវាយលើការងារ (៤ វិមាត្រ × ផ្កាយ ១–៥) ការងារនីមួយៗទទួលបានពិន្ទុ។ ពិន្ទុត្រូវបានសរុបតាមបុគ្គលិកលើរយៈពេល ៩០ ថ្ងៃ ដោយថ្លឹងតាមផលប៉ះពាល់ (ខ្ពស់ × ២.០, មធ្យម × ១.៥, ទាប × ១.០)។ ការវាយតម្លៃជាជម្រើស — ការទទួលយកដោយមិនវាយតម្លៃក៏ល្អដែរសម្រាប់ការងារទាបស្តើង។",
        "empty": "គ្មានការងារនៅទីនេះទេ។",
        "system": "ប្រព័ន្ធ",
        "unknown": "មិនស្គាល់",
        "contrib": {
          "label": "ពិន្ទុចូលរួមរបស់ខ្ញុំ · ៩០ ថ្ងៃចុងក្រោយ",
          "meta": "ផ្អែកលើការងារដែលបានវាយតម្លៃ {count} · {arrow} {delta} ធៀបនឹងរយៈពេលមុន"
        },
        "pills": {
          "pending": "កំពុងរង់ចាំការវាយតម្លៃ ({n})",
          "received": "ការវាយតម្លៃបានទទួល ({n})",
          "given": "ការវាយតម្លៃបានផ្ដល់ ({n})"
        },
        "cols": {
          "work-item": "ការងារ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "priority": "អាទិភាព",
          "assignee": "អ្នកទទួលបន្ទុក",
          "due": "ផុតកំណត់",
          "score": "ពិន្ទុ",
          "q": "គុណ",
          "time": "ពេល",
          "init": "បុ.",
          "coll": "សហ.",
          "badge": "ឡើងតម្លៃ",
          "rated": "បានវាយ"
        },
        "status": {
          "open": "បើក",
          "progress": "កំពុងដំណើរការ",
          "review": "កំពុងរង់ការវាយតម្លៃ",
          "done": "បានបញ្ចប់",
          "revision": "ត្រូវការកែប្រែ",
          "overdue": "ហួសកំណត់",
          "cancelled": "បានបោះបង់"
        },
        "type": {
          "assigned": "បានចាត់តាំង",
          "request": "សំណើការងារ",
          "self": "ការងារផ្ទាល់ខ្លួន",
          "recurring": "ដដែលៗ",
          "system": "ប្រព័ន្ធ"
        },
        "priority": {
          "low": "ទាប",
          "normal": "ធម្មតា",
          "high": "ខ្ពស់",
          "urgent": "បន្ទាន់"
        },
        "impact": {
          "low": "ទាប",
          "medium": "មធ្យម",
          "high": "ខ្ពស់"
        },
        "sla": {
          "warning": "ប្រឈម",
          "critical": "សំខាន់",
          "breached": "ហួសកំណត់"
        },
        "aging": {
          "overdue": "{n}ថ. ហួសកំណត់",
          "today": "ផុតកំណត់ថ្ងៃនេះ",
          "tomorrow": "ផុតកំណត់ស្អែក",
          "in-days": "ផុតកំណត់ក្នុង {n}ថ."
        },
        "rel": {
          "in-days": "ក្នុង {n}ថ.",
          "today": "ថ្ងៃនេះ",
          "days-ago": "{n}ថ. មុន",
          "weeks-ago": "{n}អ. មុន",
          "months-ago": "{n}ខែ មុន",
          "years-ago": "{n}ឆ្នាំ មុន"
        },
        "dim": {
          "quality": {
            "label": "គុណភាព",
            "help": "បានបំពេញតាមស្តង់ដារ?"
          },
          "timeliness": {
            "label": "ទាន់ពេលវេលា",
            "help": "ទាន់ពេលឬទេ?"
          },
          "initiative": {
            "label": "បុរុករាប់ខ្លួន",
            "help": "បានទទួលយកការទទួលខុសត្រូវឬទេ?"
          },
          "collab": {
            "label": "ការសហការ",
            "help": "ធ្វើការជាមួយអ្នកដទៃបានល្អឬទេ?"
          }
        },
        "badge": {
          "helpful": "មានប្រយោជន៍",
          "fast": "ឆ្លើយតបឆាប់រហ័ស",
          "reliable": "ទុកចិត្តបាន",
          "accurate": "ត្រឹមត្រូវ",
          "solver": "អ្នកដោះស្រាយ",
          "collab": "សហការ",
          "proactive": "បុរុករាប់ខ្លួន",
          "above": "លើសពីការរំពឹងទុក"
        },
        "aside": {
          "dim-heading": "ការបំបែកតាមវិមាត្ររបស់ខ្ញុំ",
          "dim-sub": "មធ្យមតាមវិមាត្រ",
          "top-heading": "អ្នកចូលរួមកំពូល",
          "top-sub": "តម្រៀបតាមពិន្ទុចូលរួម",
          "rated-count": "បានវាយ {n}",
          "you-tag": "អ្នក"
        },
        "drawer": {
          "close": "បិទផ្ទាំង",
          "assigned-by": "បានចាត់តាំងដោយ {name}",
          "due": "ផុតកំណត់ {date}",
          "description": "ការពិពណ៌នា",
          "assignee": "អ្នកទទួលបន្ទុក",
          "reviewer": "អ្នកវាយតម្លៃ",
          "start": "បានចាប់ផ្ដើម",
          "due-label": "ផុតកំណត់",
          "linked-module": "ម៉ូឌុលដែលភ្ជាប់",
          "linked-record": "កំណត់ត្រាដែលភ្ជាប់",
          "impact-label": "ផលប៉ះពាល់ {level}",
          "rating-heading": "ការវាយតម្លៃ",
          "overall-label": "ពិន្ទុរួម",
          "overall-meta": "បានវាយដោយ {name} · {when}",
          "badge-label": "ឡើងតម្លៃ",
          "no-rating": "មិនទាន់បានវាយតម្លៃ — ការវាយតម្លៃជាជម្រើស ហើយអាចបន្ថែមនៅពេលទទួលយកការងារ។"
        }
      },
      "reports": {
        "heading": "របាយការណ៍",
        "heading-sub": "ការវិភាគប្រតិបត្តិការនៅទូទាំងម៉ូឌុល",
        "toast-open": "បើករបាយការណ៍ {name}",
        "tiles": {
          "throughput": {
            "label": "Throughput",
            "desc": "ការងារដែលបានបញ្ចប់ក្នុងមួយរយៈពេល · តាមក្រុម / ជួរ / បុគ្គល"
          },
          "cycle-time": {
            "label": "Cycle Time",
            "desc": "ពេលវេលាមធ្យម / កណ្ដាល ពី open → done បំបែកតាមការផ្លាស់ប្ដូរស្ថានភាព"
          },
          "sla": {
            "label": "SLA Adherence",
            "desc": "% ក្នុង SLA, មូលហេតុបាត់, អ្នកល្មើសច្រើនដង"
          },
          "workload": {
            "label": "Workload Distribution",
            "desc": "តុល្យភាពបន្ទុកតាមបុគ្គលិកជាមួយការរកឃើញការផ្ទុកលើស / ខ្វះ"
          }
        }
      }
    },
    "perform": {
      "title": "ការអនុវត្តន៍",
      "subtitle": "ការអនុវត្តន៍បន្ត · បញ្ញាកម្លាំងពលកម្ម · ផ្អែកលើភស្តុតាង · ក្រោមការគ្រប់គ្រងរបស់ HR និងអ្នកគ្រប់គ្រងផ្ទាល់",
      "persona": {
        "current": "ទិដ្ឋភាពបច្ចុប្បន្ន",
        "demo-label": "សាកល្បង · ប្ដូរតួនាទី",
        "admin": {
          "label": "HR Admin / HR Director",
          "note": "អភិបាលកិច្ច · គំរូ · វដ្ត · ការសម្របសម្រួល · ការត្រួតពិនិត្យភាពយុត្តិធម៌ · សវនកម្ម"
        },
        "lm": {
          "label": "អ្នកគ្រប់គ្រងផ្ទាល់",
          "note": "ការណែនាំ · ការតម្រឹម KPI · ការផ្ទៀងផ្ទាត់ភស្តុតាង · ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង"
        },
        "employee": {
          "label": "បុគ្គលិក",
          "note": "ការអភិវឌ្ឍខ្លួនឯង · ស្នើ KPI · កត់ត្រាការវិវត្ត · ទទួលស្គាល់"
        }
      },
      "tabs": {
        "dashboard": "ផ្ទាំងគ្រប់គ្រង",
        "cycles": "វដ្ត",
        "templates": "គំរូ",
        "competency": "បណ្ណាល័យសមត្ថភាព",
        "goals": "គោលដៅ និង KPI",
        "reviews": "ការវាយតម្លៃ",
        "calibration": "ការសម្របសម្រួល",
        "devplans": "ផែនការអភិវឌ្ឍ",
        "reports": "របាយការណ៍",
        "settings": "ការកំណត់"
      },
      "dashboard": {
        "title": "ផ្ទាំងគ្រប់គ្រងរបស់ HR Admin",
        "view-mode": "ទិដ្ឋភាព",
        "view-standard": "ស្តង់ដារ",
        "view-executive": "នាយក",
        "exec-view-toast": "ទិដ្ឋភាពនាយក — នឹងមកដល់ក្នុងកំណែបន្ត",
        "cycle-sub": "{cycle} · ដំណាក់កាល {stage} · បុគ្គលិកដែលមានសិទ្ធិ {participants} នាក់",
        "banner": "{cycle} · ដំណាក់កាល {stage} · ការវាយតម្លៃខ្លួនឯងបានដាក់ស្នើ {selfPct}% · ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងបានដាក់ស្នើ {mgrPct}% · កាលបរិច្ឆេទផុតកំណត់នៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង {deadline}",
        "action": {
          "settings": "ការកំណត់",
          "open-cycle": "បើកវដ្តសកម្ម"
        },
        "attention": {
          "title": "ត្រូវការការយកចិត្តទុកដាក់",
          "open-cycle": "បើកវដ្ត →",
          "overdue-rev": {
            "title": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង ១៤ ហួសកាលបរិច្ឆេទ",
            "sub": "H1 2026 · ត្រូវការរាយការណ៍ដល់ប្រធានផ្នែក",
            "cta": "ដោះស្រាយ"
          },
          "calib-stalled": {
            "title": "ការសម្របសម្រួលជាប់នៅជំហានទី ២ នៃ ៤",
            "sub": "ការសម្របសម្រួលរបស់ HR + ហិរញ្ញវត្ថុ · នៅទំនេរ ៥ ថ្ងៃ",
            "cta": "បើកឡើងវិញ"
          },
          "risk-flagged": {
            "title": "បុគ្គលិក ៣ នាក់ត្រូវបានសម្គាល់ថាមានហានិភ័យខ្ពស់",
            "sub": "ការអនុវត្តន៍ខ្សោយ + ខកខានកិច្ចប្រជុំ 1:1 ក្នុងរយៈ ៦០ ថ្ងៃចុងក្រោយ",
            "cta": "ត្រួតពិនិត្យ"
          },
          "feedback-gap": {
            "title": "មតិកែលម្អនៅ ៣៨% — គោលដៅ ៧០%",
            "sub": "ខ្វះច្រើនបំផុត៖ Engineering pod B · Customer Success",
            "cta": "រំលឹក"
          }
        },
        "kpi": {
          "section": "ទិដ្ឋភាព KPI",
          "active-cycles": {
            "label": "វដ្តវាយតម្លៃសកម្ម",
            "meta": "H1 2026 · ដំណាក់កាលវាយតម្លៃរបស់អ្នកគ្រប់គ្រង"
          },
          "pending-evals": {
            "label": "ការវាយតម្លៃកំពុងរង់ចាំ",
            "meta": "កំពុងរង់ចាំការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង · ផុតកំណត់ ២៥ ឧសភា"
          },
          "overdue-mgr": {
            "label": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងហួសកំណត់",
            "meta": "ហួសកាលបរិច្ឆេទវដ្ត · ត្រូវការរាយការណ៍"
          },
          "calibration-pending": {
            "label": "ការសម្របសម្រួលកំពុងរង់ចាំ",
            "meta": "HR + ហិរញ្ញវត្ថុ ត្រៀមរួចសម្រាប់ការសម្របសម្រួល"
          },
          "completed": {
            "label": "ការវាយតម្លៃបានបញ្ចប់",
            "meta": "៤១% នៃវដ្តបានបញ្ចប់"
          },
          "below-expect": {
            "label": "ក្រោមការរំពឹងទុក",
            "meta": "បុគ្គលិកដែលត្រូវការការគាំទ្រ"
          },
          "top-performers": {
            "label": "អ្នកអនុវត្តន៍កំពូល",
            "meta": "Outstanding + Exceeds"
          },
          "dev-pending": {
            "label": "ផែនការអភិវឌ្ឍកំពុងរង់ចាំ",
            "meta": "កំពុងរង់ចាំការអនុម័តរបស់អ្នក"
          }
        },
        "stub": {
          "title": "ផ្នែកផ្ទាំងគ្រប់គ្រងខាងក្រោម",
          "lede": "ផែនទីកំដៅ variance · សន្ទស្សន៍ហានិភ័យ · គ្រាហ្វីកការចែកចាយ · ពេលវេលាការវិវត្តនៃវដ្ត · ៥ អ្នកគ្រប់គ្រងហួសកំណត់ច្រើនបំផុត។ កំណែនឹងមកដល់បន្តិចម្ដងៗចាប់ពី P19។"
        },
        "watchlist": {
          "title": "សន្ទស្សន៍ហានិភ័យការអនុវត្តន៍",
          "formula": "សមាសភាពនៃ វត្តមាន · ការងារបន្ថែម · SLA · គោលដៅយឺត · variance នៃការសម្របសម្រួល · ការចូលរួម",
          "hint": "បុគ្គលអាទិភាពខ្ពស់ · {n} នាក់ស្ថិតក្នុងបញ្ជីតាមដាន · ចុចជួរដេកដើម្បីបើកប្រវត្តិហានិភ័យ",
          "bucket": {
            "low-sub": "អនុវត្តន៍ល្អ · គ្មានសញ្ញាព្រមាន",
            "med-sub": "មានសញ្ញា ១–២ · បញ្ជីតាមដាន",
            "high-sub": "៣ សញ្ញាឡើងលើ · ត្រូវការអន្តរាគមន៍",
            "critical-sub": "ត្រូវការអន្តរាគមន៍ភ្លាមៗ"
          },
          "tier": {
            "low": "ទាប",
            "med": "មធ្យម",
            "high": "ខ្ពស់",
            "critical": "គ្រោះថ្នាក់"
          },
          "col": {
            "employee": "បុគ្គលិក",
            "dept": "នាយកដ្ឋាន",
            "signals": "សញ្ញាហានិភ័យ",
            "score": "ពិន្ទុ",
            "tier": "កម្រិត",
            "actions": "សកម្មភាព"
          },
          "action": {
            "open": "បើកព័ត៌មានលម្អិតពេញលេញ",
            "coaching": "បង្កើតផែនការគ្រូ",
            "schedule": "កំណត់ពេលជួប ១:១",
            "coaching-toast": "ផែនការគ្រូសម្រាប់ {name} — នឹងមកដល់ក្នុងកំណែបន្ទាប់",
            "schedule-toast": "កំណត់ពេលជួប ១:១ ជាមួយ {name} — នឹងមកដល់ក្នុងកំណែបន្ទាប់"
          },
          "drawer": {
            "title": "ប្រវត្តិហានិភ័យ · {name}",
            "subtitle": "ពិន្ទុហានិភ័យ {score}/100 · {tier}",
            "close": "បិទ",
            "devplans": "បើកផែនការអភិវឌ្ឍ",
            "banner": {
              "critical": "ពិន្ទុហានិភ័យសមាស · ត្រូវការអន្តរាគមន៍ភ្លាមៗ",
              "high": "ពិន្ទុហានិភ័យសមាស · ត្រូវការអន្តរាគមន៍ក្នុងរយៈពេល ២ សប្ដាហ៍",
              "med": "ពិន្ទុហានិភ័យសមាស · បញ្ជីតាមដាន · ពិនិត្យរៀងរាល់ខែ",
              "low": "ពិន្ទុហានិភ័យសមាស · អាទិភាពទាប"
            },
            "why-title": "ហេតុអ្វីបានជាពិន្ទុនេះ · ការបែងចែកទម្ងន់",
            "composite": "ហានិភ័យសមាស = {points} ពិន្ទុ (សញ្ញា) ≈ {score}/100 (បានធ្វើនិយម)",
            "col": {
              "signal": "សញ្ញា",
              "weight": "ទម្ងន់",
              "source": "ប្រភពទិន្នន័យ"
            },
            "scale": "មាត្រដ្ឋាន៖ {scale}។ សញ្ញាត្រូវបានធ្វើបច្ចុប្បន្នភាពពេលយប់ពីម៉ូឌុលដែលបានភ្ជាប់ · ការធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖ ព្រឹកនេះ ម៉ោង ០៤:០០។",
            "context": "បរិបទបុគ្គលិក",
            "kv": {
              "role": "តួនាទី",
              "dept": "នាយកដ្ឋាន",
              "manager": "អ្នកគ្រប់គ្រង",
              "score": "ពិន្ទុហានិភ័យបច្ចុប្បន្ន"
            },
            "actions-title": "សកម្មភាពដែលណែនាំ",
            "actions": {
              "schedule-1on1": "កំណត់ពេលជួប ១:១ ជាមួយអ្នកគ្រប់គ្រងក្នុងរយៈពេល ៧ ថ្ងៃ",
              "review-devplan": "ពិនិត្យផែនការអភិវឌ្ឍ · កែប្រែបើចាំបាច់",
              "reduce-workload": "កាត់បន្ថយបន្ទុកការងារ / ការងារបន្ថែម បើពាក់ព័ន្ធ",
              "coaching-engagement": "ពិចារណាការចូលរួមជាគ្រូ ឬការត្រួតពិនិត្យសុខភាព",
              "monitor-weekly": "តាមដានសញ្ញារៀងរាល់សប្ដាហ៍",
              "recheck-cycle": "ពិនិត្យឡើងវិញនៅវដ្តបន្ទាប់",
              "add-watchlist": "បន្ថែមទៅបញ្ជីតាមដានរបស់អ្នកគ្រប់គ្រង",
              "maintain": "រក្សាគន្លងបច្ចុប្បន្ន",
              "reevaluate": "វាយតម្លៃឡើងវិញរៀងរាល់ត្រីមាស"
            },
            "copilot-title": "សកម្មភាព AI Copilot"
          }
        }
      },
      "lm": {
        "tabs": {
          "my-perf": "ការអនុវត្តន៍របស់ខ្ញុំ",
          "my-goals": "គោលដៅរបស់ខ្ញុំ",
          "my-review": "ការវាយតម្លៃរបស់ខ្ញុំ",
          "my-feedback": "មតិកែលម្អដែលបានទទួល",
          "my-dev": "ការអភិវឌ្ឍ និងប្រវត្តិ",
          "team-reviews": "ការវាយតម្លៃក្រុមរបស់ខ្ញុំ",
          "team-goals": "គោលដៅក្រុម",
          "feedback-given": "មតិកែលម្អដែលបានផ្ដល់",
          "team-snapshot": "ទិដ្ឋភាពរួមនៃក្រុម"
        },
        "stubs": {
          "my-perf": {
            "title": "ការអនុវត្តន៍របស់ខ្ញុំ",
            "lede": "ផ្ទាំងគ្រប់គ្រងការអនុវត្តន៍ផ្ទាល់ខ្លួន — ការវិវត្តនៃវដ្តបច្ចុប្បន្ន · ការមើលជាមុននៃការវាយតម្លៃ · ភស្តុតាងពីអ្នកគ្រប់គ្រង · សមិទ្ធផល KPI។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-goals": {
            "title": "គោលដៅរបស់ខ្ញុំ",
            "lede": "វដ្តគោលដៅរបស់អ្នក (សកម្ម · សំណើ · សេចក្ដីព្រាង · បានបិទ) · ការតភ្ជាប់ទៅគោលដៅក្រុម · ការវិវត្ត KPI · ដំណាក់កាល។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-review": {
            "title": "ការវាយតម្លៃរបស់ខ្ញុំ",
            "lede": "ទម្រង់វាយតម្លៃខ្លួនឯង (វដ្តបច្ចុប្បន្ន) + ការមើលជាមុននៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង + ទទួលស្គាល់បន្ទាប់ពីការផ្សព្វផ្សាយ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-feedback": {
            "title": "មតិកែលម្អដែលបានទទួល",
            "lede": "មតិកែលម្អពីអ្នកគ្រប់គ្រងរបស់អ្នក មិត្តរួមការងារ និងថ្នាក់លើ។ អាចត្រងតាមស្លាក រយៈពេល និងអារម្មណ៍។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-dev": {
            "title": "ការអភិវឌ្ឍ និងប្រវត្តិ",
            "lede": "ផែនការអភិវឌ្ឍសកម្មរបស់អ្នក · វដ្តដែលបានបញ្ចប់ · ប្រវត្តិការវាយតម្លៃ · ការបណ្ដុះបណ្ដាលបានបញ្ចប់។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "team-reviews": {
            "title": "ការវាយតម្លៃក្រុម",
            "lede": "ស្ថានភាពវាយតម្លៃរបស់បុគ្គលិកក្រោមឱវាទ · ដានភស្តុតាង · ទម្រង់វាយតម្លៃរបស់អ្នកគ្រប់គ្រង · អនុម័ត និងដាក់ស្នើ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "team-goals": {
            "title": "គោលដៅក្រុម",
            "lede": "ទិដ្ឋភាពតភ្ជាប់ដែលបានត្រងនៃគោលដៅរបស់បុគ្គលិកក្រោមឱវាទ · ការអនុម័តកំពុងរង់ចាំ · កម្រិត KPI។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "feedback-given": {
            "title": "មតិកែលម្អដែលបានផ្ដល់",
            "lede": "កំណត់ហេតុមតិកែលម្អដែលអ្នកបានផ្ញើទៅក្រុមរបស់អ្នក។ សេចក្ដីព្រាង កាលវិភាគ និងប្រវត្តិ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "team-snapshot": {
            "title": "ទិដ្ឋភាពរួមនៃក្រុម",
            "lede": "សុខភាពក្រុមមួយមើល — ការបញ្ចប់ការវាយតម្លៃ · ការមើលជាមុននៃការចែកចាយការវាយតម្លៃ · សញ្ញាវត្តមាន/ការផ្សារភ្ជាប់ពី HR Ops។ កំណែនឹងមកដល់នៅ Phase B។"
          }
        }
      },
      "ee": {
        "tabs": {
          "my-perf": "ការអនុវត្តន៍របស់ខ្ញុំ",
          "my-goals": "គោលដៅរបស់ខ្ញុំ",
          "my-review": "ការវាយតម្លៃរបស់ខ្ញុំ",
          "my-feedback": "មតិកែលម្អដែលបានទទួល",
          "my-dev": "ការអភិវឌ្ឍ និងប្រវត្តិ"
        },
        "stubs": {
          "my-perf": {
            "title": "ការអនុវត្តន៍របស់ខ្ញុំ",
            "lede": "ផ្ទាំងគ្រប់គ្រងការអនុវត្តន៍ផ្ទាល់ខ្លួន — ការវិវត្តនៃវដ្តបច្ចុប្បន្ន · ការមើលជាមុននៃការវាយតម្លៃ · ភស្តុតាងពីអ្នកគ្រប់គ្រង · សមិទ្ធផល KPI។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-goals": {
            "title": "គោលដៅរបស់ខ្ញុំ",
            "lede": "វដ្តគោលដៅរបស់អ្នក (សកម្ម · សំណើ · សេចក្ដីព្រាង · បានបិទ) · ការវិវត្ត KPI · ដំណាក់កាល។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-review": {
            "title": "ការវាយតម្លៃរបស់ខ្ញុំ",
            "lede": "ទម្រង់វាយតម្លៃខ្លួនឯង (វដ្តបច្ចុប្បន្ន) + ការមើលជាមុននៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង + ទទួលស្គាល់បន្ទាប់ពីការផ្សព្វផ្សាយ។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-feedback": {
            "title": "មតិកែលម្អដែលបានទទួល",
            "lede": "មតិកែលម្អពីអ្នកគ្រប់គ្រងរបស់អ្នក មិត្តរួមការងារ និងថ្នាក់លើ។ អាចត្រងតាមស្លាក រយៈពេល និងអារម្មណ៍។ កំណែនឹងមកដល់នៅ Phase B។"
          },
          "my-dev": {
            "title": "ការអភិវឌ្ឍ និងប្រវត្តិ",
            "lede": "ផែនការអភិវឌ្ឍសកម្មរបស់អ្នក · វដ្តដែលបានបញ្ចប់ · ប្រវត្តិការវាយតម្លៃ · ការបណ្ដុះបណ្ដាលបានបញ្ចប់។ កំណែនឹងមកដល់នៅ Phase B។"
          }
        }
      },
      "cycles": {
        "title": "វដ្តវាយតម្លៃ",
        "subtitle": "វដ្តវាយតម្លៃទាំងអស់ · {total} សរុប · {active} សកម្ម",
        "templates-btn": "គំរូ",
        "create": "បង្កើតវដ្ត",
        "banner-strong": "គំរូវាយតម្លៃ {templates}",
        "banner-rest": "មាន · ប្រើដោយបុគ្គលិក {usage} នាក់ឆ្លងវដ្តទាំងអស់",
        "confirm-close": "បិទវដ្តនេះមែនទេ? ការវាយតម្លៃមិនទាន់បញ្ចប់ទាំងអស់នឹងត្រូវរក្សាទុក។",
        "col": {
          "cycle": "វដ្ត",
          "period": "រយៈពេល",
          "status": "ស្ថានភាព",
          "stage": "ដំណាក់កាល",
          "progress": "ការវិវត្ត",
          "participants": "អ្នកចូលរួម",
          "actions": "សកម្មភាព"
        },
        "cell": {
          "self-mgr": "{self} ខ្លួនឯង · {mgr} អ្នកគ្រប់គ្រង",
          "overall": "{pct}% សរុប"
        },
        "action": {
          "view": "មើល",
          "edit": "កែ"
        },
        "timeline": {
          "setup": "រៀបចំ",
          "self": "វាយតម្លៃខ្លួនឯង",
          "mgr": "អ្នកគ្រប់គ្រងវាយតម្លៃ",
          "calib": "ការសម្រួល",
          "close": "បានបិទ"
        },
        "drawer": {
          "close": "បិទ",
          "close-cta": "បិទ",
          "close-cycle": "បិទវដ្ត",
          "edit-timeline": "កែតម្រូវកាលវិភាគ",
          "sub": "{period} · បុគ្គលិកមានសិទ្ធិ {count} នាក់ · ស្ថានភាព៖ {status}",
          "id": "លេខសម្គាល់វដ្ត",
          "type": "ប្រភេទ",
          "template": "គំរូ",
          "mixed": "ផ្សំ (តាមគ្រួសារតួនាទី)",
          "current-stage": "ដំណាក់កាលបច្ចុប្បន្ន",
          "self-reviews": "ការវាយតម្លៃខ្លួនឯង",
          "mgr-reviews": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
          "calibrated": "បានសម្រួល",
          "submitted": "{done}/{total} បានដាក់",
          "timeline": "កាលវិភាគ"
        },
        "toast": {
          "closed": "បានបិទវដ្ត · {name}"
        },
        "wizard": {
          "rail-title": "ជំហានរៀបចំ",
          "cancel": "បោះបង់",
          "back": "ថយក្រោយ",
          "next": "បន្ទាប់",
          "save-draft": "រក្សាទុកព្រាង",
          "save-changes": "រក្សាទុកការផ្លាស់ប្តូរ",
          "create-launch": "បង្កើត និងចាប់ផ្តើម",
          "title": {
            "create": "បង្កើតវដ្តវាយតម្លៃថ្មី",
            "edit": "កែវដ្ត — {name}",
            "unnamed": "មិនទាន់ដាក់ឈ្មោះ",
            "sub": "ជំហានទី {n} នៃ {total} · {label}"
          },
          "step": {
            "setup": {
              "label": "រៀបចំ",
              "desc": "ឈ្មោះវដ្ត ប្រភេទ និងរយៈពេលសរុប។"
            },
            "eligibility": {
              "label": "សិទ្ធិចូលរួម",
              "desc": "នរណាដែលត្រូវរួមបញ្ចូលក្នុងវដ្តនេះ។"
            },
            "template": {
              "label": "គំរូ",
              "desc": "គំរូវាយតម្លៃណាដែលត្រូវអនុវត្ត។"
            },
            "calibration": {
              "label": "ការសម្រួល",
              "desc": "រយៈពេល និងច្បាប់សម្រាប់ការសម្រួល។"
            },
            "notify": {
              "label": "ការជូនដំណឹង",
              "desc": "នរណាដែលត្រូវជូនដំណឹង និងពេលណា។"
            },
            "review": {
              "label": "ពិនិត្យ និងបង្កើត",
              "desc": "ការពិនិត្យចុងក្រោយមុនបើកដំណើរការ។"
            }
          },
          "setup": {
            "name": "ឈ្មោះវដ្ត",
            "name-ph": "ឧ. ការវាយតម្លៃការអនុវត្ត H2 2026",
            "type": "ប្រភេទវដ្ត",
            "start": "ចាប់ផ្តើមរយៈពេល",
            "end": "បញ្ចប់រយៈពេល",
            "self-deadline": "ថ្ងៃផុតកំណត់វាយតម្លៃខ្លួនឯង",
            "mgr-deadline": "ថ្ងៃផុតកំណត់វាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
            "period-label": "រយៈពេល"
          },
          "type": {
            "half-yearly": "ពាក់កណ្តាលឆ្នាំ",
            "quarterly": "ត្រីមាស",
            "annual": "ប្រចាំឆ្នាំ",
            "project-based": "ផ្អែកលើគម្រោង",
            "probation": "សាកល្បង",
            "mid-cycle": "ពាក់កណ្តាលវដ្ត"
          },
          "elig": {
            "dept": "នាយកដ្ឋាន",
            "dept-all": "នាយកដ្ឋានទាំងអស់",
            "emp-type": "ប្រភេទការងារ",
            "emp-all": "ទាំងអស់ (ផ្ទាល់ + ខាងក្រៅ)",
            "emp-direct": "បុគ្គលិកផ្ទាល់តែប៉ុណ្ណោះ",
            "emp-outsourced": "បុគ្គលិកខាងក្រៅតែប៉ុណ្ណោះ",
            "emp-external": "ខាងក្រៅ (អតិថិជន) — ជាធម្មតាមិនរាប់បញ្ចូល",
            "emp-hint": "បុគ្គលិកខាងក្រៅជាធម្មតាមិនធ្វើការវាយតម្លៃការអនុវត្ត (គ្រប់គ្រងដោយអតិថិជន)។",
            "manager": "អ្នកគ្រប់គ្រង (ស្រេចចិត្ត · កំណត់ត្រូវក្រុមរបស់អ្នកគ្រប់គ្រងម្នាក់)",
            "manager-all": "អ្នកគ្រប់គ្រងទាំងអស់",
            "live-preview": "បុគ្គលិកមានសិទ្ធិ · មើលផ្ទាល់",
            "empty": "គ្មានបុគ្គលិកត្រូវនឹងលក្ខខណ្ឌ។ សូមបន្ធូរតម្រង។",
            "sample": "គណនាផ្ទាល់ពីបុគ្គលិកសកម្ម + តម្រង។"
          },
          "tpl": {
            "pick": "ជ្រើសរើសគំរូវាយតម្លៃ",
            "meta": "ផ្នែក {comps} · កំពុងប្រើ {usage}"
          },
          "calib": {
            "required": "តម្រូវឱ្យមានការសម្រួលឬ?",
            "yes": "បាទ/ចាស (ណែនាំ) — ពិភាក្សាការវាយតម្លៃមុនពេលចាក់សោចុងក្រោយ",
            "no": "ទេ — ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងជាចុងក្រោយ",
            "deadline": "ថ្ងៃផុតកំណត់សម្រួល",
            "window": "រយៈពេលសម្រួល (ថ្ងៃ)",
            "w7": "១ សប្តាហ៍",
            "w14": "២ សប្តាហ៍ (ធម្មតា)",
            "w21": "៣ សប្តាហ៍",
            "w30": "១ ខែ",
            "info": "ក្នុងពេលសម្រួល HR + អ្នកគ្រប់គ្រងពិភាក្សាករណីខុសប្រក្រតី និងភាពខុសគ្នា។ ការវាយតម្លៃនឹងចាក់សោនៅចុងបញ្ចប់នៃរយៈពេលនេះ។",
            "skip": "មិនណែនាំឱ្យរំលងការសម្រួលទេ — ភាពខុសគ្នានៃការវាយតម្លៃរបស់អ្នកគ្រប់គ្រងនឹងមិនត្រូវបានពិនិត្យ។"
          },
          "notify": {
            "launch": "ផ្ញើសេចក្ដីប្រកាសបើកដំណើរការ",
            "launch-hint": "ផ្ញើអ៊ីមែលដល់បុគ្គលិកដែលមានសិទ្ធិទាំងអស់ពេលវដ្តបើក។",
            "r7": "ការរំលឹក ៧ ថ្ងៃមុនថ្ងៃផុតកំណត់",
            "r7-hint": "ការរំលឹកស្វ័យប្រវត្តិមួយសប្តាហ៍មុនថ្ងៃផុតកំណត់នីមួយៗ។",
            "r1": "ការរំលឹក ១ ថ្ងៃមុនថ្ងៃផុតកំណត់",
            "r1-hint": "ការរំលឹកចុងក្រោយ ២៤ ម៉ោងមុនថ្ងៃផុតកំណត់នីមួយៗ។",
            "mgr": "ការរំលឹកអ្នកគ្រប់គ្រង",
            "mgr-hint": "សង្ខេបប្រចាំថ្ងៃដល់អ្នកគ្រប់គ្រងបង្ហាញការវាយតម្លៃដែលនៅសេសសល់។",
            "exec": "សង្ខេបនាយកប្រតិបត្តិ",
            "exec-hint": "សង្ខេបប្រចាំសប្តាហ៍ដល់នាយក HR និង CEO ក្នុងពេលវដ្ត។",
            "welcome": "សារស្វាគមន៍ដល់អ្នកចូលរួម (ស្រេចចិត្ត)",
            "welcome-ph": "សារស្រេចចិត្តបញ្ចូលក្នុងអ៊ីមែលបើកដំណើរការ។"
          },
          "review": {
            "ready": "រួចរាល់ហើយក្នុងការបើកដំណើរការ។ សូមពិនិត្យសេចក្តីសង្ខេបខាងក្រោម និងបញ្ជាក់។",
            "missing": "វដ្តខ្វះព័ត៌មានចាំបាច់ ({bits})។ ត្រឡប់ក្រោយដើម្បីបំពេញ។",
            "no-name": "ឈ្មោះ",
            "no-elig": "គ្មានបុគ្គលិកមានសិទ្ធិ",
            "eligible": "ចំនួនមានសិទ្ធិ",
            "selected": "បានជ្រើសរើស",
            "yes": "បាទ/ចាស",
            "no": "ទេ",
            "on": "បើក",
            "off": "បិទ"
          },
          "toast": {
            "missing": "មិនអាចបើកដំណើរការ — សូមជួសជុលព័ត៌មានដែលខ្វះក្នុងជំហានពិនិត្យ។",
            "saved": "បានរក្សាទុកវដ្ត · {name}",
            "launched": "បានបង្កើត និងបើកដំណើរការវដ្ត \"{name}\" (អ្នកចូលរួម {count} នាក់)។",
            "draft": "បានរក្សាទុកវដ្ត \"{name}\" ជាព្រាង។"
          }
        }
      },
      "templates": {
        "title": "គំរូវាយតម្លៃ",
        "subtitle": "{count} គំរូ · ប្រើដោយបុគ្គលិក {employees} នាក់ក្នុងវដ្តបច្ចុប្បន្ន",
        "create": "គំរូថ្មី",
        "create-toast": "កម្មវិធីកែគំរូ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "open-toast": "ប្រអប់លម្អិតគំរូ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "usage": "ប្រើដោយបុគ្គលិក {n} នាក់",
        "usage-suffix": "{n} កំពុងប្រើ",
        "weight-distribution": "ការបែងចែកទម្ងន់ផ្នែក",
        "components-head": "ផ្នែក ({n})",
        "more": "+{n} ផ្សេងទៀត",
        "open-cta": "ចុចដើម្បីមើល / កែ →",
        "versions": "គ្មានកំណែ | {n} កំណែ | {n} កំណែ",
        "cycles": "គ្មានវដ្ត | {n} វដ្ត | {n} វដ្ត",
        "version": {
          "active": "សកម្ម",
          "archived": "ដាក់ក្នុងបណ្ណាល័យ"
        },
        "items": {
          "tpl-mgmt": {
            "name": "យុទ្ធសាស្ត្រ / អភិបាល",
            "roles": "ប្រធានផ្នែក · អ្នកគ្រប់គ្រងជាន់ខ្ពស់ · នាយក",
            "owner": "នាយកធនធានមនុស្ស"
          },
          "tpl-ops": {
            "name": "ប្រតិបត្តិការ / ការិយាល័យក្រោយ",
            "roles": "ហិរញ្ញវត្ថុ · ធនធានមនុស្ស · ព័ត៌មានវិទ្យា · ប្រតិបត្តិការ · រដ្ឋបាល",
            "owner": "នាយកប្រតិបត្តិការ"
          },
          "tpl-sales": {
            "name": "ការលក់",
            "roles": "អ្នកលក់ · អ្នកលក់ផ្ទាល់ · ប្រធានការលក់",
            "owner": "នាយកការលក់"
          },
          "tpl-tech": {
            "name": "វិស្វកម្ម / បច្ចេកវិទ្យា",
            "roles": "វិស្វករ · អ្នករចនា · ទិន្នន័យ",
            "owner": ""
          }
        }
      },
      "competency": {
        "title": "បណ្ណាល័យសមត្ថភាព",
        "subtitle": "{total} សមត្ថភាព · {system} លំនាំដើមប្រព័ន្ធ · {tenant} ផ្ទាល់ខ្លួន · អាចប្រើឡើងវិញនៅគ្រប់ការវាយតម្លៃ ផែនការអភិវឌ្ឍ ការតម្រៀបអ្នកស្នង និងទម្រង់ការងារ",
        "import": "នាំចូល",
        "export": "នាំចេញ",
        "new": "សមត្ថភាពថ្មី",
        "result-count": "បង្ហាញ {n} ក្នុង {total}",
        "action": {
          "import-toast": "នាំចូល CSV / XLSX — នឹងមកដល់ក្នុងកំណែបន្ត",
          "export-toast": "នាំចេញបញ្ជីដែលបានច្រោះ — នឹងមកដល់ក្នុងកំណែបន្ត",
          "new-toast": "កម្មវិធីកែសមត្ថភាព — នឹងមកដល់ក្នុងកំណែបន្ត",
          "add-category-toast": "បន្ថែមប្រភេទ — នឹងមកដល់ក្នុងកំណែបន្ត",
          "bulk-archive-toast": "រក្សាទុក {n} ដែលបានជ្រើស — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-edit-toast": "កែ {name} — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-clone-toast": "ចម្លង {name} ទៅបណ្ណាល័យផ្ទាល់ខ្លួន — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-archive-toast": "រក្សាទុក {name} — នឹងមកដល់ក្នុងកំណែបន្ត",
          "row-delete-toast": "លុប {name} — នឹងមកដល់ក្នុងកំណែបន្ត",
          "view": "មើល",
          "edit": "កែ",
          "clone": "ចម្លងដើម្បីកែ",
          "archive": "រក្សាទុក",
          "delete": "លុប"
        },
        "summary": {
          "total": "សមត្ថភាពសរុប",
          "total-sub": "{system} ប្រព័ន្ធ · {tenant} ផ្ទាល់ខ្លួន",
          "categories": "ប្រភេទសកម្ម",
          "categories-sub": "ក្នុងចំណោម {total} ដែលមាន",
          "templates": "គំរូប្រើ",
          "templates-sub": "ក្នុងចំណោម {total} គំរូភ្ជាប់សមត្ថភាព",
          "draft": "សមត្ថភាពព្រាង",
          "draft-sub": "{archived} ដាក់ក្នុងបណ្ណាល័យ"
        },
        "sidebar": {
          "title": "ប្រភេទ",
          "all": "សមត្ថភាពទាំងអស់",
          "add": "បន្ថែមប្រភេទថ្មី",
          "expand": "ពង្រីករបារខាង",
          "collapse": "បង្រួមរបារខាង",
          "hint": "ព័ត៌មាន · ចុច + ខាងលើ ដើម្បីបន្ថែមប្រភេទផ្ទាល់ខ្លួន។"
        },
        "filter": {
          "search-placeholder": "ស្វែងរកតាមឈ្មោះ ឬការពិពណ៌នា…",
          "search-aria": "ស្វែងរកសមត្ថភាព",
          "advanced": "បង្ហាញការកំណត់ខ្ពស់",
          "source": {
            "label": "ប្រភព",
            "all": "ប្រភពទាំងអស់"
          },
          "type": {
            "label": "ប្រភេទ",
            "all": "ប្រភេទទាំងអស់"
          },
          "status": {
            "label": "ស្ថានភាព",
            "all": "ស្ថានភាពទាំងអស់"
          }
        },
        "view": {
          "label": "ប្តូរទិដ្ឋភាព",
          "cards": "ទិដ្ឋភាពកាត",
          "table": "ទិដ្ឋភាពតារាង"
        },
        "bulk": {
          "aria": "សកម្មភាពច្រើន",
          "selected": "សមត្ថភាពបានជ្រើស | សមត្ថភាពបានជ្រើស",
          "archive": "រក្សាទុក",
          "clear": "សម្អាត"
        },
        "source": {
          "system": "លំនាំដើមប្រព័ន្ធ",
          "tenant": "ផ្ទាល់ខ្លួន"
        },
        "status": {
          "active": "សកម្ម",
          "draft": "ព្រាង",
          "archived": "បានរក្សាទុក"
        },
        "card": {
          "templates": "គំរូ | គំរូ",
          "versions": "កំណែ | កំណែ",
          "owner": "ម្ចាស់អភិបាលកិច្ច",
          "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ"
        },
        "table": {
          "select-all": "ជ្រើសជួរទាំងអស់",
          "name": "ឈ្មោះសមត្ថភាព",
          "category": "ប្រភេទ",
          "type": "ប្រភេទ",
          "levels": "កម្រិត",
          "templates": "គំរូភ្ជាប់",
          "templates-suffix": "គំរូ | គំរូ",
          "status": "ស្ថានភាព",
          "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
          "version": "កំណែ",
          "actions": "សកម្មភាព"
        },
        "empty": {
          "archived": {
            "title": "មិនមានសមត្ថភាពដែលបានរក្សាទុក",
            "body": "សមត្ថភាពដែលបានរក្សាទុកលេចឡើងនៅទីនេះ។ មិនទាន់មានសមត្ថភាពផ្ទាល់ខ្លួនណាបានរក្សាទុកឡើយ។",
            "cta": "បង្ហាញសមត្ថភាពសកម្ម"
          },
          "category": {
            "title": "មិនទាន់មានអ្វីនៅក្នុង {label}",
            "body": "មិនមានសមត្ថភាពណាដែលបានកំណត់ជាមួយប្រភេទនេះ។ បង្កើតថ្មីមួយ ឬរុករកប្រភេទផ្សេងពីរបារខាង។",
            "cta": "សមត្ថភាពទាំងអស់"
          },
          "search": {
            "title": "មិនមានលទ្ធផលសម្រាប់ \"{q}\"",
            "body": "ព្យាយាមពាក្យខ្លីជាង ឬពិនិត្យអក្ខរាវិរុទ្ធ។ ការស្វែងរកគ្របដណ្ដប់ឈ្មោះ និងការពិពណ៌នា។",
            "cta": "សម្អាតការស្វែងរក"
          },
          "filter": {
            "title": "មិនមានសមត្ថភាពដែលត្រូវនឹងការរួមបញ្ចូលច្រោះបច្ចុប្បន្ន",
            "body": "សាកល្បងសម្អាតច្រោះមួយ ឬច្រើន ដើម្បីពង្រីកលទ្ធផល។",
            "cta": "សម្អាតច្រោះទាំងអស់"
          }
        },
        "drawer": {
          "close": "បិទប្រអប់",
          "close-cta": "បិទ",
          "system-readonly": "លំនាំដើមប្រព័ន្ធ (មើលតែប៉ុណ្ណោះ)",
          "system-banner": {
            "title": "លំនាំដើមប្រព័ន្ធ",
            "body": "ផ្តល់ដោយ Optimal HR ជាចំណុចចាប់ផ្តើម។ មើលតែប៉ុណ្ណោះ — ដើម្បីប្ដូរ សូមចម្លងទៅបណ្ណាល័យផ្ទាល់ខ្លួន។"
          },
          "description": "ការពិពណ៌នា",
          "no-desc": "មិនមានការពិពណ៌នា។",
          "category": "ប្រភេទ",
          "type": "ប្រភេទសមត្ថភាព",
          "source-k": "ប្រភពបណ្ណាល័យ",
          "status": "ស្ថានភាព",
          "owner": "ម្ចាស់អភិបាលកិច្ច",
          "scale": "មាត្រដ្ឋានជំនាញ",
          "version": "កំណែសកម្ម",
          "cloned-from": "ចម្លងពី",
          "levels": "កម្រិតជំនាញ ({n})",
          "usage": "ការគ្រោងប្រើប្រាស់",
          "usage-templates": "គំរូ ({n})",
          "usage-departments": "នាយកដ្ឋាន",
          "no-templates": "មិនទាន់ភ្ជាប់ទៅគំរូណាមួយ — អាចលុបបាន",
          "all-depts": "នាយកដ្ឋានទាំងអស់",
          "history": "ប្រវត្តិកំណែ ({n})",
          "clone": "ចម្លងទៅបណ្ណាល័យផ្ទាល់ខ្លួន",
          "duplicate": "ស្ទួន",
          "archive": "រក្សាទុក",
          "edit": "កែ"
        }
      },
      "goals": {
        "title": "គោលដៅ និង OKR",
        "subtitle": "ស្បួននៃ SMART + OKR · {total} គោលដៅ ({smart} SMART · {okr} OKR) · {aligned} បានចុះតាមថ្នាក់",
        "cascade": "ចុះតាមថ្នាក់សាជីវកម្ម",
        "cascade-toast": "ប្រអប់ចុះតាមថ្នាក់សាជីវកម្ម — នឹងមកដល់ក្នុងកំណែបន្ត",
        "create": "គោលដៅថ្មី",
        "create-toast": "ប្រអប់បង្កើតគោលដៅ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "checkin-toast": "ប្រអប់កត់ត្រាដំណើរការសម្រាប់ {id} — នឹងមកដល់ក្នុងកំណែបន្ត",
        "edit-toast": "ប្រអប់កែគោលដៅ {id} — នឹងមកដល់ក្នុងកំណែបន្ត",
        "adjust-toast": "ប្រអប់កែតម្រូវកណ្ដាលវដ្ត {id} — នឹងមកដល់ក្នុងកំណែបន្ត",
        "complete": "បានសម្រេច",
        "result-count": "ត្រូវនឹង {n} គោលដៅ",
        "kpi": {
          "active": "គោលដៅសកម្ម",
          "active-sub": "{smart} SMART · {okr} OKR",
          "on-track": "ដើរតាមផ្លូវ ឬសម្រេច",
          "on-track-sub": "{achieved} សម្រេច",
          "at-risk": "មានហានិភ័យ ឬខុសផ្លូវ",
          "at-risk-sub": "{low} ទំនុកចិត្តទាប",
          "avg-progress": "ការវិវត្តមធ្យម",
          "avg-progress-sub": "នៅគ្រប់គោលដៅទាំងអស់",
          "alignment": "ការគ្របដណ្ដប់ការតម្រឹម",
          "alignment-sub": "{aligned} បានចុះតាមថ្នាក់"
        },
        "filter": {
          "type": {
            "label": "ប្រភេទ",
            "all": "គ្រប់ប្រភេទ",
            "smart": "SMART KPI តែប៉ុណ្ណោះ",
            "okr": "OKR តែប៉ុណ្ណោះ"
          },
          "status": {
            "label": "ស្ថានភាព",
            "all": "គ្រប់ស្ថានភាព"
          },
          "dept": {
            "label": "ផ្នែក",
            "all": "គ្រប់ផ្នែក"
          }
        },
        "status": {
          "not_started": "មិនទាន់ចាប់ផ្ដើម",
          "on_track": "ដើរតាមផ្លូវ",
          "at_risk": "មានហានិភ័យ",
          "off_track": "ខុសផ្លូវ",
          "achieved": "សម្រេច",
          "missed": "ខកខាន"
        },
        "type-desc": {
          "smart": "ច្បាស់លាស់ វាស់វែងបាន សម្រេចបាន ពាក់ព័ន្ធ និងមានពេលកំណត់។ ការគណនាមានទម្ងន់ក្នុងការវាយតម្លៃ។",
          "okr": "គោលបំណង + លទ្ធផលគន្លឹះ ៣-៥ ។ ការគណនាមានសង្ឃឹមខ្ពស់ (0.0-1.0 ក្នុង KR មួយ ដែលគណនាជាមធ្យម)។"
        },
        "col": {
          "goal": "គោលដៅ",
          "type": "ប្រភេទ",
          "owner": "ម្ចាស់",
          "lifecycle": "វដ្តជីវិត",
          "source": "ប្រភព",
          "weight": "ទម្ងន់",
          "progress": "វិវត្ត",
          "status": "ស្ថានភាព",
          "confidence": "ទំនុកចិត្ត",
          "last-checkin": "ចុះឈ្មោះចុងក្រោយ",
          "actions": "សកម្មភាព"
        },
        "action": {
          "view": "មើល",
          "checkin": "កត់ត្រាដំណើរការ",
          "edit": "កែ",
          "adjust": "កែតម្រូវកណ្ដាលវដ្ត"
        },
        "empty": {
          "title": "មិនមានគោលដៅណាមួយត្រូវនឹងតម្រងរបស់អ្នកទេ",
          "sub": "សូមសាកល្បងសម្អាតតម្រងណាមួយខាងលើ។",
          "clear": "សម្អាតតម្រង"
        },
        "drawer": {
          "close": "បិទប្រអប់",
          "close-cta": "បិទ",
          "lifecycle": "វដ្តជីវិត",
          "step": "ជំហាន {n}/10",
          "progress": "វិវត្ត",
          "status": "ស្ថានភាព",
          "confidence": "ទំនុកចិត្ត",
          "weight": "ទម្ងន់",
          "owner": "ម្ចាស់",
          "source": "ប្រភព",
          "parent": "មាតាបិតា",
          "cycle": "វដ្ត",
          "last-checkin": "ចុះឈ្មោះចុងក្រោយ",
          "alignment": "ការតម្រឹម",
          "description": "ការពិពណ៌នា"
        }
      },
      "reviews": {
        "title": "បំពង់វាយតម្លៃ",
        "subtitle": "វដ្ត H1 2026 · ស្ថានភាពវាយតម្លៃរបស់អ្នកគ្រប់គ្រងទូទាំងស្ថាប័ន · {total} ការវាយតម្លៃនៅគ្រប់ {managers} អ្នកគ្រប់គ្រង · {pct}% បានដាក់ស្នើ ឬលើស",
        "nudge": "រំលឹកអ្នកគ្រប់គ្រងកំពុងរង់ចាំ",
        "nudge-toast": "បានផ្ញើការរំលឹកជាក្រុមដល់អ្នកគ្រប់គ្រងកំពុងរង់ចាំទាំងអស់ (សាកល្បង)",
        "go-calibration": "ទៅការសម្របសម្រួល",
        "state": {
          "not_started": "មិនបានចាប់ផ្ដើម",
          "self_in_progress": "សេចក្ដីព្រាងខ្លួនឯង",
          "self_submitted": "ខ្លួនឯងបានដាក់ស្នើ",
          "manager_in_progress": "ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
          "manager_submitted": "អ្នកគ្រប់គ្រងបានដាក់ស្នើ",
          "pending_calibration": "កំពុងរង់ចាំការសម្របសម្រួល",
          "calibrated": "បានសម្របសម្រួល",
          "acknowledged": "ទទួលស្គាល់"
        },
        "filter": {
          "all": "គ្រប់ស្ថានភាព",
          "pending": "កំពុងរង់ចាំ (អ្នកគ្រប់គ្រងមិនទាន់ដាក់ស្នើ)",
          "submitted": "អ្នកគ្រប់គ្រងបានដាក់ស្នើ",
          "complete": "បានសម្របសម្រួល / ទទួលស្គាល់"
        },
        "mgr": {
          "summary": "{dept} · {total} បុគ្គលិកផ្ទាល់ · {submitted} បានដាក់ស្នើ",
          "submitted-pct": "បានដាក់ស្នើ {pct}%",
          "nudge-toast": "បានផ្ញើការរំលឹកទៅ {name} (សាកល្បង)",
          "expand": "បើក {name}",
          "collapse": "បិទ {name}",
          "nudge-aria": "រំលឹក {name}"
        },
        "row": {
          "employee": "បុគ្គលិក",
          "self-submitted": "ខ្លួនឯងបានដាក់ស្នើ",
          "manager-submitted": "អ្នកគ្រប់គ្រងបានដាក់ស្នើ",
          "state": "ស្ថានភាព",
          "rating-self": "ការវាយតម្លៃខ្លួនឯង",
          "rating-manager": "ការវាយតម្លៃអ្នកគ្រប់គ្រង",
          "open": "បើក",
          "open-aria": "បើកកន្លែងធ្វើការវាយតម្លៃរបស់ {name}",
          "open-toast": "កន្លែងធ្វើការវាយតម្លៃរបស់ {name} — នឹងមកដល់ក្នុងកំណែបន្ត"
        },
        "empty-filter": "មិនមានអ្នកគ្រប់គ្រងណាដែលផ្គូផ្គងនឹងតម្រងនេះទេ។"
      },
      "calibration": {
        "title": "សិក្ខាសាលាសម្របសម្រួល",
        "subtitle-pill": "H1 2026 · {pending} កំពុងរង់ចាំការចុះហត្ថលេខា",
        "subtitle": "សមត្ថភាព × សក្តានុពល · អូសបុគ្គលិករវាងក្រឡា ឬប្រើម៉ឺនុយ ⋮ · ចុះហត្ថលេខាដើម្បីចាក់សោការវាយតម្លៃ និងផ្ទេរការវាយតម្លៃទៅជា {calibrated}",
        "calibrated-bold": "បានសម្របសម្រួល",
        "export-csv": "នាំចេញ CSV",
        "export-pdf": "នាំចេញ PDF",
        "sign-off-lock-n": "ចុះហត្ថលេខា & ចាក់សោ ({count})",
        "sign-off-lock": "ចុះហត្ថលេខា & ចាក់សោការវាយតម្លៃ",
        "nudge": "រំលឹកអ្នកគ្រប់គ្រងដែលមានទង់ប្រែប្រួល",
        "open": "បើកសម័យ",
        "open-toast": "UI សម័យសម្របសម្រួល — នឹងមកដល់ក្នុងកំណែបន្ត",
        "export-csv-toast": "បាននាំចេញ CSV ការសម្របសម្រួល (សាកល្បង)",
        "export-pdf-toast": "បាននាំចេញ PDF ការសម្របសម្រួល (សាកល្បង)",
        "sign-off-toast": "ចុះហត្ថលេខា & ចាក់សោ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "nudge-toast": "បានផ្ញើការរំលឹកទៅអ្នកគ្រប់គ្រងដែលមានទង់ប្រែប្រួល (សាកល្បង)",
        "axis": {
          "perf-low": "← សមត្ថភាពទាបជាង",
          "perf-solid": "សមត្ថភាពមធ្យម",
          "perf-high": "សមត្ថភាពខ្ពស់ជាង →",
          "pot-high": "↑ សក្តានុពលខ្ពស់ជាង",
          "pot-solid": "សក្តានុពលមធ្យម",
          "pot-low": "↓ សក្តានុពលមានកម្រិត"
        },
        "cell": {
          "empty": "— ទទេ —",
          "1A": "ពេជ្រកំពុងលាក់",
          "2A": "តារាអនាគត",
          "3A": "តារា",
          "1B": "អ្នកលេងមិនស្ថិតស្ថេរ",
          "2B": "អ្នកលេងស្នូល",
          "3B": "អ្នករួមចំណែកគន្លឹះ",
          "1C": "ក្តីបារម្ភ",
          "2C": "អ្នកសម្តែងស្ថិតស្ថេរ",
          "3C": "អ្នកជំនាញ",
          "1A-desc": "សក្តានុពលរឹងមាំ ប៉ុន្តែសមត្ថភាពមិនទាន់ឈានដល់។ ប្រឹក្សារឹងមាំ។",
          "2A-desc": "សមត្ថភាពមធ្យមជាមួយសក្តានុពលខ្ពស់។ មួយជំហានពីតារា។",
          "3A-desc": "សមត្ថភាពខ្ពស់ និងសក្តានុពលខ្ពស់។ ទេពកោសល្យកំពូល។",
          "1B-desc": "សក្តានុពលមធ្យម សមត្ថភាពទាប។ ស៊ើបអង្កេត។",
          "2B-desc": "អ្នករួមចំណែកមធ្យមដែលអាចទុកចិត្តបាន។ ឆ្អឹងខ្នង។",
          "3B-desc": "អ្នកសម្តែងខ្ពស់ក្នុងតួនាទីបច្ចុប្បន្ន។ សក្តានុពលមធ្យម។",
          "1C-desc": "សមត្ថភាពទាប និងសក្តានុពលមានកម្រិត។ លំបាក។",
          "2C-desc": "ឈានដល់កម្រិតយ៉ាងជឿជាក់។ បន្ទប់រីកលូតលាស់មានកម្រិត។",
          "3C-desc": "សមត្ថភាពខ្ពស់ ជំនាញពិសេស។ ការផ្លាស់ប្តូរមានកម្រិត។"
        },
        "legend": {
          "variance": "ខ្លួនឯង ≠ ការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង (ប្រែប្រួល)",
          "promo": "បានណែនាំការតម្លើងឋានៈ",
          "menu": "ចុចសម្រាប់ម៉ឺនុយផ្លាស់ទី"
        },
        "card-menu": {
          "title": "ផ្លាស់ទី \"{name}\" ទៅ",
          "current": "(បច្ចុប្បន្ន)",
          "detail": "ព័ត៌មានលម្អិតការសម្របសម្រួល (ចំណាំ · ប្រវត្តិ)",
          "open-workspace": "បើកកន្លែងធ្វើការវាយតម្លៃ"
        },
        "side": {
          "session": {
            "title": "ទិដ្ឋភាពទូទៅសម័យ",
            "in-matrix": "ក្នុងម៉ាទ្រីស",
            "pending": "កំពុងរង់ចាំចុះហត្ថលេខា",
            "locked": "បានចាក់សោរួច",
            "variance": "ទង់ប្រែប្រួល"
          },
          "dist": {
            "title": "សុខភាពការចែកចាយ",
            "sub": "គោលដៅ vs ជាក់ស្តែង",
            "lede": "សញ្ញាខ្មៅសម្គាល់គោលដៅ។ ប្រែប្រួលធំ = ការផ្លាស់ប្ដូរការចែកចាយដោយបង្ខំ។",
            "foot": "គោលដៅ = ការចែកចាយដោយបង្ខំដែលបានណែនាំ។ ±8% នៅក្នុងរង្វាល់សុខភាព; លើសពីនោះ ការរអាក់រអួលក្នុងការសម្របសម្រួលទំនងជាកើតឡើង។"
          },
          "variance": {
            "title": "ការដោះស្រាយការប្រែប្រួល",
            "flagged": "{count} បានដាក់ទង់",
            "empty": "គ្មានអ្នកគ្រប់គ្រងលើសកម្រិតប្រែប្រួល ±0.50 ឡើយ។ ការចែកចាយមានសុខភាពល្អ។",
            "over": "វាយតម្លៃលើស",
            "under": "វាយតម្លៃក្រោម",
            "row": "{dir} ដោយ {amount} (មធ្យម {avg} vs អង្គភាព 3.55) · {n} ការវាយតម្លៃបានដាក់ស្នើ"
          },
          "lock": {
            "title": "ការចាក់សោចុះហត្ថលេខា",
            "body": "នៅពេលអ្នកចុះហត្ថលេខា rating_manager ក្លាយជាការវាយតម្លៃចុងក្រោយសម្រាប់ការវាយតម្លៃកំពុងរង់ចាំទាំងអស់ កំណែគំរូដែលបានប្រើត្រូវបានបង្កក និងបុគ្គលិកត្រូវបានជូនដំណឹងឲ្យទទួលស្គាល់។ ការកែសម្រួលគំរូនាពេលអនាគតនឹងមិនផ្លាស់ប្ដូរការវាយតម្លៃទាំងនេះឡើយ។"
          }
        },
        "footer": {
          "summary": "{reviews-bold} រួចរាល់សម្រាប់ចុះហត្ថលេខា · {flags-bold} ត្រូវដោះស្រាយ · នៅពេលចាក់សោ ការវាយតម្លៃជាចុងក្រោយ",
          "reviews-one": "1 ការវាយតម្លៃ",
          "reviews-other": "{count} ការវាយតម្លៃ",
          "flags-one": "1 ទង់ប្រែប្រួល",
          "flags-other": "{count} ទង់ប្រែប្រួល"
        }
      },
      "devplans": {
        "title": "ផែនការអភិវឌ្ឍ",
        "subtitle": "{total} ផែនការសកម្ម · {pending} កំពុងរង់ចាំការអនុម័ត · {approved} បានអនុម័ត",
        "push": "ផ្ញើទៅ L&D",
        "push-toast": "ការតភ្ជាប់ម៉ូឌុល L&D នឹងសកម្ម · ការផ្ញើទៅ L&D នឹងដំណើរការនៅពេល L&D ត្រូវបានបង្កើត",
        "bulk": "អនុម័តជាក្រុម",
        "bulk-toast": "លំហូរអនុម័តជាក្រុម (សាកល្បង)",
        "approve-toast": "ផែនការ {id} បានអនុម័ត (សាកល្បង)",
        "lnd-toast": "បានផ្ញើទៅម៉ូឌុល L&D (សាកល្បង · L&D មិនទាន់បានបង្កើត)",
        "col": {
          "id": "លេខផែនការ",
          "employee": "បុគ្គលិក",
          "dept": "ផ្នែក",
          "area": "ផ្នែកអភិវឌ្ឍ",
          "action": "សកម្មភាពអនុសាសន៍",
          "status": "ស្ថានភាព",
          "owner": "ម្ចាស់",
          "actions": "សកម្មភាព"
        },
        "action": {
          "view": "មើល",
          "approve": "អនុម័ត",
          "lnd": "L&D"
        },
        "status": {
          "Active": "សកម្ម",
          "In review": "កំពុងពិនិត្យ",
          "Approved": "បានអនុម័ត",
          "Pending": "កំពុងរង់ចាំ"
        },
        "drawer": {
          "title": "{id} — {emp}",
          "sub": "{dept} · ម្ចាស់ផែនការ៖ {owner} · ស្ថានភាព៖ {status}",
          "close-label": "បិទប្រអប់",
          "employee": "បុគ្គលិក",
          "department": "ផ្នែក",
          "area": "ផ្នែកអភិវឌ្ឍ",
          "action": "សកម្មភាពអនុសាសន៍",
          "owner": "ម្ចាស់ (អ្នកគ្រប់គ្រងផ្ទាល់)",
          "status": "ស្ថានភាព",
          "milestones": "ចំណុចសំខាន់ (សាកល្បង)",
          "milestone-1": "ត្រីមាសទី២ ឆ្នាំ២០២៦ · បញ្ចប់វគ្គបណ្ដុះបណ្ដាលគ្រឹះ (៤សប្ដាហ៍)",
          "milestone-2": "ត្រីមាសទី៣ ឆ្នាំ២០២៦ · ការពិនិត្យលើកដំបូងជាមួយនាយក HR · វាយតម្លៃសញ្ញានៃការប្រសើរឡើង",
          "milestone-3": "ត្រីមាសទី៤ ឆ្នាំ២០២៦ · ការវាយតម្លៃពាក់កណ្ដាលឆ្នាំជាថ្មី · កែតម្រូវផែនការបើចាំបាច់",
          "lnd-linkage": "ការតភ្ជាប់ជាមួយ L&D",
          "lnd-body": "នៅពេលផែនការនេះត្រូវបានអនុម័ត និងផ្ញើទៅ L&D វគ្គណែនាំទាំងនោះនឹងក្លាយជាធាតុចុះឈ្មោះសម្រាប់បុគ្គលិកក្នុងម៉ូឌុល L&D។ ទិន្នន័យនៃការបញ្ចប់នឹងហូរត្រឡប់មកវិញចូលក្នុងមូលដ្ឋានភស្ដុតាងរបស់ Performance សម្រាប់វដ្តបន្ទាប់។",
          "close-cta": "បិទ",
          "send-cta": "ផ្ញើទៅ L&D",
          "send-toast": "បានផ្ញើទៅ L&D (សាកល្បង)",
          "approve-cta": "អនុម័តផែនការ",
          "approve-toast": "ផែនការបានអនុម័ត (សាកល្បង)"
        }
      },
      "reports": {
        "title": "របាយការណ៍ និងវិភាគ",
        "subtitle": "{count} របាយការណ៍ស្ដង់ដារ · ចុចលើកាតណាមួយដើម្បីមើលជាមុន",
        "custom": "របាយការណ៍ផ្ទាល់ខ្លួន",
        "custom-toast": "កម្មវិធីបង្កើតរបាយការណ៍ផ្ទាល់ខ្លួន — សមត្ថភាពកម្រិត Enterprise",
        "export": "នាំចេញទាំងអស់",
        "export-toast": "នាំចេញទាំងអស់ទៅ Excel (សាកល្បង)",
        "preview": "មើលជាមុន →",
        "preview-toast": "ប្រអប់របាយការណ៍ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "items": {
          "R1": {
            "title": "របាយការណ៍សង្ខេបការអនុវត្តន៍",
            "desc": "ការចែកចាយការវាយតម្លៃទូទាំងស្ថាប័ន · ការវិវត្តវដ្ត · អត្រាបញ្ចប់ · ពិន្ទុមធ្យមតាមគំរូ",
            "period": "ផ្ទុកស្វ័យប្រវត្តិពីវដ្តបច្ចុប្បន្ន"
          },
          "R2": {
            "title": "របាយការណ៍ការចែកចាយការវាយតម្លៃ",
            "desc": "ខ្សែ Bell តាមផ្នែក · អ្នកគ្រប់គ្រង · ថ្នាក់ · ការផ្លាស់ប្ដូរឆ្នាំទៅឆ្នាំ",
            "period": "វដ្តបិទចុងក្រោយ"
          },
          "R3": {
            "title": "របាយការណ៍ការអនុវត្តន៍តាមផ្នែក",
            "desc": "តម្រៀបផ្នែកតាមការវាយតម្លៃមធ្យម · KPI · ការសម្រេចគោលដៅ · ពិន្ទុវត្តមាន",
            "period": "វដ្តបច្ចុប្បន្ន"
          },
          "R4": {
            "title": "សង្ខេបការសម្របសម្រួល",
            "desc": "ការផ្លាស់ប្ដូរមុន vs ក្រោយ · ការកែសម្រួលដោយ HR · ផ្នែកដែលមាន variance ច្រើនបំផុត",
            "period": "ក្រោយការសម្របសម្រួលបិទ"
          },
          "R5": {
            "title": "របាយការណ៍កំពូលនៃទេពកោសល្យ",
            "desc": "បុគ្គលិកដែលត្រូវវាយតម្លៃ Outstanding ២+ វដ្តជាប់គ្នា · បេក្ខជនការតម្លើងតួនាទី",
            "period": "៣ វដ្តមួយប្រែប្រួល"
          },
          "R6": {
            "title": "តាមដានអ្នកអនុវត្តន៍ខ្សោយ",
            "desc": "បុគ្គលិកអនុវត្តន៍ខ្សោយ · ហេតុ root · ស្ថានភាពផែនការអភិវឌ្ឍ · ហានិភ័យចាកចេញ",
            "period": "២ វដ្តមួយប្រែប្រួល"
          },
          "R7": {
            "title": "តាមដានផែនការអភិវឌ្ឍ",
            "desc": "ផែនការសកម្មទាំងអស់ · % បញ្ចប់ · ការបណ្ដុះបណ្ដាល · ថ្ងៃតាមដាន · មតិអ្នកគ្រប់គ្រង",
            "period": "ពីដើមវដ្តដល់ឥឡូវ"
          }
        }
      },
      "settings": {
        "title": "ការកំណត់ម៉ូឌុលការអនុវត្តន៍",
        "subtitle": "កំណត់រចនាសម្ព័ន្ធមាត្រដ្ឋានវាយតម្លៃ · លំហូរ · ការរំលឹក · ការអនុម័ត · ការតភ្ជាប់",
        "edit": "កែ",
        "restore": "ស្ដារទៅលំនាំដើម",
        "save": "រក្សាទុកទាំងអស់",
        "restore-toast": "ស្ដារទៅលំនាំដើម (សាកល្បង)",
        "save-toast": "ការកំណត់ត្រូវបានរក្សាទុក (សាកល្បង)",
        "edit-toast": "ប្រអប់កែ — នឹងមកដល់ក្នុងកំណែបន្ត",
        "toggle-toast": "បានប្ដូរ (សាកល្បង) — ការរក្សាទុកនឹងមកដល់ក្នុងកំណែបន្ត",
        "groups": {
          "workflow": "ការវាយតម្លៃ និងលំហូរ",
          "calibration": "ការសម្របសម្រួល",
          "reminders": "ការរំលឹក និងការជូនដំណឹង",
          "integrations": "ការតភ្ជាប់"
        },
        "items": {
          "rating-scale": {
            "title": "មាត្រដ្ឋានវាយតម្លៃ",
            "desc": "កម្រិតដែលប្រើនៅគ្រប់ទម្រង់វាយតម្លៃ",
            "value": "៥ កម្រិត (Outstanding → Unsatisfactory)"
          },
          "cycle-cadence": {
            "title": "ល្បឿនវដ្តលំនាំដើម",
            "desc": "ភាពញឹកញាប់ដែលវដ្តថ្មីបើក",
            "value": "ពាក់កណ្ដាលឆ្នាំ (H1 / H2)"
          },
          "self-review": {
            "title": "តម្រូវការវាយតម្លៃខ្លួនឯង",
            "desc": "បុគ្គលិកត្រូវដាក់ស្នើមុនអ្នកគ្រប់គ្រងបើក",
            "value": "បើក"
          },
          "peer-360": {
            "title": "បើកមតិកែ ៣៦០",
            "desc": "មតិពីមិត្ត / អ្នកក្រោម (ជម្រើស)",
            "value": "បិទ"
          },
          "calib-required": {
            "title": "តម្រូវការសម្របសម្រួល",
            "desc": "ការសម្របសម្រួលរបស់ HR មុនការវាយតម្លៃចុងក្រោយត្រូវចាក់សោ",
            "value": "បើក"
          },
          "forced-dist": {
            "title": "ការចែកចាយដោយបង្ខំ",
            "desc": "កំណត់ % នៃ Outstanding/Exceeds តាមផ្នែក",
            "value": "បិទ (ណែនាំ)"
          },
          "calib-quorum": {
            "title": "សន្តិបាតការសម្របសម្រួល",
            "desc": "អ្នកចូលរួមតិចបំផុតសម្រាប់ផ្នែកដើម្បីសម្របសម្រួល",
            "value": "៥ បុគ្គលិក"
          },
          "reminder-self": {
            "title": "ការរំលឹកការវាយតម្លៃខ្លួនឯង",
            "desc": "ការរំលឹកអ៊ីមែល/ក្នុងកម្មវិធីមុនថ្ងៃកំណត់",
            "value": "៧ ថ្ងៃ · ២ ថ្ងៃ · ថ្ងៃនោះ"
          },
          "reminder-mgr": {
            "title": "ការរំលឹកការវាយតម្លៃរបស់អ្នកគ្រប់គ្រង",
            "desc": "ផ្ញើទៅ LM ដែលមានការវាយតម្លៃកំពុងរង់ចាំ",
            "value": "៥ ថ្ងៃ · ១ ថ្ងៃ · ប្រចាំថ្ងៃក្រោយផុតកំណត់"
          },
          "escalate-overdue": {
            "title": "រាយការណ៍ការវាយតម្លៃហួសកំណត់",
            "desc": "ជូនដំណឹងអ្នកគ្រប់គ្រងបន្ទាប់ក្រោយផុតកំណត់",
            "value": "+៣ ថ្ងៃ"
          },
          "pull-wm": {
            "title": "ទាញពី Work Mgmt",
            "desc": "ភ្ជាប់ភស្តុតាងប្រតិបត្តិការទៅទម្រង់ស្វ័យប្រវត្តិ",
            "value": "បើក"
          },
          "pull-hrops": {
            "title": "ទាញពី HR Ops",
            "desc": "បរិបទវត្តមាន ឈប់សម្រាក OT ក្នុងទម្រង់",
            "value": "បើក"
          },
          "push-payroll": {
            "title": "ផ្ញើរង្វាន់ទៅ Payroll",
            "desc": "ផ្ញើប្រាក់រង្វាន់/កើនប្រាក់ខែដែលបានអនុម័តទៅ Payroll",
            "value": "បើក (ការណែនាំ; Payroll Admin បញ្ជាក់)"
          },
          "push-lnd": {
            "title": "ផ្ញើទៅ L&D",
            "desc": "ផ្ញើផែនការអភិវឌ្ឍ/ការបណ្ដុះបណ្ដាលដែលបានអនុម័តទៅ L&D",
            "value": "បិទ (ម៉ូឌុល L&D មិនទាន់សកម្ម)"
          }
        }
      },
      "subtitle-suffix": "ការអនុវត្តការងារ"
    },
    "billing": {
      "title": "វិក្កយបត្រ",
      "subtitle": "{company} · ការគិតប្រាក់សេវាបន្តរបស់អ្នកផ្គត់ផ្គង់",
      "period-label": "រយៈពេលវិក្កយបត្រ",
      "no-access": "អ្នកមិនមានសិទ្ធិចូលប្រើវិក្កយបត្រទេ។",
      "not-recharged": "មិនត្រូវបានគិតប្រាក់ឡើងវិញ",
      "reconciled": "បានផ្ទៀងផ្ទាត់",
      "direct-notice": "បុគ្គលិកផ្ទាល់គឺជាថ្លៃដើមផ្ទៃក្នុងរបស់ក្រុមហ៊ុន ហើយ{strong}។ ប្តូរទៅវិសាលភាពអតិថិជន ឬគម្រោង ដើម្បីមើលការគិតប្រាក់សេវា។",
      "dashboard-empty": "មិនមានដំណើរការគិតប្រាក់សេវាសម្រាប់វិសាលភាព + រយៈពេលនេះនៅឡើយទេ។",
      "runs-direct-notice": "បុគ្គលិកផ្ទាល់គឺជាថ្លៃដើមផ្ទៃក្នុងរបស់ក្រុមហ៊ុន ហើយ{strong}។",
      "runs-empty": "មិនមានដំណើរការគិតប្រាក់សេវាសម្រាប់វិសាលភាព + រយៈពេលនេះទេ។",
      "recon-direct-notice": "បុគ្គលិកផ្ទាល់មិនត្រូវបានគិតប្រាក់សេវាឡើងវិញ — គ្មានអ្វីត្រូវផ្ទៀងផ្ទាត់ទេ។",
      "tabs": {
        "dashboard": "ផ្ទាំងគ្រប់គ្រង",
        "runs": "ដំណើរការគិតប្រាក់សេវា",
        "recon": "ការផ្ទៀងផ្ទាត់",
        "agreements": "កិច្ចព្រមព្រៀង"
      },
      "kpi": {
        "total-recharge": "ការគិតប្រាក់សេវាសរុប",
        "cost-base": "មូលដ្ឋានថ្លៃដើម",
        "margin-fee": "កម្រៃ / ថ្លៃសេវា",
        "runs": "ដំណើរការគិតប្រាក់សេវា",
        "employees-billed": "បុគ្គលិកដែលបានគិតប្រាក់",
        "reconciled": "បានផ្ទៀងផ្ទាត់",
        "with-variance": "មានភាពខុសគ្នា",
        "period": "រយៈពេល"
      },
      "runs": {
        "col-run-id": "លេខដំណើរការ",
        "col-client-project": "អតិថិជន › គម្រោង",
        "col-method": "វិធីសាស្ត្រ",
        "col-emp": "បុគ្គលិក",
        "col-cost-base": "មូលដ្ឋានថ្លៃដើម",
        "col-margin": "កម្រៃ",
        "col-total": "ការគិតប្រាក់សេវាសរុប",
        "col-recon": "ការផ្ទៀងផ្ទាត់",
        "heading": "ដំណើរការគិតប្រាក់សេវា",
        "count": "{n} ដំណើរការ"
      },
      "recon": {
        "runs-reconciled": "ដំណើរការដែលបានផ្ទៀងផ្ទាត់",
        "total-variance": "ភាពខុសគ្នាសរុប",
        "col-run": "ដំណើរការ",
        "col-project": "គម្រោង",
        "col-payroll-cost": "ថ្លៃដើមបើកប្រាក់ខែ",
        "col-billed-base": "មូលដ្ឋានគិតប្រាក់",
        "col-variance": "ភាពខុសគ្នា",
        "col-status": "ស្ថានភាព",
        "heading": "ការផ្ទៀងផ្ទាត់"
      },
      "detail": {
        "back": "ត្រឡប់",
        "back-to-runs": "ត្រឡប់ទៅដំណើរការ",
        "not-found": "រកមិនឃើញដំណើរការទេ។",
        "service-fee": "ថ្លៃសេវា",
        "pass-through": "ឆ្លងកាត់",
        "margin": "កម្រៃ",
        "lines-heading": "បន្ទាត់គិតប្រាក់សេវា",
        "no-lines": "មិនមានបន្ទាត់គិតប្រាក់សេវាទេ។",
        "col-employee": "បុគ្គលិក",
        "col-cost": "ថ្លៃដើម",
        "col-fee": "ថ្លៃសេវា",
        "col-pass-through": "ឆ្លងកាត់",
        "col-line-total": "សរុបបន្ទាត់",
        "recon-heading": "ការផ្ទៀងផ្ទាត់",
        "payroll-employer-cost": "ថ្លៃដើមនិយោជកបើកប្រាក់ខែ",
        "billed-cost-base": "មូលដ្ឋានថ្លៃដើមដែលបានគិតប្រាក់",
        "variance": "ភាពខុសគ្នា",
        "sources-heading": "ប្រភពបើកប្រាក់ខែ",
        "sources-note": "ការគិតប្រាក់សេវាមានប្រភពពីការបើកប្រាក់ខែ · ADV មិនរាប់បញ្ចូលក្នុងថ្លៃដើម · FIN = ថ្លៃដើមពេញមួយខែ។",
        "advance-excluded": "បុរេប្រទាន (មិនរាប់បញ្ចូលក្នុងថ្លៃដើម)",
        "cost-amount": "ថ្លៃដើម {amount}"
      },
      "loading": "កំពុងផ្ទុកវិក្កយបត្រ…",
      "load-error": "មិនអាចផ្ទុកទិន្នន័យវិក្កយបត្របានទេ។",
      "retry": "ព្យាយាមម្តងទៀត",
      "dashboard-empty-owner": "សូមប្រើ {strong} ខាងលើ។",
      "dashboard-empty-readonly": "ការគិតប្រាក់សេវាត្រូវបានបង្កើតដោយម្ចាស់ពាណិជ្ជកម្មនៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់ — វិសាលភាពនេះជាទិដ្ឋភាពសហការ សម្រាប់តែមើលប៉ុណ្ណោះ។",
      "scope": {
        "all": "វិសាលភាពទាំងអស់",
        "direct": "{company} (ផ្ទាល់)"
      },
      "method": {
        "cost": "ថ្លៃដើម + ថ្លៃសេវា",
        "lump": "ចំនួនសរុបថេរ"
      },
      "status": {
        "reconciled": "បានផ្ទៀងផ្ទាត់",
        "issued": "បានចេញវិក្កយបត្រ",
        "handed": "បានប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុ"
      },
      "gen": {
        "button": "បង្កើតការគិតប្រាក់សេវា",
        "disabled-title": "បង្កើតដោយម្ចាស់ពាណិជ្ជកម្មនៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់"
      },
      "dashboard": {
        "heading": "ផ្ទាំងគ្រប់គ្រងវិក្កយបត្រ",
        "view-runs": "មើលដំណើរការគិតប្រាក់សេវា"
      },
      "panel": {
        "heading": "ម្ចាស់ពាណិជ្ជកម្ម · ប្រតិបត្តិការ",
        "project": "គម្រោង",
        "agreements": "កិច្ចព្រមព្រៀងពាណិជ្ជកម្ម",
        "note": "ម្ចាស់ពាណិជ្ជកម្មតែមួយ៖ ការគិតប្រាក់សេវាត្រូវបានបង្កើតនៅទីនេះ នៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់ សម្រាប់រយៈពេលវិក្កយបត្រដែលបានជ្រើស។ វិសាលភាពអតិថិជន និងគម្រោងពិនិត្យលទ្ធផល។"
      },
      "lifecycle": {
        "issue": "ចេញវិក្កយបត្រ",
        "handoff": "ប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុ",
        "invoice-chip": "វិក្កយបត្រ {no}",
        "issued-line": "បានចេញ {at} ដោយ {by} · ស្ថានភាពចុងក្រោយនៃវិក្កយបត្រ (PO D2)",
        "locked": "បានចាក់សោ",
        "handed-line": "{no} · {at} ដោយ {by}",
        "handoff-note": "ការប្រគល់ដែនការងារជាផ្លូវការ៖ កំណត់ត្រាវិក្កយបត្រត្រូវបានចាក់សោ កិច្ចព្រមព្រៀងពាណិជ្ជកម្ម និងប្រភពបើកប្រាក់ខែត្រូវបានរក្សាទុកជារូបថតទិន្នន័យ ហើយការទទួលខុសត្រូវត្រូវបានផ្ទេរទៅផ្នែកហិរញ្ញវត្ថុ។ ផ្នែកវិក្កយបត្រមិនគ្រប់គ្រងគណនីត្រូវទទួល ឬការប្រមូលប្រាក់ទេ។",
        "agreement-snapshot": "រូបថតកិច្ចព្រមព្រៀង៖ {id} · មានប្រសិទ្ធភាព {date}",
        "payroll-snapshot": "រូបថតបើកប្រាក់ខែ៖ {ids} · ផលបូកត្រួតពិនិត្យ {checksum}"
      },
      "agreements": {
        "heading": "កិច្ចព្រមព្រៀងពាណិជ្ជកម្ម",
        "sub": "តម្លៃ និងច្បាប់គិតប្រាក់សេវាតាមកាលបរិច្ឆេទមានប្រសិទ្ធភាព សម្រាប់គម្រោងអតិថិជននីមួយៗ · កំណែមិនអាចកែប្រែបាន ដូច្នេះវិក្កយបត្រអាចបង្កើតវិក្កយបត្រចាស់ឡើងវិញបានជានិច្ច (PO D1)",
        "form-heading": "កំណែកិច្ចព្រមព្រៀងថ្មី",
        "form-hint": "(កំណែមិនអាចកែប្រែបាន — ការផ្លាស់ប្តូរ = កំណែថ្មីតាមកាលបរិច្ឆេទមានប្រសិទ្ធភាព; PO D1)",
        "project": "គម្រោង",
        "effective": "មានប្រសិទ្ធភាពចាប់ពី",
        "method": "វិធីសាស្ត្រ",
        "fee-type": "ប្រភេទថ្លៃសេវា (ថ្លៃដើម+ថ្លៃសេវា)",
        "fee-percentage": "ភាគរយនៃថ្លៃដើម",
        "fee-per-head": "តាមម្នាក់",
        "fee-flat": "ថេរក្នុងមួយរយៈពេល",
        "fee-value": "តម្លៃថ្លៃសេវា",
        "fee-placeholder": "ឧ. 15",
        "currency": "រូបិយប័ណ្ណ",
        "lump-basis": "មូលដ្ឋានចំនួនសរុបថេរ",
        "lump-per-head": "តាមម្នាក់",
        "lump-flat": "ថេរ",
        "lump-amount": "ចំនួនសរុបថេរ",
        "pass-through": "សមាសធាតុឆ្លងកាត់",
        "pass-through-hint": "(ពីកាតាឡុកសមាសធាតុបើកប្រាក់ខែ — គ្មានតក្កវិជ្ជាបើកប្រាក់ខែស្ទួន)",
        "catalog-unavailable": "កាតាឡុកសមាសធាតុបើកប្រាក់ខែមិនមានទេ",
        "save": "រក្សាទុកកំណែថ្មី",
        "read-only": "កិច្ចព្រមព្រៀងពាណិជ្ជកម្មត្រូវបានរៀបចំដោយម្ចាស់ពាណិជ្ជកម្មនៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់ — នៅទីនេះសម្រាប់តែមើលប៉ុណ្ណោះ។",
        "empty": "មិនទាន់មានកិច្ចព្រមព្រៀងពាណិជ្ជកម្មនៅឡើយទេ។",
        "current": "បច្ចុប្បន្ន",
        "col-version": "កំណែ",
        "col-effective": "មានប្រសិទ្ធភាពចាប់ពី",
        "col-method": "វិធីសាស្ត្រ",
        "col-pricing": "តម្លៃ",
        "col-pass-through": "ឆ្លងកាត់",
        "col-cur": "រូបិយប័ណ្ណ"
      },
      "toast": {
        "generated": "បានបង្កើតការគិតប្រាក់សេវាសម្រាប់ {client} › {project}",
        "issued": "បានចេញវិក្កយបត្រ {no} សម្រាប់ {id} — ស្ថានភាពចុងក្រោយនៃវិក្កយបត្រ។ សូមប្រើ “ប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុ” ដើម្បីផ្ទេរការទទួលខុសត្រូវ។",
        "handed": "{no} ត្រូវបានប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុ — កំណត់ត្រាត្រូវបានចាក់សោ; រូបថតកិច្ចព្រមព្រៀង + បើកប្រាក់ខែត្រូវបានរក្សាទុក។",
        "agreement-saved": "បានរក្សាទុកកំណែកិច្ចព្រមព្រៀង · {project} មានប្រសិទ្ធភាព {date}"
      },
      "error": {
        "refused-generate": "ការគិតប្រាក់សេវាត្រូវបានបង្កើតដោយម្ចាស់ពាណិជ្ជកម្មនៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់ — វិសាលភាពអតិថិជន និងគម្រោងជាទិដ្ឋភាពសហការ សម្រាប់តែមើលប៉ុណ្ណោះ។",
        "refused-issue": "ការចេញវិក្កយបត្រជាសិទ្ធិរបស់ម្ចាស់ពាណិជ្ជកម្មនៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់ — វិសាលភាពនេះជាទិដ្ឋភាពសហការ សម្រាប់តែមើលប៉ុណ្ណោះ។",
        "refused-handoff": "ការប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុជាសិទ្ធិរបស់ម្ចាស់ពាណិជ្ជកម្មនៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់ — វិសាលភាពនេះជាទិដ្ឋភាពសហការ សម្រាប់តែមើលប៉ុណ្ណោះ។",
        "refused-agreement": "កិច្ចព្រមព្រៀងពាណិជ្ជកម្មជាសិទ្ធិរបស់ម្ចាស់ពាណិជ្ជកម្មនៅកម្រិតក្រុមហ៊ុនមេរបស់អ្នកផ្គត់ផ្គង់ — វិសាលភាពនេះជាទិដ្ឋភាពសហការ សម្រាប់តែមើលប៉ុណ្ណោះ។",
        "pick-project": "សូមជ្រើសរើសគម្រោងនៅក្នុងផ្ទាំងបង្កើត",
        "already-exists": "ការគិតប្រាក់សេវាមានរួចហើយសម្រាប់គម្រោង + រយៈពេលនេះ",
        "no-payroll": "គ្មានទិន្នន័យបើកប្រាក់ខែសម្រាប់គិតប្រាក់សេវាក្នុងគម្រោង + រយៈពេលនេះទេ",
        "no-agreement": "គ្មានកិច្ចព្រមព្រៀងពាណិជ្ជកម្មមានប្រសិទ្ធភាពសម្រាប់ {projectId} ក្នុងរយៈពេលនេះទេ — សូមរក្សាទុកកំណែកិច្ចព្រមព្រៀងនៅក្នុងកិច្ចព្រមព្រៀងពាណិជ្ជកម្មជាមុនសិន។",
        "run-not-found": "រកមិនឃើញដំណើរការទេ",
        "locked": "ដំណើរការនេះត្រូវបានប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុ — វាត្រូវបានចាក់សោ និងមិនអាចកែប្រែបានទេ។",
        "not-reconciled": "អាចចេញវិក្កយបត្របានតែដំណើរការដែលបានផ្ទៀងផ្ទាត់ប៉ុណ្ណោះ (ស្ថានភាពបច្ចុប្បន្ន៖ {status})។",
        "variance": "សូមដោះស្រាយភាពខុសគ្នានៃការផ្ទៀងផ្ទាត់ មុនពេលចេញវិក្កយបត្រនេះ។",
        "already-handed": "បានប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុរួចហើយ។",
        "not-issued": "អាចប្រគល់ទៅផ្នែកហិរញ្ញវត្ថុបានតែវិក្កយបត្រដែលបានចេញប៉ុណ្ណោះ (ស្ថានភាពបច្ចុប្បន្ន៖ {status})។",
        "project-required": "ត្រូវការគម្រោង",
        "effective-required": "ត្រូវការកាលបរិច្ឆេទមានប្រសិទ្ធភាព",
        "duplicate-version": "មានកំណែកិច្ចព្រមព្រៀងសម្រាប់គម្រោងនេះចាប់ផ្តើមនៅ {date} រួចហើយ — សូមជ្រើសរើសកាលបរិច្ឆេទមានប្រសិទ្ធភាពផ្សេង។",
        "generic": "មានបញ្ហាកើតឡើង — សូមព្យាយាមម្តងទៀត។"
      }
    },
    "insights": {
      "title": "ការវិភាគ",
      "subtitle": "របាយការណ៍ និងវិភាគ · គ្រប់ម៉ូឌុលទាំងអស់",
      "toast-open": "បើក {name}",
      "tiles": {
        "headcount": {
          "title": "ចំនួនបុគ្គលិក",
          "desc": "ផ្ទាល់ · ក្រៅ · ខាងក្រៅ"
        },
        "turnover": {
          "title": "អត្រាបុគ្គលិកចូលចេញ",
          "desc": "ស្ម័គ្រចិត្ត គ្មានស្ម័គ្រចិត្ត តាមគម្រោង"
        },
        "attendance": {
          "title": "វត្តមាន",
          "desc": "មានវត្តមាន យឺត អវត្តមាន OT"
        },
        "payroll-cost": {
          "title": "តម្លៃប្រាក់ខែ",
          "desc": "ច្រាស សុទ្ធ ពន្ធ ប្រាក់ឧបត្ថម្ភ"
        },
        "project-profitability": {
          "title": "ផលចំណេញគម្រោង",
          "desc": "តម្លៃវិក្កយបត្រធៀបនឹងតម្លៃ ប្រាក់ចំណេញ"
        },
        "compliance": {
          "title": "ការអនុលោម",
          "desc": "កិច្ចសន្យាជិតផុតកំណត់ NSSF TOS"
        }
      }
    },
    "ownKit": {
      "crumb": {
        "label": "ផ្លូវរុករកកម្រិត"
      },
      "filter": {
        "period": "កំឡុងពេលប្រាក់ខែ",
        "all-periods": "គ្រប់កំឡុងពេល",
        "type": "ប្រភេទ",
        "all-types": "ប្រភេទទាំងអស់",
        "type-adv": "បុរេប្រទាន",
        "type-fin": "ចុងក្រោយ",
        "type-off": "ក្រៅវដ្ត",
        "published-only": "តែការបើកប្រាក់ខែដែលបានផ្សព្វផ្សាយប៉ុណ្ណោះ"
      },
      "quick": {
        "label": "តម្រងរហ័ស",
        "all": "ទាំងអស់",
        "attention": "ត្រូវការចាប់អារម្មណ៍",
        "payroll-ready": "រួចរាល់សម្រាប់ប្រាក់ខែ",
        "locked": "បានចាក់សោ",
        "ready": "រួចរាល់",
        "inflight": "កំពុងដំណើរការ"
      },
      "portfolio": {
        "label": "ផលប័ត្រត្រួតពិនិត្យ",
        "lead": "ទិដ្ឋភាពត្រួតពិនិត្យ · តែចំនួនប៉ុណ្ណោះ។",
        "banner": "ប្រតិបត្តិការធ្វើឡើងនៅវិសាលភាពម្ចាស់; កំណត់ត្រាដែលបានផ្សព្វផ្សាយបង្ហាញលម្អិតខាងក្រោម; ការងារកំពុងដំណើរការត្រូវបានសរុបជាចំនួន។",
        "empty": "មិនទាន់មានកំណត់ត្រាដែលបានផ្សព្វផ្សាយក្នុងវិសាលភាពនេះនៅឡើយទេ។"
      }
    },
    "moreapps": {
      "title": "កម្មវិធីបន្ថែម",
      "subtitle": "កន្លែងបើកដំណើរការប្រព័ន្ធអេកូ · ការពង្រីកវេទិកាកម្លាំងពលកម្ម",
      "section-live": "មានឥឡូវនេះ",
      "section-future": "នឹងមកដល់វេទិកា",
      "tag-live": "Live",
      "tag-soon": "ឆាប់ៗ",
      "title-open": "បើក {name}",
      "toasts": {
        "coming-soon": "{name} — ឆាប់ៗនេះ"
      },
      "live": {
        "stock": {
          "label": "ការគ្រប់គ្រងស្តុក",
          "desc": "ស្តុក FMCG · ឃ្លាំងច្រើន · បាច់/ផុតកំណត់ · ការផ្គត់ផ្គង់"
        },
        "lnd": {
          "label": "L&D",
          "desc": "ការសិក្សា និងអភិវឌ្ឍន៍ · វគ្គសិក្សា · ម៉ាទ្រីសសមត្ថភាព · វិញ្ញាបនបត្រ"
        },
        "admin": {
          "label": "Admin",
          "desc": "ការកំណត់រចនាសម្ព័ន្ធអ្នកជួល · អ្នកប្រើ · តួនាទី · ទិន្នន័យមេ · គោលនយោបាយ · វេទិកា"
        }
      },
      "future": {
        "recruitment": "ការជ្រើសរើស",
        "benefits": "អត្ថប្រយោជន៍",
        "ai-assistant": "AI ជំនួយ",
        "survey": "ការស្ទង់មតិ",
        "asset-mgmt": "ការគ្រប់គ្រងទ្រព្យសកម្ម",
        "compliance-center": "មជ្ឈមណ្ឌលការអនុលោម"
      }
    },
    "fieldops": {
      "shared": {
        "status": {
          "completed": "បានបញ្ចប់",
          "missed": "ខកខាន",
          "inprogress": "កំពុងដំណើរការ",
          "scheduled": "បានកំណត់កាលវិភាគ",
          "planned": "បានគ្រោងទុក",
          "cancelled": "បានលុបចោល"
        },
        "flag": {
          "flagged": "⚑ បានសម្គាល់",
          "critical": " · ធ្ងន់ធ្ងរ"
        },
        "pager": {
          "summary": "{n} ជួរ · ទំព័រ {page} / {pages}",
          "prev": "‹ មុន",
          "next": "បន្ទាប់ ›",
          "label": "ការបែងចែកទំព័រ"
        },
        "breadcrumb": {
          "label": "ផ្លូវរុករក"
        },
        "lifecycle": {
          "label": "វឌ្ឍនភាពវដ្តជីវិត"
        }
      },
      "title": "Field Ops",
      "kind": {
        "sup": "ប្រតិបត្តិការវាល",
        "oversight": "ការត្រួតពិនិត្យថ្នាក់គ្រប់គ្រង",
        "admin": "ការកំណត់រចនាសម្ព័ន្ធ និងសវនកម្ម"
      },
      "subtitle": "{project} · {kind}",
      "portfolio": {
        "company": "{name} · ផលប័ត្រ (តាមអតិថិជន)",
        "client": "{name} · ផលប័ត្រ (តាមគម្រោង)",
        "scope-company": "វិសាលភាពក្រុមហ៊ុន",
        "scope-client": "វិសាលភាពអតិថិជន",
        "mode": "ទិដ្ឋភាពផលប័ត្រសរុប — តែចំនួនប៉ុណ្ណោះ",
        "hint-company": "ដាក់ជាក្រុមតាមអតិថិជន; ជ្រើសរើសអតិថិជនដើម្បីមើលលម្អិតគម្រោងរបស់ខ្លួន។ ការចុះពិនិត្យកម្រិតកំណត់ត្រាស្ថិតនៅវិសាលភាពគម្រោង ក្រោមគំរូសិទ្ធិចូលប្រើដែលមានស្រាប់។",
        "hint-client": "ដាក់ជាក្រុមតាមគម្រោងរបស់អតិថិជននេះ; ព័ត៌មានរបស់គម្រោងនីមួយៗត្រូវបានរក្សាដាច់ដោយឡែក។ បើកគម្រោងមួយ ដើម្បីប្រើបទពិសោធន៍ប្រតិបត្តិការ។",
        "kind-company": "ផលប័ត្រក្រុមហ៊ុន",
        "kind-client": "ផលប័ត្រអតិថិជន",
        "period-label": "រយៈពេលផលប័ត្រ",
        "all-periods": "គ្រប់រយៈពេល",
        "reset": "កំណត់ឡើងវិញ",
        "col": {
          "client": "អតិថិជន",
          "projects": "គម្រោង",
          "active": "PJP សកម្ម",
          "inpr": "កំពុងដំណើរការ",
          "done": "បានបញ្ចប់",
          "miss": "ខកខាន",
          "flag": "បានដាក់ទង់",
          "completion": "អត្រាបញ្ចប់",
          "coverage": "ការគ្របដណ្តប់",
          "project": "គម្រោង",
          "pjp-status": "ស្ថានភាព PJP",
          "planned": "បានគ្រោងទុក",
          "outcomes": "លទ្ធផលពេលបិទ",
          "actions": "សកម្មភាព"
        },
        "open-client": "បើកអតិថិជន →",
        "open-client-aria": "បើកអតិថិជន {name}",
        "view": "មើល",
        "view-aria": "មើលអតិថិជន {name}",
        "open-project": "បើកគម្រោង →",
        "open-project-aria": "បើកគម្រោង {name}",
        "no-activity": "មិនទាន់មានសកម្មភាព Field Ops នៅឡើយ",
        "status-none": "គ្មាន PJP",
        "status-active": "{n} សកម្ម",
        "status-pending": "{n} កំពុងរង់ចាំការអនុម័ត",
        "outcomes": "{met} សម្រេចតាមផែនការ · {part} សម្រេចបានមួយផ្នែក",
        "empty-company": "គ្មានអតិថិជនសកម្មទេ។",
        "empty-client": "គ្មានគម្រោងក្រោមអតិថិជននេះទេ។",
        "unav": "ប្រតិទិនប្រតិបត្តិការ (សរុប អានតែប៉ុណ្ណោះ)៖ រយៈពេលហាងមិនអាចចុះពិនិត្យបាន {n} ខាងមុខ នៅទូទាំងផលប័ត្រ — ព័ត៌មានលម្អិតមាននៅវិសាលភាពគម្រោង។",
        "own-ops": "ប្រតិបត្តិការផ្ទាល់ (ទីតាំងផ្ទាល់)៖ ការចុះពិនិត្យនៅទីតាំង {n} — ប្តូរឧបករណ៍ជ្រើសវិសាលភាពទៅ {scope} ដើម្បីមើលកម្រិតកំណត់ត្រា។",
        "direct-workforce": "កម្លាំងពលកម្មផ្ទាល់",
        "isolation-company": "ការញែកទិន្នន័យអនុវត្តតាមក្របខ័ណ្ឌកម្មសិទ្ធិដែលមានស្រាប់ — កំណត់ត្រារបស់អតិថិជនម្នាក់ មិនដែលត្រូវបានលាយបញ្ចូលក្នុងទិដ្ឋភាពរបស់អតិថិជនផ្សេងទៀតឡើយ។",
        "isolation-client": "ព័ត៌មាន PJP និងការចុះពិនិត្យកម្រិតកំណត់ត្រា ស្ថិតនៅវិសាលភាពគម្រោង ក្រោមតួនាទី និងសិទ្ធិចូលប្រើដែលបានអនុម័តរបស់អ្នកប្រើ។"
      },
      "today-label": "{date} · {tz}",
      "tabs-label": "ផ្នែកនៃ Field Ops",
      "subtabs-label": "ទិដ្ឋភាព {tab}",
      "tabs": {
        "cc": "មជ្ឈមណ្ឌលបញ្ជា",
        "plan": "ផែនការ",
        "exec": "អនុវត្ត",
        "actions": "សកម្មភាព",
        "insights": "ការយល់ដឹងពីការអនុវត្ត",
        "config": "ការកំណត់រចនាសម្ព័ន្ធ",
        "vtpl": "គំរូការចុះជួប",
        "cal": "ប្រតិទិនប្រតិបត្តិការ",
        "audit": "សវនកម្ម"
      },
      "subtabs": {
        "sup": {
          "exec": {
            "today": "ថ្ងៃនេះ",
            "week": "សប្តាហ៍",
            "history": "ប្រវត្តិ"
          },
          "plan": {
            "detail": "ព័ត៌មានលម្អិតផែនការ"
          }
        },
        "rsm": {
          "plan": {
            "queue": "ជួររង់ចាំការអនុម័ត",
            "reg": "បញ្ជី PJP តាមតំបន់",
            "ready": "ការត្រៀមខ្លួនរៀបផែនការ"
          },
          "exec": {
            "cov": "ការអនុវត្តតាមតំបន់",
            "exc": "ករណីលើកលែង",
            "recs": "កំណត់ត្រាការចុះជួប",
            "md": "ការចុះជួបតាមបញ្ជាអ្នកគ្រប់គ្រង",
            "load": "បន្ទុកការងាររបស់អ្នកត្រួតពិនិត្យ"
          }
        },
        "hrbp": {
          "plan": {
            "comp": "ការអនុលោមតាមផែនការ",
            "work": "បន្ទុកការងាររបស់អ្នកត្រួតពិនិត្យ",
            "ready": "ផែនការហួសកាលកំណត់"
          },
          "exec": {
            "cov": "ការគ្របដណ្តប់",
            "exc": "សូចនាករករណីលើកលែង",
            "load": "បន្ទុកការងាររបស់អ្នកត្រួតពិនិត្យ"
          }
        },
        "gov": {
          "exec": {
            "cov": "ការគ្របដណ្តប់",
            "exc": "ករណីលើកលែង"
          }
        }
      },
      "actor": {
        "tag": "ធ្វើការជា · សាកល្បង",
        "aria": "កំពុងធ្វើការជា {name}, {sub}។ ប្ដូរតួនាទីសាកល្បង។",
        "menu-label": "តួនាទីសាកល្បង",
        "groups": {
          "system": "សិទ្ធិប្រព័ន្ធ",
          "governance": "អភិបាលកិច្ច និងការត្រួតពិនិត្យ",
          "regional": "ប្រតិបត្តិការតាមតំបន់"
        },
        "unassigned": "ខ្សែបន្ទាត់មិនទាន់ចាត់តាំង",
        "note": "ការធ្វើការជាតួនាទីផ្សេង គឺជាការជំនួសសាកល្បងសម្រាប់ SSO — បញ្ជីតួនាទី និងសិទ្ធិទាំងអស់ត្រូវបានទាញចេញពីទំនាក់ទំនងរាយការណ៍ជាក់ស្តែង មិនមែនពីលេខកូដថេរទេ។ ការដាក់ជាក្រុម និងការចូលបន្ទាត់ គឺសម្រាប់ជួយឱ្យយល់ក្នុងការសាកល្បងប៉ុណ្ណោះ។ អ្នកគ្រប់គ្រងប្រព័ន្ធ គឺជាតួនាទីចូលប្រើប្រព័ន្ធ មិនមែនជាអ្នកគ្រប់គ្រងអង្គភាពនៃតួនាទីខាងក្រោមទេ ហើយតួនាទីអភិបាលកិច្ចស្ថិតនៅក្រៅខ្សែរាយការណ៍ RSM។",
        "sub": {
          "sup": "អ្នកត្រួតពិនិត្យការលក់ · {region}",
          "rsm": "RSM (ខាងក្រៅ) · {region}",
          "hrbp": "HRBP · ការត្រួតពិនិត្យរបស់ Optimal P",
          "champion": "អ្នកជំរុញគម្រោង (ខាងក្រៅ, មើលតែប៉ុណ្ណោះ)",
          "leader": "អ្នកដឹកនាំគម្រោង (ខាងក្រៅ, មើលតែប៉ុណ្ណោះ)",
          "admin": "អ្នកគ្រប់គ្រងធនធានមនុស្ស · ការកំណត់រចនាសម្ព័ន្ធ + សវនកម្ម"
        },
        "switch-failed": "មិនអាចប្ដូរតួនាទីសាកល្បងបានទេ។"
      },
      "reset": {
        "button": "កំណត់ទិន្នន័យសាកល្បង Field Ops ឡើងវិញ",
        "title": "ស្ដារទិន្នន័យមូលដ្ឋានសាកល្បង Field Ops ដែលកំណត់ជាមុន",
        "ask": "កំណត់ទិន្នន័យសាកល្បង Field Ops ទាំងអស់ត្រឡប់ទៅមូលដ្ឋានវិញ?",
        "keep": "រក្សាទុក",
        "go": "កំណត់ទិន្នន័យសាកល្បងឡើងវិញ",
        "flash": "ទិន្នន័យសាកល្បង Field Ops ត្រូវបានកំណត់ត្រឡប់ទៅមូលដ្ឋានដែលកំណត់ជាមុនវិញ។",
        "failed": "មិនអាចកំណត់ទិន្នន័យសាកល្បង Field Ops ឡើងវិញបានទេ។"
      },
      "panel": {
        "placeholder-title": "{view}",
        "placeholder-body": "ទិដ្ឋភាពនេះកំពុងត្រូវបានបង្កើត — វានឹងមកដល់ក្នុងការចេញផ្សាយ Field Ops បន្ទាប់។",
        "portfolio-company": "ផលប័ត្រក្រុមហ៊ុន",
        "portfolio-client": "ផលប័ត្រអតិថិជន",
        "legacy": "គម្រោងនេះមិនទាន់មានហាងលក់នៅឡើយទេ ដូច្នេះកន្លែងធ្វើការប្រតិបត្តិការ Field Ops មិនអាចប្រើបាន។ បន្ថែមហាងលក់ទៅគម្រោងក្នុង Site Master ដើម្បីរៀបផែនការផ្លូវ និងការចុះជួប។"
      },
      "state": {
        "loading": "កំពុងផ្ទុក Field Ops…",
        "error": "មិនអាចផ្ទុកទិន្នន័យ Field Ops បានទេ។",
        "retry": "ព្យាយាមម្តងទៀត",
        "not-found": "រកមិនឃើញគម្រោងនេះទេ។"
      },
      "exec": {
        "mode": {
          "label": "របៀបបង្ហាញ",
          "list": "បញ្ជី",
          "map": "ផែនទី",
          "my-route": "ផ្លូវរបស់ខ្ញុំ · {date}",
          "regional": "ការអនុវត្តតាមតំបន់",
          "coverage": "ការគ្របដណ្តប់",
          "map-title": "ផែនទីផ្លូវ"
        },
        "origin": {
          "label": "ដឹកនាំដោយអ្នកគ្រប់គ្រង",
          "title": "ប្រភព៖ ដឹកនាំដោយអ្នកគ្រប់គ្រង/បន្ទាន់ — ណែនាំដោយអ្នកគ្រប់គ្រងផ្ទាល់ មិនមែនជាផ្នែកនៃ PJP ប្រចាំខែទេ"
        },
        "kpi": {
          "today-stops": "ចំណតថ្ងៃនេះ",
          "planned-route": "ផ្លូវដែលបានគ្រោង",
          "completed-today": "បានបញ្ចប់ថ្ងៃនេះ",
          "of": "ក្នុងចំណោម {n}",
          "month-completion": "ការបញ្ចប់ប្រចាំខែ",
          "due-sub": "{done} / {due} ដល់កំណត់",
          "open-fu": "ការតាមដានកំពុងបើក",
          "overdue-sub": "{n} ហួសកំណត់",
          "coverage": "ការគ្របដណ្តប់",
          "outlets-sub": "{visited} / {total} ហាង",
          "completion": "ការបញ្ចប់",
          "missed": "ខកខាន",
          "count": "ចំនួន",
          "flagged": "មានទង់សម្គាល់",
          "critical-sub": "{n} ធ្ងន់ធ្ងរ",
          "in-population": "ក្នុងក្រុមដែលបានច្រោះ",
          "flagged-completed": "មានទង់សម្គាល់ (បានបញ្ចប់)"
        },
        "today": {
          "open-field": "បើករបៀបការងារវាល (ទូរស័ព្ទ)",
          "check-in": "ចុះឈ្មោះចូល",
          "continue": "បន្តបញ្ជីត្រួតពិនិត្យ →",
          "empty": "គ្មានការចុះពិនិត្យលើផ្លូវថ្ងៃនេះទេ។ សូមពិនិត្យប្រតិទិនប្រចាំសប្តាហ៍ ឬបង្កើតសប្តាហ៍នេះពី PJP ដែលបានផ្សព្វផ្សាយរបស់អ្នក។",
          "promoter": "អ្នកផ្សព្វផ្សាយ៖ {name}",
          "combined": "រួមបញ្ចូលគ្នា",
          "combined-title": "ការចុះពិនិត្យផ្ទាល់មួយបំពេញទាំងតម្រូវការដឹកនាំដោយអ្នកគ្រប់គ្រង និងការចុះពិនិត្យ PJP ដែលមានសិទ្ធិ ({id})",
          "linked": "ភ្ជាប់ទៅការចុះពិនិត្យរួម {id}",
          "linked-title": "ការចុះពិនិត្យរួម ({id}) គ្របដណ្តប់ការចុះពិនិត្យ PJP នេះ — ការបញ្ចប់នៅទីនោះបំពេញកាតព្វកិច្ចនេះម្តង គ្មានការរាប់ស្ទួន",
          "overlap": "{n} ភារកិច្ចត្រួតគ្នាត្រូវបានដកស្ទួន | {n} ភារកិច្ចត្រួតគ្នាត្រូវបានដកស្ទួន"
        },
        "cycle": {
          "title": "វឌ្ឍនភាពវដ្តចុះពិនិត្យ · {period}",
          "sub": "ស្ថានភាពអនុវត្តផ្ទាល់នៃ PJP ដែលបានអនុម័តរបស់អ្នក — ការកែប្រែផែនការនៅតែក្នុងកម្មវិធីបង្កើត / វិសោធនកម្ម",
          "in-progress": "វដ្តចុះពិនិត្យ {k} កំពុងដំណើរការ · {done}/{elig}",
          "all-complete": "វដ្តចុះពិនិត្យទាំងអស់បានបញ្ចប់",
          "name": "វដ្តចុះពិនិត្យ {k}",
          "outlets": "{done}/{elig} ហាង | {done}/{elig} ហាង",
          "complete": " · បានបញ្ចប់",
          "remaining": " · នៅសល់ {n}",
          "not-due": " · មិនទាន់ដល់កំណត់",
          "next": "ការចុះពិនិត្យបន្ទាប់ដែលត្រូវការ៖",
          "due": "កំណត់ {date}"
        },
        "week": {
          "label": "សប្តាហ៍",
          "w": "ស{n}",
          "generate": "បង្កើតសប្តាហ៍ទី {n} ពី PJP",
          "report": "រាយការណ៍ហាងមិនអាចចូលបាន",
          "today": " · ថ្ងៃនេះ",
          "schedule": "កំណត់កាលវិភាគ",
          "reschedule": "ប្តូរកាលវិភាគ",
          "reschedule-of": "ប្តូរកាលវិភាគ {name}",
          "new-date": "កាលបរិច្ឆេទថ្មី",
          "reason": "មូលហេតុ",
          "move": "ផ្លាស់ទី",
          "cancel": "បោះបង់ការប្តូរកាលវិភាគ",
          "empty": "មិនទាន់បានបង្កើតការចុះពិនិត្យសម្រាប់សប្តាហ៍ទី {n} នៅឡើយ",
          "empty-gen": " — ប្រើ “បង្កើតសប្តាហ៍”។",
          "empty-nopjp": " (PJP មិនទាន់បានអនុម័ត)។",
          "generated": "បានបង្កើតការចុះពិនិត្យ {n} សម្រាប់សប្តាហ៍ទី {w} | បានបង្កើតការចុះពិនិត្យ {n} សម្រាប់សប្តាហ៍ទី {w}"
        },
        "filter": {
          "search": "ស្វែងរកហាង / បុគ្គល / លេខសម្គាល់",
          "all-regions": "តំបន់ទាំងអស់",
          "all-rsms": "RSM ទាំងអស់",
          "all-sups": "អ្នកគ្រប់គ្រងទាំងអស់",
          "all-provinces": "ខេត្តទាំងអស់",
          "all-outlets": "ហាងទាំងអស់",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "from": "ពីកាលបរិច្ឆេទ",
          "to": "ដល់កាលបរិច្ឆេទ",
          "clear": "សម្អាត",
          "clear-one": "សម្អាត {field}",
          "field": {
            "q": "ស្វែងរក",
            "region": "តំបន់",
            "rsm": "RSM",
            "sup": "អ្នកគ្រប់គ្រង",
            "province": "ខេត្ត",
            "outlet": "ហាង",
            "status": "ស្ថានភាព",
            "from": "ពី",
            "to": "ដល់"
          }
        },
        "status": {
          "planned": "បានគ្រោង",
          "scheduled": "បានកំណត់ពេល",
          "inprogress": "កំពុងដំណើរការ",
          "completed": "បានបញ្ចប់",
          "flagged": "បានបញ្ចប់ — មានទង់សម្គាល់",
          "missed": "ខកខាន",
          "cancelled": "បានបោះបង់"
        },
        "cols": {
          "id": "លេខសម្គាល់",
          "outlet": "ហាង",
          "supervisor": "អ្នកគ្រប់គ្រង",
          "promoter": "អ្នកផ្សព្វផ្សាយ",
          "planned": "បានគ្រោង",
          "status": "ស្ថានភាព",
          "score": "ពិន្ទុ"
        },
        "table": {
          "empty": "គ្មានការចុះពិនិត្យត្រូវគ្នាទេ។"
        },
        "mgmt": {
          "period": "រយៈពេល",
          "execution": " · ការអនុវត្ត",
          "planning": " · ការរៀបចំផែនការ",
          "all-periods": "រយៈពេលទាំងអស់",
          "all": "{label} (ទាំងអស់)",
          "locked": "ជាប់សោតាមវិសាលភាពដែលអ្នកមានសិទ្ធិ",
          "all-exc": "ប្រភេទករណីលើកលែងទាំងអស់",
          "exc": {
            "missed": "ខកខាន",
            "flagged": "មានទង់សម្គាល់ (បានបញ្ចប់)",
            "critical": "ទង់ធ្ងន់ធ្ងរ",
            "overdue": "ការតាមដានហួសកំណត់"
          },
          "chip": {
            "period": "រយៈពេល",
            "region": "តំបន់",
            "rsm": "RSM",
            "sup": "អ្នកគ្រប់គ្រង",
            "province": "ខេត្ត",
            "dt": "DT",
            "exc": "ករណីលើកលែង"
          },
          "clear": "សម្អាត",
          "reset": "កំណត់តម្រងឡើងវិញ",
          "dim": {
            "region": "តំបន់",
            "rsm": "RSM",
            "sup": "អ្នកគ្រប់គ្រង",
            "province": "ខេត្ត",
            "dt": "DT"
          },
          "by": "តាម{dim}",
          "by-dt": "តាម DT",
          "drill-hint": "ចុចលើជួរដើម្បីមើលលម្អិត",
          "drill-row": "{name} — មើលលម្អិត",
          "no-data": "គ្មានទិន្នន័យក្នុងក្រុមដែលបានច្រោះទេ។",
          "col": {
            "outlets": "ហាង",
            "visited": "បានចុះពិនិត្យ",
            "coverage": "ការគ្របដណ្តប់",
            "completion": "ការបញ្ចប់",
            "missed": "ខកខាន",
            "flagged": "មានទង់",
            "critical": "ធ្ងន់ធ្ងរ",
            "open-fu": "តាមដានបើក",
            "overdue-fu": "តាមដានហួសកំណត់"
          },
          "hrbp-note": "ការគ្របដណ្តប់កម្លាំងពលកម្ម និងអ្នកគ្រប់គ្រង — មើលលម្អិតតាមគម្រោង → តំបន់ → RSM → អ្នកគ្រប់គ្រង → ខេត្ត/DT។ តែទិន្នន័យសរុបប៉ុណ្ណោះ គ្មានប្រតិបត្តិការចុះពិនិត្យទេ។"
        },
        "exc": {
          "missed-title": "ការចុះពិនិត្យដែលខកខាន — កម្រិតកំណត់ត្រា (តំបន់របស់អ្នក)",
          "flagged-title": "បានបញ្ចប់ — មានទង់សម្គាល់ (កំណត់ត្រាដែលបានផ្សព្វផ្សាយ)",
          "overdue-title": "ការតាមដានហួសកំណត់",
          "overdue-row": "· ម្ចាស់ {owner} · កំណត់ {due}",
          "none": "គ្មាន។"
        },
        "recs": {
          "note": "កំណត់ត្រាចុះពិនិត្យដែលមានសិទ្ធិទូទាំងតំបន់របស់អ្នក (ច្បាប់ផ្សព្វផ្សាយ D2-107 មិនផ្លាស់ប្តូរ)។"
        },
        "load": {
          "note": "បន្ទុកការងាររបស់អ្នកគ្រប់គ្រងធៀបនឹងសមត្ថភាពផែនការ — រយៈពេលបច្ចុប្បន្ន {period}។",
          "col": {
            "supervisor": "អ្នកគ្រប់គ្រង",
            "region": "តំបន់",
            "outlets": "ហាង",
            "planned": "ការចុះពិនិត្យដែលបានគ្រោង",
            "capacity": "សមត្ថភាព",
            "utilisation": "អត្រាប្រើប្រាស់",
            "peak": "ថ្ងៃកំពូល"
          },
          "no-plan": "គ្មានផែនការដែលបានអនុម័តសម្រាប់រយៈពេលនេះ",
          "empty": "គ្មានអ្នកគ្រប់គ្រងក្នុងវិសាលភាពទេ។"
        },
        "months": {
          "1": "មករា",
          "2": "កុម្ភៈ",
          "3": "មីនា",
          "4": "មេសា",
          "5": "ឧសភា",
          "6": "មិថុនា",
          "7": "កក្កដា",
          "8": "សីហា",
          "9": "កញ្ញា",
          "10": "តុលា",
          "11": "វិច្ឆិកា",
          "12": "ធ្នូ"
        }
      },
      "rsm": {
        "more": "ទៀត",
        "cycle": "វដ្ត {k}",
        "weekly": "បន្ទុកការងារប្រចាំសប្ដាហ៍៖",
        "clustering": "ការដាក់ក្រុមតាមភូមិសាស្ត្រ៖",
        "state": {
          "loading": "កំពុងផ្ទុកជួរអនុម័ត…",
          "error": "មិនអាចផ្ទុកជួរអនុម័តបានទេ។",
          "loading-review": "កំពុងផ្ទុកការពិនិត្យផែនការ…",
          "error-review": "មិនអាចផ្ទុកការពិនិត្យផែនការបានទេ។"
        },
        "queue": {
          "note": "អ្នកអនុម័ត{plan} មិនមែនការចុះទស្សនកិច្ចនីមួយៗទេ។ ការអនុម័តបោះពុម្ពផ្សាយផែនការទាំងមូលក្នុងពេលតែមួយ — វាចាប់ផ្ដើមប្រតិបត្តិភ្លាមៗ ហើយកាលបរិច្ឆេទចុះទស្សនកិច្ចនាពេលខាងមុខត្រូវបានរក្សាទុក។ សិទ្ធិរបស់អ្នកគ្របដណ្ដប់តែអ្នកគ្រប់គ្រងក្នុងតំបន់របស់អ្នកប៉ុណ្ណោះ។",
          "plan": "ផែនការ",
          "meta": "{id} · កំណែ {rev} · ហាង {outlets} · ប៉ាន់ស្មាន {est} ដងចុះទស្សនកិច្ចតាមប្រតិទិន · បានដាក់ស្នើ {at}",
          "review": "ពិនិត្យផែនការ",
          "hide": "លាក់ការពិនិត្យ",
          "empty": "មិនមានផែនការដែលបានដាក់ស្នើកំពុងរង់ចាំការអនុម័តរបស់អ្នកទេ។",
          "amendments": "សំណើកែប្រែ"
        },
        "sla": {
          "approval": "ការអនុម័ត",
          "decision": "ការសម្រេច",
          "state": {
            "ok": "តាមកាលកំណត់",
            "reminder": "ជិតដល់ថ្ងៃកំណត់",
            "urgent": "បន្ទាន់ — ដល់ថ្ងៃកំណត់ថ្ងៃនេះ",
            "breached": "ហួសកាលកំណត់",
            "escalated": "បានបញ្ជូនបន្ត",
            "met": "បានបំពេញ",
            "met-late": "បានបំពេញយឺត",
            "met-offline": "បានបំពេញ · បានធ្វើសមកាលកម្មក្រៅបណ្ដាញ"
          },
          "wd": "{n} ថ្ងៃធ្វើការ",
          "by": "ត្រឹម {date}",
          "sync": "រង់ចាំសមកាលកម្ម",
          "paused": "បានផ្អាក (ច្បាប់ឈប់សម្រាកដែលបានអនុម័ត)",
          "policy": "គោលការណ៍ {ref}",
          "capped": "គោលដៅត្រូវបានកំណត់ពិដាន",
          "legacy": "កំណត់ត្រាចាស់"
        },
        "life": {
          "draft": "សេចក្ដីព្រាង",
          "submitted": "បានដាក់ស្នើ",
          "approved": "បានអនុម័ត និងបោះពុម្ពផ្សាយ",
          "owner-rsm": "RSM · {name}",
          "owner-sup": "អ្នកគ្រប់គ្រង · {name}",
          "next": {
            "draft": "ដាក់ស្នើទៅ RSM",
            "returned": "កែសម្រួល និងដាក់ស្នើឡើងវិញ (កំណែ {rev})",
            "submitted": "ការសម្រេចរបស់ RSM — អនុម័ត និងបោះពុម្ពផ្សាយ ឬបង្វិលឱ្យកែសម្រួល",
            "approved-published": "បង្កើតសប្ដាហ៍ និងអនុវត្ត · ការផ្លាស់ប្ដូរតាមរយៈសំណើកែប្រែ",
            "cancelled": "គ្មាន — ផែនការត្រូវបានលុបចោល",
            "archived": "គ្មាន — បានរក្សាទុកក្នុងបណ្ណសារ"
          },
          "returned": "បានបង្វិលឱ្យកែសម្រួល · កំណែ {rev}",
          "cancelled": "បានលុបចោល",
          "amendment": "ការកែប្រែ {status} · {id}",
          "amend-status": {
            "requested": "បានស្នើ",
            "approved": "បានអនុម័ត",
            "rejected": "បានបដិសេធ"
          },
          "stage": "ដំណាក់កាល៖",
          "rev": "កំណែ {rev}",
          "owner": "ម្ចាស់៖",
          "next-label": "សកម្មភាពបន្ទាប់៖",
          "history": "វដ្តជីវិត និងប្រវត្តិកំណែ ({n} ព្រឹត្តិការណ៍)"
        },
        "review": {
          "period": "រយៈពេលរៀបចំផែនការ",
          "rev": "កំណែ {rev}",
          "sup-note": "កំណត់ចំណាំរបស់អ្នកគ្រប់គ្រង៖",
          "no-note": "មិនមានកំណត់ចំណាំនៃការដាក់ស្នើទេ។",
          "kpi": {
            "planned": "ការចុះទស្សនកិច្ចតាមផែនការ",
            "coverage": "ការគ្របដណ្ដប់ហាង",
            "gaps": "ចន្លោះខ្វះការគ្របដណ្ដប់",
            "remaining": "សមត្ថភាពនៅសល់"
          },
          "target": "គោលដៅ {n}",
          "below": "ខ្វះ {n} ពីគោលដៅ",
          "above": "លើស {n} ពីគោលដៅ",
          "target-met": "បានសម្រេចគោលដៅ",
          "balanced": "បែងចែកស្មើគ្នាលើ {n} ថ្ងៃធ្វើការ",
          "coverage-sub": "{n} ក្នុងចំណោមហាងដែលបានចាត់តាំង {of}",
          "gaps-some": "ហាងដែលមិនមានក្នុងផែនការនេះ",
          "gaps-none": "ហាងដែលបានចាត់តាំងទាំងអស់មានក្នុងផែនការ",
          "slots": "ក្នុងចំណោមកន្លែងសរុប {n} លើ {days} ថ្ងៃចុះទស្សនកិច្ច",
          "date-overrides": "ការកំណត់តាមកាលបរិច្ឆេទ {n} | ការកំណត់តាមកាលបរិច្ឆេទ {n}",
          "shortfall": "ខ្វះគោលដៅប្រចាំខែ៖ {n} ដង។ | ខ្វះគោលដៅប្រចាំខែ៖ {n} ដង។",
          "sup-explanation": "ការពន្យល់របស់អ្នកគ្រប់គ្រង៖ “{reason}”",
          "no-explanation": "មិនមានការពន្យល់ត្រូវបានកត់ត្រាទេ — សូមបង្វិលផែនការនេះឱ្យកែសម្រួល។",
          "overload": "លើសបន្ទុក៖",
          "overload-rest": "លើសសមត្ថភាពដែលអនុវត្តសម្រាប់កាលបរិច្ឆេទនោះ។",
          "unsched": "មិនអាចកំណត់កាលវិភាគក្នុងសមត្ថភាពបាន ({n})៖",
          "override": "មានការកំណត់សមត្ថភាពលើសដោយអ្នកគ្រប់គ្រងក្នុងកំណត់ត្រា",
          "override-weigh": "សូមពិចារណាចំណុចនេះមុនសម្រេចចិត្ត។",
          "gaps-title": "ចន្លោះខ្វះការគ្របដណ្ដប់៖",
          "views": "ពិនិត្យ PJP ដែលបានដាក់ស្នើ",
          "view": {
            "summary": "សង្ខេប",
            "calendar": "ប្រតិទិន",
            "map": "ផែនទី"
          },
          "readonly": "ការពិនិត្យដោយរូបភាពគឺសម្រាប់អានតែប៉ុណ្ណោះ; ច្បាប់អនុម័តមិនផ្លាស់ប្ដូរទេ។",
          "daily": "បន្ទុកការងារប្រចាំថ្ងៃ — សមត្ថភាពលំនាំដើម",
          "per-day": "ដង/ថ្ងៃ",
          "date-specific": "ការកំណត់តាមកាលបរិច្ឆេទជាក់លាក់ | ការកំណត់តាមកាលបរិច្ឆេទជាក់លាក់",
          "tip": "{n} ក្នុងចំណោម {cap}",
          "tip-override": "ការកំណត់តាមកាលបរិច្ឆេទ",
          "tip-over": "លើសបន្ទុក +{n}",
          "tip-left": "នៅសល់ {n}",
          "daycap": "សមត្ថភាពតាមកាលបរិច្ឆេទជាក់លាក់៖",
          "per-day-n": "{n}/ថ្ងៃ",
          "daycap-star": "(* នៅក្នុងរបារបន្ទុកការងារ)",
          "clustering": "ហាងក្នុងខេត្ត · DT ដូចគ្នាចែករំលែកថ្ងៃដែលសមត្ថភាពអនុញ្ញាត (ដាក់កណ្ដុរលើថ្ងៃដើម្បីមើលសមាសភាព)។",
          "commit": "ការប្ដេជ្ញាវដ្តចុះទស្សនកិច្ច៖",
          "commit-body": "តារាងខាងក្រោមគឺជាសមាជិកភាពវដ្ត និងកាលបរិច្ឆេទដែលបានស្នើយ៉ាងពិតប្រាកដដែលអ្នកគ្រប់គ្រងបានដាក់ស្នើ។ ចំនួនតាមផែនការ/ខែ គណនាពីវដ្តដែលមានហាងនីមួយៗ — វាមិនមែនជាការកំណត់ប្រេកង់ដាច់ដោយឡែកទេ។",
          "col": {
            "outlet": "ហាង",
            "promoter": "អ្នកផ្សព្វផ្សាយ",
            "province": "ខេត្ត",
            "dt": "DT",
            "planned": "តាមផែនការ / ខែ",
            "cycles": "ការចាត់តាំងវដ្តចុះទស្សនកិច្ច",
            "visits": "ការចុះទស្សនកិច្ច"
          }
        },
        "decide": {
          "approve": "អនុម័ត និងបោះពុម្ពផ្សាយ…",
          "return": "បង្វិលឱ្យកែសម្រួល…",
          "approve-label": "បញ្ជាក់ការអនុម័ត",
          "approve-title": "បញ្ជាក់ការអនុម័ត។",
          "approve-body": "ការអនុម័ត និងបោះពុម្ពផ្សាយធ្វើឡើងក្នុងពេលតែមួយ — ផែនការចាប់ផ្ដើមប្រតិបត្តិភ្លាមៗ ហើយកាលវិភាគចុះទស្សនកិច្ចខែនេះត្រូវបានបង្កើតដូចដែលបានពិនិត្យខាងលើ",
          "approve-override": "; សូមកត់សម្គាល់ការកំណត់សមត្ថភាពលើសរបស់អ្នកគ្រប់គ្រងក្នុងកំណត់ត្រា",
          "approve-ph": "កំណត់ចំណាំអនុម័ត (ស្រេចចិត្ត)",
          "confirm-approve": "បញ្ជាក់ — អនុម័ត និងបោះពុម្ពផ្សាយ",
          "cancel": "បោះបង់",
          "return-label": "បង្វិលឱ្យកែសម្រួល",
          "return-title": "បង្វិលផែនការនេះឱ្យកែសម្រួល។",
          "return-body": "ត្រូវការហេតុផល — វានឹងបង្ហាញដល់អ្នកគ្រប់គ្រង ហើយកត់ត្រាក្នុងកំណត់ហេតុសវនកម្មរបស់ផែនការ។",
          "return-ph": "ហេតុផលបង្វិល (ចាំបាច់)",
          "confirm-return": "បញ្ជាក់ — បង្វិលឱ្យកែសម្រួល",
          "err-reason": "ត្រូវការហេតុផលបង្វិល — អ្នកគ្រប់គ្រងត្រូវដឹងថាត្រូវកែសម្រួលអ្វី។",
          "flash-approved": "ផែនការ {id} ត្រូវបានអនុម័ត និងបោះពុម្ពផ្សាយ — វាកំពុងប្រតិបត្តិសម្រាប់ {period}។",
          "flash-returned": "ផែនការ {id} ត្រូវបានបង្វិលឱ្យកែសម្រួល — អ្នកគ្រប់គ្រងនឹងឃើញហេតុផលរបស់អ្នក។",
          "toast-approved": "✓ PJP ត្រូវបានអនុម័ត និងបោះពុម្ពផ្សាយ",
          "toast-returned": "PJP ត្រូវបានបង្វិលឱ្យកែសម្រួល",
          "failed": "មិនអាចរក្សាទុកការសម្រេចបានទេ។"
        },
        "amend": {
          "rev": "កំណែ {from} → {to}",
          "effective": "មានប្រសិទ្ធភាព {date}",
          "requested": "បានស្នើ {at}",
          "reason": "ហេតុផល៖",
          "changes": "ការផ្លាស់ប្ដូរដែលបានស្នើ ({n})៖",
          "add": "បន្ថែមទៅផែនការ",
          "at": "នៅ {freq}",
          "remove": "ដកចេញពីផែនការ",
          "current": "(បច្ចុប្បន្ន {freq})",
          "impact": "ផលប៉ះពាល់លើកាលវិភាគ (ម៉ាស៊ីនបង្កើតបែងចែកស្មើ)៖",
          "before": "មុន",
          "after": "ក្រោយ",
          "visits": "ដង",
          "within": "ក្នុងសមត្ថភាព",
          "capacity": "។",
          "exceeded": "លើសសមត្ថភាពក្រោយការកែប្រែ — {n} ដងមិនអាចដាក់បាន៖",
          "feasible": "អាចអនុវត្តបានក្រោយការកែប្រែ · ថ្ងៃកំពូល {peak} / {cap}។",
          "forward": "ការចុះទស្សនកិច្ចកន្លងមក និងកំពុងដំណើរការមិនត្រូវបានប៉ះពាល់ទេ; មានតែការចុះទស្សនកិច្ចនាពេលខាងមុខប៉ុណ្ណោះដែលត្រូវបង្កើតឡើងវិញ (ទៅមុខតែប៉ុណ្ណោះ)។",
          "approve": "អនុម័តកំណែ",
          "reject": "បដិសេធ",
          "reject-ph": "ហេតុផលបដិសេធ",
          "reject-label": "ហេតុផលបដិសេធសម្រាប់ {id}",
          "toast-approved": "ការកែប្រែត្រូវបានអនុម័ត — ការចុះទស្សនកិច្ចនាពេលខាងមុខត្រូវបានបង្កើតឡើងវិញ"
        },
        "cal": {
          "conflict-title": "ទំនាស់សមត្ថភាព — ផែនការនេះមិនអាចកំណត់កាលវិភាគតាមការកំណត់បច្ចុប្បន្នបានទេ។",
          "required": "ត្រូវការ",
          "vs-available": "ដង ធៀបនឹងកន្លែងទំនេរ",
          "conflict": "កន្លែងសរុបលើ {days} ថ្ងៃចុះទស្សនកិច្ច (លំនាំដើម {cap}/ថ្ងៃ; រួមទាំងការកំណត់តាមកាលបរិច្ឆេទ)។",
          "conflict-unplaced": "{n} ដងមិនអាចដាក់បាន៖ | {n} ដងមិនអាចដាក់បាន៖",
          "conflict-revise": "សូមកែសម្រួលសមាជិកភាពវដ្តចុះទស្សនកិច្ច កាលបរិច្ឆេទដែលបានស្នើ ឬសមត្ថភាព។",
          "feasible": "អាចអនុវត្តបាន៖",
          "feasible-fit": "ដងសមនឹងកន្លែង",
          "feasible-rest": "សរុបលើ {days} ថ្ងៃចុះទស្សនកិច្ច · កំពូល {n} / {cap} នៅ {date} · នៅសល់ {rem}។",
          "override-title": "បានកត់ត្រាការកំណត់សមត្ថភាពលើស",
          "override-rsm": "RSM នឹងឃើញចំណុចនេះមុនការអនុម័ត។",
          "title": "ប្រតិទិនប្រតិបត្តិការ · {period} — លំនាំដើម {cap}/ថ្ងៃ",
          "overrides": "ការកំណត់តាមកាលបរិច្ឆេទជាក់លាក់ {n} | ការកំណត់តាមកាលបរិច្ឆេទជាក់លាក់ {n}",
          "views-label": "ទិដ្ឋភាពកាលវិភាគ",
          "calendar": "ប្រតិទិន",
          "itinerary": "ដំណើរការ · តាមលំដាប់កាលបរិច្ឆេទ",
          "all-cycles": "វដ្តទាំងអស់",
          "cycle-hint": "តម្រងវដ្តបន្លិចកាលបរិច្ឆេទដែលបានបង្កើតរបស់វា ដោយមិនដកបរិបទប្រចាំខែចេញទេ។",
          "dow": {
            "mon": "ច័ន្ទ",
            "tue": "អង្គារ",
            "wed": "ពុធ",
            "thu": "ព្រហ",
            "fri": "សុក្រ",
            "sat": "សៅរ៍",
            "sun": "អាទិត្យ"
          },
          "dow-long": {
            "sun": "ថ្ងៃអាទិត្យ",
            "mon": "ថ្ងៃច័ន្ទ",
            "tue": "ថ្ងៃអង្គារ",
            "wed": "ថ្ងៃពុធ",
            "thu": "ថ្ងៃព្រហស្បតិ៍",
            "fri": "ថ្ងៃសុក្រ",
            "sat": "ថ្ងៃសៅរ៍"
          },
          "company-calendar": "ប្រតិទិនក្រុមហ៊ុន",
          "included-override": "បានបញ្ចូលដោយការកំណត់ដែលមានសវនកម្ម",
          "non-working": "ថ្ងៃមិនធ្វើការ",
          "override": "កំណត់លើស",
          "source-title": "ពីប្រតិទិនបុគ្គលដែលបានបោះពុម្ពផ្សាយ",
          "not-available": "មិនមែនជាថ្ងៃចុះទស្សនកិច្ចទំនេរ",
          "unavailable": "មិនអាចចូលបាន",
          "of-cap": "{n} ក្នុងចំណោម {cap}",
          "override-suffix": " · កំណត់លើស",
          "capacity": "សមត្ថភាព",
          "overloaded": "លើសបន្ទុក",
          "day-full": "ថ្ងៃពេញ",
          "tip": "{n} ក្នុងចំណោមសមត្ថភាព {cap}",
          "tip-over": "លើសបន្ទុក +{n}",
          "tip-free": "ទំនេរ {n}",
          "visits": "{n} ដង | {n} ដង",
          "in-cycle": "{n} ក្នុង C{k}",
          "nonvisit-title": "គ្មានការចុះទស្សនកិច្ច PJP · សកម្មភាពមិនមែនចុះទស្សនកិច្ចតាមផែនការ",
          "legend": {
            "planned": "ការចុះទស្សនកិច្ចតាមផែនការ",
            "nonvisit": "ការងារមិនមែនចុះទស្សនកិច្ចលំនាំដើម",
            "unavailable": "ហាងមិនអាចចូលបាន",
            "holiday": "ថ្ងៃឈប់សម្រាកសាធារណៈ / ថ្ងៃមិនធ្វើការ",
            "sunday": "ថ្ងៃអាទិត្យ",
            "click": "ចុចលើថ្ងៃធ្វើការដើម្បីមើលផ្លូវដែលបានបង្កើត ឬសកម្មភាពមិនមែនចុះទស្សនកិច្ចតាមផែនការ"
          },
          "date-override": "ការកំណត់តាមកាលបរិច្ឆេទ",
          "sunday-nonworking": "ថ្ងៃអាទិត្យ · ថ្ងៃមិនធ្វើការ",
          "outlets-unavailable": "ហាង {n} មិនអាចចូលបាន | ហាង {n} មិនអាចចូលបាន",
          "close-day": "បិទព័ត៌មានលម្អិតប្រចាំថ្ងៃ",
          "sequence": "លំដាប់ដែលបានបង្កើតសម្រាប់កាលបរិច្ឆេទនេះ (លំដាប់ហាងមូលដ្ឋាន)៖",
          "min": "នាទី",
          "window": "ចន្លោះម៉ោង {w}",
          "resolve": "ហាងមិនអាចចូលបាន — ដោះស្រាយមុនការអនុវត្ត",
          "no-located": "គ្មានហាងដែលមានទីតាំងនៅកាលបរិច្ឆេទនេះទេ — លំដាប់ខាងលើគឺជាលំដាប់ចុះទស្សនកិច្ច។",
          "route": "ផ្លូវដែលបានបង្កើត · {date}",
          "route-note": "— សម្រាប់តែកាលបរិច្ឆេទដែលបានជ្រើសរើសនេះ; វដ្តចុះទស្សនកិច្ចក្រោយៗអាចប្រើផ្លូវផ្សេង ដោយសារសមាជិកភាព សមត្ថភាព ថ្ងៃធ្វើការ និងករណីលើកលែងអាចខុសគ្នា។",
          "no-visits": "គ្មានការចុះទស្សនកិច្ច PJP តាមកាលវិភាគទេ។",
          "choose-work": "ជ្រើសរើសសកម្មភាពមិនមែនចុះទស្សនកិច្ចតាមផែនការសម្រាប់កាលបរិច្ឆេទនេះ៖",
          "nonvisit-label": "សកម្មភាពមិនមែនចុះទស្សនកិច្ចតាមផែនការសម្រាប់ {date}",
          "other-ph": "ពិពណ៌នាសកម្មភាពផ្សេងទៀត",
          "step1-default": "ជំហានទី 1 នៅតែជាលំនាំដើម; នេះផ្លាស់ប្ដូរតែ {date} ប៉ុណ្ណោះ។",
          "regen": "នេះគឺជាកាលវិភាគប្រចាំខែតាមកាលបរិច្ឆេទដែលមានសិទ្ធិអំណាច។ វាបង្កើតឡើងវិញពីសមាជិកភាពវដ្តចុះទស្សនកិច្ច លំដាប់វដ្ត កាលបរិច្ឆេទដែលបានស្នើ ការងារហាង សមត្ថភាព និងករណីលើកលែងប្រតិទិនបច្ចុប្បន្ន; ការផ្លាស់ប្ដូរជំហានទី 2 ហូរមកទីនេះដោយផ្ទាល់។",
          "itin-empty": "មិនទាន់មានការចុះទស្សនកិច្ចតាមផែនការនៅឡើយទេ — សូមបន្ថែមហាងជាមុនសិន។",
          "visit-of": "ការចុះទស្សនកិច្ចទី {i} ក្នុងចំណោម {n}",
          "clustering": "ហាងក្នុងខេត្ត · DT ដូចគ្នាចែករំលែកថ្ងៃដែលសមត្ថភាពអនុញ្ញាត (ដាក់កណ្ដុរលើថ្ងៃ)។ ថ្ងៃអាទិត្យ ថ្ងៃឈប់សម្រាកសាធារណៈ និងការបិទដែលបានកត់ត្រា ត្រូវបានដកចេញដោយស្វ័យប្រវត្តិ។",
          "closure": {
            "title": "ផលប៉ះពាល់ប្រតិទិនប្រតិបត្តិការ — រយៈពេលមិនអាចចូលបាន {n}៖ | ផលប៉ះពាល់ប្រតិទិនប្រតិបត្តិការ — រយៈពេលមិនអាចចូលបាន {n}៖",
            "unavailable": "មិនអាចចូលបាន",
            "unscheduled": "មិនអាចកំណត់កាលវិភាគឡើងវិញក្នុងសមត្ថភាពបានទេ (បានរាយខាងលើ)",
            "avoided": "ម៉ាស៊ីនបង្កើតបានជៀសវាងកាលបរិច្ឆេទទាំងនេះ; ការចុះទស្សនកិច្ចស្ថិតនៅថ្ងៃធ្វើការផ្សេងទៀត",
            "review": "ត្រូវការការពិនិត្យ"
          }
        },
        "map": {
          "legacy": "មិនមានផ្លូវវដ្តចុះទស្សនកិច្ចដែលបានដាក់ស្នើសម្រាប់ផែនការចាស់នេះទេ។",
          "by-cycle": "ផ្លូវដែលបានដាក់ស្នើតាមវដ្តចុះទស្សនកិច្ច",
          "cycle-stops": "វដ្ត {k} · {n} ចំណត",
          "readonly": "ការពិនិត្យ LM សម្រាប់អានតែប៉ុណ្ណោះ",
          "no-geo": "មិនមានកូអរដោនេហាងដែលបានចាត់តាំងទេ; សូមប្រើបញ្ជីហាងដែលបានបញ្ចូលខាងក្រោម។",
          "mode-label": "ការបង្ហាញផ្លូវ",
          "map": "ផែនទី",
          "list": "បញ្ជី",
          "title": "វដ្តចុះទស្សនកិច្ច {k} · លំដាប់ពីដំបូងដល់ចុងក្រោយដែលបានស្នើ · បានបញ្ចូល {n} ក្នុងចំណោមដែលបានចាត់តាំង {assigned}",
          "title-note": "— ការពិនិត្យផ្លូវដែលបានដាក់ស្នើសម្រាប់អានតែប៉ុណ្ណោះ · ជំហានទី 3 នៅតែជាប្រតិទិនប្រចាំខែដែលមានសិទ្ធិអំណាច",
          "distance": "ចម្ងាយប៉ាន់ស្មានពីហាងមួយទៅហាងមួយ",
          "navigate": "នាំផ្លូវពីទីតាំងរបស់អ្នក ↗",
          "nav-unavailable": "មិនអាចនាំផ្លូវខាងក្រៅបានទេ — ទិដ្ឋភាពផ្លូវខាងក្នុង និងរបៀបបញ្ជីនៅតែអាចប្រើបានពេញលេញ",
          "nav-notice": "បើក Google Maps។ កូអរដោនេហាងត្រូវបានចែករំលែកសម្រាប់ការនាំផ្លូវ។ Optimal HR មិនប្រមូល ឬរក្សាទុកទីតាំងផ្ទាល់របស់អ្នកសម្រាប់ការមើលផ្លូវជាមុនទេ។",
          "list-mode": "ផែនទីត្រូវបានលាក់។ សូមប្រើបញ្ជីហាងដែលបានបញ្ចូលខាងក្រោមដើម្បីពិនិត្យលំដាប់ ការងារចុះទស្សនកិច្ច និងកាលបរិច្ឆេទដែលបានស្នើ។",
          "legend-on": "● បានបញ្ចូល + មានផ្លូវ",
          "legend-off": "○ បានចាត់តាំង មិនបានបញ្ចូល",
          "legend-google": "Google Maps ផ្ដល់ពេលវេលាបើកបរផ្ទាល់ និងចម្ងាយផ្លូវពីទីតាំងបច្ចុប្បន្នរបស់អ្នក",
          "missing": "ហាង {n} គ្មានកូអរដោនេ ហើយនៅតែមានក្នុងការគ្រប់គ្រងបញ្ជី | ហាង {n} គ្មានកូអរដោនេ ហើយនៅតែមានក្នុងការគ្រប់គ្រងបញ្ជី",
          "svg-label": "ផែនទីផ្លូវវដ្តចុះទស្សនកិច្ច {k}",
          "included": "បានបញ្ចូល",
          "not-included": "មិនបានបញ្ចូល",
          "rank": "លំដាប់ផ្លូវវដ្ត {k}",
          "stops": "{n} ចំណត",
          "range": "ជ្រើសរើសកាលបរិច្ឆេទក្នុងចន្លោះ",
          "dates-pending": "កាលបរិច្ឆេទកំពុងរង់ចាំ",
          "empty-route": "បញ្ចូលហាងពីផែនទីដើម្បីបង្កើតផ្លូវ។",
          "no-date": "គ្មានកាលបរិច្ឆេទ",
          "start": "ចាប់ផ្ដើម"
        }
      },
      "cc": {
        "hero": {
          "title": "អ្វីដែលត្រូវយកចិត្តទុកដាក់ឥឡូវនេះ",
          "continue": "បន្តការចុះពិនិត្យបច្ចុប្បន្ន — {site}",
          "continue-sub": "បានចុះឈ្មោះចូល · បញ្ចប់កិច្ចការ ហើយចុះឈ្មោះចេញ",
          "start": "ចាប់ផ្ដើមផ្លូវថ្ងៃនេះ ({n} ចំណត)",
          "start-sub": "{done} នៃ {total} បានបញ្ចប់ថ្ងៃនេះ",
          "plan": "{action} — {period}",
          "plan-sub": "ថ្ងៃផុតកំណត់រៀបចំផែនការ {date}",
          "review": "ពិនិត្យការអនុវត្តខែនេះ",
          "review-sub": "គ្មានការចុះពិនិត្យណាត្រូវការសកម្មភាពឥឡូវនេះទេ"
        },
        "attn": {
          "missed": "ខកខាន {n} ក្នុងខែនេះ",
          "critical": "ទង់ធ្ងន់ធ្ងរ {n}",
          "overdue": "សកម្មភាពហួសកំណត់ {n}",
          "not-started": "PJP {period} មិនទាន់ចាប់ផ្ដើម · ផុតកំណត់ {date}"
        },
        "action": {
          "create": "បង្កើត PJP",
          "create-next": "បង្កើត PJP បន្ទាប់",
          "continue": "បន្តសេចក្ដីព្រាង",
          "revise": "កែសម្រួល និងដាក់ស្នើឡើងវិញ",
          "view-submitted": "មើលដែលបានដាក់ស្នើ",
          "view-approved": "មើលដែលបានអនុម័ត",
          "view-pjp": "មើល PJP",
          "amend": "ស្នើសុំវិសោធនកម្ម"
        },
        "status": {
          "none": "មិនទាន់មានផែនការសម្រាប់ {period}",
          "draft": "{id} · កំណែ {rev}",
          "returned": "{id} · ត្រូវបានបញ្ជូនត្រឡប់ដោយ RSM",
          "submitted": "{id} · កំពុងរង់ចាំការអនុម័តពី RSM",
          "approved": "{id} · កំពុងដំណើរការ"
        },
        "chip": {
          "none": "មិនទាន់បង្កើត",
          "draft": "សេចក្ដីព្រាង",
          "returned": "បានបញ្ជូនត្រឡប់",
          "submitted": "បានដាក់ស្នើ",
          "approved": "បានអនុម័ត · បានផ្សព្វផ្សាយ"
        },
        "exec": {
          "title": "ការអនុវត្តខែបច្ចុប្បន្ន · {period}",
          "line": "គម្របការចុះ {coverage} ({visited}/{outlets}) · បានបញ្ចប់ {completed} · ខកខាន {missed} · មានទង់ {flagged}",
          "bar": "ការបញ្ចប់ {n}%"
        },
        "plan": {
          "title": "ការរៀបចំផែនការខែបន្ទាប់ · {period}",
          "deadline": "ថ្ងៃផុតកំណត់រៀបចំផែនការ៖ {date}",
          "passed": "ហួសកំណត់",
          "empty": "រៀបចំផ្លូវចុះហាងសម្រាប់ខែបន្ទាប់មុនថ្ងៃផុតកំណត់។"
        },
        "life": {
          "draft": "សេចក្ដីព្រាង",
          "submitted": "បានដាក់ស្នើ",
          "approved": "បានអនុម័ត និងផ្សព្វផ្សាយ",
          "returned": "បានបញ្ជូនត្រឡប់ដើម្បីកែសម្រួល · កំណែ {rev}",
          "cancelled": "បានលុបចោល",
          "amendment": "វិសោធនកម្ម {status} · {id}",
          "stage": "ដំណាក់កាល៖",
          "rev": "កំណែ {rev}",
          "owner": "ម្ចាស់៖",
          "owner-rsm": "RSM · {name}",
          "owner-sup": "អ្នកគ្រប់គ្រង · {name}",
          "next": "សកម្មភាពបន្ទាប់៖",
          "history": "ប្រវត្តិវដ្ដជីវិត និងការកែសម្រួល ({n} ព្រឹត្តិការណ៍)",
          "next-action": {
            "draft": "ដាក់ស្នើទៅ RSM",
            "returned": "កែសម្រួល និងដាក់ស្នើឡើងវិញ (កំណែ {rev})",
            "submitted": "ការសម្រេចរបស់ RSM — អនុម័ត និងផ្សព្វផ្សាយ ឬបញ្ជូនត្រឡប់ដើម្បីកែសម្រួល",
            "approved-published": "បង្កើតសប្ដាហ៍ និងអនុវត្ត · ការផ្លាស់ប្ដូរតាមរយៈសំណើវិសោធនកម្ម",
            "cancelled": "គ្មាន — ផែនការត្រូវបានលុបចោល",
            "archived": "គ្មាន — បានរក្សាទុកក្នុងបណ្ណសារ"
          }
        },
        "kpi": {
          "today": "ផ្លូវថ្ងៃនេះ",
          "today-sub": "បានបញ្ចប់ {done} · កំពុងដំណើរការ {inprogress}",
          "week": "សប្ដាហ៍នេះ (W{n})",
          "week-sub": "បានបញ្ចប់ {n}",
          "coverage": "គម្របហាង",
          "coverage-sub": "{visited} / {outlets} ហាងក្នុងខែនេះ",
          "cmf": "បានបញ្ចប់ · ខកខាន · មានទង់",
          "clean-rate": "អត្រាស្អាត {n}%",
          "followups": "ការតាមដាន",
          "open": "បើក {n}",
          "overdue": "ហួសកំណត់ {n}"
        },
        "route": {
          "title": "ផ្លូវថ្ងៃនេះ · {date}",
          "empty": "គ្មានចំណតថ្ងៃនេះទេ។",
          "open": "បើកការអនុវត្ត · ថ្ងៃនេះ →"
        },
        "upcoming": {
          "title": "ការចុះពិនិត្យខាងមុខ",
          "empty": "គ្មានកាលវិភាគខាងមុខទេ — បង្កើតសប្ដាហ៍បន្ទាប់ពី PJP របស់អ្នក។",
          "open": "បើកការអនុវត្ត · សប្ដាហ៍ →"
        },
        "recent": {
          "title": "សកម្មភាពថ្មីៗ"
        },
        "rsm": {
          "banner": "ការគ្រប់គ្រងខ្សែបន្ទាត់តំបន់ · ការអនុម័ត PJP",
          "pending": "ផែនការ {n} កំពុងរង់ចាំការអនុម័តរបស់អ្នក",
          "amends": "សំណើវិសោធនកម្ម {n}",
          "open-queue": "បើកជួរអនុម័ត →",
          "queue-clear": "ជួរទំនេរ",
          "exec-title": "ការអនុវត្តខែបច្ចុប្បន្ន · {period}",
          "coverage": "គម្របតំបន់",
          "coverage-sub": "{visited} / {outlets} ហាង",
          "completion": "ការបញ្ចប់",
          "completion-sub": "{completed} / {due} ដល់កំណត់",
          "missed": "ខកខាន",
          "missed-sub": "កម្រិតកំណត់ត្រានៅក្នុងករណីលើកលែង",
          "flagged": "មានទង់ (បានបញ្ចប់)",
          "critical-sub": "ធ្ងន់ធ្ងរ {n}",
          "followups": "ការតាមដាន",
          "readiness": "ការត្រៀមខ្លួន PJP ខែបន្ទាប់ · {period}",
          "deadline": "(ផុតកំណត់ {date})",
          "ready": "ផែនការរួចរាល់",
          "ready-sub": "បានអនុម័ត និងផ្សព្វផ្សាយសម្រាប់ {period}",
          "awaiting": "កំពុងរង់ចាំការអនុម័ត",
          "awaiting-sub": "នៅក្នុងជួររបស់អ្នក",
          "not-started": "មិនទាន់ចាប់ផ្ដើម / សេចក្ដីព្រាង",
          "not-started-sub": "ជំរុញមុនថ្ងៃផុតកំណត់",
          "table-title": "ស្ថានភាព PJP តាមអ្នកគ្រប់គ្រង · ទាំងពីរខែ",
          "th-supervisor": "អ្នកគ្រប់គ្រង",
          "th-exec": "{period} (ការអនុវត្ត)",
          "th-coverage": "គម្រប",
          "th-adherence": "ការគោរពតាម",
          "th-plan": "{period} (ការរៀបចំផែនការ)",
          "note": "ការវិភាគជាមួយតម្រង និងការចុះលម្អិតមាននៅក្រោម {coverage}, {exceptions} និង {performance}; ការខកខាន និងទង់កម្រិតកំណត់ត្រានៅក្រោមករណីលើកលែង។",
          "note-coverage": "គម្រប",
          "note-exceptions": "ករណីលើកលែង",
          "note-performance": "សមិទ្ធផល"
        },
        "hrbp": {
          "note-lead": "ស្រទាប់អភិបាលកិច្ចសេវាកម្មខាងក្រៅ។",
          "note": "អ្នកត្រួតពិនិត្យកម្លាំងការងារខាងក្រៅនៅលើគម្រោងនេះ — គម្រប ករណីលើកលែង ហានិភ័យ និងការអនុលោម។ ការអនុម័ត PJP ធម្មតា និងការអនុវត្តការចុះពិនិត្យ នៅតែស្ថិតក្នុងលំហូរការងារអ្នកគ្រប់គ្រង / RSM; កំណត់ត្រាចុះពិនិត្យធម្មតាមិនត្រូវបានរាយនៅទីនេះទេ។ កៅអីអ្នកគ្រប់គ្រងទំនេរត្រូវបានគ្របដណ្ដប់តាមរយៈការត្រួតពិនិត្យការអនុវត្ត (មានសវនកម្ម)។",
          "supervisors": "អ្នកគ្រប់គ្រង",
          "supervisors-sub": "អ្នកផ្សព្វផ្សាយជាមធ្យម {n} / អ្នកគ្រប់គ្រង",
          "coverage": "គម្របគម្រោង · {period}",
          "coverage-sub": "{visited} / {outlets} ហាង (ការអនុវត្ត)",
          "exceptions": "ករណីលើកលែងមិនទាន់ដោះស្រាយ",
          "exceptions-sub": "ហួសកំណត់ {n} — ហានិភ័យត្រូវបង្កើនកម្រិត",
          "missed-rate": "អត្រាខកខាន",
          "missed-rate-sub": "ខកខាន {n} (ចំនួន)",
          "readiness": "ការត្រៀមខ្លួន PJP ខែបន្ទាប់",
          "readiness-sub": "{period} បានអនុម័ត · {n} កំពុងរង់ចាំ RSM",
          "workload-title": "បន្ទុកការងារ និងហានិភ័យរបស់អ្នកគ្រប់គ្រង (សរុប)",
          "th-supervisor": "អ្នកគ្រប់គ្រង",
          "th-region": "តំបន់",
          "th-promoters": "អ្នកផ្សព្វផ្សាយ",
          "th-outlets": "ហាង",
          "th-completion": "ការបញ្ចប់",
          "th-missed": "ខកខាន",
          "th-flag-rate": "អត្រាទង់",
          "th-pjp": "PJP {period}",
          "not-created": "មិនទាន់បង្កើត",
          "exceptions-title": "ករណីលើកលែងប្រតិបត្តិការមិនទាន់ដោះស្រាយ (ការតាមដានបើក)",
          "exception-meta": "· ម្ចាស់ {owner} · ផុតកំណត់ {due}",
          "overdue": "ហួសកំណត់",
          "open": "បើក",
          "no-exceptions": "គ្មានករណីលើកលែងមិនទាន់ដោះស្រាយទេ។"
        },
        "gov": {
          "lead-leader": "ការត្រួតពិនិត្យគម្រោងកម្រិតប្រតិបត្តិ",
          "lead-champion": "ការត្រួតពិនិត្យសមិទ្ធផលគម្រោង",
          "aggregate-only": "— តែទិន្នន័យសរុបប៉ុណ្ណោះ។",
          "note": "ផ្ទៃនេះបង្ហាញចំនួនសរុប អត្រា ពិន្ទុ និន្នាការ និងចំនួនករណីលើកលែងធំៗ។ កំណត់ត្រាចុះពិនិត្យកម្រិតបុគ្គល — គ្រប់ស្ថានភាព រួមទាំងដែលបានបញ្ចប់ — មិនមានសម្រាប់តួនាទីនេះទេ (D2-107 គឺជាពិដានការផ្សព្វផ្សាយ មិនមែនជាសិទ្ធិតួនាទីទេ)។",
          "exec-title": "ការអនុវត្តខែបច្ចុប្បន្ន · {period}",
          "coverage": "គម្រប",
          "coverage-sub": "{visited} / {outlets} ហាង",
          "completion": "ការបញ្ចប់",
          "completion-sub": "បានបញ្ចប់ {completed} / ដល់កំណត់ {due}",
          "clean": "ការបញ្ចប់ស្អាត",
          "clean-sub": "អត្រាទង់ {n}% នៃដែលបានបញ្ចប់",
          "avg-score": "ពិន្ទុមធ្យម",
          "avg-score-sub": "លើការចុះពិនិត្យដែលបានបញ្ចប់",
          "critical": "បញ្ហាធ្ងន់ធ្ងរ",
          "critical-sub": "ករណីលើកលែងធំៗ (ចំនួន)",
          "missed": "ខកខាន",
          "missed-sub": "ចំនួន · ការតាមដានបើក {open} (ហួសកំណត់ {overdue})",
          "readiness": "ការត្រៀមខ្លួនរៀបចំផែនការខែបន្ទាប់ · {period}",
          "aggregate": "(សរុប)",
          "approved": "ផែនការបានអនុម័ត",
          "approved-sub": "នៃអ្នកគ្រប់គ្រង {n} នាក់",
          "awaiting": "កំពុងរង់ចាំការអនុម័ត",
          "awaiting-sub": "ជាមួយ RSM តំបន់",
          "not-started": "មិនទាន់ចាប់ផ្ដើម / សេចក្ដីព្រាង",
          "not-started-sub": "ផុតកំណត់ {date}",
          "by-region": "តាមតំបន់",
          "by-rsm": "តាម RSM",
          "th-region": "តំបន់",
          "th-rsm": "RSM",
          "th-due": "ដល់កំណត់",
          "th-completed": "បានបញ្ចប់",
          "th-completion": "ការបញ្ចប់",
          "th-clean": "ស្អាត",
          "th-flag-rate": "អត្រាទង់",
          "th-critical": "ធ្ងន់ធ្ងរ",
          "th-missed": "ខកខាន",
          "th-avg-score": "ពិន្ទុមធ្យម",
          "majors-title": "ករណីលើកលែងធំៗ (សង្ខេប — គ្មានកំណត់ត្រាកម្រិតអ្នកផ្សព្វផ្សាយ)",
          "major-critical": "បញ្ហាធ្ងន់ធ្ងរ {n} នៅ {region}",
          "major-missed": "ការចុះពិនិត្យខកខាន {n} នៅ {region}",
          "no-majors": "គ្មានករណីលើកលែងធំៗលើសកម្រិតទេ។"
        },
        "state": {
          "loading": "កំពុងផ្ទុកមជ្ឈមណ្ឌលបញ្ជា…",
          "error": "មិនអាចផ្ទុកមជ្ឈមណ្ឌលបញ្ជាបានទេ។",
          "retry": "ព្យាយាមម្ដងទៀត"
        }
      },
      "plans": {
        "per": "{month} {year}",
        "day-short": "{day} {month}",
        "months": {
          "m1": "មករា",
          "m2": "កុម្ភៈ",
          "m3": "មីនា",
          "m4": "មេសា",
          "m5": "ឧសភា",
          "m6": "មិថុនា",
          "m7": "កក្កដា",
          "m8": "សីហា",
          "m9": "កញ្ញា",
          "m10": "តុលា",
          "m11": "វិច្ឆិកា",
          "m12": "ធ្នូ"
        },
        "months-short": {
          "m1": "មករា",
          "m2": "កុម្ភៈ",
          "m3": "មីនា",
          "m4": "មេសា",
          "m5": "ឧសភា",
          "m6": "មិថុនា",
          "m7": "កក្កដា",
          "m8": "សីហា",
          "m9": "កញ្ញា",
          "m10": "តុលា",
          "m11": "វិច្ឆិកា",
          "m12": "ធ្នូ"
        },
        "appr": {
          "draft": "សេចក្តីព្រាង",
          "submitted": "កំពុងរង់ចាំការអនុម័ត",
          "returned": "បានបញ្ជូនត្រឡប់ដើម្បីកែសម្រួល",
          "approved-published": "បានអនុម័ត និងផ្សព្វផ្សាយ",
          "archived": "បានអនុម័ត និងផ្សព្វផ្សាយ",
          "cancelled": "បានលុបចោល"
        },
        "exec": {
          "inprogress": "កំពុងដំណើរការ · {done} / {total}",
          "closed": "បានបិទ · {done} / {total}",
          "upcoming": "នាពេលខាងមុខ",
          "upcoming-n": "នាពេលខាងមុខ · ការចុះជួប {n}"
        },
        "outcome": {
          "open": "បើក",
          "closed": "បានបិទ · {outcome}",
          "met": "សម្រេចតាមផែនការ",
          "partial": "សម្រេចបានមួយផ្នែក",
          "below": "ទាបជាងផែនការ",
          "not-assessed": "មិនបានវាយតម្លៃ",
          "cancelled": "បានលុបចោល"
        },
        "sla": {
          "ok": "តាមកាលកំណត់",
          "reminder": "ជិតដល់កាលកំណត់",
          "urgent": "បន្ទាន់ — ផុតកំណត់ថ្ងៃនេះ",
          "breached": "ហួសកាលកំណត់",
          "escalated": "បានបញ្ជូនបន្ត",
          "met": "បានសម្រេច",
          "met-late": "សម្រេចយឺត",
          "met-offline": "បានសម្រេច · ធ្វើសមកាលកម្មក្រៅបណ្តាញ",
          "wd": "{n} ថ្ងៃធ្វើការ",
          "by": " · ត្រឹម {date}",
          "sync": " · កំពុងរង់ចាំសមកាលកម្ម",
          "paused": " · បានផ្អាក (ច្បាប់ឈប់សម្រាកដែលបានអនុម័ត)",
          "policy": "គោលការណ៍ {ref}",
          "capped": " · គោលដៅត្រូវបានកំណត់ពិដាន",
          "legacy": " · កំណត់ត្រាចាស់"
        },
        "reg": {
          "hrbp-title": "បញ្ជីការអនុលោម និងបន្ទុកការងាររបស់គម្រោង។",
          "hrbp-text": "ការត្រួតពិនិត្យសម្រាប់តែអាន៖ ការអនុម័តនៅជាមួយ RSM តាមតំបន់ ហើយការអនុវត្តការចុះជួបនៅជាមួយអ្នកត្រួតពិនិត្យ។",
          "filter-period": "ត្រងតាមរយៈពេល",
          "filter-status": "ត្រងតាមស្ថានភាពអនុម័ត",
          "filter-sup": "ត្រងតាមអ្នកត្រួតពិនិត្យ",
          "all-periods": "គ្រប់រយៈពេល",
          "all-statuses": "គ្រប់ស្ថានភាពអនុម័ត",
          "all-sups": "អ្នកត្រួតពិនិត្យទាំងអស់",
          "reset": "កំណត់ឡើងវិញ",
          "new": "+ PJP ថ្មី",
          "col": {
            "period": "រយៈពេល",
            "supervisor": "អ្នកត្រួតពិនិត្យ",
            "region": "តំបន់",
            "approval": "ការអនុម័ត",
            "execution": "ការអនុវត្ត",
            "planned": "បានគ្រោង",
            "completion": "ការបញ្ចប់",
            "coverage": "ការគ្របដណ្តប់",
            "capacity": "ការប្រើសមត្ថភាព",
            "outcome": "លទ្ធផល",
            "actions": "សកម្មភាព"
          },
          "id-rev": "{id} · កំណែ {rev}",
          "fix": "កែ",
          "empty": "គ្មានផែនការដែលត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។",
          "footnote": "ការអនុម័ត ការអនុវត្ត និងការបិទ គឺឯករាជ្យពីគ្នា៖ «បានបិទ» មានន័យថារយៈពេលបានកន្លងផុត — ស្លាកលទ្ធផលវាយតម្លៃអ្វីដែលសម្រេចបាន (ឧ. ផែនការដែលកន្លងផុតហើយបញ្ចប់បាន 80% បង្ហាញជា បានបិទ · សម្រេចបានមួយផ្នែក)។",
          "action": {
            "continue": "បន្តសេចក្តីព្រាង",
            "revise": "កែសម្រួល និងដាក់ស្នើម្តងទៀត",
            "view-submission": "មើលការដាក់ស្នើ",
            "results": "មើលលទ្ធផល",
            "open-current": "បើកផែនការបច្ចុប្បន្ន",
            "view": "មើលផែនការ",
            "review": "ពិនិត្យផែនការ"
          },
          "more": "សកម្មភាពបន្ថែម",
          "delete-draft": "លុបសេចក្តីព្រាង",
          "cancel-submission": "បោះបង់ការដាក់ស្នើ",
          "delete-title": "លុបសេចក្តីព្រាងនេះជាអចិន្ត្រៃយ៍?",
          "cancel-title": "បោះបង់ការដាក់ស្នើមុនពេល RSM អនុម័ត?",
          "cancel-text": "ផែនការត្រឡប់ទៅជាសេចក្តីព្រាងវិញ ហើយអាចកែសម្រួល និងដាក់ស្នើម្តងទៀតបាន។",
          "delete-impact": "លុបសេចក្តីព្រាងនេះ ({outlets}) {visits} និង {followups} របស់វា។ ផែនការផ្សេងទៀតក្នុង {period} រក្សាការចុះជួប និងការតាមដានរបស់ខ្លួន។ កំណត់ត្រាការលុបដែលមានសវនកម្មត្រូវបានរក្សាទុក។",
          "n-outlets": "ហាង {n} | ហាង {n}",
          "n-visits": "ការចុះជួបដែលបានគ្រោង {n} | ការចុះជួបដែលបានគ្រោង {n}",
          "n-followups": "ការតាមដានដែលភ្ជាប់ {n} | ការតាមដានដែលភ្ជាប់ {n}",
          "keep": "រក្សាទុក",
          "confirm": "បញ្ជាក់",
          "deleted": "បានលុបសេចក្តីព្រាង {id} · បានដក {visits} និង {followups}។ ផែនការផ្សេងទៀតក្នុង {period} មិនរងផលប៉ះពាល់ទេ។",
          "n-planned-visits": "ការចុះជួបដែលបានគ្រោង {n} | ការចុះជួបដែលបានគ្រោង {n}",
          "n-followups-short": "ការតាមដាន {n} | ការតាមដាន {n}",
          "cancelled": "បានបោះបង់ការដាក់ស្នើ — ផែនការត្រឡប់ទៅជាសេចក្តីព្រាងវិញ។"
        },
        "agg": {
          "title": "ផែនការ PJP — បញ្ជីសរុប (សម្រាប់តែអាន)។",
          "text": "កំណត់ត្រាកម្រិតផែនការ ការអនុម័ត និងការកែប្រែ នៅជាមួយលំហូរការងារប្រតិបត្តិការ។ ទិដ្ឋភាពនេះរាយការណ៍តែចំនួន និងលទ្ធផលប៉ុណ្ណោះ។",
          "kpi": {
            "plans": "ផែនការ (គ្រប់រយៈពេល)",
            "plans-sub": "ទូទាំងគម្រោង",
            "approved": "បានអនុម័ត និងផ្សព្វផ្សាយ",
            "approved-sub": "ផែនការប្រតិបត្តិការ",
            "closed": "រយៈពេលដែលបានបិទ",
            "closed-sub": "សម្រេចតាមផែនការ {met} · សម្រេចបានមួយផ្នែក {partial}",
            "pending": "កំពុងរង់ចាំការអនុម័ត",
            "pending-sub": "ក្នុងជួររង់ចាំរបស់ RSM"
          },
          "col": {
            "region": "តំបន់",
            "plans": "ផែនការ",
            "draft": "សេចក្តីព្រាង",
            "pending": "កំពុងរង់ចាំ",
            "returned": "បានបញ្ជូនត្រឡប់",
            "approved": "បានអនុម័ត",
            "met": "បានបិទ · សម្រេចតាមផែនការ",
            "partial": "បានបិទ · មួយផ្នែក"
          },
          "empty": "មិនទាន់មានផែនការនៅឡើយ — ចំនួននឹងបង្ហាញនៅពេលអ្នកត្រួតពិនិត្យបង្កើត PJP។"
        },
        "ready": {
          "lead": "ការត្រៀមខ្លួនរៀបផែនការសម្រាប់",
          "deadline": "— កាលកំណត់ {date} (ថ្ងៃធ្វើការចុងក្រោយនៃខែអនុវត្ត)។",
          "col": {
            "supervisor": "អ្នកត្រួតពិនិត្យ",
            "region": "តំបន់",
            "next": "ផែនការរយៈពេលបន្ទាប់",
            "approval": "ការអនុម័ត",
            "current": "ផែនការរយៈពេលបច្ចុប្បន្ន"
          },
          "awaiting": "កំពុងរង់ចាំការពិនិត្យរបស់អ្នក",
          "ready": "រួចរាល់",
          "with-sup": "នៅជាមួយអ្នកត្រួតពិនិត្យ",
          "not-started": "មិនទាន់ចាប់ផ្តើម",
          "none": "គ្មាន"
        },
        "pd": {
          "back": "← ត្រឡប់ទៅបញ្ជី PJP",
          "period": "រយៈពេល",
          "new-for": "+ PJP ថ្មីសម្រាប់ {period}",
          "none": "គ្មាន PJP សម្រាប់ {period} ទេ។",
          "none-use": "ប្រើ",
          "new": "+ PJP ថ្មី",
          "none-builder": "— កម្មវិធីបង្កើតដែលមានការណែនាំ (ការរៀបចំ → ហាង និងការងារចុះជួប → មើលកាលវិភាគជាមុន → ពិនិត្យ និងដាក់ស្នើ)។",
          "none-elapsed": "រយៈពេលដែលកន្លងផុតហើយ មិនអាចទទួលផែនការថ្មីបានទេ។",
          "last": "ចុងក្រោយ៖ {event} {ts}",
          "note-ph": "កំណត់សម្គាល់ទៅ RSM របស់អ្នក (ស្រេចចិត្ត)",
          "submit": "ដាក់ស្នើទៅ RSM",
          "continue-amend": "បន្តការកែប្រែ · កំណែ {rev}",
          "request-amend": "ស្នើសុំការកែប្រែ",
          "awaiting": "កំពុងរង់ចាំការសម្រេចរបស់ RSM",
          "sections": "ផ្នែកនៃផែនការ",
          "submitted": "បានដាក់ស្នើ PJP ដើម្បីឱ្យ RSM អនុម័ត",
          "sec": {
            "ov": "ទិដ្ឋភាពទូទៅ",
            "out": "ហាង និងកិច្ចការ",
            "sch": "កាលវិភាគ",
            "hist": "ការអនុម័ត និងប្រវត្តិ",
            "amend": "ការកែប្រែ",
            "amend-n": "ការកែប្រែ ({n})"
          },
          "ov": {
            "outlets": "ហាង",
            "outlets-sub": "{pct}% នៃហាងដែលបានចាត់តាំង",
            "planned": "ការចុះជួបដែលបានគ្រោង",
            "planned-sub": "ពីកាលវិភាគដែលមានតុល្យភាព",
            "available": "សមត្ថភាពដែលមាន",
            "slots": "{n} កន្លែង",
            "available-sub": "{days} ថ្ងៃធ្វើការ × {cap} ការចុះជួប/ថ្ងៃ · បានប្រើ {pct}%",
            "daily": "សមត្ថភាពប្រចាំថ្ងៃ",
            "daily-sub": "ការចុះជួប/ថ្ងៃ (ការកំណត់ផែនការ) — dailyCapacity",
            "execution": "ការអនុវត្ត",
            "period-active": "រយៈពេលកំពុងដំណើរការ",
            "period-upcoming": "រយៈពេលនាពេលខាងមុខ",
            "src": {
              "label": "ប្រភពចាប់ផ្តើម៖",
              "template": {
                "t": "គំរូផ្លូវ៖ បញ្ជីហាងដែលបានចាត់តាំងទាំងមូល",
                "d": "បង្កើតពីបញ្ជីហាងដែលបានចាត់តាំងទាំងមូលរបស់អ្នក ជាមួយតម្លៃលំនាំដើមស្តង់ដារ ហើយកែតម្រូវនៅពេលក្រោយក្នុងផែនការនេះ។"
              },
              "blank": {
                "t": "ចាប់ផ្តើមទទេ",
                "d": "បង្កើតដោយមិនចម្លងផែនការផ្សេង — ហាង និងការកំណត់ផែនការត្រូវបានបន្ថែមដោយដៃ។"
              },
              "copied": {
                "t": "ចម្លងពី {from}",
                "d": "ចាប់ផ្តើមជាច្បាប់ចម្លងនៃផែនការដែលបានអនុម័តនោះ។ ការកែសម្រួលទាំងអស់បន្ទាប់ពីបង្កើត ជាកម្មសិទ្ធិរបស់សេចក្តីព្រាងនេះ។"
              },
              "copy-none": {
                "t": "ចម្លង · គ្មានផែនការដែលបានអនុម័តពីមុន",
                "d": "បានជ្រើសរើសការចម្លងនៅពេលបង្កើត ប៉ុន្តែគ្មានផែនការដែលបានអនុម័តពីមុនទេ — ដូច្នេះបានអនុវត្តតម្លៃលំនាំដើមស្តង់ដារជំនួស។"
              }
            },
            "conflict": "ទំនាស់សមត្ថភាព",
            "conflict-text": "— ត្រូវការ {required} ធៀបនឹងមាន {available}។ បើក",
            "conflict-tail": "ដើម្បីដោះស្រាយ ឬកត់ត្រាការបដិសេធដែលមានសវនកម្ម។",
            "feasible": "អាចធ្វើបាន — ការចុះជួប {required} ក្នុងសមត្ថភាព {available}។",
            "plan-note": "កំណត់សម្គាល់ផែនការ៖ {note}",
            "override": "មានកំណត់ត្រាការបដិសេធសមត្ថភាព — {reason}"
          },
          "hist": {
            "step": {
              "draft": "សេចក្តីព្រាង",
              "submitted": "បានដាក់ស្នើ",
              "approved": "បានអនុម័ត និងផ្សព្វផ្សាយ"
            },
            "owner-rsm": "RSM · {name}",
            "owner-sup": "អ្នកត្រួតពិនិត្យ · {name}",
            "next": {
              "draft": "ដាក់ស្នើទៅ RSM",
              "returned": "កែសម្រួល និងដាក់ស្នើម្តងទៀត (កំណែ {rev})",
              "submitted": "ការសម្រេចរបស់ RSM — អនុម័ត និងផ្សព្វផ្សាយ ឬបញ្ជូនត្រឡប់ដើម្បីកែសម្រួល",
              "approved-published": "បង្កើតសប្តាហ៍ និងអនុវត្ត · ការផ្លាស់ប្តូរតាមរយៈសំណើកែប្រែ",
              "cancelled": "គ្មាន — ផែនការត្រូវបានលុបចោល",
              "archived": "គ្មាន — បានរក្សាទុកក្នុងបណ្ណសារ"
            },
            "returned-chip": "បានបញ្ជូនត្រឡប់ដើម្បីកែសម្រួល · កំណែ {rev}",
            "amend-chip": "ការកែប្រែ {status} · {id}",
            "stage": "ដំណាក់កាល៖",
            "owner": "ម្ចាស់៖",
            "next-label": "សកម្មភាពបន្ទាប់៖",
            "history": "ប្រវត្តិវដ្តជីវិត និងការកែសម្រួល ({n} ព្រឹត្តិការណ៍)",
            "submit-note": "កំណត់សម្គាល់ការដាក់ស្នើ៖ {note}"
          },
          "amend": {
            "working": "ការកែប្រែកំពុងធ្វើ · កំណែ {rev}",
            "working-text": "កំណែ {rev} ដែលបានអនុម័តនៅតែមានសុពលភាព។ បន្តលំហូររៀបផែនការដែលធ្លាប់ស្គាល់ មានតែកំណែដែលអ្នកស្នើប៉ុណ្ណោះនឹងត្រូវផ្ញើទៅ RSM។",
            "continue": "បន្តការកែប្រែ",
            "request": "ស្នើសុំការកែប្រែ",
            "revision": "កំណែ {from} → {to}",
            "effective": "មានប្រសិទ្ធភាព {date}",
            "reason": "មូលហេតុ៖",
            "none": "គ្មានការកែប្រែលើផែនការនេះទេ។",
            "add": "បន្ថែមទៅផែនការ",
            "at": "នៅ {freq}",
            "remove": "ដកចេញពីផែនការ",
            "current": "(បច្ចុប្បន្ន {freq})"
          }
        },
        "out": {
          "title": "ផែនការតាមវដ្តចុះជួប",
          "lead": "វដ្តចុះជួប គឺជាការឆ្លងកាត់ដែលបានគ្រោងទុកមួយដងតាមហាងដែលបានជ្រើសរើស។ វដ្តនីមួយៗអាចមានសមាជិកភាព លំដាប់ និងកាលបរិច្ឆេទស្នើផ្ទាល់ខ្លួន។",
          "count": "{cycles} · ការចុះជួប {visits}",
          "n-cycles": "{n} វដ្ត | {n} វដ្ត",
          "cycles-label": "វដ្តចុះជួប",
          "cycle": "វដ្តចុះជួប {k}",
          "partial": "មួយផ្នែក",
          "dates-pending": "កាលបរិច្ឆេទកំពុងរង់ចាំ",
          "calc": "ការចុះជួប/ខែ ដែលបានគណនា៖",
          "calc-text": "តម្លៃរបស់ហាងមួយ គឺចំនួនវដ្តចុះជួបដែលមានហាងនោះ។ អប្បបរមា {min} ·",
          "below-min": "{n} ទាបជាងអប្បបរមា — នៅតែត្រូវការការព្រមាន/ការពន្យល់",
          "all-meet": "ហាងទាំងអស់បំពេញអប្បបរមា",
          "overlap-block": "កាលបរិច្ឆេទវដ្តចុះជួបត្រួតគ្នាលើសពីថ្ងៃប្រគល់បន្ត — ការដាក់ស្នើត្រូវបានរារាំង។",
          "overlap-block-text": "{b} ចាប់ផ្តើម {start} មុនពេល {a} បញ្ចប់ {finish}។ កែតម្រូវកាលបរិច្ឆេទវដ្ត ដើម្បីឱ្យវដ្តបន្ទាប់ចាប់ផ្តើមនៅពេល ឬក្រោយពេលវដ្តមុនបញ្ចប់។",
          "overlap-warn": "ការប្រគល់វដ្តបន្តក្នុងថ្ងៃតែមួយ។",
          "overlap-warn-text": "{b} ចាប់ផ្តើម {start} នៅពេល {a} បញ្ចប់។ នេះត្រូវបានអនុញ្ញាត នៅពេលការចុះជួបរួមគ្នានៅតែស្ថិតក្នុងសមត្ថភាពនៃថ្ងៃនោះ។",
          "editing": "កំពុងកែសម្រួលវដ្តចុះជួប {k}",
          "editing-text": "ការផ្លាស់ប្តូរផ្លូវ ហាង និងការផ្លាស់ប្តូរជាដុំខាងក្រោមទាំងអស់ អនុវត្តចំពោះវដ្តដែលបានជ្រើសរើសនេះ។",
          "guard": "ការពិនិត្យដែនកំណត់ការរៀបផែនការ។",
          "guard-below": "ហាង {n} ទាបជាងអប្បបរមាដែលបានកំណត់។ | ហាង {n} ទាបជាងអប្បបរមាដែលបានកំណត់។",
          "guard-target": "ការចុះជួបដែលបានគ្រោង {n} ទាបជាងគោលដៅប្រចាំខែ។ | ការចុះជួបដែលបានគ្រោង {n} ទាបជាងគោលដៅប្រចាំខែ។",
          "guard-tail": "ផែនការនៅតែអាចកែសម្រួលបាន ត្រូវការការពន្យល់មុនពេលដាក់ស្នើ។",
          "why-min": "មូលហេតុសម្រាប់ហាងដែលទាបជាងអប្បបរមា",
          "why-target": "មូលហេតុសម្រាប់ការខ្វះគោលដៅប្រចាំខែ",
          "zero": "ហាង {n} ត្រូវបានគ្រោងសម្រាប់ការចុះជួប 0 ក្នុងខែនេះ។ | ហាង {n} ត្រូវបានគ្រោងសម្រាប់ការចុះជួប 0 ក្នុងខែនេះ។",
          "zero-text": "វានៅតែស្ថិតក្នុងផែនការប្រចាំខែ ប៉ុន្តែមិនមែនជាសមាជិកនៃវដ្តចុះជួបណាមួយទេ ដូច្នេះវាទាបជាងអប្បបរមា {min}។ បន្ថែមទៅវដ្តចុះជួប ឬពន្យល់ពីការខ្វះខាតមុនពេលដាក់ស្នើ។ | ពួកវានៅតែស្ថិតក្នុងផែនការប្រចាំខែ ប៉ុន្តែមិនមែនជាសមាជិកនៃវដ្តចុះជួបណាមួយទេ ដូច្នេះពួកវាទាបជាងអប្បបរមា {min}។ បន្ថែមទៅវដ្តចុះជួប ឬពន្យល់ពីការខ្វះខាតមុនពេលដាក់ស្នើ។",
          "per-month": "ការចុះជួប/ខែ",
          "chk-1": "គោលបំណងនៃ",
          "chk-purpose": "ការចុះជួប",
          "chk-2": "ដែលបានជ្រើសរើស អនុវត្តបញ្ជីត្រួតពិនិត្យស្តង់ដាររបស់វាពី",
          "chk-lib": "បណ្ណាល័យកិច្ចការមេនៃការគ្រប់គ្រងការងារ",
          "chk-3": "។ ជំហានទី 3 នៅតែជាប្រតិទិនប្រចាំខែពេញលេញដែលមានសុពលភាព។",
          "no-geo": "កូអរដោនេហាងដែលបានចាត់តាំងមិនមានទេ សូមប្រើបញ្ជីហាងដែលបានរួមបញ្ចូលខាងក្រោម។",
          "route-head": "វដ្តចុះជួប {k} · លំដាប់ស្នើពីដំបូងដល់ចុងក្រោយ · បានរួមបញ្ចូល {included} ក្នុងចំណោម {assigned} ដែលបានចាត់តាំង",
          "route-edit": "— ចុចលើម្ជុលណាមួយដើម្បីរួមបញ្ចូល ឬដកចេញ · ជំហានទី 3 នៅតែជាប្រតិទិនប្រចាំខែតាមកាលបរិច្ឆេទដែលមានសុពលភាព",
          "route-read": "— ការពិនិត្យផ្លូវដែលបានដាក់ស្នើ សម្រាប់តែអាន · ជំហានទី 3 នៅតែជាប្រតិទិនប្រចាំខែតាមកាលបរិច្ឆេទដែលមានសុពលភាព",
          "route-km": "ចម្ងាយប៉ាន់ស្មានពីហាងមួយទៅហាងមួយ",
          "nav": "នាំផ្លូវពីទីតាំងរបស់អ្នក ↗",
          "nav-unavailable": "ការនាំផ្លូវខាងក្រៅមិនអាចប្រើបានទេ — ទិដ្ឋភាពផ្លូវខាងក្នុង និងរបៀបបញ្ជី នៅតែអាចប្រើបានពេញលេញ",
          "nav-notice": "បើក Google Maps។ កូអរដោនេហាងត្រូវបានចែករំលែកសម្រាប់ការនាំផ្លូវ។ Optimal HR មិនប្រមូល ឬរក្សាទុកទីតាំងផ្ទាល់របស់អ្នកសម្រាប់ការមើលផ្លូវជាមុនទេ។",
          "list-mode": "ផែនទីត្រូវបានលាក់។ ប្រើបញ្ជីហាងដែលបានរួមបញ្ចូលខាងក្រោម ដើម្បីពិនិត្យលំដាប់ ការងារចុះជួប និងកាលបរិច្ឆេទស្នើ។",
          "col": {
            "order": "លំដាប់",
            "outlet": "ហាង",
            "promoter": "អ្នកផ្សព្វផ្សាយ",
            "priority": "អាទិភាព",
            "purpose": "គោលបំណងចុះជួប",
            "date-scheduled": "កាលបរិច្ឆេទចុះជួបដែលបានកំណត់",
            "date-proposed": "កាលបរិច្ឆេទចុះជួបដែលបានស្នើ",
            "capacity": "សមត្ថភាព",
            "window": "ចន្លោះពេល",
            "min": "នាទី",
            "planned": "បានគ្រោង / ខែ"
          },
          "start": "ចាប់ផ្តើម",
          "carry": "អាទិភាពយោងបន្ត",
          "not-scheduled": "មិនបានកំណត់កាលវិភាគ",
          "slots-left": "នៅសល់ {n} កន្លែង | នៅសល់ {n} កន្លែង",
          "est": "ប៉ាន់ស្មាន {n} នាទី",
          "suggest": "ស្នើ {n}",
          "unresolved": "កំណែកិច្ចការមិនទាន់ដោះស្រាយ — {text}",
          "legacy": "ចាស់ · {why} — រក្សាទុកតាមការកត់ត្រា",
          "review": "សំណុំកិច្ចការបានផ្លាស់ប្តូរ —",
          "keep": "រក្សា {v}",
          "use": "ប្រើ {v}",
          "use-suggestion": "ប្រើការណែនាំ",
          "below": "ទាបជាងការប៉ាន់ស្មាន {n} នាទី —",
          "below-reason": "មូលហេតុកត់ត្រាដោយ {by} នៅ {at}៖ {reason}",
          "below-required": "ត្រូវការការពន្យល់",
          "below-ph": "ហេតុអ្វីរយៈពេលដែលបានគ្រោងទាបជាងការប៉ាន់ស្មាន?",
          "minimum": "អប្បបរមា {n}",
          "empty": "វដ្តចុះជួបនេះគ្មានហាងទេ។ បន្ថែមមួយខាងក្រោម ឬចម្លងរចនាសម្ព័ន្ធពីវដ្តមុន។",
          "table-label": "ហាងក្នុងវដ្តចុះជួប {k}"
        },
        "sch": {
          "conflict": "ទំនាស់សមត្ថភាព — ផែនការនេះមិនអាចកំណត់កាលវិភាគតាមការកំណត់បច្ចុប្បន្នបានទេ។",
          "conflict-text": "ត្រូវការការចុះជួប {required} ធៀបនឹងកន្លែងសរុបដែលមាន {available} ក្នុង {days} ថ្ងៃចុះជួប (លំនាំដើម {cap}/ថ្ងៃ រួមទាំងការបដិសេធតាមកាលបរិច្ឆេទ)។",
          "unplaced": "ការចុះជួប {n} មិនអាចដាក់បានទេ៖ | ការចុះជួប {n} មិនអាចដាក់បានទេ៖",
          "more": "ទៀត",
          "revise": "កែសម្រួលសមាជិកភាពវដ្តចុះជួប កាលបរិច្ឆេទស្នើ ឬសមត្ថភាព —",
          "or-override": "ឬកត់ត្រាការបដិសេធច្បាស់លាស់៖",
          "override-ph": "មូលហេតុបដិសេធ (តម្រូវ មានសវនកម្ម)",
          "record-override": "កត់ត្រាការបដិសេធ",
          "feasible": "អាចធ្វើបាន៖",
          "fit": "ការចុះជួបសមនឹង",
          "feasible-tail": "កន្លែងសរុបក្នុង {days} ថ្ងៃចុះជួប · ខ្ពស់បំផុត {peak} / {cap} នៅ {date} · នៅសល់ {rem}។",
          "override-recorded": "បានកត់ត្រាការបដិសេធសមត្ថភាព",
          "override-rsm": "RSM មើលឃើញវាមុនពេលអនុម័ត។",
          "op-cal": "ប្រតិទិនប្រតិបត្តិការ · {period} — លំនាំដើម {cap}/ថ្ងៃ",
          "date-overrides": "ការបដិសេធតាមកាលបរិច្ឆេទ {n} | ការបដិសេធតាមកាលបរិច្ឆេទ {n}",
          "views": "ទិដ្ឋភាពកាលវិភាគ",
          "calendar": "ប្រតិទិន",
          "itinerary": "ដំណើរការ · តាមលំដាប់កាលបរិច្ឆេទ",
          "cycle-filter": "តម្រងវដ្ត",
          "all-cycles": "វដ្តទាំងអស់",
          "cycle": "វដ្ត {k}",
          "cycle-hint": "តម្រងវដ្តបន្លិចកាលបរិច្ឆេទដែលបានបង្កើតរបស់វា ដោយមិនដកបរិបទប្រចាំខែចេញ។",
          "wd": {
            "mon": "ច",
            "tue": "អ",
            "wed": "ពុ",
            "thu": "ព្រ",
            "fri": "សុ",
            "sat": "ស",
            "sun": "អា"
          },
          "wdl": {
            "mon": "ថ្ងៃច័ន្ទ",
            "tue": "ថ្ងៃអង្គារ",
            "wed": "ថ្ងៃពុធ",
            "thu": "ថ្ងៃព្រហស្បតិ៍",
            "fri": "ថ្ងៃសុក្រ",
            "sat": "ថ្ងៃសៅរ៍",
            "sun": "ថ្ងៃអាទិត្យ"
          },
          "company-cal": "ប្រតិទិនក្រុមហ៊ុន",
          "included": "បានរួមបញ្ចូលដោយការបដិសេធដែលមានសវនកម្ម",
          "non-working": "មិនមែនថ្ងៃធ្វើការ",
          "override": "បដិសេធ",
          "from-person-cal": "ពីប្រតិទិនបុគ្គលដែលបានផ្សព្វផ្សាយ",
          "not-visit-day": "មិនមែនជាថ្ងៃចុះជួបដែលអាចប្រើបាន",
          "names-unavailable": "{names} មិនអាចប្រើបាន",
          "n-unavailable": "{n} មិនអាចប្រើបាន",
          "of-cap": "{n} នៃសមត្ថភាព {cap}",
          "overload": "លើសបន្ទុក +{n}",
          "free": "ទំនេរ {n}",
          "n-of": "{n} នៃ {cap}",
          "capacity": "សមត្ថភាព",
          "overloaded": "លើសបន្ទុក",
          "full": "ពេញថ្ងៃ",
          "n-visits": "ការចុះជួប {n} | ការចុះជួប {n}",
          "in-cycle": "{n} ក្នុង C{k}",
          "nonvisit-tip": "គ្មានការចុះជួប PJP ដែលបានកំណត់ · សកម្មភាពមិនមែនចុះជួបដែលបានគ្រោង",
          "lg": {
            "planned": "ការចុះជួបដែលបានគ្រោង",
            "nonvisit": "ការងារមិនមែនចុះជួបលំនាំដើម",
            "unavailable": "ហាងមិនអាចប្រើបាន",
            "holiday": "ថ្ងៃឈប់សម្រាកសាធារណៈ / មិនមែនថ្ងៃធ្វើការ",
            "sunday": "ថ្ងៃអាទិត្យ",
            "click": "ចុចលើថ្ងៃធ្វើការ ដើម្បីមើលផ្លូវដែលបានបង្កើត ឬសកម្មភាពមិនមែនចុះជួបដែលបានគ្រោង"
          },
          "date-override": "ការបដិសេធកាលបរិច្ឆេទ",
          "sunday-nw": "ថ្ងៃអាទិត្យ · មិនមែនថ្ងៃធ្វើការ",
          "outlets-unavailable": "ហាង {n} មិនអាចប្រើបាន | ហាង {n} មិនអាចប្រើបាន",
          "close-day": "បិទព័ត៌មានលម្អិតថ្ងៃ",
          "sequence": "លំដាប់ដែលបានបង្កើតសម្រាប់កាលបរិច្ឆេទនេះ (លំដាប់ហាងមូលដ្ឋាន)៖",
          "window": "ចន្លោះពេល {w}",
          "resolve": "ហាងមិនអាចប្រើបាន — ដោះស្រាយមុនពេលអនុវត្ត",
          "no-visits": "គ្មានការចុះជួប PJP ដែលបានកំណត់ទេ។",
          "choose-activity": "ជ្រើសរើសសកម្មភាពមិនមែនចុះជួបដែលបានគ្រោងសម្រាប់កាលបរិច្ឆេទនេះ៖",
          "activity": "សកម្មភាពមិនមែនចុះជួបដែលបានគ្រោង",
          "other-ph": "ពិពណ៌នាសកម្មភាពផ្សេងទៀត",
          "step1-default": "ជំហានទី 1 នៅតែជាលំនាំដើម នេះផ្លាស់ប្តូរតែ {date} ប៉ុណ្ណោះ។",
          "regen": "នេះគឺជាកាលវិភាគប្រចាំខែតាមកាលបរិច្ឆេទដែលមានសុពលភាព។ វាបង្កើតឡើងវិញពីសមាជិកភាពវដ្តចុះជួប លំដាប់វដ្ត កាលបរិច្ឆេទស្នើ ការងារហាង សមត្ថភាព និងករណីលើកលែងប្រតិទិនបច្ចុប្បន្ន ហើយការផ្លាស់ប្តូរនៅជំហានទី 2 ហូរមកទីនេះដោយផ្ទាល់។",
          "no-planned": "មិនទាន់មានការចុះជួបដែលបានគ្រោងទេ — សូមបន្ថែមហាងជាមុនសិន។",
          "visit-of": "ការចុះជួប {n} នៃ {total}",
          "weekly": "បន្ទុកការងារប្រចាំសប្តាហ៍៖",
          "cluster": "ការដាក់ជាក្រុមតាមភូមិសាស្ត្រ៖",
          "cluster-text": "ហាងក្នុងខេត្ត · DT ដូចគ្នាចែករំលែកថ្ងៃ នៅពេលសមត្ថភាពអនុញ្ញាត (ដាក់ទស្សន៍ទ្រនិចលើថ្ងៃ)។ ថ្ងៃអាទិត្យ ថ្ងៃឈប់សម្រាកសាធារណៈ និងការបិទដែលបានកត់ត្រា ត្រូវបានដកចេញដោយស្វ័យប្រវត្តិ។",
          "closures": "ផលប៉ះពាល់ប្រតិទិនប្រតិបត្តិការ — រយៈពេលមិនអាចប្រើបាន {n}៖ | ផលប៉ះពាល់ប្រតិទិនប្រតិបត្តិការ — រយៈពេលមិនអាចប្រើបាន {n}៖",
          "closure": "{name} មិនអាចប្រើបាន {range} ({type}) — {outcome}",
          "closure-unscheduled": "មិនអាចកំណត់កាលវិភាគឡើងវិញក្នុងសមត្ថភាពបានទេ (បានរាយខាងលើ)",
          "closure-avoided": "កម្មវិធីបង្កើតបានជៀសវាងកាលបរិច្ឆេទទាំងនេះ ការចុះជួបស្ថិតនៅលើថ្ងៃធ្វើការផ្សេងទៀត",
          "closure-review": "ត្រូវការការពិនិត្យ",
          "drag-hint": "អូសហាងមួយទៅថ្ងៃធ្វើការផ្សេងទៀត ដើម្បីផ្លាស់ទីការចុះទស្សនកិច្ចនោះ — សម្រាប់សេចក្តីព្រាងប៉ុណ្ណោះ; ផែនការដែលបានអនុម័ត និងផ្សព្វផ្សាយ ត្រូវកែប្រែតាមរយៈ {amend}។",
          "drag-amend": "ស្នើសុំវិសោធនកម្ម",
          "drag-tip": "អូសទៅថ្ងៃធ្វើការផ្សេងទៀត",
          "moved": "បានផ្លាស់ទីការចុះទស្សនកិច្ចទៅ {date} — ការកែតម្រូវសេចក្តីព្រាង បានកត់ត្រាសវនកម្ម; បានពិនិត្យសមត្ថភាព និងភាពមិនអាចចូលបានឡើងវិញ",
          "move-picked": "បានលើក {name} ({date}) — ទៅកាន់ថ្ងៃធ្វើការ ហើយចុច Enter ដើម្បីដាក់ ឬ Escape ដើម្បីបោះបង់។",
          "move-cancel": "បានបោះបង់ការផ្លាស់ទី។",
          "move-label": "{name} នៅថ្ងៃ {date} — ចុច Enter ដើម្បីលើក និងផ្លាស់ទីការចុះទស្សនកិច្ចនេះ",
          "route": "ផ្លូវដែលបានបង្កើត · {date}",
          "route-note": "— សម្រាប់តែកាលបរិច្ឆេទដែលបានជ្រើសនេះ; វដ្តទស្សនកិច្ចបន្ទាប់អាចប្រើផ្លូវផ្សេង ព្រោះសមាជិកភាព សមត្ថភាព ថ្ងៃធ្វើការ និងករណីលើកលែងអាចខុសគ្នា។",
          "route-none": "មិនមានហាងដែលមានទីតាំងនៅថ្ងៃនេះទេ — លំដាប់ដែលបានបង្កើតខាងលើ គឺជាលំដាប់ចុះទស្សនកិច្ច។"
        }
      },
      "wizard": {
        "title-new": "+ PJP ថ្មី · {period}",
        "title-amend": "កែប្រែ PJP · {period} · កំណែ {rev}",
        "sub-new": "{name} · ផែនការណែនាំប្រចាំខែ",
        "sub-amend": "{name} · កំណែនៃផែនការដែលបានអនុម័ត",
        "status-ready": "រួចរាល់",
        "status-updating": "កំពុងធ្វើបច្ចុប្បន្នភាព…",
        "close": "បិទ",
        "stepper-label": "ជំហានបង្កើតផែនការ",
        "steps": {
          "1": "ការរៀបចំផែនការ",
          "2": "ហាង និងការងារចុះជួប",
          "3": "មើលកាលវិភាគជាមុន",
          "4": "ពិនិត្យ និងដាក់ស្នើ"
        },
        "amend-banner-title": "វិសោធនកម្មកំពុងធ្វើ · កំណែ {rev}",
        "amend-banner": " — កំណែដែលបានអនុម័ត {base} នៅតែចាក់សោ និងដំណើរការ រហូតដល់ RSM អនុម័តកំណែដែលបានស្នើនេះ។",
        "open-existing": "បើកផែនការដែលមានស្រាប់",
        "month": {
          "10": "តុលា",
          "11": "វិច្ឆិកា",
          "12": "ធ្នូ",
          "01": "មករា",
          "02": "កុម្ភៈ",
          "03": "មីនា",
          "04": "មេសា",
          "05": "ឧសភា",
          "06": "មិថុនា",
          "07": "កក្កដា",
          "08": "សីហា",
          "09": "កញ្ញា"
        },
        "month-short": {
          "10": "តុលា",
          "11": "វិច្ឆិកា",
          "12": "ធ្នូ",
          "01": "មករា",
          "02": "កុម្ភៈ",
          "03": "មីនា",
          "04": "មេសា",
          "05": "ឧសភា",
          "06": "មិថុនា",
          "07": "កក្កដា",
          "08": "សីហា",
          "09": "កញ្ញា"
        },
        "foot": {
          "cancel": "បោះបង់",
          "back": "‹ ថយក្រោយ",
          "save": "រក្សាទុកសេចក្ដីព្រាង",
          "save-amend": "រក្សាទុកសេចក្ដីព្រាងវិសោធនកម្ម",
          "create": "បង្កើតសេចក្ដីព្រាង និងបន្ត ›",
          "continue": "បន្ត ›",
          "submit": "ដាក់ស្នើទៅ RSM",
          "submit-amend": "ដាក់ស្នើវិសោធនកម្ម",
          "confirm": "បោះបង់ការរៀបចំផែនការដែលមិនទាន់រក្សាទុកនេះ?",
          "keep": "បន្តកែសម្រួល",
          "discard": "បោះបង់",
          "missing": "នៅត្រូវការកាលបរិច្ឆេទចុះជួប {n} ក្នុងវដ្តចុះជួបទាំងអស់។ | នៅត្រូវការកាលបរិច្ឆេទចុះជួប {n} ក្នុងវដ្តចុះជួបទាំងអស់។"
        },
        "err": {
          "min-reason": "សូមពន្យល់ពីមូលហេតុដែលចំនួនអប្បបរមាទាបជាងការណែនាំរបស់គម្រោង មុននឹងបន្ត។",
          "alt-work": "សូមជ្រើសរើសប្រភេទការងារលំនាំដើម សម្រាប់ថ្ងៃធ្វើការដែលគ្មានការចុះជួប PJP។ «ផ្សេងៗ» ត្រូវការការពិពណ៌នា។",
          "source": "សូមជ្រើសរើសប្រភពចាប់ផ្ដើម៖ បន្តពី PJP ដែលបានអនុម័តមុន ឬគំរូផ្លូវ។ «ចាប់ផ្ដើមទទេ» លែងមានសម្រាប់ផែនការថ្មីហើយ។",
          "dup": "PJP សម្រាប់ {period} មានរួចហើយ — ផែនការមួយក្នុងមួយអ្នកគ្រប់គ្រង × រយៈពេល។ សូមបើកវាពីបញ្ជីវិញ។",
          "period": "សូមជ្រើសរើសរយៈពេលផែនការ។",
          "future": "PJP ថ្មីសម្រាប់តែរយៈពេលអនាគតប៉ុណ្ណោះ — ខែបច្ចុប្បន្ន និងរយៈពេលកន្លងផុត មិនអាចទទួលផែនការថ្មីបានទេ។",
          "amend-reason": "សូមពន្យល់ពីមូលហេតុដែលផែនការដែលបានអនុម័តត្រូវផ្លាស់ប្ដូរ មុននឹងបន្ត។",
          "amend-reason-submit": "សូមពន្យល់ពីមូលហេតុដែលផែនការដែលបានអនុម័តនេះត្រូវផ្លាស់ប្ដូរ មុននឹងដាក់ស្នើ។",
          "amend-effective": "សូមជ្រើសរើសកាលបរិច្ឆេទចូលជាធរមានដែលត្រឹមត្រូវ ពីប្រតិទិនការងារដែលបានអនុម័ត។ កាលបរិច្ឆេទកន្លងផុតមិនដែលមានទេ។",
          "missing-dates": "សូមជ្រើសរើសកាលបរិច្ឆេទចុះជួបសម្រាប់ហាងនីមួយៗ មុនមើលកាលវិភាគជាមុន។ នៅត្រូវការកាលបរិច្ឆេទ {n}។ | សូមជ្រើសរើសកាលបរិច្ឆេទចុះជួបសម្រាប់ហាងនីមួយៗ មុនមើលកាលវិភាគជាមុន។ នៅត្រូវការកាលបរិច្ឆេទ {n}។",
          "day-work": "សូមពិពណ៌នាសកម្មភាពមិនចុះជួប «ផ្សេងៗ» សម្រាប់ {date} មុននឹងបន្ត។",
          "month-draft-only": "មានតែផែនការសេចក្ដីព្រាង (ឬដែលបានបង្វិលត្រឡប់) ទេ ដែលអាចប្ដូរខែផែនការបាន។",
          "only-sup": "មានតែអ្នកគ្រប់គ្រងប៉ុណ្ណោះ ដែលបង្កើត PJP របស់ខ្លួន។"
        },
        "flash": {
          "draft-saved": "បានរក្សាទុកសេចក្ដីព្រាង — អ្វីៗដែលអ្នកបានបញ្ចូលត្រូវបានរក្សាទុក។ បន្តបានគ្រប់ពេលពីបញ្ជី។",
          "draft-kept": "សេចក្ដីព្រាងត្រូវបានរក្សាទុក — បន្តបានគ្រប់ពេលពីបញ្ជី។",
          "amend-saved": "បានរក្សាទុកវិសោធនកម្មកំណែ {rev} — ផែនការដែលបានអនុម័តនៅតែដំណើរការ។",
          "submitted": "បានដាក់ស្នើផែនការ {id} — កំពុងរង់ចាំការអនុម័តពី RSM របស់អ្នក។",
          "amend-submitted": "បានដាក់ស្នើវិសោធនកម្ម {id} — កំណែ {rev} កំពុងរង់ចាំការអនុម័តពី RSM; កំណែ {base} នៅតែដំណើរការ។"
        },
        "toast": {
          "created": "បានបង្កើតសេចក្ដីព្រាង {id}"
        },
        "impact": {
          "applied": "✓ បានអនុវត្ត៖ {list}{outlets}។ ការប៉ាន់ស្មាន/ខែ ការចុះជួបតាមផែនការ បន្ទុកការងារ និងសមត្ថភាព ត្រូវបានគណនាឡើងវិញ; កាលវិភាគជាមុនបង្កើតឡើងវិញពីផែនការដែលបានធ្វើបច្ចុប្បន្នភាព។ គ្មានអ្វីផ្សេងទៀតនៅក្នុងសេចក្ដីព្រាងរបស់អ្នកត្រូវបានផ្លាស់ប្ដូរទេ។",
          "outlets": "ហាង {updated} ត្រូវបានធ្វើបច្ចុប្បន្នភាព, ហាង {preserved} ដែលបានកែតម្រូវផ្ទាល់ខ្លួនរក្សាការកំណត់របស់វា, {kept} មិនប៉ះពាល់",
          "title": "អនុវត្តតម្លៃលំនាំដើមនៃការធ្វើផែនការដែលបានធ្វើបច្ចុប្បន្នភាព?",
          "changed": "{label} បានប្តូរពី {from} ទៅ {to}។",
          "k": {
            "period": "ខែធ្វើផែនការ",
            "capacity": "សមត្ថភាពប្រចាំថ្ងៃ",
            "purpose": "គោលបំណងចុះទស្សនកិច្ចលំនាំដើម",
            "minfreq": "ចំនួនចុះទស្សនកិច្ចអប្បបរមា / ហាង",
            "target": "ចំនួនចុះទស្សនកិច្ចគោលដៅ",
            "altwork": "ការងារលំនាំដើមក្រៅពីការចុះទស្សនកិច្ច",
            "dur": "រយៈពេលចុះទស្សនកិច្ចលំនាំដើម"
          },
          "v": {
            "capacity": "{n} ដង/ថ្ងៃ",
            "minfreq": "{n}/ខែ",
            "dur": "{n} នាទី",
            "not-set": "មិនទាន់កំណត់"
          },
          "count": "មានហាង {n} រួចហើយនៅក្នុងសេចក្តីព្រាងនេះ | មានហាង {n} រួចហើយនៅក្នុងសេចក្តីព្រាងនេះ",
          "count-adj": " រួមទាំងហាង {n} ដែលបានកែតម្រូវដោយឡែក | រួមទាំងហាង {n} ដែលបានកែតម្រូវដោយឡែក",
          "count-tail": "។ ការមើលកាលវិភាគជាមុនបង្កើតឡើងវិញ បន្ទាប់ពីការផ្លាស់ប្តូរណាមួយត្រូវបានអនុវត្ត។",
          "prev": "ធ្វើបច្ចុប្បន្នភាពហាងដែលនៅប្រើតម្លៃលំនាំដើមចាស់",
          "prev-hint": "— ណែនាំ · ហាងដែលបានកែតម្រូវដោយឡែក រក្សាការកំណត់របស់ខ្លួន",
          "all": "ធ្វើបច្ចុប្បន្នភាពហាងទាំងអស់ដែលមានស្រាប់",
          "all-hint": "— ការកែតម្រូវដោយឡែកនឹងត្រូវសរសេរជាន់ពីលើ",
          "later": "រក្សាការកំណត់ហាងដែលមានស្រាប់",
          "later-hint": "— អនុវត្តតម្លៃលំនាំដើមថ្មីចំពោះតែហាងដែលបន្ថែមពេលក្រោយ",
          "apply": "អនុវត្តការកំណត់ផែនការដែលបានធ្វើបច្ចុប្បន្នភាព",
          "apply-hint": "— រក្សាការកំណត់ហាង; កាលវិភាគ បន្ទុកការងារ និងលទ្ធភាពត្រូវគណនាឡើងវិញ",
          "cancel": "បោះបង់ ហើយត្រឡប់ទៅការរៀបចំផែនការ"
        },
        "sec": {
          "amend-request": "សំណើវិសោធនកម្ម",
          "amend-request-hint": "ត្រូវការមុនពេលកែសម្រួលផែនការដែលបានអនុម័ត",
          "identity": "អត្តសញ្ញាណផែនការ",
          "identity-hint": "អ្នកគ្រប់គ្រងមួយ × ខែ · សម្រាប់តែរយៈពេលអនាគត",
          "baseline": "មូលដ្ឋានកំណែ",
          "baseline-hint": "ផែនការដែលបានអនុម័តត្រូវបានចម្លងចូលកំណែការងារនេះ",
          "source": "ប្រភពចាប់ផ្ដើម",
          "source-hint": "ជ្រើសរើសរបៀបចាប់ផ្ដើមផែនការប្រចាំខែថ្មីនេះ",
          "defaults": "លំនាំដើមផែនការ",
          "defaults-hint": "សមត្ថភាព និងគោលដៅបង្កើតការណែនាំ · ជំហានទី 2 កំណត់វដ្តពិតប្រាកដ",
          "calendar": "ថ្ងៃចុះជួប និងសមត្ថភាព",
          "note": "កំណត់ចំណាំផែនការ",
          "note-hint": "(ស្រេចចិត្ត)"
        },
        "setup": {
          "intro-new-b": "+ PJP ថ្មី",
          "intro-new": "ផែនការប្រចាំខែមួយ ក្នុងមួយអ្នកគ្រប់គ្រង × ខែផែនការ (សម្រាប់តែខែអនាគត; ផែនការដែលបានអនុម័តកំពុងដំណើរការរបស់អ្នកមិនដែលត្រូវបានកែប្រែទេ)។",
          "intro-amend-b": "កែប្រែ PJP ដែលបានអនុម័ត",
          "intro-amend": "កែសម្រួលផែនការដែលបានចាក់សោ តាមរយៈដំណើរការរៀបចំផែនការណែនាំដដែល; កំណែដែលបានអនុម័តមិនដែលត្រូវបានកែសម្រួលដោយផ្ទាល់ទេ។",
          "pending": "ការផ្លាស់ប្ដូរការរៀបចំផែនការ {n} កំពុងរង់ចាំ — ចុច {continue} ដើម្បីពិនិត្យផលប៉ះពាល់លើ {outlets} របស់អ្នក មុនពេលអនុវត្តអ្វីមួយ។ | ការផ្លាស់ប្ដូរការរៀបចំផែនការ {n} កំពុងរង់ចាំ — ចុច {continue} ដើម្បីពិនិត្យផលប៉ះពាល់លើ {outlets} របស់អ្នក មុនពេលអនុវត្តអ្វីមួយ។",
          "pending-continue": "បន្ត",
          "pending-outlets": "ហាងដែលមានស្រាប់ {n} | ហាងដែលមានស្រាប់ {n}",
          "amend-reason": "មូលហេតុនៃវិសោធនកម្ម",
          "amend-reason-ph": "ពន្យល់ពីអ្វីដែលបានផ្លាស់ប្ដូរ និងមូលហេតុដែលផែនការដែលបានអនុម័តត្រូវកែសម្រួល",
          "amend-effective": "កាលបរិច្ឆេទចូលជាធរមាន",
          "choose-date": "ជ្រើសរើសកាលបរិច្ឆេទ…",
          "today-sameday": "ថ្ងៃនេះ (ថ្ងៃដដែល)",
          "amend-effective-hint": "តែថ្ងៃចុះជួបដែលអាចប្រើបានប៉ុណ្ណោះ; កាលបរិច្ឆេទកន្លងផុតមិនដែលផ្ដល់ជូនទេ ហើយការងារដែលបានបញ្ចប់ ឬកន្លងផុតនៅតែចាក់សោ។",
          "sameday-notice": "វិសោធនកម្មថ្ងៃដដែល — ការអនុម័តត្រូវតែបញ្ចប់ មុនពេលការអនុវត្តនៅទីវាលណាមួយចាប់ផ្ដើម។",
          "month": "ខែផែនការ",
          "month-hint": "សម្រាប់តែខែអនាគត",
          "owner": "ម្ចាស់ផែនការ",
          "route": "ផ្លូវអនុម័ត",
          "target": "គោលដៅអនុម័ត",
          "target-hint": "គោលការណ៍រៀបចំផែនការគម្រោង · ថ្ងៃធ្វើការចុងក្រោយមុនខែផែនការ",
          "workcal": "ប្រតិទិនការងារ",
          "workcal-value": "ប្រតិទិនបុគ្គល · កាលវិភាគ",
          "workcal-hint": "កាលវិភាគវេនដែលបានផ្សព្វផ្សាយ ច្បាប់ឈប់សម្រាកដែលបានអនុម័ត និងថ្ងៃឈប់សម្រាករបស់គម្រោង",
          "baseline-b": "កំណែដែលបានអនុម័ត {rev}",
          "baseline": "គឺជាមូលដ្ឋានប្រតិបត្តិការដែលបានចាក់សោ។",
          "baseline-copy": "ហាង វដ្តចុះជួប លំដាប់ផ្លូវ កាលបរិច្ឆេទដែលបានស្នើ ប្រតិទិនការងារ និងការងារចុះជួបរបស់វា ត្រូវបានចម្លងចូល {rev}។ កែសម្រួលតែអ្វីដែលត្រូវផ្លាស់ប្ដូរ; ផែនការដែលបានអនុម័តនៅតែដំណើរការរហូតដល់ RSM អនុម័ត។",
          "baseline-working": "កំណែការងារ {rev}",
          "src-copy": "បន្តពី PJP ដែលបានអនុម័តមុន",
          "recommended": "បានណែនាំ",
          "src-copy-d": "ចម្លងការកំណត់ហាងដែលបានអនុម័ត ហើយផ្ដល់អាទិភាពដល់ហាងដែលមិនទាន់គ្របដណ្ដប់គ្រប់គ្រាន់មុន។",
          "src-template": "ចាប់ផ្ដើមពីគំរូផ្លូវ",
          "src-template-d": "ប្រើហាងដែលបានចាត់តាំងទាំង {n} ជាមួយលំនាំដើមបច្ចុប្បន្នរបស់គម្រោង។",
          "capacity": "សមត្ថភាពចុះជួបប្រចាំថ្ងៃ",
          "capacity-hint": "ចំនួនចុះជួបអតិបរមាក្នុងមួយថ្ងៃចុះជួប; មិនមែនជាកូតាប្រចាំថ្ងៃទេ",
          "target-visits": "គោលដៅចុះជួបតាមផែនការ",
          "target-visits-hint": "គោលដៅប្រចាំខែ; ប្រព័ន្ធណែនាំវដ្តពេញ + វដ្តមួយផ្នែក",
          "purpose": "គោលបំណងចុះជួបលំនាំដើម",
          "purpose-title": "គោលបំណងអាជីវកម្មដែលបំពេញជាមុនសម្រាប់ហាងនីមួយៗដែលបានបន្ថែមនៅជំហានទី 2 — អាចកែសម្រួលតាមហាង ខណៈផែនការជាសេចក្ដីព្រាង/បានបង្វិលត្រឡប់; បញ្ជីត្រួតពិនិត្យដែលបានអនុម័តកំណត់ដោយស្វ័យប្រវត្តិពីគោលបំណង",
          "purpose-hint": "បំពេញជាមុនសម្រាប់ហាងនីមួយៗ · បញ្ជីត្រួតពិនិត្យតាមគោលបំណង",
          "min": "ការចុះជួបអប្បបរមា / ហាង",
          "min-hint": "ការណែនាំរបស់គម្រោង៖ {n}/ខែ · លើសត្រូវបានអនុញ្ញាត; ទាបជាងត្រូវការមូលហេតុ",
          "min-why": "មូលហេតុដែលទាបជាងការណែនាំរបស់គម្រោង",
          "dur": "រយៈពេលចុះជួបលំនាំដើម",
          "dur-title": "បំពេញជាមុននូវរយៈពេលប៉ាន់ស្មាន (នាទី) សម្រាប់ហាងនីមួយៗដែលបានបន្ថែមនៅជំហានទី 2 — អាចកែតម្រូវតាមហាង",
          "minutes": "{n} នាទី",
          "alt": "ការងារលំនាំដើម នៅពេលគ្មានការចុះជួប PJP ត្រូវបានកំណត់",
          "choose-activity": "ជ្រើសរើសសកម្មភាព…",
          "alt-other": "បញ្ជាក់ការងារផ្សេងៗ",
          "alt-hint": "ធ្វើឱ្យថ្ងៃធ្វើការដែលមិនចុះជួបអាចមើលឃើញដោយអ្នកគ្រប់គ្រងផ្ទាល់; កាលបរិច្ឆេទជាក់លាក់អាចកំណត់ខុសពីនេះបាន។",
          "note-ph": "បរិបទ ឧបសគ្គ ឬការណែនាំសម្រាប់ RSM របស់អ្នក"
        },
        "src": {
          "template": "គំរូផ្លូវ៖ បញ្ជីហាងដែលបានចាត់តាំងទាំងអស់",
          "blank": "ចាប់ផ្ដើមទទេ",
          "blank-d": "បានបង្កើតដោយមិនចម្លងផែនការផ្សេង — ហាង និងការកំណត់ផែនការត្រូវបានបន្ថែមដោយដៃ។",
          "legacy": "បានកត់ត្រានៅពេលបង្កើត ហើយរក្សាទុកដដែល; ប្រភពចាប់ផ្ដើមនេះលែងផ្ដល់ជូនសម្រាប់ផែនការថ្មីហើយ។",
          "copied": "បានចម្លងពី {from}",
          "copied-none": "បានចម្លង · គ្មានផែនការដែលបានអនុម័តមុន"
        },
        "ins": {
          "config": "ប្រភពការកំណត់",
          "config-v": "PJP ដែលបានអនុម័ត {period}",
          "config-none": "គ្មានផែនការដែលបានអនុម័តមុន — ប្រើលំនាំដើម",
          "latest": "ព័ត៌មានអនុវត្តចុងក្រោយ",
          "latest-v": "{period} · គិតត្រឹម {date}",
          "latest-none": "មិនទាន់មានទិន្នន័យអនុវត្តនៅឡើយ",
          "signal": "សញ្ញាគ្របដណ្ដប់",
          "signal-v": "ហាង {n} បច្ចុប្បន្នមិនទាន់គ្របដណ្ដប់គ្រប់គ្រាន់ | ហាង {n} បច្ចុប្បន្នមិនទាន់គ្របដណ្ដប់គ្រប់គ្រាន់",
          "suggest": "ហាងចាប់ផ្ដើមដែលបានណែនាំ",
          "reason": "មូលហេតុ៖ បានបញ្ចប់ការចុះជួប {done} ក្នុងចំណោម {req} ដែលត្រូវការក្នុងខែ{month}{high}{geo}។",
          "high": "អាទិភាពខ្ពស់",
          "geo": "អាចធ្វើបានតាមភូមិសាស្ត្រ",
          "shortfall": "កង្វះខាតមុននៅតែមាននៅក្នុង {period}។ ខែថ្មីមិនចម្លងកាតព្វកិច្ចនោះដោយស្វ័យប្រវត្តិទេ; វាអាចផ្ដល់អាទិភាពដល់ហាងទាំងនោះក្នុងគោលដៅជាក់លាក់។",
          "on-track": "ការគ្របដណ្ដប់ដំណើរការល្អ — គោលដៅថ្មីត្រូវបានបែងចែកជាវដ្តពេញ និងវដ្តមួយផ្នែក ហើយនៅតែអាចកែសម្រួលបាននៅជំហានទី 2។",
          "prioritize": "ផ្ដល់អាទិភាពដល់ហាងដែលមិនទាន់គ្របដណ្ដប់គ្រប់គ្រាន់ក្នុងកាលវិភាគថ្មី",
          "prioritized": "ហាងដែលមិនទាន់គ្របដណ្ដប់គ្រប់គ្រាន់ត្រូវបានផ្ដល់អាទិភាពនៅពេលបង្កើតសេចក្ដីព្រាងនេះ (តែលំដាប់ + ចំណុចចាប់ផ្ដើមផ្លូវ)។"
        },
        "sum": {
          "source": "ប្រភពចាប់ផ្ដើម",
          "outlets": "ហាងដែលបានជ្រើសរើស",
          "days": "ថ្ងៃចុះជួបដែលអាចប្រើបាន",
          "slots": "ចំនួនចុះជួបអតិបរមា",
          "target": "គោលដៅចុះជួបតាមផែនការ",
          "remain": "សមត្ថភាពនៅសល់",
          "min": "ការចុះជួបអប្បបរមាដែលត្រូវការ",
          "met": "បានសម្រេច",
          "warning": "ការព្រមាន",
          "avg": "មធ្យមប៉ាន់ស្មាន / ហាង",
          "cycles": "វដ្តចុះជួបដែលបានណែនាំ",
          "cycles-wait": "កំពុងរង់ចាំការជ្រើសរើសហាង",
          "cycles-full": "វដ្ត 1–{full} វដ្តពេញ",
          "cycles-partial": "វដ្ត 1–{full} + ហាង {partial} ក្នុងវដ្ត {next}",
          "time": "ពេលវេលាចុះជួបប៉ាន់ស្មាន",
          "hours": "{n} ម៉ោង | {n} ម៉ោង",
          "util": "ការប្រើប្រាស់ {pct}%។ សមត្ថភាពប្រចាំថ្ងៃគឺជាពិដាន មិនមែនជាការណែនាំឱ្យបំពេញរាល់ថ្ងៃទេ។ ជំហានទី 2 កំណត់សមាជិកភាពវដ្តពិតប្រាកដ និងប្រេកង់តាមហាង។"
        },
        "cal": {
          "multi": "ជ្រើសរើសច្រើន",
          "multi-finish": "បញ្ចប់ការជ្រើសរើសច្រើន",
          "selected-n": "បានជ្រើសរើស {n}",
          "include": "បញ្ចូល",
          "exclude": "ដកចេញ",
          "reset": "កំណត់ឡើងវិញតាមប្រតិទិនបុគ្គល",
          "dow": {
            "1": "ច",
            "2": "អ",
            "3": "ពុ",
            "4": "ព្រ",
            "5": "សុ",
            "6": "ស",
            "7": "អា"
          },
          "state": {
            "work": "ថ្ងៃចុះជួបដែលអាចប្រើបាន",
            "rest": "ថ្ងៃឈប់សម្រាកដែលបានកំណត់",
            "exception": "ករណីលើកលែងចុះជួប",
            "nonvisit": "ការងារមិនចុះជួប",
            "comprest": "ការឈប់សម្រាកសងវិញ"
          },
          "pending-rsm": "រង់ចាំ RSM",
          "tip": {
            "off": "ការចាត់ថ្នាក់មិនចុះជួបដោយដៃ — {type}",
            "other-work": "ការងារផ្សេងៗ",
            "comp-off": "ការឈប់សម្រាកសងវិញដែលភ្ជាប់ សម្រាប់ការងារនៅទីវាលនៅ {date}",
            "on": "ករណីលើកលែងថ្ងៃចុះជួបដែលគ្រប់គ្រង · {status}",
            "leave": "{label} — ការហាមឃាត់ដាច់ខាតពីការឈប់សម្រាក",
            "comp": "{label} — គ្រប់គ្រងពីករណីលើកលែងការងារនៅទីវាលដែលភ្ជាប់",
            "exception": "{label} — ត្រូវការមូលហេតុ និងជម្រើសសំណង",
            "work": "ថ្ងៃចុះជួបដែលអាចប្រើបាន — ចុចដើម្បីចាត់ថ្នាក់សកម្មភាពផ្សេង ឬប្ដូរសមត្ថភាព"
          },
          "cap": "សមត្ថភាព {n}",
          "cap-title": "សមត្ថភាពកាលបរិច្ឆេទ {n}",
          "legend": {
            "work": "ថ្ងៃចុះជួបដែលអាចប្រើបាន",
            "rest": "ថ្ងៃឈប់សម្រាក / មិនធ្វើការ",
            "holiday": "ថ្ងៃឈប់សម្រាកសាធារណៈ",
            "leave": "ការឈប់សម្រាកដែលបានអនុម័ត",
            "other": "ការងារផ្សេងៗ / បានដកចេញ",
            "exception": "ករណីលើកលែងចុះជួប / ការឈប់សម្រាកសងវិញ",
            "selected": "បានជ្រើសរើស"
          },
          "hint": "ជ្រើសរើសកាលបរិច្ឆេទដើម្បីប្ដូរភាពអាចប្រើបាន ឬសមត្ថភាពរបស់វា។ កាលបរិច្ឆេទលើកលែងត្រូវការមូលហេតុ។",
          "chip": {
            "on": "ករណីលើកលែងចុះជួប · {status}",
            "comp-off": "ការឈប់សម្រាកសងវិញ · ភ្ជាប់ទៅ {date}"
          },
          "sel": {
            "leave": "ការហាមឃាត់ដាច់ខាតពីការឈប់សម្រាក។ សូមប្ដូរ ឬលុបចោលការឈប់សម្រាកនៅក្នុង HR Ops; Field Ops មិនអាចបដិសេធវាបានទេ។",
            "comp": "ប្រតិបត្តិការប្រតិទិនដែលភ្ជាប់។ សូមប្ដូរករណីលើកលែងការងារនៅទីវាលថ្ងៃឈប់សម្រាក/បុណ្យដើម; កុំជំនួសវាដោយកំណត់ចំណាំ។",
            "why": "មូលហេតុនៃការងារនៅទីវាល (ចាំបាច់)",
            "comp-choice": "ជម្រើសសំណង…",
            "comp-repl": "ថ្ងៃឈប់សម្រាកជំនួស",
            "comp-none": "គ្មានថ្ងៃជំនួស",
            "repl-title": "កាលបរិច្ឆេទឈប់សម្រាកសងវិញដែលភ្ជាប់ · ត្រូវតែជាថ្ងៃធ្វើការតាមវេន បន្ទាប់ពីកាលបរិច្ឆេទការងារនៅទីវាលនេះ",
            "from": "ម៉ោងចាប់ផ្ដើមដែលបានអនុញ្ញាត",
            "to": "ម៉ោងបញ្ចប់ដែលបានអនុញ្ញាត",
            "request": "ស្នើករណីលើកលែងថ្ងៃចុះជួប",
            "repl-note": "ការឈប់សម្រាកជំនួសត្រូវបានភ្ជាប់ដោយស្វ័យប្រវត្តិ ហើយអាចធ្លាក់ក្នុងខែបន្ទាប់ ក្នុងរយៈពេលគោលការណ៍ {days} ថ្ងៃ។",
            "linked": "ការឈប់សម្រាកសងវិញដែលភ្ជាប់៖ {date} · ប្រតិបត្តិការអនុម័តតែមួយ",
            "restore": "ស្ដារប្រតិទិនបុគ្គលវិញ",
            "activity": "សកម្មភាពមិនចុះជួប…",
            "other": "ពិពណ៌នាប្រសិនបើជា ផ្សេងៗ",
            "use-other": "ប្រើសម្រាប់ការងារផ្សេង",
            "comp-hint": "សម្រាប់ការឈប់សម្រាកសងវិញ សូមចាប់ផ្ដើមពីកាលបរិច្ឆេទការងារនៅទីវាលថ្ងៃបុណ្យ/ឈប់សម្រាកដើម ហើយជ្រើសរើស ថ្ងៃឈប់សម្រាកជំនួស; ប្រព័ន្ធបង្កើតកាលបរិច្ឆេទនេះជាប្រតិបត្តិការភ្ជាប់។",
            "cap": "សមត្ថភាពសម្រាប់កាលបរិច្ឆេទនេះ",
            "cap-why": "មូលហេតុ ប្រសិនបើខុសពី {n}",
            "cap-apply": "អនុវត្តសមត្ថភាព",
            "foot": "សមត្ថភាពផែនការគឺជាពិដាន មិនមែនជាតម្រូវការឱ្យបំពេញរាល់ថ្ងៃទេ។ ការឈប់សម្រាកជាកម្មសិទ្ធិរបស់ប្រភព; ការងារថ្ងៃបុណ្យ/ឈប់សម្រាកត្រូវបានអនុញ្ញាតវត្តមាន តែបន្ទាប់ពី RSM អនុម័ត។"
          },
          "msg": {
            "blocked": "សូមអនុវត្តការផ្លាស់ប្ដូរខែដែលរង់ចាំជាមុនសិន (ចុច បន្ត) — បន្ទាប់មកកែតម្រូវប្រតិទិនរបស់ខែថ្មី។",
            "leave-hard": "{label} គឺជាការហាមឃាត់ដាច់ខាតពីការឈប់សម្រាក។ សូមប្ដូរ ឬលុបចោលការឈប់សម្រាកនៅប្រភពរបស់វា មុនរៀបចំផែនការការងារនៅទីវាល។",
            "comp-linked": "{label} ភ្ជាប់ទៅនឹងសំណើការងារនៅទីវាលថ្ងៃឈប់សម្រាក/បុណ្យដើម។ សូមប្ដូរប្រតិបត្តិការដែលភ្ជាប់នោះ ជំនួសឱ្យការបដិសេធវានៅទីនេះ។",
            "already-unavailable": "{label} មិនអាចប្រើបានរួចហើយនៅក្នុងប្រតិទិនបុគ្គល។",
            "alt-required": "សូមជ្រើសរើសប្រភេទការងារសម្រាប់ថ្ងៃមិនចុះជួបនេះ។ «ផ្សេងៗ» ក៏ត្រូវការការពិពណ៌នាដែរ។",
            "reason-required": "{label} — ត្រូវការមូលហេតុមុនស្នើការងារនៅទីវាល។",
            "comp-choice": "សូមជ្រើសរើសថាតើករណីលើកលែងនេះទទួលបានថ្ងៃឈប់សម្រាកជំនួសឬអត់។",
            "repl-required": "សូមជ្រើសរើសថ្ងៃឈប់សម្រាកជំនួស មុនស្នើករណីលើកលែងថ្ងៃចុះជួបនេះ។",
            "repl-window": "សូមជ្រើសរើសកាលបរិច្ឆេទធ្វើការជំនួស បន្ទាប់ពីកាលបរិច្ឆេទការងារនៅទីវាល និងក្នុងរយៈពេល {days} ថ្ងៃ។",
            "repl-unavailable": "សូមជ្រើសរើសកាលបរិច្ឆេទធ្វើការតាមវេនដែលអាចប្រើបាន សម្រាប់ថ្ងៃឈប់សម្រាកជំនួស។",
            "repl-taken": "កាលបរិច្ឆេទជំនួសនោះមានការកែតម្រូវផែនការរួចហើយ។ សូមជ្រើសរើសថ្ងៃធ្វើការផ្សេង។",
            "done-off": "{date} ត្រូវបានចាត់ថ្នាក់ជាការងារមិនចុះជួប ហើយដកចេញពីសមត្ថភាពថ្ងៃចុះជួប។",
            "done-on": "បានស្នើករណីលើកលែង {date} — ការអនុម័តរបស់ RSM នឹងអនុញ្ញាតវត្តមាន។",
            "done-clear": "{date} ត្រូវបានស្ដារទៅប្រតិទិនបុគ្គលវិញ។",
            "click-leave": "{label} — ត្រូវបានហាមឃាត់ដាច់ខាតដោយការឈប់សម្រាក; Field Ops មិនអាចបដិសេធវាបានទេ។",
            "click-comp": "{label} — កាលបរិច្ឆេទនេះត្រូវបានគ្រប់គ្រងដោយករណីលើកលែងការងារនៅទីវាលដែលភ្ជាប់ មិនមែនដោយកំណត់ចំណាំប្រតិទិនទេ។",
            "click-exception": "{label} — ត្រូវការមូលហេតុ និងជម្រើសសំណង មុនស្នើការងារនៅទីវាល។",
            "click-selected": "បានជ្រើសរើសកាលបរិច្ឆេទ — ពិនិត្យភាពអាចប្រើបាន និងសមត្ថភាពខាងក្រោម។",
            "multi-on": "ការជ្រើសរើសច្រើនបានបើក — ជ្រើសរើសកាលបរិច្ឆេទ បន្ទាប់មក បញ្ចូល ឬ ដកចេញ។ ករណីលើកលែងនៅតែត្រូវការមូលហេតុម្ដងមួយៗ។",
            "multi-none": "មិនទាន់បានជ្រើសរើសអ្វីទេ — សូមជ្រើសរើសកាលបរិច្ឆេទជាមុន។",
            "multi-included": "បានបញ្ចូលកាលបរិច្ឆេទ {n} | បានបញ្ចូលកាលបរិច្ឆេទ {n}",
            "multi-excluded": "កាលបរិច្ឆេទ {n} ត្រូវបានចាត់ថ្នាក់ជាការងារមិនចុះជួប | កាលបរិច្ឆេទ {n} ត្រូវបានចាត់ថ្នាក់ជាការងារមិនចុះជួប",
            "multi-skip-tail": "បានរំលងកាលបរិច្ឆេទ {n} — ត្រូវការព័ត៌មានលម្អិតករណីលើកលែង ឬសកម្មភាពមិនចុះជួបលំនាំដើម | បានរំលងកាលបរិច្ឆេទ {n} — ត្រូវការព័ត៌មានលម្អិតករណីលើកលែង ឬសកម្មភាពមិនចុះជួបលំនាំដើម",
            "multi-tail": "សមត្ថភាពត្រូវបានធ្វើបច្ចុប្បន្នភាពនៅនឹងកន្លែង។",
            "multi-skipped": "កាលបរិច្ឆេទដែលបានជ្រើសរើស {n} ត្រូវការព័ត៌មានលម្អិតករណីលើកលែង ឬសកម្មភាពមិនចុះជួបលំនាំដើម។ | កាលបរិច្ឆេទដែលបានជ្រើសរើស {n} ត្រូវការព័ត៌មានលម្អិតករណីលើកលែង ឬសកម្មភាពមិនចុះជួបលំនាំដើម។",
            "reset": "ថ្ងៃចុះជួបត្រូវបានស្ដារពីប្រតិទិនបុគ្គល (កាលវិភាគ)។",
            "cap-range": "សមត្ថភាពត្រូវតែចន្លោះពី 1 ដល់ 30 ចុះជួប សម្រាប់កាលបរិច្ឆេទដែលបានជ្រើសរើស។",
            "cap-reason": "ត្រូវការមូលហេតុសម្រាប់ការផ្លាស់ប្ដូរសមត្ថភាពតាមកាលបរិច្ឆេទ។",
            "cap-done": "សមត្ថភាព {date} ត្រូវបានកំណត់ជា {n} ចុះជួប · កាលវិភាគត្រូវបានគណនាឡើងវិញ។",
            "cap-restored": "សមត្ថភាព {date} ត្រូវបានស្ដារទៅលំនាំដើមផែនការ · កាលវិភាគត្រូវបានគណនាឡើងវិញ។"
          }
        },
        "rev": {
          "loading": "កំពុងរៀបចំការពិនិត្យ…",
          "intro": "បញ្ជាក់ផែនការប្រចាំខែ មុនពេលផ្ញើទៅ {rsm} ដើម្បីអនុម័ត · កំណែ {rev}",
          "intro-amend": "បញ្ជាក់ {rev} ដែលបានស្នើ មុនពេលផ្ញើតែការផ្លាស់ប្ដូររបស់វាទៅ {rsm}។ កំណែដែលបានអនុម័ត {base} នៅតែដំណើរការ ខណៈការពិនិត្យកំពុងរង់ចាំ។",
          "revision": "កំណែ {rev}",
          "amend-request": "សំណើវិសោធនកម្ម",
          "reason": "មូលហេតុ៖",
          "effective": "ចូលជាធរមាន៖",
          "not-selected": "មិនទាន់ជ្រើសរើស",
          "changes": "ការផ្លាស់ប្ដូរពីកំណែដែលបានអនុម័ត {base}",
          "no-change": "មិនទាន់រកឃើញការផ្លាស់ប្ដូរផែនការនៅឡើយ។",
          "kpi-outlets": "ហាងតាមផែនការ",
          "kpi-outlets-s": "{pct}% នៃហាងដែលបានចាត់តាំង",
          "kpi-visits": "ការចុះជួបដែលបានបង្កើត",
          "kpi-visits-s": "ក្នុងវដ្តចុះជួប {n} · ពីកាលវិភាគដែលមានតុល្យភាព | ក្នុងវដ្តចុះជួប {n} · ពីកាលវិភាគដែលមានតុល្យភាព",
          "kpi-peak": "បន្ទុកប្រចាំថ្ងៃខ្ពស់បំផុត",
          "kpi-peak-ok": "សមត្ថភាពអាចធ្វើបាន",
          "kpi-peak-no": "មានជម្លោះ — សូមមើលភាពត្រៀមខ្លួន",
          "kpi-util": "ការប្រើប្រាស់",
          "kpi-util-s": "នៃចំនួនចុះជួបសរុប {slots} ក្នុងថ្ងៃចុះជួប {days}",
          "summary": "សេចក្ដីសង្ខេបផែនការ",
          "period": "រយៈពេលផែនការ",
          "baseline": "មូលដ្ឋានកំណែ",
          "source": "ប្រភពចាប់ផ្ដើម",
          "baseline-v": "កំណែដែលបានអនុម័ត {base} → កំណែដែលបានស្នើ {rev}",
          "target": "គោលដៅចុះជួប",
          "target-v": "បានបង្កើត {n} / គោលដៅ {target}",
          "target-above": "លើសគោលដៅ {n}",
          "target-gap": "ការចុះជួប {n} ទាបជាងគោលដៅ — សូមពន្យល់សម្រាប់ RSM ឬកែសម្រួលជំហានទី 2។ | ការចុះជួប {n} ទាបជាងគោលដៅ — សូមពន្យល់សម្រាប់ RSM ឬកែសម្រួលជំហានទី 2។",
          "target-why": "មូលហេតុនៃការខ្វះគោលដៅ",
          "min-v": "{n}/ខែ",
          "min-below": "ហាង {n} ទាបជាងអប្បបរមា | ហាង {n} ទាបជាងអប្បបរមា",
          "min-met": "សម្រេចអប្បបរមាសម្រាប់ហាងទាំងអស់",
          "min-why": "ការពន្យល់ពីការទាបជាងអប្បបរមា",
          "min-why-missing": "ខ្វះ — ការដាក់ស្នើត្រូវបានរារាំង",
          "nonvisit": "ថ្ងៃធ្វើការមិនចុះជួប",
          "not-classified": "មិនទាន់ចាត់ថ្នាក់",
          "dur-policy-l": "គោលការណ៍រយៈពេលចុះជួប",
          "dur-policy": "អប្បបរមា {min} · អតិបរមា {max} · ជំហាន {inc} នាទី",
          "dur-none": "មិនទាន់កំណត់ — ការរៀបចំផែនការត្រូវបានរារាំង",
          "dur-below": "រយៈពេលទាបជាងការប៉ាន់ស្មាន ({n})",
          "dur-below-row": "{site} · {sel} នាទី ធៀបនឹងការប៉ាន់ស្មាន {est} នាទី —",
          "dur-below-missing": "ខ្វះការពន្យល់",
          "cal-days": "ថ្ងៃចុះជួប {n}",
          "cal-adj": "ការកែតម្រូវដោយដៃ {n} | ការកែតម្រូវដោយដៃ {n}",
          "cal-cap": "ការកំណត់សមត្ថភាពតាមកាលបរិច្ឆេទ {n} | ការកំណត់សមត្ថភាពតាមកាលបរិច្ឆេទ {n}",
          "checklist": "បញ្ជីត្រួតពិនិត្យដែលបានអនុវត្ត៖",
          "mix-n": "(ហាង {n}) | (ហាង {n})",
          "checklist-tail": "— កិច្ចការមកពីបណ្ណាល័យកិច្ចការមេនៃការគ្រប់គ្រងការងារ។",
          "readiness": "ភាពត្រៀមខ្លួនសម្រាប់ការដាក់ស្នើ",
          "ok": "រួចរាល់",
          "not-ok": "ត្រូវការការយកចិត្តទុកដាក់",
          "override": "មានការបដិសេធសមត្ថភាពក្នុងកំណត់ត្រា — {reason} (RSM អាចមើលឃើញ)។",
          "review-again": "ពិនិត្យកាលវិភាគម្ដងទៀត"
        },
        "ready": {
          "out": "ការងារហាងបានបញ្ចប់",
          "out-ok": "ហាង {n} ក្នុងចំណោម {n} មានគោលបំណង សមាជិកភាពវដ្តចុះជួប កាលបរិច្ឆេទដែលបានស្នើ ចន្លោះពេល និងរយៈពេល។",
          "out-no": "សូមបន្ថែមហាងយ៉ាងហោចណាស់មួយនៅជំហានទី 2។",
          "sched": "កាលវិភាគត្រូវបានបង្កើត",
          "sched-ok": "ការចុះជួប {n} ត្រូវបានបែងចែកលើថ្ងៃធ្វើការ {dates} និងវដ្ត {cycles}។ | ការចុះជួប {n} ត្រូវបានបែងចែកលើថ្ងៃធ្វើការ {dates} និងវដ្ត {cycles}។",
          "sched-no": "មិនទាន់មានការចុះជួបត្រូវបានបង្កើតទេ — សូមបន្ថែមហាងនៅជំហានទី 2។",
          "overlap": "ការប្រគល់វដ្តចុះជួបត្រឹមត្រូវ",
          "overlap-ok": "គ្មានចន្លោះកាលបរិច្ឆេទវដ្តត្រួតគ្នាទេ។",
          "overlap-warn": "វដ្តជាប់គ្នាចែករំលែកកាលបរិច្ឆេទប្រគល់មួយ; នេះត្រូវបានអនុញ្ញាតក្នុងសមត្ថភាពនៃកាលបរិច្ឆេទនោះ។",
          "overlap-no": "វដ្តក្រោយចាប់ផ្ដើមមុនវដ្តមុនបញ្ចប់ — សូមកែសម្រួលជំហានទី 2 មុនដាក់ស្នើ។",
          "target": "គោលដៅចុះជួបប្រចាំខែត្រូវបានសម្រេច ឬពន្យល់",
          "target-explained": "ការខ្វះការចុះជួប {n} មានការពន្យល់ដែល RSM អាចមើលឃើញ។",
          "target-over": "កាលវិភាគលើសគោលដៅ {n} ចុះជួប ហើយនៅតែក្នុងសមត្ថភាព។ | កាលវិភាគលើសគោលដៅ {n} ចុះជួប ហើយនៅតែក្នុងសមត្ថភាព។",
          "target-ok": "កាលវិភាគដែលបានបង្កើតត្រូវនឹងគោលដៅប្រចាំខែ។",
          "target-no": "ការចុះជួប {n} ទាបជាងគោលដៅ — សូមពន្យល់ភាពខុសគ្នា ឬកែសម្រួលជំហានទី 2។ | ការចុះជួប {n} ទាបជាងគោលដៅ — សូមពន្យល់ភាពខុសគ្នា ឬកែសម្រួលជំហានទី 2។",
          "cap": "សមត្ថភាពអាចធ្វើបាន",
          "cap-ok": "បន្ទុកខ្ពស់បំផុតគឺ {peak} ធៀបនឹងដែនកំណត់ {cap} នៅ {date}។",
          "cap-busiest": "កាលបរិច្ឆេទមមាញឹកបំផុត",
          "cap-no": "ការចុះជួប {n} មិនអាចដាក់បានទេ — សូមជ្រើសរើសកាលបរិច្ឆេទផ្សេង បន្ថែមថ្ងៃចុះជួប ឬកត់ត្រាករណីលើកលែងសមត្ថភាពដែលមានមូលហេតុ។ | ការចុះជួប {n} មិនអាចដាក់បានទេ — សូមជ្រើសរើសកាលបរិច្ឆេទផ្សេង បន្ថែមថ្ងៃចុះជួប ឬកត់ត្រាករណីលើកលែងសមត្ថភាពដែលមានមូលហេតុ។",
          "work": "ថ្ងៃធ្វើការមិនចុះជួបត្រូវបានចាត់ថ្នាក់",
          "work-ok": "ថ្ងៃដែលគ្មានការចុះជួបហាងតាមផែនការ ប្រើលំនាំដើម {type}។",
          "work-no": "សូមជ្រើសរើសការងារដែលរំពឹងទុក នៅពេលគ្មានការចុះជួប PJP; ផ្សេងៗ ត្រូវការការពិពណ៌នា។",
          "min": "ការគ្របដណ្ដប់អប្បបរមាត្រូវបានពន្យល់",
          "min-explained": "ហាង {n} ទាបជាងអប្បបរមាផែនការ ជាមួយការពន្យល់ដែល RSM អាចមើលឃើញ។ | ហាង {n} ទាបជាងអប្បបរមាផែនការ ជាមួយការពន្យល់ដែល RSM អាចមើលឃើញ។",
          "min-ok": "ហាងនីមួយៗសម្រេច ឬលើសអប្បបរមាផែនការ។",
          "min-no": "ហាង {n} ទាបជាងអប្បបរមា — សូមបន្ថែមមូលហេតុដែល RSM អាចមើលឃើញ មុនដាក់ស្នើ។ | ហាង {n} ទាបជាងអប្បបរមា — សូមបន្ថែមមូលហេតុដែល RSM អាចមើលឃើញ មុនដាក់ស្នើ។",
          "exc": "ករណីលើកលែងប្រតិទិនត្រូវបានដោះស្រាយ",
          "exc-ok": "ថ្ងៃមិនធ្វើការរបស់គម្រោង និងថ្ងៃឈប់សម្រាកសាធារណៈត្រូវបានជៀសវាង លុះត្រាតែបញ្ចូលដោយការបដិសេធដែលមានមូលហេតុ; ភាពមិនអាចប្រើបានរបស់ហាងត្រូវបានគោរព",
          "exc-adj": "ការកែតម្រូវប្រតិទិនដោយដៃត្រូវបានកត់ត្រា និងធ្វើសវនកម្ម",
          "exc-tail": "គ្មានជម្លោះដែលមិនទាន់ដោះស្រាយនៅសល់ទេ។",
          "exc-no": "នៅមានជម្លោះដែលមិនទាន់ដោះស្រាយ — សូមបើកកាលវិភាគជាមុន។"
        },
        "life": {
          "title": "ការប្រគល់ការអនុម័ត",
          "note": "ការដាក់ស្នើមិនផ្សព្វផ្សាយផែនការទេ; នៅតែត្រូវការការអនុម័តពី RSM។",
          "note-amend": "ការដាក់ស្នើមិនជំនួសផែនការដែលបានអនុម័តទេ; នៅតែត្រូវការការអនុម័តពី RSM។",
          "draft": "សេចក្ដីព្រាង",
          "working": "កំណែការងារ",
          "pending": "កំពុងរង់ចាំការអនុម័ត",
          "pending-amend": "វិសោធនកម្មកំពុងរង់ចាំ",
          "published": "បានអនុម័ត និងផ្សព្វផ្សាយ",
          "active": "កំណែសកម្ម",
          "appr": "ការដាក់ស្នើផ្ញើកំណែនេះទៅ {rsm} ដើម្បីពិនិត្យ — ការអនុម័ត និងការផ្សព្វផ្សាយកើតឡើងជាមួយគ្នានៅខាង RSM; អ្នកមិនអាចផ្លាស់ប្ដូរផែនការដោយស្ងាត់ៗ ខណៈការអនុម័តកំពុងរង់ចាំទេ។",
          "appr-amend": "ការដាក់ស្នើផ្ញើសំណុំការផ្លាស់ប្ដូរដែលបានស្នើទៅ {rsm} ដើម្បីពិនិត្យ។ កំណែដែលបានអនុម័ត {base} នៅតែដំណើរការ រហូតដល់កំណែ {rev} ត្រូវបានអនុម័ត; ការងារដែលបានបញ្ចប់ និងកន្លងផុតមិនដែលត្រូវបានសរសេរឡើងវិញទេ។",
          "subnote": "កំណត់ចំណាំទៅ RSM របស់អ្នក (ស្រេចចិត្ត)"
        },
        "lane": {
          "empty": "មិនទាន់មានការចុះទស្សនកិច្ចដែលបានគ្រោងទុកទេ — បន្ថែមហាង ដើម្បីមើលវឌ្ឍនភាពនៃការគ្របដណ្តប់។",
          "title": "ការប្តេជ្ញាគ្របដណ្តប់ប្រចាំខែ",
          "hint": "ផ្លូវតាមកាលបរិច្ឆេទពិតប្រាកដ នៅតែអាចមើលឃើញក្នុងការមើលកាលវិភាគជាមុន។",
          "cycles": "{n} វដ្ត | {n} វដ្ត",
          "cycle": "វដ្តទស្សនកិច្ច {k}",
          "outlets": "{n} ហាង | {n} ហាង",
          "visits": "{n} ដង | {n} ដង",
          "finish": "បញ្ចប់តាមគម្រោង {d}",
          "rule": "ច្បាប់វដ្តបន្ទាប់៖",
          "rule-text": "ហាងនីមួយៗចូលវដ្តទស្សនកិច្ចបន្ទាប់ លុះត្រាតែបានចុះទស្សនកិច្ចមុនរបស់ខ្លួន និងគម្លាតអប្បបរមាដែលតម្រូវ — ដោយគោរពថ្ងៃធ្វើការ សមត្ថភាព ថ្ងៃឈប់សម្រាក និងភាពមិនអាចចូលបានរបស់ហាង។",
          "overlap": "ចន្លោះវដ្តទស្សនកិច្ចត្រួតគ្នាលើហាងផ្សេងៗគ្នា។",
          "overlap-text": "វដ្តទស្សនកិច្ច {b} ចាប់ផ្តើម {start} ខណៈវដ្តទស្សនកិច្ច {a} បញ្ចប់ {finish}។ នេះជារឿងធម្មតា នៅពេលសមាជិកភាពវដ្តខុសគ្នា; លំដាប់ និងគម្លាតរបស់ហាងនីមួយៗនៅតែត្រូវបានការពារ។ ប្រើជំហានទី 3 សម្រាប់ផ្លូវតាមកាលបរិច្ឆេទពិតប្រាកដ។"
        },
        "plan": {
          "banner-title": "បង្កើតផែនការប្រចាំខែតាមវដ្តទស្សនកិច្ច។",
          "banner": "ពិនិត្យវដ្តនីមួយៗ បន្ទាប់មកកែតម្រូវហាង លំដាប់ពីដំបូងដល់ចុងក្រោយ និងកាលបរិច្ឆេទដែលបានស្នើ។ គោលបំណង ចន្លោះពេលដែលពេញចិត្ត និងរយៈពេល នៅតែអាចកែបាន; បញ្ជីត្រួតពិនិត្យធ្វើតាមគោលបំណងដោយស្វ័យប្រវត្តិ។",
          "fits": "ផែនការវដ្តទស្សនកិច្ចសមនឹងប្រតិទិនដែលមាន។",
          "fits-text": "ការចុះទស្សនកិច្ចដែលបានគ្រោង {n} ដង លើថ្ងៃចុះទស្សនកិច្ច {days} ថ្ងៃ · ខ្ពស់បំផុត {peak} / {cap} នៅ {date} · នៅសល់ចន្លោះចុះទស្សនកិច្ច {rem}។",
          "fits-tail": "សមាជិកភាពវដ្ត និងកាលបរិច្ឆេទដែលបានស្នើ នៅតែច្បាស់លាស់ និងអាចកែបាន។",
          "unplaced": "ការចុះទស្សនកិច្ចដែលបានគ្រោង {n} ដង មិនអាចដាក់បានទេ។ | ការចុះទស្សនកិច្ចដែលបានគ្រោង {n} ដង មិនអាចដាក់បានទេ។",
          "unplaced-actions": "សកម្មភាពដែលបានណែនាំ៖ {a}, {b}, ឬ {c}។ ប្រព័ន្ធមិនដែលដកហាងចេញពីវដ្តទស្សនកិច្ចដោយស្វ័យប្រវត្តិទេ។",
          "unplaced-a": "ជ្រើសកាលបរិច្ឆេទស្នើផ្សេងទៀត",
          "unplaced-b": "បន្ថែមថ្ងៃចុះទស្សនកិច្ច",
          "unplaced-c": "បង្កើនសមត្ថភាពសម្រាប់កាលបរិច្ឆេទដែលបានជ្រើស ដោយមានហេតុផលសវនកម្ម",
          "title": "ធ្វើផែនការតាមវដ្តទស្សនកិច្ច",
          "title-hint": "វដ្តទស្សនកិច្ចមួយ គឺការចុះទស្សនកិច្ចដែលបានគ្រោងមួយជុំ ទៅកាន់ហាងដែលបានជ្រើស។ វដ្តនីមួយៗអាចមានសមាជិកភាព លំដាប់ និងកាលបរិច្ឆេទស្នើរៀងៗខ្លួន។",
          "cycles-chip": "{n} វដ្ត · {visits} ដង | {n} វដ្ត · {visits} ដង",
          "tabs-label": "វដ្តទស្សនកិច្ច",
          "cycle": "វដ្តទស្សនកិច្ច {k}",
          "partial": "មួយផ្នែក",
          "dates-pending": "កាលបរិច្ឆេទកំពុងរង់ចាំ",
          "copy-next": "អនុវត្តទៅវដ្តបន្ទាប់",
          "copy-rest": "អនុវត្តទៅវដ្តដែលនៅសល់ទាំងអស់",
          "reset-all": "កំណត់ការណែនាំរបស់ប្រព័ន្ធឡើងវិញ",
          "calc": "ចំនួនចុះទស្សនកិច្ច/ខែ ដែលបានគណនា៖",
          "calc-text": "តម្លៃរបស់ហាងគឺជាចំនួនវដ្តទស្សនកិច្ចដែលមានហាងនោះ។ អប្បបរមា {n} ·",
          "calc-below": "{n} ក្រោមអប្បបរមា — នៅតែតម្រូវឱ្យមានការព្រមាន/ការពន្យល់ | {n} ក្រោមអប្បបរមា — នៅតែតម្រូវឱ្យមានការព្រមាន/ការពន្យល់",
          "calc-met": "ហាងទាំងអស់បំពេញអប្បបរមា",
          "overlap-block": "កាលបរិច្ឆេទវដ្តទស្សនកិច្ចត្រួតគ្នាលើសថ្ងៃប្រគល់វេន — ការដាក់ស្នើត្រូវបានរារាំង។",
          "overlap-block-text": "វដ្តទស្សនកិច្ច {b} ចាប់ផ្តើម {start} មុនពេលវដ្តទស្សនកិច្ច {a} បញ្ចប់ {finish}។ កែតម្រូវកាលបរិច្ឆេទវដ្ត ដើម្បីឱ្យវដ្តបន្ទាប់ចាប់ផ្តើមនៅ ឬក្រោយពេលវដ្តមុនបញ្ចប់។",
          "overlap-warn": "ការប្រគល់វេនវដ្តនៅថ្ងៃតែមួយ។",
          "overlap-warn-text": "វដ្តទស្សនកិច្ច {b} ចាប់ផ្តើម {start} ខណៈវដ្តទស្សនកិច្ច {a} បញ្ចប់។ អនុញ្ញាត នៅពេលការចុះទស្សនកិច្ចរួមនៅក្នុងសមត្ថភាពនៃកាលបរិច្ឆេទនោះ។",
          "editing": "កំពុងកែវដ្តទស្សនកិច្ច {k}",
          "editing-hint": "ការផ្លាស់ប្តូរផ្លូវ ហាង និងជាក្រុមខាងក្រោម អនុវត្តចំពោះវដ្តដែលបានជ្រើសនេះ។",
          "window": "ចន្លោះវដ្តដែលបានណែនាំ",
          "window-end": "ថ្ងៃចុះទស្សនកិច្ចចុងក្រោយសម្រាប់វដ្ត {k}",
          "window-note": "វដ្ត {k} ចាប់ផ្តើមនៅថ្ងៃចុះទស្សនកិច្ចបន្ទាប់ដែលមាន។ ការបង្រួមផ្តល់ថ្ងៃឱ្យវា; ការពង្រីកយកថ្ងៃពីវា។",
          "window-final": "វដ្តចុងក្រោយប្រើថ្ងៃចុះទស្សនកិច្ចដែលនៅសល់។",
          "window-reset": "កំណត់ចន្លោះដែលបានណែនាំឡើងវិញ",
          "guardrail": "ការពិនិត្យដែនកំណត់ធ្វើផែនការ។",
          "guardrail-below": "ហាង {n} ស្ថិតនៅក្រោមអប្បបរមាដែលបានកំណត់។ | ហាង {n} ស្ថិតនៅក្រោមអប្បបរមាដែលបានកំណត់។",
          "guardrail-target": "ការចុះទស្សនកិច្ចដែលបានគ្រោង {n} ដង ស្ថិតនៅក្រោមគោលដៅប្រចាំខែ។ | ការចុះទស្សនកិច្ចដែលបានគ្រោង {n} ដង ស្ថិតនៅក្រោមគោលដៅប្រចាំខែ។",
          "guardrail-tail": "ផែនការនៅតែអាចកែបាន; តម្រូវឱ្យមានការពន្យល់មុនពេលដាក់ស្នើ។",
          "min-why": "ហេតុផលសម្រាប់ហាងក្រោមអប្បបរមា",
          "target-why": "ហេតុផលសម្រាប់ការខ្វះគោលដៅប្រចាំខែ",
          "zero": "ហាង {n} ត្រូវបានគ្រោងចុះទស្សនកិច្ច 0 ដងក្នុងខែនេះ។ | ហាង {n} ត្រូវបានគ្រោងចុះទស្សនកិច្ច 0 ដងក្នុងខែនេះ។",
          "zero-text": "វានៅក្នុងផែនការប្រចាំខែ ប៉ុន្តែមិនស្ថិតក្នុងវដ្តទស្សនកិច្ចណាមួយទេ ដូច្នេះវាស្ថិតនៅក្រោមអប្បបរមា {min}។ បន្ថែមទៅវដ្តទស្សនកិច្ច ឬពន្យល់ការខ្វះខាតមុនពេលដាក់ស្នើ។ | ពួកវានៅក្នុងផែនការប្រចាំខែ ប៉ុន្តែមិនស្ថិតក្នុងវដ្តទស្សនកិច្ចណាមួយទេ ដូច្នេះពួកវាស្ថិតនៅក្រោមអប្បបរមា {min}។ បន្ថែមទៅវដ្តទស្សនកិច្ច ឬពន្យល់ការខ្វះខាតមុនពេលដាក់ស្នើ។",
          "visits-month": "ដង/ខែ",
          "chk": "{purpose} ដែលបានជ្រើស អនុវត្តបញ្ជីត្រួតពិនិត្យស្តង់ដារពី {library}។ ជំហានទី 3 នៅតែជាប្រតិទិនប្រចាំខែពេញលេញដែលមានសិទ្ធិអំណាច។",
          "chk-purpose": "គោលបំណងចុះទស្សនកិច្ច",
          "chk-library": "បណ្ណាល័យភារកិច្ចមេនៃការគ្រប់គ្រងការងារ",
          "bulk-select": "ជ្រើសវដ្ត",
          "bulk-clear": "សម្អាត",
          "bulk-count": "បានជ្រើស {n}",
          "bulk-priority": "អាទិភាព…",
          "bulk-purpose": "គោលបំណង…",
          "bulk-window": "ចន្លោះពេល…",
          "bulk-min": "នាទី",
          "bulk-dur": "រយៈពេលប៉ាន់ស្មាន (នាទី) សម្រាប់ហាងដែលបានជ្រើស",
          "bulk-remove": "ដកចេញពីវដ្តនេះ",
          "bulk-field": {
            "priority": "អាទិភាព",
            "purpose": "គោលបំណងចុះទស្សនកិច្ច (បញ្ជីត្រួតពិនិត្យធ្វើតាមដោយស្វ័យប្រវត្តិ)",
            "window": "ចន្លោះពេលដែលពេញចិត្ត",
            "dur": "រយៈពេលប៉ាន់ស្មាន"
          },
          "bulk-confirm": "ដកហាង {n} ដែលបានជ្រើសចេញពីវដ្តទស្សនកិច្ច {k}? | ដកហាង {n} ដែលបានជ្រើសចេញពីវដ្តទស្សនកិច្ច {k}?",
          "bulk-confirm-text": "វដ្តទស្សនកិច្ចផ្សេងទៀត និងការចាត់ហាងប្រចាំខែ នៅតែមិនផ្លាស់ប្តូរ។",
          "keep": "រក្សាទុក",
          "cancel": "បោះបង់",
          "close": "បិទ",
          "conflict": "{date} ពេញហើយ ({used} / {cap})។",
          "conflict-text": "ជ្រើសកាលបរិច្ឆេទផ្សេងទៀត ឬកត់ត្រាករណីលើកលែងសមត្ថភាពសម្រាប់កាលបរិច្ឆេទនោះ ដោយមានហេតុផលសវនកម្ម។",
          "conflict-why": "ហេតុផលលើកលែង",
          "conflict-apply": "បង្កើនកាលបរិច្ឆេទនេះ 1",
          "add": "បន្ថែមទៅវដ្តទស្សនកិច្ច {k}",
          "add-label": "ហាងដែលត្រូវបន្ថែមទៅវដ្តទស្សនកិច្ច {k}",
          "add-none": "ហាងទាំងអស់ក្នុងផែនការប្រចាំខែនេះ មាននៅក្នុងវដ្តទស្សនកិច្ច {k} រួចហើយ។",
          "note": {
            "copied-next": "✓ ហាង ហាងចាប់ផ្តើម និងលំដាប់ចុះទស្សនកិច្ចនៃវដ្តទស្សនកិច្ច {from} ត្រូវបានអនុវត្តទៅវដ្តទស្សនកិច្ច {to}។ កាលបរិច្ឆេទថ្មីត្រូវបានណែនាំពីថ្ងៃចុះទស្សនកិច្ច និងសមត្ថភាពដែលមាននៃវដ្តគោលដៅនីមួយៗ។",
            "copied-all": "✓ ហាង ហាងចាប់ផ្តើម និងលំដាប់ចុះទស្សនកិច្ចនៃវដ្តទស្សនកិច្ច {from} ត្រូវបានអនុវត្តទៅវដ្តដែលនៅសល់ {n}។ កាលបរិច្ឆេទថ្មីត្រូវបានណែនាំពីថ្ងៃចុះទស្សនកិច្ច និងសមត្ថភាពដែលមាននៃវដ្តគោលដៅនីមួយៗ។ | ✓ ហាង ហាងចាប់ផ្តើម និងលំដាប់ចុះទស្សនកិច្ចនៃវដ្តទស្សនកិច្ច {from} ត្រូវបានអនុវត្តទៅវដ្តដែលនៅសល់ {n}។ កាលបរិច្ឆេទថ្មីត្រូវបានណែនាំពីថ្ងៃចុះទស្សនកិច្ច និងសមត្ថភាពដែលមាននៃវដ្តគោលដៅនីមួយៗ។",
            "reset-all": "✓ វដ្តទស្សនកិច្ចត្រូវបានកំណត់ឡើងវិញទៅការណែនាំដើមរបស់ប្រព័ន្ធ។",
            "select-first": "ជ្រើសហាងជាមុនសិន — ការផ្លាស់ប្តូរជាក្រុមអនុវត្តតែចំពោះហាងដែលបានជ្រើស។",
            "remove-first": "ជ្រើសហាងជាមុនសិន — ការដកចេញអនុវត្តតែចំពោះវដ្តទស្សនកិច្ចសកម្ម។",
            "bulk-set": "✓ {field} ត្រូវបានធ្វើបច្ចុប្បន្នភាពសម្រាប់ហាង {n} ដែលបានជ្រើស — ការប៉ាន់ស្មាន បន្ទុកការងារ និងសមត្ថភាពត្រូវបានគណនាឡើងវិញ។ ហាងដែលមិនបានជ្រើសរក្សាតម្លៃរបស់ខ្លួន។ | ✓ {field} ត្រូវបានធ្វើបច្ចុប្បន្នភាពសម្រាប់ហាង {n} ដែលបានជ្រើស — ការប៉ាន់ស្មាន បន្ទុកការងារ និងសមត្ថភាពត្រូវបានគណនាឡើងវិញ។ ហាងដែលមិនបានជ្រើសរក្សាតម្លៃរបស់ខ្លួន។",
            "bulk-removed": "✓ ហាង {n} ដែលបានជ្រើស ត្រូវបានដកចេញពីវដ្តទស្សនកិច្ច {k} តែប៉ុណ្ណោះ។ វដ្តផ្សេងទៀតមិនផ្លាស់ប្តូរទេ។ | ✓ ហាង {n} ដែលបានជ្រើស ត្រូវបានដកចេញពីវដ្តទស្សនកិច្ច {k} តែប៉ុណ្ណោះ។ វដ្តផ្សេងទៀតមិនផ្លាស់ប្តូរទេ។",
            "cand-first": "ជ្រើសហាងដែលបានចាត់មួយ ឬច្រើនជាមុនសិន។",
            "cand-added": "✓ បានបន្ថែមហាងដែលបានចាត់ {n}។ ហាងដែលបានជ្រើសដំបូងគឺជាចំណុចចាប់ផ្តើមផ្លូវ; ប្រើការគ្រប់គ្រងលំដាប់ដើម្បីប្តូរវាពេលក្រោយ។ | ✓ បានបន្ថែមហាងដែលបានចាត់ {n}។ ហាងដែលបានជ្រើសដំបូងគឺជាចំណុចចាប់ផ្តើមផ្លូវ; ប្រើការគ្រប់គ្រងលំដាប់ដើម្បីប្តូរវាពេលក្រោយ។",
            "cand-added-map": "✓ បានបន្ថែមហាងដែលបានចាត់ {n} ពីផែនទី។ ហាងដែលបានជ្រើសដំបូងគឺជាចំណុចចាប់ផ្តើមផ្លូវ; ប្រើការគ្រប់គ្រងលំដាប់ដើម្បីប្តូរវាពេលក្រោយ។ | ✓ បានបន្ថែមហាងដែលបានចាត់ {n} ពីផែនទី។ ហាងដែលបានជ្រើសដំបូងគឺជាចំណុចចាប់ផ្តើមផ្លូវ; ប្រើការគ្រប់គ្រងលំដាប់ដើម្បីប្តូរវាពេលក្រោយ។",
            "reset-part-order": "✓ លំដាប់ហាងនៃវដ្តទស្សនកិច្ច {k} ត្រូវបានកំណត់ឡើងវិញ។ ហាងទាំងអស់នៅតែក្នុងវដ្តនេះ។",
            "reset-part-dates": "✓ កាលបរិច្ឆេទនៃវដ្តទស្សនកិច្ច {k} ត្រូវបានកំណត់ឡើងវិញ។ ហាងទាំងអស់នៅតែក្នុងវដ្តនេះ។",
            "reset-part-both": "✓ លំដាប់ហាង និងកាលបរិច្ឆេទនៃវដ្តទស្សនកិច្ច {k} ត្រូវបានកំណត់ឡើងវិញ។ ហាងទាំងអស់នៅតែក្នុងវដ្តនេះ។"
          },
          "cand-title": "ហាងដែលបានចាត់ និងអាចជ្រើសបាន",
          "cand-hint": "ហាងដែលបានចាត់ទាំងអស់ដែលមិនទាន់ជ្រើស នៅតែជាបេក្ខភាព។",
          "cand-n": "មាន {n}",
          "cand-assigned": "ហាងដែលបានចាត់",
          "cand-add": "បន្ថែមដែលបានជ្រើស ({n})",
          "cand-add-hint": "ជ្រើសមួយដើម្បីបន្ថែមតែមួយ ឬជ្រើសច្រើនដើម្បីបន្ថែមជាមួយគ្នា។",
          "cand-nogeo": "កូអរដោនេហាងដែលបានចាត់មិនមានទេ; ប្រើបញ្ជីបេក្ខភាព។",
          "cand-map": "បន្ថែមពីផែនទី",
          "cand-map-hint": "ជ្រើសម្ជុលហាងដែលបានចាត់ បន្ទាប់មកបន្ថែមទៅផែនការនេះ។",
          "cand-map-add": "បន្ថែមដែលបានជ្រើសពីផែនទី",
          "select": "ជ្រើស",
          "deselect": "ដកការជ្រើស",
          "include": "រួមបញ្ចូល",
          "exclude": "ដកចេញ",
          "map-note-edit": "— ចុចម្ជុលណាមួយដើម្បីរួមបញ្ចូល ឬដកចេញ · ជំហានទី 3 នៅតែជាប្រតិទិនប្រចាំខែតាមកាលបរិច្ឆេទដែលមានសិទ្ធិអំណាច",
          "map-note-read": "— ការពិនិត្យផ្លូវដែលបានដាក់ស្នើ (អានតែប៉ុណ្ណោះ) · ជំហានទី 3 នៅតែជាប្រតិទិនប្រចាំខែតាមកាលបរិច្ឆេទដែលមានសិទ្ធិអំណាច",
          "spill": "ថ្ងៃដែលមានបន្ទាប់ពីចន្លោះ",
          "why": {
            "step1": "មិនមែនជាថ្ងៃចុះទស្សនកិច្ចក្នុងជំហានទី 1",
            "step1-off": "ការងារផ្សេងក្នុងជំហានទី 1",
            "step1-comp": "ការសម្រាកជំនួស",
            "unavailable": "ហាងមិនអាចចូលបាន",
            "before-prev": "មុនចំណុចផ្លូវមុន",
            "after-next": "ក្រោយចំណុចផ្លូវបន្ទាប់",
            "too-close": "ជិតពេកនឹងវដ្ត {k}",
            "too-soon": "ឆាប់ពេកក្រោយវដ្ត {k}",
            "full": "សមត្ថភាពប្រចាំថ្ងៃពេញ",
            "before-window": "មុនចន្លោះវដ្ត",
            "outside-window": "ក្រៅចន្លោះវដ្ត",
            "other": "មិនអាចប្រើបាន"
          },
          "reset-cycle": "កំណត់វដ្តឡើងវិញ",
          "reset-cycle-title": "កំណត់វដ្តទស្សនកិច្ច {k} ឡើងវិញ",
          "reset-cycle-text": "ជ្រើសអ្វីដែលត្រូវកំណត់ឡើងវិញ។ ហាងទាំងអស់នៅតែក្នុងវដ្តនេះ។",
          "reset-order": "លំដាប់ហាង",
          "reset-dates": "កាលបរិច្ឆេទ",
          "reset-both": "លំដាប់ហាង និងកាលបរិច្ឆេទ",
          "selected": "បានជ្រើស",
          "date-for": "កាលបរិច្ឆេទចុះទស្សនកិច្ចសម្រាប់ {name}",
          "pick-date": "ជ្រើសកាលបរិច្ឆេទ",
          "picker-title": "ជ្រើសកាលបរិច្ឆេទ · {name}",
          "picker-hint": "អាចជ្រើសបានតែកាលបរិច្ឆេទដែលមានពីជំហានទី 1 ប៉ុណ្ណោះ។ លំដាប់ផ្លូវ និងសមត្ថភាពប្រចាំថ្ងៃក៏អនុវត្តដែរ។",
          "pick": {
            "ok": "កាលបរិច្ឆេទចុះទស្សនកិច្ចដែលមាន",
            "step1": "មិនមានក្នុងជំហានទី 1",
            "outlet": "ហាងមិនអាចចូលបាន",
            "before-prev": "មុនចំណុចផ្លូវមុន",
            "after-next": "ក្រោយចំណុចផ្លូវបន្ទាប់",
            "before-next-cycle": "មុនរយៈពេលវដ្តប្រាំពីរថ្ងៃបន្ទាប់របស់ហាង",
            "overlaps-next": "ត្រួតនឹងរយៈពេលវដ្តបន្ទាប់ដែលបានជ្រើសរបស់ហាង",
            "full": "សមត្ថភាពប្រចាំថ្ងៃពេញ"
          },
          "tbl": {
            "label": "ហាងនៃវដ្តទស្សនកិច្ច {k}",
            "select": "ជ្រើស",
            "select-row": "ជ្រើស {name}",
            "order": "លំដាប់",
            "outlet": "ហាង",
            "promoter": "អ្នកផ្សព្វផ្សាយ",
            "priority": "អាទិភាព",
            "purpose": "គោលបំណងចុះទស្សនកិច្ច",
            "date-proposed": "កាលបរិច្ឆេទចុះទស្សនកិច្ចដែលបានស្នើ",
            "date-scheduled": "កាលបរិច្ឆេទចុះទស្សនកិច្ចដែលបានកំណត់",
            "capacity": "សមត្ថភាព",
            "window": "ចន្លោះពេល",
            "min": "នាទី",
            "planned": "បានគ្រោង / ខែ",
            "actions": "សកម្មភាពជួរ",
            "start": "ចាប់ផ្តើម",
            "carry": "អាទិភាពបន្តពីខែមុន",
            "tasks": "ភារកិច្ច",
            "not-scheduled": "មិនទាន់កំណត់",
            "slots-left": "នៅសល់ {n} ចន្លោះ | នៅសល់ {n} ចន្លោះ",
            "dur": "រយៈពេល (នាទី)",
            "est": "ប៉ាន់ស្មាន {n} នាទី",
            "suggest": "ណែនាំ {n}",
            "unresolved": "កំណែភារកិច្ចមិនទាន់ដោះស្រាយ — {text}",
            "legacy": "ចាស់ · {why} — រក្សាតាមដែលបានកត់ត្រា",
            "review": "សំណុំភារកិច្ចបានផ្លាស់ប្តូរ —",
            "keep": "រក្សា {v}",
            "use": "ប្រើ {v}",
            "use-suggestion": "ប្រើការណែនាំ",
            "below-recorded": "ក្រោមការប៉ាន់ស្មាន {n} នាទី — ហេតុផលកត់ត្រាដោយ {by} នៅ {at}៖ {reason}",
            "below-required": "ក្រោមការប៉ាន់ស្មាន {n} នាទី — តម្រូវឱ្យមានការពន្យល់",
            "below-why": "ហេតុអ្វីរយៈពេលដែលបានគ្រោងទាបជាងការប៉ាន់ស្មាន?",
            "minimum": "អប្បបរមា {n}",
            "earlier": "ផ្លាស់ទីមុន",
            "later": "ផ្លាស់ទីក្រោយ",
            "remove": "ដកចេញពីវដ្តទស្សនកិច្ចនេះតែប៉ុណ្ណោះ",
            "tasks-from": "ភារកិច្ច {n} ពីបណ្ណាល័យភារកិច្ចមេនៃការគ្រប់គ្រងការងារ",
            "empty": "វដ្តទស្សនកិច្ចនេះមិនមានហាងទេ។ បន្ថែមមួយខាងក្រោម ឬចម្លងរចនាសម្ព័ន្ធពីវដ្តមុន។"
          },
          "regen-title": "✓ ការមើលកាលវិភាគជាមុនត្រូវបានបង្កើតឡើងវិញ",
          "regen": "— ប្រតិទិនខាងក្រោមគណនាឡើងវិញពីវដ្តទស្សនកិច្ច កាលបរិច្ឆេទស្នើ ការងារហាង សមត្ថភាព និងករណីលើកលែងប្រតិទិនដែលបានអនុម័តបច្ចុប្បន្ន។"
        }
      },
      "phone": {
        "label": "របៀបការងារវាល",
        "tag": "គំរូសាកល្បង · របៀបការងារវាល",
        "close": "បិទរបៀបការងារវាល",
        "today": "ថ្ងៃនេះ · {date}",
        "promoter": "អ្នកផ្សព្វផ្សាយ {name}",
        "no-stops": "គ្មានចំណតថ្ងៃនេះទេ។",
        "back": "‹ ផ្លូវ",
        "check-in": "ចុះវត្តមាននៅហាង",
        "combined": "ការចុះពិនិត្យរួមបញ្ចូលគ្នា",
        "combined-union": "សំណុំកិច្ចការដែលបានអនុម័ត (ដកស្ទួន {n}) | សំណុំកិច្ចការដែលបានអនុម័ត (ដកស្ទួន {n})",
        "dur": "~{n} នាទី",
        "window": "ចន្លោះពេល {w}",
        "feed-label": "ទិន្នន័យពីការគ្រប់គ្រងការងារ៖",
        "feed": "កិច្ចការគ្រោងទុក {n} | កិច្ចការគ្រោងទុក {n}",
        "feed-added": " + បន្ថែមនៅវាល {n}",
        "flow": {
          "label": "ជំហានអនុវត្តការងារវាល",
          "checkin": "✓ ចុះវត្តមាន",
          "review": "2 ពិនិត្យ {a}/{b}",
          "tasks": "3 កិច្ចការ {a}/{b}",
          "followup": "4 តាមដាន",
          "clockout": "5 ចេញ"
        },
        "sec": {
          "prior": "2. ការតាមដានពីមុន · បានពិនិត្យ {a}/{b}",
          "planned": "3. កិច្ចការគ្រោងទុកថ្ងៃនេះ · បានបញ្ចប់ {a}/{b}",
          "added": "កិច្ចការបន្ថែម · បានបញ្ចប់ {a}/{b}",
          "followup": "4. បន្ថែមចំណុចតាមដាន ឬកែលម្អ"
        },
        "prior-empty": "គ្មានការតាមដានដែលមិនទាន់ដោះស្រាយពីការចុះពិនិត្យមុននៅហាងនេះទេ។",
        "added-empty": "បន្ថែមតែនៅពេលត្រូវការការងារបន្ថែមក្នុងការចុះពិនិត្យនេះប៉ុណ្ណោះ។",
        "add-task": "＋ បន្ថែមកិច្ចការពីការគ្រប់គ្រងការងារ…",
        "add-action": "＋ បន្ថែមសកម្មភាពគ្រប់គ្រងការងារ",
        "created": "បានបង្កើតក្នុងការចុះពិនិត្យនេះ៖",
        "notes": "កំណត់ចំណាំការចុះពិនិត្យ / ប្រធានបទណែនាំ",
        "wm-hint": "ការរកឃើញ ឬការប្តេជ្ញាអាចបង្កើត {wm} នៅពេលចេញ (ការរកឃើញដែលបានដាក់ទង់ធ្វើដូច្នេះដោយស្វ័យប្រវត្តិ)។ កំណត់ចំណាំណែនាំនៅតែជាភស្តុតាងនៃការសង្កេត — មិនមែនជាការវាយតម្លៃលទ្ធផលការងារដោយស្វ័យប្រវត្តិទេ។",
        "wm-hint-action": "សកម្មភាពគ្រប់គ្រងការងារ",
        "ready": "រួចរាល់សម្រាប់បញ្ចប់",
        "ready-tail": " · បញ្ជីត្រួតពិនិត្យ និងភស្តុតាងចាំបាច់បានបំពេញរួច។",
        "incomplete": "ការចុះពិនិត្យនៅមិនទាន់បញ្ចប់",
        "complete": "ចេញ និងបញ្ចប់",
        "complete-title": "សូមបំពេញបញ្ជីត្រួតពិនិត្យ និងភស្តុតាងដែលត្រូវការជាមុនសិន",
        "flag-placeholder": "បញ្ហាដែលបានសង្កេត (មូលហេតុដាក់ទង់ដោយដៃ)",
        "complete-flag": "បញ្ចប់ + ដាក់ទង់",
        "closed": "ការចុះពិនិត្យ {status}{flag}។ ពិន្ទុ {score}។",
        "closed-flag": " — បានដាក់ទង់៖ {reasons}",
        "vstatus": {
          "planned": "បានគ្រោងទុក",
          "scheduled": "បានកំណត់ពេល",
          "inprogress": "កំពុងដំណើរការ",
          "completed": "បានបញ្ចប់",
          "cancelled": "បានលុបចោល"
        },
        "task": {
          "min": "{n} នាទី",
          "evidence": {
            "photo": "ត្រូវការរូបថត",
            "note": "ត្រូវការកំណត់ចំណាំ",
            "none": "មិនត្រូវការឯកសារភ្ជាប់"
          },
          "source": {
            "planned": " · បានគ្រោងទុក",
            "additional": " · បន្ថែមនៅវាល"
          },
          "remove": "ដកកិច្ចការដែលបានបន្ថែមចេញ",
          "complete": "បញ្ចប់",
          "issue": "រកឃើញបញ្ហា",
          "note-issue": "រៀបរាប់បញ្ហា និងសកម្មភាពបន្ទាប់",
          "note-required": "កំណត់ចំណាំកិច្ចការដែលត្រូវការ",
          "add-photo": "📷 បន្ថែមរូបថតភស្តុតាង"
        },
        "photo": {
          "remove": "ដករូបថតភស្តុតាងចេញ",
          "source": {
            "camera": "ថតដោយកាមេរ៉ា",
            "library": "ជ្រើសពីបណ្ណាល័យរូបថត"
          },
          "status": {
            "active": "សកម្ម",
            "superseded": "ត្រូវបានជំនួស",
            "failed": "បរាជ័យ",
            "purged": "បានលុបចោល"
          }
        },
        "retention": {
          "pending-config": "ការរក្សាទុកកំពុងរង់ចាំការកំណត់",
          "held": "ការរក្សាទុកស្ថិតក្រោមការឃាត់ទុកផ្លូវច្បាប់ — កាលបរិច្ឆេទដើម {date}",
          "pending": "កំពុងរង់ចាំ",
          "pending-anchor": "ការរក្សាទុកចាប់ផ្តើមនៅពេលកំណត់ត្រានេះបិទ",
          "set": "រក្សាទុករហូតដល់ {date}"
        },
        "fu": {
          "meta": "{id} · ពី {from} · កំណត់ {due}",
          "previous-visit": "ការចុះពិនិត្យមុន",
          "overdue": "ហួសកំណត់",
          "evidence-required": "ត្រូវការភស្តុតាង",
          "outcome": {
            "placeholder": "កត់ត្រាបច្ចុប្បន្នភាពថ្ងៃនេះ…",
            "completed": "បានបញ្ចប់ថ្ងៃនេះ — ផ្ញើឱ្យប្រធានផ្ទៀងផ្ទាត់",
            "progress": "មានវឌ្ឍនភាព — បន្តបើក",
            "blocked": "ជាប់គាំង — បន្តបើក",
            "not-applicable": "មិនអនុវត្តក្នុងការចុះពិនិត្យនេះ"
          },
          "note": "បច្ចុប្បន្នភាពដែលត្រូវការ៖ អ្វីដែលបានធ្វើ នៅសល់ ឬជាប់គាំង",
          "add-evidence": "📷 បន្ថែមភស្តុតាងនៃការបញ្ចប់"
        },
        "fu-status": {
          "open": "បើក",
          "inprogress": "កំពុងដំណើរការ",
          "submitted": "បានដាក់ជូនផ្ទៀងផ្ទាត់",
          "reopened": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ",
          "resolved": "បានផ្ទៀងផ្ទាត់"
        },
        "form": {
          "kind-label": "ប្រភេទសកម្មភាព",
          "kind": {
            "follow-up": "តាមដាន",
            "improvement": "កែលម្អ",
            "issue": "បញ្ហា"
          },
          "kind-hint": "ប្រភេទមានរចនាសម្ព័ន្ធ (PO-D19) — “ការលើកឡើង” គឺជាលក្ខខណ្ឌលំហូរការងារ មិនមែនជាប្រភេទទេ។",
          "desc": "តើត្រូវធ្វើអ្វីបន្ទាប់?",
          "task-label": "កិច្ចការភ្ជាប់",
          "no-task": "គ្មានការភ្ជាប់កិច្ចការ (បរិបទប្រភពត្រូវបានកត់ត្រាថាខ្វះ)",
          "critical": "ការរកឃើញប្រភពគឺធ្ងន់ធ្ងរ",
          "due-title": "ទុកទទេសម្រាប់កាលកំណត់លំនាំដើមតាមគោលការណ៍ (ខ្ពស់ +3 · ធម្មតា +5 ថ្ងៃធ្វើការ — PO-D20)",
          "create": "បង្កើតសកម្មភាព",
          "cancel": "បោះបង់"
        },
        "sheet": {
          "title": "បន្ថែមរូបថតភស្តុតាង",
          "evidence": "ភស្តុតាង",
          "cancel": "បោះបង់ការថតរូប",
          "camera": "📷 ថតរូប",
          "library": "▧ ជ្រើសពីបណ្ណាល័យរូបថត",
          "lib-reason": "ត្រូវការ ប្រសិនបើអ្នកជ្រើសពីបណ្ណាល័យ៖ ហេតុអ្វីមិនមែនជារូបថតពីកាមេរ៉ា?",
          "help": "{camera} ត្រូវបានណែនាំសម្រាប់ភស្តុតាងផ្ទាល់។ រូបភាពពីបណ្ណាល័យត្រូវបានអនុញ្ញាត {reason} ត្រូវបានដាក់ស្លាកយ៉ាងច្បាស់ក្នុងកំណត់ត្រាសវនកម្ម ហើយបំពេញតម្រូវការពេញលេញ។ បើគ្មានមូលហេតុ កិច្ចការនៅតែមិនទាន់បញ្ចប់ — ការចុះពិនិត្យមិនបរាជ័យទេ។",
          "help-camera": "កាមេរ៉ា",
          "help-reason": "ជាមួយមូលហេតុមួយបន្ទាត់"
        },
        "toast": {
          "done": "✓ ការចុះពិនិត្យបានបញ្ចប់",
          "flagged": "ការចុះពិនិត្យបានបញ្ចប់ — បានដាក់ទង់ ({sev}) · ត្រូវការការតាមដាន",
          "synced": "បានធ្វើសមកាលកម្មកំណត់ត្រាទីតាំង {n} | បានធ្វើសមកាលកម្មកំណត់ត្រាទីតាំង {n}",
          "nothing": "គ្មានអ្វីរង់ចាំទេ — បានធ្វើសមកាលកម្មរួចហើយ។"
        },
        "issues": {
          "tasks": "ធាតុបញ្ជីត្រួតពិនិត្យការគ្រប់គ្រងការងារ {n} មិនទាន់បញ្ចប់ | ធាតុបញ្ជីត្រួតពិនិត្យការគ្រប់គ្រងការងារ {n} មិនទាន់បញ្ចប់",
          "photos": "ខ្វះរូបថតចុះពិនិត្យដែលត្រូវការ {n} | ខ្វះរូបថតចុះពិនិត្យដែលត្រូវការ {n}",
          "photos-lib": "ខ្វះរូបថតចុះពិនិត្យដែលត្រូវការ {n} ({lib} កំពុងរង់ចាំមូលហេតុជ្រើសពីបណ្ណាល័យ) | ខ្វះរូបថតចុះពិនិត្យដែលត្រូវការ {n} ({lib} កំពុងរង់ចាំមូលហេតុជ្រើសពីបណ្ណាល័យ)",
          "notes": "ខ្វះកំណត់ចំណាំកិច្ចការដែលត្រូវការ {n} | ខ្វះកំណត់ចំណាំកិច្ចការដែលត្រូវការ {n}",
          "unreviewed": "ការតាមដានពីមុន {n} មិនទាន់បានពិនិត្យ | ការតាមដានពីមុន {n} មិនទាន់បានពិនិត្យ",
          "update-notes": "ខ្វះកំណត់ចំណាំបច្ចុប្បន្នភាពការតាមដាន {n} | ខ្វះកំណត់ចំណាំបច្ចុប្បន្នភាពការតាមដាន {n}",
          "update-evidence": "ខ្វះភស្តុតាងការតាមដានដែលបានបញ្ចប់ {n} | ខ្វះភស្តុតាងការតាមដានដែលបានបញ្ចប់ {n}"
        },
        "sim": {
          "title": "កម្មវិធីក្លែងទីតាំងគំរូ — គ្មាន GPS ពិតនៅក្នុង V6",
          "inside": "នៅហាង",
          "edge": "ជិតព្រំដែន",
          "far": "ឆ្ងាយពីហាង",
          "weak": "សញ្ញាខ្សោយ",
          "denied": "ការអនុញ្ញាតត្រូវបានបដិសេធ",
          "none": "គ្មានទីតាំង",
          "offline": "ក្លែងឧបករណ៍គ្មានអ៊ីនធឺណិត — ការថតនៅតែរង់ចាំសមកាលកម្ម"
        },
        "geo": {
          "state": {
            "unconfigured": "មិនទាន់កំណត់",
            "permission-denied": "ការអនុញ្ញាតត្រូវបានបដិសេធ",
            "no-fix": "គ្មានទីតាំង",
            "low-confidence": "ភាពជឿជាក់ទាប",
            "inside": "នៅខាងក្នុង",
            "outside": "នៅខាងក្រៅ",
            "boundary-uncertainty": "មិនប្រាកដនៅព្រំដែន",
            "not-captured": "មិនបានកត់ត្រា / មិនពាក់ព័ន្ធ"
          },
          "source": {
            "site": "ទីតាំង",
            "project": "គម្រោង"
          },
          "nums": {
            "distance": "ចម្ងាយ {n} ម",
            "accuracy": "ភាពត្រឹមត្រូវ ±{n} ម",
            "radius": "កាំ {n} ម",
            "none": "គ្មានចម្ងាយ ភាពត្រឹមត្រូវ ឬកាំត្រូវបានកត់ត្រាសម្រាប់ស្ថានភាពនេះទេ — គ្មានអ្វីត្រូវបានសន្មត់ទេ។"
          },
          "reason": "ត្រូវការមូលហេតុ — បន្ទាប់មកសកម្មភាពត្រូវបានអនុញ្ញាត និងដាក់ទង់",
          "foot": "ទីតាំងក្លែង · ការគ្រប់គ្រងទន់ V6 ប៉ុណ្ណោះ មិនដែលរារាំងទេ · មិនមែនជាកំណត់ត្រាវត្តមានទេ។",
          "why": {
            "no-coords": "គ្មានកូអរដោនេហាងក្នុងបញ្ជីមេទីតាំង/ហាង",
            "no-radius": "គ្មានកាំរបងភូមិសាស្ត្រហាង ហើយគ្មានកាំបម្រុងរបស់គម្រោងត្រូវបានកំណត់យ៉ាងច្បាស់ទេ",
            "no-threshold": "គ្មានកម្រិតភាពត្រឹមត្រូវរបស់គម្រោងត្រូវបានកំណត់យ៉ាងច្បាស់ទេ",
            "denied": "ការអនុញ្ញាតទីតាំងត្រូវបានបដិសេធនៅលើឧបករណ៍",
            "no-fix": "មិនមានការអានទីតាំងទេ",
            "no-distance": "មិនអាចគណនាចម្ងាយទៅហាងបានទេ",
            "inside": "ទីតាំងដែលបានរាយការណ៍ និងរង្វង់ភាពត្រឹមត្រូវស្ថិតនៅខាងក្នុងរបងភូមិសាស្ត្ររបស់ហាងទាំងស្រុង",
            "outside": "ទីតាំងដែលបានរាយការណ៍ និងរង្វង់ភាពត្រឹមត្រូវស្ថិតនៅខាងក្រៅរបងភូមិសាស្ត្ររបស់ហាងទាំងស្រុង",
            "boundary": "រង្វង់ភាពត្រឹមត្រូវត្រួតលើព្រំដែនរបងភូមិសាស្ត្រ — វត្តមានមិនអាចបញ្ជាក់ ឬបដិសេធបានទេ",
            "low": "ភាពត្រឹមត្រូវដែលបានរាយការណ៍ ±{acc} ម លើសកម្រិតដែលបានកំណត់ {thr} ម"
          },
          "rec": {
            "checkin": "ទីតាំងចុះវត្តមាន",
            "checkout": "ទីតាំងចេញ",
            "pending": "រង់ចាំសមកាលកម្ម",
            "synced": "បានធ្វើសមកាលកម្ម",
            "flagged": "បានដាក់ទង់",
            "captured": "បានកត់ត្រា {at}",
            "synced-at": "បានធ្វើសមកាលកម្ម {at}",
            "reason": "មូលហេតុ៖ {r}",
            "sync-now": "ធ្វើសមកាលកម្មឥឡូវ",
            "none-title": "ទីតាំង៖ {label}",
            "none-body": "កំណត់ត្រានេះមានមុនការកត់ត្រារបងភូមិសាស្ត្រ ឬត្រូវបានបង្កើតដោយប្រព័ន្ធ — គ្មានការវាយតម្លៃទេ។ នោះជាប្រភពដើម មិនមែនជាករណីលើកលែងទេ។"
          }
        }
      },
      "sla": {
        "state": {
          "ok": "តាមគម្រោង",
          "reminder": "ជិតដល់កំណត់",
          "urgent": "បន្ទាន់ — ផុតកំណត់ថ្ងៃនេះ",
          "breached": "ហួសកំណត់",
          "escalated": "បានបញ្ជូនបន្ត",
          "met": "សម្រេច",
          "met-late": "សម្រេចយឺត",
          "met-offline": "សម្រេច · ធ្វើសមកាលកម្មក្រៅបណ្ដាញ"
        },
        "wd": "{n} ថ្ងៃធ្វើការ",
        "by": "ត្រឹម {date}",
        "sync-pending": "រង់ចាំសមកាលកម្ម",
        "paused": "ផ្អាក (ច្បាប់ឈប់សម្រាកបានអនុម័ត)",
        "policy": "គោលការណ៍ {ref}",
        "capped": "គោលដៅត្រូវបានកំណត់ពិដាន",
        "legacy": "កំណត់ត្រាចាស់",
        "label": {
          "due": "កំណត់",
          "resp": "ឆ្លើយតប",
          "verify": "ផ្ទៀងផ្ទាត់",
          "response": "ការឆ្លើយតបដំបូង",
          "delivery": "ការបញ្ចប់",
          "verification": "ការផ្ទៀងផ្ទាត់",
          "acknowledge": "ទទួលស្គាល់"
        }
      },
      "actions": {
        "note": {
          "lead": "ការចុះពិនិត្យបានបញ្ចប់ ≠ បញ្ហាត្រូវបានដោះស្រាយ។",
          "a": "សកម្មភាពកែតម្រូវត្រូវបានគ្រប់គ្រង និងតាមដាននៅក្នុង",
          "wm": "ការគ្រប់គ្រងការងារ",
          "b": "។ អ្នកគ្រប់គ្រងដាក់ស្នើសកម្មភាពដែលបានធ្វើ និងភស្តុតាង; LM ផ្ទៀងផ្ទាត់ ឬបញ្ជូនត្រឡប់។ លទ្ធផលរកឃើញដើមនៃការចុះពិនិត្យមិនត្រូវបានសរសេរជាន់ឡើយ។"
        },
        "empty": "គ្មានសកម្មភាព។ លទ្ធផលរកឃើញដែលមានសញ្ញាព្រមាននឹងបង្កើតសកម្មភាពមួយដោយស្វ័យប្រវត្តិ។",
        "status": {
          "open": "បើក",
          "inprogress": "កំពុងដំណើរការ",
          "submitted": "បានដាក់ស្នើសម្រាប់ផ្ទៀងផ្ទាត់",
          "reopened": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ",
          "resolved": "បានផ្ទៀងផ្ទាត់"
        },
        "cols": {
          "action": "សកម្មភាព",
          "source": "ការចុះពិនិត្យដើម · ហាង",
          "owner": "ម្ចាស់ · កំណត់",
          "risk": "ហានិភ័យ",
          "sla": "SLA",
          "status": "ស្ថានភាព",
          "evidence": "ភស្តុតាង",
          "verification": "ការផ្ទៀងផ្ទាត់",
          "open": "បើកសកម្មភាព"
        },
        "kind": {
          "follow-up": "ការតាមដាន",
          "improvement": "ការកែលម្អ",
          "issue": "បញ្ហា"
        },
        "risk": {
          "High": "ខ្ពស់",
          "Normal": "ធម្មតា"
        },
        "overdue": "ហួសកំណត់",
        "evidence": {
          "required": "តម្រូវ",
          "supporting": "គាំទ្រ",
          "attached": "បានភ្ជាប់ {n}",
          "photo": "📷 រូបថតការកែតម្រូវ",
          "receipt": "＋ បង្កាន់ដៃដឹកជញ្ជូន",
          "ack": "＋ ការទទួលស្គាល់ពីហាង",
          "revisit": "＋ ភស្តុតាងការចុះពិនិត្យឡើងវិញ",
          "remove": "ដកចេញ",
          "none": "មិនទាន់មានភស្តុតាងការកែតម្រូវនៅឡើយ។"
        },
        "verification": {
          "pending": "កំពុងរង់ចាំការផ្ទៀងផ្ទាត់",
          "verified": "បានផ្ទៀងផ្ទាត់ {at}",
          "returned": "បានបញ្ជូនត្រឡប់ · {reason}",
          "returned-default": "បានបញ្ជូនត្រឡប់ · តម្រូវឱ្យកែតម្រូវ",
          "not-submitted": "មិនទាន់ដាក់ស្នើ"
        },
        "button": {
          "work": "ដោះស្រាយបញ្ហា",
          "continue": "បន្តការងារ",
          "correct": "កែតម្រូវ និងដាក់ស្នើឡើងវិញ",
          "view-submission": "មើលការដាក់ស្នើ",
          "view-record": "មើលកំណត់ត្រា",
          "review": "ពិនិត្យ",
          "view": "មើល"
        },
        "method": {
          "choose": "ជ្រើសរើសវិធីដោះស្រាយ…",
          "replenished": "បានជំនួស / បំពេញស្តុករួចរាល់",
          "revisit": "បានកែតម្រូវក្នុងការចុះពិនិត្យឡើងវិញ",
          "remote": "បានកែតម្រូវពីចម្ងាយជាមួយហាង",
          "late_evidence": "បានផ្ដល់ភស្តុតាងដែលតម្រូវក្រោយការចុះពិនិត្យ",
          "exception": "ស្នើសុំការលើកលែងភស្តុតាង",
          "none": "—"
        },
        "basis": {
          "pinned-evidence": "កិច្ចការដែលបានខ្ទាស់តម្រូវឱ្យមានភស្តុតាង",
          "critical": "លទ្ធផលរកឃើញដើមត្រូវបានសម្គាល់ថាធ្ងន់ធ្ងរ",
          "issue": "ប្រភេទសកម្មភាពគឺបញ្ហា",
          "unavailable": "មិនមានប្រភពជារចនាសម្ព័ន្ធ — កំណត់ជាធម្មតា",
          "none-met": "មិនបំពេញលក្ខខណ្ឌខ្ពស់ណាមួយ"
        },
        "missing-item": {
          "pinned-task": "កិច្ចការដែលបានខ្ទាស់",
          "pinned-unresolved": "កំណែកិច្ចការដែលបានខ្ទាស់មិនទាន់កំណត់",
          "severity": "កម្រិតធ្ងន់ធ្ងរនៃលទ្ធផលរកឃើញ",
          "type": "ប្រភេទសកម្មភាព"
        },
        "drawer": {
          "aria": "សកម្មភាពកែតម្រូវ {id}",
          "eyebrow": "សកម្មភាពកែតម្រូវ · {id}",
          "meta": "{type} · ម្ចាស់ {owner} · កំណត់ {due}",
          "close": "បិទ",
          "separate-lead": "ការបញ្ចប់ការចុះពិនិត្យ និងការដោះស្រាយបញ្ហាគឺដាច់ដោយឡែកពីគ្នា។",
          "separate-body": "លទ្ធផលរកឃើញដើមនៃការចុះពិនិត្យមិនអាចផ្លាស់ប្ដូរបានទេ។ សកម្មភាពនេះបិទបានតែបន្ទាប់ពីការងារកែតម្រូវត្រូវបានដាក់ស្នើជាមួយភស្តុតាងដែលតម្រូវ ហើយត្រូវបាន LM ផ្ទៀងផ្ទាត់។",
          "source-title": "លទ្ធផលរកឃើញដើម",
          "visit": "ការចុះពិនិត្យ",
          "outlet": "ហាង",
          "visit-date": "កាលបរិច្ឆេទចុះពិនិត្យ",
          "type": "ប្រភេទ (ជារចនាសម្ព័ន្ធ)",
          "risk": "ហានិភ័យ (ជារចនាសម្ព័ន្ធ)",
          "pin": "កំណែកិច្ចការដែលបានខ្ទាស់",
          "severity": "កម្រិតធ្ងន់ធ្ងរនៃលទ្ធផលរកឃើញដើម",
          "critical": "ធ្ងន់ធ្ងរ",
          "not-critical": "មិនធ្ងន់ធ្ងរ",
          "executor": "អ្នកចុះពិនិត្យជាក់ស្ដែង",
          "executor-none": "មិនបានកត់ត្រា (ការចុះពិនិត្យមុន PO-D19)",
          "sla-title": "SLA · PO-D20 (ការត្រួតពិនិត្យទន់ — ការរំលោភនឹងព្រមាន បញ្ជូនបន្ត និងត្រូវបានធ្វើសវនកម្ម; វាមិនដែលរារាំង ឬសម្រេចដោយស្វ័យប្រវត្តិឡើយ)",
          "missing": "បរិបទប្រភពជារចនាសម្ព័ន្ធខ្វះនៅពេលបង្កើត៖ {list} — ហានិភ័យត្រូវបានកំណត់ពីរចនាសម្ព័ន្ធដែលមានតែប៉ុណ្ណោះ មិនដែលពីអត្ថបទសេរីឡើយ (PO-D19)។",
          "submissions": "ការដាក់ស្នើ {n} ត្រូវបានរក្សាទុក — ការបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវមិនដែលលុបការដាក់ស្នើ ឬភស្តុតាងមុនៗឡើយ (PO-D19)។",
          "returned": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ៖",
          "step1": "1 · តើបញ្ហាត្រូវបានដោះស្រាយដោយរបៀបណា?",
          "step2": "2 · សកម្មភាពដែលបានធ្វើ",
          "step2-ph": "អ្វីដែលបានធ្វើជាក់ស្ដែង (ឧ. បំពេញស្តុក 2 SKU, រៀបចំធ្នើឡើងវិញ)",
          "step3": "3 · កំណត់ចំណាំការដោះស្រាយ",
          "step3-ph": "ពិពណ៌នាអ្វីដែលបានកែតម្រូវ បរិមាណ/លទ្ធផល និងអ្នកដែលបានបញ្ជាក់។",
          "step4": "4 · ការកែតម្រូវបានបញ្ចប់នៅ",
          "step5": "5 · ភស្តុតាង",
          "required-pinned": "តម្រូវ — កំណែកិច្ចការដែលបានខ្ទាស់ {pin} (មិនអាចកាត់បន្ថយបាន)",
          "required": "តម្រូវ",
          "supporting": "(ភស្តុតាងគាំទ្រ)",
          "exception-lead": "ការលើកលែងមិនបិទបញ្ហាដោយស្វ័យប្រវត្តិទេ។",
          "exception-body": "ពន្យល់ពីមូលហេតុដែលមិនអាចទទួលបានភស្តុតាង។ LM អាចទទួលយកការលើកលែង ឬតម្រូវឱ្យចុះពិនិត្យឡើងវិញ។",
          "cannot-submit": "មិនអាចដាក់ស្នើបាន៖",
          "submitted-title": "សកម្មភាពកែតម្រូវដែលបានដាក់ស្នើ",
          "action-performed": "សកម្មភាពដែលបានធ្វើ៖",
          "completed": "បានបញ្ចប់ {on} · បានដាក់ស្នើ {at}",
          "submitted-evidence": "ភស្តុតាងដែលបានដាក់ស្នើ",
          "no-file": "គ្មានឯកសារភស្តុតាង — បានស្នើសុំការលើកលែងភស្តុតាង។",
          "verified-lead": "បានផ្ទៀងផ្ទាត់",
          "verified-body": "— ស្ថានភាពអាជីវកម្មចុងក្រោយ · {at} · ដោយ {by}{via}{note}",
          "via": {
            "direct-line": "ខ្សែផ្ទាល់",
            "designated": "បានចាត់តាំង"
          },
          "reopen-rule": "ការបើកឡើងវិញតម្រូវឱ្យមានសកម្មភាពកែតម្រូវថ្មីដែលភ្ជាប់គ្នា (PO-D19)។",
          "linked": "សកម្មភាពបន្តដែលភ្ជាប់៖ {ids}",
          "follow-on": "បង្កើតសកម្មភាពបន្តដែលភ្ជាប់",
          "foot": "ការគ្រប់គ្រងការងារជាម្ចាស់សកម្មភាពកែតម្រូវ; Field Ops រក្សាការចុះពិនិត្យដើម និងសវនកម្មការបញ្ចប់។",
          "start": "ចាប់ផ្ដើមសកម្មភាព",
          "submit": "ដាក់ស្នើសម្រាប់ផ្ទៀងផ្ទាត់",
          "verify-ph": "កំណត់ចំណាំអ្នកផ្ទៀងផ្ទាត់ (តម្រូវ)",
          "return": "បញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ",
          "verify": "ផ្ទៀងផ្ទាត់"
        },
        "err": {
          "method": "ជ្រើសរើសរបៀបដែលបញ្ហាត្រូវបានដោះស្រាយ។",
          "action": "កត់ត្រាសកម្មភាពដែលបានធ្វើ — អ្វីដែលបានធ្វើជាក់ស្ដែង (PO-D19)។",
          "note": "ពិពណ៌នាសកម្មភាពកែតម្រូវដែលបានធ្វើ (យ៉ាងហោចណាស់ 10 តួអក្សរ)។",
          "date": "កត់ត្រាកាលបរិច្ឆេទដែលសកម្មភាពកែតម្រូវត្រូវបានបញ្ចប់។",
          "pinned": "កំណែកិច្ចការដែលបានខ្ទាស់តម្រូវឱ្យមានភស្តុតាង — កម្រិតអប្បបរមានេះមិនអាចកាត់បន្ថយ ឬលើកលែងបានទេ រួមទាំងដោយការលើកលែង (PO-D19)។",
          "evidence": "តម្រូវឱ្យមានភស្តុតាង។ បន្ថែមរូបថតការកែតម្រូវ បង្កាន់ដៃ ការទទួលស្គាល់ ឬភស្តុតាងការចុះពិនិត្យឡើងវិញ។",
          "exception": "ការលើកលែងភស្តុតាងត្រូវការមូលហេតុច្បាស់លាស់សម្រាប់ LM វាយតម្លៃ។",
          "source": "កត់ត្រាថាតើភស្តុតាងនេះមកពីកាមេរ៉ា ឬបណ្ណាល័យរូបថត។",
          "remove-reason": "តម្រូវឱ្យមានមូលហេតុដើម្បីដកភស្តុតាងចេញ។ ច្បាប់ដើមត្រូវបានរក្សាទុកជាការជំនួស; គ្មានអ្វីត្រូវបានលុបទេ។",
          "return-note": "ពន្យល់ពីភស្តុតាង ឬការកែតម្រូវដែលនៅតែត្រូវការ។",
          "verify-note": "តម្រូវឱ្យមានកំណត់ចំណាំអ្នកផ្ទៀងផ្ទាត់ដើម្បីផ្ទៀងផ្ទាត់ (PO-D19, AUTH-018)។",
          "scope": "សកម្មភាពកែតម្រូវនេះនៅក្រៅវិសាលភាពដែលអ្នកមានសិទ្ធិ។"
        },
        "toast": {
          "submitted": "សកម្មភាពកែតម្រូវត្រូវបានដាក់ស្នើសម្រាប់ផ្ទៀងផ្ទាត់",
          "verified": "សកម្មភាពកែតម្រូវត្រូវបានផ្ទៀងផ្ទាត់",
          "returned": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ — ម្ចាស់នឹងឃើញមូលហេតុរបស់អ្នក"
        },
        "mgmt": {
          "line": "· ម្ចាស់ {owner} · {site} · កំណត់ {due}",
          "empty": "គ្មានការតាមដាននៅក្នុងក្រុមដែលបានត្រង។"
        }
      },
      "md": {
        "title": "ការចុះពិនិត្យតាមបញ្ជាអ្នកគ្រប់គ្រង",
        "purpose-title": "គោលបំណងចុះពិនិត្យអាជីវកម្ម — Ad Hoc គឺជាប្រភព មិនមែនជាគោលបំណងឡើយ",
        "channel": {
          "in-app": "ក្នុងកម្មវិធី",
          "verbal": "ផ្ទាល់មាត់"
        },
        "vstatus": {
          "inprogress": "កំពុងដំណើរការ",
          "scheduled": "បានកំណត់ពេល",
          "planned": "បានគ្រោងទុក",
          "completed": "បានបញ្ចប់",
          "cancelled": "បានលុបចោល"
        },
        "aria": {
          "supervisor": "អ្នកគ្រប់គ្រង",
          "outlet": "ហាង",
          "purpose": "គោលបំណងចុះពិនិត្យ"
        },
        "sup": {
          "sub": "ប្រភព “តាមបញ្ជាអ្នកគ្រប់គ្រង/Ad Hoc” — ទម្រង់ចុះពិនិត្យ និងបញ្ជីផ្ទៀងផ្ទាត់ WM ដូចគ្នា; មិនដែលជាផែនការដាច់ដោយឡែកឡើយ",
          "counts": "បានបំពេញ {done} · បើក {open}",
          "record": "កត់ត្រាការណែនាំផ្ទាល់មាត់ពី LM",
          "awaiting": "កំពុងរង់ចាំការទទួលស្គាល់",
          "acknowledged": "បានទទួលស្គាល់",
          "requested-by": "ស្នើដោយ",
          "meta": "កត់ត្រាដោយ {rec} · {channel} · គោលបំណង៖ {purpose}",
          "ack": "ទទួលស្គាល់",
          "inroute-a": "ការចុះពិនិត្យ",
          "combined-with": "(រួមបញ្ចូលជាមួយ {id})",
          "inroute-b": "ស្ថិតនៅលើផ្លូវថ្ងៃនេះ — {status}។ អនុវត្តវាពីផ្លូវខាងក្រោម ឬរបៀបការងារវាល។",
          "elig-a": "ហាងនេះមានការចុះពិនិត្យ PJP នាពេលអនាគតដែលមានសិទ្ធិ —",
          "elig-b": "គ្រោងនៅ {date}។ ការចុះពិនិត្យរួមបញ្ចូលគឺជាការចូល ការចេញ រយៈពេល និងកំណត់ត្រាជាក់ស្ដែងតែមួយ; កិច្ចការដែលជាន់គ្នាត្រូវបានលុបចោលការស្ទួន; ការចុះពិនិត្យ PJP បញ្ចប់មុនពេលកំណត់តែនៅពេលការងារ PJP ចាំបាច់ទាំងអស់ត្រូវបានធ្វើរួច។",
          "no-elig": "ហាងនេះគ្មានការចុះពិនិត្យ PJP នាពេលអនាគតដែលមានសិទ្ធិ — អនុវត្តជាការចុះពិនិត្យតាមបញ្ជាអ្នកគ្រប់គ្រងតែប៉ុណ្ណោះ។",
          "combine": "ចាប់ផ្ដើមការចុះពិនិត្យរួមបញ្ចូល ({id})",
          "only-elig": "តាមបញ្ជាអ្នកគ្រប់គ្រងតែប៉ុណ្ណោះ",
          "only": "ចាប់ផ្ដើមការចុះពិនិត្យតាមបញ្ជាអ្នកគ្រប់គ្រង",
          "route-note": "ផ្លូវ PJP ដែលបានគ្រោងរបស់អ្នកមិនដែលត្រូវបានផ្លាស់ប្ដូរដោយស្ងាត់ៗឡើយ៖ ចំណតដែលត្រូវបានរំកិលនៅតែបានកំណត់ពេល — រៀបចំលំដាប់ ឬកំណត់ពេលឡើងវិញដោយផ្ទាល់ (ផ្ទាំងសប្ដាហ៍ ↻) ឬស្នើសុំការកែប្រែ។",
          "empty": "គ្មានការណែនាំដែលបើក។ ការណែនាំក្នុងកម្មវិធីពី RSM របស់អ្នកនឹងបង្ហាញនៅទីនេះសម្រាប់ការទទួលស្គាល់។"
        },
        "form": {
          "lead": "កត់ត្រាការណែនាំផ្ទាល់មាត់ / ខាងក្រៅពី LM។",
          "body": "អ្នកស្នើ និងអ្នកកត់ត្រានៅដាច់ដោយឡែក៖ ស្នើដោយ LM/RSM របស់អ្នក កត់ត្រាដោយអ្នក។",
          "requested-by": "ស្នើដោយ",
          "recorded-by": "កត់ត្រាដោយ",
          "rsm": "{name} (RSM)",
          "supervisor": "{name} (អ្នកគ្រប់គ្រង)",
          "note-ph": "ការណែនាំ / បរិបទ (ស្រេចចិត្ត)",
          "go": "កត់ត្រា និងទទួលស្គាល់",
          "cancel": "បោះបង់"
        },
        "toast": {
          "combined": "បានបង្កើតការចុះពិនិត្យរួមបញ្ចូល — ការចុះពិនិត្យជាក់ស្ដែងមួយ តាមដានកាតព្វកិច្ចទាំងពីរ",
          "only": "ការចុះពិនិត្យតាមបញ្ជាអ្នកគ្រប់គ្រងត្រូវបានបន្ថែមទៅផ្លូវថ្ងៃនេះ"
        },
        "kpi": {
          "issued": "ការណែនាំដែលបានចេញ",
          "issued-sub": "តំបន់របស់អ្នក",
          "awaiting": "កំពុងរង់ចាំការទទួលស្គាល់",
          "awaiting-sub": "សកម្មភាពអ្នកគ្រប់គ្រង",
          "acknowledged": "បានទទួលស្គាល់",
          "acknowledged-sub": "មិនទាន់អនុវត្ត",
          "fulfilled": "បានបំពេញ",
          "fulfilled-sub": "{n} តាមរយៈការចុះពិនិត្យរួមបញ្ចូល"
        },
        "rsm": {
          "note": "— ណែនាំអ្នកគ្រប់គ្រងក្នុងតំបន់របស់អ្នកឱ្យទៅហាងក្នុងវិសាលភាពដែលបានចាត់តាំង។ ការណែនាំគឺជាកំណត់ត្រាប្រភព (“តាមបញ្ជាអ្នកគ្រប់គ្រង/Ad Hoc”) មិនដែលជាផែនការដាច់ដោយឡែកឡើយ; អ្នកគ្រប់គ្រងទទួលស្គាល់ និងអនុវត្តវាដោយប្រើទម្រង់ចុះពិនិត្យស្តង់ដារ និងបញ្ជីផ្ទៀងផ្ទាត់ WM។ ការបញ្ចប់ PJP និងការបញ្ចប់តាមបញ្ជាអ្នកគ្រប់គ្រងតែងតែរាយការណ៍ដាច់ដោយឡែក។",
          "flash": "បានចេញការណែនាំ — អ្នកគ្រប់គ្រងឃើញវានៅ ការអនុវត្ត · ថ្ងៃនេះ ហើយត្រូវទទួលស្គាល់មុនពេលអនុវត្ត។",
          "direct": "ណែនាំការចុះពិនិត្យ",
          "note-ph": "ការណែនាំ / បរិបទ (ស្រេចចិត្ត)",
          "issue": "ចេញការណែនាំ",
          "scope": "អនុវត្តវិសាលភាពតំបន់៖ តែអ្នកគ្រប់គ្រងរបស់អ្នក តែហាងក្នុងវិសាលភាពដែលបានចាត់តាំង។ Ad Hoc គឺជាប្រភព — គោលបំណងចុះពិនិត្យនៅតែជាគោលបំណងអាជីវកម្ម។",
          "fulfil-combined": "{id} · រួមបញ្ចូល — ការចុះពិនិត្យជាក់ស្ដែងមួយ; ក៏បានបញ្ចប់ការចុះពិនិត្យ PJP {pjp}",
          "fulfil-only": "{id} · តាមបញ្ជាអ្នកគ្រប់គ្រងតែប៉ុណ្ណោះ",
          "empty": "មិនទាន់មានការចុះពិនិត្យតាមបញ្ជាអ្នកគ្រប់គ្រងនៅឡើយ។",
          "report-note": "ការរាយការណ៍នៅដាច់ដោយឡែក៖ ការបញ្ចប់ PJP (ការអនុវត្តតាមតំបន់) មិនដែលរាប់កំណត់ត្រាជាក់ស្ដែងតាមបញ្ជាអ្នកគ្រប់គ្រងឡើយ ហើយការចុះពិនិត្យរួមបញ្ចូលគឺជាការចុះពិនិត្យជាក់ស្ដែងមួយដែលបំពេញតម្រូវការតាមបញ្ជាអ្នកគ្រប់គ្រងមួយ និងកាតព្វកិច្ច PJP មួយ — គ្មានការរាប់ស្ទួន។"
        },
        "cols": {
          "id": "លេខសម្គាល់",
          "outlet": "ហាង",
          "supervisor": "អ្នកគ្រប់គ្រង",
          "requested": "ស្នើដោយ",
          "recorded": "កត់ត្រាដោយ",
          "channel": "មធ្យោបាយ",
          "purpose": "គោលបំណង",
          "status": "ស្ថានភាព",
          "fulfilment": "ការបំពេញ"
        },
        "status": {
          "completed": "បានបំពេញ",
          "acknowledged": "បានទទួលស្គាល់",
          "cancelled": "បានលុបចោល",
          "issued": "បានចេញ"
        }
      },
      "map": {
        "truth": "ទិដ្ឋភាពការអនុវត្តផ្លូវដែលបានគ្រោង · មិនមែនការតាមដាន GPS របស់បុគ្គលិកជាបន្តបន្ទាប់ទេ។ ខ្សែផ្លូវធ្វើតាមលំដាប់ហាងដែលបានគ្រោង (គ្មានការណែនាំផ្លូវតាមវេននីមួយៗ); កូអរដោនេមកពីបញ្ជីមេទីតាំង/ហាង។",
        "no-geo": "គ្មានកូអរដោនេហាងពីបញ្ជីមេទីតាំង/ហាងទេ — សូមប្រើរបៀបបញ្ជី។",
        "canvas-label": "ផែនទីផ្លូវដែលបានគ្រោង។ គ្រាប់ចុចព្រួញរំកិលផែនទី, + និង − ពង្រីក/បង្រួម, 0 ត្រឡប់ទៅទិដ្ឋភាពផ្លូវពេញ។",
        "bg": {
          "river": "ទន្លេ",
          "north": "ស្រុកខាងជើង",
          "south": "ស្រុកខាងត្បូង",
          "caption": "ផ្ទៃខាងក្រោយគំនូសតាង · សម្រាប់បង្ហាញប៉ុណ្ណោះ (មិនមែនផែនទីវាស់វែងទេ)"
        },
        "nav": {
          "up": "រំកិលឡើងលើ",
          "down": "រំកិលចុះក្រោម",
          "left": "រំកិលទៅឆ្វេង",
          "right": "រំកិលទៅស្តាំ",
          "reset": "ត្រឡប់ទៅទិដ្ឋភាពផ្លូវពេញ",
          "zoom-in": "ពង្រីក",
          "zoom-out": "បង្រួម"
        },
        "status": {
          "done": "បានបញ្ចប់",
          "flagged": "មានទង់សម្គាល់ · បានបញ្ចប់",
          "inpr": "កំពុងដំណើរការ",
          "up": "នឹងមកដល់",
          "missed": "ខកខាន",
          "unav": "ហាងមិនអាចចូលបាន"
        },
        "range": {
          "label": "រយៈពេលផ្លូវ",
          "pjp": "រយៈពេល PJP",
          "week": "សប្តាហ៍",
          "day": "ថ្ងៃ",
          "custom": "ជួរកាលបរិច្ឆេទផ្ទាល់ខ្លួន",
          "month": "ខែ PJP ដែលបានអនុម័ត",
          "week-date": "កាលបរិច្ឆេទណាមួយក្នុងសប្តាហ៍",
          "day-date": "ថ្ងៃ",
          "today": "ថ្ងៃនេះ",
          "from": "ពី",
          "to": "ដល់",
          "invalid": "ជួរកាលបរិច្ឆេទមិនត្រឹមត្រូវ — {to} ត្រូវតែនៅថ្ងៃដដែល ឬក្រោយ {from}។ សូមកែកាលបរិច្ឆេទដើម្បីបន្ត។",
          "pjp-label": "រយៈពេល PJP · {month}",
          "week-label": "សប្តាហ៍ទី {wk} · {month}"
        },
        "stat": {
          "all": "ស្ថានភាពផ្លូវទាំងអស់",
          "up": "នឹងមកដល់",
          "inpr": "កំពុងដំណើរការ",
          "done": "បានបញ្ចប់",
          "missed": "ខកខាន",
          "flagged": "មានទង់សម្គាល់",
          "unav": "មិនអាចចូលបាន"
        },
        "updated": "បានធ្វើបច្ចុប្បន្នភាពឥឡូវនេះ",
        "refresh": "ផ្ទុកឡើងវិញ",
        "kpi": {
          "routes": "ផ្លូវសកម្ម",
          "routes-sub": {
            "pjp": "បានគ្រោងក្នុងរយៈពេល PJP នេះ",
            "week": "បានគ្រោងក្នុងសប្តាហ៍នេះ",
            "day": "បានគ្រោងសម្រាប់ថ្ងៃនេះ",
            "custom": "បានគ្រោងក្នុងជួរដែលបានជ្រើស"
          },
          "completed": "បានបញ្ចប់",
          "flagged-sub": "{n} មានទង់សម្គាល់",
          "inpr": "កំពុងដំណើរការ",
          "inpr-sub": "បានចុះឈ្មោះចូលឥឡូវនេះ",
          "up": "នឹងមកដល់",
          "unav-sub": "{n} ហាងមិនអាចចូលបាន",
          "exc": "ករណីលើកលែង",
          "exc-sub": "{m} ខកខាន · {f} មានទង់សម្គាល់"
        },
        "empty": "គ្មានផ្លូវដែលបានគ្រោងក្នុង {range} ក្រោមវិសាលភាព/តម្រងបច្ចុប្បន្នទេ។",
        "my-route": "ផ្លូវរបស់ខ្ញុំ",
        "sup-routes": "ផ្លូវរបស់អ្នកគ្រប់គ្រង",
        "show-route": "បង្ហាញផ្លូវរបស់ {name} លើផែនទី",
        "stops": "{done} / {total} ចំណត",
        "legend": {
          "owner": "ម្ចាស់ផ្លូវ៖",
          "status": "ស្ថានភាពការចុះពិនិត្យ៖"
        },
        "detail": {
          "none": "គ្មានផ្លូវសម្រាប់រយៈពេលនេះទេ។",
          "progress": "{name} · វឌ្ឍនភាពផ្លូវ",
          "summary": "{done} ក្នុងចំណោម {total} បានបញ្ចប់",
          "n-flagged": "{n} មានទង់សម្គាល់",
          "n-inpr": "{n} កំពុងដំណើរការ",
          "n-up": "{n} នឹងមកដល់",
          "n-missed": "{n} ខកខាន",
          "n-unav": "{n} មិនអាចចូលបាន",
          "estimated": "ប៉ាន់ស្មាន",
          "distance": "ចម្ងាយ {km}",
          "time": "ពេលវេលា {t}",
          "hm": "{h}ម៉ោង {m}នាទី",
          "current": "បច្ចុប្បន្ន៖",
          "current-chip": "បច្ចុប្បន្ន",
          "timeline": "{name} · ដំណាក់កាលផ្លូវដែលបានគ្រោង",
          "stop-label": "{n} {name}, {status}",
          "window": "ចន្លោះពេល {w}",
          "visit": "ការចុះពិនិត្យ",
          "loc-unavailable": "គ្មានទីតាំង",
          "tasks": "ភារកិច្ច {n} / {total} បានកត់ត្រា",
          "score": "ពិន្ទុ {n}",
          "photos": "រូបថតភស្តុតាង {n} | រូបថតភស្តុតាង {n}",
          "exception": "បានកត់ត្រាករណីលើកលែង",
          "open-visit": "បើកការចុះពិនិត្យ",
          "view-visit": "មើលការចុះពិនិត្យ",
          "nogeo-title": "គ្មានទីតាំង ({n})៖",
          "nogeo-text": "— គ្មានកូអរដោនេក្នុងបញ្ជីមេទីតាំង/ហាង; កំណត់ត្រានៅតែអាចចូលមើលបានក្នុងរបៀបបញ្ជី។"
        },
        "agg": {
          "truth": "ទិដ្ឋភាពការអនុវត្តផ្លូវដែលបានគ្រោង · មិនមែនការតាមដាន GPS របស់បុគ្គលិកជាបន្តបន្ទាប់ទេ។ ការគ្របដណ្តប់សរុបតាមភូមិសាស្ត្រ — ផ្លូវនីមួយៗ លំដាប់ហាង និងកំណត់ត្រាតាមបុគ្គល ស្ថិតនៅក្រៅកម្រិតព័ត៌មានរបស់តួនាទីនេះ។",
          "empty": "គ្មានទិន្នន័យការអនុវត្តក្នុងវិសាលភាព/តម្រងបច្ចុប្បន្នទេ។",
          "svg-label": "ការគ្របដណ្តប់សរុបតាមខេត្ត",
          "done": "{done} / {n} បានបញ្ចប់",
          "col": {
            "province": "ខេត្ត",
            "planned": "បានគ្រោង",
            "completed": "បានបញ្ចប់",
            "missed": "ខកខាន",
            "flagged": "មានទង់សម្គាល់",
            "completion": "ការបញ្ចប់"
          }
        },
        "cycle": {
          "label": "ផែនទីផ្លូវវដ្តចុះពិនិត្យ {k}",
          "start": "ចាប់ផ្តើម",
          "include": "បញ្ចូល {name}",
          "exclude": "ដកចេញ {name}",
          "legend-in": "● បានបញ្ចូល + មានផ្លូវ",
          "legend-out": "○ បានចាត់តាំង មិនទាន់បញ្ចូល",
          "legend-google": "Google Maps ផ្តល់ពេលបើកបរ និងចម្ងាយផ្លូវជាក់ស្តែងពីទីតាំងបច្ចុប្បន្នរបស់អ្នក",
          "missing": "ហាង {n} គ្មានកូអរដោនេ ហើយនៅតែមានក្នុងបញ្ជីគ្រប់គ្រង | ហាង {n} គ្មានកូអរដោនេ ហើយនៅតែមានក្នុងបញ្ជីគ្រប់គ្រង",
          "no-geo": "គ្មានកូអរដោនេហាងដែលបានចាត់តាំងទេ; សូមប្រើបញ្ជីហាងដែលបានបញ្ចូលខាងក្រោម។",
          "rank": "លំដាប់ផ្លូវវដ្តទី {k}",
          "n-stops": "{n} ចំណត",
          "within": "ជ្រើសកាលបរិច្ឆេទក្នុង {range}",
          "pending": "កាលបរិច្ឆេទមិនទាន់កំណត់",
          "no-date": "គ្មានកាលបរិច្ឆេទ",
          "selected": "បានជ្រើស",
          "empty": "បញ្ចូលហាងពីផែនទីដើម្បីបង្កើតផ្លូវ។",
          "view": "ទិដ្ឋភាពផ្លូវ",
          "map": "ផែនទី",
          "list": "បញ្ជី",
          "start-badge": "S"
        }
      },
      "ins": {
        "note-title": "ការយល់ដឹងពីការអនុវត្ត",
        "note": "លទ្ធផលអនុវត្តនៅហាង និងផ្លូវចុះ។ នេះមិនមែនជាការវាយតម្លៃបុគ្គលិកទេ៖ ការវាយតម្លៃផ្លូវការស្ថិតនៅក្នុងការគ្រប់គ្រងលទ្ធផលការងារ ដែលមានគំរូ អ្នកវាយតម្លៃ និងវដ្តពិនិត្យផ្ទាល់ខ្លួន។",
        "reporting-period": "រយៈពេលរបាយការណ៍",
        "all-periods": "គ្រប់រយៈពេល",
        "period-select": "រយៈពេលរបាយការណ៍",
        "period-hint": "រយៈពេលត្រូវបានកំណត់នៅរបារតម្រងខាងក្រោម",
        "refreshed": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ {ts}",
        "scope": {
          "owner": "ម្ចាស់ផែនការ៖ {name}",
          "rsm": "វិសាលភាពដែលមានសិទ្ធិ៖ {sub}",
          "rsm-default": "ការគ្រប់គ្រងខ្សែបន្ទាត់តំបន់",
          "hrbp": "វិសាលភាពដែលមានសិទ្ធិ៖ ការត្រួតពិនិត្យ Optimal P (ទូទាំងគម្រោង)",
          "gov": "វិសាលភាពដែលមានសិទ្ធិ៖ ទិដ្ឋភាពអភិបាលកិច្ចសរុប (តែចំនួនប៉ុណ្ណោះ)"
        },
        "exec": {
          "inprogress": "កំពុងដំណើរការ · {done} / {total}",
          "closed": "បានបិទ · {done} / {total}",
          "upcoming": "នឹងមកដល់",
          "upcoming-n": "នឹងមកដល់ · ការចុះ {n}"
        },
        "close": {
          "met": "បានបិទ · សម្រេចតាមផែនការ",
          "partial": "បានបិទ · សម្រេចបានមួយផ្នែក",
          "below": "បានបិទ · ក្រោមផែនការ",
          "not-assessed": "បានបិទ · មិនបានវាយតម្លៃ",
          "cancelled": "បានលុបចោល"
        },
        "sla": {
          "title": "រង្វាស់ SLA · PO-D20 (គោលការណ៍ {ref})",
          "sub-own": "នាឡិកាថ្ងៃធ្វើការ · Asia/Phnom_Penh · សកម្មភាពរបស់អ្នក។ ការបំពានផ្ដល់ការព្រមាន បង្កើនកម្រិត និងត្រូវបានកត់ត្រាសវនកម្ម — វាមិនដែលសម្រេចអ្វីដោយស្វ័យប្រវត្តិទេ។",
          "sub-agg": "នាឡិកាថ្ងៃធ្វើការ · Asia/Phnom_Penh · សរុបគម្រោង — តែចំនួនប៉ុណ្ណោះ សិទ្ធិចូលមើលកំណត់ត្រាមិនផ្លាស់ប្ដូរ។ ការបំពានផ្ដល់ការព្រមាន បង្កើនកម្រិត និងត្រូវបានកត់ត្រាសវនកម្ម — វាមិនដែលសម្រេចអ្វីដោយស្វ័យប្រវត្តិទេ។",
          "col": {
            "measure": "រង្វាស់",
            "on-time": "ទាន់ពេល",
            "open": "បើកក្នុងគោលដៅ",
            "overdue": "បើកហួសកំណត់",
            "met-late": "សម្រេចយឺត"
          },
          "row": {
            "response": "ការឆ្លើយតបដំបូង",
            "delivery": "ការប្រគល់ (ថ្ងៃកំណត់)",
            "verify": "ការផ្ទៀងផ្ទាត់"
          }
        },
        "sup": {
          "coverage": "ការគ្របដណ្ដប់ហាង",
          "outlets-sub": "ហាង {visited} / {total}",
          "completion": "ការបញ្ចប់",
          "due-sub": "{done} / {due} ដល់កំណត់",
          "clean": "ការបញ្ចប់ស្អាត",
          "flag-rate": "អត្រាទង់ {n}%",
          "avg": "ពិន្ទុហាងមធ្យម",
          "completed-visits": "ការចុះដែលបានបញ្ចប់",
          "empty": "គ្មានការចុះក្នុងរយៈពេលនេះទេ។",
          "col": {
            "outlet": "ហាង",
            "visits": "ការចុះ",
            "completed": "បានបញ្ចប់",
            "missed": "ខកខាន",
            "flagged": "មានទង់",
            "avg": "ពិន្ទុហាងមធ្យម"
          }
        },
        "perf": {
          "clean": "ការបញ្ចប់ស្អាត",
          "flag-rate": "អត្រាទង់ {n}%",
          "avg": "ពិន្ទុមធ្យម",
          "completed-visits": "ការចុះដែលបានបញ្ចប់",
          "adherence": "ការគោរពតាមផែនការ",
          "on-planned-date": "នៅថ្ងៃដែលបានគ្រោង",
          "col": {
            "clean": "ស្អាត",
            "avg-score": "ពិន្ទុមធ្យម",
            "flag-rate": "អត្រាទង់",
            "adherence": "ការគោរពតាមផែនការ"
          }
        }
      },
      "admin": {
        "config": {
          "note-title": "ការកំណត់រចនាសម្ព័ន្ធ។",
          "note": "ធាតុបញ្ជីត្រួតពិនិត្យ និងទម្ងន់ គឺជាទិន្នន័យការកំណត់ — ពិន្ទុ និងទង់ស្វ័យប្រវត្តិកើតចេញពីវា។ គំរូការចុះ និងប្រតិទិនប្រតិបត្តិការមានទីតាំងផ្ទាល់ខ្លួន។ សិទ្ធិរដ្ឋបាលមិនផ្ដល់សិទ្ធិប្រតិបត្តិការណាមួយឡើយ។",
          "template": "គំរូបញ្ជីត្រួតពិនិត្យ · {name}",
          "col": {
            "group": "ក្រុម",
            "item": "ធាតុ",
            "weight": "ទម្ងន់",
            "critical": "ទង់ស្វ័យប្រវត្តិធ្ងន់ធ្ងរ"
          },
          "critical": "ធ្ងន់ធ្ងរ",
          "toggle-aria": "ទង់ស្វ័យប្រវត្តិធ្ងន់ធ្ងរសម្រាប់ធាតុ {n}៖ {item}"
        },
        "sla": {
          "title": "គោលការណ៍ SLA · PO-D20 (AUTH-019)",
          "published": "លំនាំដើមប្រព័ន្ធដែលបានផ្សព្វផ្សាយ v{v}",
          "override-active": "ការកំណត់ជំនួសគម្រោង v{v} សកម្ម",
          "no-override": "គ្មានការកំណត់ជំនួសគម្រោង — អនុវត្តលំនាំដើមប្រព័ន្ធ (ការវាយតម្លៃមិនដែលផ្អាក)",
          "resolved": "បានកំណត់៖ {ref}",
          "wd": "ថ្ងៃធ្វើការ",
          "reason": "មូលហេតុ (ចាំបាច់)",
          "set-project": "កំណត់ការជំនួសគម្រោង",
          "publish": "ផ្សព្វផ្សាយលំនាំដើមប្រព័ន្ធថ្មី",
          "remove": "ដកការជំនួសចេញ",
          "err-whole": "តម្លៃ SLA ត្រូវតែជាចំនួនគត់នៃថ្ងៃធ្វើការ។",
          "coverage": "ការគ្របដណ្ដប់៖ នាឡិកាផ្ទៀងផ្ទាត់ {n} ហួសកំណត់ | ការគ្របដណ្ដប់៖ នាឡិកាផ្ទៀងផ្ទាត់ {n} ហួសកំណត់",
          "designated": "អ្នកផ្ទៀងផ្ទាត់ដែលបានចាត់តាំងសកម្ម៖ {n}",
          "coverage-suggest": " — សូមពិចារណាចាត់តាំងការគ្របដណ្ដប់ LM/RSM (AUTH-017)។ ផ្ទាំងនេះមិនផ្ដល់សិទ្ធិចូលមើលខ្លឹមសារសកម្មភាពកម្រិតកំណត់ត្រាទេ។",
          "coverage-tail": " · ផ្ទាំងនេះមិនផ្ដល់សិទ្ធិចូលមើលខ្លឹមសារសកម្មភាពកម្រិតកំណត់ត្រាទេ។",
          "audit": "សវនកម្មគោលការណ៍ (ចុងក្រោយ)"
        },
        "vtpl": {
          "own-label": "កម្មសិទ្ធិ៖",
          "own-a": "គឺ",
          "library": "បណ្ណាល័យភារកិច្ចមេនៃការគ្រប់គ្រងការងារ",
          "own-b": "ដែលជាម្ចាស់និយមន័យភារកិច្ចដែលអាចប្រើឡើងវិញទាំងអស់ (ភារកិច្ចដែលបានផ្សព្វផ្សាយ {n})។ គំរូការចុះ Field Ops គ្រាន់តែផ្សំ និងយោងភារកិច្ចបណ្ណាល័យដែលបានអនុម័តតាមគោលបំណងការចុះ — គ្មានបណ្ណាល័យភារកិច្ចទីពីរទេ។",
          "intro-label": "គំរូភារកិច្ចការចុះ",
          "intro-a": "ផ្សំភារកិច្ចដែលបានអនុម័តពី",
          "intro-b": "— Field Ops យោងបណ្ណាល័យ មិនដែលបំបែកបណ្ណាល័យទីពីរទេ។ គំរូផ្លូវ = បញ្ជីហាងដែលបានចាត់តាំងទាំងមូលរបស់អ្នក ជាមួយលំនាំដើមស្តង់ដារ (ប្រភពចាប់ផ្ដើមនៃ + PJP ថ្មី)។",
          "unresolved": "កំណែភារកិច្ចមិនទាន់កំណត់",
          "minutes": "~{n} នាទី",
          "tasks": "ភារកិច្ចបណ្ណាល័យ {n} | ភារកិច្ចបណ្ណាល័យ {n}"
        },
        "audit": {
          "note-title": "សវនកម្ម។",
          "note": "ការមើលឃើញពេញលេញបែបអានប៉ុណ្ណោះ សម្រាប់គោលបំណងសវនកម្ម។ រាល់ការផ្លាស់ប្ដូរស្ថានភាព ការកំណត់ជំនួស ការអនុម័ត ការកែប្រែ និងដំណោះស្រាយ ត្រូវបានកត់ត្រានៅលើកំណត់ត្រារបស់វា។"
        }
      },
      "cal": {
        "note-title": "ប្រតិទិនប្រតិបត្តិការ។",
        "note": "ភាពមិនអាចចុះហាងបាន = ភាពមិនអាចចុះបានជាបណ្ដោះអាសន្ន (មិនមែនការបិទជាអចិន្ត្រៃយ៍ ការដកចេញពីកម្មវិធី ការលាលែង ឬច្បាប់ឈប់សម្រាក — ទាំងនោះស្ថិតនៅជាមួយ Site/Outlet Master និង HR/People)។ ថ្ងៃដែលបានបញ្ជាក់ថាមិនអាចចុះបានត្រូវបានជៀសវាងដោយកម្មវិធីរៀបកាលវិភាគ និងលើកលែងការខកខាន។ ថ្ងៃឈប់សម្រាកសាធារណៈជាកម្មសិទ្ធិប្រតិទិនក្រុមហ៊ុន — អានប៉ុណ្ណោះនៅទីនេះ។",
        "prev": "ខែមុន",
        "next": "ខែបន្ទាប់",
        "today": "ថ្ងៃនេះ",
        "today-lower": "ថ្ងៃនេះ",
        "view": {
          "month": "ខែ",
          "list": "បញ្ជី"
        },
        "filter-label": "តម្រងព្រឹត្តិការណ៍",
        "filter": {
          "all": "ព្រឹត្តិការណ៍ទាំងអស់",
          "pjp": "ការចុះ PJP",
          "unav": "ភាពមិនអាចចុះហាងបាន",
          "hol": "ថ្ងៃឈប់សម្រាកសាធារណៈ / មិនធ្វើការ",
          "exc": "ខកខាន និងករណីលើកលែង"
        },
        "record": "+ កត់ត្រាភាពមិនអាចចុះបាន",
        "grid-label": "ប្រតិទិនប្រតិបត្តិការ {month}",
        "dow": {
          "mon": "ច័ន្ទ",
          "tue": "អង្គារ",
          "wed": "ពុធ",
          "thu": "ព្រហស្បតិ៍",
          "fri": "សុក្រ",
          "sat": "សៅរ៍",
          "sun": "អាទិត្យ"
        },
        "chip": {
          "visits": "ការចុះ {n} | ការចុះ {n}",
          "unav": "មិនអាចចុះបាន {n}",
          "missed": "ខកខាន {n}",
          "flagged": "មានទង់ {n}"
        },
        "hol-title": "{name} · ប្រតិទិនក្រុមហ៊ុន · មិនធ្វើការ",
        "legend": {
          "pjp": "ការចុះ PJP",
          "unav": "ហាងមិនអាចចុះបាន",
          "hol": "ថ្ងៃឈប់សម្រាកសាធារណៈ / មិនធ្វើការ",
          "done": "បានបញ្ចប់",
          "flagged": "បានបញ្ចប់ · មានទង់"
        },
        "list": {
          "visits": "ការចុះ {n}",
          "empty": "គ្មានព្រឹត្តិការណ៍ត្រូវនឹងតម្រងនេះក្នុង {month} ទេ។"
        },
        "day": {
          "planned": "បានគ្រោង",
          "completed": "បានបញ្ចប់",
          "inprogress": "កំពុងដំណើរការ",
          "upcoming": "នឹងមកដល់",
          "missed": "ខកខាន",
          "flagged": "មានទង់",
          "unavailable": "មិនអាចចុះបាន",
          "by-sup": "ការចុះតាមអ្នកគ្រប់គ្រង ({n})",
          "visits": "ការចុះ",
          "n-done": "រួចរាល់ {n}",
          "n-inprogress": "កំពុងដំណើរការ {n}",
          "n-upcoming": "នឹងមកដល់ {n}",
          "visit": "ការចុះ",
          "window": "ចន្លោះពេល {w}",
          "empty": "គ្មានព្រឹត្តិការណ៍នៅថ្ងៃនេះទេ។",
          "impact-title": "ផលប៉ះពាល់កាលវិភាគ៖",
          "impact": "ហាងដែលសម្គាល់ថាមិនអាចចុះបាន ត្រូវបានដកចេញដោយកម្មវិធីរៀបកាលវិភាគ ហើយការចុះដែលបានគ្រោងត្រូវបានលើកលែង — មិនដែលរាប់ជាខកខានទេ។ ការចុះនាពេលអនាគតដែលបានអនុម័តនៅថ្ងៃដែលរងផលប៉ះពាល់ លេចឡើងជាការប៉ះទង្គិចសម្រាប់ការប្ដូរកាលវិភាគ/ការកែប្រែ។"
        },
        "hist": {
          "title": "ប្រវត្តិភាពមិនអាចចុះបាន · {month}",
          "outlet": "ហាង",
          "status": "ស្ថានភាព",
          "all-outlets": "ហាងទាំងអស់",
          "all-statuses": "ស្ថានភាពទាំងអស់",
          "reset": "កំណត់ឡើងវិញ",
          "empty": "គ្មានកំណត់ត្រាភាពមិនអាចចុះបានក្នុង {month} ទេ។"
        },
        "status": {
          "active": "សកម្ម",
          "scheduled": "បានកំណត់ពេល",
          "past": "កន្លងផុត",
          "cancelled": "បានលុបចោល"
        },
        "col": {
          "outlet": "ហាង",
          "from": "ពី",
          "to": "ដល់",
          "type": "ប្រភេទ",
          "reason": "មូលហេតុ",
          "status": "ស្ថានភាព",
          "recorded-by": "កត់ត្រាដោយ",
          "actions": "សកម្មភាព"
        },
        "upcoming": {
          "title": "ភាពមិនអាចចុះហាងបាននាពេលខាងមុខ · {month}",
          "reopen": "បើកឡើងវិញ {d}",
          "cancel": "លុបចោល",
          "cancel-aria": "លុបចោលភាពមិនអាចចុះបានរបស់ {outlet}",
          "empty": "គ្មានភាពមិនអាចចុះបាននាពេលខាងមុខក្នុង {month} ទេ។ ប្រវត្តិពេញលេញមាននៅក្នុងរបៀបបញ្ជី។"
        },
        "hol": {
          "title": "ថ្ងៃឈប់សម្រាកសាធារណៈ / ថ្ងៃមិនធ្វើការ · {month}",
          "col": {
            "dates": "កាលបរិច្ឆេទ",
            "holiday": "ថ្ងៃឈប់សម្រាក",
            "source": "ប្រភព",
            "impact": "ផលប៉ះពាល់កាលវិភាគ"
          },
          "source": "ប្រតិទិនក្រុមហ៊ុន",
          "non-working": "មិនធ្វើការ",
          "impact": "កម្មវិធីរៀបកាលវិភាគមិនដែលគ្រោងការចុះនៅថ្ងៃនេះទេ។ អានប៉ុណ្ណោះនៅទីនេះ — ថ្ងៃឈប់សម្រាកត្រូវបានថែទាំនៅក្នុងប្រតិទិនក្រុមហ៊ុន។",
          "impact-range": "កម្មវិធីរៀបកាលវិភាគមិនដែលគ្រោងការចុះនៅចន្លោះថ្ងៃនេះទេ។ អានប៉ុណ្ណោះនៅទីនេះ — ថ្ងៃឈប់សម្រាកត្រូវបានថែទាំនៅក្នុងប្រតិទិនក្រុមហ៊ុន។",
          "empty": "គ្មានថ្ងៃឈប់សម្រាកសាធារណៈក្នុង {month} នៅលើប្រតិទិនក្រុមហ៊ុនទេ។"
        },
        "cancelled": "បានលុបចោលភាពមិនអាចចុះបាន — ថ្ងៃទាំងនោះអាចរៀបកាលវិភាគបានវិញ"
      },
      "unav": {
        "title": "កត់ត្រាភាពមិនអាចចុះហាងបាន",
        "close": "បិទ",
        "sub": "ភាពមិនអាចចុះបានជាបណ្ដោះអាសន្ន — ការបិទជាអចិន្ត្រៃយ៍ស្ថិតនៅជាមួយ Site/Outlet Master; ការលាលែងស្ថិតនៅជាមួយ HR/People។",
        "f": {
          "site": "ហាង *",
          "type": "ប្រភេទ *",
          "from": "ថ្ងៃចាប់ផ្ដើម *",
          "to": "ថ្ងៃបញ្ចប់ *",
          "reason": "មូលហេតុ *",
          "reopen": "ថ្ងៃរំពឹងថាបើកឡើងវិញ",
          "notes": "កំណត់ចំណាំ (ស្រេចចិត្ត)"
        },
        "select-outlet": "— ជ្រើសរើសហាង —",
        "reason-ph": "ឧ. ការរាប់ស្តុក",
        "reopen-hint": "លំនាំដើមគឺថ្ងៃបន្ទាប់ពីថ្ងៃបញ្ចប់។ អាចកែបាន — ការបើកឡើងវិញគឺជាការរំពឹងទុក។",
        "notes-ph": "បន្ថែមព័ត៌មានលម្អិតផ្សេងទៀត…",
        "by-a": "កត់ត្រាដោយ",
        "by-b": "{ts} · រាល់ការកត់ត្រា និងការលុបចោលត្រូវបានធ្វើសវនកម្ម។",
        "cancel": "បោះបង់",
        "submit": "កត់ត្រាភាពមិនអាចចុះបាន",
        "recorded": "បានកត់ត្រាភាពមិនអាចចុះបាន — ការចុះដែលបានគ្រោងនៅថ្ងៃទាំងនោះត្រូវបានលើកលែង មិនមែនខកខានទេ",
        "recorded-conflicts": "បានកត់ត្រាភាពមិនអាចចុះបាន — ការចុះដែលបានគ្រោងនៅថ្ងៃទាំងនោះត្រូវបានលើកលែង មិនមែនខកខានទេ · ការចុះនាពេលអនាគតដែលបានអនុម័ត {n} រងផលប៉ះពាល់ — សូមប្រើការកែប្រែ/ប្ដូរកាលវិភាគ",
        "types": {
          "0": "ការបិទអាជីវកម្មបណ្ដោះអាសន្ន",
          "1": "ការជួសជុល",
          "2": "ការរាប់សារពើភ័ណ្ឌ / ស្តុក",
          "3": "រយៈពេលមិនចុះតាមសំណើម្ចាស់ហាង",
          "4": "អាសន្ន",
          "5": "ការរឹតបន្តឹងការចូល",
          "6": "ព្រឹត្តិការណ៍មូលដ្ឋាន",
          "7": "ផ្សេងៗ"
        },
        "err": {
          "pick-outlet": "សូមជ្រើសរើសហាង។",
          "start-required": "ត្រូវការថ្ងៃចាប់ផ្ដើម។",
          "end-before-start": "ថ្ងៃបញ្ចប់ត្រូវតែនៅថ្ងៃ ឬក្រោយថ្ងៃចាប់ផ្ដើម។",
          "reason-required": "ត្រូវការមូលហេតុ។",
          "reopen-after-end": "ថ្ងៃរំពឹងថាបើកឡើងវិញត្រូវតែក្រោយថ្ងៃបញ្ចប់។",
          "end-before-new-start": "ថ្ងៃបញ្ចប់ឥឡូវនៅមុនថ្ងៃចាប់ផ្ដើមថ្មី — សូមកែថ្ងៃបញ្ចប់។"
        }
      }
    },
    "admin-settings": {
      "title": "Admin",
      "subtitle": "ការកំណត់រចនាសម្ព័ន្ធអ្នកជួល · ទិន្នន័យមេ · គោលនយោបាយ · វេទិកា",
      "toast-open": "បើក {name}",
      "title-open": "បើក {name}",
      "groups": {
        "company": {
          "label": "ក្រុមហ៊ុន",
          "tiles": {
            "profile": {
              "title": "ប្រវត្តិក្រុមហ៊ុន",
              "desc": "ទិដ្ឋភាពអ្នកជួល · ទីតាំង · គោលនយោបាយ"
            },
            "users-roles": {
              "title": "អ្នកប្រើ និងតួនាទី",
              "desc": "ម៉ាទ្រីសសិទ្ធិ"
            },
            "modules": {
              "title": "ម៉ូឌុល",
              "desc": "បើក/បិទ តាមអ្នកជួល"
            }
          }
        },
        "setup": {
          "label": "ការរៀបចំ · ទិន្នន័យមេ",
          "tiles": {
            "employment-types": {
              "title": "ប្រភេទការងារ",
              "desc": "ពេញម៉ោង, ខ្លះៗ, ហាត់ការ, បណ្ដោះអាសន្ន"
            },
            "contract-types": {
              "title": "ប្រភេទកិច្ចសន្យា",
              "desc": "UDC, FDC, អ្នកប្រឹក្សា, ការសាកល្បង"
            },
            "cost-centers": {
              "title": "មជ្ឈមណ្ឌលថ្លៃដើម",
              "desc": "ការបែងចែកហិរញ្ញវត្ថុគ្រប់ម៉ូឌុល"
            },
            "approval-workflows": {
              "title": "លំហូរការអនុម័ត",
              "desc": "ច្បាប់ការណែនាំឆ្លងម៉ូឌុល"
            }
          }
        },
        "policies": {
          "label": "គោលនយោបាយ"
        },
        "platform": {
          "label": "វេទិកា",
          "tiles": {
            "localization": {
              "title": "ការធ្វើមូលដ្ឋាន",
              "desc": "ភាសាអង់គ្លេស + ខ្មែរ · ទម្រង់កាលបរិច្ឆេទ · តំបន់ម៉ោង"
            },
            "audit-log": {
              "title": "កំណត់ហេតុ Audit",
              "desc": "ការផ្លាស់ប្ដូរទាំងអស់ត្រូវបានកត់ត្រា"
            },
            "data-privacy": {
              "title": "ទិន្នន័យ និងភាពឯកជន",
              "desc": "ការរក្សា PDPA នាំចេញ លុប"
            }
          }
        }
      },
      "workspace": {
        "title": "ការកំណត់កន្លែងធ្វើការ និងអ្នកជួល",
        "desc": "ប្រភេទអាជីវកម្ម · វិក្កយបត្រ · អាសយដ្ឋាន · ការជាវ · ទំនាក់ទំនង"
      }
    },
    "admin-policies": {
      "title": "គោលការណ៍",
      "subtitle": "ពិនិត្យ និងកែសម្រួលគោលការណ៍ និងការកំណត់ម៉ូឌុលធនធានមនុស្សរបស់ក្រុមហ៊ុននេះ។ ការផ្លាស់ប្តូរនឹងមានប្រសិទ្ធភាពលើដំណើរការពាក់ព័ន្ធ។",
      "back": "ត្រឡប់ទៅ Admin",
      "back-to-cards": "ត្រឡប់ទៅគោលការណ៍",
      "areas": {
        "attendance": {
          "title": "វត្តមាន",
          "desc": "ច្បាប់ចុះម៉ោង រយៈពេលអនុគ្រោះ ការសម្រាក និងការអនុវត្តទីតាំង"
        },
        "employment": {
          "title": "ការងារ",
          "desc": "រយៈពេលជូនដំណឹង FDC និង UDC និងការរំលឹកកិច្ចសន្យា"
        },
        "leave": {
          "title": "ការឈប់សម្រាក",
          "desc": "ការប្រមូលផ្ដុំ ការ​ផ្ដល់​សិទ្ធិ និងច្បាប់ស្នើសុំការឈប់សម្រាក"
        },
        "schedule": {
          "title": "កាលវិភាគ",
          "desc": "ម៉ោងធ្វើការ វេន និងការកំណត់ច្បាប់ការងារ"
        },
        "localization": {
          "title": "ការធ្វើមូលដ្ឋានីយកម្ម",
          "desc": "ភាសា រូបិយប័ណ្ណ និងទ្រង់ទ្រាយតំបន់"
        },
        "overtime": {
          "title": "ការងារបន្ថែមម៉ោង",
          "desc": "ដែនកំណត់សំណើ អត្រា មេគុណ និងមូលដ្ឋានគណនាការងារបន្ថែមម៉ោង"
        }
      },
      "groups": {
        "attendance": {
          "clock-settings": "ការកំណត់ការចុះម៉ោង",
          "overtime-grace": "ម៉ោងបន្ថែម និងរយៈពេលអនុគ្រោះ",
          "breaks-reminders": "ការសម្រាក និងការរំលឹក",
          "location-enforcement": "ការអនុវត្តទីតាំង"
        },
        "employment": {
          "fdc": "កិច្ចសន្យាមានកំណត់ (FDC)",
          "udc": "កិច្ចសន្យាគ្មានកំណត់ (UDC)"
        },
        "other": "ផ្សេងៗ"
      },
      "row": {
        "value": "តម្លៃ៖",
        "edit-value": "កែសម្រួល {name}",
        "errors": {
          "min": "តម្លៃត្រូវតែយ៉ាងតិច {min}។",
          "max": "តម្លៃត្រូវតែយ៉ាងច្រើន {max}។",
          "required": "តម្រូវឱ្យមានតម្លៃ។",
          "not-a-number": "សូមបញ្ចូលលេខ។",
          "range-numbers": "សូមបញ្ចូលទាំងអប្បបរមា និងអតិបរមា ជាលេខ។",
          "range-min-max": "អប្បបរមាមិនត្រូវលើសអតិបរមាទេ។",
          "range-bounds-min": "តម្លៃទាំងពីរត្រូវតែយ៉ាងតិច {min}។",
          "range-bounds-max": "តម្លៃទាំងពីរត្រូវតែយ៉ាងច្រើន {max}។",
          "time-format": "សូមបញ្ចូលម៉ោងចាប់ផ្ដើម និងម៉ោងបញ្ចប់។",
          "time-order": "ម៉ោងបញ្ចប់ត្រូវតែក្រោយម៉ោងចាប់ផ្ដើម។"
        },
        "changed": "បានផ្លាស់ប្ដូរ",
        "default": "លំនាំដើម៖ {value}",
        "reset": "កំណត់ {name} ទៅលំនាំដើមវិញ ({value})",
        "read-only": "កំណត់ដោយប្រព័ន្ធ",
        "start-time": "{name} — ម៉ោងចាប់ផ្ដើម",
        "end-time": "{name} — ម៉ោងបញ្ចប់",
        "range-min": "{name} — អប្បបរមា",
        "range-max": "{name} — អតិបរមា",
        "hint-range": "អនុញ្ញាតពី {min} ដល់ {max}",
        "hint-step": "ជាជំហាន {step}",
        "hint-waived": "ចន្លោះណាមួយក៏បាន — ដែនកំណត់ច្បាប់ការងារត្រូវបានបិទ"
      },
      "error": {
        "title": "មិនអាចផ្ទុកគោលការណ៍បានទេ",
        "desc": "មានបញ្ហាក្នុងការផ្ទុកគោលការណ៍របស់ក្រុមហ៊ុននេះ។ សូមព្យាយាមម្ដងទៀត។"
      },
      "no-company": {
        "title": "គ្មានក្រុមហ៊ុនសកម្ម",
        "desc": "សូមជ្រើសរើសក្រុមហ៊ុនពីកន្លែងប្ដូរ ដើម្បីគ្រប់គ្រងគោលការណ៍របស់វា។"
      },
      "empty": {
        "title": "គ្មានការកំណត់ដែលអាចកំណត់បាន",
        "desc": "ផ្នែកនេះមិនទាន់មានគោលការណ៍ ឬការកំណត់ដែលអាចកំណត់បានឡើយ។"
      },
      "unknown": {
        "title": "ផ្នែកគោលការណ៍មិនស្គាល់",
        "desc": "ផ្នែកគោលការណ៍នោះមិនមានទេ។ សូមជ្រើសរើសផ្នែកមួយក្នុងចំណោមផ្នែកដែលមាន។"
      },
      "pending-note": "មានប្រសិទ្ធភាពនៅពេល {module} ផ្លាស់ទៅ V2។ ការផ្លាស់ប្ដូររបស់អ្នកត្រូវបានរក្សាទុកឥឡូវនេះ ហើយនឹងត្រូវប្រើនៅពេលនោះ។",
      "no-id": "ការកំណត់របស់ក្រុមហ៊ុននេះសម្រាប់ផ្នែកនេះ មិនទាន់មានកំណត់ត្រាដែលបានរក្សាទុកនៅលើម៉ាស៊ីនមេនៅឡើយទេ ដូច្នេះមិនអាចផ្លាស់ប្ដូរនៅទីនេះបានទេ។ វាបង្ហាញតម្លៃលំនាំដើមរបស់ប្រព័ន្ធ។",
      "zones-link": "គ្រប់គ្រងតំបន់ការងារ",
      "save-errors": {
        "forbidden": "អ្នកមិនមានសិទ្ធិផ្លាស់ប្ដូរគោលការណ៍របស់ក្រុមហ៊ុននេះទេ។",
        "conflict": "ការកំណត់នេះត្រូវបានផ្លាស់ប្ដូរដោយអ្នកផ្សេង។ សូមផ្ទុកទំព័រឡើងវិញ ហើយព្យាយាមម្ដងទៀត។",
        "generic": "មិនអាចរក្សាទុកការផ្លាស់ប្ដូរបានទេ។ សូមព្យាយាមម្ដងទៀត។"
      },
      "history": {
        "button": "ប្រវត្តិកែសម្រួល",
        "title": "{area} — ប្រវត្តិកែសម្រួល",
        "overrides": "តម្លៃដែលបានផ្លាស់ប្ដូរ"
      },
      "orphans": {
        "title": "គន្លឹះដែលលែងប្រើ",
        "empty": "គ្មានគន្លឹះដែលលែងប្រើទេ។ តម្លៃដែលបានរក្សាទុកទាំងអស់ជារបស់ការកំណត់បច្ចុប្បន្ន។",
        "error": "មិនអាចផ្ទុកគន្លឹះដែលលែងប្រើបានទេ។"
      }
    },
    "pay": {
      "center": {
        "title": "មជ្ឈមណ្ឌលប្រាក់ខែ",
        "subtitle-upcoming": "រៀបចំការដំណើរការប្រាក់ខែខាងមុខ មុនកាលបរិច្ឆេទកំណត់ និងបង់ប្រាក់",
        "subtitle-in-progress": "បន្តដំណើរការប្រាក់ខែ (កំពុងធ្វើ)",
        "subtitle-completed": "ពិនិត្យលទ្ធផលប្រាក់ខែដែលបានអនុម័ត និងចាក់សោ",
        "subtitle-error": "មិនអាចផ្ទុកកាលវិភាគប្រាក់ខែបានទេ",
        "error": "មិនអាចផ្ទុកកាលវិភាគប្រាក់ខែ — {message}",
        "off-cycle": {
          "button": "ប្រាក់ខែក្រៅវាគ្គ",
          "types": {
            "bonus": "ប្រាក់រង្វាន់",
            "incentive": "ប្រាក់លើកទឹកចិត្ត",
            "adjustment": "ការកែតម្រូវ",
            "final-pay": "ប្រាក់ខែចុងក្រោយ",
            "special": "ប្រាក់ខែពិសេស"
          }
        },
        "filters": {
          "all": "ទាំងអស់",
          "upcoming": "ខាងមុខ",
          "in-progress": "កំពុងដំណើរការ",
          "off-cycle": "ក្រៅវាគ្គ",
          "completed": "បានបញ្ចប់",
          "label": "តម្រងកាលវិភាគ"
        },
        "schedule": {
          "title": "កាលវិភាគ",
          "subtitle": "មើលការដំណើរការប្រាក់ខែតាមស្ថានភាព",
          "scroll-left": "រំកិលកាលវិភាគទៅឆ្វេង",
          "scroll-right": "រំកិលកាលវិភាគទៅស្ដាំ"
        },
        "status": {
          "upcoming": "ខាងមុខ",
          "in-progress": "កំពុងដំណើរការ",
          "off-cycle": "ក្រៅវាគ្គ",
          "completed": "បានបញ្ចប់"
        },
        "empty": {
          "description": "មិនមានការដំណើរការប្រាក់ខែណាមួយត្រូវនឹងតម្រងនេះទេ។"
        },
        "retry": "ព្យាយាមម្ដងទៀត",
        "yes": "បាទ/ចាស",
        "result-count": "ការដំណើរការប្រាក់ខែ {n} ក្នុងតម្រងនេះ",
        "card": {
          "paid": "បានបង់",
          "est": "ប៉ាន់ស្មាន",
          "opens": "បើកនៅ {date}",
          "later": "ពេលក្រោយ",
          "approved": "បានអនុម័ត: {date}",
          "paid-date": "ថ្ងៃបង់ប្រាក់: {date}",
          "cut-off": "ថ្ងៃផុតកំណត់: {date}",
          "pay-date": "ថ្ងៃបើកប្រាក់: {date}",
          "pay-period": "រយៈពេលប្រាក់ខែ: {period}",
          "net-pay": "ប្រាក់ខែសុទ្ធ",
          "progress": "វឌ្ឍនភាព",
          "step-of": "ជំហាន {n} នៃ {total}"
        },
        "ip": {
          "current": "ការដំណើរការប្រាក់ខែបច្ចុប្បន្ន",
          "validate": "ផ្ទៀងផ្ទាត់",
          "resume": "បន្តដំណើរការ",
          "emps": "បុគ្គលិកក្នុងការដំណើរការ",
          "emps-sub-first": "ទាំងអស់មានសិទ្ធិទទួលប្រាក់បុរេប្រទាន",
          "emps-sub-second": "{n} រួចរាល់សម្រាប់ការផ្ទៀងផ្ទាត់ពេញលេញ",
          "net-first": "ប្រាក់ខែសុទ្ធប៉ាន់ស្មាន (បុរេប្រទាន)",
          "net-second": "ប្រាក់ខែសុទ្ធប៉ាន់ស្មាន",
          "net-sub-first": "ប្រាក់ខែគោល 50% · ពន្ធ/ប.ស.ស នៅលើកទី 2",
          "net-sub-second": "បន្ទាប់ពីពន្ធ TOS / ប.ស.ស / FBT / បុរេប្រទាន",
          "warn": {
            "bank-account": "គណនីធនាគារ 1",
            "count-blockers": "ឧបសគ្គ {n} | ឧបសគ្គ {n}",
            "count-warnings": "ការព្រមាន {n} | ការព្រមាន {n}",
            "label-blockers": "ឧបសគ្គ",
            "label-warnings": "ការព្រមាន",
            "label-issues": "បញ្ហា",
            "sub-blockers": "ត្រូវដោះស្រាយមុនជំហានបន្ទាប់",
            "sub-acknowledged": "មិនរារាំង · បានទទួលស្គាល់នៅជំហានទី 1 កំពុងរង់ចាំការដោះស្រាយ",
            "sub-eligibility": "មិនរារាំង · សិទ្ធិទទួល",
            "sub-clear": "គ្មានបញ្ហា"
          },
          "steps-title": "ជំហាននៃការដំណើរការប្រាក់ខែ",
          "steps-sub": "តាមដានវឌ្ឍនភាពពេញវដ្តនៃការដំណើរការ",
          "step": {
            "1": "សិទ្ធិទទួល",
            "2": "ពិនិត្យទិន្នន័យបញ្ចូល",
            "3": "ការគណនា",
            "4": "ការអនុម័ត",
            "5": "ការទូទាត់ និងប័ណ្ណប្រាក់ខែ"
          },
          "step-state": {
            "done": "រួចរាល់",
            "active": "កំពុងដំណើរការ",
            "pending": "កំពុងរង់ចាំ"
          },
          "first-note-title": "ប្រាក់ខែលើកទី 1 — បុរេប្រទាន 50% នៃប្រាក់ខែគោល",
          "first-note": "ពន្ធ (TOS) និង ប.ស.ស មិនអនុវត្តលើប្រាក់ខែលើកទី 1 ទេ។ វាត្រូវបានគណនានៅប្រាក់ខែលើកទី 2 (27 កុម្ភៈ) នៅពេលដឹងពីប្រាក់ចំណូលពេញមួយខែ។ បុរេប្រទានដែលបានបង់នៅទីនេះ នឹងត្រូវកាត់ដោយស្វ័យប្រវត្តិពីប្រាក់សុទ្ធនៃប្រាក់ខែលើកទី 2។",
          "hc": "ចំនួនបុគ្គលិកក្នុងការដំណើរការ",
          "hc-sub": "+1 បុគ្គលិកថ្មី ធៀបនឹងលើកមុន",
          "adv": "ប្រាក់សុទ្ធបុរេប្រទាន",
          "adv-sub": "50% នៃប្រាក់ខែគោល (បុរេប្រទាន)។",
          "issues": "បញ្ហាផ្ទៀងផ្ទាត់",
          "issues-sub": "ការព្រមាន — មិនរារាំង អាចបន្តទៅការគណនាបាន។",
          "quick-title": "ការពិនិត្យរហ័ស",
          "quick-tax": "ប្រវត្តិពន្ធត្រឹមត្រូវ",
          "quick-bank": "គណនីធនាគារត្រឹមត្រូវ",
          "quick-att": "វត្តមានបានចាក់សោ",
          "quick-note": "បញ្ចប់ការផ្ទៀងផ្ទាត់ ដើម្បីដោះសោជំហានអនុម័ត។",
          "validate-ok": "ការផ្ទៀងផ្ទាត់បានជោគជ័យ — រួចរាល់ដើម្បីបន្តទៅការគណនា",
          "validate-issues": "ឧបសគ្គ {blockers} · ការព្រមាន {warnings} — កំពុងបើកមជ្ឈមណ្ឌលបញ្ហា"
        },
        "dept": {
          "mode-label": "មូលដ្ឋាននៃការបែងចែក",
          "amount": "ចំនួនទឹកប្រាក់",
          "share": "% ចំណែក",
          "draft-title": "ការបែងចែកព្រាងតាមនាយកដ្ឋាន",
          "draft-sub": "មើលជាមុន (ព្រាង) — ស្របនឹងការវិភាគប្រាក់ខែកន្លងមក",
          "completed-title": "ការបែងចែកប្រាក់ខែតាមនាយកដ្ឋាន",
          "completed-sub": "ទិន្នន័យប្រាក់ខែកន្លងមក — តែប្រាក់ខែដែលបានបញ្ចប់"
        },
        "done": {
          "summary": "សេចក្ដីសង្ខេបប្រាក់ខែចុងក្រោយ",
          "run-id": "លេខសម្គាល់ការដំណើរការ",
          "locked": "បានអនុម័ត និងចាក់សោ",
          "approved": "បានអនុម័ត {date}",
          "paid": "បានបង់ {date}",
          "employees": "បុគ្គលិក {n} នាក់",
          "view": "មើលព័ត៌មានលម្អិតប្រាក់ខែ",
          "kpi-hc": "ចំនួនបុគ្គលិកសរុបដែលបានបង់",
          "kpi-net": "ប្រាក់ខែសុទ្ធសរុប",
          "kpi-net-sub": "ការទូទាត់ចុងក្រោយបន្ទាប់ពីបុរេប្រទានលើកទី 1",
          "kpi-gross": "ប្រាក់ខែដុលសរុប",
          "kpi-gross-sub": "ប្រាក់ខែគោល + ម៉ោងបន្ថែម + ប្រាក់រង្វាន់ + ប្រាក់លើកទឹកចិត្ត + ច្បាប់ឈប់សម្រាកមានប្រាក់ខែ",
          "kpi-ded": "ការកាត់កងសរុប",
          "kpi-ded-sub": "ពន្ធ + ប.ស.ស + ច្បាប់គ្មានប្រាក់ខែ + ការទូទាត់បុរេប្រទាន + ផ្សេងៗ",
          "earnings": "ការវិភាគប្រាក់ចំណូល",
          "final": "ចុងក្រោយ",
          "basic": "ប្រាក់ខែគោល",
          "ot": "ម៉ោងបន្ថែម",
          "bonus": "ប្រាក់រង្វាន់",
          "incentive": "ប្រាក់លើកទឹកចិត្ត",
          "leave": "ច្បាប់ឈប់សម្រាកមានប្រាក់ខែ",
          "deductions": "ការវិភាគការកាត់កង",
          "unpaid": "ច្បាប់ឈប់សម្រាកគ្មានប្រាក់ខែ",
          "tax": "ពន្ធ (TOS)",
          "nssf": "ប.ស.ស (បុគ្គលិក)",
          "advance": "ការទូទាត់បុរេប្រទានលើកទី 1",
          "other": "ការកាត់កងផ្សេងៗ",
          "unpaid-note": "គឺជាការកាត់ប្រាក់ពីប្រាក់ខែគោល (មិនមែនជាពន្ធ ឬការពិន័យទេ)។",
          "bonuses-title": "ប្រាក់រង្វាន់ និងប្រាក់លើកទឹកចិត្ត",
          "total-bonuses": "ប្រាក់រង្វាន់សរុប",
          "total-incentives": "ប្រាក់លើកទឹកចិត្តសរុប",
          "rewarded": "បុគ្គលិកដែលទទួលរង្វាន់",
          "rewarded-note": "សម្រាប់បញ្ជីបុគ្គលិកពេញលេញ សូមបើក មើលព័ត៌មានលម្អិតប្រាក់ខែ។",
          "compliance": "រូបភាពអនុលោមភាពប្រាក់ខែ",
          "compliance-sub": "សេចក្ដីសង្ខេបងាយស្រួលសវនកម្មសម្រាប់ប្រាក់ខែដែលបានអនុម័ត",
          "compliant": "អនុលោម",
          "c-cycle": "វដ្តប្រាក់ខែ",
          "c-cycle-v": "ពីរដងក្នុងមួយខែ",
          "c-tax": "បានអនុវត្តពន្ធ",
          "c-nssf": "បានអនុវត្ត ប.ស.ស",
          "c-currency": "រូបិយប័ណ្ណ",
          "c-offset": "ការទូទាត់ប្រាក់ខែលើកទី 1",
          "c-offset-v": "បានអនុវត្ត (លើកទី 2)",
          "c-rounding": "ការបង្គត់",
          "c-rounding-v": "2 ខ្ទង់ទសភាគ",
          "c-by": "បញ្ចប់ដោយ",
          "c-by-v": "ធនធានមនុស្ស និងហិរញ្ញវត្ថុ",
          "c-trail": "ប្រវត្តិអនុម័ត",
          "c-trail-v": "មាន"
        },
        "export": {
          "button": "នាំចេញរបាយការណ៍",
          "failed": "មិនអាចនាំចេញរបាយការណ៍បានទេ — {message}",
          "payroll-detail": "ព័ត៌មានលម្អិតប្រាក់ខែ",
          "tax-report": "របាយការណ៍ពន្ធ (TOS)",
          "nssf-report": "របាយការណ៍ ប.ស.ស"
        },
        "up": {
          "next": "ប្រាក់ខែបន្ទាប់",
          "off-badge": "ក្រៅវាគ្គ · {kind}",
          "start": "ចាប់ផ្ដើមប្រាក់ខែ",
          "est": "ចំនួនបុគ្គលិកប៉ាន់ស្មាន",
          "required": "ទិន្នន័យបញ្ចូលដែលត្រូវការ",
          "status": "ស្ថានភាព",
          "off-demo": "ក្រៅវាគ្គ · សម្រាប់សាកល្បងតែប៉ុណ្ណោះ",
          "status-blockers": "ឧបសគ្គ {n} | ឧបសគ្គ {n}",
          "status-pending": "ទិន្នន័យបញ្ចូល {n} កំពុងរង់ចាំ | ទិន្នន័យបញ្ចូល {n} កំពុងរង់ចាំ",
          "status-ready": "រួចរាល់ដើម្បីចាប់ផ្ដើម",
          "checklist": "បញ្ជីត្រួតពិនិត្យការរៀបចំ",
          "checklist-sub": "តាមដានការត្រៀមខ្លួនមុនថ្ងៃផុតកំណត់",
          "open-items": "ធាតុបើក {n}",
          "ready-of": "រួចរាល់ {ready} នៃ {total}",
          "card": {
            "att": "ការផុតកំណត់វត្តមាន",
            "ota": "ម៉ោងបន្ថែម និងប្រាក់ឧបត្ថម្ភ",
            "roster": "បុគ្គលិកថ្មី / ចាកចេញ",
            "tax": "បច្ចុប្បន្នភាពពន្ធ/ប.ស.ស"
          },
          "card-state": {
            "ready": "រួចរាល់",
            "in-progress": "កំពុងដំណើរការ",
            "not-started": "មិនទាន់ចាប់ផ្ដើម",
            "pending": "កំពុងរង់ចាំ {n}",
            "review": "ពិនិត្យ",
            "blocker": "ឧបសគ្គ"
          },
          "start-note": "នៅពេលអ្នកចុច ចាប់ផ្ដើមប្រាក់ខែ ប្រព័ន្ធនឹងចាក់សោទិន្នន័យបញ្ចូល ហើយចាប់ផ្ដើមការផ្ទៀងផ្ទាត់។",
          "off-inputs": {
            "final-pay": "សេចក្ដីជូនដំណឹងបញ្ចប់ការងារ · ច្បាប់ឈប់សម្រាកសន្សំ · ការបញ្ចប់ពន្ធ/ប.ស.ស ចុងក្រោយ",
            "bonus": "បញ្ជីប្រាក់រង្វាន់ដែលបានអនុម័តជាមុន",
            "incentive": "បញ្ជីប្រាក់លើកទឹកចិត្តដែលបានអនុម័តជាមុន",
            "adjustment": "ការកែតម្រូវដោយដៃ",
            "special": "ទិន្នន័យបញ្ចូលផ្ទាល់ខ្លួន",
            "other": "ទិន្នន័យបញ្ចូលក្រៅវាគ្គ"
          },
          "all-collected": "បានប្រមូលទាំងអស់",
          "input": {
            "attendance": "វត្តមាន",
            "ot": "កំណត់ត្រាម៉ោងបន្ថែម",
            "allowance": "ប្រាក់ឧបត្ថម្ភ",
            "bonus": "ប្រាក់រង្វាន់ / អថេរ"
          },
          "locked-title": "រយៈពេលប្រាក់ខែមិនទាន់ចាប់ផ្ដើមនៅឡើយទេ",
          "off-title": "ក្រៅវាគ្គ {kind} — សាកល្បងតាមរយៈកាតកំពុងដំណើរការ / ខាងមុខធម្មតា",
          "locked-toast": "ប្រាក់ខែនេះនឹងបើកនៅពេលរយៈពេលប្រាក់ខែចាប់ផ្ដើម។ មិនទាន់មានទិន្នន័យសម្រាប់ពិនិត្យនៅឡើយទេ។"
        },
        "prep": {
          "collect": "ប្រមូលទិន្នន័យបញ្ចូល",
          "precheck": "ពិនិត្យជាមុន",
          "open-collect": "បើកការប្រមូលទិន្នន័យបញ្ចូល",
          "open-precheck": "បើកការពិនិត្យជាមុន",
          "ci-sub": "កំឡុងពេលប្រាក់ខែ {period} · ថ្ងៃផុតកំណត់ {cutOff}",
          "ci-received": "បានទទួលប្រភព {collected} នៃ {total}",
          "due": "ផុតកំណត់ {date}",
          "ci-lifecycle": "ប្រភពនីមួយៗបន្តដំណាក់កាល៖ មិនទាន់ចាប់ផ្ដើម → បានស្នើ → មួយផ្នែក → បានទទួល។ សម្គាល់ថាបានទទួលនៅពេលទិន្នន័យនៅក្នុងប្រព័ន្ធ។",
          "mark-all": "សម្គាល់ថាបានទទួលទាំងអស់",
          "mark-all-toast": "ទិន្នន័យបញ្ចូលទាំងអស់ត្រូវបានសម្គាល់ថាបានទទួល",
          "cols": {
            "source": "ប្រភពទិន្នន័យបញ្ចូល",
            "owner": "ម្ចាស់",
            "method": "វិធីសាស្ត្រ",
            "status": "ស្ថានភាព",
            "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
            "actions": "សកម្មភាព"
          },
          "records": "កំណត់ត្រា {n} | កំណត់ត្រា {n}",
          "just-now": "អម្បាញ់មិញ",
          "send-request": "ផ្ញើសំណើ",
          "send-reminder": "ផ្ញើការរំលឹក",
          "mark-received": "សម្គាល់ថាបានទទួល",
          "reopen": "បើកឡើងវិញ",
          "ci-foot": "ការបិទប្រអប់នេះនឹងនាំអ្នកត្រឡប់ទៅទិដ្ឋភាពប្រាក់ខែនាពេលខាងមុខ។",
          "close": "បិទ",
          "status": {
            "received": "បានទទួល",
            "partial": "មួយផ្នែក",
            "requested": "បានស្នើ",
            "not-required": "មិនតម្រូវ",
            "not-started": "មិនទាន់ចាប់ផ្ដើម"
          },
          "status-toast": "{source} → {status}",
          "input": {
            "attendance": {
              "label": "វត្តមាន",
              "owner": "មន្ត្រីធនធានមនុស្ស",
              "source": "TMS / ផ្ទុកឡើងដោយដៃ"
            },
            "ot": {
              "label": "កំណត់ត្រាម៉ោងបន្ថែម",
              "owner": "ប្រធាននាយកដ្ឋាន",
              "source": "ការដាក់ស្នើរបស់អ្នកគ្រប់គ្រង"
            },
            "allowance": {
              "label": "ប្រាក់ឧបត្ថម្ភ",
              "owner": "មន្ត្រីធនធានមនុស្ស",
              "source": "ថេរ + ដោយដៃ"
            },
            "bonus": {
              "label": "ប្រាក់រង្វាន់ / អថេរ",
              "owner": "អ្នកគ្រប់គ្រង",
              "source": "ការដាក់ស្នើរបស់អ្នកគ្រប់គ្រង"
            }
          },
          "pc-sub": "ការផ្ទៀងផ្ទាត់ការត្រៀមខ្លួនស្រាល · គ្មានអ្វីត្រូវបានរក្សាទុកទេ",
          "passed": "ឆ្លងកាត់ {n}",
          "warnings": "ការព្រមាន {n}",
          "blockers": "ឧបសគ្គ {n}",
          "last-run": "ដំណើរការចុងក្រោយ {when}",
          "check": {
            "roster": {
              "title": "រូបភាពបញ្ជីបុគ្គលិក",
              "detail": "សកម្ម ៣២ · បុគ្គលិកថ្មី ១ · បញ្ចប់ការងារ ១ ក្នុងកំឡុងពេលនេះ"
            },
            "bank": {
              "title": "គណនីធនាគារមានក្នុងប្រព័ន្ធ",
              "detail": "បុគ្គលិកទាំង ៣៣ នាក់មានគណនីធនាគារបានកំណត់"
            },
            "tax": {
              "title": "លេខពន្ធបានផ្ទៀងផ្ទាត់",
              "detail": "បុគ្គលិក ២ នាក់មានកំណត់ត្រាពន្ធមិនទាន់ផ្ទៀងផ្ទាត់ (E0007, E0011)",
              "fix": "បើក បុគ្គលិក · ពន្ធ"
            },
            "nssf": {
              "title": "លេខ NSSF បានកំណត់",
              "detail": "បុគ្គលិកទាំង ៣៣ នាក់មានលេខ NSSF"
            },
            "carry": {
              "title": "ការផ្ទេរពីការដំណើរការមុន",
              "detail": "បុគ្គលិកផ្អាក ០ នាក់ផ្ទេរមកការដំណើរការនេះ"
            },
            "rates": {
              "title": "អត្រាប្ដូរប្រាក់ទាន់សម័យ",
              "detail": "NSSF 4080 KHR/USD · NBC 4085 KHR/USD (កុម្ភៈ ២០២៦)"
            },
            "holidays": {
              "title": "ថ្ងៃឈប់សម្រាកសាធារណៈបានផ្ទុក",
              "detail": "ចូលឆ្នាំខ្មែរ (១៤–១៦ មេសា) បានបញ្ជាក់សម្រាប់កំឡុងពេលបន្ទាប់"
            }
          },
          "resolved-was": "បានដោះស្រាយ · ពីមុន៖ {detail}",
          "fix-toast": "បានបញ្ជូនទៅការជួសជុល — សម្គាល់ថាបានដោះស្រាយសម្រាប់គំរូ",
          "rerun": "ពិនិត្យជាមុនម្ដងទៀត",
          "rerun-toast": "ការពិនិត្យជាមុនបានដំណើរការឡើងវិញ · ឆ្លងកាត់ {pass} នៃ {total}",
          "start-blocked": "ដោះស្រាយឧបសគ្គ {n} មុនពេលចាប់ផ្ដើម | ដោះស្រាយឧបសគ្គ {n} មុនពេលចាប់ផ្ដើម",
          "start-confirm": "ការពិនិត្យជាមុនមានឧបសគ្គ {n}។ ចាប់ផ្ដើមដដែលឬ? | ការពិនិត្យជាមុនមានឧបសគ្គ {n}។ ចាប់ផ្ដើមដដែលឬ?",
          "started-pending": "បានចាប់ផ្ដើម — ទិន្នន័យបញ្ចូលខ្លះនៅរង់ចាំ។ អ្នកអាចដោះស្រាយវានៅជំហានទី ១។"
        }
      },
      "detail": {
        "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
        "meta": "កំឡុងពេលប្រាក់ខែ {start} – {end} · វដ្ត {cycle} · លេខសម្គាល់ {runId} · បង្កើតនៅ {generatedAt}",
        "badges": {
          "locked": "បានអនុម័ត និងចាក់សោ",
          "approved": "បានអនុម័តនៅ {date} ដោយ {actor}",
          "paid": "បានបង់នៅ {date}",
          "employees": "បុគ្គលិក {count} នាក់",
          "off-cycle": "ក្រៅវដ្ត: {type}"
        },
        "totals": {
          "title": "សរុបការដំណើរការ",
          "headcount-paid": {
            "label": "ចំនួនបុគ្គលិកដែលបានទទួលប្រាក់",
            "help": "ចំនួនបុគ្គលិកដែលបានទទួលការបង់ប្រាក់"
          },
          "gross": {
            "label": "ប្រាក់ខែសរុបដុល",
            "help": "មូលដ្ឋាន + ម៉ោងបន្ថែម + រង្វាន់ + ការលើកទឹកចិត្ត + ច្បាប់មានប្រាក់"
          },
          "deductions": {
            "label": "ការកាត់សរុប",
            "help": "ពន្ធ (TOS) + NSSF + ច្បាប់គ្មានប្រាក់ + ប្រាក់សងរំលឹក + ផ្សេងៗ"
          },
          "net": {
            "label": "ប្រាក់ខែសុទ្ធសរុប",
            "help": "ការបង់ប្រាក់ចុងក្រោយដល់បុគ្គលិក {count} នាក់"
          }
        },
        "earnings": {
          "title": "ប្រាក់ចំណូល",
          "total": "សរុបដុល"
        },
        "deductions": {
          "title": "ការកាត់",
          "total": "សរុបការកាត់"
        },
        "employees": {
          "title": "ព័ត៌មានបុគ្គលិក (គំរូ {n} នៃ {total})",
          "columns": {
            "employee": "បុគ្គលិក",
            "dept": "ផ្នែក",
            "pay-method": "វិធីបង់",
            "bank": "ធនាគារ",
            "gross": "ដុល",
            "tax": "ពន្ធ",
            "nssf": "NSSF",
            "other": "ការកាត់",
            "net": "សុទ្ធ"
          },
          "demo-note": "បង្ហាញកំណត់ត្រាសាកល្បង — ផលិតកម្មបង្ហាញទាំង {total}"
        },
        "compliance": {
          "title": "ការអនុលោម"
        },
        "audit": {
          "title": "ប្រវត្តិសវនកម្ម"
        },
        "export": {
          "csv": "CSV",
          "excel": "Excel",
          "pdf": "ទាញយក PDF"
        },
        "loading": "កំពុងផ្ទុកកំណត់ត្រាប្រាក់ខែ…",
        "error": "មិនអាចផ្ទុកកំណត់ត្រាប្រាក់ខែបានទេ។",
        "retry": "ព្យាយាមម្ដងទៀត",
        "footer": "បង្កើតដោយ Optimal HR — ម៉ូឌុលប្រាក់ខែ · ឯកសារនេះឆ្លុះបញ្ចាំងរូបភាពប្រាក់ខែដែលបានចាក់សោ។",
        "footer-run-id": "លេខសម្គាល់ដំណើរការ: {id}"
      },
      "run": {
        "untitled": "ការដំណើរការប្រាក់ខែ",
        "save-exit": "រក្សាទុក និងចាកចេញ",
        "save-exit-hint": "ការដំណើរការនៅតែកំពុងដំណើរការ · បន្តបានគ្រប់ពេល",
        "save-exit-title": "ការដំណើរការនៅតែកំពុងដំណើរការ — អ្នកអាចបន្តបានគ្រប់ពេលពីមជ្ឈមណ្ឌលប្រាក់ខែ",
        "identity": {
          "run-id": "ការដំណើរការ",
          "pending": "កំពុងរង់ចាំ — បង្កើតនៅជំហានទី ៣",
          "pay-date": "ថ្ងៃបើកប្រាក់៖",
          "pay-period": "រយៈពេលប្រាក់ខែ៖"
        },
        "step-title": "ជំហានទី {n} នៃ {total} — {label}",
        "steps": {
          "eligibility": "សិទ្ធិ",
          "pay-inputs": "ពិនិត្យធាតុចូលប្រាក់ខែ",
          "calculation": "ការគណនា",
          "approval": "ការអនុម័ត",
          "payment-distribution": "ការបង់ប្រាក់ និងប័ណ្ណបើកប្រាក់"
        },
        "subtitles": {
          "eligibility": "ពិនិត្យអ្នកដែលនឹងត្រូវដាក់បញ្ចូលក្នុងការដំណើរការប្រាក់ខែនេះ ហើយដោះស្រាយបញ្ហាកម្រិតបុគ្គលិកមុនធាតុចូលប្រាក់ខែ។",
          "pay-inputs": "ផ្ទៀងផ្ទាត់ភាពត្រៀមរួចរាល់នៃធាតុចូលប្រាក់ខែ។ ដោះស្រាយឧបសគ្គ រួចបញ្ជាក់ដើម្បីដោះសោការគណនា។",
          "calculation": "ដំណើរការម៉ាស៊ីនលើធាតុចូលដែលបានផ្ទៀងផ្ទាត់ ប្រៀបធៀបនឹងការដំណើរការមុនៗ ហើយដាក់ស្នើសុំការអនុម័ត។",
          "approval": "ពិនិត្យកញ្ចប់ប្រាក់ខែដែលបានដាក់ស្នើ។ អនុម័ត ឬបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ។",
          "payment-distribution": "តាមធនាគារនីមួយៗ៖ បង្កើតឯកសារ → ទូទាត់ → បង្កើតប័ណ្ណបើកប្រាក់ → ចែកចាយ។ បិទការដំណើរការនៅពេលបុគ្គលិកគ្រប់រូបត្រូវបានទូទាត់ និងចែកចាយ។"
        },
        "stepper": {
          "label": "ជំហាននៃការដំណើរការប្រាក់ខែ",
          "locked-tooltip": "សូមបញ្ចប់ជំហានមុនជាមុនសិន"
        },
        "summary-strip": {
          "in-this-run": "ក្នុងការដំណើរការនេះ",
          "eligible": "មានសិទ្ធិ",
          "excluded": "មិនរាប់បញ្ចូល",
          "warnings": "ការព្រមាន"
        },
        "warning-banner": {
          "title": "ការព្រមានទម្រង់បុគ្គលិក — មិនរារាំង",
          "subtitle": "សូមដោះស្រាយមុនជំហានទី ៥ (ការបង់ប្រាក់) ដើម្បីឱ្យឯកសារធនាគារ និងរបាយការណ៍ NSSF មានភាពត្រឹមត្រូវ។",
          "show": "បង្ហាញព័ត៌មានលម្អិត",
          "hide": "លាក់ព័ត៌មានលម្អិត"
        },
        "loading": "កំពុងផ្ទុកការដំណើរការប្រាក់ខែ…",
        "error": "មិនអាចផ្ទុកការដំណើរការប្រាក់ខែបានទេ — {message}",
        "retry": "ព្យាយាមម្តងទៀត",
        "confirm-error": "មិនអាចបញ្ជាក់បានទេ — {message}",
        "back-to-center": "ត្រឡប់ទៅមជ្ឈមណ្ឌលប្រាក់ខែ",
        "back-to": "ត្រឡប់ទៅ {step}",
        "confirm-continue-dot": "បញ្ជាក់ · បន្តទៅ {step}",
        "confirm-continue-to": "បញ្ជាក់ និងបន្តទៅ {step}",
        "confirm-passthrough": "បញ្ជាក់ការឆ្លងកាត់ · បន្តទៅ {step}",
        "resolve": {
          "issue": "បញ្ហា",
          "blocker": "ឧបសគ្គ",
          "warning": "ការព្រមាន",
          "choose": "ជ្រើសរើសវិធីដោះស្រាយ៖",
          "resolve": "ដោះស្រាយ",
          "close": "បិទ",
          "cancel": "បោះបង់",
          "apply": "អនុវត្ត",
          "select": "ជ្រើសរើស...",
          "missing": "ខ្វះ៖ {fields}",
          "audit": "ការដោះស្រាយត្រូវបានកត់ត្រាសវនកម្ម (អ្នកធ្វើ ពេលវេលា មុន/ក្រោយ) ហើយធ្វើបច្ចុប្បន្នភាពកំណត់ត្រាបុគ្គលិកកណ្តាល។",
          "forms": {
            "add-bank": "បន្ថែមគណនីធនាគារ",
            "add-nssf": "បន្ថែមលេខ NSSF",
            "adjust": "កែតម្រូវចំនួនទឹកប្រាក់ក្នុងកម្រិត",
            "edit": "កែម៉ោងបន្ថែម"
          },
          "fields": {
            "bank": "ធនាគារ",
            "bankAccount": "លេខគណនី",
            "nssfId": "លេខ NSSF",
            "newAmount": "ចំនួនថ្មី (USD)",
            "weekday": "ម៉ោងថ្ងៃធ្វើការ",
            "dayOff": "ម៉ោងថ្ងៃឈប់"
          },
          "actions": {
            "add-bank": "បន្ថែមគណនីធនាគារនៅទីនេះ",
            "cash": "បង់ជាសាច់ប្រាក់",
            "cheque": "បង់ដោយមូលប្បទានប័ត្រ",
            "hold": "ពន្យារទៅការដំណើរការបន្ទាប់",
            "exclude": "មិនរាប់បញ្ចូលក្នុងការដំណើរការនេះ",
            "verify-tax": "ផ្ទៀងផ្ទាត់ទម្រង់ពន្ធ (និវាសនជន)",
            "add-nssf": "បន្ថែមលេខ NSSF"
          }
        },
        "step1": {
          "loading": "កំពុងផ្ទុកសិទ្ធិ…",
          "error": "មិនអាចផ្ទុកសិទ្ធិបានទេ។",
          "kpi": {
            "total": {
              "label": "បុគ្គលិកសរុប",
              "help": "បានពិនិត្យក្នុងការដំណើរការនេះ"
            },
            "ready": {
              "label": "មានសិទ្ធិ និងត្រៀមរួចរាល់",
              "help": "ប្រាក់ខែគោលសរុប ${amount}"
            },
            "action": {
              "label": "ការព្រមាន",
              "help": "មិនរារាំង · ដោះស្រាយនៅពេលរួចរាល់"
            },
            "excluded": {
              "label": "គ្មានសិទ្ធិ / មិនរាប់បញ្ចូល",
              "sub-newhires": "បុគ្គលិកថ្មី {n} នាក់ពន្យារទៅការដំណើរការបន្ទាប់ | បុគ្គលិកថ្មី {n} នាក់ពន្យារទៅការដំណើរការបន្ទាប់",
              "sub-manual": "មិនរាប់បញ្ចូលដោយដៃ · មិនបង់ក្នុងការដំណើរការនេះ",
              "sub-none": "គ្មានប្រាក់ត្រូវបានរក្សាទុក ($0)"
            }
          },
          "list": {
            "label": {
              "all": "កំពុងបង្ហាញ · បុគ្គលិកទាំងអស់ក្នុងការដំណើរការ",
              "ready": "កំពុងបង្ហាញ · មានសិទ្ធិ និងត្រៀមរួចរាល់",
              "action": "កំពុងបង្ហាញ · ការព្រមាន",
              "excluded": "កំពុងបង្ហាញ · ពន្យារ / មិនរាប់បញ្ចូល"
            },
            "help": {
              "all": "បញ្ជីពេញលេញគ្រប់ក្រុម។ ប្រើតម្រងខាងលើដើម្បីផ្តោត។",
              "ready": "ជ្រើសជួរដើម្បីពន្យារ (យកទៅការដំណើរការបន្ទាប់ជាប្រាក់បង់ត្រឡប់)។",
              "action": "ដោះស្រាយម្តងមួយៗ ឬមិនរាប់បញ្ចូលជាក្រុម (ជាស្ថាពរ) / ពន្យារតាមជួរ។",
              "excluded": "ពន្យារ = នឹងយកទៅការដំណើរការបន្ទាប់ · មិនរាប់បញ្ចូល = ជាស្ថាពរ។ ចុច រាប់បញ្ចូល ដើម្បីនាំត្រឡប់។"
            },
            "bulk": {
              "all": "អនុវត្ត",
              "ready": "ពន្យារជួរដែលបានជ្រើស",
              "action": "មិនរាប់បញ្ចូលជួរដែលបានជ្រើស",
              "excluded": "រាប់បញ្ចូលជួរដែលបានជ្រើស"
            },
            "in-list": "ក្នុងបញ្ជី",
            "total-basic": "ប្រាក់ខែគោលសរុប",
            "search": "ស្វែងរកតាមលេខសម្គាល់ ឈ្មោះ នាយកដ្ឋាន ឬតួនាទី…",
            "clear-search": "សម្អាតការស្វែងរក",
            "matching": "នៃ {total} · ត្រូវនឹង “{q}”",
            "in-filter": "បុគ្គលិក {n} នាក់ក្នុងតម្រងនេះ | បុគ្គលិក {n} នាក់ក្នុងតម្រងនេះ",
            "sort-hint": "ចុចក្បាលជួរឈរដើម្បីតម្រៀប",
            "sort-by": "តម្រៀបតាម {col}",
            "sel-none": "ជ្រើសជួរដើម្បីអនុវត្តសកម្មភាពជាក្រុម។",
            "sel-all-tab": "ជ្រើសតម្រង (មានសិទ្ធិ / សកម្មភាព / មិនរាប់បញ្ចូល) ដើម្បីអនុវត្តសកម្មភាព។",
            "selected": "បានជ្រើស {n}",
            "select-all": "ជ្រើសជួរទាំងអស់",
            "select-row": "ជ្រើស {name}",
            "no-match": "គ្មានបុគ្គលិកត្រូវនឹង “{q}” ក្នុងតម្រងនេះទេ។",
            "empty": "គ្មានបុគ្គលិកក្នុងតម្រងនេះទេ។",
            "columns": {
              "code": "លេខសម្គាល់",
              "name": "បុគ្គលិក",
              "dept": "នាយកដ្ឋាន",
              "position": "តួនាទី",
              "basic": "ប្រាក់ខែគោល",
              "bank": "ធនាគារ",
              "action": "សកម្មភាព",
              "issues": "បញ្ហា",
              "reason": "មូលហេតុ",
              "bucket": "ក្រុម",
              "status": "ស្ថានភាព / មូលហេតុ"
            },
            "actions": {
              "hold": "ពន្យារ",
              "hold-title": "ពន្យារបុគ្គលិកនេះ — នឹងយកទៅការដំណើរការបន្ទាប់ជាប្រាក់បង់ត្រឡប់",
              "defer-title": "ពន្យារទៅការដំណើរការបន្ទាប់ជាប្រាក់បង់ត្រឡប់",
              "exclude": "មិនរាប់បញ្ចូល",
              "exclude-title": "មិនរាប់បញ្ចូលជាស្ថាពរ — គ្មានការយកទៅបន្តដោយស្វ័យប្រវត្តិ",
              "fix": "ជួសជុល",
              "include": "រាប់បញ្ចូល",
              "read-only": "អានតែប៉ុណ្ណោះ",
              "filter-to-act": "ត្រងដើម្បីធ្វើសកម្មភាព"
            },
            "status": {
              "held": "ពន្យារ (រំលងការគណនា)",
              "excluded": "មិនរាប់បញ្ចូល",
              "final-pay": "ប្រាក់ខែចុងក្រោយ",
              "deferred": "ពន្យារពេល",
              "active": "សកម្ម"
            },
            "bucket": {
              "ready": "ត្រៀមរួចរាល់",
              "action": "សកម្មភាព",
              "excluded": "មិនរាប់បញ្ចូល"
            }
          },
          "movements": {
            "title": "ចលនាបុគ្គលិកក្នុងរយៈពេលនេះ",
            "body": "ទាំងនេះមិនមែនជាឧបសគ្គទេ — ការគណនានឹងគណនាតាមសមាមាត្រ ឬដោះស្រាយករណីនីមួយៗដោយស្វ័យប្រវត្តិ។ ពិនិត្យនៅទីនេះដើម្បីដឹងពីអ្វីដែលត្រូវរំពឹងនៅជំហានទី ៣។",
            "type": {
              "new-hire": "បុគ្គលិកថ្មី",
              "termination": "ការបញ្ចប់ការងារ"
            },
            "new-hire-first": "ចូលធ្វើការ {date} · ពន្យារទៅប្រាក់ខែទីពីរ",
            "new-hire-second": "ចូលធ្វើការ {date} · ប្រាក់ខែគោលតាមសមាមាត្រថ្ងៃធ្វើការ",
            "termination-detail": "ថ្ងៃចុងក្រោយ {date} · មិនរាប់បញ្ចូល — រង់ចាំការដំណើរការប្រាក់ខែចុងក្រោយ"
          },
          "rules": {
            "title-first": "វិធានសិទ្ធិ — ប្រាក់ខែទីមួយ",
            "title-second": "វិធានសិទ្ធិ — ប្រាក់ខែទីពីរ",
            "defaults": "លំនាំដើម — ផ្លាស់ប្តូរក្នុងការកំណត់ក្រុមហ៊ុន",
            "active": "ស្ថានភាពសកម្មចាប់ពីថ្ងៃធ្វើការដំបូងរហូតដល់ថ្ងៃចុងក្រោយនៃរយៈពេលប្រាក់ខែ",
            "leavers": "មិនរាប់បញ្ចូលបុគ្គលិកដែលលាលែង ឬបញ្ចប់ការងារក្នុងរយៈពេលនេះ — រង់ចាំការដំណើរការប្រាក់ខែចុងក្រោយ",
            "new-hires-first": "បុគ្គលិកថ្មីរាប់បញ្ចូលតែនៅពេលចាប់ផ្តើមនៅថ្ងៃធ្វើការដំបូងប៉ុណ្ណោះ — បើមិនដូច្នោះទេ ពន្យារទៅប្រាក់ខែទីពីរ",
            "profile-first": "ទម្រង់ចាំបាច់ (ធនាគារ ពន្ធ NSSF) សម្រាប់ជាព័ត៌មានប៉ុណ្ណោះ — ការបុរេប្រទានជាសាច់ប្រាក់អាចទទួលយកបាន",
            "new-hires-second": "រាប់បញ្ចូលបុគ្គលិកថ្មីទាំងអស់ដែលចាប់ផ្តើមក្នុងរយៈពេលប្រាក់ខែ — តាមសមាមាត្រថ្ងៃធ្វើការ",
            "profile-second": "ទម្រង់ចាំបាច់ (ធនាគារ NSSF ពន្ធ) បង្កើតការព្រមាន ប៉ុន្តែមិនរារាំងទេ — ដោះស្រាយមុនជំហានទី ៥ (ការបង់ប្រាក់)"
          },
          "gate-banner": {
            "strong": "ត្រូវការសកម្មភាព",
            "text": "ធាតុត្រូវដោះស្រាយមុនជំហានទី ២ ត្រូវបានដោះសោ។"
          },
          "gate-hint": "សូមដោះស្រាយធាតុដែលត្រូវការសកម្មភាពទាំងអស់ជាមុនសិន",
          "toast": {
            "confirmed": "បានបញ្ជាក់ជំហានទី ១ — បានរក្សាទុករូបភាពសិទ្ធិ",
            "held-one": "{name} ត្រូវបានពន្យារ — សមាសភាគយកទៅការដំណើរការបន្ទាប់ · {reason}",
            "held-many": "បុគ្គលិក {n} នាក់ត្រូវបានពន្យារ — សមាសភាគយកទៅការដំណើរការបន្ទាប់ · {reason}",
            "excluded-one": "{name} មិនត្រូវបានរាប់បញ្ចូលក្នុងការដំណើរការនេះ · {reason}",
            "excluded-many": "បុគ្គលិក {n} នាក់មិនត្រូវបានរាប់បញ្ចូលក្នុងការដំណើរការនេះ · {reason}",
            "included-one": "{name} ត្រូវបានរាប់បញ្ចូលវិញក្នុងការដំណើរការនេះ។",
            "included-many": "បុគ្គលិក {n} នាក់ត្រូវបានរាប់បញ្ចូលវិញក្នុងការដំណើរការនេះ។",
            "cannot-exclude": "{code} គ្មានការព្រមានសម្រាប់មិនរាប់បញ្ចូលទេ — សូមប្រើ ពន្យារ ជំនួសវិញ។"
          },
          "move-modal": {
            "supra": "ជំហានទី ១",
            "title": {
              "hold": "ពន្យារ (រំលងការគណនា)",
              "exclude": "មិនរាប់បញ្ចូលក្នុងការដំណើរការនេះ"
            },
            "hint": {
              "hold": "សមាសភាគយកទៅការដំណើរការបន្ទាប់ជាប្រាក់បង់ត្រឡប់",
              "exclude": "ជាស្ថាពរ — គ្មានការយកទៅបន្តដោយស្វ័យប្រវត្តិ"
            },
            "selected": "បុគ្គលិកដែលបានជ្រើស {n} នាក់",
            "reason": "មូលហេតុ (មើលឃើញក្នុងកំណត់ត្រាសវនកម្ម) *",
            "default": {
              "hold": "ពន្យាររយៈពេលនេះ — សមាសភាគនឹងយកទៅការដំណើរការបន្ទាប់ជាប្រាក់បង់ត្រឡប់",
              "exclude": "សេចក្តីសម្រេចរបស់អ្នកគ្រប់គ្រង — មិនបង់រយៈពេលនេះ"
            },
            "required": {
              "hold": "ត្រូវការមូលហេតុនៃការពន្យារ",
              "exclude": "ត្រូវការមូលហេតុនៃការមិនរាប់បញ្ចូល"
            },
            "audit": "រក្សាទុកក្នុងកំណត់ត្រាសវនកម្មជាមួយអ្នកធ្វើ និងពេលវេលា។",
            "cancel": "បោះបង់",
            "submit": {
              "hold": "ពន្យារ",
              "exclude": "មិនរាប់បញ្ចូល"
            }
          }
        },
        "step2": {
          "loading": "កំពុងផ្ទុកធាតុចូលប្រាក់ខែ…",
          "error": "មិនអាចផ្ទុកការពិនិត្យធាតុចូលប្រាក់ខែបានទេ។",
          "open-pi": "បើកធាតុចូលប្រាក់ខែ",
          "cross-component": "ទិដ្ឋភាពឆ្លងសមាសភាគ",
          "gate-hint": "សូមដោះស្រាយឧបសគ្គទាំងអស់ជាមុនសិន",
          "passthrough": {
            "title": "គ្មានធាតុចូលប្រាក់ខែអនុវត្តទេ — បុរេប្រទានប្រាក់ខែទីមួយ",
            "body-1": "ប្រាក់ខែទីមួយដំណើរការជា",
            "body-advance": "បុរេប្រទានប្រាក់ខែគោល ៥០%",
            "body-2": " ថេរ។ សមាសភាគធាតុចូល (ម៉ោងបន្ថែម ប្រាក់ឧបត្ថម្ភ ប្រាក់រង្វាន់ ប្រាក់លើកទឹកចិត្ត អតីតភាពការងារ ប្រាក់បង់ត្រឡប់ វិស្សមកាល ការកែតម្រូវ) ត្រូវបាន",
            "body-scheduled": "គ្រោងទុកសម្រាប់ប្រាក់ខែទីពីរ",
            "body-3": "នៅចុងខែ នៅពេលដែលចំណូលពេញលេញត្រូវបានដឹង។ គ្មានអ្វីត្រូវផ្ទៀងផ្ទាត់នៅទីនេះទេ — ពិនិត្យសារ រួចបញ្ជាក់ដើម្បីបន្ត។",
            "hint-1": "ប្រសិនបើសមាសភាគជាក់លាក់ត្រូវដាក់បញ្ចូលក្នុងប្រាក់ខែទីមួយ (កម្រមាន) សូមរុញវាដោយផ្ទាល់ពី",
            "hint-pic": "មជ្ឈមណ្ឌលធាតុចូលប្រាក់ខែ",
            "hint-2": "មុនពេលបញ្ជាក់។",
            "kpi": {
              "components": "សមាសភាគដែលបានរុញ",
              "components-sub": "គ្មានក្នុងការដំណើរការនេះ",
              "records": "កំណត់ត្រាបានផ្ទៀងផ្ទាត់",
              "records-sub": "គ្មានសមាសភាគធាតុចូល",
              "issues": "បញ្ហារកឃើញ",
              "issues-sub": "គ្មានអ្វីត្រូវផ្ទៀងផ្ទាត់"
            },
            "ack-1": "ជំហានទី ២ គឺជា",
            "ack-pass": "ការឆ្លងកាត់",
            "ack-2": "សម្រាប់ការដំណើរការនេះ — មិនចាំបាច់ពិនិត្យធាតុចូលប្រាក់ខែទេ។ ចុច",
            "ack-confirm": "បញ្ជាក់ និងបន្ត",
            "ack-3": "ខាងក្រោមដើម្បីទៅជំហានទី ៣ (ការគណនា)។"
          },
          "kpi": {
            "val-amount": "ចំនួនទឹកប្រាក់បានផ្ទៀងផ្ទាត់",
            "val-records": "កំណត់ត្រាបានផ្ទៀងផ្ទាត់",
            "pass-rate": "អត្រាឆ្លងកាត់ ១០០%",
            "emps": "បុគ្គលិកដែលរងផលប៉ះពាល់",
            "emps-sub": "{n} នៃ {of} ក្នុងការដំណើរការ",
            "issues": "បញ្ហារកឃើញ",
            "blockers": "ឧបសគ្គ {n} | ឧបសគ្គ {n}",
            "movements": "ចលនា",
            "mv-new-hire": "បុគ្គលិកថ្មី {n}",
            "mv-term": "បញ្ចប់ការងារ {n}",
            "mv-unpaid": "ច្បាប់ឈប់គ្មានប្រាក់ខែ {n}",
            "mv-none": "គ្មានចលនា"
          },
          "components": {
            "title": "សមាសភាគប្រាក់ខែ",
            "subtitle": "ស្ថានភាពផ្ទៀងផ្ទាត់តាមសមាសភាគ — ដោះស្រាយឧបសគ្គដើម្បីដោះសោជំហានទី ៣"
          },
          "comp": {
            "OT": "ម៉ោងបន្ថែម",
            "ALLOW": "ប្រាក់ឧបត្ថម្ភ",
            "BONUS": "ប្រាក់រង្វាន់",
            "INCENT": "ប្រាក់លើកទឹកចិត្ត",
            "SENIOR": "អតីតភាពការងារ",
            "BACKPAY": "ប្រាក់បង់ត្រឡប់",
            "UNPAID": "ច្បាប់ឈប់គ្មានប្រាក់ខែ",
            "ANNUAL": "ច្បាប់ឈប់សម្រាកប្រចាំឆ្នាំ"
          },
          "card": {
            "blockers": "កំណត់ត្រា {r} · ឧបសគ្គ {n} | កំណត់ត្រា {r} · ឧបសគ្គ {n}",
            "warnings": "កំណត់ត្រា {r} · ការព្រមាន {n} | កំណត់ត្រា {r} · ការព្រមាន {n}",
            "hours": "កំណត់ត្រា {r} · {n} ម៉ោង",
            "days": "កំណត់ត្រា {r} · {n} ថ្ងៃ",
            "amount": "កំណត់ត្រា {r} · ${amount}"
          },
          "gate-banner": {
            "title": "ឧបសគ្គរារាំងការដោះសោជំហានទី ៣"
          },
          "issues": {
            "title": "បញ្ហាត្រូវដោះស្រាយ",
            "subtitle": "ដោះស្រាយឧបសគ្គទាំងអស់។ ការព្រមានអាចឆ្លងកាត់បាន។",
            "blockers": "ឧបសគ្គ",
            "warnings": "ការព្រមាន",
            "all-resolved": "បញ្ហាធាតុចូលប្រាក់ខែទាំងអស់ត្រូវបានដោះស្រាយ។"
          },
          "toast": {
            "passed": "ជំហានទី ២ បានឆ្លងកាត់ — គ្មានធាតុចូលប្រាក់ខែអនុវត្ត កំពុងទៅការគណនា",
            "confirmed": "បានបញ្ជាក់ជំហានទី ២ — កញ្ចប់ធាតុចូលប្រាក់ខែត្រូវបានចាក់សោសម្រាប់ការគណនា"
          },
          "issues-center": {
            "supra": "ធាតុចូលប្រាក់ខែ",
            "title": "មជ្ឈមណ្ឌលបញ្ហា",
            "subtitle": "ការព្រមាន និងឧបសគ្គទាំងអស់ឆ្លងកាត់សមាសភាគ។ ឧបសគ្គត្រូវតែដោះស្រាយមុនពេលផ្ទៀងផ្ទាត់។",
            "kpi": {
              "total": "បញ្ហាសរុប",
              "blockers": "ឧបសគ្គ",
              "warnings": "ការព្រមាន"
            },
            "cols": {
              "severity": "កម្រិតធ្ងន់ធ្ងរ",
              "component": "សមាសភាគ",
              "code": "កូដ",
              "message": "សារ",
              "employees": "បុគ្គលិក"
            },
            "blocker": "ឧបសគ្គ",
            "warning": "ការព្រមាន",
            "empty": "មិនមានបញ្ហារកឃើញទេ។"
          }
        },
        "step3": {
          "loading": "កំពុងផ្ទុកការគណនា…",
          "error": "មិនអាចផ្ទុកការគណនាបានទេ។",
          "submit-hint": "ចុច គណនា ជាមុនសិនដើម្បីបង្កើតលេខសម្គាល់ការដំណើរការ",
          "compare": {
            "title": "ច្រកប្រៀបធៀប",
            "subtitle": "ប្រៀបធៀបនឹងការដំណើរការមុនដើម្បីចាប់បម្រែបម្រួលមិនធម្មតាមុនការគណនា",
            "options": {
              "dec-second": "ធៀបនឹង Dec 31, 2025 — ប្រាក់ខែទីពីរ",
              "jan-first": "ធៀបនឹង Jan 15, 2026 — ប្រាក់ខែទីមួយ",
              "none": "គ្មានការប្រៀបធៀប"
            },
            "headcount": "ចំនួនបុគ្គលិក",
            "gross": "សរុបប្រាក់ខែដុល",
            "ot": "សរុបម៉ោងបន្ថែម",
            "tax": "សរុបពន្ធ",
            "advance": "សរុបបុរេប្រទាន",
            "within-range": "{v} (ក្នុងកម្រិត)",
            "normal": "{v} (ធម្មតា)",
            "review": "{v} (ពិនិត្យ)",
            "no-prior": "គ្មានការដំណើរការមុន",
            "advance-value": "+3 នាក់ (៥០% ប្រាក់ខែគោល)"
          },
          "calc": {
            "title": "ការគណនា",
            "subtitle": "ដំណើរការម៉ាស៊ីនប្រាក់ខែលើធាតុចូលដែលបានផ្ទៀងផ្ទាត់។ លទ្ធផលសម្រាប់អានតែប៉ុណ្ណោះ ហើយអាចដាក់ស្នើសុំការអនុម័ត។",
            "completed": "បានបញ្ចប់"
          },
          "log": {
            "loaded": "បានផ្ទុកបុគ្គលិកមានសិទ្ធិ {n} នាក់",
            "applied": "បានអនុវត្តកំណត់ត្រាធាតុចូល {records} (ម៉ោងបន្ថែម {hours} ម៉ោង)",
            "tos": "បានគណនាពន្ធលើប្រាក់បៀវត្សរ៍ (តារាង ៥ កម្រិត KHR ÷ អត្រា NBC {tos})",
            "nssf": "បានគណនា NSSF — ៤ គម្រោង (គ្រោះថ្នាក់ សុខភាព សោធននិវត្តន៍ និយោជក+និយោជិត) កំណត់ត្រឹម 1.2M KHR {'@'} {nssf}",
            "fbt": "បានគណនាពន្ធលើអត្ថប្រយោជន៍បន្ថែម ២០% លើប្រាក់ឧបត្ថម្ភ (ចែកនិយោជិត/និយោជក)",
            "net": "បានគណនាប្រាក់ខែសុទ្ធ និងចាក់សោរូបភាព"
          },
          "totals": {
            "title": "សរុបដែលបានគណនា",
            "subtitle": "រូបភាពអានតែប៉ុណ្ណោះ។ ដាក់ស្នើដើម្បីដោះសោជំហានទី ៤។",
            "note-pending-1": "មិនទាន់មានការគណនាប្រាក់ខែនៅឡើយទេ។ ចុច",
            "note-pending-2": "ដើម្បីបង្កើតលេខសម្គាល់ការដំណើរការ និងសរុបដែលបានគណនា។",
            "note-first-strong": "ទំនៀមប្រាក់ខែទីមួយ៖",
            "note-first": "បុរេប្រទានប្រាក់ខែគោល ៥០% ប៉ុណ្ណោះ។ ពន្ធ NSSF FBT និងសមាសភាគផ្សេងទៀតត្រូវផ្ទៀងផ្ទាត់នៅប្រាក់ខែទីពីរ។",
            "note-second": "គណនាជា KHR ជាមួយអត្រា NSSF {nssf} · អត្រាពន្ធ {tos}។ បង្ហាញជា USD។",
            "pending-1": "ការគណនាកំពុងរង់ចាំ។ ចុច",
            "pending-2": "ដើម្បីគណនារូបភាពប្រាក់ខែ និងបង្កើតលេខសម្គាល់ការដំណើរការ។",
            "cols": {
              "component": "សមាសភាគ",
              "amount": "ចំនួនទឹកប្រាក់",
              "records": "កំណត់ត្រា",
              "method": "វិធីសាស្ត្រ"
            }
          },
          "rows": {
            "basic-advance": "ប្រាក់ខែគោល (បុរេប្រទាន ៥០%)",
            "gross-advance": "ប្រាក់ខែដុល (បុរេប្រទាន)",
            "tos": "ពន្ធលើប្រាក់បៀវត្សរ៍ (TOS)",
            "nssf-pension": "NSSF (សោធននិវត្តន៍និយោជិត)",
            "fbt": "FBT (និយោជិត)",
            "net-advance": "ប្រាក់ខែសុទ្ធ (បុរេប្រទាន)",
            "basic": "ប្រាក់ខែគោល (ជាក់ស្តែង)",
            "ot": "ម៉ោងបន្ថែម (OT)",
            "allowance": "ប្រាក់ឧបត្ថម្ភ (អថេរ)",
            "incentive": "ប្រាក់លើកទឹកចិត្ត / កម្រៃជើងសារ",
            "bonus": "ប្រាក់រង្វាន់",
            "seniority": "អតីតភាពការងារ",
            "back-pay": "ប្រាក់បង់ត្រឡប់ / កាត់",
            "leave-encash": "ប្រាក់ទូទាត់ច្បាប់ឈប់សម្រាក",
            "adjustment": "ការកែតម្រូវ",
            "unpaid-leave": "ច្បាប់ឈប់គ្មានប្រាក់ខែ (កាត់)",
            "gross": "ប្រាក់ខែដុល",
            "nssf-employee": "NSSF (សោធននិវត្តន៍និយោជិត ២%)",
            "fbt-employee": "FBT (ចំណែកនិយោជិត)",
            "advance": "បុរេប្រទានប្រាក់ខែទីមួយ",
            "net": "ប្រាក់ខែសុទ្ធ",
            "employer-nssf": "(និយោជក) NSSF សរុប",
            "employer-fbt": "(និយោជក) FBT"
          },
          "methods": {
            "first": "ទំនៀមប្រាក់ខែទីមួយកម្ពុជា",
            "second-only": "មិនអនុវត្ត — ប្រាក់ខែទីពីរប៉ុណ្ណោះ",
            "basic": "តាមសមាមាត្រសម្រាប់បុគ្គលិកថ្មី / បញ្ចប់ការងារ / ច្បាប់ឈប់គ្មានប្រាក់ខែ",
            "ot": "សរុប {hours} ម៉ោង · ថ្ងៃធ្វើការ 1.5× ថ្ងៃឈប់ 2×",
            "allowance": "មិនរាប់បញ្ចូលក្នុងមូលដ្ឋាន NSSF/TOS — មើល FBT",
            "pay-input": "ធាតុចូលប្រាក់ខែ",
            "auto": "គណនាដោយស្វ័យប្រវត្តិ",
            "manual-correction": "ការកែតម្រូវដោយដៃ",
            "leave-encash": "ប្រាក់ខែដុលមធ្យម ១២ ខែ ÷ 22 × ច្បាប់ប្រចាំឆ្នាំមិនបានប្រើ",
            "manual": "ដោយដៃ",
            "unpaid": "កាត់បន្ថយប្រាក់ខែគោល",
            "tos": "{khr} KHR {'@'} {rate}",
            "nssf": "{khr} KHR {'@'} {rate} (កំណត់ត្រឹម 1.2M)",
            "fbt": "២០% × ប្រាក់ឧបត្ថម្ភ × អត្រានិយោជិត",
            "advance": "កាត់ពីបុរេប្រទានដែលបានបង់ពាក់កណ្តាលខែ",
            "employer-nssf": "គ្រោះថ្នាក់ + សុខភាព + សោធននិវត្តន៍និយោជក — បង់ទៅ NSSF",
            "employer-fbt": "រាយការណ៍ក្នុងលិខិតប្រកាស FBT"
          },
          "flags": {
            "title": "សញ្ញាបម្រែបម្រួល",
            "subtitle": "ទទួលស្គាល់បម្រែបម្រួលមុនពេលដាក់ស្នើ (ការព្រមានប៉ុណ្ណោះ — មិនរារាំង)។",
            "all-ack": "សញ្ញាបម្រែបម្រួលទាំងអស់ត្រូវបានទទួលស្គាល់។"
          },
          "actions": {
            "calculate": "គណនា",
            "recalculate": "គណនាឡើងវិញ",
            "submit": "ដាក់ស្នើសុំការអនុម័ត"
          },
          "toast": {
            "calculated": "បានគណនាប្រាក់ខែ — លេខសម្គាល់ការដំណើរការ៖ {id}",
            "recalculated": "បានគណនាឡើងវិញ — លេខសម្គាល់ការដំណើរការ៖ {id} · ត្រៀមដាក់ស្នើម្តងទៀត",
            "submitted": "បានដាក់ស្នើសុំការអនុម័ត — បានបញ្ជូនទៅអ្នកអនុម័ត",
            "not-calculated": "ការគណនាមិនទាន់បញ្ចប់"
          }
        },
        "step4": {
          "loading": "កំពុងផ្ទុកជំហានទី 4 (ការអនុម័ត)…",
          "error": "មិនអាចផ្ទុកជំហានទី 4 បានទេ — {message}",
          "retry": "ព្យាយាមម្តងទៀត",
          "close": "បិទ",
          "cancel": "បោះបង់",
          "back": "ត្រឡប់ទៅការគណនា",
          "approve-continue": "អនុម័ត និងបន្តទៅការទូទាត់ និងប័ណ្ណបើកប្រាក់",
          "continue": "បន្តទៅការទូទាត់ និងប័ណ្ណបើកប្រាក់",
          "confirm-error": "មិនអាចអនុម័តបើកប្រាក់បៀវត្សបានទេ — {message}",
          "locked": "បានអនុម័ត និងចាក់សោ — ជំហានទី 5 បានបើក។",
          "workspace": "កន្លែងពិនិត្យ",
          "resolve": "ដោះស្រាយ",
          "view": "មើល",
          "decision": {
            "pending": "រង់ចាំ",
            "approved": "បានអនុម័ត",
            "deferred": "បានពន្យារ",
            "returned": "បានបញ្ជូនត្រឡប់"
          },
          "kpi": {
            "employees": "បុគ្គលិក",
            "advance": "ប្រាក់បុរេប្រទានមូលដ្ឋាន (សរុប)",
            "advance-sub": "50% នៃប្រាក់ខែមូលដ្ឋាន · ពន្ធ/ប.ស.ស ពន្យារទៅបើកប្រាក់លើកទីពីរ",
            "net-advance": "ប្រាក់ទទួលសុទ្ធ (បុរេប្រទាន)",
            "exceptions": "ករណីលើកលែង",
            "exceptions-sub": "ចលនាបុគ្គលិក + គម្លាត",
            "gross": "ប្រាក់សរុប",
            "tos": "ពន្ធលើប្រាក់បៀវត្ស",
            "nssf": "ប.ស.ស (បុគ្គលិក)",
            "nssf-sub": "សោធននិវត្តន៍ 2% · ផ្នែកនិយោជកក្នុងរបាយការណ៍",
            "fbt": "ពន្ធលើអត្ថប្រយោជន៍បន្ថែម (បុគ្គលិក)",
            "fbt-sub": "20% × ប្រាក់ឧបត្ថម្ភ · ចំណែកបុគ្គលិក",
            "advance-offset": "ការកាត់ប្រាក់បុរេប្រទាន",
            "net": "ប្រាក់ទទួលសុទ្ធ"
          },
          "bucket": {
            "ready": "រួចរាល់",
            "ready-first": "បុគ្គលិកទាំងអស់ត្រឹមត្រូវសម្រាប់បុរេប្រទាន",
            "ready-second": "ការត្រួតពិនិត្យទាំងអស់បានឆ្លងកាត់",
            "review": "ត្រូវពិនិត្យ",
            "review-first": "គ្មានករណីលើកលែងលើប្រាក់បុរេប្រទាន",
            "review-second": "ចលនាបុគ្គលិក / គម្លាត",
            "hold": "កំពុងផ្អាក",
            "hold-first": "គ្មានការកែតម្រូវដែលកំពុងរង់ចាំ",
            "hold-second": "ត្រូវការសកម្មភាព (មិនទាន់ដោះស្រាយ)"
          },
          "ws-filter": {
            "all": "ទាំងអស់",
            "totals": "សរុប",
            "exceptions": "ករណីលើកលែង",
            "review": "ត្រូវពិនិត្យ"
          },
          "col": {
            "type": "ប្រភេទ",
            "item": "ធាតុ",
            "current": "បច្ចុប្បន្ន",
            "previous": "មុន",
            "variance": "គម្លាត",
            "status": "ស្ថានភាព"
          },
          "row": {
            "total": "សរុប",
            "movement": "ចលនា",
            "basic-advance": "ប្រាក់បុរេប្រទានមូលដ្ឋាន",
            "gross": "ប្រាក់សរុប",
            "net": "ប្រាក់ទទួលសុទ្ធ",
            "first-run": "ការបើកប្រាក់លើកដំបូង",
            "snapshot": "រូបភាពទិន្នន័យ",
            "first-note": "ម៉ោងបន្ថែម ប្រាក់ឧបត្ថម្ភ ពន្ធ ប.ស.ស និងពន្ធលើអត្ថប្រយោជន៍បន្ថែម ត្រូវផ្ទៀងផ្ទាត់នៅបើកប្រាក់លើកទីពីរ — គ្មានអ្វីត្រូវពិនិត្យនៅទីនេះទេ។",
            "none": "គ្មានជួរក្នុងទិដ្ឋភាពនេះទេ។"
          },
          "status": {
            "review": "ពិនិត្យ",
            "blocked": "ជាប់គាំង",
            "acknowledged": "បានទទួលស្គាល់",
            "elsewhere": "ប្រាក់ចុងក្រោយបានដោះស្រាយនៅកន្លែងផ្សេង",
            "held": "ផ្អាកទៅការបើកប្រាក់បន្ទាប់"
          },
          "panel": {
            "kicker": "សេចក្តីសម្រេចអនុម័ត",
            "title": "ហិរញ្ញវត្ថុ · នាយកធនធានមនុស្ស",
            "submitted": "បានដាក់ស្នើ",
            "reviewer": "អ្នកពិនិត្យ",
            "approve": "អនុម័តបើកប្រាក់បៀវត្ស",
            "return": "បញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ"
          },
          "movement": {
            "kicker": "ការពិនិត្យ{type}",
            "new-hire": "បុគ្គលិកថ្មី",
            "termination": "ការបញ្ចប់ការងារ",
            "unpaid-leave": "ច្បាប់ឈប់សម្រាកគ្មានប្រាក់ខែ",
            "leave-dates": "កាលបរិច្ឆេទច្បាប់ដែលបានអនុម័ត",
            "unpaid-days": "ថ្ងៃគ្មានប្រាក់ខែ",
            "unpaid-days-value": "{n} ក្នុងចំណោម 22 ថ្ងៃធ្វើការ",
            "daily-rate": "អត្រាប្រចាំថ្ងៃ",
            "daily-rate-value": "${amount} · មូលដ្ឋាន/22",
            "deduction": "ការកាត់ដែលបានអនុវត្ត",
            "net": "ប្រាក់ទទួលសុទ្ធជាលទ្ធផល",
            "leave-note": "ប្រភព៖ ម៉ូឌុលច្បាប់ឈប់សម្រាក · បានអនុម័តរួចហើយ។ ជួរនេះគ្រាន់តែបញ្ជាក់ថាការកាត់ប្រាក់បៀវត្សត្រឹមត្រូវ។",
            "hire-date": "ថ្ងៃចូលធ្វើការ",
            "basic-full": "ប្រាក់មូលដ្ឋាន (ពេញមួយខែ)",
            "prorated": "ប្រាក់មូលដ្ឋានតាមសមាមាត្រ",
            "tax-nssf": "ពន្ធ / ប.ស.ស",
            "tax-nssf-value": "គណនាលើប្រាក់ចំណូលតាមសមាមាត្រ",
            "net-period": "ប្រាក់ទទួលសុទ្ធក្នុងគ្រានេះ",
            "hire-note": "ផ្ទៀងផ្ទាត់ថ្ងៃចូលធ្វើការ និងថាប្រាក់ឧបត្ថម្ភប្រចាំទាំងអស់ត្រូវបានអនុវត្តត្រឹមត្រូវសម្រាប់គ្រាមិនពេញ។",
            "effective": "ថ្ងៃមានប្រសិទ្ធភាព",
            "reason": "មូលហេតុ",
            "status-run": "ស្ថានភាពក្នុងការបើកប្រាក់នេះ",
            "status-run-value": "មិនរាប់បញ្ចូល · រង់ចាំប្រាក់ចុងក្រោយ (ក្រៅវដ្ត)",
            "term-title": "ការអនុវត្តនៅកម្ពុជា៖ ការបញ្ចប់ការងារត្រូវការការបើកប្រាក់ចុងក្រោយដាច់ដោយឡែក។",
            "term-body": "ប្រាក់ចុងក្រោយជាធម្មតារួមមាន៖ ប្រាក់កំឡុងពេលជូនដំណឹង ប្រាក់ជំនួសច្បាប់ប្រចាំឆ្នាំសល់ ប្រាក់បំណាច់ (ប្រសិនបើមាន) ការកាត់ពន្ធចុងក្រោយ និងការបញ្ឈប់ ប.ស.ស។",
            "note": "កំណត់ចំណាំអ្នកអនុម័ត (ចាំបាច់ដើម្បីបញ្ជូនត្រឡប់)",
            "note-placeholder": "ឧ. បានផ្ទៀងផ្ទាត់ជាមួយម៉ូឌុលច្បាប់ ref LEAVE-2026-014",
            "reason-required": "ត្រូវការកំណត់ចំណាំដើម្បីបញ្ជូនចលនានេះត្រឡប់ទៅកែតម្រូវ។",
            "return": "បញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ",
            "acknowledge": "ទទួលស្គាល់",
            "elsewhere": "បានដោះស្រាយនៅកន្លែងផ្សេង",
            "final-pay": "ចាប់ផ្តើមការបើកប្រាក់ចុងក្រោយ"
          },
          "override": {
            "title": "អនុម័តទាំងចលនាដែលមិនទាន់ទទួលស្គាល់?",
            "body": "ចលនា {n} នៅតែត្រូវការការទទួលស្គាល់ពីអ្នកអនុម័ត។ អនុម័តដដែលឬ? (ការបដិសេធនឹងត្រូវកត់ត្រា។)",
            "approve": "អនុម័តដដែល"
          },
          "return": {
            "kicker": "ជំហានទី 4",
            "title": "បញ្ជូនបើកប្រាក់បៀវត្សត្រឡប់ដើម្បីកែតម្រូវ",
            "sub": "មូលហេតុគឺចាំបាច់ ហើយត្រូវរក្សាទុកក្នុងកំណត់ត្រាសវនកម្ម។",
            "reason": "មូលហេតុនៃការបញ្ជូនត្រឡប់ *",
            "placeholder": "ពិពណ៌នាអ្វីដែលត្រូវកែតម្រូវ (ឧ. ម៉ោងបន្ថែមសរុបខ្ពស់ពេក — សូមផ្ទៀងផ្ទាត់ក្រុមលក់ម្តងទៀត)",
            "required": "មូលហេតុគឺចាំបាច់ដើម្បីបញ្ជូនត្រឡប់",
            "target": "បញ្ជូនត្រឡប់ទៅ",
            "target-3": "ជំហានទី 3 — ការគណនា"
          },
          "toast": {
            "approved": "បើកប្រាក់បៀវត្សបានអនុម័ត និងចាក់សោ — ជំហានទី 5 បានបើក",
            "returned": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ — ទៅជំហានទី 3",
            "movement-acknowledged": "បានទទួលស្គាល់ចលនា",
            "movement-elsewhere": "ចលនាត្រូវបានសម្គាល់ថាបានដោះស្រាយនៅកន្លែងផ្សេង",
            "movement-returned": "បានបញ្ជូនត្រឡប់ដើម្បីកែតម្រូវ — ការបើកប្រាក់បើកឡើងវិញនៅជំហានទី 3"
          }
        },
        "step5": {
          "loading": "កំពុងផ្ទុកជំហានទី 5 (ការទូទាត់ និងប័ណ្ណបើកប្រាក់)…",
          "error": "មិនអាចផ្ទុកជំហានទី 5 បានទេ — {message}",
          "retry": "ព្យាយាមម្តងទៀត",
          "close": "បិទ",
          "cancel": "បោះបង់",
          "resolve": "ដោះស្រាយ",
          "resolved": "បានដោះស្រាយ",
          "page": {
            "back": "ត្រឡប់ទៅការបើកប្រាក់",
            "heading": "ជំហានទី 5 នៃ 5 — ការទូទាត់ និងប័ណ្ណបើកប្រាក់",
            "subtitle": "តាមធនាគារ៖ បង្កើតឯកសារ → ទូទាត់ → បង្កើតប័ណ្ណបើកប្រាក់ → ចែកចាយ។ បិទការបើកប្រាក់នៅពេលបុគ្គលិកទាំងអស់បានទូទាត់ និងចែកចាយ។"
          },
          "kpi": {
            "employees": "បុគ្គលិកត្រូវបើកប្រាក់",
            "total-net": "ប្រាក់ទទួលសុទ្ធសរុប",
            "pending": "រង់ចាំការទូទាត់",
            "settled": "បានទូទាត់",
            "distributed": "ប័ណ្ណបើកប្រាក់បានចែកចាយ"
          },
          "how": {
            "title": "កាតនីមួយៗដំណើរការបំពង់ផ្ទាល់ខ្លួន៖",
            "body": "បង្កើត Excel → ទូទាត់ (បន្ទាប់ពីធនាគារបញ្ជាក់ការទូទាត់) → បង្កើតប័ណ្ណបើកប្រាក់ → ចែកចាយ។ កាតធនាគារនីមួយៗដំណើរការដោយឯករាជ្យ។ កាតដោយដៃចេញប័ណ្ណបើកប្រាក់ លុះត្រាតែបុគ្គលិកទាំងអស់លើកាតនោះបានទូទាត់ — បុគ្គលិកដែលបានប្តូរតាម \"ធ្វើបច្ចុប្បន្នភាពគណនីធនាគារ\" នឹងលេចឡើងក្នុងកាតធនាគារថ្មីជាបាច់ថ្មីដោយស្វ័យប្រវត្តិ។"
          },
          "held": {
            "title": "បុគ្គលិក {n} នាក់ត្រូវបានផ្អាកនៅជំហានទី 5 — ប្រាក់សុទ្ធ ${amount}",
            "materiality": "ណែនាំឱ្យអនុម័តឡើងវិញ ({pct}% នៃប្រាក់សុទ្ធសរុប)",
            "body": "ការទូទាត់ដែលបានផ្អាកត្រូវបានរាយក្នុងការដោះស្រាយដោយដៃ / ករណីលើកលែង។ បើកវាដើម្បីដោះលែង · ពន្យារ · ឬលុបចោល និងកែតម្រូវនីមួយៗ។",
            "open": "បើកផ្ទាំងដោះស្រាយដោយដៃ",
            "open-title": "ដោះស្រាយការទូទាត់ដែលបានផ្អាកក្នុងផ្ទាំងដោះស្រាយដោយដៃ / ករណីលើកលែង"
          },
          "pipeline": {
            "title": "បំពង់ការទូទាត់",
            "subtitle": "បាច់តាមធនាគារដំណើរការដោយឯករាជ្យ។ ចុចកាតដើម្បីមើលលម្អិត ឬពិនិត្យបើកប្រាក់ទាំងមូលនៅខាងស្តាំ។",
            "pending": "រង់ចាំ",
            "pending-file": "រង់ចាំឯកសារ",
            "settled": "បានទូទាត់",
            "distributed": "បានចែកចាយ",
            "held": "ការទូទាត់ត្រូវបានផ្អាក"
          },
          "card": {
            "manual": "ដោយដៃ / ករណីលើកលែង",
            "employees": "បុគ្គលិក",
            "amount": "ចំនួនទឹកប្រាក់",
            "pending": "រង់ចាំ",
            "settled": "បានទូទាត់",
            "distrib": "ចែកចាយ",
            "view": "មើលបុគ្គលិក {n} នាក់",
            "empty": "គ្មានបុគ្គលិកត្រូវបានបញ្ជូនមកទីនេះទេ",
            "generate": "បង្កើត Excel · បុគ្គលិក {n} នាក់",
            "resolve-manually": "ដោះស្រាយដោយដៃ",
            "resolve-first": "ដោះស្រាយករណីលើកលែង {n} ជាមុនសិន",
            "resolve-first-hint": "បើកការដោះស្រាយដោយដៃ ហើយជ្រើសវិធីទូទាត់សម្រាប់ករណីលើកលែងនីមួយៗ",
            "release": "បង្កើត និងចែកចាយប័ណ្ណបើកប្រាក់",
            "release-manual": "បង្កើត និងចែកចាយ",
            "distribute": "ចែកចាយប័ណ្ណបើកប្រាក់",
            "done": "បុគ្គលិកទាំង {n} នាក់បានទូទាត់ និងចែកចាយ",
            "locked": "បានចាក់សោ · បុគ្គលិក {n} នាក់",
            "settle": "ទូទាត់បាច់",
            "mark-settled": "សម្គាល់ថាបានទូទាត់ទាំងអស់",
            "regenerate": "បង្កើតឡើងវិញ"
          },
          "reports": {
            "title": "របាយការណ៍បើកប្រាក់បៀវត្សចុងក្រោយ",
            "subtitle": "បានចាក់សោ និងអាចនាំចេញសម្រាប់ការដាក់ / រក្សាទុក",
            "all-ready": "របាយការណ៍ទាំង 4 រួចរាល់",
            "ready": "រួចរាល់",
            "preview": "មើលជាមុន និងទាញយក",
            "download": "ទាញយក CSV",
            "gate-pre": "របាយការណ៍នឹងបើក នៅពេល",
            "gate-strong": "ប័ណ្ណបើកប្រាក់ទាំងអស់ត្រូវបានចែកចាយ",
            "gate-post": "។ ពួកវាឆ្លុះបញ្ចាំងរូបភាពទិន្នន័យដែលបានចាក់សោនៃការបើកប្រាក់នេះ។",
            "summary": {
              "label": "របាយការណ៍សង្ខេប",
              "help": "សរុប · ការបែងចែក · អនុលោមភាព · សវនកម្ម"
            },
            "detail": {
              "label": "របាយការណ៍លម្អិត",
              "help": "បញ្ជីតាមបុគ្គលិក · A4 ផ្តេក"
            },
            "tos": {
              "label": "របាយការណ៍ពន្ធលើប្រាក់បៀវត្ស (TOS)",
              "help": "អនុលោមតាម អ.ព.ដ · EN ↔ ខ្មែរ"
            },
            "nssf": {
              "label": "របាយការណ៍ ប.ស.ស",
              "help": "ការរួមចំណែក 4 គ្រោងការណ៍ · EN ↔ ខ្មែរ"
            }
          },
          "close-gate": {
            "blocked": "មិនទាន់អាចបិទការបើកប្រាក់បានទេ",
            "blocked-hint": "ទូទាត់បាច់ធនាគារទាំងអស់ និងចែកចាយប័ណ្ណបើកប្រាក់ទាំងអស់ជាមុនសិន។",
            "holds-hint": "ដោះស្រាយការទូទាត់ដែលបានផ្អាក {n} (ដោះលែង / ពន្យារ / លុបចោល និងកែតម្រូវ) មុនពេលបិទ។",
            "ready": "រួចរាល់ដើម្បីបិទការបើកប្រាក់",
            "ready-hint": "បុគ្គលិកទាំងអស់បានទូទាត់ និងប័ណ្ណបើកប្រាក់បានចែកចាយ។ ចុចបិទការបើកប្រាក់ដើម្បីចាក់សោរូបភាពទិន្នន័យ។",
            "closed": "ការបើកប្រាក់បានបិទ",
            "closed-hint": "រូបភាពទិន្នន័យដែលបានចាក់សោត្រូវបានរក្សាទុក — មើលកំណត់ត្រាបើកប្រាក់បៀវត្ស។",
            "summary-emps": "បុគ្គលិក {n} នាក់ · ប្រាក់សុទ្ធ ${amount}",
            "summary-reports": "របាយការណ៍ {n} ក្នុងចំណោម 4 រួចរាល់",
            "summary-holds": "ការផ្អាកមិនទាន់ដោះស្រាយ {n}",
            "title": "ចាក់សោរូបភាពទិន្នន័យ — របាយការណ៍ក្លាយជាចុងក្រោយ ហើយកាលវិភាគផ្លាស់ទៅបានបញ្ចប់",
            "btn": "បិទការបើកប្រាក់",
            "closed-btn": "ការបើកប្រាក់បានបិទ"
          },
          "col": {
            "id": "លេខសម្គាល់",
            "employee": "បុគ្គលិក",
            "department": "នាយកដ្ឋាន",
            "net-pay": "ប្រាក់ទទួលសុទ្ធ",
            "account": "គណនី",
            "pipeline": "បំពង់",
            "action": "សកម្មភាព",
            "reason": "មូលហេតុ",
            "amount": "ចំនួនទឹកប្រាក់",
            "status": "ស្ថានភាព",
            "bank": "ធនាគារ"
          },
          "bank-list": {
            "kicker": "បាច់ធនាគារ · {tag}",
            "employees": "បុគ្គលិក",
            "total": "សរុប",
            "pending": "រង់ចាំ",
            "settled": "បានទូទាត់",
            "distributed": "បានចែកចាយ",
            "empty": "គ្មានបុគ្គលិកត្រូវបានបញ្ជូនទៅធនាគារនេះទេ។",
            "footer": "បំពង់ធ្វើបច្ចុប្បន្នភាពនៅពេលអ្នកបន្តសកម្មភាពកាតធនាគារនៅជំហានទី 5។",
            "payslip": "ប័ណ្ណបើកប្រាក់",
            "payslip-title": "មើលប័ណ្ណបើកប្រាក់ផ្លូវការ",
            "hold-title": "ដកបុគ្គលិកនេះចេញពីបាច់ — រង់ចាំការស៊ើបអង្កេត"
          },
          "full": {
            "open": "ពិនិត្យព័ត៌មានបើកប្រាក់ពេញលេញ",
            "open-title": "មើលកំណត់ត្រាបើកប្រាក់ពេញលេញរបស់បុគ្គលិកគ្រប់គ្នាទូទាំងធនាគារ",
            "kicker": "ព័ត៌មានបើកប្រាក់ពេញលេញ",
            "sub": "រូបភាពទិន្នន័យសម្រាប់តែអាននៃបុគ្គលិកដែលបានបើកប្រាក់ · ដូចការទាញយករបាយការណ៍លម្អិត",
            "gross": "សរុប",
            "tax": "ពន្ធ",
            "net": "សុទ្ធ",
            "search": "ស្វែងរកតាមលេខសម្គាល់ ឈ្មោះ នាយកដ្ឋាន ឬធនាគារ…",
            "count": "បុគ្គលិក {n} នាក់ក្នុងការបើកប្រាក់នេះ",
            "showing": "បង្ហាញ {n} ក្នុងចំណោម {total} · ត្រូវនឹង “{q}”",
            "no-match": "គ្មានបុគ្គលិកត្រូវនឹង “{q}” ទេ",
            "none": "គ្មានកំណត់ត្រាបើកប្រាក់បៀវត្សទេ។",
            "tip": "គន្លឹះ៖ ប្រើការស្វែងរកដើម្បីត្រង; ចុចកាតធនាគារនៅជំហានទី 5 ដើម្បីធ្វើសកម្មភាពលើបាច់នោះ។"
          },
          "hold": {
            "kicker": "ផ្អាកការទូទាត់ · រង់ចាំការស៊ើបអង្កេត",
            "title": "ផ្អាកការទូទាត់ — {name}",
            "net": "ប្រាក់សុទ្ធ",
            "next": "អ្វីដែលកើតឡើងបន្ទាប់",
            "next-1": "បុគ្គលិកត្រូវបានដកចេញពីបាច់រង់ចាំរបស់ {bank} (ចំនួន និងទឹកប្រាក់ថយចុះ)។",
            "next-2": "Excel របស់ {bank} ត្រូវបង្កើតម្តងទៀតសម្រាប់បុគ្គលិកដែលនៅសល់។",
            "next-3": "ប័ណ្ណបើកប្រាក់របស់ពួកគេត្រូវបានចាក់សោ — មិនបង្កើត មិនចែកចាយ — រហូតដល់អ្នកដោះស្រាយការផ្អាក។",
            "next-4": "ដោះស្រាយនៅពេលក្រោយពីការដោះស្រាយដោយដៃ / ករណីលើកលែង៖ ដោះលែង · ពន្យារទៅការបើកប្រាក់បន្ទាប់ · លុបចោល និងកែតម្រូវ។",
            "reason": "មូលហេតុ (ចាំបាច់ ត្រូវកត់ត្រាក្នុងកំណត់ត្រាសវនកម្ម)",
            "reason-placeholder": "ឧ. អ្នកគ្រប់គ្រងបានទូរស័ព្ទមក — បុគ្គលិកមិនបានមកធ្វើការព្រឹកនេះ។ រង់ចាំការស៊ើបអង្កេត។",
            "reason-required": "មូលហេតុគឺចាំបាច់។",
            "action": "ផ្អាកការទូទាត់",
            "held": "បានផ្អាក — រង់ចាំការស៊ើបអង្កេត",
            "deferred": "ពន្យារទៅការបើកប្រាក់បន្ទាប់",
            "cancelled": "បានលុបចោល — បានបង្កើតការកែតម្រូវ",
            "cancelled-short": "បានលុបចោល — ការកែតម្រូវ"
          },
          "hold-resolve": {
            "kicker": "ដោះស្រាយការផ្អាក",
            "title": "ដោះស្រាយការផ្អាក — {name}",
            "subtitle": "{code} · មកពី {bank} · មូលហេតុ៖ {reason}",
            "release": "ដោះលែងសម្រាប់ការទូទាត់",
            "release-desc": "ការស៊ើបអង្កេតបានបញ្ចប់ (ឧ. បានទទួលវិញ្ញាបនបត្រវេជ្ជសាស្ត្រ)។ បុគ្គលិកត្រឡប់ចូលបាច់រង់ចាំនៃធនាគារដើមវិញ — Excel របស់ធនាគារនោះត្រូវបង្កើតម្តងទៀត។",
            "defer": "ពន្យារទៅការបើកប្រាក់បន្ទាប់",
            "defer-desc": "ការស៊ើបអង្កេតនឹងលើសពេលបិទ។ ប្រាក់សុទ្ធត្រូវយកទៅការបើកប្រាក់លើកទីពីរបន្ទាប់ជាជួរដំបូង។ ពន្ធ និង ប.ស.ស នៅតែដាក់ក្នុងគ្រានេះ។",
            "cancel": "លុបចោល និងកែតម្រូវ",
            "cancel-desc": "បានបញ្ជាក់ការមិនមកធ្វើការ (ឧ. អវត្តមានដោយគ្មានច្បាប់)។ ការទូទាត់ត្រូវបានលុបចោលក្នុងការបើកប្រាក់នេះ ហើយការកែតម្រូវក្រៅវដ្តនឹងតាមក្រោយ ដើម្បីកាត់ថ្ងៃអវត្តមាន និងទាមទារប្រាក់បុរេប្រទានលើកដំបូងមកវិញ។",
            "note": "កំណត់ចំណាំការដោះស្រាយ (ស្រេចចិត្ត)",
            "note-placeholder": "ឧ. បាននិយាយជាមួយអ្នកគ្រប់គ្រង — បុគ្គលិកត្រឡប់មកវិញជាមួយវិញ្ញាបនបត្រវេជ្ជសាស្ត្រ។"
          },
          "manual": {
            "kicker": "ជំហានទី 5 · ការទូទាត់",
            "title": "ការដោះស្រាយដោយដៃ / ករណីលើកលែង",
            "pending-of": "ក្នុងចំណោម {total} កំពុងរង់ចាំ។ ករណីលើកលែងនីមួយៗត្រូវការសកម្មភាព មុនពេលប័ណ្ណបើកប្រាក់អាចបញ្ចប់បាន។",
            "empty": "គ្មានករណីលើកលែងដោយដៃក្នុងការបើកប្រាក់នេះទេ។",
            "error": "មិនអាចរក្សាទុកលទ្ធផលដោយដៃបានទេ — {message}",
            "reason-held": "បានផ្អាក · មកពី {bank} — {reason}",
            "reason-investigation": "រង់ចាំការស៊ើបអង្កេត",
            "reason-no-bank": "គ្មានគណនីធនាគារក្នុងឯកសារ",
            "reason-routed": "បានបញ្ជូនទៅដោយដៃ",
            "ref": "លេខយោង",
            "change": "ប្តូរ",
            "undo": "មិនធ្វើវិញ",
            "choose": "ជ្រើសរើសការដោះស្រាយ",
            "apply": "អនុវត្ត",
            "save-reroute": "រក្សាទុក និងប្តូរផ្លូវ",
            "bank": "ធនាគារ",
            "bank-placeholder": "ជ្រើសរើសធនាគារ…",
            "bank-required": "ជ្រើសរើសធនាគារថ្មី។",
            "ref-required": "លេខយោងគឺចាំបាច់សម្រាប់ {option}",
            "legend": {
              "settled": "បានទូទាត់",
              "settled-desc": "បានបើកប្រាក់ ករណីលើកលែងត្រូវបានដោះស្រាយ",
              "updated": "បានធ្វើបច្ចុប្បន្នភាព",
              "updated-desc": "ព័ត៌មានធនាគារថ្មី ព្យាយាមម្តងទៀតដោយស្វ័យប្រវត្តិ",
              "deferred": "បានពន្យារ",
              "deferred-desc": "យកទៅការបើកប្រាក់បន្ទាប់ជាប្រាក់ខែជំពាក់",
              "held": "បានផ្អាក",
              "held-desc": "ផ្អាកកំពុងដំណើរការ; ដោះស្រាយតាមការដោះលែង / ពន្យារ / លុបចោល និងកែតម្រូវ",
              "pending": "រង់ចាំ",
              "pending-desc": "បានទទួលស្គាល់ រារាំងប័ណ្ណបើកប្រាក់"
            },
            "opt": {
              "cash": "បង់ជាសាច់ប្រាក់",
              "cheque": "បង់ជាមូលប្បទានបត្រ",
              "transfer": "បង់តាមការផ្ទេរ",
              "update": "ធ្វើបច្ចុប្បន្នភាពគណនីធនាគារ",
              "hold": "ផ្អាកការទូទាត់ទៅការបើកប្រាក់បន្ទាប់",
              "pending": "ទុករង់ចាំ"
            },
            "opt-desc": {
              "cash": "ប្រគល់សាច់ប្រាក់។ កត់ត្រាបង្កាន់ដៃសម្រាប់សវនកម្ម។",
              "cheque": "បានចេញមូលប្បទានបត្រដោយដៃ។ កត់ត្រាលេខមូលប្បទានបត្រ។",
              "transfer": "ការផ្ទេរប្រាក់ដោយដៃ។ កត់ត្រាលេខយោង។",
              "update": "កត់ត្រាព័ត៌មានធនាគារថ្មី — ប្រព័ន្ធព្យាយាមម្តងទៀតនៅបាច់បន្ទាប់។",
              "hold": "ពន្យារការទូទាត់សាច់ប្រាក់ទៅការបើកប្រាក់បន្ទាប់។ ពន្ធ/ប.ស.ស បានដាក់រួចក្នុងគ្រានេះ — ការបើកប្រាក់បន្ទាប់បូកតែប្រាក់សុទ្ធ។",
              "pending": "ទទួលស្គាល់ ប៉ុន្តែមិនទាន់ធ្វើសកម្មភាព (នឹងរារាំងប័ណ្ណបើកប្រាក់)។"
            },
            "prompt": {
              "cash": "លេខបង្កាន់ដៃ (ស្រេចចិត្ត)",
              "cheque": "លេខមូលប្បទានបត្រ (ចាំបាច់)",
              "transfer": "លេខយោងការផ្ទេរ (ចាំបាច់)",
              "update": "លេខគណនីថ្មី (ចាំបាច់)",
              "hold": "មូលហេតុនៃការពន្យារ (ការគណនាបានធ្វើរួច; ពន្យារតែសាច់ប្រាក់)"
            },
            "status": {
              "cash": "បានបង់ (សាច់ប្រាក់)",
              "cheque": "បានបង់ (មូលប្បទានបត្រ)",
              "transfer": "បានបង់ (ការផ្ទេរ)",
              "update": "បានធ្វើបច្ចុប្បន្នភាព"
            }
          },
          "toast": {
            "generated": "បាច់ {bank} បានបង្កើត — {file} (បុគ្គលិក {n} នាក់)",
            "generate-error": "មិនអាចបង្កើតឯកសារ {bank} បានទេ — {message}",
            "distributed": "ប័ណ្ណបើកប្រាក់ {bank} បានបង្កើត និងចែកចាយ — បុគ្គលិក {n} នាក់",
            "held": "{name} ត្រូវបានផ្អាក — បាច់ {bank} បានធ្វើបច្ចុប្បន្នភាព",
            "released": "{name} ត្រូវបានដោះលែងទៅធនាគារដើមវិញ — ត្រូវបង្កើតឯកសារម្តងទៀត",
            "deferred": "{name} ត្រូវបានពន្យារ — ប្រាក់សុទ្ធយកទៅការបើកប្រាក់បន្ទាប់",
            "cancelled": "{name} ត្រូវបានលុបចោល — ការកែតម្រូវក្រៅវដ្តនឹងតាមក្រោយ",
            "closed": "ការបើកប្រាក់បានបិទ · សម្គាល់ថាបានបញ្ចប់ · ត្រឡប់ទៅមជ្ឈមណ្ឌលបើកប្រាក់បៀវត្ស",
            "manual-cash": "បានកត់ត្រាការបង់ជាសាច់ប្រាក់",
            "manual-cheque": "បានកត់ត្រាការបង់ជាមូលប្បទានបត្រ",
            "manual-transfer": "បានកត់ត្រាការបង់តាមការផ្ទេរ",
            "manual-update": "គណនីធនាគារបានធ្វើបច្ចុប្បន្នភាព — បុគ្គលិកផ្លាស់ទៅកាតធនាគារថ្មីជាបាច់ថ្មី",
            "manual-hold": "ការទូទាត់ត្រូវបានផ្អាកទៅការបើកប្រាក់បន្ទាប់",
            "manual-pending": "ទុករង់ចាំ",
            "settled": "បាច់ {bank} បានទូទាត់ — បុគ្គលិក {n} នាក់ · យោង {ref}"
          }
        }
      },
      "input-center": {
        "title": "ធាតុចូលប្រាក់ខែ",
        "subtitle": "ពិនិត្យ និងផ្ទៀងផ្ទាត់សមាសភាគប្រាក់ខែសម្រាប់ការដំណើរការសកម្ម",
        "subtitle-editing": "កំពុងកែប្រែ {component} — ការផ្លាស់ប្ដូរធ្វើបច្ចុប្បន្នភាពផ្នែកសុខភាពការដំណើរការ",
        "subtitle-readonly": "ទិដ្ឋភាពប្រវត្តិអានបានតែប៉ុណ្ណោះ — {period}",
        "past-period": "កំឡុងពេលអតីត",
        "period-label": "កំឡុងពេលប្រាក់ខែ៖",
        "period-group": {
          "current": "បច្ចុប្បន្ន",
          "past": "អតីត (បានបើក)"
        },
        "period-current": "{label} (បច្ចុប្បន្ន)",
        "period-none": "កំឡុងពេលបច្ចុប្បន្ន (គ្មានការដំណើរការសកម្ម)",
        "read-only": "អានបានតែប៉ុណ្ណោះ",
        "no-components": "មិនទាន់មានសមាសភាគប្រាក់ខែត្រូវបានកំណត់សម្រាប់ការដំណើរការនេះទេ។",
        "error": "មិនអាចផ្ទុកធាតុចូលប្រាក់ខែបានទេ — {message}",
        "retry": "ព្យាយាមម្ដងទៀត",
        "empty": "គ្មានធាតុណាត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។",
        "close": "បិទ",
        "cancel": "បោះបង់",
        "run-context": {
          "heading": "កំពុងកែតម្រូវសម្រាប់ {id}",
          "subtitle": "កំឡុងពេលត្រូវបានចាក់សោសម្រាប់ការដំណើរការនេះ។ ធ្វើការកែតម្រូវនៅទីនេះ រួចត្រឡប់ទៅលំហូរការដំណើរការ។",
          "return": "ត្រឡប់ទៅការដំណើរការ"
        },
        "issues-center": {
          "btn": "មជ្ឈមណ្ឌលបញ្ហា"
        },
        "validate": {
          "btn": "ផ្ទៀងផ្ទាត់ទាំងអស់"
        },
        "bulk-import": {
          "btn": "នាំចូលជាបាច់"
        },
        "header-actions": {
          "settings": "ការកំណត់",
          "add-entry": "បន្ថែមធាតុ",
          "verify": "បញ្ជាក់"
        },
        "next": {
          "blockers": "ដោះស្រាយឧបសគ្គ {n} ក្នុង {component} មុនពេលការគណនាអាចដំណើរការ។ | ដោះស្រាយឧបសគ្គ {n} ក្នុង {component} មុនពេលការគណនាអាចដំណើរការ។",
          "warnings": "ការព្រមាន {n} ក្នុង {component} — ពិនិត្យមុនពេលផ្ទៀងផ្ទាត់។ | ការព្រមាន {n} ក្នុង {component} — ពិនិត្យមុនពេលផ្ទៀងផ្ទាត់។",
          "clean": "សមាសភាគទាំងអស់ស្អាត។ រួចរាល់សម្រាប់ផ្ទៀងផ្ទាត់។",
          "open": "បើក {component} →",
          "validate": "ផ្ទៀងផ្ទាត់ទាំងអស់ →"
        },
        "health": {
          "total-records": "កំណត់ត្រាសរុប",
          "validated-suffix": "បានផ្ទៀងផ្ទាត់",
          "validated-amount": "ចំនួនទឹកប្រាក់បានផ្ទៀងផ្ទាត់",
          "employees": "បុគ្គលិក {n} នាក់ | បុគ្គលិក {n} នាក់",
          "warnings": "ការព្រមាន",
          "warnings-sub": "មិនរារាំង",
          "blockers": "ឧបសគ្គ",
          "blockers-sub": "ដោះស្រាយមុនការគណនា",
          "progress": "វឌ្ឍនភាពនៃការផ្ទៀងផ្ទាត់",
          "progress-of": "{done} នៃ {total}"
        },
        "sidebar": {
          "title": "សមាសភាគ",
          "count-suffix": "សរុប",
          "sort-label": "តម្រៀបសមាសភាគ",
          "sort-urgency": "តម្រៀប៖ អាទិភាព",
          "sort-group": "តម្រៀប៖ ក្រុម",
          "sort-name": "តម្រៀប៖ ឈ្មោះ",
          "group-system": "ការងារប្រព័ន្ធ · ស្វ័យប្រវត្តិពីការងារ",
          "group-variable": "ប្រាក់អថេរ · ដោយដៃ",
          "paid": "បានបើក {n} · ចាក់សោ",
          "add-component": "បន្ថែមសមាសភាគ",
          "catalog-toast": "កាតាឡុកសមាសភាគគ្រប់គ្រងដោយអ្នកគ្រប់គ្រង"
        },
        "pulse": {
          "title": "ជីពចរវដ្តការដំណើរការ",
          "cut-off": "ថ្ងៃផុតកំណត់",
          "passed": "ថ្ងៃផុតកំណត់បានកន្លងផុតហើយ",
          "today": "ថ្ងៃនេះជាថ្ងៃផុតកំណត់",
          "left": "នៅសល់ {n} ថ្ងៃធ្វើការ | នៅសល់ {n} ថ្ងៃធ្វើការ",
          "anomaly": "ភាពមិនប្រក្រតី",
          "vs-prior": "ធៀបនឹងការដំណើរការមុន",
          "now-was": "${now} ឥឡូវ · ពីមុន ${was}",
          "activity": "សកម្មភាព",
          "view-all": "មើលទាំងអស់",
          "view-all-toast": "កំណត់ហេតុសកម្មភាពពេញលេញនឹងមកដល់បន្ទាប់",
          "who": {
            "sarah": "សារ៉ា",
            "system": "ប្រព័ន្ធ",
            "visal": "វិសាល"
          },
          "what": {
            "sarah": "បានបញ្ជាក់ធាតុ OT ចំនួន ៤",
            "system": "បាននាំចូលជួរប្រាក់រង្វាន់ ៥",
            "visal": "បានសម្គាល់ឧបសគ្គការកែតម្រូវ"
          },
          "when": {
            "sarah": "១២ នាទីមុន",
            "system": "១ ម៉ោងមុន",
            "visal": "២ ម៉ោងមុន"
          }
        },
        "groups": {
          "system": "ការងារប្រព័ន្ធ",
          "variable": "ប្រាក់អថេរ"
        },
        "components": {
          "ot": "ម៉ោងបន្ថែម (OT)",
          "seniority": "អតីតភាពការងារ",
          "unpaid": "ច្បាប់ឈប់សម្រាកគ្មានប្រាក់ខែ",
          "annual": "ច្បាប់ឈប់សម្រាកប្រចាំឆ្នាំ",
          "allow": "ប្រាក់ឧបត្ថម្ភ",
          "incentive": "ប្រាក់លើកទឹកចិត្ត / កម្រៃជើងសារ",
          "bonus": "ប្រាក់រង្វាន់",
          "other": "ផ្ទាល់ខ្លួនផ្សេងៗ",
          "backpay": "ប្រាក់បើកយឺត / កាត់",
          "adjust": "ការកែតម្រូវ / កាត់"
        },
        "component-desc": {
          "ot": "បញ្ជូនពីវត្តមាន",
          "seniority": "គណនាស្វ័យប្រវត្តិពីអតីតភាព",
          "unpaid": "បញ្ជូនពីប្រព័ន្ធច្បាប់ឈប់សម្រាក",
          "annual": "បញ្ជូនពីប្រព័ន្ធច្បាប់ឈប់សម្រាក",
          "allow": "តែម្ដងប៉ុណ្ណោះ — ប្រាក់ឧបត្ថម្ភថេរ/កើតឡើងវិញ កំណត់ក្នុង C&B",
          "incentive": "ដោយដៃ ឬនាំចូលតាមកំឡុងពេល",
          "bonus": "ដោយដៃ ឬនាំចូលតាមកំឡុងពេល",
          "other": "សមាសភាគផ្ទាល់ខ្លួនតាមកំឡុងពេល",
          "backpay": "ការកែតម្រូវដោយដៃសម្រាប់កំឡុងពេលមុន",
          "adjust": "ការកែតម្រូវដោយដៃតាមកំឡុងពេល"
        },
        "workspaces": {
          "ot": "ម៉ោងបន្ថែម (OT)",
          "allow": "ប្រាក់ឧបត្ថម្ភ",
          "variable": "ប្រាក់អថេរ",
          "system": "ប្រព័ន្ធ និងក្រោយវដ្ត"
        },
        "ws": {
          "period": "កំឡុងពេល៖ {period}",
          "cut-off": "ថ្ងៃផុតកំណត់៖ {date}"
        },
        "settings": {
          "tolerance": "កម្រិតអត់ឱន (ស្នើ ធៀបនឹង គណនា)",
          "tol-0": "±០ នាទី (តឹងរ៉ឹង)",
          "min": "±{n} នាទី",
          "rounding": "ការបង្គត់",
          "none": "គ្មាន",
          "round": "{n} នាទី",
          "note": "ការកំណត់ម្ដងក្នុងមួយការដំណើរការ។ អនុវត្តចំពោះការបញ្ជាក់តែប៉ុណ្ណោះ។"
        },
        "kpis": {
          "records": "កំណត់ត្រា",
          "total-amount": "ចំនួនទឹកប្រាក់សរុប",
          "employees": "បុគ្គលិក",
          "warnings": "ការព្រមាន",
          "blockers": "ឧបសគ្គ"
        },
        "subtypes": {
          "all": "ទាំងអស់",
          "label": "សមាសភាគរង"
        },
        "filters": {
          "search-placeholder": "ស្វែងរកបុគ្គលិក កំណត់ចំណាំ ឯកសារយោង…",
          "search-label": "ស្វែងរកធាតុ",
          "clear-search": "សម្អាតការស្វែងរក",
          "status-label": "តម្រងតាមស្ថានភាព",
          "source-label": "តម្រងតាមប្រភព",
          "remove": "ដកតម្រងចេញ៖ {filter}",
          "all": "ទាំងអស់",
          "valid": "ត្រឹមត្រូវ",
          "warning": "ការព្រមាន",
          "blocker": "ឧបសគ្គ",
          "paid": "បានបើក",
          "source-all": "គ្រប់ប្រភព",
          "source-attendance": "វត្តមាន",
          "source-import": "នាំចូល",
          "source-manual": "ដោយដៃ",
          "source-system": "ប្រព័ន្ធ / API"
        },
        "columns": {
          "emp": "បុគ្គលិក",
          "date": "ថ្ងៃ OT",
          "time": "ម៉ោង",
          "claimed": "បានស្នើ (ម៉ោង)",
          "computed": "បានគណនា (ម៉ោង)",
          "amount": "ចំនួនទឹកប្រាក់",
          "otType": "ប្រភេទ OT",
          "source": "ប្រភព",
          "status": "ស្ថានភាព",
          "subtype": "ប្រភេទរង",
          "effective": "កំឡុងពេលរកបាន",
          "applyTo": "អនុវត្តចំពោះ"
        },
        "cb-readonly": "កំណត់ក្នុង C&B · អានបានតែប៉ុណ្ណោះ",
        "from-cb": "ពី C&B",
        "paid-title": "ចាក់សោ — បានបើកតាម {run}",
        "resolve": "ដោះស្រាយ",
        "resolve-for": "ដោះស្រាយ {emp}",
        "mark-valid": "សម្គាល់ថាត្រឹមត្រូវ",
        "resolved": "បានដោះស្រាយ — {emp} ត្រូវបានសម្គាល់ថាត្រឹមត្រូវ",
        "rows-of": "{shown} នៃ {total} ធាតុ",
        "export": "នាំចេញ",
        "exported": "បាននាំចេញ {n} ធាតុ",
        "verify-done": "{component} បានបញ្ជាក់ — នៅសល់ការព្រមាន {warnings} និងឧបសគ្គ {blockers}",
        "issues": {
          "employee": "បុគ្គលិក",
          "memo": "កំណត់ចំណាំ",
          "amount": "ចំនួនទឹកប្រាក់",
          "action": "សកម្មភាព",
          "open": "បើកក្នុងកន្លែងធ្វើការ",
          "open-for": "បើក {emp} ក្នុងកន្លែងធ្វើការ",
          "empty": "គ្មានបញ្ហា — ធាតុទាំងអស់ត្រឹមត្រូវ។"
        },
        "va": {
          "title": "ផ្ទៀងផ្ទាត់សមាសភាគទាំងអស់",
          "blocked": "ដោះស្រាយឧបសគ្គ {n} មុនពេលផ្ទៀងផ្ទាត់។ បើកមជ្ឈមណ្ឌលបញ្ហាដើម្បីពិនិត្យ។ | ដោះស្រាយឧបសគ្គ {n} មុនពេលផ្ទៀងផ្ទាត់។ បើកមជ្ឈមណ្ឌលបញ្ហាដើម្បីពិនិត្យ។",
          "warn": "ការព្រមាន {n} នឹងត្រូវសម្គាល់ឱ្យអ្នកពិនិត្យយកចិត្តទុកដាក់ ប៉ុន្តែមិនរារាំងការផ្ទៀងផ្ទាត់ទេ។ | ការព្រមាន {n} នឹងត្រូវសម្គាល់ឱ្យអ្នកពិនិត្យយកចិត្តទុកដាក់ ប៉ុន្តែមិនរារាំងការផ្ទៀងផ្ទាត់ទេ។",
          "ok": "ធាតុទាំងអស់ឆ្លងកាត់ការផ្ទៀងផ្ទាត់។ ចាក់សោធាតុចូល ហើយបន្តទៅការពិនិត្យ។",
          "confirm": "ផ្ទៀងផ្ទាត់ និងចាក់សោ",
          "done": "សមាសភាគទាំងអស់បានផ្ទៀងផ្ទាត់ និងចាក់សោ។ ការដំណើរការបន្តទៅការពិនិត្យ។",
          "error": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ — {message}"
        },
        "form": {
          "period": "កំឡុងពេលប្រាក់ខែ",
          "emp": "បុគ្គលិក",
          "date": "កាលបរិច្ឆេទ",
          "otType": "ប្រភេទ OT",
          "claimed": "ម៉ោងបានស្នើ",
          "subtype": "ប្រភេទ",
          "allowance-type": "ប្រភេទប្រាក់ឧបត្ថម្ភ",
          "effective": "កំឡុងពេលរកបាន",
          "applyTo": "មូលហេតុ / ឯកសារយោង",
          "amount": "ចំនួនទឹកប្រាក់ (USD)",
          "memo": "កំណត់ចំណាំ",
          "optional": "(ស្រេចចិត្ត)",
          "select-period": "ជ្រើសរើសកំឡុងពេលប្រាក់ខែ…",
          "select": "ជ្រើសរើស {field}…",
          "helper": {
            "when-paid": "ពេលដែលនឹងត្រូវបើក",
            "when-earned": "ពេលដែលរកបាន",
            "negative": "ប្រើលេខអវិជ្ជមានសម្រាប់ការកាត់"
          },
          "placeholder": {
            "optional": "កំណត់ចំណាំស្រេចចិត្ត",
            "effective-allow": "ឧ. មករា ២០២៦, បច្ចុប្បន្ន",
            "effective-variable": "ឧ. ត្រីមាសទី៤ ២០២៥, មករា ២០២៦, បច្ចុប្បន្ន",
            "effective-system": "ឧ. ធ្នូ ២០២៥, បច្ចុប្បន្ន",
            "apply-allow": "ឧ. ជួបអតិថិជន ១៨ មករា, អាហារក្រុម",
            "apply-variable": "ឧ. គោលដៅលក់, លទ្ធផលការងារ, ការរក្សាបុគ្គលិក",
            "apply-system": "ឧ. សងប្រាក់កម្ចី, ប្រាក់ឧបត្ថម្ភខកខាន"
          }
        },
        "add": {
          "title": "បន្ថែមធាតុ — {component}",
          "submit": "បន្ថែមធាតុ",
          "drift": "អ្នកកំពុងបន្ថែមទៅ {target} ខណៈពេលកំពុងមើល {current}។ ពេលដាក់ស្នើ ធាតុនឹងចូលក្នុងកន្លែងធ្វើការរបស់ {target} មិនមែនកន្លែងបច្ចុប្បន្នទេ។",
          "duplicate": "បុគ្គលិកនេះមានធាតុ {component} ដែលបានបើករួចហើយ (ចាក់សោតាម {run})។ បន្ថែមមួយទៀតឬ?",
          "done": "បានបន្ថែមធាតុ — {emp} ({component})",
          "elsewhere": " · មិននៅក្នុងទិដ្ឋភាពបច្ចុប្បន្ន"
        },
        "batch": {
          "title": "នាំចូលជាបាច់ — {component}",
          "effective-placeholder": "ឧ. ត្រីមាសទី៤ ២០២៥ / មករា ២០២៦ / បច្ចុប្បន្ន",
          "file": "ផ្ទុកឯកសារឡើង",
          "click": "ចុចដើម្បីផ្ទុកឡើង",
          "drag": "ឬអូស និងទម្លាក់",
          "hint": "CSV ឬ XLSX រហូតដល់ 10 MB",
          "selected": "បានជ្រើស៖ {name}",
          "note": "កំណត់ចំណាំបាច់",
          "note-placeholder": "ឧ. បាច់ប្រាក់លើកទឹកចិត្តត្រីមាសទី៤ — អនុម័តយឺត ផ្លាស់ពីខែមករាទៅកុម្ភៈ",
          "note-hint": "បន្ថែមនៅមុខកំណត់ចំណាំនៃធាតុនាំចូលនីមួយៗសម្រាប់បរិបទ។",
          "columns": "ជួរឈរដែលរំពឹងទុក",
          "template": "ទាញយកគំរូ",
          "template-done": "បានទាញយកគំរូ — {name}",
          "import": "នាំចូល",
          "done": "បាននាំចូល {n} ធាតុពី {file}",
          "note-attached": " (បានភ្ជាប់កំណត់ចំណាំបាច់)"
        }
      },
      "reportsCenter": {
        "types": {
          "summary": "សង្ខេបប្រាក់ខែ",
          "detail": "ប្រាក់ខែលម្អិត",
          "tos": "របាយការណ៍ពន្ធ (TOS)",
          "nssf": "របាយការណ៍ NSSF"
        },
        "statuses": {
          "idle": "ទំនេរ",
          "generating": "កំពុងបង្កើត…",
          "ready": "រួចរាល់",
          "failed": "បរាជ័យ"
        }
      },
      "offCycle": {
        "back": "ត្រឡប់ទៅមជ្ឈមណ្ឌលបើកប្រាក់បៀវត្សរ៍",
        "title": "បើកប្រាក់បៀវត្សរ៍ក្រៅវដ្ត",
        "subtitle": "ការបើកប្រាក់រង្វាន់ ប្រាក់លើកទឹកចិត្ត ការកែតម្រូវ ប្រាក់ចុងក្រោយ និងការបើកប្រាក់ពិសេស ក្រៅវដ្តធម្មតា។ ការបើកប្រាក់ក្រៅវដ្តត្រូវបានបញ្ចូលក្នុងមជ្ឈមណ្ឌលបើកប្រាក់បៀវត្សរ៍ តាមកាលបរិច្ឆេទបើកប្រាក់។",
        "loading": "កំពុងផ្ទុកសេចក្តីព្រាងក្រៅវដ្ត…",
        "error": "មិនអាចផ្ទុកសេចក្តីព្រាងក្រៅវដ្តបានទេ — {message}",
        "retry": "ព្យាយាមម្តងទៀត",
        "list-title": "សេចក្តីព្រាងក្រៅវដ្ត",
        "count": "{n} ក្នុងបញ្ជី",
        "empty": {
          "title": "មិនទាន់មានសេចក្តីព្រាងក្រៅវដ្តនៅឡើយ",
          "subtitle": "ជ្រើសរើសប្រភេទពី បើកប្រាក់បៀវត្សរ៍ក្រៅវដ្ត ដើម្បីចាប់ផ្តើម។ សេចក្តីព្រាងរក្សាទុក ៧ ថ្ងៃ។"
        },
        "menu": {
          "button": "បើកប្រាក់បៀវត្សរ៍ក្រៅវដ្ត"
        },
        "kind": {
          "bonus": "ប្រាក់រង្វាន់",
          "incentive": "ប្រាក់លើកទឹកចិត្ត",
          "adjustment": "ការកែតម្រូវ",
          "final-pay": "ប្រាក់ចុងក្រោយ",
          "special": "បៀវត្សរ៍ពិសេស"
        },
        "filter": {
          "label": "ស្ថានភាព"
        },
        "status": {
          "all": "ទាំងអស់",
          "DRAFT": "សេចក្តីព្រាង",
          "COMMITTED": "បានបញ្ជាក់",
          "ABANDONED": "បានបោះបង់"
        },
        "type": {
          "FINAL_PAY": "ប្រាក់ចុងក្រោយ",
          "BONUS": "ប្រាក់រង្វាន់",
          "BACK_PAY": "ប្រាក់បើកយឺត",
          "ADVANCE": "ប្រាក់បុរេប្រទាន",
          "INCENTIVE": "ប្រាក់លើកទឹកចិត្ត",
          "ADJUSTMENT": "ការកែតម្រូវ",
          "SPECIAL": "បៀវត្សរ៍ពិសេស",
          "unspecified": "មិនទាន់កំណត់ប្រភេទ"
        },
        "cols": {
          "draft": "សេចក្តីព្រាង",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "pay-date": "កាលបរិច្ឆេទបើកប្រាក់",
          "employees": "បុគ្គលិក",
          "updated": "បានធ្វើបច្ចុប្បន្នភាព",
          "action": "សកម្មភាព"
        },
        "row": {
          "open": "បើក",
          "open-label": "បើកសេចក្តីព្រាង {name}",
          "untitled": "សេចក្តីព្រាងគ្មានចំណងជើង"
        },
        "create": {
          "eyebrow": "បើកប្រាក់បៀវត្សរ៍ក្រៅវដ្ត",
          "title": "បង្កើតកាលវិភាគ{kind}",
          "subtitle": "ការបើកប្រាក់ក្រៅវដ្តត្រូវបានបញ្ចូលក្នុងមជ្ឈមណ្ឌលបើកប្រាក់បៀវត្សរ៍ តាមកាលបរិច្ឆេទបើកប្រាក់។",
          "type-label": "ប្រភេទក្រៅវដ្ត",
          "cancel": "បោះបង់",
          "close": "បិទ",
          "submit": "បង្កើតសេចក្តីព្រាង",
          "submitting": "កំពុងបង្កើតសេចក្តីព្រាង…",
          "error": "មិនអាចបង្កើតសេចក្តីព្រាងបានទេ — {message}"
        },
        "advance": {
          "title": "{kind} ត្រូវបានចាត់ទុកជាប្រាក់បុរេប្រទាន",
          "body": "បើកឥឡូវនេះក្នុងការបើកប្រាក់ក្រៅវដ្តនេះ រួចបញ្ចូលក្នុងបៀវត្សរ៍ចុងក្រោយធម្មតាបន្ទាប់ ជាប្រាក់ចំណូលសរុប។ ពន្ធ + ប.ស.ស ត្រូវគណនាលើប្រាក់សរុបពេញនៅទីនោះ ហើយប្រាក់បុរេប្រទាននេះត្រូវកាត់ចេញពីប្រាក់សុទ្ធដោយស្វ័យប្រវត្តិ។"
        },
        "flow": {
          "title": "របៀបដែលការបើកប្រាក់នេះដំណើរការ",
          "badge-pass": "{n} ជំហាន · ជំហានទី ២ ឆ្លងកាត់",
          "badge-full": "{n} ជំហាន · ពិនិត្យពេញលេញ",
          "steps": {
            "bonus": {
              "s1": "សិទ្ធិទទួល (ស្វ័យប្រវត្តិពីបញ្ជីដែលបានអនុម័ត)",
              "s2": "ពិនិត្យទិន្នន័យបៀវត្សរ៍ (ឆ្លងកាត់)",
              "s3": "ការគណនា",
              "s4": "ការអនុម័ត",
              "s5": "ការទូទាត់ និងប័ណ្ណបៀវត្សរ៍"
            },
            "incentive": {
              "s1": "សិទ្ធិទទួល (ស្វ័យប្រវត្តិពីបញ្ជីដែលបានអនុម័ត)",
              "s2": "ពិនិត្យទិន្នន័យបៀវត្សរ៍ (ឆ្លងកាត់)",
              "s3": "ការគណនា",
              "s4": "ការអនុម័ត",
              "s5": "ការទូទាត់ និងប័ណ្ណបៀវត្សរ៍"
            },
            "adjustment": {
              "s1": "សិទ្ធិទទួល (ជ្រើស → ដកបុគ្គលិក)",
              "s2": "ពិនិត្យទិន្នន័យបៀវត្សរ៍ (ឆ្លងកាត់)",
              "s3": "ការគណនា",
              "s4": "ការអនុម័ត",
              "s5": "ការទូទាត់ និងប័ណ្ណបៀវត្សរ៍"
            },
            "final-pay": {
              "s1": "សិទ្ធិទទួល (បញ្ជីលាឈប់ស្វ័យប្រវត្តិ)",
              "s2": "ពិនិត្យទិន្នន័យបៀវត្សរ៍",
              "s3": "ការគណនា",
              "s4": "ការអនុម័ត",
              "s5": "ការទូទាត់ និងប័ណ្ណបៀវត្សរ៍"
            },
            "special": {
              "s1": "សិទ្ធិទទួល (អ្នកមានសិទ្ធិទាំងអស់)",
              "s2": "ពិនិត្យទិន្នន័យបៀវត្សរ៍",
              "s3": "ការគណនា",
              "s4": "ការអនុម័ត",
              "s5": "ការទូទាត់ និងប័ណ្ណបៀវត្សរ៍"
            }
          },
          "note": {
            "bonus": "ជំហានទី ២ ជាការឆ្លងកាត់ — ទិន្នន័យមកពីបញ្ជីប្រាក់រង្វាន់ដែលបានអនុម័តរួច។ ចាត់ទុកជាប្រាក់បុរេប្រទាន៖ ពន្ធ + ប.ស.ស ផ្ទៀងផ្ទាត់ក្នុងបៀវត្សរ៍ចុងក្រោយធម្មតាបន្ទាប់។",
            "incentive": "ជំហានទី ២ ជាការឆ្លងកាត់ — ទិន្នន័យមកពីបញ្ជីប្រាក់លើកទឹកចិត្តដែលបានអនុម័តរួច។ ចាត់ទុកជាប្រាក់បុរេប្រទាន៖ ពន្ធ + ប.ស.ស ផ្ទៀងផ្ទាត់ក្នុងបៀវត្សរ៍ចុងក្រោយធម្មតាបន្ទាប់។",
            "adjustment": "ជំហានទី ២ ជាការឆ្លងកាត់ — តម្លៃកែតម្រូវបញ្ចូលជាមួយការជ្រើសបុគ្គលិកនៅជំហានទី ១។ មិនគណនាពន្ធ/ប.ស.ស ឡើងវិញទេ (សម្រាប់កែតម្រូវតែប៉ុណ្ណោះ)។",
            "final-pay": "ពិនិត្យពេញលេញនៅជំហានទី ២។ ប្រាក់ចុងក្រោយផ្ទៀងផ្ទាត់ប្រាក់បំណាច់ ការប្តូរច្បាប់ឈប់ជាប្រាក់ ប្រាក់ខែតាមសមាមាត្រ ប្រាក់អតីតភាព — ទាំងអស់ត្រូវពិនិត្យក្នុងទិន្នន័យបៀវត្សរ៍មុនការគណនា។",
            "special": "ពិនិត្យពេញលេញនៅជំហានទី ២ — បៀវត្សរ៍ពិសេស (ឧ. ខែទី ១៣ ការបើកប្រាក់ថយក្រោយម្តង) ដើរតាមផ្លូវពិនិត្យដូចការបើកប្រាក់ធម្មតា។"
          }
        },
        "wizard": {
          "back": "ត្រឡប់ទៅសេចក្តីព្រាងក្រៅវដ្ត",
          "loading": "កំពុងផ្ទុកសេចក្តីព្រាង…",
          "error": "មិនអាចផ្ទុកសេចក្តីព្រាងបានទេ — {message}",
          "not-found": "រកមិនឃើញសេចក្តីព្រាង ឬផុតកំណត់។ សេចក្តីព្រាងក្រៅវដ្តរក្សាទុក ៧ ថ្ងៃ។",
          "steps-label": "ជំហានសេចក្តីព្រាង",
          "steps": {
            "employees": "បុគ្គលិក",
            "amounts": "ចំនួនទឹកប្រាក់",
            "dates": "កាលបរិច្ឆេទ",
            "review": "ពិនិត្យ"
          },
          "back-step": "ថយក្រោយ",
          "next": "រក្សាទុក និងបន្ត",
          "saving": "កំពុងរក្សាទុក…",
          "save-error": "មិនអាចរក្សាទុកបានទេ — {message}",
          "committed": "សេចក្តីព្រាងនេះត្រូវបានបញ្ជាក់ជាកាលវិភាគ {id}។",
          "abandoned": "សេចក្តីព្រាងនេះត្រូវបានបោះបង់។",
          "employees": {
            "batch-label": "បាច់{kind}ដែលបានអនុម័ត",
            "batch-placeholder": "ជ្រើសរើសបាច់{kind}ដែលបានអនុម័ត…",
            "batch-option": "{title} · បុគ្គលិក {count} នាក់ · ${total} · អនុម័ត {date}",
            "batch-hint": "នាំចូលពីទិន្នន័យបៀវត្សរ៍ · ចំនួនបុគ្គលិកបំពេញដោយស្វ័យប្រវត្តិ។",
            "batch-picked": "{title} · បុគ្គលិក {count} នាក់ · សរុប ${total} · អនុម័ត {date}",
            "batch-empty-1": "មិនមានបញ្ជី{kind}ដែលបានអនុម័តទេ។ សូមទៅកាន់",
            "batch-empty-link": "ទិន្នន័យបៀវត្សរ៍",
            "batch-empty-2": "ដើម្បីនាំចូលបាច់ និងទទួលការអនុម័តជាមុនសិន។",
            "est-label": "ចំនួនបុគ្គលិកប៉ាន់ស្មាន",
            "est-auto-batch": "· ស្វ័យប្រវត្តិពីបាច់",
            "est-auto-selection": "· ស្វ័យប្រវត្តិពីការជ្រើសរើស",
            "run-label": "លេខសម្គាល់ការបើកប្រាក់ដើម",
            "run-placeholder": "ជ្រើសរើសការបើកប្រាក់ដែលបានបិទ…",
            "run-hint": "ជ្រើសរើសការបើកប្រាក់ដែលបានបិទ ដែលមានចំនួនខុសដែលអ្នកត្រូវកែតម្រូវ។",
            "run-picked": "· បានបើក {paid} · រយៈពេល {period} · បុគ្គលិក {n} នាក់ក្នុងការបើកប្រាក់",
            "select-label": "ជ្រើសរើសបុគ្គលិក",
            "select-resigning-label": "ជ្រើសរើសបុគ្គលិកដែលកំពុងលាឈប់",
            "select-eligible-label": "ជ្រើសរើសបុគ្គលិកដែលមានសិទ្ធិ",
            "no-run": "មិនទាន់ជ្រើសរើសការបើកប្រាក់",
            "pick-run-first": "ជ្រើសរើសលេខសម្គាល់ការបើកប្រាក់ដើមជាមុន ដើម្បីផ្ទុកបុគ្គលិករបស់វា។",
            "selected": "បានជ្រើស {n} ក្នុងចំណោម {total}",
            "select-all": "ជ្រើសទាំងអស់",
            "deselect-all": "ដកការជ្រើសទាំងអស់",
            "resigning": "លាឈប់ {date}",
            "resigning-hint": "រកឃើញស្វ័យប្រវត្តិពីម៉ូឌុលបុគ្គលិក · បុគ្គលិកដែលមានកាលបរិច្ឆេទលាឈប់ក្នុងរយៈពេលបើកប្រាក់។",
            "resigning-empty-label": "បុគ្គលិកដែលកំពុងលាឈប់",
            "resigning-empty": "រកមិនឃើញបុគ្គលិកកំពុងលាឈប់ក្នុងបញ្ជីទេ។ ការបើកប្រាក់ចុងក្រោយត្រូវការការលាឈប់យ៉ាងហោចណាស់មួយ។",
            "eligible-hint": "បុគ្គលិកសកម្ម {n} នាក់ក្នុងបញ្ជី · ជ្រើសអ្នកដែលត្រូវបញ្ចូលក្នុងបៀវត្សរ៍ពិសេសនេះ។",
            "eligible-empty-label": "បុគ្គលិកដែលមានសិទ្ធិ",
            "eligible-empty": "គ្មានបុគ្គលិកសកម្មក្នុងបញ្ជីទេ។"
          },
          "amounts": {
            "title": "ចំនួនទឹកប្រាក់ {component}",
            "hint": "ចំនួនទឹកប្រាក់តាមបុគ្គលិកដែលបើកក្នុងការបើកប្រាក់នេះ — បំពេញជាមុនពីបញ្ជីដែលបានអនុម័ត ប្រសិនបើមាន។",
            "currency": "រូបិយប័ណ្ណ",
            "cols": {
              "code": "លេខសម្គាល់",
              "employee": "បុគ្គលិក",
              "dept": "នាយកដ្ឋាន",
              "amount": "ចំនួនទឹកប្រាក់",
              "reason": "មូលហេតុ"
            },
            "total": "សរុប",
            "empty": "សូមជ្រើសរើសបុគ្គលិកជាមុន។",
            "amount-label": "ចំនួនទឹកប្រាក់សម្រាប់ {name}",
            "reason-label": "មូលហេតុសម្រាប់ {name}",
            "reason-placeholder": "ស្រេចចិត្ត"
          },
          "dates": {
            "pay-date": "កាលបរិច្ឆេទបើកប្រាក់",
            "pay-date-hint": "កាលបរិច្ឆេទផុតកំណត់ស្វ័យប្រវត្តិ = ២ ថ្ងៃធ្វើការមុនកាលបរិច្ឆេទបើកប្រាក់",
            "cut-off": "ផុតកំណត់ (ស្វ័យប្រវត្តិ)",
            "period": "រយៈពេលបើកប្រាក់",
            "period-placeholder": "ជ្រើសរើសរយៈពេលបើកប្រាក់ដែលមានស្រាប់…",
            "period-hint": "ស្នើពីរយៈពេលបើកប្រាក់ដែលមានស្រាប់ ដើម្បីជៀសវាងកំហុសក្នុងការជ្រើសកាលបរិច្ឆេទ។",
            "period-inherited": "ទទួលពីលេខសម្គាល់ការបើកប្រាក់ដើមដែលបានជ្រើសនៅជំហានបុគ្គលិក។",
            "reason": "មូលហេតុ / ការពិពណ៌នា",
            "placeholder": {
              "bonus": "ឧ. ការបើកប្រាក់រង្វាន់ស្នាដៃចុងឆ្នាំ សម្រាប់ឆ្នាំសារពើពន្ធ ២០២៥",
              "incentive": "ឧ. ប្រាក់លើកទឹកចិត្តគោលដៅលក់ត្រីមាសទី ៤ — ក្រុមលក់",
              "adjustment": "ឧ. កែតម្រូវប្រាក់ឧបត្ថម្ភខែធ្នូដែលខកខាន — បុគ្គលិក ៤ នាក់",
              "final-pay": "ឧ. ការទូទាត់ចុងក្រោយសម្រាប់ការលាឈប់មានប្រសិទ្ធភាពក្នុងខែកុម្ភៈ ២០២៦",
              "special": "ឧ. ការបើកប្រាក់ខែទី ១៣ ស្របពេលចូលឆ្នាំខ្មែរ"
            }
          },
          "review": {
            "title": "ពិនិត្យ",
            "valid": "ការផ្ទៀងផ្ទាត់បានជោគជ័យ",
            "invalid": "រកឃើញបញ្ហាផ្ទៀងផ្ទាត់",
            "employees": "បុគ្គលិក",
            "cut-off": "ផុតកំណត់",
            "cycle": "វដ្តមេ",
            "totals-title": "សរុបតាមសមាសភាគ",
            "grand-total": "សរុបរួម"
          },
          "commit": {
            "action": "បង្កើតកាលវិភាគ",
            "submitting": "កំពុងបង្កើតកាលវិភាគ…",
            "error": "មិនអាចបង្កើតកាលវិភាគបានទេ — {message}",
            "success": "បានបង្កើតកាលវិភាគ{kind} — {date}"
          },
          "abandon": {
            "action": "បោះបង់សេចក្តីព្រាង",
            "title": "បោះបង់សេចក្តីព្រាងនេះ?",
            "body": "សេចក្តីព្រាងនឹងត្រូវបោះបង់ ហើយគ្មានកាលវិភាគត្រូវបានបង្កើតទេ។ មិនអាចត្រឡប់វិញបានទេ។",
            "confirm": "បោះបង់សេចក្តីព្រាង",
            "cancel": "រក្សាសេចក្តីព្រាង",
            "error": "មិនអាចបោះបង់សេចក្តីព្រាងបានទេ — {message}"
          }
        }
      },
      "templates": {
        "title": "គំរូ",
        "subtitle": "ការកំណត់ប្រាក់ខែដែលអាចប្រើឡើងវិញសម្រាប់វដ្តធម្មតា ការដំណើរការក្រៅវដ្ត និងប្រាក់ខែពិសេស។",
        "loading": "កំពុងផ្ទុកគំរូ…",
        "error": "មិនអាចផ្ទុកគំរូបានទេ — {message}",
        "empty": "មិនទាន់មានគំរូត្រូវបានបង្កើតសម្រាប់ស្ថាប័ននេះទេ។",
        "untitled": "គំរូគ្មានឈ្មោះ",
        "default-badge": "លំនាំដើម",
        "code": {
          "1ST_PAY": "ប្រាក់ខែលើកទីមួយ",
          "2ND_PAY": "ប្រាក់ខែលើកទីពីរ",
          "FINAL_PAY": "ប្រាក់ខែចុងក្រោយ"
        },
        "versions": {
          "btn": "ប្រវត្តិកំណែ",
          "heading": "ប្រវត្តិកំណែ",
          "loading": "កំពុងផ្ទុកកំណែ…",
          "error": "មិនអាចផ្ទុកកំណែបានទេ — {message}",
          "empty": "មិនមានប្រវត្តិកំណែទេ។",
          "version-label": "កំណែ {n}",
          "latest": "ចុងក្រោយ",
          "attributes": "{n} គុណលក្ខណៈ",
          "btn-for": "ប្រវត្តិកំណែនៃ {name}"
        },
        "clone": {
          "btn": "ចម្លង",
          "title": "ចម្លងគំរូ",
          "description": "បង្កើតគំរូថ្មីដោយផ្អែកលើគំរូដែលមានស្រាប់។",
          "name-label": "ឈ្មោះគំរូថ្មី",
          "default-name": "{name} (ចម្លង)",
          "name-required": "ឈ្មោះគំរូជាចាំបាច់។",
          "cancel": "បោះបង់",
          "confirm": "ចម្លង",
          "cloning": "កំពុងចម្លង…",
          "success": "គំរូ \"{name}\" បានបង្កើតដោយជោគជ័យ។",
          "btn-for": "ចម្លង {name}"
        },
        "import": {
          "btn": "នាំចូល",
          "coming-soon": "ការនាំចូលគំរូស្ថិតក្នុងផែនការ — នឹងមកដល់ក្នុងកំណែបន្ត។"
        },
        "new": {
          "btn": "គំរូថ្មី",
          "coming-soon": "ការបង្កើតគំរូស្ថិតក្នុងផែនការ — នឹងមកដល់ក្នុងកំណែបន្ត។"
        },
        "use": {
          "btn": "ប្រើ"
        },
        "computation": {
          "title": "ច្បាប់គណនា",
          "subtitle": "ការកំណត់គណនាប្រាក់ខែទូទៅ (អនុវត្តលើគ្រប់គំរូ)",
          "edit": "កែប្រែ",
          "ot-weekday-label": "មេគុណម៉ោងបន្ថែម (ថ្ងៃធ្វើការ)",
          "ot-weekday-value": "១.៥× តម្លៃម៉ោងមូលដ្ឋាន",
          "ot-weekend-label": "មេគុណម៉ោងបន្ថែម (ចុងសប្តាហ៍ / បុណ្យ)",
          "ot-weekend-value": "២.០× តម្លៃម៉ោងមូលដ្ឋាន",
          "daily-rate-label": "រូបមន្តប្រាក់ប្រចាំថ្ងៃ",
          "daily-rate-value": "មូលដ្ឋាន ÷ ២២ ថ្ងៃធ្វើការ · ប្រចាំម៉ោង៖ មូលដ្ឋាន ÷ ១៩៨ (២២ថ ​× ៩ម)",
          "workweek-label": "សប្តាហ៍ធ្វើការ",
          "workweek-value": "៥ ថ្ងៃ × ៩ ម៉ោង = ៤៥ ម៉ោង / សប្តាហ៍",
          "rounding-label": "ការបង្គត់",
          "rounding-value": "២ ខ្ទង់ទសភាគ បង្គត់ឡើង",
          "currency-label": "រូបិយប័ណ្ណលំនាំដើម",
          "currency-value": "USD (KHR សម្រាប់ការដាក់ TOS)",
          "first-payroll-offset-label": "ការផ្តាច់ប្រាក់ខែលើកដំបូង",
          "first-payroll-offset-value": "ពន្ធ និង NSSF អនុវត្តលើប្រាក់ខែលើកទីពីរប៉ុណ្ណោះ"
        },
        "retry": "ព្យាយាមម្ដងទៀត",
        "used-in": "បានប្រើក្នុង",
        "last-used": "ប្រើចុងក្រោយ",
        "runs": "ការដំណើរការ {n}",
        "edit": "កែប្រែ",
        "edit-for": "កែប្រែ {name}",
        "kind": {
          "Regular": "ធម្មតា",
          "Off-Cycle Bonus": "ប្រាក់រង្វាន់ក្រៅវដ្ត",
          "Off-Cycle Adjustment": "ការកែតម្រូវក្រៅវដ្ត",
          "Off-Cycle Final Pay": "ប្រាក់ខែចុងក្រោយក្រៅវដ្ត",
          "Off-Cycle Special": "ពិសេសក្រៅវដ្ត",
          "Draft": "សេចក្ដីព្រាង"
        }
      },
      "payslip": {
        "unnamed": "បុគ្គលិកគ្មានឈ្មោះ",
        "list": {
          "back": "ត្រឡប់ទៅការដំណើរការ",
          "title": "បាណ្ណប្រាក់ខែ",
          "subtitle": "បាណ្ណប្រាក់ខែតាមបុគ្គលិកសម្រាប់ការដំណើរការប្រាក់ខែនេះ។",
          "loading": "កំពុងផ្ទុកបាណ្ណប្រាក់ខែ…",
          "error": "មិនអាចផ្ទុកបាណ្ណប្រាក់ខែបានទេ — {message}",
          "empty": "មិនទាន់មានបាណ្ណប្រាក់ខែសម្រាប់ការដំណើរការនេះទេ។",
          "filtered-empty": "គ្មានបាណ្ណប្រាក់ខែត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "employees": "បុគ្គលិក {n} នាក់",
          "total-net": "ប្រាក់សុទ្ធសរុប",
          "held": "{n} កំពុងផ្អាក",
          "showing": "បាណ្ណប្រាក់ខែ {n} នៃ {total}"
        },
        "view": {
          "back": "ត្រឡប់ទៅបញ្ជីបាណ្ណប្រាក់ខែ",
          "title": "បាណ្ណប្រាក់ខែ",
          "subtitle": "រូបភាពនៃការគណនាជំហានទី៣ដែលបានចាក់សោ។",
          "loading": "កំពុងផ្ទុកបាណ្ណប្រាក់ខែ…",
          "error": "មិនអាចផ្ទុកបាណ្ណប្រាក់ខែបានទេ — {message}",
          "empty": "មិនមានបាណ្ណប្រាក់ខែសម្រាប់បុគ្គលិកនេះទេ។",
          "kicker": "បាណ្ណប្រាក់ខែផ្លូវការ",
          "pdf": "ទាញយក PDF (លម្អិតពេញលេញ)",
          "pdf-hint": "ពង្រីកក្រុមទាំងអស់ រួចបើកប្រអប់បោះពុម្ព → រក្សាទុកជា PDF",
          "lang": "ភាសាបាណ្ណប្រាក់ខែ"
        },
        "kpi": {
          "total": "សរុប",
          "ready": "ត្រៀមបង្កើត",
          "generated": "បានបង្កើត",
          "on-hold": "ស្ថិតក្នុងការផ្អាក",
          "distributed": "បានចែកចាយ"
        },
        "lock": {
          "locked": "ការដំណើរការត្រូវបានចាក់សោ",
          "unlocked": "ការដំណើរការមិនទាន់ត្រូវបានចាក់សោ"
        },
        "filter": {
          "all": "ស្ថានភាពទាំងអស់",
          "search-label": "ស្វែងរកតាមឈ្មោះ ឬលេខកូដ",
          "search-placeholder": "ស្វែងរកតាមឈ្មោះ ឬលេខកូដបុគ្គលិក…",
          "clear": "សម្អាតការស្វែងរក"
        },
        "status": {
          "ready-to-generate": "ត្រៀមបង្កើត",
          "generated": "បានបង្កើត",
          "on-hold": "ស្ថិតក្នុងការផ្អាក",
          "distributed": "បានចែកចាយ"
        },
        "hold-reason": {
          "MISSING_DELIVERY_METHOD": "ខ្វះវិធីសាស្ត្រចែកចាយ",
          "MISSING_EMAIL": "ខ្វះអាសយដ្ឋានអ៊ីមែល",
          "PORTAL_NOT_ACTIVATED": "ច្រកបុគ្គលិកមិនទាន់ត្រូវបានធ្វើឱ្យសកម្ម"
        },
        "delivery": {
          "MANUAL_DOWNLOAD": "ទាញយកដោយដៃ",
          "EMAIL": "អ៊ីមែល",
          "PORTAL": "ច្រកបុគ្គលិក"
        },
        "cols": {
          "employee": "បុគ្គលិក",
          "status": "ស្ថានភាព",
          "gross": "សរុប",
          "net": "សុទ្ធ",
          "delivery": "ការចែកចាយ",
          "actions": "សកម្មភាព",
          "item": "មុខទែទាត់",
          "amount": "ចំនួនទឹកប្រាក់",
          "id": "លេខសម្គាល់"
        },
        "actions": {
          "view": "បាណ្ណប្រាក់ខែ",
          "view-for": "បើកបាណ្ណប្រាក់ខែរបស់ {name}"
        },
        "doc": {
          "title": "បាណ្ណប្រាក់ខែ",
          "tagline": "លិខិតផ្លូវការនៃប្រាក់សំណងប្រចាំខែ",
          "run-id": "លេខការដំណើរការ: {id}"
        },
        "meta": {
          "employee-name": "ឈ្មោះបុគ្គលិក",
          "employee-id": "លេខសម្គាល់បុគ្គលិក",
          "template": "ប្រភេទប្រាក់ខែ",
          "pay-method": "វិធីបង់ប្រាក់",
          "delivery-contact": "ទំនាក់ទំនងចែកចាយ"
        },
        "summary": {
          "gross": "ប្រាក់ចំណូលសរុប",
          "deductions": "ការកាត់សរុប",
          "net": "ប្រាក់សុទ្ធ"
        },
        "section": {
          "earnings": "ចំណូល",
          "deductions": "ការកាត់",
          "empty-earnings": "មិនមានចំណូលត្រូវបានកត់ត្រាសម្រាប់បាណ្ណប្រាក់ខែនេះទេ។",
          "empty-deductions": "មិនមានការកាត់ត្រូវបានកត់ត្រាសម្រាប់បាណ្ណប្រាក់ខែនេះទេ។"
        },
        "totals": {
          "earnings": "ចំណូលសរុប",
          "deductions": "ការកាត់សរុប"
        },
        "hold-banner": {
          "title": "បាណ្ណប្រាក់ខែត្រូវបានផ្អាក",
          "hint": "ត្រូវដោះស្រាយការផ្អាកមុនពេលបង្កើត ឬចែកចាយបាណ្ណប្រាក់ខែនេះ។"
        },
        "note": {
          "label": "កំណត់ចំណាំសំខាន់",
          "body": "នេះជាបាណ្ណប្រាក់ខែដែលបង្កើតដោយប្រព័ន្ធ។ មិនចាំបាច់មានហត្ថលេខាទេ។ តួលេខដែលបង្ហាញគឺជារូបភាពនៃការគណនាជំហានទី៣ដែលបានចាក់សោ។",
          "generated-at": "បានបង្កើត: {date}",
          "file": "ឯកសារ: {name}"
        },
        "distribute": {
          "action": "ចែកចាយ",
          "title": "ចែកចាយបាណ្ណប្រាក់ខែ",
          "body": "ផ្ញើបាណ្ណប្រាក់ខែដែលបានបង្កើតតាមឆានែលចែកចាយមួយ។ ជួរដែលផ្អាក ឬមិនទាន់បង្កើតនឹងត្រូវរំលងដោយស្វ័យប្រវត្តិ។",
          "method-label": "ឆានែលចែកចាយ",
          "methods": {
            "manual": "ទាញយកដោយដៃ",
            "manual-hint": "សម្គាល់បាណ្ណប្រាក់ខែទាំងអស់ដែលបានបង្កើតថាបានចែកចាយ; អ្នកប្រើទាញយកឯកសារក្នុងពេលនេះ។",
            "email": "អ៊ីមែល",
            "email-hint": "ផ្ញើបាណ្ណប្រាក់ខែទៅអាសយដ្ឋានអ៊ីមែលដែលបានចុះឈ្មោះរបស់បុគ្គលិក។",
            "portal": "ច្រកសេវាខ្លួនឯង",
            "portal-hint": "ផ្សព្វផ្សាយបាណ្ណប្រាក់ខែទៅច្រកសេវាខ្លួនឯងរបស់បុគ្គលិក។"
          },
          "submit": "ចែកចាយឥឡូវនេះ",
          "submitting": "កំពុងចែកចាយ…",
          "cancel": "បោះបង់",
          "success": "បានចែកចាយបាណ្ណប្រាក់ខែ {count}។",
          "skipped": "បានរំលងជួរ {count}។",
          "error": "មិនអាចចែកចាយបាណ្ណប្រាក់ខែបានទេ — {message}",
          "kicker": "បាណ្ណប្រាក់ខែ"
        },
        "hold-resolve": {
          "action": "ដោះស្រាយការផ្អាក",
          "empty": "បើកបាណ្ណប្រាក់ខែដែលត្រូវផ្អាកដើម្បីដោះស្រាយ។",
          "reason-title": "មូលហេតុផ្អាក",
          "method-label": "ជ្រើសរើសវិធីចែកចាយ",
          "methods": {
            "manual": "ទាញយកដោយដៃ",
            "email": "អ៊ីមែល",
            "portal": "ច្រកសេវាខ្លួនឯង"
          },
          "email-label": "អ៊ីមែលបុគ្គលិក",
          "email-placeholder": "បញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់បុគ្គលិក",
          "email-required-error": "ត្រូវតែបញ្ចូលអាសយដ្ឋានអ៊ីមែលសម្រាប់ការផ្ញើតាមអ៊ីមែល។",
          "portal-label": "ដំណើរការច្រកសេវាខ្លួនឯងរបស់បុគ្គលិក",
          "portal-hint": "ចាំបាច់សម្រាប់ការផ្ញើតាមច្រកសេវាខ្លួនឯងដើម្បីឲ្យបុគ្គលិកអាចចូល។",
          "portal-required-error": "ត្រូវតែដំណើរការសម្រាប់ការផ្ញើតាមច្រកសេវាខ្លួនឯង។",
          "required-marker": "(ចាំបាច់)",
          "submit": "ដោះស្រាយការផ្អាក",
          "submitting": "កំពុងដោះស្រាយ…",
          "cancel": "បោះបង់",
          "error": "មិនអាចដោះស្រាយការផ្អាកបានទេ — {message}",
          "subtitle": "ជ្រើសរើសវិធីផ្ញើ។ ការដោះស្រាយត្រូវបានកត់ត្រាក្នុងប្រវត្តិសវនកម្ម។"
        },
        "generate": {
          "action": "បង្កើតបាណ្ណប្រាក់ខែ",
          "done": "បានបង្កើតបាណ្ណប្រាក់ខែ {n}។"
        },
        "hold": {
          "action": "ផ្អាកការបង់ប្រាក់",
          "kicker": "ផ្អាកការបង់ប្រាក់ · កំពុងរង់ចាំការស៊ើបអង្កេត",
          "title": "ផ្អាកការបង់ប្រាក់ — {name}",
          "subtitle": "{code} · សុទ្ធ {net}",
          "next-title": "អ្វីដែលនឹងកើតឡើងបន្ទាប់",
          "next-1": "បុគ្គលិកត្រូវបានដកចេញពីបាច់រង់ចាំរបស់ធនាគារ (ចំនួន និងទឹកប្រាក់ថយចុះ)។",
          "next-2": "បាណ្ណប្រាក់ខែរបស់ពួកគេត្រូវបានចាក់សោ — មិនបង្កើត មិនចែកចាយ — រហូតដល់អ្នកដោះស្រាយការផ្អាក។",
          "next-3": "ការដោះលែងនឹងដាក់ពួកគេត្រឡប់ទៅបាច់ធនាគារវិញ។",
          "reason-label": "មូលហេតុ (ចាំបាច់ កត់ត្រាក្នុងប្រវត្តិសវនកម្ម)",
          "reason-placeholder": "ឧ. ប្រធានផ្នែកបានទូរស័ព្ទមក — បុគ្គលិកមិនបានមកធ្វើការព្រឹកនេះ។ កំពុងរង់ចាំការស៊ើបអង្កេត។",
          "reason-required": "តម្រូវឱ្យមានមូលហេតុ។",
          "cancel": "បោះបង់",
          "badge": "បានផ្អាក — កំពុងរង់ចាំការស៊ើបអង្កេត",
          "release": "ដោះលែង",
          "done": "{name} ត្រូវបានផ្អាក — មិនរាប់បញ្ចូលក្នុងការចែកចាយបាណ្ណប្រាក់ខែ។",
          "released": "{name} ត្រូវបានដោះលែងសម្រាប់ការបង់ប្រាក់។",
          "title-hint": "ដកបុគ្គលិកនេះចេញពីបាច់ — កំពុងរង់ចាំការស៊ើបអង្កេត"
        },
        "verify": {
          "open": "បើកការផ្ទៀងផ្ទាត់",
          "qr": "កូដ QR ផ្ទៀងផ្ទាត់",
          "title": "ការផ្ទៀងផ្ទាត់បាណ្ណប្រាក់ខែ",
          "verified": "បានផ្ទៀងផ្ទាត់",
          "issued-by": "ឯកសារនេះត្រូវបានផ្ទៀងផ្ទាត់ និងចេញដោយ",
          "generated-at": "បង្កើតនៅ:",
          "hash": "កូដឯកសារ:",
          "run-id": "លេខសម្គាល់ដំណើរការ:",
          "employee": "បុគ្គលិក:",
          "contact": "សម្រាប់ការផ្ទៀងផ្ទាត់បន្ថែម សូមទាក់ទង:",
          "phone": "ទូរស័ព្ទ:",
          "email": "អ៊ីមែល:",
          "warning": "ការកែប្រែណាមួយលើឯកសារនេះនឹងធ្វើឱ្យភាពត្រឹមត្រូវរបស់វាគ្មានសុពលភាព។",
          "close": "បិទ"
        }
      },
      "shell": {
        "title": "ប្រាក់ខែ",
        "owning-suffix": "វិសាលភាពម្ចាស់ប្រាក់ខែ (ដំណើរការ)",
        "client-suffix": "ប្រាក់ខែដែលបានផ្សព្វផ្សាយ · អានតែប៉ុណ្ណោះ",
        "company-suffix": "ឋានានុក្រមប្រាក់ខែដែលបានផ្សព្វផ្សាយ · អានតែប៉ុណ្ណោះ (ការដំណើរការធ្វើនៅវិសាលភាពម្ចាស់)",
        "tenant-subtitle": "វិសាលភាពទាំងអស់ · ផលប័ត្រប្រតិបត្តិ · តែប្រាក់ខែដែលបានផ្សព្វផ្សាយ · អានតែប៉ុណ្ណោះ",
        "operations": "ប្រតិបត្តិការប្រាក់ខែ",
        "tabs-label": "ផ្នែកប្រាក់ខែ",
        "tabs": {
          "payroll-center": "មជ្ឈមណ្ឌលប្រាក់ខែ",
          "pay-input": "ទិន្នន័យបញ្ចូលប្រាក់ខែ",
          "reports": "របាយការណ៍",
          "templates": "គំរូ"
        },
        "module-name": "ប្រាក់ខែ",
        "portfolio-label": "ការត្រួតពិនិត្យប្រាក់ខែ",
        "portfolio-lead": "ការត្រួតពិនិត្យប្រាក់ខែនៅវិសាលភាពនេះ គឺសម្រាប់អានតែប៉ុណ្ណោះ។"
      },
      "portfolio": {
        "all-scopes": "វិសាលភាពទាំងអស់",
        "direct": "កម្លាំងពលកម្មផ្ទាល់",
        "direct-sub": "ម្ចាស់បើកប្រាក់ខែ · បុគ្គលិករបស់ក្រុមហ៊ុន",
        "client-rollup": "សរុបតាមអតិថិជន · អានតែប៉ុណ្ណោះ",
        "project-sub": "{id} · ម្ចាស់បើកប្រាក់ខែ",
        "months": {
          "m1": "មករា",
          "m2": "កុម្ភៈ",
          "m3": "មីនា",
          "m4": "មេសា",
          "m5": "ឧសភា",
          "m6": "មិថុនា",
          "m7": "កក្កដា",
          "m8": "សីហា",
          "m9": "កញ្ញា",
          "m10": "តុលា",
          "m11": "វិច្ឆិកា",
          "m12": "ធ្នូ"
        },
        "kpi": {
          "count": "បញ្ជីបើកប្រាក់ដែលបានផ្សព្វផ្សាយ",
          "emp": "បុគ្គលិកដែលបានទទួលប្រាក់",
          "gross": "ប្រាក់ខែសរុបដុល",
          "last": "ផ្សព្វផ្សាយចុងក្រោយ"
        },
        "col": {
          "workspace": "កន្លែងធ្វើការ",
          "projects": "គម្រោង",
          "published": "បញ្ជីបើកប្រាក់ដែលបានផ្សព្វផ្សាយ",
          "emp": "បុគ្គលិកដែលបានទទួលប្រាក់",
          "gross": "ប្រាក់ខែដុល",
          "last": "ផ្សព្វផ្សាយចុងក្រោយ",
          "status": "ស្ថានភាព",
          "scope": "វិសាលភាព",
          "latest": "ផ្សព្វផ្សាយថ្មីបំផុត",
          "period": "រយៈពេលបើកប្រាក់",
          "type": "ប្រភេទ",
          "employees": "បុគ្គលិក",
          "gross-short": "ដុល",
          "net": "សុទ្ធ",
          "published-on": "ផ្សព្វផ្សាយនៅ"
        },
        "status-published": "បានផ្សព្វផ្សាយ",
        "status-none": "គ្មាន",
        "demo": "សាកល្បង",
        "demo-title": "ប្រវត្តិទិន្នន័យសាកល្បង (PAY-PORT-97) — អាចលុបចេញដោយការផ្ទេរទិន្នន័យ",
        "search": "ស្វែងរកកន្លែងធ្វើការ…",
        "search-clear": "សម្អាតការស្វែងរក",
        "open-row": "បើក {name}",
        "open-company": "បើកកន្លែងធ្វើការប្រាក់ខែរបស់ក្រុមហ៊ុន",
        "view-latest": "មើលបញ្ជីបើកប្រាក់ដែលបានផ្សព្វផ្សាយចុងក្រោយ (អានតែប៉ុណ្ណោះ)",
        "open-owning": "បើកកន្លែងធ្វើការប្រាក់ខែ — វិសាលភាពម្ចាស់ (ដំណើរការ)",
        "empty-l1": "រកមិនឃើញបញ្ជីបើកប្រាក់ដែលបានផ្សព្វផ្សាយសម្រាប់តម្រងដែលបានជ្រើសទេ។",
        "empty-l3": "រកមិនឃើញបញ្ជីបើកប្រាក់ដែលបានផ្សព្វផ្សាយសម្រាប់វិសាលភាពនេះក្នុងរយៈពេលដែលបានជ្រើសទេ។",
        "foot-l1": "តែកន្លែងធ្វើការពិតប៉ុណ្ណោះ (ARCH-2) — ចុចមួយដើម្បីចូលទៅ ផ្ទាល់ / អតិថិជន / គម្រោង · ផលប័ត្រអានតែប៉ុណ្ណោះ",
        "foot-l2": "ចុចជួរដើម្បីមើលរយៈពេលដែលបានផ្សព្វផ្សាយ · រូបភ្នែកបើកកំណត់ត្រាចុងក្រោយ · សញ្ញាព្រួញប្ដូរទៅកន្លែងធ្វើការម្ចាស់",
        "foot-l3": "ចុចរយៈពេលបើកប្រាក់ដើម្បីបើកកំណត់ត្រាប្រាក់ខែដែលបានផ្សព្វផ្សាយ (អានតែប៉ុណ្ណោះ)",
        "l2-banner-lead": "មជ្ឈមណ្ឌលប្រាក់ខែ គឺជាកន្លែងធ្វើការ មិនមែនជារបាយការណ៍ទេ។",
        "l2-banner": "ការដំណើរការមានតែនៅវិសាលភាពដែលជាម្ចាស់ប្រាក់ខែប៉ុណ្ណោះ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — កម្រិតនេះពិនិត្យប្រវត្តិដែលបានផ្សព្វផ្សាយ និងរុករកតាមឋានានុក្រម។ ជួរអតិថិជនជាការសរុបរួម (អានតែប៉ុណ្ណោះ)។",
        "l4-banner-lead": "កំណត់ត្រាប្រាក់ខែដែលបានផ្សព្វផ្សាយ — រូបថតអានតែប៉ុណ្ណោះ។",
        "l4-banner": "នេះជាទំព័រកំណត់ត្រាប្រាក់ខែរបស់ម៉ូឌុលប្រាក់ខែ ដែលបង្ហាញពីការបើកប្រាក់ដែលបានចាក់សោ និងផ្សព្វផ្សាយ។ គ្មានប្រតិបត្តិការប្រាក់ខែនៅវិសាលភាពទាំងអស់ទេ; ការនាំចេញ CSV/Excel/PDF នៅតែអាចប្រើបាន (សកម្មភាពអានតែប៉ុណ្ណោះ)។",
        "loading": "កំពុងផ្ទុកបញ្ជីបើកប្រាក់ដែលបានផ្សព្វផ្សាយ…",
        "error": "មិនអាចផ្ទុកបញ្ជីបើកប្រាក់ដែលបានផ្សព្វផ្សាយបានទេ។",
        "retry": "ព្យាយាមម្ដងទៀត",
        "run-missing": "រកមិនឃើញការបើកប្រាក់ដែលបានផ្សព្វផ្សាយទេ។",
        "record": {
          "back": "ត្រឡប់ទៅរយៈពេលដែលបានផ្សព្វផ្សាយ",
          "pdf": "ទាញយក PDF",
          "title": "{period} — ប្រាក់ខែ{type}",
          "window": "រយៈពេលបើកប្រាក់ {window}",
          "run-id": "លេខសម្គាល់ការបើកប្រាក់",
          "published": "បានផ្សព្វផ្សាយ {at}",
          "locked": "បានអនុម័ត និងចាក់សោ",
          "published-by": "បានផ្សព្វផ្សាយ {at} ដោយ {by}",
          "employees": "បុគ្គលិក {n} នាក់",
          "totals": "សរុបនៃការបើកប្រាក់",
          "hc": "ចំនួនបុគ្គលិកដែលបានបើកប្រាក់",
          "hc-sub": "ចំនួនបុគ្គលិកដែលបានទទួលប្រាក់",
          "gross": "ប្រាក់ដុលសរុប",
          "gross-sub": "ប្រាក់គោល + ប្រាក់ឧបត្ថម្ភ + ម៉ោងបន្ថែម + ប្រាក់បើកយឺត + អតីតភាព",
          "ded": "ការកាត់សរុប",
          "ded-sub": "ពន្ធ (TOS) + ប.ស.ស + ច្បាប់គ្មានប្រាក់ + ការទូទាត់ប្រាក់បុរេប្រទាន + ផ្សេងៗ",
          "net": "ប្រាក់សុទ្ធសរុប",
          "net-sub": "ការទូទាត់ចុងក្រោយដល់បុគ្គលិក {n} នាក់",
          "earnings": "ប្រាក់ចំណូល",
          "basic": "ប្រាក់ខែគោល",
          "advance": "ប្រាក់បុរេប្រទាន (៥០% នៃប្រាក់គោល)",
          "allowances": "ប្រាក់ឧបត្ថម្ភ",
          "overtime": "ម៉ោងបន្ថែម",
          "back-pay": "ប្រាក់បើកយឺត",
          "seniority": "អតីតភាព",
          "total-gross": "ដុលសរុប",
          "deductions": "ការកាត់",
          "unpaid": "ច្បាប់គ្មានប្រាក់",
          "tax": "ពន្ធ (TOS)",
          "nssf": "ប.ស.ស (បុគ្គលិក)",
          "offset": "ការទូទាត់ប្រាក់បុរេប្រទានលើកទី១",
          "other": "ការកាត់ផ្សេងៗ",
          "total-ded": "ការកាត់សរុប",
          "detail": "ព័ត៌មានលម្អិតបុគ្គលិក ({n})",
          "col": {
            "employee": "បុគ្គលិក",
            "dept": "នាយកដ្ឋាន",
            "pay-method": "វិធីបើកប្រាក់",
            "bank": "ធនាគារ",
            "gross": "ដុល",
            "tax": "ពន្ធ",
            "nssf": "ប.ស.ស",
            "deductions": "ការកាត់",
            "net": "សុទ្ធ"
          },
          "loading": "កំពុងផ្ទុកជួរបុគ្គលិក…",
          "error": "មិនអាចផ្ទុកជួរបុគ្គលិកបានទេ។",
          "no-lines": "គ្មានជួរបុគ្គលិកក្នុងការបើកប្រាក់នេះទេ។",
          "compliance": "ការអនុលោម",
          "cycle": "វដ្តប្រាក់ខែ",
          "bimonthly": "ពីរដងក្នុងមួយខែ",
          "tax-applied": "បានអនុវត្តពន្ធ",
          "nssf-applied": "បានអនុវត្ត ប.ស.ស",
          "currency": "រូបិយប័ណ្ណ",
          "rounding": "ការបង្គត់",
          "two-dec": "ខ្ទង់ទសភាគ ២",
          "offset-row": "ការទូទាត់ប្រាក់ខែលើកទី១",
          "applied": "បានអនុវត្ត (លើកទី២)",
          "yes": "បាទ/ចាស",
          "no": "ទេ",
          "audit": "ប្រវត្តិសវនកម្ម",
          "audit-published": "ប្រាក់ខែត្រូវបានផ្សព្វផ្សាយ",
          "audit-locked": "រូបថតត្រូវបានចាក់សោ",
          "audit-locked-sub": "អានតែប៉ុណ្ណោះបន្ទាប់ពី {at}",
          "footer": "បង្កើតដោយ Optimal HR — ម៉ូឌុលប្រាក់ខែ · ឯកសារនេះឆ្លុះបញ្ចាំងពីរូបថតប្រាក់ខែដែលបានចាក់សោ។",
          "footer-run": "លេខសម្គាល់ការបើកប្រាក់៖ {id}"
        }
      },
      "bridge": {
        "label": "ធាតុបញ្ចូលប្រាក់ខែ — ប្រមូល",
        "kpi": {
          "employees": "បុគ្គលិក",
          "basic": "ប្រាក់គោលសរុប",
          "allowances": "ប្រាក់ឧបត្ថម្ភ",
          "ot": "ម៉ោងបន្ថែម (បានអនុម័ត)",
          "attention": "ត្រូវការការយកចិត្តទុកដាក់"
        },
        "info-lead": "ទិន្នន័យពីប្រព័ន្ធ អាចកែបានមុនពេលដំណើរការ។",
        "info": "ប្រាក់គោល (មូលដ្ឋានអត្រា × វត្តមានដែលបានចាក់សោ សម្រាប់ប្រចាំថ្ងៃ/ប្រចាំម៉ោង) ប្រាក់ឧបត្ថម្ភលម្អិត (កំណត់ត្រាប្រាក់សំណង) ម៉ោងបន្ថែមដែលបានអនុម័តចាត់ថ្នាក់តាមប្រភេទថ្ងៃ ថ្ងៃច្បាប់គ្មានប្រាក់/ច្បាប់ប្រចាំឆ្នាំដែលបានអនុម័ត និងសញ្ញាចលនា ត្រូវបានបំពេញជាមុនពីម៉ូឌុលផ្ទាល់។ តម្លៃដែលជាកម្មសិទ្ធិប្រភព (ប្រាក់គោល ប្រាក់ឧបត្ថម្ភ អតីតភាព ច្បាប់ ម៉ោងបន្ថែម) អានតែប៉ុណ្ណោះនៅទីនេះ — សូមកែនៅម៉ូឌុលម្ចាស់។ មានតែធាតុបញ្ចូលរបស់ប្រាក់ខែ (ប្រាក់រង្វាន់ ប្រាក់លើកទឹកចិត្ត ការកែតម្រូវ សមាសធាតុម្ដង) ប៉ុណ្ណោះដែលអាចកែបាន។",
        "src": {
          "ec": "ប្រាក់សំណងជាធរមាន · កំណត់ត្រាការងារ",
          "att": "វត្តមាន",
          "lv": "ច្បាប់ឈប់សម្រាក",
          "man": "ការបញ្ចូលដោយដៃរបស់ប្រាក់ខែ"
        },
        "col": {
          "employee": "បុគ្គលិក",
          "basis": "មូលដ្ឋាន",
          "basic": "ប្រាក់គោល $",
          "allowances": "ប្រាក់ឧបត្ថម្ភ",
          "seniority": "អតីតភាព $",
          "ot": "ម៉ោងបន្ថែម",
          "unpaid": "ថ្ងៃគ្មានប្រាក់",
          "al": "ថ្ងៃច្បាប់ប្រចាំឆ្នាំ",
          "bonus": "ប្រាក់រង្វាន់ $",
          "incentive": "ប្រាក់លើកទឹកចិត្ត $",
          "adjust": "កែតម្រូវ $",
          "flags": "សញ្ញា"
        },
        "est": "ប៉ាន់ស្មាន",
        "locked": "បានចាក់សោ",
        "lock": {
          "basic": "ប្រាក់ខែគោល — គ្រប់គ្រងក្នុងប្រាក់សំណងជាធរមាន (កំណត់ត្រាការងារ)។ អានតែប៉ុណ្ណោះក្នុងប្រាក់ខែ។",
          "seniority": "សិទ្ធិអតីតភាព — គ្រប់គ្រងក្នុងប្រាក់សំណងជាធរមាន។ អានតែប៉ុណ្ណោះក្នុងប្រាក់ខែ។",
          "unpaid": "ថ្ងៃច្បាប់គ្មានប្រាក់ — ពីសំណើច្បាប់ដែលបានអនុម័ត។ អានតែប៉ុណ្ណោះក្នុងប្រាក់ខែ។",
          "al": "ថ្ងៃច្បាប់ប្រចាំឆ្នាំ — ពីសំណើច្បាប់ដែលបានអនុម័ត។ អានតែប៉ុណ្ណោះក្នុងប្រាក់ខែ។"
        },
        "ot-tip": "ថ្ងៃធ្វើការ {weekday}ម៉ · ថ្ងៃឈប់ {dayOff}ម៉ · ធ្វើការថ្ងៃបុណ្យ {holWork}ម៉ · ថ្ងៃបុណ្យត្រូវថ្ងៃឈប់ {holOff}ម៉",
        "ot-none": "គ្មានម៉ោងបន្ថែមដែលបានអនុម័តក្នុងរយៈពេលនេះ",
        "ot-src": "ពីវត្តមាន (ម៉ោងបន្ថែមដែលបានអនុម័ត)។ អានតែប៉ុណ្ណោះក្នុងប្រាក់ខែ។",
        "src-manual": "ប្រភព៖ ការបញ្ចូលដោយដៃរបស់ប្រាក់ខែ (សម្រាប់ការបើកប្រាក់នេះតែប៉ុណ្ណោះ)",
        "src-ec": "ប្រភព៖ ប្រាក់សំណងជាធរមាន · រក្សាក្នុងកំណត់ត្រាការងារ · មានប្រសិទ្ធភាព {eff}",
        "add": "+ បន្ថែម",
        "add-from": "បន្ថែមសមាសធាតុពីកាតាឡុក៖",
        "add-amount": "ចំនួនទឹកប្រាក់ (USD)",
        "add-btn": "បន្ថែម",
        "add-hint": "ការកាត់៖ ប្រើការកែតម្រូវអវិជ្ជមាន",
        "add-nonzero": "សូមបញ្ចូលចំនួនមិនមែនសូន្យ",
        "remove": "លុប {code}",
        "edit": {
          "bonus": "ប្រាក់រង្វាន់សម្រាប់ {name}",
          "incentive": "ប្រាក់លើកទឹកចិត្តសម្រាប់ {name}",
          "adjustment": "ការកែតម្រូវសម្រាប់ {name}"
        },
        "warn": {
          "no-bank": "គ្មានគណនីធនាគារ",
          "estimated": "គ្មានវត្តមានដែលបានចាក់សោ — ការប៉ាន់ស្មានខែស្តង់ដារ",
          "zero-basic": "ប្រាក់គោលសូន្យ"
        },
        "move": {
          "termination": "ការបញ្ចប់ការងារ",
          "new-hire": "បុគ្គលិកថ្មី",
          "unpaid-leave": "ច្បាប់គ្មានប្រាក់"
        },
        "empty": "គ្មានបុគ្គលិកមានសិទ្ធិទទួលប្រាក់ខែក្នុងវិសាលភាពនេះទេ។",
        "loading": "កំពុងផ្ទុកធាតុបញ្ចូលប្រាក់ខែ…",
        "error": "មិនអាចផ្ទុកធាតុបញ្ចូលប្រាក់ខែបានទេ។",
        "reset": "កំណត់ការកែឡើងវិញ"
      },
      "reports": {
        "title": "របាយការណ៍",
        "subtitle": "របាយការណ៍ដែលបានបង្កើតសម្រាប់ការដំណើរការប្រាក់ខែដែលបានបញ្ចប់ — មើលជាមុន ទាញយក PDF ឬនាំចេញ Excel។",
        "year-label": "តម្រងតាមឆ្នាំ",
        "all-years": "គ្រប់ឆ្នាំ",
        "all": "ទាំងអស់",
        "export-all": "នាំចេញទាំងអស់ (ZIP)",
        "export-all-start": "កំពុងនាំចេញការដំណើរការ {n} · របាយការណ៍ ៤ ក្នុងមួយ — សូមមើលការទាញយករបស់អ្នក",
        "export-none": "គ្មានការដំណើរការបានបញ្ចប់ដើម្បីនាំចេញ",
        "exported": "{tab} បាននាំចេញ — {name}",
        "popup-blocked": "អនុញ្ញាតផ្ទាំងលេចឡើងដើម្បីបោះពុម្ព PDF។",
        "tabs-label": "ប្រភេទរបាយការណ៍",
        "tabs": {
          "summary": "សង្ខេបប្រាក់ខែ",
          "detail": "ប្រាក់ខែលម្អិត",
          "tos": "របាយការណ៍ពន្ធ (TOS)",
          "nssf": "របាយការណ៍ NSSF"
        },
        "kpi": {
          "reports": "របាយការណ៍",
          "hc": "ចំនួនបុគ្គលិកបានបើកសរុប",
          "net": "ប្រាក់សុទ្ធបានបើកសរុប",
          "gross": "ប្រាក់សរុបបានបើក",
          "tax": "ពន្ធសរុប (TOS)",
          "avg-tax": "ពន្ធមធ្យម / ការដំណើរការ",
          "nssf": "NSSF សរុប (បុគ្គលិក)",
          "avg-nssf": "NSSF មធ្យម / ការដំណើរការ",
          "hc-filed": "ចំនួនបុគ្គលិកបានដាក់"
        },
        "kpi-sub": {
          "reports": "ការដំណើរការបានបញ្ចប់",
          "hc": "កំណត់ត្រាបុគ្គលិក",
          "net": "កំឡុងពេលតម្រង",
          "gross": "មុនការកាត់",
          "tax": "បានដាក់ក្នុងកំឡុងពេល",
          "avg-tax": "មធ្យមបន្ត",
          "nssf": "សោធននិវត្តន៍ ២%",
          "avg-nssf": "មធ្យមបន្ត",
          "hc-filed": "កំណត់ត្រាបុគ្គលិក"
        },
        "search-placeholder": "ស្វែងរកតាមលេខការដំណើរការ កំឡុងពេល ឬអ្នកអនុម័ត…",
        "search-label": "ស្វែងរករបាយការណ៍",
        "clear-search": "សម្អាតការស្វែងរក",
        "result-count": "ការដំណើរការ {n} | ការដំណើរការ {n}",
        "remove-filter": "ដកតម្រងចេញ៖ {filter}",
        "error": "មិនអាចផ្ទុករបាយការណ៍បានទេ — {message}",
        "retry": "ព្យាយាមម្ដងទៀត",
        "empty": "មិនទាន់មានប្រាក់ខែបានបញ្ចប់ទេ។ របាយការណ៍នឹងបង្ហាញនៅទីនេះបន្ទាប់ពីការដំណើរការត្រូវបានបិទ។",
        "empty-filtered": "គ្មានរបាយការណ៍ត្រូវនឹងតម្រងរបស់អ្នកទេ។ សាកសម្អាតការស្វែងរក ឬតម្រងឆ្នាំ។",
        "runs": "ការដំណើរការ {n} | ការដំណើរការ {n}",
        "total-prefix": "សរុប៖",
        "across": "លើ",
        "employee-records": "កំណត់ត្រាបុគ្គលិក",
        "cols": {
          "run": "ការដំណើរការ",
          "type": "ប្រភេទ",
          "period": "កំឡុងពេលប្រាក់ខែ",
          "pay-date": "ថ្ងៃបើកប្រាក់",
          "employees": "បុគ្គលិក",
          "net": "ប្រាក់សុទ្ធ",
          "status": "ស្ថានភាព",
          "approver": "អ្នកអនុម័ត",
          "actions": "សកម្មភាព"
        },
        "type": {
          "regular": "ធម្មតា",
          "other": "ក្រៅវដ្ត"
        },
        "completed": "បានបញ្ចប់",
        "view": "មើល {tab}",
        "view-for": "មើល {tab} សម្រាប់ {run}",
        "pdf": "ទាញយក PDF",
        "pdf-for": "ទាញយក PDF សម្រាប់ {run}",
        "excel": "ទាញយក Excel",
        "excel-for": "ទាញយក Excel សម្រាប់ {run}"
      }
    },
    "people": {
      "title": "បុគ្គលិក",
      "subtitle": "បុគ្គលិក {total} នាក់",
      "page-subtitle": "ក្នុងស្ថាប័ន {direct} · ខាងក្រៅ {outsourced}",
      "tab-coming-soon": "នឹងមានក្នុងការអាប់ដេតបន្ទាប់",
      "tabs": {
        "directory": "បញ្ជី",
        "outsourced": "កម្លាំងពលកម្មក្រៅ",
        "clients": "អតិថិជន",
        "external": "អ្នកអនុម័តខាងក្រៅ",
        "emp-records": "កំណត់ហេតុការងារ",
        "sites": "ទីតាំង",
        "org-units": "អង្គភាព",
        "org-chart": "គំនូសតាងអង្គភាព",
        "workforce-plan": "ផែនការកម្លាំងពលកម្ម",
        "positions": "មុខតំណែង",
        "onboarding": "ការចូលបំពេញការងារ",
        "offboarding": "ការចាកចេញពីការងារ",
        "compliance": "ការអនុលោម",
        "configuration": "ការកំណត់"
      },
      "clients": {
        "subtitle": "អតិថិជនជួលកម្លាំងពលកម្ម · ដាក់ក្រុមគម្រោង · អ្នកអនុម័តខាងក្រៅ",
        "add-client": "បន្ថែមអតិថិជន",
        "search-placeholder": "ស្វែងរកអតិថិជន ទំនាក់ទំនង វិស័យ…",
        "status-unknown": "មិនស្គាល់",
        "yes": "បាទ/ចាស",
        "no": "ទេ",
        "banner": {
          "title": "អតិថិជន",
          "lead": "អតិថិជនម្នាក់ដាក់ក្រុមគម្រោងជួលកម្លាំងពលកម្មមួយ ឬច្រើន (ឧ. Unilever → APSARA · NAO)។ គម្រោងផ្ទុកបុគ្គលិក ហើយអ្នកអនុម័តខាងក្រៅជាប់នឹងអតិថិជន។"
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "archived": "ទុកក្នុងប័ណ្ណសារ",
          "all-platform": "គ្រប់វេទិកា",
          "on-platform": "នៅលើវេទិកា",
          "off-platform": "មិននៅលើវេទិកា",
          "label-status": "ស្ថានភាព",
          "label-platform": "វេទិកា",
          "label-search": "ស្វែងរក"
        },
        "actions": {
          "clear-filters": "សម្អាតតម្រង",
          "cancel": "បោះបង់",
          "create": "បង្កើតអតិថិជន",
          "save": "រក្សាទុកការផ្លាស់ប្តូរ"
        },
        "table": {
          "name": "អតិថិជន",
          "industry": "វិស័យ",
          "contact": "ទំនាក់ទំនងចម្បង",
          "platform": "វេទិកា",
          "status": "ស្ថានភាព",
          "on-platform-tag": "នៅលើវេទិកា",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} អតិថិជន",
          "click-hint": "ចុចជួរដេកដើម្បីបើកប្រវត្តិរូបអតិថិជន"
        },
        "empty": {
          "title": "មិនមានអតិថិជនត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។"
        },
        "error": "មិនអាចផ្ទុកអតិថិជនបានទេ។",
        "error-403": "អ្នកមិនមានសិទ្ធិចូលមើលបញ្ជីអតិថិជននេះទេ។",
        "retry": "ព្យាយាមម្តងទៀត",
        "fields": {
          "name": "ឈ្មោះបង្ហាញ",
          "name-placeholder": "ឧ. Unilever",
          "legal-name": "ឈ្មោះស្របច្បាប់",
          "industry": "វិស័យ",
          "on-platform": "អតិថិជននៅលើ OptimalHR ផងដែរ (ឆ្លងភតិកៈ)",
          "counterparty": "ភតិកៈដៃគូ",
          "primary-contact": "ទំនាក់ទំនងចម្បង",
          "contact-name": "ឈ្មោះអ្នកទំនាក់ទំនង",
          "contact-email": "អ៊ីមែលអ្នកទំនាក់ទំនង",
          "contact-phone": "ទូរស័ព្ទអ្នកទំនាក់ទំនង",
          "email-invalid": "សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ។",
          "address": "អាសយដ្ឋាន",
          "notes": "កំណត់ចំណាំ"
        },
        "engagement": {
          "provider-managed": "គ្រប់គ្រងដោយអ្នកផ្គត់ផ្គង់",
          "vendor-lite": "អ្នកលក់ស្រាល",
          "service": "សេវាកម្ម",
          "unknown": "មិនស្គាល់"
        },
        "create": {
          "title": "បន្ថែមអតិថិជន",
          "subtitle": "បង្កើតអតិថិជនជួលកម្លាំងពលកម្មថ្មី។"
        },
        "edit": {
          "title": "កែសម្រួលអតិថិជន"
        },
        "profile": {
          "back": "ត្រឡប់ទៅអតិថិជន",
          "edit": "កែសម្រួល",
          "error": "មិនអាចផ្ទុកអតិថិជននេះបានទេ។",
          "sections": {
            "profile": "ប្រវត្តិរូប",
            "projects": "គម្រោង",
            "approvers": "អ្នកអនុម័តខាងក្រៅ",
            "staff": "បុគ្គលិក"
          }
        },
        "projects": {
          "add": "បន្ថែមគម្រោង",
          "edit": "កែសម្រួល",
          "create-title": "បន្ថែមគម្រោង",
          "edit-title": "កែសម្រួលគម្រោង",
          "empty": "មិនទាន់មានគម្រោងក្រោមអតិថិជននេះទេ។",
          "error": "មិនអាចផ្ទុកគម្រោងបានទេ។",
          "contract-count": "កិច្ចសន្យា {n}",
          "fields": {
            "name": "ឈ្មោះគម្រោង",
            "engagement": "ប្រភេទការជាប់ពាក់ព័ន្ធ",
            "org-full": "ឈ្មោះពេញរបស់ស្ថាប័ន",
            "org-short": "ឈ្មោះខ្លីរបស់ស្ថាប័ន",
            "id-format": "ទម្រង់លេខសម្គាល់បុគ្គលិក",
            "id-format-hint": "លំនាំស្រេចចិត្តសម្រាប់លេខកូដបុគ្គលិកដែលបង្កើតដោយស្វ័យប្រវត្តិ។"
          }
        },
        "approvers": {
          "placeholder": "អ្នកអនុម័តខាងក្រៅសម្រាប់អតិថិជននេះត្រូវបានគ្រប់គ្រងនៅក្នុងផ្ទាំងអ្នកអនុម័តខាងក្រៅ។",
          "go-to-tab": "បើកអ្នកអនុម័តខាងក្រៅ",
          "error": "មិនអាចផ្ទុកអ្នកអនុម័ត។",
          "empty": "មិនទាន់មានអ្នកអនុម័តខាងក្រៅសម្រាប់អតិថិជននេះ។",
          "count": "អ្នកអនុម័តសកម្ម {active} · គម្រោងបានគ្របដណ្ដប់ {covered}/{total}"
        },
        "staff": {
          "placeholder": "បញ្ជីបុគ្គលិកតាមអតិថិជននឹងមកដល់នៅផ្នែកក្រោយ។ ឥឡូវនេះ សូមមើលចំនួនកិច្ចសន្យាក្រោមគម្រោងនីមួយៗ។"
        },
        "toasts": {
          "created": "បានបង្កើតអតិថិជន \"{name}\"។",
          "create-failed": "មិនអាចបង្កើតអតិថិជនបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "saved": "បានរក្សាទុកអតិថិជន។",
          "save-failed": "មិនអាចរក្សាទុកអតិថិជនបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "project-created": "បានបង្កើតគម្រោង \"{name}\"។",
          "project-saved": "បានរក្សាទុកគម្រោង។",
          "project-failed": "មិនអាចរក្សាទុកគម្រោងបានទេ។ សូមព្យាយាមម្តងទៀត។"
        }
      },
      "emp-records": {
        "title": "កំណត់ហេតុការងារ",
        "subtitle": "ការផ្ដល់ការងារ · កិច្ចសន្យា · សកម្មភាពការងារ · សំណង · អត្ថប្រយោជន៍ — មជ្ឈមណ្ឌលតែមួយសម្រាប់រឿងរ៉ាវការងាររបស់បុគ្គលិក",
        "actions": {
          "new-record": "កំណត់ហេតុថ្មី",
          "view": "មើល",
          "clear-filters": "សម្អាតតម្រង",
          "cancel": "បោះបង់",
          "close": "បិទ",
          "edit": "កែសម្រួល"
        },
        "sub-tabs": {
          "offers": "ការផ្ដល់ការងារ",
          "contracts": "កិច្ចសន្យា",
          "actions": "សកម្មភាពការងារ",
          "compensation": "សំណង",
          "benefits": "អត្ថប្រយោជន៍"
        },
        "dispatch": {
          "title": "បង្កើតកំណត់ហេតុការងារ",
          "lede": "សូមជ្រើសប្រភេទកំណត់ហេតុដែលអ្នកចង់បង្កើត — យើងនឹងបង្ហាញនូវជំហានបន្ទាប់។",
          "form-title": "{kind} ថ្មី",
          "form-lede": "បំពេញព័ត៌មានមូលដ្ឋាន — ក្រុមការងារនឹងទទួលបានការជូនដំណឹងពេលអ្នកបញ្ជូន។",
          "back": "ត្រឡប់",
          "cancel": "បោះបង់",
          "submit": "បង្កើត",
          "created-toast": "បានបង្កើតសេចក្ដីព្រាង {kind} សម្រាប់ {employee}",
          "fields": {
            "employee": "បុគ្គលិក ឬបេក្ខជន",
            "detail": "កំណត់ចំណាំ / ព័ត៌មានលម្អិត"
          },
          "placeholders": {
            "employee": "ស្វែងរកតាមឈ្មោះ ឬកូដបុគ្គលិក…",
            "detail": "បន្ថែមបរិបទ — កាលបរិច្ឆេទមានសុពលភាព ចំនួនទឹកប្រាក់ លក្ខខណ្ឌ ។ល។"
          },
          "errors": {
            "no-kind": "សូមជ្រើសប្រភេទកំណត់ហេតុជាមុនសិន។",
            "employee-required": "បុគ្គលិក ឬបេក្ខជន គឺត្រូវការ។"
          },
          "offer": {
            "title": "ការផ្ដល់ការងារ",
            "desc": "ព្រាងលិខិតផ្ដល់ការងារសម្រាប់បេក្ខជន។"
          },
          "contract": {
            "title": "កិច្ចសន្យា",
            "desc": "ចេញកិច្ចសន្យាការងារថ្មី។"
          },
          "action": {
            "title": "សកម្មភាពការងារ",
            "desc": "ការតម្លើងតួនាទី ការផ្ទេរ ឬការផ្លាស់ប្ដូរប្រាក់ខែ។"
          },
          "benefit": {
            "title": "អត្ថប្រយោជន៍",
            "desc": "ចុះឈ្មោះបុគ្គលិកចូលក្នុងកម្មវិធីអត្ថប្រយោជន៍។"
          },
          "compensation": {
            "title": "ព្រឹត្តិការណ៍សំណង",
            "desc": "កត់ត្រាការផ្លាស់ប្ដូរប្រាក់ខែ ប្រាក់រង្វាន់ ឬប្រាក់ឧបត្ថម្ភ។"
          }
        },
        "offers": {
          "banner": "លិខិតផ្ដល់ការងារ គឺជាសំណើការងារមុនកិច្ចសន្យា ដែលចេញជូនបេក្ខជនមុនពេលបន្ថែមបុគ្គល។ វដ្ត៖ សេចក្ដីព្រាង → បានចេញ → បានទទួលយក (ឬ បដិសេធ / ដកវិញ / ផុតកំណត់)។ បន្ទាប់ពីចេញ ប៉ុន្តែមុនពេលទទួលយក ការកែប្រែបង្កើតកំណែថ្មី (កែ & ចេញឡើងវិញ)។ ពេលទទួលយក ការបង្កើតបុគ្គល + កិច្ចសន្យា + សំណង នឹងដំណើរការនៅ CT-4។",
          "search-placeholder": "បេក្ខជន តួនាទី លេខការផ្ដល់…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "footer-note": "បង្ហាញ {shown} ក្នុងចំណោម {total} ការផ្ដល់ · អនុញ្ញាតឱ្យកែតម្រូវតាមការផ្ដល់នីមួយៗ — កញ្ចប់ពីបណ្ណាល័យប្រាក់ឧបត្ថម្ភ & អត្ថប្រយោជន៍ ជាចំណុចចាប់ផ្ដើម មិនមែនជាការកំណត់។",
          "new-offer": "ការផ្ដល់ថ្មី",
          "filters": {
            "status": "ស្ថានភាព",
            "workforce": "ប្រភេទកម្លាំងពលកម្ម",
            "search": "ស្វែងរក"
          },
          "status-filter": {
            "open": "បើកចំហ (ព្រាង + បានចេញ)",
            "all": "ស្ថានភាពទាំងអស់"
          },
          "statuses": {
            "Draft": "សេចក្ដីព្រាង",
            "Issued": "បានចេញ",
            "Distributed": "បានផ្ញើ",
            "Accepted": "បានទទួលយក",
            "Declined": "បានបដិសេធ",
            "Withdrawn": "បានដកវិញ",
            "Expired": "ផុតកំណត់"
          },
          "workforce": {
            "all": "ទាំងអស់",
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "kpi": {
            "all": "ទាំងអស់",
            "draft": "សេចក្ដីព្រាង",
            "issued-not-sent": "បានចេញ · មិនទាន់ផ្ញើ",
            "distributed": "បានផ្ញើ · កំពុងរង់ចាំចម្លើយ",
            "accepted": "បានទទួលយក",
            "declined": "បានបដិសេធ"
          },
          "cols": {
            "code": "លេខការផ្ដល់",
            "candidate": "បេក្ខជន",
            "position": "តួនាទី",
            "scope": "វិសាលភាព",
            "salary": "ប្រាក់ខែ",
            "type-on-accept": "ប្រភេទ → ពេលទទួលយក",
            "issued": "បានចេញ",
            "status": "ស្ថានភាព",
            "actions": "សកម្មភាព"
          },
          "scope": {
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "drawer": {
            "candidate-email": "អ៊ីមែល",
            "candidate-phone": "ទូរស័ព្ទ",
            "scope": "វិសាលភាព",
            "position": "តួនាទី",
            "job-grade": "កម្រិតការងារ",
            "contract-type": "ប្រភេទកិច្ចសន្យាពេលទទួលយក",
            "salary": "ប្រាក់ខែសរុប (ប្រចាំខែ)",
            "start": "ការចាប់ផ្ដើមដែលស្នើ",
            "valid-until": "មានសុពលភាពដល់",
            "end": "ការបញ្ចប់ដែលស្នើ",
            "probation-end": "សាកល្បងបញ្ចប់",
            "allowances": "ប្រាក់ឧបត្ថម្ភ",
            "notes": "កំណត់ចំណាំផ្ទៃក្នុង",
            "issued": "បានចេញ",
            "distributed": "បានផ្ញើ",
            "accepted": "បានទទួលយក",
            "declined-reason": "មូលហេតុបដិសេធ"
          },
          "empty": {
            "title": "មិនមានការផ្ដល់ត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។"
          },
          "form": {
            "new-title": "លិខិតផ្ដល់ការងារថ្មី",
            "new-sub": "សេចក្ដីព្រាង · ជ្រើសតួនាទី កញ្ចប់នឹងបំពេញដោយស្វ័យប្រវត្តិ",
            "no-name": "(គ្មានឈ្មោះ)",
            "no-position": "(គ្មានតួនាទី)",
            "close": "បិទ",
            "view-mode": "របៀបមើល។",
            "edit": "កែសម្រួល",
            "chain": "កំណែ {version} · ខ្សែសង្វាក់ការផ្ដល់ដែលបានកែ។",
            "candidate": "បេក្ខជន",
            "latin-name": "ឈ្មោះឡាតាំង *",
            "khmer-name": "ឈ្មោះខ្មែរ",
            "email": "អ៊ីមែល",
            "phone": "ទូរស័ព្ទ",
            "position-contract": "តួនាទី និងប្រភេទកិច្ចសន្យា",
            "workforce-type": "ប្រភេទកម្លាំងពលកម្ម *",
            "job-grade": "កម្រិតការងារ *",
            "grade-hint": "(តម្រងតួនាទីខាងក្រោម)",
            "client": "អតិថិជន",
            "project": "គម្រោង",
            "select": "— ជ្រើស —",
            "any-project": "— គម្រោងណាមួយ —",
            "position": "តួនាទី *",
            "position-hint": "(ពីបញ្ជីតួនាទីទំនេរ)",
            "select-position": "— ជ្រើសតួនាទីទំនេរ{grade} —",
            "position-other": "— ផ្សេងទៀត (សរសេរសេរី គ្មានតួនាទីទំនេរ) —",
            "position-other-ph": "ចំណងជើងតួនាទីសរសេរសេរី (ឧ. សម្រាប់តួនាទីថ្មីដែលមិនទាន់មានក្នុងបញ្ជី)",
            "no-vacancies": "គ្មានតួនាទីទំនេរនៅ {grade} សម្រាប់កម្លាំងពលកម្មនេះ។ ប្ដូរកម្រិត ឬជ្រើស ផ្សេងទៀត (សរសេរសេរី)។",
            "selected": "បានជ្រើស",
            "contract-type": "ប្រភេទកិច្ចសន្យានៅពេលទទួលយក *",
            "start-date": "កាលបរិច្ឆេទចាប់ផ្ដើមដែលស្នើ *",
            "valid-until": "ការផ្ដល់មានសុពលភាពរហូតដល់ *",
            "end-date": "កាលបរិច្ឆេទបញ្ចប់ដែលស្នើ *",
            "fdc-max": "(អតិបរមា ២៤ ខែតាមច្បាប់ការងារ)",
            "prob-end": "(= ការបញ្ចប់សាកល្បង)",
            "fdc-warn": "FDC អតិបរមា ២៤ ខែតាមច្បាប់ការងារកម្ពុជា (បានបញ្ជាក់ {months} ខែ)",
            "include-probation": "រួមបញ្ចូលរយៈពេលសាកល្បង",
            "probation-end-date": "កាលបរិច្ឆេទបញ្ចប់សាកល្បង *",
            "probation": "ការសាកល្បង",
            "probation-ends": "បាទ/ចាស · បញ្ចប់ {date}",
            "no": "ទេ",
            "compensation": "កញ្ចប់សំណង",
            "override": "· ការកំណត់ឡើងវិញតាមការផ្ដល់",
            "template": "· គំរូ៖ {ref}",
            "gross-salary": "ប្រាក់ខែសរុប (ប្រចាំខែ) *",
            "gross-salary-short": "ប្រាក់ខែសរុប",
            "salary-ph": "ឧ. 1500",
            "salary-band-warn": "ក្រៅក្រុម {code} (${min}-${max})",
            "allowance-package": "កញ្ចប់ប្រាក់បំណាច់",
            "allowance-package-hint": "(ជ្រើសគំរូ ឬជ្រើស ផ្ទាល់ខ្លួន ដើម្បីកំណត់ដោយខ្លួនឯង)",
            "choose-template": "— ជ្រើសគំរូ ឬ ផ្ទាល់ខ្លួន —",
            "custom": "ផ្ទាល់ខ្លួន (កំណត់ដោយដៃ)",
            "no-allowance-template": "គ្មានគំរូត្រូវគ្នា — ជ្រើស ផ្ទាល់ខ្លួន ហើយបន្ថែមជួរខាងក្រោម។",
            "allowance": "ប្រាក់បំណាច់",
            "monthly": "ប្រចាំខែ",
            "no-allowances": "គ្មានប្រាក់បំណាច់",
            "add-one": "បន្ថែមមួយ",
            "total-allowances": "ប្រាក់បំណាច់សរុប + មូលដ្ឋាន",
            "add-allowance": "បន្ថែមជួរប្រាក់បំណាច់",
            "remove": "លុប",
            "benefits": "អត្ថប្រយោជន៍",
            "benefits-package": "កញ្ចប់អត្ថប្រយោជន៍",
            "benefits-package-hint": "(ជ្រើសគំរូ ឬជ្រើស ផ្ទាល់ខ្លួន)",
            "no-benefits-template": "គ្មានគំរូត្រូវគ្នា — ជ្រើស ផ្ទាល់ខ្លួន។",
            "pick-benefits": "ជ្រើសគំរូខាងលើ ឬប្ដូរទៅ",
            "no-benefits": "គ្មានអត្ថប្រយោជន៍ត្រូវបានកំណត់។",
            "note-optional": "ចំណាំ (ស្រេចចិត្ត)",
            "conditions-notes": "លក្ខខណ្ឌ និងចំណាំ",
            "conditions": "លក្ខខណ្ឌមុនពេលចូលធ្វើការ",
            "conditions-hint": "(មួយជួរក្នុងមួយបន្ទាត់ — អ្វីដែលបេក្ខជនត្រូវបំពេញមុនកាលបរិច្ឆេទចាប់ផ្ដើម)",
            "conditions-ll": "ច្បាប់ការងារកម្ពុជាតម្រូវ៖ វិញ្ញាបនបត្រសុខភាពពីវេជ្ជបណ្ឌិតក្រសួងការងារ។ លក្ខខណ្ឌផ្សេងទៀត (ការត្រួតពិនិត្យប្រវត្តិ ឯកសារយោង) ជាគោលនយោបាយក្រុមហ៊ុន។",
            "no-conditions": "គ្មានលក្ខខណ្ឌត្រូវបានបញ្ជាក់។",
            "internal-notes": "ចំណាំផ្ទៃក្នុង",
            "notes-hint": "(មិនបង្ហាញលើលិខិតផ្ដល់)",
            "notes-label": "ចំណាំ",
            "letter-preview": "មើលលិខិតជាមុន",
            "download-pdf": "ទាញយកជា PDF",
            "all-filled": "បានបំពេញគ្រប់វាលដែលត្រូវការ",
            "cancel": "បោះបង់",
            "cancel-edit": "បោះបង់ការកែសម្រួល",
            "save-draft": "រក្សាទុកសេចក្ដីព្រាង",
            "save-issue": "រក្សាទុក និងចេញ",
            "status": "ស្ថានភាព",
            "toast-draft": "ការផ្ដល់ {id} បានរក្សាទុកជាសេចក្ដីព្រាង",
            "toast-issued": "ការផ្ដល់ {id} បានចេញ"
          }
        },
        "contracts": {
          "banner": "កិច្ចសន្យាកាន់កាប់លក្ខខណ្ឌច្បាប់នៃការងារដែលបានព្រមព្រៀង។ ប្រភេទនីមួយៗមានវដ្តជីវិតផ្ទាល់៖ សាកល្បងប្ដូរទៅ FDC/UDC តាមរយៈកិច្ចសន្យាថ្មី · FDC ពន្យារ ឬប្ដូរទៅ UDC · ការផ្លាស់ប្ដូរ UDC ឆ្លងកាត់ការផ្លាស់ប្ដូរការងារ (កិច្ចសន្យានៅតែមាន) · កិច្ចសន្យាណាមួយអាចត្រូវបានបញ្ចប់។ ចុចជួរដើម្បីមើលប្រវត្តិខ្សែសង្វាក់ពេញលេញ។",
          "search-placeholder": "ស្វែងរកតាមកូដ បុគ្គលិក តួនាទី ឬប្រភេទ…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "footer-note": "បង្ហាញកិច្ចសន្យា {shown} ក្នុងចំណោម {total} · សកម្មភាពវដ្តជីវិត (ប្ដូរ · ពន្យារ · ចេញការផ្លាស់ប្ដូរការងារ · បញ្ចប់) មាននៅក្នុងផ្ទាំងលម្អិត នៅពេលស្ថានភាពកិច្ចសន្យាជាសកម្ម",
          "kpi": {
            "active": "កិច្ចសន្យាសកម្ម",
            "expiring-30": "ផុតក្នុង ≤30 ថ្ងៃ",
            "expiring-31-60": "ផុតក្នុង 31-60 ថ្ងៃ",
            "probation-ending-30": "សាកល្បងបញ្ចប់ ≤30 ថ្ងៃ",
            "unsigned": "មិនទាន់ចុះហត្ថលេខា"
          },
          "filters": {
            "status": "ស្ថានភាព",
            "type": "ប្រភេទកិច្ចសន្យា",
            "workforce": "កម្លាំងពលកម្ម",
            "client": "អតិថិជន",
            "search": "ស្វែងរក"
          },
          "status-opts": {
            "active": "សកម្មតែប៉ុណ្ណោះ",
            "all": "ស្ថានភាពទាំងអស់",
            "Active": "សកម្ម",
            "history": "ប្រវត្តិ (បានជំនួស/ផុតកំណត់/បានបញ្ចប់)",
            "pending": "រង់ចាំចុះហត្ថលេខា"
          },
          "type-opts": {
            "all": "ប្រភេទទាំងអស់"
          },
          "workforce": {
            "all": "ទាំងអស់",
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "client-opts": {
            "all": "អតិថិជនទាំងអស់"
          },
          "cols": {
            "code": "លេខកិច្ចសន្យា",
            "employee": "បុគ្គលិក",
            "type": "ប្រភេទ",
            "position": "តួនាទី",
            "scope": "វិសាលភាព",
            "start": "ចាប់ផ្ដើម",
            "end": "បញ្ចប់",
            "status": "ស្ថានភាព",
            "actions": "សកម្មភាព"
          },
          "scope": {
            "direct": "ផ្ទាល់",
            "outsourced": "ប្រៅ"
          },
          "exp-chip": {
            "le30": "≤30ថ្ងៃ",
            "le60": "≤60ថ្ងៃ",
            "expired": "ផុតកំណត់"
          },
          "empty": {
            "no-match": "មិនមានកិច្ចសន្យាត្រូវនឹងតម្រងបច្ចុប្បន្ន។",
            "title": "មិនមានកិច្ចសន្យាត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។"
          },
          "detail": {
            "close": "បិទ",
            "close-btn": "បិទ",
            "no-position": "គ្មានតួនាទី",
            "header": "ក្បាល",
            "employee": "បុគ្គលិក",
            "position": "តួនាទី",
            "type": "ប្រភេទ",
            "status": "ស្ថានភាព",
            "scope": "វិសាលភាព",
            "reports-to": "រាយការណ៍ទៅ",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "end": "កាលបរិច្ឆេទបញ្ចប់",
            "indefinite": "មិនកំណត់",
            "probation-end": "បញ្ចប់សាកល្បង",
            "notice-period": "រយៈពេលជូនដំណឹង",
            "work-location": "ទីតាំងធ្វើការ",
            "working-hours": "ម៉ោងធ្វើការ",
            "remuneration": "ប្រាក់កម្រៃ",
            "remuneration-note": "(តម្លៃដំបូងពីកិច្ចសន្យា · តម្លៃបច្ចុប្បន្ននៅក្នុងសំណង)",
            "gross-salary": "ប្រាក់ខែសរុប",
            "pay-frequency": "ភាពញឹកញាប់នៃការបើកប្រាក់",
            "pay-method": "វិធីបើកប្រាក់",
            "extensions": "ការពន្យារ ({count})",
            "ext-addendum": "ឧបសម្ព័ន្ធ",
            "ext-old-end": "បញ្ចប់ចាស់",
            "ext-new-end": "បញ្ចប់ថ្មី",
            "ext-signed": "ចុះហត្ថលេខា",
            "ext-reason": "មូលហេតុ",
            "amendments": "ការកែប្រែ / ការផ្លាស់ប្ដូរការងារ ({count})",
            "amd-eff": "មានប្រសិទ្ធភាព {date}",
            "amd-reason": "មូលហេតុ៖ {reason}",
            "amd-by": "ដោយ {by}",
            "chain": "ខ្សែសង្វាក់កិច្ចសន្យា ({count})",
            "chain-viewing": "← កំពុងមើល",
            "chain-open": "បើក",
            "signed-copy": "ច្បាប់ចម្លងដែលបានចុះហត្ថលេខា",
            "signed-by": "ចុះហត្ថលេខាដោយ៖",
            "document": "ឯកសារ៖",
            "not-attached": "មិនបានភ្ជាប់",
            "not-signed": "កិច្ចសន្យាមិនទាន់ចុះហត្ថលេខា។",
            "footer-id": "កិច្ចសន្យា",
            "action-convert": "ប្ដូរទៅ UDC…",
            "action-extend": "ពន្យារ…",
            "action-amend": "ចេញការផ្លាស់ប្ដូរការងារ…",
            "action-terminate": "បញ្ចប់…",
            "action-stub": "{action} — នឹងមកដល់ឆាប់ៗ។ កិច្ចសន្យាត្រូវបានបង្កើតពីការផ្ដល់ជូនដែលបានទទួលយកក្នុងកំណែនេះ។"
          },
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "probation": "សាកល្បង",
            "expiring": "ផុតក្នុង ≤30ថ្ងៃ",
            "unsigned": "មិនចុះហត្ថលេខា",
            "expired": "ផុតកំណត់"
          },
          "drawer": {
            "position": "តួនាទី",
            "employee-code": "កូដបុគ្គលិក",
            "start": "ចាប់ផ្ដើម",
            "end": "បញ្ចប់",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "actions-tab": {
          "title": "សកម្មភាពការងារ",
          "subtitle": "កន្លែងធ្វើការប្រតិបត្តិការឆ្លងបុគ្គលិក · ការកត់ត្រាដំណាក់កាលទី ១ · ស្ថានភាពកំណត់តាមកាលបរិច្ឆេទមានសុពលភាព · គ្មានជួរអនុម័ត",
          "new-action": "សកម្មភាពការងារថ្មី",
          "search-placeholder": "ស្វែងរកតាមកូដ បុគ្គលិក ប្រភេទ ឬព័ត៌មានលម្អិត…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "banner-title": "ដំណាក់កាលទី ១ · កត់ត្រាតែប៉ុណ្ណោះ។",
          "banner-lede": "ផ្នែកធនធានមនុស្សកត់ត្រា EA ដែលបានអនុម័តក្រៅប្រព័ន្ធ (កំណត់ត្រា / លិខិត / ការចុះហត្ថលេខារបស់អ្នកគ្រប់គ្រង)។ ស្ថានភាព៖ បានកំណត់ (កាលបរិច្ឆេទនាពេលអនាគត) → មានសុពលភាព (ថ្ងៃនេះ / អតីតកាល)។ លំហូរការអនុម័តនឹងមកនៅដំណាក់កាលទី ២។",
          "phase2": "ដំណាក់កាលទី ២",
          "kpi": {
            "all-eas": "EA ទាំងអស់",
            "scheduled": "បានកំណត់",
            "effective-this-week": "មានសុពលភាពសប្ដាហ៍នេះ",
            "by-detected-label": "តាមស្លាកដែលរកឃើញ",
            "cancelled": "បានបោះបង់",
            "cancelled-delta": "បានបោះបង់ {n}",
            "future-dated": "កាលបរិច្ឆេទអនាគត",
            "last-7-days": "ក្នុងរយៈពេល ៧ ថ្ងៃចុងក្រោយ",
            "retained": "រក្សាទុកសម្រាប់សវនកម្ម"
          },
          "filters": {
            "all-types": "ប្រភេទសកម្មភាពទាំងអស់",
            "all-labels": "ស្លាករកឃើញទាំងអស់",
            "all-statuses": "ស្ថានភាពទាំងអស់"
          },
          "status": {
            "scheduled": "បានកំណត់",
            "effective": "មានសុពលភាព",
            "cancelled": "បានបោះបង់"
          },
          "cols": {
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "employee": "បុគ្គលិក",
            "type": "ប្រភេទសកម្មភាព",
            "detail": "ព័ត៌មានលម្អិត",
            "detected-label": "ស្លាករកឃើញ",
            "status": "ស្ថានភាព",
            "comp": "សំណង",
            "actions": "សកម្មភាព",
            "code": "កូដ"
          },
          "empty": {
            "title": "មិនមានសកម្មភាពការងារត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។",
            "lede-none": "ចុច សកម្មភាពការងារថ្មី ដើម្បីកត់ត្រាលើកដំបូង។"
          },
          "modal": {
            "aria": "សកម្មភាពការងារ",
            "title": "សកម្មភាពការងារថ្មី",
            "step1": "ជំហានទី ១ ក្នុង ៣ · ជ្រើសរើសប្រភេទព្រឹត្តិការណ៍ការងារ",
            "step2": "ជំហានទី ២ ក្នុង ៣ · ជ្រើសរើសបុគ្គលិកដែលប្រភេទនេះអនុវត្ត",
            "step3": "ជំហានទី ៣ ក្នុង ៣ · បំពេញទម្រង់ · ការកត់ត្រាដំណាក់កាលទី ១",
            "what-change": "ការផ្លាស់ប្ដូរប្រភេទណា?",
            "what-change-lede": "ជ្រើសរើសប្រភេទអាជីវកម្មជាមុនសិន។ ប្រភេទនីមួយៗមានទម្រង់ផ្ទាល់ខ្លួន។ បន្ទាប់មកអ្នកនឹងជ្រើសរើសបុគ្គលិក រួចបំពេញទម្រង់។",
            "classification": "ប្រភេទ",
            "change-classification": "ប្ដូរប្រភេទ",
            "pick-employee": "ជ្រើសរើសបុគ្គលិក",
            "employee": "បុគ្គលិក",
            "employee-search": "ស្វែងរកតាមលេខសម្គាល់ · ឈ្មោះ · មុខតំណែង · នាយកដ្ឋាន…",
            "employee-hint": "មិនរាប់បញ្ចូលបុគ្គលិកអសកម្ម។ ចុចជួរមួយដើម្បីបន្តទៅទម្រង់ {label}។",
            "employee-empty": "មិនមានបុគ្គលិកសកម្មត្រូវនឹងការស្វែងរករបស់អ្នក។",
            "upcoming": "{label} — មុខងារនាពេលខាងមុខ · គ្រោងសម្រាប់ដំណាក់កាលក្រោយ",
            "upcoming-tag": "⏸ មុខងារនាពេលខាងមុខ",
            "detail-title": "ព័ត៌មានលម្អិត",
            "recorded": "បានកត់ត្រា {date}",
            "toast-saved": "បានកត់ត្រា {label} · ស្ថានភាព៖ {status}"
          },
          "form": {
            "effective-date": "កាលបរិច្ឆេទមានសុពលភាព",
            "effective-hint": "ចន្លោះកាលបរិច្ឆេទថយក្រោយ៖ {days} ថ្ងៃ · ថ្ងៃនេះ (សាកល្បង)៖ {today}",
            "reason": "មូលហេតុ",
            "reason-placeholder": "ហេតុអ្វីការផ្លាស់ប្ដូរនេះត្រូវបានកត់ត្រា?",
            "document": "ឯកសារយោង",
            "document-placeholder": "ឈ្មោះឯកសារ ឬឯកសារយោង (ឧ. PromotionLetter-2026-014.pdf)",
            "dropzone": "អូស និងទម្លាក់ ឬរុករកដើម្បីភ្ជាប់កំណត់ត្រា / លិខិតក្រៅប្រព័ន្ធ",
            "offline-label": "ការអនុម័តក្រៅប្រព័ន្ធបានបញ្ចប់",
            "offline-desc": "អ្នកគ្រប់គ្រង / ផ្នែកធនធានមនុស្ស / បុគ្គលិកបានព្រមព្រៀង និងចុះហត្ថលេខាក្រៅប្រព័ន្ធ (កំណត់ត្រា លិខិត ឬផ្ទាល់មាត់)។ គូសធីកនៅពេលឯកសារត្រូវបានរៀបចំ។",
            "offline-notes": "កំណត់សម្គាល់ — ឧ. បានអនុម័តដោយអ្នកគ្រប់គ្រង Sopheap កំណត់ត្រាចុះហត្ថលេខា ២០២៦-០៦-២៨",
            "companion-label": "ភ្ជាប់៖ កត់ត្រាការកែតម្រូវប្រាក់ខែផងដែរ",
            "companion-desc": "ការផ្ដល់មុខតំណែងតែងតែភ្ជាប់នឹងការផ្លាស់ប្ដូរប្រាក់ខែ។ កត់ត្រាធាតុពីរផ្សេងគ្នា (សកម្មភាពការងារមួយ + ព្រឹត្តិការណ៍សំណងមួយ) ដែលចែករំលែកកាលបរិច្ឆេទមានសុពលភាព និងមូលហេតុនេះ។",
            "base-salary": "ប្រាក់ខែមូលដ្ឋាន",
            "new-base-salary": "ប្រាក់ខែមូលដ្ឋានថ្មី",
            "routing-template": "គំរូផ្លូវ (រក្សាទុក មិនប្រតិបត្តិ)",
            "position-placeholder": "ជ្រើសរើសមុខតំណែងគោលដៅ…",
            "position-search": "ស្វែងរកមុខងារ · នាយកដ្ឋាន · ទីតាំង · ថ្នាក់…",
            "position-empty": "មិនមានមុខតំណែងដែលអាចចាត់តាំងបាន · កៅអីដែលត្រូវគ្នាសុទ្ធតែកំពុងកាន់កាប់។",
            "vacant": "ទំនេរ",
            "manager-placeholder": "ជ្រើសរើសអ្នកគ្រប់គ្រង…",
            "pick": "ជ្រើសរើស…",
            "value": "តម្លៃ",
            "detected-action": "សកម្មភាពរកឃើញ (ទាញចេញពីភាពខុសគ្នា)",
            "delta-attribute": "គុណលក្ខណៈ",
            "delta-current": "បច្ចុប្បន្ន",
            "delta-target": "គោលដៅ",
            "no-change": " (គ្មានការផ្លាស់ប្ដូរ)",
            "ready": "រួចរាល់ដើម្បីរក្សាទុក · ស្ថានភាពនឹងជា {status}",
            "missing": "{n} វាលដែលត្រូវការ បាត់ ឬមិនត្រឹមត្រូវ",
            "cancel": "បោះបង់",
            "save": "រក្សាទុកកំណត់ត្រា"
          },
          "detail": {
            "record-id": "លេខកំណត់ត្រា",
            "employee": "បុគ្គលិក",
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "status": "ស្ថានភាព",
            "detected": "សកម្មភាពរកឃើញ",
            "document": "ឯកសារយោង",
            "offline": "ការអនុម័តក្រៅប្រព័ន្ធ",
            "offline-yes": "បានបញ្ចប់",
            "offline-no": "មិនបានសម្គាល់ថាបញ្ចប់",
            "change-summary": "សេចក្ដីសង្ខេបការផ្លាស់ប្ដូរ",
            "position-delta": "ភាពខុសគ្នាមុខតំណែង (នៅពេលកត់ត្រា)",
            "routing": "ឯកសារយោងផ្លូវការអនុម័ត",
            "routing-template": "គំរូផ្លូវ (រក្សាទុក មិនប្រតិបត្តិ)",
            "cancel-record": "បោះបង់កំណត់ត្រា",
            "close": "បិទ"
          },
          "chips": {
            "all": "ទាំងអស់",
            "pending": "កំពុងរង់ចាំ",
            "approved": "បានអនុម័ត",
            "effective": "មានសុពលភាព"
          },
          "drawer": {
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "approver": "អ្នកអនុម័ត",
            "detail": "ព័ត៌មានលម្អិត"
          }
        },
        "benefits": {
          "title": "អត្ថប្រយោជន៍",
          "subtitle": "កន្លែងធ្វើការចុះឈ្មោះឆ្លងបុគ្គលិក · បុគ្គលិក {employees} នាក់ · ធាតុកាតាឡុក {entries} · ការគណនាចំណាយប្រចាំខែ",
          "new-benefit": "អត្ថប្រយោជន៍ថ្មី",
          "bulk-enroll": "ចុះឈ្មោះច្រើន",
          "edit-catalog": "កែកាតាឡុក",
          "search-placeholder": "ស្វែងរកតាមអត្ថប្រយោជន៍ អ្នកផ្ដល់ ប្រភេទ…",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "footer-note": "អត្ថប្រយោជន៍ថ្មី បន្ថែមធាតុកាតាឡុកទូទាំងក្រុមហ៊ុន · ចុះឈ្មោះច្រើន ចុះឈ្មោះបុគ្គលិកមានសិទ្ធិច្រើននាក់ក្នុងពេលតែមួយ · ចុចលើខ្មៅដៃនៅជួរណាមួយដើម្បីកែ។ សម្រាប់ការចុះឈ្មោះម្នាក់ៗ សូមទៅ ប្រវត្តិរូប → អត្ថប្រយោជន៍ របស់បុគ្គលិក។",
          "kpi": {
            "active-enrollments": "ការចុះឈ្មោះសកម្ម",
            "employees-enrolled": "បុគ្គលិកបានចុះឈ្មោះ",
            "monthly-cost-employer": "ការចំណាយប្រចាំខែ (និយោជក)",
            "renewing-90": "ត្រូវបន្ត ≤90 ថ្ងៃ",
            "across-all": "គ្រប់អត្ថប្រយោជន៍",
            "coverage": "ការគ្របដណ្ដប់ {pct}%",
            "annualized": "USD {amount} ប្រចាំឆ្នាំ",
            "action-needed": "ត្រូវការសកម្មភាព",
            "all-clear": "គ្មានបញ្ហា"
          },
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "renewing": "កំពុងបន្ត",
            "ended": "បានបញ្ចប់"
          },
          "cols": {
            "benefit": "អត្ថប្រយោជន៍",
            "enrolled": "បានចុះឈ្មោះ",
            "eligible": "មានសិទ្ធិ",
            "takeup": "ការទទួលយក",
            "monthly-cost": "ចំណាយប្រចាំខែ",
            "renewal": "ការបន្ត",
            "actions": "សកម្មភាព"
          },
          "kinds": {
            "Insurance": "ធានារ៉ាប់រង",
            "Statutory": "តាមច្បាប់",
            "Wellness": "សុខភាព",
            "Allowance In-kind": "ប្រាក់ឧបត្ថម្ភជាសម្ភារ",
            "Other": "ផ្សេងៗ"
          },
          "statuses": {
            "Active": "សកម្ម",
            "Renewing": "កំពុងបន្ត",
            "Ended": "បានបញ្ចប់"
          },
          "workforce": {
            "Direct": "ផ្ទាល់",
            "Outsourced": "ខាងក្រៅ"
          },
          "eligibility-types": {
            "all": "បុគ្គលិកទាំងអស់",
            "grade": "តាមកម្រិត (អប្បបរមា)",
            "workforce_type": "ប្រភេទកម្លាំងពលកម្ម (ផ្ទាល់ / ខាងក្រៅ)",
            "tenure": "រយៈពេលធ្វើការ (ខែអប្បបរមា)",
            "department": "នាយកដ្ឋានជាក់លាក់"
          },
          "catalog": {
            "new-title": "អត្ថប្រយោជន៍ថ្មី",
            "edit-title": "កែអត្ថប្រយោជន៍",
            "subtitle": "ធាតុកាតាឡុកមេ",
            "kind": "ប្រភេទ",
            "status": "ស្ថានភាព",
            "name": "ឈ្មោះអត្ថប្រយោជន៍",
            "name-ph": "ឧ. Infinity Group Health · Plan A",
            "provider": "អ្នកផ្ដល់",
            "provider-ph": "ឧ. Infinity General Insurance",
            "scheme": "គម្រោង / កម្រិតគ្របដណ្ដប់",
            "scheme-ph": "ឧ. គ្រោះថ្នាក់ + សុខភាព",
            "coverage": "ធាតុគ្របដណ្ដប់ (បំបែកដោយក្បៀស)",
            "coverage-ph": "ឧ. សុខភាព, ការសម្រាកព្យាបាល, OPD",
            "eligibility": "សិទ្ធិ",
            "min-grade": "លេខកម្រិតអប្បបរមា",
            "workforce-type": "ប្រភេទកម្លាំងពលកម្ម",
            "min-months": "ខែអប្បបរមា",
            "department": "នាយកដ្ឋាន",
            "department-ph": "ឧ. លក់",
            "label": "ស្លាក",
            "cost-employee": "ចំណាយ / បុគ្គលិក / ខែ (USD)",
            "cost-family": "ចំណាយ / គ្រួសារ / ខែ (USD)",
            "renewal": "ការបន្តបន្ទាប់",
            "policy-pattern": "លំនាំលេខគោលការណ៍",
            "policy-pattern-opt": "(ស្រេចចិត្ត · ប្រើ {code} ជាកន្លែងដាក់)",
            "policy-pattern-ph": "ឧ. P/01/GPA/24/{code}",
            "create": "បង្កើតអត្ថប្រយោជន៍",
            "save-changes": "រក្សាទុកការផ្លាស់ប្ដូរ",
            "toast-created": "បានបង្កើត {name}",
            "toast-updated": "បានធ្វើបច្ចុប្បន្នភាព {name}"
          },
          "bulk": {
            "title": "ចុះឈ្មោះច្រើនក្នុងអត្ថប្រយោជន៍",
            "step1": "ជំហានទី 1 · ជ្រើសអត្ថប្រយោជន៍ដើម្បីចុះឈ្មោះច្រើន",
            "step1-eyebrow": "ជំហានទី 1 · ជ្រើសអត្ថប្រយោជន៍",
            "step2": "ជំហានទី 2 · ជ្រើសបុគ្គលិកដើម្បីចុះឈ្មោះ",
            "selected-benefit": "អត្ថប្រយោជន៍ដែលបានជ្រើស",
            "selected-count": "បានជ្រើស {count}",
            "currently-enrolled": "បានចុះឈ្មោះ {count} នាក់",
            "eligible-not-enrolled": "{count} មានសិទ្ធិ · មិនទាន់ចុះឈ្មោះ",
            "pick-different": "← ជ្រើសអត្ថប្រយោជន៍ផ្សេង",
            "select-all": "ជ្រើសទាំងអស់",
            "clear": "សម្អាត",
            "all-enrolled": "បុគ្គលិកមានសិទ្ធិទាំងអស់បានចុះឈ្មោះរួចហើយ។",
            "submit": "ចុះឈ្មោះ {count} នាក់",
            "toast": "បានចុះឈ្មោះបុគ្គលិក {count} នាក់ក្នុង {name}"
          },
          "drawer": {
            "provider": "អ្នកផ្ដល់",
            "eligibility": "សិទ្ធិ",
            "cost-per-employee": "តម្លៃក្នុងម្នាក់",
            "renewal": "ការបន្ត",
            "description": "ការពិពណ៌នា"
          },
          "empty": {
            "title": "មិនមានអត្ថប្រយោជន៍ត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សូមព្យាយាមសម្អាតតម្រង ឬប្ដូរពាក្យស្វែងរក។"
          }
        },
        "compensation": {
          "title": "មជ្ឈមណ្ឌលប្រាក់បំណាច់",
          "subtitle": "សមាសភាគ · កញ្ចប់ · ការផ្តល់ · ព្រឹត្តិការណ៍ · របាយការណ៍ — ទូទាំងកម្លាំងពលកម្ម · ដំណាក់កាលទី១ កត់ត្រាប៉ុណ្ណោះ",
          "tabs": {
            "overview": "ទិដ្ឋភាពទូទៅ",
            "components": "សមាសភាគ",
            "packages": "កញ្ចប់",
            "assignments": "ការផ្តល់",
            "events": "ព្រឹត្តិការណ៍",
            "reports": "របាយការណ៍"
          },
          "phase-banner": {
            "title": "ដំណាក់កាលទី១ · កត់ត្រាប៉ុណ្ណោះ។",
            "body": "ព្រឹត្តិការណ៍ប្រាក់បំណាច់ត្រូវបានរក្សាទុកដោយផ្ទាល់ទៅកាន់កាលប្បវត្តិប្រាក់បំណាច់ និងប្រវត្តិកែតម្រូវប្រាក់ខែតាមកិច្ចសន្យា។ ការអនុម័តធ្វើឡើងក្រៅប្រព័ន្ធ។ ម៉ាស៊ីនលំហូរការងារនឹងមកដល់ក្នុងដំណាក់កាលទី២។"
          },
          "kpi": {
            "active-employees": "បុគ្គលិកសកម្ម",
            "total-monthly-comp": "ប្រាក់បំណាច់សរុបប្រចាំខែ",
            "components": "សមាសភាគ",
            "packages": "កញ្ចប់",
            "salary-adj-ytd": "ការកែប្រាក់ខែ {year}",
            "bonuses-ytd": "ប្រាក់រង្វាន់ {year}",
            "in-scope": "ក្នុងវិសាលភាព",
            "recurring-wide": "កញ្ចប់ដែលកើតឡើងដដែល · ទូទាំងកម្លាំងពលកម្ម",
            "active-catalog": "សកម្មក្នុងបញ្ជី",
            "pkg-breakdown": "ប្រាក់ឧបត្ថម្ភ {allowance} · អត្ថប្រយោជន៍ {benefits}",
            "recorded": "បានកត់ត្រា",
            "total": "សរុប"
          },
          "actions": {
            "manage-components": "គ្រប់គ្រងសមាសភាគ",
            "manage-components-desc": "បន្ថែម ឬកែបញ្ជីសមាសភាគប្រាក់បំណាច់",
            "build-packages": "បង្កើតកញ្ចប់",
            "build-packages-desc": "ផ្គុំសមាសភាគតាមវិសាលភាព",
            "bulk-assign": "ផ្តល់ជាក្រុម",
            "bulk-assign-desc": "តាមនាយកដ្ឋាន + កម្រិត",
            "record-event": "កត់ត្រាព្រឹត្តិការណ៍",
            "record-event-desc": "ប្រាក់ខែ · ប្រាក់រង្វាន់ · ការប្តូរប្រាក់ឧបត្ថម្ភ"
          },
          "top-depts": {
            "title": "នាយកដ្ឋានកំពូលតាមប្រាក់បំណាច់ប្រចាំខែ",
            "view-report": "មើលរបាយការណ៍ពេញ →",
            "empty": "គ្មានទិន្នន័យ។"
          },
          "recent-events": {
            "title": "ព្រឹត្តិការណ៍ថ្មីៗ",
            "view-ledger": "បើកសៀវភៅកត់ត្រាពេញ →",
            "empty": "មិនទាន់មានព្រឹត្តិការណ៍ប្រាក់បំណាច់ត្រូវបានកត់ត្រាទេ។"
          },
          "stub": {
            "lede": "ផ្ទាំងនេះនឹងមកដល់ជាមួយប្រព័ន្ធសំណងដំណាក់កាល B (សមាសភាគ កញ្ចប់ ការផ្ដល់ឲ្យ ព្រឹត្តិការណ៍ និងរបាយការណ៍)។ ឥឡូវសូមប្រើទិដ្ឋភាពទូទៅសម្រាប់រូបភាពទូទាំងបុគ្គលិក។",
            "back": "ត្រឡប់ទៅទិដ្ឋភាពទូទៅ"
          },
          "phase2": "ដំណាក់កាលទី២",
          "filters": {
            "category": "ប្រភេទ",
            "status": "ស្ថានភាព",
            "dept": "នាយកដ្ឋាន",
            "grade": "កម្រិតការងារ",
            "contract": "កិច្ចសន្យា",
            "all": "ទាំងអស់",
            "all-depts": "នាយកដ្ឋានទាំងអស់",
            "all-grades": "កម្រិតទាំងអស់",
            "all-contracts": "កិច្ចសន្យាទាំងអស់"
          },
          "components": {
            "title": "បញ្ជីសមាសភាគប្រាក់បំណាច់",
            "subtitle": "បញ្ជីមេនៃសមាសភាគដែលប្រើនៅទូទាំងកញ្ចប់ និងការផ្តល់តាមបុគ្គលិក។ ការកែនឹងផ្សព្វផ្សាយទៅបុគ្គលិកទាំងអស់ពេលរក្សាទុកបន្ទាប់។",
            "new": "សមាសភាគថ្មី",
            "search-placeholder": "ស្វែងរកតាមកូដ ឬឈ្មោះ…",
            "empty": "គ្មានសមាសភាគត្រូវគ្នា។",
            "status-active": "សកម្ម",
            "status-inactive": "អសកម្ម",
            "cat": {
              "all": "ប្រភេទទាំងអស់",
              "base": "ប្រាក់គោល",
              "allowance": "ប្រាក់ឧបត្ថម្ភ",
              "var": "ប្រាក់អថេរ"
            },
            "status": {
              "active": "សកម្មប៉ុណ្ណោះ",
              "all": "ទាំងអស់",
              "inactive": "អសកម្មប៉ុណ្ណោះ"
            },
            "cols": {
              "code": "កូដ",
              "name": "ឈ្មោះ",
              "category": "ប្រភេទ",
              "recurring": "កើតឡើងដដែល",
              "tax": "ការគិតពន្ធ",
              "nssf": "មូលដ្ឋាន NSSF",
              "funded": "ឧបត្ថម្ភ",
              "status": "ស្ថានភាព"
            },
            "legend": {
              "none": "មិនរាប់បញ្ចូលក្នុងពន្ធ",
              "tos": "កម្រិតរីកចម្រើនតាមក្រុមប្រាក់ខែ (ច្បាប់ការងារកម្ពុជា)",
              "fringe": "ពន្ធអត្ថប្រយោជន៍បន្ថែម ២០% ថេរ"
            }
          },
          "packages": {
            "title": "កញ្ចប់ប្រាក់ឧបត្ថម្ភ និងអត្ថប្រយោជន៍",
            "subtitle": "ផ្គុំសមាសភាគជាកញ្ចប់ដែលប្រើឡើងវិញ តាមប្រភេទកម្លាំងពលកម្ម · អតិថិជន · គម្រោង · កម្រិតការងារ។ ការផ្សព្វផ្សាយ៖ គម្រោង → អតិថិជន → ទូទៅ។ ប្រើដោយលិខិតផ្តល់ការងារ និងការបំពេញមុនពេលបន្ថែមបុគ្គល។",
            "allowance-title": "កញ្ចប់ប្រាក់ឧបត្ថម្ភ",
            "benefits-title": "កញ្ចប់អត្ថប្រយោជន៍",
            "cols": {
              "name": "កញ្ចប់",
              "scope": "វិសាលភាព",
              "components": "សមាសភាគ",
              "monthly": "ប្រចាំខែ",
              "enabled": "បានបើក",
              "items": "ធាតុ",
              "contract": "កិច្ចសន្យា"
            },
            "kpi": {
              "active": "សកម្មក្នុងផ្នែក",
              "direct": "គំរូផ្ទាល់",
              "outsourced": "គំរូក្រៅ",
              "shown": "បង្ហាញក្រោយតម្រង"
            },
            "filters": {
              "workforce": "កម្លាំងពលកម្ម",
              "client": "អតិថិជន",
              "project": "គម្រោង",
              "all-clients": "អតិថិជនទាំងអស់",
              "all-projects": "គម្រោងទាំងអស់"
            },
            "workforce-direct": "ផ្ទាល់តែប៉ុណ្ណោះ",
            "workforce-outsourced": "ក្រៅតែប៉ុណ្ណោះ",
            "show-inactive": "បង្ហាញអសកម្ម",
            "empty": "គ្មានកញ្ចប់ត្រូវនឹងតម្រងបច្ចុប្បន្នទេ។",
            "footnote": "គំរូគ្រាន់តែជាមូលដ្ឋានក្នុងការចេញផ្សាយនេះ — នឹងត្រូវប្រើដោយលំហូរលិខិតស្នើ និងការបំពេញមុនពេលបន្ថែមបុគ្គលនៅក្នុងជំហានបន្ទាប់។ ការបដិសេធតាមការផ្តល់ជូននៅតែមាន។",
            "on": "បើក",
            "off": "បិទ",
            "detail": {
              "scope": "វិសាលភាព",
              "notes": "កំណត់ចំណាំ",
              "line-items": "ធាតុលម្អិត",
              "allowance": "ប្រាក់ឧបត្ថម្ភ",
              "amount": "ចំនួនប្រចាំខែ",
              "total": "សរុបក្នុងមួយខែ"
            }
          },
          "assignments": {
            "title": "ការផ្តល់ប្រាក់បំណាច់បុគ្គលិក",
            "subtitle": "នរណានៅលើកញ្ចប់ណា · សមាសភាគគោល + ប្រាក់ឧបត្ថម្ភក្នុងមួយបុគ្គលិក។ ប្រើ ផ្តល់ជាក្រុម សម្រាប់ការប្តូរជាក្រុម។",
            "bulk": "ផ្តល់ជាក្រុមតាមក្រុម",
            "search-placeholder": "ស្វែងរកឈ្មោះ កូដ ឋានៈ…",
            "showing": "បង្ហាញ {shown} នៃ {total} បុគ្គលិក",
            "empty": "គ្មានបុគ្គលិកត្រូវគ្នា។",
            "cols": {
              "employee": "បុគ្គលិក",
              "title": "ឋានៈ",
              "base": "គោល / ខែ",
              "allowances": "សមាសភាគប្រាក់ឧបត្ថម្ភ",
              "allowance-total": "ប្រាក់ឧបត្ថម្ភ / ខែ",
              "total": "សរុប / ខែ"
            },
            "open-profile": "បើកប្រវត្តិរូប {name}"
          },
          "events": {
            "title": "សៀវភៅកត់ត្រាព្រឹត្តិការណ៍ប្រាក់បំណាច់",
            "subtitle": "ការកែតម្រូវប្រាក់ខែ ប្រាក់រង្វាន់ ការប្តូរប្រាក់អថេរ និងព្រឹត្តិការណ៍ប្រាក់ឧបត្ថម្ភទាំងអស់ដែលបានកត់ត្រាទូទាំងកម្លាំងពលកម្ម។",
            "export": "នាំចេញ CSV",
            "export-soon": "ការនាំចេញឆ្លងបុគ្គលិក — នឹងមកដល់ឆាប់ៗ",
            "record": "កត់ត្រាព្រឹត្តិការណ៍",
            "search-placeholder": "ស្វែងរកបុគ្គលិក ប្រភេទព្រឹត្តិការណ៍ ឬមូលហេតុ…",
            "event-type": "ប្រភេទព្រឹត្តិការណ៍",
            "date-range": "ចន្លោះកាលបរិច្ឆេទ",
            "types": {
              "all": "ប្រភេទព្រឹត្តិការណ៍ទាំងអស់",
              "salary": "ការកែតម្រូវប្រាក់ខែ",
              "bonus": "ប្រាក់រង្វាន់ផ្តល់",
              "varpay": "សិទ្ធិទទួលប្រាក់អថេរ",
              "allowance": "ប្រាក់ឧបត្ថម្ភ (បន្ថែម / ប្តូរ / បញ្ចប់)"
            },
            "ranges": {
              "30": "៣០ ថ្ងៃចុងក្រោយ",
              "90": "៩០ ថ្ងៃចុងក្រោយ",
              "180": "៦ ខែចុងក្រោយ",
              "365": "១២ ខែចុងក្រោយ",
              "all": "គ្រប់ពេលវេលា"
            },
            "ledger-title": "សៀវភៅកត់ត្រាព្រឹត្តិការណ៍ប្រាក់បំណាច់",
            "ledger-count": "{groups} ធាតុ · {filtered} នៃ {total} ព្រឹត្តិការណ៍ (សកម្មភាពជាក្រុមបានដាក់ជាក្រុម)",
            "empty": "គ្មានព្រឹត្តិការណ៍ប្រាក់បំណាច់ត្រូវនឹងតម្រងបច្ចុប្បន្ន។",
            "cols": {
              "effective": "មានសុពលភាព",
              "employee": "បុគ្គលិក",
              "event": "ព្រឹត្តិការណ៍",
              "detail": "ព័ត៌មានលម្អិត",
              "reason": "មូលហេតុ",
              "status": "ស្ថានភាព"
            },
            "effective": "មានសុពលភាព",
            "scheduled": "បានកំណត់ពេល",
            "employees": "បុគ្គលិក",
            "bulk": "ជាក្រុម",
            "same-to": "ចំនួនដូចគ្នាទៅ {count} បុគ្គលិក",
            "show": "បង្ហាញ {count}",
            "hide": "លាក់ {count}",
            "open-profile": "បើកប្រវត្តិរូបបុគ្គលិក"
          },
          "cost-alloc": {
            "title": "ទិដ្ឋភាពទូទៅនៃការបែងចែកចំណាយ",
            "manage": "គ្រប់គ្រង (ដំណាក់កាលទី២)",
            "body": "ការកែការបែងចែកគម្រោងឆ្លងបុគ្គលិកនឹងមកដល់ក្នុងដំណាក់កាលទី២។ ទិដ្ឋភាពអានតែប៉ុណ្ណោះក្នុងមួយបុគ្គលិកមាននៅផ្ទាំងព័ត៌មាន → ប្រាក់បំណាច់។"
          },
          "reports": {
            "title": "របាយការណ៍ប្រាក់បំណាច់",
            "subtitle": "ការវិភាគស្រាលៗទូទាំងកម្លាំងពលកម្ម។",
            "by-component": "តាមសមាសភាគ",
            "by-dept": "តាមនាយកដ្ឋាន",
            "by-grade": "តាមកម្រិតការងារ",
            "top-earners": "អ្នករកចំណូលខ្ពស់",
            "dept-total": "សរុប · {count} នាយកដ្ឋាន",
            "footnote": "របាយការណ៍ដំណាក់កាលទី១ ប្រើកញ្ចប់មានសុពលភាពបច្ចុប្បន្ន។ ក្រាហ្វ ការប្រៀបធៀបតាមកំឡុងពេល និងការនាំចេញ CSV នឹងមកដល់ក្នុងដំណាក់កាលទី២។",
            "cols": {
              "component": "សមាសភាគ",
              "assignments": "ការផ្តល់",
              "monthly-total": "សរុបប្រចាំខែ",
              "distribution": "ការបែងចែក",
              "department": "នាយកដ្ឋាន",
              "headcount": "ចំនួនបុគ្គលិក",
              "base-total": "គោលសរុប",
              "allowances-total": "ប្រាក់ឧបត្ថម្ភសរុប",
              "grade": "កម្រិតការងារ",
              "avg-monthly": "មធ្យមប្រចាំខែ",
              "employee": "បុគ្គលិក",
              "title-dept": "ឋានៈ · នាយកដ្ឋាន",
              "base": "គោល",
              "allowances": "ប្រាក់ឧបត្ថម្ភ",
              "total-monthly": "សរុបប្រចាំខែ"
            }
          },
          "picker": {
            "title": "កត់ត្រាព្រឹត្តិការណ៍ប្រាក់បំណាច់",
            "sub": "ជ្រើសរើសបុគ្គលិកជាមុនសិន · បន្ទាប់មកជ្រើសប្រភេទព្រឹត្តិការណ៍",
            "search": "ស្វែងរក",
            "search-placeholder": "ឈ្មោះ កូដ ឬឋានៈ…",
            "helper": "បង្ហាញ ៣០ លទ្ធផលដំបូង។ កែតម្រូវការស្វែងរកដើម្បីបង្រួម។",
            "empty": "គ្មានបុគ្គលិកត្រូវគ្នា។",
            "toast": "កំពុងបើកប្រាក់បំណាច់សម្រាប់ {name} — ដំណាក់កាលទី២ កត់ត្រាព្រឹត្តិការណ៍។"
          },
          "bulk": {
            "title": "ផ្តល់សមាសភាគប្រាក់បំណាច់ជាក្រុម",
            "sub": "ដំណាក់កាលទី១ កត់ត្រាប៉ុណ្ណោះ · បង្កើតព្រឹត្តិការណ៍ប្រាក់បំណាច់មួយក្នុងមួយបុគ្គលិកត្រូវគ្នា",
            "info-title": "ផ្តល់ជាក្រុមតាមក្រុម។",
            "info-body": "ជ្រើសរើសការផ្សំ នាយកដ្ឋាន + កម្រិត បន្ទាប់មកសមាសភាគ និងចំនួន។ ព្រឹត្តិការណ៍ប្រាក់បំណាច់មួយត្រូវបានកត់ត្រាក្នុងមួយបុគ្គលិកត្រូវគ្នា។ ប្រាក់ខែគោលតាមកិច្ចសន្យាមិនត្រូវបានសរសេរជាន់លើទេ។",
            "matched": "បុគ្គលិកត្រូវគ្នា",
            "will-receive": "បុគ្គលិកនឹងទទួលការផ្តល់នេះ",
            "component": "សមាសភាគ",
            "select-component": "ជ្រើសរើសសមាសភាគប្រាក់ឧបត្ថម្ភ…",
            "component-helper": "មានតែសមាសភាគប្រាក់ឧបត្ថម្ភប៉ុណ្ណោះអាចផ្តល់ជាក្រុមក្នុងដំណាក់កាលទី១។ ការកែប្រាក់ខែត្រូវកត់ត្រាក្នុងមួយបុគ្គលិក។",
            "amount": "ចំនួន (USD)",
            "amount-helper": "ចំនួនដូចគ្នាអនុវត្តចំពោះបុគ្គលិកត្រូវគ្នាគ្រប់រូប។",
            "funded": "ឧបត្ថម្ភដោយ",
            "funded-optimal": "ឧបត្ថម្ភដោយ Optimal",
            "funded-client": "ឧបត្ថម្ភដោយអតិថិជន",
            "effective": "កាលបរិច្ឆេទមានសុពលភាព",
            "reason": "មូលហេតុ",
            "reason-placeholder": "ឧ. ការផ្សព្វផ្សាយប្រាក់ឧបត្ថម្ភទូរស័ព្ទទូទាំងនាយកដ្ឋាន",
            "submit": "កត់ត្រា {count} ព្រឹត្តិការណ៍",
            "toast": "បានកត់ត្រា {count} ព្រឹត្តិការណ៍ប្រាក់បំណាច់ · មើលសៀវភៅកត់ត្រាព្រឹត្តិការណ៍"
          },
          "component": {
            "new-title": "សមាសភាគថ្មី",
            "edit-title": "កែសមាសភាគ — {name}",
            "sub": "សមាសភាគប្រាក់បំណាច់មេ · ផ្សព្វផ្សាយទៅគ្រប់កញ្ចប់ និងការផ្តល់",
            "code": "កូដ",
            "code-helper": "កូដអក្សរធំខ្លី · មិនអាចប្តូរបានពេលក្រោយ។",
            "code-immutable": "កូដមិនអាចផ្លាស់ប្តូរបានពេលបង្កើតរួច។",
            "name-en": "ឈ្មោះ (អង់គ្លេស)",
            "name-km": "ឈ្មោះ (ខ្មែរ)",
            "tax": "ការគិតពន្ធ",
            "flags": "ទង់ផ្សេងទៀត",
            "recurring": "កើតឡើងដដែល (បង់រាល់ដំណាក់កាល)",
            "nssf": "រាប់បញ្ចូលក្នុងមូលដ្ឋាន NSSF",
            "seniority": "រាប់បញ្ចូលក្នុងមូលដ្ឋានអតីតភាព",
            "funding": "ការឧបត្ថម្ភលំនាំដើម",
            "funded-optimal": "ឧបត្ថម្ភដោយ Optimal",
            "funded-client": "ឧបត្ថម្ភដោយអតិថិជន",
            "funded-policy": "តាមគោលនយោបាយ (ក្នុងមួយការផ្តល់)",
            "save": "រក្សាទុកការផ្លាស់ប្តូរ",
            "create": "បង្កើតសមាសភាគ",
            "toast-created": "សមាសភាគ \"{name}\" ត្រូវបានបង្កើត",
            "toast-updated": "សមាសភាគ \"{name}\" ត្រូវបានកែ",
            "tax-help": {
              "none": "មិនរាប់បញ្ចូលក្នុងពន្ធលើប្រាក់បៀវត្ស (TOS) និងពន្ធលើអត្ថប្រយោជន៍បន្ថែម។ ឧ. ប្រាក់ដឹកជញ្ជូន ប្រាក់អាហារក្នុងដែនកំណត់ច្បាប់។",
              "tos": "ពន្ធលើប្រាក់បៀវត្ស · អត្រាកើនលំដាប់តាមច្បាប់ការងារកម្ពុជា។ អនុវត្តចំពោះប្រាក់សាច់ប្រាក់ដែលបង់ដោយផ្ទាល់ទៅបុគ្គលិក (គោល លំនៅឋាន តួនាទី ។ល។)។",
              "fringe": "ពន្ធលើអត្ថប្រយោជន៍បន្ថែម · អត្រាថេរ ២០% លើតម្លៃអត្ថប្រយោជន៍។ អនុវត្តចំពោះអត្ថប្រយោជន៍មិនមែនសាច់ប្រាក់ (រថយន្តក្រុមហ៊ុន លំនៅឋានផ្តល់ដោយនិយោជក ប្រាក់ឧបត្ថម្ភជាសម្ភារៈ ។ល។)។"
            }
          }
        }
      },
      "sites": {
        "subtitle": "ទីតាំងធ្វើការ · ជាកម្មសិទ្ធិក្រុមហ៊ុន និងការដាក់នៅអតិថិជន EOR · ប្រភពតែមួយសម្រាប់កន្លែងបុគ្គលិកធ្វើការ",
        "add-site": "បន្ថែមទីតាំង",
        "search-placeholder": "ឈ្មោះទីតាំង កូដ អាសយដ្ឋាន…",
        "footnote": "បង្ហាញ {shown} ក្នុងចំណោម {total} ទីតាំង · ចុចលើជួរណាមួយដើម្បីមើលព័ត៌មាន · កែ បិទ ឬលុបទីតាំងពីសកម្មភាពជួរ",
        "banner": {
          "title": "ទីតាំង",
          "lead": "— គ្រប់គ្រងទីតាំងធ្វើការដែលប្រើជា Base Location របស់បុគ្គលិក។",
          "detail": "ទីតាំងបង្រួបបង្រួមការិយាល័យក្រុមហ៊ុន និងទីតាំងដាក់នៅអតិថិជន EOR ក្នុងគំរូតែមួយ។ ការិយាល័យកណ្ដាលគឺជា Base Location មេ; ការិយាល័យសាខាបន្ថែមអាចបើក ឬបិទតាមតម្រូវការ។"
        },
        "type": {
          "main": "ការិយាល័យកណ្ដាល",
          "sub": "ការិយាល័យសាខា",
          "unknown": "មិនស្គាល់"
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "inactive": "មិនសកម្ម",
          "all-types": "គ្រប់ប្រភេទ",
          "label-type": "ប្រភេទ",
          "label-status": "ស្ថានភាព",
          "label-search": "ស្វែងរក",
          "label-country": "ប្រទេស",
          "label-province": "ខេត្ត/រាជធានី",
          "label-district": "ស្រុក/ខណ្ឌ",
          "all-countries": "គ្រប់ប្រទេស",
          "all-provinces": "គ្រប់ខេត្ត/រាជធានី",
          "all-districts": "គ្រប់ស្រុក/ខណ្ឌ",
          "clear-one": "សម្អាតតម្រង {name}"
        },
        "table": {
          "code": "កូដទីតាំង",
          "name": "ឈ្មោះទីតាំង",
          "type": "ប្រភេទ",
          "owner": "ម្ចាស់ទីតាំង",
          "status": "ស្ថានភាព",
          "enabled": "បើក",
          "actions": "សកម្មភាព",
          "always-on": "បើកជានិច្ច",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "click-hint": "ចុចលើជួរណាមួយដើម្បីបើកព័ត៌មានទីតាំង",
          "area": "តំបន់",
          "no-coordinates": "គ្មានកូអរដោនេ"
        },
        "actions": {
          "clear-filters": "សម្អាតតម្រង",
          "edit": "កែ {name}",
          "edit-short": "កែ",
          "delete": "លុប {name}",
          "delete-short": "លុប",
          "view-map": "មើល {name} លើផែនទី",
          "view-map-short": "មើលលើផែនទី",
          "toggle": "បើក ឬបិទ {name}",
          "export": "នាំចេញ",
          "export-empty": "គ្មានអ្វីត្រូវនាំចេញ — គ្មានជួរដេកត្រូវនឹងតម្រង",
          "history": "ប្រវត្តិ"
        },
        "empty": {
          "title": "គ្មានទីតាំងណាមួយផ្គូផ្គងតម្រងបច្ចុប្បន្ន។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកទីតាំងបានទេ។"
        },
        "drawer": {
          "close": "បិទព័ត៌មានទីតាំង",
          "section": {
            "address": "អាសយដ្ឋាន & GPS",
            "roster": "ព័ត៌មានលម្អិត"
          },
          "fields": {
            "gps-lat": "GPS Lat",
            "gps-lon": "GPS Lon",
            "owner": "ម្ចាស់ទីតាំង"
          },
          "no-value": "—"
        },
        "map": {
          "label": "ផែនទីទីតាំង",
          "coordinates": "កូអរដោនេទីតាំង",
          "coordinates-hint": "ចុច ឬអូសម្ជុលលើផែនទី ឬវាយ \"រយៈទទឹង, រយៈបណ្ដោយ\"។"
        },
        "modal": {
          "title": "បង្កើតទីតាំងថ្មី",
          "edit-title": "កែទីតាំង",
          "subtitle": "ទីតាំងធ្វើការដែលប្រើជា Base Location របស់បុគ្គលិក។ វាលដែលមាន * គឺត្រូវការ។",
          "cancel": "បោះបង់",
          "submit": "បង្កើតទីតាំង",
          "update": "ធ្វើបច្ចុប្បន្នភាពទីតាំង",
          "footnote": "ទីតាំងត្រូវការឈ្មោះ។ សូមដាក់ម្ជុលលើផែនទី (កូអរដោនេ) ប្រសិនបើទីតាំងនេះនឹងប្រើជាតំបន់ការងារ។ អាចបន្ថែមបានតែការិយាល័យរង ព្រោះការិយាល័យកណ្ដាលមកជាមួយក្រុមហ៊ុនស្រាប់។",
          "fields": {
            "name": "ឈ្មោះទីតាំង",
            "name-placeholder": "ឧ. ការិយាល័យកណ្ដាល",
            "code": "កូដទីតាំង",
            "code-placeholder": "កូដក្រុមហ៊ុន (ស្រេចចិត្ត)",
            "type": "ប្រភេទ",
            "location": "ទីតាំងលើផែនទី",
            "address": "ព័ត៌មានអាសយដ្ឋាន",
            "address-placeholder": "ផ្លូវ សង្កាត់ ខណ្ឌ",
            "status": "ស្ថានភាព",
            "country-placeholder": "ជ្រើសរើសប្រទេស",
            "province-placeholder": "ជ្រើសរើសខេត្ត/រាជធានី",
            "district-placeholder": "ជ្រើសរើសស្រុក/ខណ្ឌ",
            "area-loading": "កំពុងផ្ទុក…",
            "area-none": "រកមិនឃើញ",
            "area-error": "មិនអាចផ្ទុកបញ្ជីទីតាំងបានទេ។ អ្នកនៅតែអាចរក្សាទុកទីតាំងបាន ហើយសាកល្បងបញ្ជីម្ដងទៀតពេលក្រោយ។"
          }
        },
        "delete": {
          "title": "លុបទីតាំង?",
          "body": "តើអ្នកប្រាកដថាចង់លុប \"{name}\" មែនទេ? វាមិនអាចមកវិញបានទេ។",
          "confirm": "លុប"
        },
        "disable": {
          "title": "បិទទីតាំង?",
          "body": "តើអ្នកប្រាកដថាចង់បិទ \"{name}\" មែនទេ? បុគ្គលិកលែងអាចប្រើវាជា Base Location រហូតដល់បើកវិញ។",
          "confirm": "បិទ"
        },
        "toasts": {
          "created": "ទីតាំង \"{name}\" បានបង្កើត",
          "updated": "ទីតាំង \"{name}\" បានធ្វើបច្ចុប្បន្នភាព",
          "deleted": "ទីតាំង \"{name}\" បានលុប",
          "enabled": "ទីតាំង \"{name}\" បានបើក",
          "disabled": "ទីតាំង \"{name}\" បានបិទ"
        },
        "export": {
          "code": "កូដ",
          "name": "ឈ្មោះ",
          "type": "ប្រភេទ",
          "status": "ស្ថានភាព",
          "country": "ប្រទេស",
          "province": "ខេត្ត/រាជធានី",
          "district": "ស្រុក/ខណ្ឌ",
          "address": "អាសយដ្ឋាន",
          "lat": "រយៈទទឹង",
          "lng": "រយៈបណ្ដោយ",
          "radius": "កាំតំបន់ការងារ (ម៉ែត្រ)"
        },
        "history-title": "ប្រវត្តិកែសម្រួល · {name}",
        "history-fields": {
          "Name": "ឈ្មោះ",
          "Code": "កូដ",
          "Status": "ស្ថានភាព",
          "Type": "ប្រភេទ",
          "IsPrimary": "ការិយាល័យកណ្ដាល",
          "Location": "កូអរដោនេ",
          "DetailedAddress": "អាសយដ្ឋាន",
          "Country": "ប្រទេស",
          "Province": "ខេត្ត/រាជធានី",
          "District": "ស្រុក/ខណ្ឌ",
          "WorkZone": "តំបន់ការងារ"
        },
        "errors": {
          "save": "មិនអាចរក្សាទុកទីតាំងបានទេ។ សូមព្យាយាមម្ដងទៀត។",
          "delete": "មិនអាចលុបទីតាំងបានទេ។ សូមព្យាយាមម្ដងទៀត។",
          "status": "មិនអាចប្ដូរស្ថានភាពទីតាំងបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        }
      },
      "workZones": {
        "title": "តំបន់ការងារ",
        "section-aria": "ទីតាំង និងតំបន់ការងារ",
        "add-zone": "បន្ថែមតំបន់",
        "convert-all": "បំប្លែងទាំងអស់",
        "search-placeholder": "ស្វែងរកតំបន់ការងារតាមឈ្មោះ លេខកូដ ឬអាសយដ្ឋាន",
        "no-match": "គ្មានតំបន់ការងារត្រូវនឹង \"{q}\" ទេ។",
        "status": {
          "active": "សកម្ម"
        },
        "table": {
          "location": "ទីតាំង",
          "address": "អាសយដ្ឋាន",
          "employees": "បុគ្គលិក",
          "radius": "កាំ",
          "status": "ស្ថានភាព",
          "actions": "សកម្មភាព",
          "no-value": "—"
        },
        "actions": {
          "edit": "កែតំបន់ការងារ {name}",
          "deactivate": "បិទតំបន់ការងារ {name}",
          "view-employees": "មើលបុគ្គលិកដែលបានកំណត់ទៅ {name}"
        },
        "empty": {
          "title": "មិនទាន់មានតំបន់ការងារ",
          "detail": "បំប្លែងទីតាំងមូលដ្ឋានដែលមានស្រាប់ទៅជាតំបន់ការងារ ដើម្បីចាប់ផ្តើមអនុវត្តព្រំដែនចូល/ចេញ។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកតំបន់ការងារបានទេ។"
        },
        "form": {
          "add-title": "បន្ថែមតំបន់ការងារ",
          "edit-title": "កែតំបន់ការងារ",
          "location": "ទីតាំងការងារ",
          "center-point": "ចំណុចកណ្តាល",
          "no-coords": "ទីតាំងនេះគ្មានកូអរដោនេទេ។ កំណត់វានៅផ្ទាំងទីតាំង មុនពេលកំណត់តំបន់ការងារ។",
          "no-locations": "គ្មានទីតាំងមូលដ្ឋាន។",
          "all-converted": "ទីតាំងមូលដ្ឋានទាំងអស់គឺជាតំបន់ការងារសកម្មរួចហើយ។",
          "radius": "កាំនៃការអនុវត្ត",
          "radius-meters": "កាំនៃការអនុវត្តគិតជាម៉ែត្រ",
          "meters": "ម៉ែត្រ",
          "cancel": "បោះបង់",
          "add": "បន្ថែមតំបន់",
          "save": "រក្សាទុកការផ្លាស់ប្តូរ"
        },
        "employees": {
          "title": "បុគ្គលិកក្នុងតំបន់",
          "subtitle": "{name} · បានកំណត់ {count}",
          "name": "ឈ្មោះពេញ",
          "code": "លេខកូដ",
          "position": "មុខតំណែង",
          "orgUnit": "អង្គភាព",
          "empty": "គ្មានបុគ្គលិកត្រូវបានកំណត់ទៅតំបន់នេះទេ។",
          "close": "បិទ"
        },
        "deactivate": {
          "title": "បិទតំបន់ការងារ",
          "body": "បិទតំបន់ការងារសម្រាប់ \"{name}\"? បុគ្គលិកដែលបានកំណត់ទៅទីតាំងនេះនឹងលែងត្រូវបានដាក់កម្រិតព្រំដែននៅទីនេះទៀតហើយ។ ទីតាំងមូលដ្ឋានខ្លួនវានៅដដែល។",
          "confirm": "បិទ"
        },
        "batch": {
          "convert-all": "បំប្លែងទាំងអស់",
          "cancel": "បោះបង់",
          "dismiss": "បដិសេធ",
          "staleHint": "ការដំណើរការនេះមិនបានរាយការណ៍វឌ្ឍនភាពលើសពី ៥ នាទីទេ — កម្មករទំនងជាបរាជ័យមុនពេលចាប់ផ្តើម។ បោះបង់វាដើម្បីសម្អាតផ្ទាំង ហើយដាក់ស្នើថ្មី។",
          "processed": "{processed} នៃ {total} បានដំណើរការ",
          "succeeded": "{count} បានជោគជ័យ",
          "skipped": "{count} ទីតាំងត្រូវបានរំលង (ដកចេញ មានតំបន់ការងាររួចហើយ ឬគ្មានកូអរដោនេ)។",
          "banner": {
            "title": "ការបំប្លែងជាបាច់",
            "queued": "ការបំប្លែងជាបាច់កំពុងរង់ចាំ…",
            "processing": "កំពុងបំប្លែងទីតាំងមូលដ្ឋានទៅជាតំបន់ការងារ…",
            "completed": "ការបំប្លែងជាបាច់បានបញ្ចប់",
            "failed": "ការបំប្លែងជាបាច់បានបរាជ័យ"
          },
          "error": {
            "invokeWorker": "មិនអាចចាប់ផ្តើមកម្មករផ្ទៃខាងក្រោយបានទេ។ សូមព្យាយាមម្តងទៀតក្នុងពេលបន្តិច។",
            "generic": "ប្រតិបត្តិការបានបរាជ័យមុនពេលបញ្ចប់។ សូមពិនិត្យកំណត់ហេតុ។"
          },
          "toast": {
            "completed": "{count} ទីតាំងបានបំប្លែង។",
            "conflict": "មានបាច់កំពុងដំណើរការរួចហើយ។ កំពុងបន្តប្រតិបត្តិការដែលមានស្រាប់។",
            "cancelled": "បាច់ត្រូវបានបោះបង់។ អ្នកអាចដាក់ស្នើប្រតិបត្តិការបាច់ថ្មីឥឡូវនេះ។",
            "submitFailed": "មិនអាចចាប់ផ្តើមការបំប្លែងជាបាច់បានទេ។"
          },
          "dialog": {
            "title": "បំប្លែងទីតាំងមូលដ្ឋានទៅជាតំបន់ការងារ",
            "lead": "រាល់ទីតាំងមូលដ្ឋានសកម្មដែលមានកូអរដោនេត្រឹមត្រូវ ហើយមិនទាន់ជាតំបន់ការងារ នឹងត្រូវបានធ្វើឱ្យសកម្មជាមួយកាំខាងក្រោម។ ទីតាំងដែលខ្វះកូអរដោនេនឹងត្រូវរំលងដោយស្វ័យប្រវត្តិ។",
            "willConvert": "នឹងត្រូវបំប្លែង",
            "missingCoords": "ខ្វះកូអរដោនេ",
            "excluded": "បានដកចេញ",
            "exclude": "ដកទីតាំងជាក់លាក់ចេញ (ស្រេចចិត្ត)",
            "excludeHint": "តំបន់ការងារសកម្មរួចហើយ និងទីតាំងដែលខ្វះកូអរដោនេនឹងត្រូវរំលងដោយស្វ័យប្រវត្តិ។",
            "alreadyZoned": "{count} ជាតំបន់ការងាររួចហើយ — ត្រូវរំលង ហើយកាំមិនផ្លាស់ប្ដូរ។",
            "start": "ចាប់ផ្តើមការបំប្លែង"
          },
          "skipped-download": "ទាញយកជួរដែលបានរំលង",
          "skipped-truncated": "បញ្ជីបង្ហាញតែ ៥០០ ទីតាំងដំបូងដែលបានរំលងប៉ុណ្ណោះ។"
        },
        "errors": {
          "save": "មិនអាចរក្សាទុកតំបន់ការងារបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        }
      },
      "org-units": {
        "title": "អង្គភាព",
        "subtitle": "ខ្នងរចនាសម្ព័ន្ធរបស់ក្រុមហ៊ុន · រៀបចំតាមស្រទាប់ដែលអាចកំណត់បាន",
        "add-unit": "បន្ថែមអង្គភាព",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះ ឬប្រធាន…",
        "kpi": {
          "total": "អង្គភាពសរុប",
          "with-head": "មានប្រធានចាត់តាំង",
          "vacant-heads": "ប្រធានទំនេរ",
          "with-budget": "មានថវិកាបុគ្គលិក"
        },
        "filters": {
          "all-types": "ប្រភេទទាំងអស់",
          "all-parents": "មាតាបិតាទាំងអស់",
          "no-parent": "គ្មានមាតាបិតា (កម្រិតកំពូល)",
          "show-inactive": "បង្ហាញដែលអសកម្ម"
        },
        "view": {
          "tree": "ដើមឈើ",
          "table": "តារាង"
        },
        "actions": {
          "clear-filters": "សម្អាតតម្រង",
          "define-levels": "កំណត់ស្រទាប់",
          "edit": "កែសម្រួល",
          "delete": "លុប",
          "deactivate": "បិទដំណើរការ",
          "reactivate": "បើកដំណើរការឡើងវិញ",
          "export": "នាំចេញ",
          "export-empty": "គ្មានអ្វីត្រូវនាំចេញ — គ្មានជួរដេកត្រូវនឹងតម្រង",
          "history": "ប្រវត្តិ"
        },
        "table": {
          "name": "ឈ្មោះ",
          "parent": "មាតាបិតា",
          "layer": "ស្រទាប់",
          "type": "ប្រភេទ",
          "head": "តំណែងទទួលបន្ទុក",
          "roles": "តួនាទីភ្ជាប់",
          "vacant-head": "ទំនេរ",
          "showing": "បង្ហាញ {filtered} នៃ {total} អង្គភាព",
          "sorted-by": "តម្រៀបតាម {col} {dir}",
          "click-hint": "ចុចលើជួរណាមួយដើម្បីបើកព័ត៌មានលម្អិតអង្គភាព",
          "code": "លេខកូដ",
          "head-col": "ប្រធាន",
          "hc-budget": "ថវិកាបុគ្គលិក",
          "hc-budget-hint": "ចំនួនបុគ្គលិកដែលបានអនុម័តសម្រាប់អង្គភាពនេះ រួមទាំងអង្គភាពរងទាំងអស់",
          "sub-alloc": "បែងចែកឱ្យអង្គភាពរង",
          "sub-alloc-hint": "ផលបូកថវិកានៃអង្គភាពរងផ្ទាល់",
          "filled": "មានបុគ្គលិក",
          "open": "ទំនេរ",
          "total": "សរុប",
          "status": "ស្ថានភាព",
          "leaf": "ចុងក្រោយ",
          "escalated": "តាមអង្គភាពមេ",
          "inactive": "អសកម្ម",
          "budget-note": "ថវិកាពីលើចុះក្រោម៖ ផលបូកថវិកានៃអង្គភាពរងផ្ទាល់ មិនអាចលើសថវិការបស់អង្គភាពមេបានទេ។ \"បែងចែកឱ្យអង្គភាពរង\" បង្ហាញចំនួនដែលបានបែងចែករួច ហើយ \"ស្ថានភាព\" បង្ហាញការបែងចែកលើស។"
        },
        "tree": {
          "showing": "បង្ហាញ {n} អង្គភាពនៅលើ {d} ស្រទាប់",
          "expand-all": "ពង្រីកទាំងអស់",
          "collapse-all": "បង្រួមទាំងអស់",
          "click-hint": "ចុចលើថ្នាំងណាមួយដើម្បីបើកអង្គភាព · ប្រើព្រួញដើម្បីពង្រីក/បង្រួម",
          "no-children": "ស្លឹក",
          "counts": "មានបុគ្គលិក {filled} · ទំនេរ {open} · សរុប {total}",
          "budget": "ថវិកាបុគ្គលិក {n}"
        },
        "empty": {
          "title": "គ្មានលទ្ធផលដូច",
          "lede": "គ្មានអង្គភាពត្រូវនឹងតម្រងទាំងនេះទេ។ សាកល្បងសម្អាតតម្រងណាមួយដើម្បីពង្រីកការស្វែងរក។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកអង្គភាពបានទេ",
          "desc": "មានបញ្ហាកើតឡើងខណៈផ្ទុកបញ្ជីអង្គភាព។ សូមព្យាយាមម្តងទៀត។"
        },
        "levels-empty": {
          "title": "មិនទាន់បានកំណត់ស្រទាប់ទេ",
          "lede": "កំណត់ស្រទាប់ឋានានុក្រមរបស់ក្រុមហ៊ុន (ឧទាហរណ៍ គ្រប់គ្រង នាយកដ្ឋាន ផ្នែក) មុននឹងបន្ថែមអង្គភាព។",
          "cta": "កំណត់ស្រទាប់"
        },
        "drawer": {
          "fields": {
            "name": "ឈ្មោះ",
            "type": "ប្រភេទ",
            "parent": "មាតាបិតា",
            "ancestor-path": "ផ្លូវដូនតា",
            "head": "តំណែងទទួលបន្ទុក",
            "created": "បានបង្កើត",
            "leadership": "ភាពជាអ្នកដឹកនាំ និងតួនាទី",
            "roles": "តួនាទីភ្ជាប់",
            "child-units": "អង្គភាពរង",
            "code": "លេខកូដ",
            "name-km": "ឈ្មោះ (ខ្មែរ)",
            "status": "ស្ថានភាព",
            "location": "ទីតាំង",
            "effective-date": "កាលបរិច្ឆេទចូលជាធរមាន",
            "description": "ការពិពណ៌នា",
            "hc-budget": "ថវិកាបុគ្គលិក",
            "sub-alloc": "ការបែងចែកឱ្យអង្គភាពរង",
            "seats": "តំណែង (មានបុគ្គលិក · ទំនេរ · សរុប)",
            "head-name": "ប្រធាន"
          },
          "no-value": "—",
          "no-children": "មិនទាន់មានអង្គភាពរងទេ។",
          "ancestor-root": "កំពូលក្រុមហ៊ុន",
          "history": "ប្រវត្តិ",
          "history-title": "ប្រវត្តិកែប្រែ · {name}",
          "close": "បិទ"
        },
        "edit-modal": {
          "subtitle-new": "អង្គភាពគឺជាថ្នាំងរចនាសម្ព័ន្ធនៅក្នុងឋានានុក្រមក្រុមហ៊ុន។",
          "title-new": "បន្ថែមអង្គភាព",
          "title-edit": "កែសម្រួល {name}",
          "name-label": "ឈ្មោះ",
          "name-placeholder": "ឧទាហរណ៍ សេវាកម្មអតិថិជន",
          "name-required": "ត្រូវការឈ្មោះ",
          "type-label": "ប្រភេទ",
          "layer-required": "សូមជ្រើសរើសស្រទាប់",
          "parent-label": "អង្គភាពមាតាបិតា",
          "parent-note": "ជ្រើសរើសអង្គភាពស្រទាប់ {n} ជាមាតាបិតា",
          "parent-required": "ត្រូវការអង្គភាពមាតាបិតា",
          "no-levels-note": "មិនទាន់មានការកំណត់ស្រទាប់ទេ។ សូមប្រើ \"កំណត់ស្រទាប់\" សិន រួចបន្ថែមអង្គភាព។",
          "head-label": "តំណែងទទួលបន្ទុក",
          "head-placeholder": "ទំនេរ — មិនទាន់កំណត់តំណែង",
          "info-note": "អ្នកអាចចាត់តាំងតំណែងទទួលបន្ទុកឥឡូវនេះ ឬទុកឱ្យទំនេរ ហើយបំពេញនៅពេលក្រោយ។",
          "cancel": "បោះបង់",
          "create": "បង្កើត",
          "save": "រក្សាទុក",
          "error-save": "មិនអាចរក្សាទុកអង្គភាពបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "error-delete": "មិនអាចលុបអង្គភាពបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "delete": {
            "title": "លុបអង្គភាព",
            "warning": "សកម្មភាពនេះនឹងលុបអង្គភាពជាអចិន្ត្រៃយ៍។ វាមិនអាចត្រឡប់វិញបានទេ។",
            "cannot-children": "មិនអាចលុបបានទេ — អង្គភាពរង {n} ត្រូវផ្លាស់ទី ឬលុបជាមុនសិន។",
            "cannot-roles": "មិនអាចលុបបានទេ — តួនាទី {n} នៅតែភ្ជាប់ជាមួយអង្គភាពនេះ។",
            "reassign": "ដោះស្រាយឧបសគ្គខាងលើ រួចព្យាយាមម្តងទៀត។",
            "confirm": "លុបអង្គភាព"
          },
          "section-identity": "អត្តសញ្ញាណ",
          "section-hierarchy": "ឋានានុក្រម",
          "section-leadership": "ការដឹកនាំ",
          "section-budget": "ចំនួនបុគ្គលិក និងកាលបរិច្ឆេទ",
          "name-km-label": "ឈ្មោះ (ខ្មែរ)",
          "name-km-placeholder": "ឧ. ផ្នែកសេវាអតិថិជន",
          "name-too-long": "ឈ្មោះត្រូវមិនលើសពី ២០០ តួអក្សរ",
          "code-label": "លេខកូដ",
          "code-hint": "ប្រព័ន្ធកំណត់ឱ្យដោយស្វ័យប្រវត្តិ (UNIT-NNN) ហើយមិនអាចផ្លាស់ប្តូរបានទេ។",
          "code-pending": "នឹងកំណត់ឱ្យនៅពេលរក្សាទុក",
          "head-seat-label": "ប្រធានអង្គភាព (តំណែង)",
          "head-seat-placeholder": "ទំនេរ — មិនទាន់កំណត់តំណែង",
          "head-seat-hint": "ជ្រើសរើសតំណែងដែលដឹកនាំអង្គភាពនេះ។ បើទុកទំនេរ ការបញ្ជូនទៅអ្នកគ្រប់គ្រងផ្ទាល់នឹងឡើងទៅប្រធានអង្គភាពមេ។",
          "seat-vacant": "ទំនេរ",
          "head-current": "ប្រធានបច្ចុប្បន្ន៖ {name}",
          "location-label": "ទីតាំង",
          "location-placeholder": "គ្មានទីតាំង",
          "budget-label": "ថវិកាបុគ្គលិក (នាក់)",
          "budget-placeholder": "— មិនទាន់កំណត់ —",
          "budget-hint": "ចំនួនបុគ្គលិកដែលបានអនុម័តសម្រាប់អង្គភាពនេះ និងអង្គភាពរងទាំងអស់។ ទុកទទេប្រសិនបើមិនកំណត់។ ផលបូកថវិកាអង្គភាពរងមិនអាចលើសចំនួននេះទេ។",
          "budget-not-integer": "ថវិកាបុគ្គលិកត្រូវតែជាចំនួនគត់",
          "budget-negative": "ថវិកាបុគ្គលិកមិនអាចអវិជ្ជមានបានទេ",
          "budget-too-large": "ថវិកាបុគ្គលិកត្រូវតែមិនលើសពី ៩៩៩ ៩៩៩",
          "effective-date-label": "កាលបរិច្ឆេទចូលជាធរមាន",
          "description-label": "ការពិពណ៌នា",
          "description-placeholder": "គោលបំណងនៃអង្គភាពនេះ",
          "inactive-banner": "អង្គភាពនេះអសកម្ម។ ប្រវត្តិរបស់វានៅតែរក្សាទុក។ ប្រើ \"បើកដំណើរការឡើងវិញ\" ខាងក្រោមដើម្បីយកវាមកវិញ។",
          "server-refused": "ម៉ាស៊ីនមេបានបដិសេធការផ្លាស់ប្តូរ៖ {reason}",
          "created": "បានបង្កើតអង្គភាព \"{name}\"",
          "updated": "បានធ្វើបច្ចុប្បន្នភាព \"{name}\"",
          "deactivate": {
            "title": "បិទដំណើរការអង្គភាព",
            "warning": "អង្គភាពដែលបិទដំណើរការត្រូវលាក់ពីបញ្ជីជ្រើសរើស និងការចាត់តាំងថ្មី ប៉ុន្តែនៅរក្សាទុកសម្រាប់ប្រវត្តិ និងរបាយការណ៍។ អាចត្រឡប់វិញបាន — អ្នកអាចបើកដំណើរការឡើងវិញពេលក្រោយ។",
            "blockers-title": "ម៉ាស៊ីនមេនឹងបដិសេធ ដរាបណាអង្គភាពនេះនៅមាន៖",
            "blocker-sub-units": "អង្គភាពរងសកម្ម {n}៖ {names}",
            "blocker-filled": "តំណែងមានបុគ្គលិក {n} (មានបុគ្គលិកភ្ជាប់)",
            "blocker-open": "តំណែងទំនេរ {n}",
            "blockers-hint": "សូមផ្លាស់ទី ឬបិទវាជាមុនសិន។ ម៉ាស៊ីនមេនឹងពិនិត្យម្តងទៀតនៅពេលអ្នកបញ្ជាក់។",
            "button": "បិទដំណើរការ",
            "confirm-question": "បិទដំណើរការ \"{name}\"? អ្នកអាចបើកវាឡើងវិញពេលក្រោយ។",
            "confirm": "បាទ/ចាស បិទដំណើរការ",
            "cancel-confirm": "រក្សាឱ្យសកម្ម",
            "done": "បានបិទដំណើរការ \"{name}\""
          },
          "reactivate": {
            "title": "បើកដំណើរការអង្គភាពឡើងវិញ",
            "warning": "ការបើកដំណើរការឡើងវិញធ្វើឱ្យអង្គភាពត្រឡប់ទៅសកម្មវិញ ហើយបង្ហាញក្នុងបញ្ជីជ្រើសរើសម្តងទៀត។ មិនអាចបើកវិញបានទេ ខណៈអង្គភាពមេនៅអសកម្ម។",
            "parent-inactive": "អង្គភាពមេ \"{name}\" អសកម្ម — សូមបើកវាឡើងវិញជាមុនសិន។",
            "button": "បើកដំណើរការឡើងវិញ",
            "done": "បានបើកដំណើរការ \"{name}\" ឡើងវិញ"
          }
        },
        "define-levels-modal": {
          "title": "កំណត់ស្រទាប់",
          "subtitle": "រៀបចំស្រទាប់ឋានានុក្រមរបស់ក្រុមហ៊ុន។",
          "layers-question": "ឋានានុក្រមរបស់អ្នកមានប៉ុន្មានស្រទាប់?",
          "layers-label": "ចំនួនស្រទាប់",
          "layers-range": "ជ្រើសរើសពី 1 ដល់ 5 ស្រទាប់",
          "names-question": "កំណត់ឈ្មោះស្រទាប់នីមួយៗ (រហូតដល់ {max})",
          "layer-name-required": "ឈ្មោះស្រទាប់ {n}",
          "layer-name-optional": "ឈ្មោះស្រទាប់ {n} (ស្រេចចិត្ត)",
          "live-preview": "ការមើលជាមុនផ្ទាល់",
          "preview-note": "ការមើលជាមុននេះនឹងធ្វើបច្ចុប្បន្នភាពនៅពេលអ្នកវាយបញ្ចូល — គ្មានអ្វីត្រូវបានរក្សាទុករហូតដល់អ្នកចុចរក្សាទុកទេ។",
          "cancel": "បោះបង់",
          "save": "រក្សាទុក",
          "error-save": "មិនអាចរក្សាទុកការកំណត់ស្រទាប់បានទេ។ សូមព្យាយាមម្តងទៀត។",
          "server-refused": "មិនបានរក្សាទុក — {reason}",
          "duplicate-names": "ស្រទាប់នីមួយៗត្រូវមានឈ្មោះខុសគ្នា — \"{name}\" ត្រូវបានប្រើពីរដង។",
          "name-required": "សូមដាក់ឈ្មោះឱ្យស្រទាប់ {n}។"
        },
        "budget-status": {
          "unset": "— មិនទាន់កំណត់ —",
          "sub-unit-over": "អង្គភាពរងលើស៖ {alloc}/{budget}",
          "hc-over": "បុគ្គលិកលើស {n}",
          "at-cap": "ពេញកម្រិត",
          "headroom": "នៅសល់ {n}",
          "unknown": "ស្ថានភាពមិនស្គាល់ ({raw})"
        },
        "status": {
          "active": "សកម្ម",
          "inactive": "អសកម្ម"
        },
        "history-fields": {
          "Name": "ឈ្មោះ",
          "NameKm": "ឈ្មោះ (ខ្មែរ)",
          "Code": "លេខកូដ",
          "Description": "ការពិពណ៌នា",
          "ParentId": "អង្គភាពមេ",
          "ParentName": "ឈ្មោះអង្គភាពមេ",
          "Layer": "ស្រទាប់",
          "Type": "ប្រភេទ",
          "LocationId": "ទីតាំង",
          "HeadPositionId": "តំណែងប្រធាន",
          "HeadcountBudget": "ថវិកាបុគ្គលិក",
          "EffectiveDate": "កាលបរិច្ឆេទចូលជាធរមាន",
          "Status": "ស្ថានភាព",
          "SubUnitAllocation": "ការបែងចែកឱ្យអង្គភាពរង",
          "FilledCount": "មានបុគ្គលិក",
          "OpenCount": "ទំនេរ"
        }
      },
      "org-chart": {
        "subtitle": "ការមើលឃើញរចនាសម្ព័ន្ធអង្គភាពរបស់អ្នកដែលមានបុគ្គលិកត្រូវបានចាត់តាំង",
        "export": "នាំចេញ",
        "export-toast": "នាំចេញ PDF គំនូសតាងអង្គភាព — នឹងមកដល់ក្នុងស្រាប់ៗ",
        "edit-lines": "កែបន្ទាត់របាយការណ៍",
        "info-banner": "បង្ហាញឋានានុក្រមបុគ្គលិកដែលបង្កើតពីទំនាក់ទំនងរបាយការណ៍។ ចុចលើថ្នាំងណាមួយដើម្បីផ្តោតលើដើមនោះ។ មុខតំណែងទំនេរលេចឡើងនៅក្រោមអ្នកគ្រប់គ្រងដែលបានដោះស្រាយ។",
        "canvas-title": "គំនូសតាងអង្គភាពនៃ Optimal P",
        "layer-1": "កម្រិត ១",
        "status": {
          "active": "សកម្ម",
          "pending": "កំពុងរង់ចាំ",
          "probation": "ការសាកល្បង",
          "on-leave": "ឈប់សម្រាក",
          "inactive-vacant": "អសកម្ម / ទំនេរ"
        },
        "nav": {
          "title": "ការរុករកតួនាទី",
          "hint": "បិទបើកដើម្បីពង្រីក · ចុចដើម្បីផ្តោត",
          "hide": "លាក់ការរុករក",
          "show": "បង្ហាញការរុករក",
          "short": "រុករក",
          "empty": "គ្មានការផ្គូផ្គង"
        },
        "toolbar": {
          "show-vacancies": "បង្ហាញមុខតំណែងទំនេរ",
          "default-view": "ទិដ្ឋភាពលំនាំដើម (កម្រិត ១+២ មើលឃើញ កម្រិត ៣+ បានដួល)",
          "expand-all": "ពង្រីកសាខាទាំងអស់",
          "collapse-all": "ដួលសាខាទាំងអស់",
          "zoom-out": "ពង្រីកចេញ",
          "zoom-in": "ពង្រីកចូល",
          "zoom-fit": "ដាក់ឱ្យសម ១០០%",
          "export": "នាំចេញ",
          "reset-focus": "កំណត់ការផ្តោតឡើងវិញ",
          "back-to-root": "ត្រឡប់ទៅឫស"
        },
        "search-placeholder": "ស្វែងរកឈ្មោះ ឬតួនាទី…",
        "chart": {
          "focus-reset": "បង្ហាញគំនូសតាងទាំងស្រុង",
          "showing-focused": "កំពុងផ្តោតលើ {name} — បង្ហាញតែបុព្វជន និងកូនចៅប៉ុណ្ណោះ",
          "vacancy-pill": "មុខតំណែងទំនេរ"
        },
        "drawer": {
          "title": "ប្រវត្តិរូបបុគ្គលិក",
          "section-contact": "ទំនាក់ទំនង",
          "section-reporting": "បន្ទាត់របាយការណ៍",
          "section-directs": "របាយការណ៍ផ្ទាល់",
          "section-meta": "ព័ត៌មានអង្គភាព",
          "field-code": "លេខកូដបុគ្គលិក",
          "field-title": "មុខតំណែង",
          "field-dept": "នាយកដ្ឋាន",
          "field-manager": "របាយការណ៍ទៅ",
          "field-email": "អ៊ីមែល",
          "field-phone": "ទូរស័ព្ទ",
          "field-join": "ចូលបម្រើការ",
          "field-type": "ប្រភេទការងារ",
          "field-breadcrumb": "ច្រកអង្គភាព",
          "no-directs": "គ្មានរបាយការណ៍ផ្ទាល់",
          "no-manager": "កំពូលក្រុមហ៊ុន — គ្មានអ្នកគ្រប់គ្រង",
          "directs-more": "+{count} ផ្សេងទៀត"
        },
        "edit-modal": {
          "title": "កែបន្ទាត់របាយការណ៍",
          "lede": "ផ្តល់អ្នកគ្រប់គ្រងថ្មីដល់បុគ្គលិក។ ការបញ្ជូននឹងបង្ហាញ toast — ខាងម៉ាស៊ីនមេពិតនឹងភ្ជាប់នៅក្នុងស្រាប់បន្ត។",
          "employee-label": "បុគ្គលិក",
          "manager-label": "អ្នកគ្រប់គ្រងថ្មី",
          "employee-placeholder": "ជ្រើសរើសបុគ្គលិក…",
          "manager-placeholder": "ជ្រើសរើសអ្នកគ្រប់គ្រង…",
          "submit": "រក្សាទុកបន្ទាត់របាយការណ៍",
          "cancel": "បោះបង់",
          "toast": "បន្ទាត់របាយការណ៍សម្រាប់ {employee} ត្រូវបានកែប្រែទៅរាយការណ៍ទៅ {manager}"
        },
        "empty": {
          "title": "មិនទាន់មានបុគ្គលិកនៅក្នុងគំនូសតាងអង្គភាព"
        }
      },
      "workforce-plan": {
        "title": "ផែនការកម្លាំងពលកម្ម",
        "subtitle": "មុខតំណែងបើកចំនួន {open} · ចុច Fill ដើម្បីចាប់ផ្ដើមកម្មវិធីបន្ថែមបុគ្គលិក",
        "banner": "<b>ការជ្រើសរើសផ្អែកលើមុខតំណែង។</b> មុខតំណែងនីមួយៗគឺជាកៅអីតែមួយគត់។ មុខតំណែងដែលមានចំណងជើងការងារដូចគ្នាត្រូវបានដាក់ជាក្រុម — ចុចលើក្រុមណាមួយដើម្បីពង្រីក។ ការបង្កើតក្រៅផែនការត្រូវបានកត់ត្រាសវនកម្ម។",
        "kpi": {
          "open-positions": "មុខតំណែងបើក",
          "high-priority": "អាទិភាពខ្ពស់",
          "filled-total": "បំពេញសរុប",
          "off-plan": "ការលើកលែងក្រៅផែនការ",
          "budgeted": "ចំនួនបុគ្គលិកតាមថវិកា",
          "filled-positions": "មុខតំណែងដែលបានបំពេញ",
          "vacant-positions": "មុខតំណែងទំនេរ",
          "vacancy-rate": "អត្រាទំនេរ",
          "hiring-demand": "តម្រូវការជ្រើសរើស"
        },
        "budget": {
          "summary": "ថវិកាចំនួនបុគ្គលិកអង្គភាព ({count} អង្គភាព)",
          "table": {
            "org-unit": "អង្គភាព",
            "filled": "បំពេញ",
            "open": "បើក",
            "total": "សរុប",
            "hc-budget": "ថវិកា HC",
            "status": "ស្ថានភាព",
            "frozen": "បានបង្កក",
            "off-plan": "ក្រៅផែនការ"
          },
          "status": {
            "over-by": "លើស {n}",
            "at-cap": "ដល់កំណត់",
            "headroom": "នៅសល់ {n}",
            "unset": "មិនបានកំណត់ថវិកា"
          },
          "region-label": "ថវិកាចំនួនបុគ្គលិកតាមអង្គភាព"
        },
        "table": {
          "showing": "បង្ហាញក្រុមចំណងជើងការងារ {groups} {label} · មុខតំណែងបើកសរុប {open}",
          "groups-one": "ក្រុម",
          "groups-many": "ក្រុម",
          "hint": "ដាក់ជាក្រុមតាមចំណងជើងការងារ · ចុចដើម្បីពង្រីក",
          "region-label": "មុខតំណែងបើកដាក់ជាក្រុមតាមចំណងជើងការងារ"
        },
        "group": {
          "summary-filled": "បំពេញ {filled}",
          "summary-open": "បើក {open}",
          "summary-high": "ខ្ពស់ {high}",
          "summary-specifiers": "សញ្ញាបញ្ជាក់: {names}",
          "bulk-fill": "បំពេញច្រើន",
          "bulk-fill-title": "បើកកម្មវិធីបន្ថែមបុគ្គលិកសម្រាប់មុខតំណែងទំនេរទីមួយក្នុងក្រុមនេះ",
          "create": "មុខតំណែងថ្មី",
          "create-aria": "មុខតំណែងថ្មីសម្រាប់ {title}",
          "view-open": "មើលកៅអីទំនេរ"
        },
        "row": {
          "off-plan": "ក្រៅផែនការ",
          "optimal-internal": "ផ្ទៃក្នុង Optimal",
          "days-suffix": "({days}ថ្ងៃ)",
          "fill": "បំពេញ",
          "reports-to": "↳ រាយការណ៍ទៅ {label}",
          "fill-aria": "បំពេញ {code} — {title}"
        },
        "priority": {
          "low": "ទាប",
          "medium": "មធ្យម",
          "high": "ខ្ពស់",
          "urgent": "បន្ទាន់"
        },
        "empty": {
          "title": "មុខតំណែងទាំងអស់បានបំពេញ",
          "lede": "មិនមានកៅអីបើកនៅពេលនេះទេ។ ប្រើ <b>មុខតំណែងថ្មី</b> ខាងលើដើម្បីគ្រោងទុក។"
        },
        "recently-filled": {
          "summary": "បានបំពេញថ្មីៗ ({count})",
          "table": {
            "position": "មុខតំណែង",
            "job-title": "ចំណងជើងការងារ",
            "filled-by": "បំពេញដោយ",
            "filled-on": "បំពេញនៅ"
          },
          "none": "មិនមានកៅអីដែលបានបំពេញក្នុងរយៈពេល ៩០ ថ្ងៃចុងក្រោយទេ។",
          "region-label": "មុខតំណែងដែលទើបបំពេញ"
        },
        "actions": {
          "new-position": "មុខតំណែងថ្មី",
          "fill-toast": "កម្មវិធីបន្ថែមបុគ្គលិកបានជ្រើសរើសសម្រាប់ {code} — នឹងមកដល់ក្នុងពេលឆាប់ៗ",
          "bulk-fill-toast": "បំពេញច្រើនសម្រាប់ {group} — នឹងមកដល់ក្នុងពេលឆាប់ៗ",
          "created-toast": "បានបង្កើតមុខតំណែង · {title}"
        },
        "drawer": {
          "title": "ព័ត៌មានលម្អិតមុខតំណែង",
          "fields": {
            "code": "កូដមុខតំណែង",
            "title": "ចំណងជើងការងារ",
            "grade": "ថ្នាក់",
            "dept": "នាយកដ្ឋាន",
            "org-unit": "អង្គភាព",
            "approver": "អ្នកអនុម័ត",
            "hiring-manager": "អ្នកគ្រប់គ្រងជ្រើសរើស",
            "created": "បានបង្កើត",
            "target-start": "ថ្ងៃចាប់ផ្ដើមគោលដៅ",
            "candidates": "បេក្ខជន",
            "timeline": "ពេលវេលាស្ថានភាព",
            "budget": "ថវិកា",
            "activity": "សកម្មភាព",
            "project": "គម្រោង",
            "filled-by": "បំពេញដោយ",
            "filled-on": "បំពេញនៅ"
          },
          "no-value": "—",
          "budget-line": "{amount} USD",
          "close": "បិទ"
        },
        "modal": {
          "title": "បង្កើតមុខតំណែង",
          "lede": "មុខតំណែងបម្រុងកៅអីដែលបានអនុម័តសម្រាប់ការជ្រើសរើសដែលបានគ្រោងទុក។",
          "fields": {
            "title": "ចំណងជើង",
            "grade": "ថ្នាក់",
            "dept": "នាយកដ្ឋាន",
            "org-unit": "អង្គភាព",
            "headcount": "ចំនួនបុគ្គលិក",
            "justification": "ហេតុផល",
            "budget": "ថវិកាប្រចាំឆ្នាំ (USD)"
          },
          "placeholders": {
            "title": "ឧ. វិស្វករផ្នែកខាងក្រោយជាន់ខ្ពស់",
            "dept": "ឧ. វិស្វកម្ម",
            "org-unit": "ឧ. OU-ENG-PLATFORM",
            "headcount": "1",
            "justification": "ហេតុអ្វីត្រូវការកៅអីនេះឥឡូវនេះ? ឯកសារយោងផែនការ…",
            "budget": "0"
          },
          "validation": {
            "title-required": "ត្រូវការចំណងជើង",
            "dept-required": "ត្រូវការនាយកដ្ឋាន",
            "org-unit-required": "ត្រូវការអង្គភាព",
            "headcount-positive": "ចំនួនបុគ្គលិកត្រូវតែជាចំនួនវិជ្ជមាន",
            "budget-non-negative": "ថវិកាមិនអាចតិចជាង 0 ទេ"
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើត"
        },
        "live-subtitle": "មុខតំណែងទំនេរ {open} · ដាក់ជាក្រុមតាមមុខតំណែង",
        "banner-lead": "ការជ្រើសរើសផ្អែកលើមុខតំណែងជាមុន។",
        "banner-live": "{lead} មុខតំណែងនីមួយៗគឺជាកៅអីតែមួយគត់។ មុខតំណែងដែលមានចំណងជើងការងារដូចគ្នាត្រូវបានដាក់ជាក្រុម — ចុចលើក្រុមណាមួយដើម្បីពង្រីក។ ការបង្កើតក្រៅផែនការត្រូវបានកត់ត្រាសវនកម្ម។",
        "empty-live": "មិនមានកៅអីទំនេរនៅពេលនេះទេ។ ប្រើ មុខតំណែងថ្មី ខាងលើ ដើម្បីរៀបចំផែនការជាមុន។"
      },
      "positions": {
        "title": "មុខតំណែង",
        "subtitle": "បញ្ជីមេនៃកៅអីដែលបានអនុម័តទាំងអស់ — បើក បំពេញ កក ក្រៅផែនការ",
        "add-position": "មុខតំណែងថ្មី",
        "banner": {
          "body": "{position} គឺជាកៅអីតែមួយគត់ (ឧ. P0150 = ទីតាំង Plant Operator ទី១នៅ Acme Line A)។ {jobTitle} គឺជាគំរូតួនាទីដែលអាចត្រូវបានយោងដោយ Position ច្រើន។ Job Title មួយ → Position ច្រើន; Position មួយ → បុគ្គលិកមិនលើសពីម្នាក់ទេ។",
          "position-term": "មុខតំណែង",
          "job-title-term": "ចំណងជើងការងារ"
        },
        "actions": {
          "new-position": "មុខតំណែងថ្មី",
          "clear-filters": "សម្អាតតម្រង",
          "edit-toast": "កែសម្រួលមុខតំណែង {id} — នឹងមកដល់ក្នុងស្រាប់ៗ",
          "export": "នាំចេញ",
          "edit": "កែសម្រួល",
          "freeze": "បង្កក",
          "unfreeze": "ឈប់បង្កក",
          "cancel": "លុបចោលមុខតំណែង",
          "restore": "ស្ដារឡើងវិញ",
          "history": "ប្រវត្តិកែសម្រួល"
        },
        "kpi": {
          "all-positions": "មុខតំណែងទាំងអស់",
          "open-vacant": "បើក (ទំនេរ)",
          "filled": "បានបំពេញ",
          "off-plan": "ក្រៅផែនការ"
        },
        "chips": {
          "all": "ទាំងអស់",
          "open": "បើក",
          "filled": "បានបំពេញ",
          "frozen": "កក",
          "offplan": "ក្រៅផែនការ",
          "cancelled": "បានបោះបង់"
        },
        "filters": {
          "all-job-titles": "ចំណងជើងការងារទាំងអស់",
          "all-org-units": "អង្គភាពទាំងអស់",
          "all-projects": "គម្រោងទាំងអស់",
          "optimal-internal": "ផ្ទៃក្នុង Optimal"
        },
        "toggles": {
          "group-by-job-title": "ដាក់ជាក្រុមតាមចំណងជើងការងារ",
          "show-cancelled": "បង្ហាញដែលបានបោះបង់"
        },
        "priority": {
          "high": "ខ្ពស់",
          "medium": "មធ្យម",
          "low": "ទាប"
        },
        "search-placeholder": "ស្វែងរកតាម P-ID ចំណងជើង បុគ្គលិក…",
        "row": {
          "off-plan": "ក្រៅផែនការ",
          "edit-action": "កែសម្រួលមុខតំណែង"
        },
        "table": {
          "showing": "បង្ហាញ {filtered} នៃ {total} មុខតំណែង",
          "click-hint": "ចុចលើជួរណាមួយដើម្បីបើកព័ត៌មានលម្អិតមុខតំណែង",
          "group-summary": "{count} មុខតំណែង · {filled} បានបំពេញ · {open} បើក",
          "position-id": "លេខសម្គាល់មុខតំណែង",
          "job-title": "ចំណងជើងការងារ",
          "org-unit": "អង្គភាព",
          "specifiers": "តម្រូវការ",
          "project": "គម្រោង",
          "grade": "ថ្នាក់",
          "status": "ស្ថានភាព",
          "filled-by": "បំពេញដោយ",
          "open-since": "បើកតាំងពី",
          "edit": "កែសម្រួល",
          "reports-to": "រាយការណ៍ទៅ",
          "remove-filter": "ដកតម្រង៖ {name}"
        },
        "empty": {
          "title": "គ្មានមុខតំណែងណាត្រូវនឹងតម្រងទាំងនេះ",
          "lede": "សាកល្បងសម្អាតតម្រងមួយឬច្រើនដើម្បីពង្រីកការស្វែងរក។"
        },
        "drawer": {
          "fields": {
            "job-title": "ចំណងជើងការងារ",
            "org-unit": "អង្គភាព",
            "project": "គម្រោង",
            "open-since": "បើកតាំងពី",
            "specifiers": "តម្រូវការ",
            "filled-by": "បំពេញដោយ",
            "status": "ស្ថានភាព"
          },
          "no-value": "—",
          "foot-note": "សកម្មភាពកែសម្រួល បំពេញ ឬកក នឹងមកដល់ក្នុងស្រាប់ៗ — តារាងនេះគឺជាការមើលត្រឹមតែប៉ុណ្ណោះសម្រាប់ពេលនេះ។",
          "close": "បិទ",
          "timeline": "ពេលវេលានៃស្ថានភាព",
          "filled-on": "បានបំពេញនៅ",
          "cancelled-on": "បានលុបចោលនៅ",
          "filled-note": "មានបុគ្គលិកកំពុងកាន់កៅអីនេះ ដូច្នេះមិនអាចបង្កក ឬលុបចោលបានទេ។ សូមដកចេញជាមុនសិន តាមរយៈការផ្ទេរ ឬការបញ្ចប់ការងារ។",
          "reports-note": "មានមុខតំណែង {n} រាយការណ៍មកមុខតំណែងនេះ — សូមផ្លាស់ទីពួកវាមុននឹងលុបចោល។",
          "fill-hint": "ដើម្បីបំពេញកៅអីនេះ សូមបន្ថែមបុគ្គលិកពី បុគ្គលិក › បន្ថែមបុគ្គលិក ហើយជ្រើស {id} ជាមុខតំណែងរបស់ពួកគេ។"
        },
        "modal": {
          "title": "មុខតំណែងថ្មី",
          "lede": "មុខតំណែងគឺជាកៅអីតែមួយគត់ — ឈ្មោះរបស់វាមកពី Job Title + តម្រូវការ (មិនចាំបាច់សរសេរឈ្មោះដោយដៃ)។",
          "fields": {
            "job-title": "ចំណងជើងការងារ",
            "org-unit": "អង្គភាព",
            "project": "គម្រោង",
            "priority": "អាទិភាព"
          },
          "placeholders": {
            "job-title": "ជ្រើសរើស Job Title…",
            "org-unit": "ឧ. ប្រតិបត្តិការ"
          },
          "validation": {
            "job-title-required": "ត្រូវការ Job Title",
            "org-unit-required": "ត្រូវការអង្គភាព"
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើតមុខតំណែង",
          "created-toast": "បានបង្កើតមុខតំណែង · {id}"
        },
        "status-unknown": "មិនស្គាល់",
        "unknown-title": "គ្មានមុខតំណែង",
        "load-error": {
          "title": "មិនអាចផ្ទុកមុខតំណែងបានទេ",
          "lede": "មានបញ្ហាក្នុងការអានតារាងរចនាសម្ព័ន្ធ។ សូមព្យាយាមម្ដងទៀត។"
        },
        "none": {
          "title": "មិនទាន់មានមុខតំណែងនៅឡើយ",
          "lede": "ក្រុមហ៊ុននេះមិនទាន់មានកៅអីនៅលើតារាងរចនាសម្ព័ន្ធទេ។ បើកកៅអីដំបូងដោយប្រើ មុខតំណែងថ្មី។"
        },
        "toasts": {
          "updated": "បានរក្សាទុកមុខតំណែង {id}",
          "frozen": "បានបង្កកមុខតំណែង {id}",
          "unfrozen": "បានឈប់បង្កកមុខតំណែង {id}",
          "cancelled": "បានលុបចោលមុខតំណែង {id}",
          "restored": "បានស្ដារមុខតំណែង {id} ឡើងវិញ"
        },
        "confirm": {
          "freeze-title": "បង្កក {id}?",
          "freeze-body": "កៅអីដែលបានបង្កកនៅតែមានក្នុងបញ្ជី ប៉ុន្តែមិនអាចបំពេញបានទេ រហូតដល់អ្នកឈប់បង្កកវា។",
          "cancel-title": "លុបចោល {id}?",
          "cancel-body": "កៅអីនេះនឹងចេញពីចំនួនបុគ្គលិកដែលនៅទំនេរ និងពីតារាងរចនាសម្ព័ន្ធ។ វានៅតែមានក្នុងបញ្ជី (បង្ហាញដែលបានលុបចោល) ហើយអាចស្ដារឡើងវិញបាននៅពេលក្រោយ។",
          "keep": "រក្សាទុកវា"
        },
        "form": {
          "edit-title": "កែសម្រួលមុខតំណែង {code}",
          "none": "គ្មាន",
          "reports-to": "រាយការណ៍ទៅ",
          "reports-to-top": "កំពូលនៃតារាង",
          "reports-to-hint": "ទុកនៅកំពូល ប្រសិនបើកៅអីនេះមិនរាយការណ៍ទៅនរណាម្នាក់។",
          "reports-to-search": "ស្វែងរកមុខតំណែង…",
          "no-results": "គ្មានមុខតំណែងដែលត្រូវគ្នា",
          "base-location": "ទីតាំងមូលដ្ឋាន",
          "target-start": "កាលបរិច្ឆេទចាប់ផ្ដើមគោលដៅ",
          "off-plan": "ក្រៅផែនការ (ក្រៅផែនការកម្លាំងពលកម្ម)",
          "off-plan-hint": "កៅអីក្រៅផែនការត្រូវបានកត់ត្រាសវនកម្ម ហើយត្រូវការហេតុផល។",
          "justification": "ហេតុផល",
          "justification-placeholder": "ហេតុអ្វីបានជាត្រូវការកៅអីនេះឥឡូវ?",
          "specifier-placeholder": "តម្លៃ",
          "title-change-warning": "ការប្ដូរមុខតំណែងនឹងលុបតម្លៃសម្គាល់របស់មុខតំណែងនេះ នៅពេលអ្នករក្សាទុក។",
          "org-unit-placeholder": "ជ្រើសរើសអង្គភាព…",
          "save": "រក្សាទុកការផ្លាស់ប្ដូរ",
          "validation": {
            "job-title-required": "ត្រូវការមុខតំណែង",
            "org-unit-required": "ត្រូវការអង្គភាព",
            "justification-required": "ត្រូវការហេតុផលសម្រាប់មុខតំណែងក្រៅផែនការ"
          }
        },
        "errors": {
          "forbidden": "អ្នកមិនមានសិទ្ធិផ្លាស់ប្ដូរមុខតំណែងទេ។",
          "not-found": "មុខតំណែងនេះលែងមានទៀតហើយ។ សូមផ្ទុកទំព័រឡើងវិញ។",
          "conflict": "ម៉ាស៊ីនមេបានបដិសេធការផ្លាស់ប្ដូរនេះ។ សូមផ្ទុកទំព័រឡើងវិញ ហើយព្យាយាមម្ដងទៀត។",
          "invalid": "ព័ត៌មានមួយចំនួនមិនត្រូវបានទទួលយកទេ។ សូមពិនិត្យទម្រង់ ហើយព្យាយាមម្ដងទៀត។",
          "network": "មិនអាចភ្ជាប់ទៅម៉ាស៊ីនមេបានទេ។ សូមពិនិត្យការតភ្ជាប់ ហើយព្យាយាមម្ដងទៀត។",
          "generic": "មានបញ្ហាក្នុងការរក្សាទុកមុខតំណែង។ សូមព្យាយាមម្ដងទៀត។"
        }
      },
      "onboarding": {
        "title": "ការចូលបំពេញការងារ",
        "subtitle": "តាមដានភាពត្រៀមលក្ខណៈពីការផ្ដល់ការងារដែលបានទទួលយករហូតដល់ការបញ្ចប់សាកល្បង — សម្ភារៈ · ឯកសារ · ប្រព័ន្ធ · ប្រាក់ខែ · អ្នកគ្រប់គ្រង · សាកល្បង។",
        "add-person": "បន្ថែមបុគ្គលិក",
        "add-toast": "កម្មវិធីបន្ថែមបុគ្គលិក — នឹងមកដល់ក្នុងស្រាប់ៗ",
        "actions": {
          "start-onboarding": "ចាប់ផ្ដើមការចូលបំពេញការងារ",
          "clear-filters": "សម្អាតការត្រងទាំងអស់",
          "view": "មើល"
        },
        "banner": {
          "title": "ដំណាក់កាល ១ · កត់ត្រាតែប៉ុណ្ណោះ។",
          "body": "ការចូលបំពេញការងារតាមដានភាពត្រៀមលក្ខណៈ — ការអនុម័តកើតឡើងក្រៅប្រព័ន្ធ។ ការអនុវត្តកិច្ចការ ការជូនដំណឹង និងសមាហរណកម្ម ដំណើរការនៅក្នុងម៉ូឌុលម្ចាស់ (សូមមើលឆ្នូតភ្ជាប់)។ ដំណាក់កាល ២ បន្ថែមការងារដោយស្វ័យប្រវត្តិ។"
        },
        "kpi": {
          "new-hires": "បុគ្គលិកថ្មី (៣០ ថ្ងៃ)",
          "pending-docs": "ឯកសារកំពុងរង់ចាំ",
          "in-probation": "ស្ថិតក្នុងសាកល្បង",
          "probation-due": "ការវាយតម្លៃសាកល្បងដល់ពេល",
          "new-joiners": "បុគ្គលិកថ្មី",
          "preboarding": "មុនចូលធ្វើការ",
          "day1": "ត្រៀមថ្ងៃទី១",
          "probation-window": "ដំណាក់កាលសាកល្បង",
          "attention": "ត្រូវការការយកចិត្តទុកដាក់",
          "open-view": "បើកទិដ្ឋភាពនេះ →"
        },
        "sub-tabs": {
          "dashboard": "ផ្ទាំងព័ត៌មាន",
          "new-joiners": "បុគ្គលិកថ្មី",
          "preboarding": "មុនចូលធ្វើការ",
          "day1": "ការត្រៀមថ្ងៃទី១",
          "probation": "សាកល្បង",
          "templates": "ទំរង់គំរូ",
          "reports": "របាយការណ៍"
        },
        "dispatch": {
          "title": "ចាប់ផ្ដើមការចូលបំពេញការងារ",
          "lede": "ជ្រើសរើសបុគ្គលិកដែលអ្នកចង់ចាប់ផ្ដើមការចូលបំពេញការងារ។",
          "form-title": "ការកំណត់ការចូលបំពេញការងារ",
          "form-lede": "បញ្ជាក់ទំរង់ ម្ចាស់រឿង និងកាលបរិច្ឆេទចាប់ផ្ដើម — ការតាមដានភាពត្រៀមលក្ខណៈនឹងចាប់ផ្ដើមភ្លាមៗ។",
          "empty": "មិនមានបុគ្គលិកសមរម្យ។ សូមបង្កើតបុគ្គលិកជាមុនដោយប្រើ បន្ថែមបុគ្គលិក។",
          "fields": {
            "template": "ទំរង់គំរូ",
            "owner": "ម្ចាស់រឿងដែលបានកំណត់",
            "start-date": "កាលបរិច្ឆេទចាប់ផ្ដើម"
          },
          "placeholders": {
            "template": "ជ្រើសរើសទំរង់គំរូ…",
            "owner": "ឧ. សុគន្ធា ប៉ែន"
          },
          "errors": {
            "no-joiner": "ជ្រើសរើសបុគ្គលិកជាមុនសិន",
            "template-required": "ត្រូវការទំរង់គំរូ",
            "owner-required": "ត្រូវការម្ចាស់រឿង",
            "start-date-required": "ត្រូវការកាលបរិច្ឆេទចាប់ផ្ដើម"
          },
          "cancel": "បោះបង់",
          "back": "ត្រឡប់",
          "submit": "ចាប់ផ្ដើម",
          "created-toast": "បានចាប់ផ្ដើមការចូលបំពេញការងារ · {employee}"
        },
        "dashboard": {
          "toolbar": {
            "title": "ផ្ទាំងព័ត៌មានភាពត្រៀមលក្ខណៈ",
            "lede": "តាមដានភាពត្រៀមលក្ខណៈចាប់ពីការទទួលយកសំណើរការងាររហូតដល់ការបញ្ចប់សាកល្បង — រូបរាង · ឯកសារ · ការចូលប្រព័ន្ធ · ប្រាក់ខែ · អ្នកគ្រប់គ្រង/ក្រុម · សាកល្បង។"
          },
          "kpi": {
            "open-view": "បើកទិដ្ឋភាពនេះ →"
          },
          "stages": {
            "draft": "ការផ្ដល់ការងារទទួលយក",
            "preboarding": "មុនចូលធ្វើការ",
            "day1": "ការធ្វើឱ្យសកម្មថ្ងៃទី១",
            "active": "ការតម្រង់ទិស",
            "probation": "សាកល្បង",
            "completed": "បានបញ្ចប់"
          },
          "journey": {
            "title": "ដំណើរការការចូលបំពេញការងារ"
          },
          "current": {
            "title": "ការចូលបំពេញការងារបច្ចុប្បន្ន",
            "empty": "មិនមានការចូលបំពេញការងារសកម្ម។ បន្ថែមបុគ្គលិកពីផ្ទាំងបុគ្គលិកថ្មី។"
          },
          "card": {
            "ready": "ត្រៀម {pct}%",
            "starts-in": "ក្នុងរយៈពេល {days} ថ្ងៃ",
            "starts-today": "ថ្ងៃនេះ",
            "started-ago": "កាលពី {days} ថ្ងៃមុន"
          },
          "attention": {
            "title": "ត្រូវការការយកចិត្តទុកដាក់",
            "empty": "អ្វីៗគ្រប់យ៉ាងល្អ — មិនមានបញ្ហារាំងស្ទះភាពត្រៀមលក្ខណៈទេឥឡូវនេះ។"
          },
          "flags": {
            "contract": "កិច្ចសន្យាមិនទាន់ហត្ថលេខា",
            "bank": "ខ្វះគណនីធនាគារ",
            "laptop": "ឡែបថបមិនបានកំណត់",
            "ess": "មិនបានផ្ញើការអញ្ជើញ ESS",
            "payroll": "ការដំឡើងប្រាក់បៀវត្សរ៍កំពុងរង់ចាំ",
            "probation": "ការវាយតម្លៃសាកល្បងដល់ពេល"
          },
          "owners": {
            "title": "កម្មសិទ្ធិម៉ូឌុល — ការចូលបំពេញការងារតាមដានភាពត្រៀមលក្ខណៈ; ការអនុវត្តកើតឡើងក្នុងម៉ូឌុលម្ចាស់",
            "people": "ប្រភពនៃការពិត",
            "contract": "កំណត់ត្រាកិច្ចព្រមព្រៀងការងារ",
            "work": "ការអនុវត្តកិច្ចការ",
            "docs": "កន្លែងស្ដារទុកឯកសារ",
            "asset": "ទ្រព្យសម្បត្តិក្រុមហ៊ុនបានចេញ",
            "hrops": "ការដំឡើងកាលវិភាគ / វត្តមាន",
            "payroll": "ភាពត្រៀមនៃប្រាក់បៀវត្សរ៍",
            "perf": "ការវាយតម្លៃសាកល្បង / ការពិនិត្យ",
            "people-name": "ប្រវត្តិរូបបុគ្គលិក",
            "contract-name": "កិច្ចសន្យា",
            "work-name": "គ្រប់គ្រងការងារ",
            "docs-name": "ឯកសារ",
            "asset-name": "ទ្រព្យសម្បត្តិ",
            "hrops-name": "ប្រតិបត្តិការ HR",
            "payroll-name": "ប្រាក់បៀវត្សរ៍",
            "perf-name": "ប្រសិទ្ធភាព"
          }
        },
        "new-joiners": {
          "toolbar": {
            "title": "បុគ្គលិកថ្មី",
            "lede": "មានតែផ្ទាំងនេះប៉ុណ្ណោះដែលចាប់ផ្ដើមការចូលបំពេញការងារ។ ប្រើ <strong>+ បន្ថែមបុគ្គលិក</strong> ប្រសិនបើប្រវត្តិរូបបុគ្គលិកមិនទាន់មាន។"
          },
          "fresh": {
            "title": "បុគ្គលិកថ្មី",
            "lede": "កិច្ចសន្យាបានហត្ថលេខា · មិនទាន់ចាប់ផ្ដើមធ្វើការ · ការចូលបំពេញការងារមិនទាន់ចាប់ផ្ដើម",
            "empty": "មិនមាននរណាក្នុងក្រុមនេះទេឥឡូវនេះ។"
          },
          "catchup": {
            "title": "ការចូលបំពេញការងារចាប់តាមក្រោយ",
            "lede": "បុគ្គលិកសកម្ម ឬបានធ្វើចំណាកស្រុក · នៅក្នុងសាកល្បង · ការចូលបំពេញការងារខ្វះ",
            "empty": "មិនមាននរណាក្នុងក្រុមនេះទេឥឡូវនេះ។"
          },
          "start": "ចាប់ផ្ដើម",
          "cols": {
            "joined": "ចាប់ផ្ដើម / ចូលធ្វើការ",
            "probation-end": "ការបញ្ចប់សាកល្បង",
            "contract": "កិច្ចសន្យា",
            "reason": "មូលហេតុ"
          },
          "drawer": {
            "title": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "joined": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "contract": "ប្រភេទកិច្ចសន្យា",
            "client": "អតិថិជន / គម្រោង",
            "reason": "មូលហេតុ"
          }
        },
        "preboarding": {
          "toolbar": {
            "title": "មុនចូលធ្វើការ",
            "lede": "អ្វីៗដែលត្រូវត្រៀម <strong>មុន</strong> ថ្ងៃទី១ — ម៉ាទ្រីសភាពត្រៀមលក្ខណៈតាមក្រុម។ ចុចលើជួរណាមួយដើម្បីបើកបញ្ជី checklist ពេញលេញ។"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "start": "ចាប់ផ្ដើម",
            "profile": "ប្រវត្តិរូប",
            "contract": "កិច្ចសន្យា",
            "physical": "រូបរាង",
            "system": "ប្រព័ន្ធ",
            "payroll": "ប្រាក់ខែ",
            "manager": "អ្នកគ្រប់គ្រង",
            "probation": "សាកល្បង",
            "overall": "សរុប"
          },
          "empty": {
            "title": "មិនមាននរណាស្ថិតក្នុងមុនចូលធ្វើការទេ។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "progress": "វឌ្ឍនភាព",
            "owner": "ម្ចាស់រឿងដែលបានកំណត់",
            "probation-end": "ការបញ្ចប់សាកល្បង",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "day1": {
          "search-placeholder": "ស្វែងរកកំណត់ត្រាថ្ងៃទី១…",
          "chips": {
            "all": "ទាំងអស់",
            "ready": "ត្រៀម",
            "not-ready": "មិនទាន់ត្រៀម",
            "activated": "បានធ្វើឱ្យសកម្ម"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "role": "តួនាទី",
            "start": "ចាប់ផ្ដើម",
            "gates": "ច្រកផ្លូវ",
            "owner": "ម្ចាស់រឿង",
            "status": "ស្ថានភាព"
          },
          "gates": {
            "contract": "កិច្ចសន្យាបានហត្ថលេខា និងបានរក្សាទុក",
            "physical": "កន្លែងធ្វើការ · បរិក្ខារ · ប័ណ្ណចូល",
            "system": "ESS · អ៊ីមែល · វត្តមាន · កាលវិភាគ",
            "manager": "អ្នកគ្រប់គ្រង · មិត្តរួមការងារ · ផែនការថ្ងៃទី១"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} កំណត់ត្រា",
          "empty": {
            "title": "គ្មាន​បេក្ខជន​ថ្ងៃ​ទី​១​នៅ​ឡើយ​ទេ — បន្ថែម​បុគ្គលិក​ថ្មី​ពី​ផ្ទាំង New Joiners។",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "gates-title": "ច្រកផ្លូវថ្ងៃទី១",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "owner": "ម្ចាស់រឿង",
            "notes": "កំណត់ចំណាំ"
          },
          "starts": "ចាប់ផ្តើម",
          "toolbar": {
            "title": "ការ​ត្រៀម​ថ្ងៃ​ទី​១",
            "lede": "បេក្ខជន​ដែល​ខិត​ជិត​ថ្ងៃ​ទី​១ — បង្ហាញ​ច្រក​ត្រៀម​លក្ខណៈ​៤​បូក​ប៊ូតុង​សកម្ម។"
          },
          "status": {
            "ready": "រួច​ហើយ",
            "not-ready": "មិន​ទាន់​រួច"
          },
          "activate": "សកម្ម · ថ្ងៃ​ទី​១​បាន​បញ្ចប់"
        },
        "probation": {
          "search-placeholder": "ស្វែងរកកំណត់ត្រាសាកល្បង…",
          "chips": {
            "all": "ទាំងអស់",
            "in-probation": "ក្នុងសាកល្បង",
            "due-soon": "ដល់ពេល ≤១៤ថ្ងៃ",
            "confirmed": "បានបញ្ជាក់"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "role": "តួនាទី",
            "start": "ចាប់ផ្ដើម",
            "probation-end": "បញ្ចប់សាកល្បង",
            "days-left": "ថ្ងៃនៅសល់",
            "owner": "ម្ចាស់រឿង",
            "status": "ស្ថានភាព",
            "role-client": "តួនាទី · អតិថិជន",
            "case": "ករណី",
            "days": "ថ្ងៃ",
            "cycle-stage": "ដំណាក់កាល",
            "lm-recommendation": "យោបល់ LM",
            "lm-recommendation-tooltip": "យោបល់របស់អ្នកគ្រប់គ្រងបន្ទាត់ពីការត្រួតពិនិត្យ — ស្ថានភាពតែប៉ុណ្ណោះ",
            "action": "សកម្មភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} កំណត់ត្រា",
          "empty": {
            "title": "មិនមានកំណត់ត្រាសាកល្បង",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
            "probation-end": "ការបញ្ចប់សាកល្បង",
            "owner": "ម្ចាស់រឿង",
            "confirmed": "បានបញ្ជាក់",
            "yes": "បាទ/ចាស",
            "no": "ទេ",
            "notes": "កំណត់ចំណាំ",
            "client": "អតិថិជន"
          },
          "toolbar": {
            "title": "ការត្រួតពិនិត្យ និងបញ្ជាក់សាកល្បង",
            "lede": "ការត្រួតពិនិត្យ LM → ការទទួលស្គាល់ពីបុគ្គលិក → ការបញ្ជាក់ HR។ ការផ្ទេរ​ដោយ​ស្វ័យ​ប្រវត្តិ​សម្រាប់​ការ​ឆ្លងផុត; HR បញ្ចប់​ព្រឹត្តិការណ៍​កិច្ច​សន្យា (ករណី A កិច្ចសន្យាថ្មី · ករណី B បញ្ជាក់ + កែប្រែ​ប្រាក់ខែ​ប្រសិន​ប្រែប្រួល)។"
          },
          "banner": {
            "title": "ច្បាប់​សាកល្បង​កម្ពុជា (ER-1)។",
            "body": "ករណី A (កិច្ចសន្យាសាកល្បងដាច់ដោយឡែក) → ឆ្លងផុត = ការផ្លាស់ប្តូរកិច្ចសន្យា (UDC/FDC ថ្មី)។ ករណី B (UDC/FDC រួមមាន​ឃ្លាសាកល្បង) → ឆ្លងផុត = ការបញ្ជាក់​សាកល្បង + កែ​ប្រាក់​ខែ​បើ​ប្តូរ។ ការបញ្ចប់​តម្រូវ​ឱ្យ​មាន​ខ្សែ​ត្រួតពិនិត្យ — មិន​ត្រឹម​តែ​កាលបរិច្ឆេទ​ទេ។"
          },
          "case-label": "ករណី {c}",
          "midway": "ពាក់​កណ្តាល",
          "days": {
            "in": "{n} ថ្ងៃ",
            "today": "ថ្ងៃ​នេះ",
            "overdue": "ហួស​ {n} ថ្ងៃ"
          },
          "stage": {
            "pending": "រង់ចាំ",
            "lm-review": "ត្រួត​ពិនិត្យ LM",
            "employee-ack": "បុគ្គលិក​ទទួល​ស្គាល់",
            "hr-confirm": "HR បញ្ជាក់",
            "confirmed": "បាន​បញ្ជាក់"
          },
          "action": {
            "confirm": "បញ្ជាក់ និងកត់ត្រា",
            "nudge": "រំលឹក LM",
            "await-employee": "រង់ចាំ​បុគ្គលិក"
          }
        },
        "templates": {
          "search-placeholder": "ស្វែងរកទំរង់គំរូ…",
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "archived": "បានទុកក្នុងបណ្ណសារ"
          },
          "status": {
            "active": "សកម្ម",
            "archived": "បានទុកក្នុងបណ្ណសារ"
          },
          "cols": {
            "id": "លេខកូដ",
            "name": "ទំរង់គំរូ",
            "category": "ប្រភេទ",
            "tasks": "កិច្ចការ (ច. បាច់)",
            "duration": "រយៈពេល",
            "updated": "បានធ្វើបច្ចុប្បន្នភាព",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ទំរង់គំរូ",
          "empty": {
            "title": "មិនមានទំរង់គំរូត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "tasks": "កិច្ចការ",
            "mandatory": "ច. បាច់",
            "duration": "រយៈពេល",
            "updated": "បានធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
            "owner": "តួនាទីម្ចាស់រឿង",
            "notes": "កំណត់ចំណាំ"
          },
          "toolbar": {
            "title": "គំរូ​បញ្ចូល​ការងារ",
            "lede": "បញ្ជី​ត្រួត​ពិនិត្យ​ត្រៀម​លក្ខណៈ​តាម​ប្រភេទ​ការងារ + តួនាទី។"
          },
          "new": "គំរូ​ថ្មី",
          "scope": {
            "direct": "ផ្ទាល់",
            "outsourced": "ខាង​ក្រៅ"
          },
          "meta": {
            "tasks": "កិច្ចការ (តម្រូវ)",
            "duration": "រយៈពេល",
            "owner": "ម្ចាស់",
            "updated": "ធ្វើបច្ចុប្បន្នភាព",
            "days": "{n} ថ្ងៃ"
          },
          "using": "{n} កំណត់ត្រា​ប្រើ​នេះ",
          "view-edit": "មើល / កែ"
        },
        "reports": {
          "search-placeholder": "ស្វែងរករបាយការណ៍…",
          "chips": {
            "all": "ទាំងអស់",
            "on-track": "តាមផ្លូវ",
            "at-risk": "ប្រឈមហានិភ័យ",
            "behind": "យឺត"
          },
          "cols": {
            "period": "កាលបរិច្ឆេទ",
            "dept": "នាយកដ្ឋាន",
            "joiners": "បុគ្គលិកថ្មី",
            "completed": "បានបញ្ចប់",
            "avg-days": "មធ្យមថ្ងៃ",
            "rate": "អត្រាបញ្ជាក់",
            "owner": "ម្ចាស់រឿង",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} របាយការណ៍",
          "empty": {
            "title": "មិនមានរបាយការណ៍ត្រូវនឹងលក្ខខណ្ឌ",
            "lede": "សម្អាតការត្រងសកម្ម ឬពង្រីកការស្វែងរករបស់អ្នក។"
          },
          "drawer": {
            "joiners": "បុគ្គលិកថ្មី",
            "completed": "បានបញ្ចប់",
            "avg-days": "មធ្យមថ្ងៃដើម្បីត្រៀម",
            "rate": "អត្រាបញ្ជាក់សាកល្បង",
            "owner": "ម្ចាស់រឿង"
          },
          "view": {
            "insights": "ការ​យល់​ដឹង",
            "completion": "របាយការណ៍​លម្អិត"
          },
          "toolbar": {
            "title": "ការ​យល់​ដឹង​អំពី​ការ​បញ្ចូល​ការងារ",
            "lede": "ការ​វិភាគ​ផ្ទាល់​ឆ្លង​កាត់​កំណត់ត្រា​បញ្ចូល​ការងារ​ទាំងអស់។"
          },
          "kpi": {
            "active": "កំពុង​បញ្ចូល",
            "active-sub": "{midway} ពាក់​កណ្តាល · {cancelled} បាន​លុបចោល",
            "soon": "ចាប់​ផ្តើម ≤ ៧ ថ្ងៃ",
            "soon-sub": "ត្រូវ​ត្រៀម​រួច",
            "readiness": "ការ​ត្រៀម​លក្ខណៈ​មធ្យម",
            "readiness-sub": "{done} នៃ {total} ធាតុ",
            "ttd": "ពេល​មធ្យម​​ដាក់​ឱ្យ​ប្រើ​ប្រាស់",
            "ttd-sub": "បង្កើត → ចាប់​ផ្តើម",
            "attention": "ត្រូវ​ការ​ការ​យក​ចិត្ត​ទុក​ដាក់",
            "attention-sub": "កំណត់ត្រា​មាន​ឧបសគ្គ"
          },
          "funnel": {
            "title": "ចូល​បំពង់​បង្ហូរ",
            "preboarding": "មុន​ការ​ចូល",
            "day1": "ត្រៀម​ថ្ងៃ​ទី​១",
            "active": "សកម្ម",
            "probation": "សាកល្បង",
            "completed": "បាន​បញ្ចប់"
          },
          "groups": {
            "title": "ការ​ត្រៀម​លក្ខណៈ​តាម​ក្រុម",
            "lede": "ការ​បំពេញ​ទាប​បំផុត​បង្ហាញ​ពី​ទីតាំង​ដែល​ការ​បញ្ចូល​ការងារ​ជាប់​គាំង។",
            "contract": "កិច្ច​សន្យា",
            "physical": "ការ​សាមញ្ញ / កន្លែង​ធ្វើ​ការ",
            "system": "ការ​ចូល​ប្រព័ន្ធ",
            "payroll": "បើក​ប្រាក់​ខែ",
            "probation": "សាកល្បង"
          },
          "blockers": {
            "title": "ឧបសគ្គ​ឈាន​មុខ",
            "empty": "គ្មាន​ឧបសគ្គ​នៅ​ក្នុង​ការ​បញ្ចូល​ការងារ​សកម្ម​ទេ។"
          },
          "dim": {
            "workforce": "ប្រភេទ​កម្លាំងពលកម្ម",
            "client": "អតិថិជន",
            "dept": "នាយកដ្ឋាន",
            "category": "ប្រភេទ",
            "midway-cohort": "ពាក់​កណ្តាល",
            "fresh-cohort": "ថ្មី"
          },
          "breakdown": {
            "title": "ការ​ចែក​ចាយ​តាម {dim}"
          },
          "cycle": {
            "title": "វដ្ត​ត្រួត​ពិនិត្យ​សាកល្បង",
            "lm": "ត្រួត​ពិនិត្យ LM",
            "ack": "បុគ្គលិក​ទទួល​ស្គាល់",
            "confirm": "HR បញ្ជាក់",
            "overdue": "{n} ហួស​ការ​បញ្ចប់​សាកល្បង — ហួស​កាល​ត្រួត​ពិនិត្យ",
            "no-overdue": "គ្មាន​ការ​ត្រួត​ពិនិត្យ​សាកល្បង​ហួស​ពេល​ទេ"
          },
          "outcomes": {
            "title": "លទ្ធផល",
            "completed": "បាន​បញ្ចប់ (សាកល្បង​បាន​បញ្ជាក់)",
            "pass-rate": "អត្រា​ឆ្លងផុត​សាកល្បង",
            "midway": "ការ​បញ្ចូល​ការងារ​ពាក់​កណ្តាល",
            "cancelled": "បាន​លុបចោល (រួម​ទាំង​ការ​ធ្លាក់​ចុះ​ការ​សាកល្បង)",
            "avg-ttd": "ពេល​មធ្យម​​ដាក់​ឱ្យ​ប្រើ​ប្រាស់",
            "days": "{n} ថ្ងៃ"
          },
          "completion": {
            "title": "របាយការណ៍​លម្អិត",
            "lede": "ការ​បំបែក​ក្រុម​តាម​ដំណាក់​កាល​បំពង់​បង្ហូរ — បន្ត​ពី​កាល​បរិច្ឆេទ​ចាប់​ផ្តើម។"
          },
          "flags": {
            "contract": "កិច្ច​សន្យា​មិន​ទាន់​ចុះ",
            "bank": "ធនាគារ​មិន​ទាន់​រៀប​ចំ",
            "laptop": "ឡែបថប​មិន​ទាន់​ផ្តល់",
            "ess": "ESS មិន​ទាន់​អញ្ជើញ",
            "payroll": "បើក​ប្រាក់​ខែ​មិន​ទាន់​រួច"
          }
        },
        "stub": {
          "title": "ការចូលបំពេញការងារ",
          "lede": "ផ្ទាំងព័ត៌មានច្រើនទិដ្ឋភាព (Dashboard / New Hires / Probation) ជាមួយវឌ្ឍនភាព checklist ការសម្គាល់ឯកសារកំពុងរង់ចាំ និងការរំលឹកការវាយតម្លៃសាកល្បង។ Phase B ភ្ជាប់ទៅ `recruitment/`។"
        }
      },
      "offboarding": {
        "title": "ការចាកចេញពីការងារ",
        "subtitle": "លាលែង → លក្ខខណ្ឌ → ប្រាក់ខែចុងក្រោយ → បទសម្ភាស — ការគ្រប់គ្រងតែមួយសម្រាប់រាល់ការចាកចេញ។",
        "actions": {
          "start": "ចាប់ផ្តើមការចាកចេញ",
          "clear-filters": "សម្អាតតម្រង",
          "view": "មើល"
        },
        "banner": {
          "title": "មជ្ឈមណ្ឌលចាកចេញ គឺជាប៉ម​​ត្រួតពិនិត្យ។",
          "body": "រាល់ការចាកចេញ — ពីប្រភពណាមួយ — ចូលមកទីនេះមុនគេ ហើយឆ្លងកាត់ផ្លូវស្ថានភាពមួយ៖ ថ្មី → កំពុងពិនិត្យ → មានសិទ្ធិ → កំពុងដំណើរការ → បានបញ្ចប់។"
        },
        "kpi": {
          "leaving-30d": "ចាកចេញក្នុង 30 ថ្ងៃ",
          "asset-recovery": "ការប្រគល់ទ្រព្យសម្បត្តិ",
          "exit-pending": "បទសម្ភាសចេញរង់ចាំ",
          "final-pay-queue": "ការទូទាត់ចុងក្រោយរង់ចាំ",
          "turnover": "% ការផ្លាស់ប្ដូរស្ម័គ្រចិត្ត",
          "in-progress": "កំពុងដំណើរការ",
          "final-pay": "ប្រាក់ខែចុងក្រោយកំពុងរង់ចាំ",
          "exit-interviews": "បទសម្ភាសចេញ",
          "completed": "បានបញ្ចប់ (ឆ្នាំនេះ)"
        },
        "sub-tabs": {
          "overview": "ទិដ្ឋភាពទូទៅ",
          "center": "មជ្ឈមណ្ឌលចាកចេញ",
          "eligible": "សិទ្ធិចាកចេញ",
          "process": "ដំណើរការចាកចេញ",
          "templates": "គំរូ",
          "reports": "របាយការណ៍"
        },
        "dispatch": {
          "title": "ចាប់ផ្តើមការចាកចេញ",
          "lede": "បំពេញព័ត៌មានការចាកចេញ — វាចូលទៅមជ្ឈមណ្ឌលចាកចេញសម្រាប់ការពិនិត្យ។",
          "fields": {
            "employee": "បុគ្គលិក",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "notice": "ការគ្រប់គ្រងការជូនដំណឹង",
            "source": "ប្រភព"
          },
          "placeholders": {
            "employee": "ជ្រើសរើសបុគ្គលិក…",
            "reason": "ឧ. ផ្លាស់ទីលំនៅ, ការផ្តល់ជូនល្អជាង, កិច្ចសន្យាបញ្ចប់…",
            "source": "ជ្រើសរើសប្រភព…"
          },
          "notice-options": {
            "served": "បម្រើដំណឹងពេញលេញ",
            "garden": "ឈប់សំរាកមានប្រាក់ខែ",
            "buyout": "ទិញដំណឹង",
            "waived": "លើកលែងដំណឹង"
          },
          "errors": {
            "employee-required": "សូមជ្រើសរើសបុគ្គលិក",
            "reason-required": "តម្រូវឱ្យមានមូលហេតុ",
            "last-day-required": "តម្រូវឱ្យមានថ្ងៃធ្វើការចុងក្រោយ",
            "source-required": "តម្រូវឱ្យមានប្រភព"
          },
          "cancel": "បោះបង់",
          "submit": "បង្កើតព្រឹត្តិការណ៍",
          "created-toast": "បានបង្កើតព្រឹត្តិការណ៍ចាកចេញ · {employee} — បានចូលមជ្ឈមណ្ឌលចាកចេញ"
        },
        "overview": {
          "toolbar-btn": "មជ្ឈមណ្ឌលចាកចេញ",
          "kpi": {
            "intake": "ថ្មី និងកំពុងពិនិត្យ",
            "intake-sub": "ការទទួលត្រូវវាយតម្លៃ",
            "eligible": "មានសិទ្ធិចាប់ផ្តើម",
            "eligible-sub": "រួចរាល់ចេញពីការងារ",
            "in-progress": "ចេញពីការងារកំពុងដំណើរការ",
            "in-progress-sub": "កំពុងអនុវត្ត",
            "overdue": "សកម្មភាពហួសកាល",
            "overdue-sub": "ករណីត្រូវការការចាប់អារម្មណ៍"
          },
          "upcoming": {
            "title": "ថ្ងៃធ្វើការចុងក្រោយខាងមុខ",
            "empty": "គ្មានកាលវិភាគ។",
            "cols": {
              "employee": "បុគ្គលិក",
              "leaving-reason": "មូលហេតុចាកចេញ",
              "last-working-day": "ថ្ងៃធ្វើការចុងក្រោយ",
              "current-stage": "ដំណាក់កាលបច្ចុប្បន្ន",
              "attention-required": "ត្រូវការការចាប់អារម្មណ៍"
            }
          },
          "recent": {
            "title": "សកម្មភាពថ្មីៗ",
            "empty": "គ្មានសកម្មភាពថ្មីៗ។"
          }
        },
        "center": {
          "search-placeholder": "ស្វែងរកអ្នកចាកចេញ…",
          "chips": {
            "all": "ទាំងអស់",
            "new": "ថ្មី",
            "under_review": "កំពុងពិនិត្យ",
            "eligible": "មានសិទ្ធិ",
            "in_progress": "កំពុងដំណើរការ",
            "completed": "បានបញ្ចប់",
            "cancelled": "បានបោះបង់"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃចុងក្រោយ",
            "progress": "វឌ្ឍនភាព",
            "owner": "ម្ចាស់",
            "status": "ស្ថានភាព",
            "action": "សកម្មភាព"
          },
          "actions": {
            "review": "ពិនិត្យ",
            "eligible": "សម្គាល់មានសិទ្ធិ",
            "start": "ចាប់ផ្តើម",
            "open": "បើក",
            "view": "មើល"
          },
          "action-toasts": {
            "review": "បានផ្លាស់ប្តូរ {employee} ទៅកំពុងពិនិត្យ",
            "eligible": "បានសម្គាល់ {employee} ថាមានសិទ្ធិ",
            "start": "បានចាប់ផ្តើមការចេញពីការងារ · {employee}",
            "open": "កំពុងបើកករណីរបស់ {employee}",
            "view": "កំពុងមើលករណីរបស់ {employee}"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ព្រឹត្តិការណ៍",
          "empty": {
            "title": "មិនមានព្រឹត្តិការណ៍ត្រូវនឹងតម្រង",
            "lede": "សម្អាតតម្រង ឬពង្រីកការស្វែងរក។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "client": "អតិថិជន",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "notice-date": "ថ្ងៃជូនដំណឹង",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "owner": "ម្ចាស់",
            "progress": "វឌ្ឍនភាព",
            "status": "ស្ថានភាព",
            "notes": "កំណត់ចំណាំ",
            "attention": "ត្រូវការចាប់អារម្មណ៍"
          }
        },
        "eligible": {
          "search-placeholder": "ស្វែងរក…",
          "chips": {
            "all": "ទាំងអស់",
            "voluntary": "ស្ម័គ្រចិត្ត",
            "involuntary": "មិនស្ម័គ្រចិត្ត",
            "due-soon": "ថ្ងៃចុងក្រោយ ≤ 14 ថ្ងៃ"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "eligible-since": "មានសិទ្ធិតាំងពី",
            "action": "សកម្មភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "empty": {
            "title": "មិនមាននរណាមានសិទ្ធិ",
            "lede": "ព្រឹត្តិការណ៍ក្លាយជាមានសិទ្ធិបន្ទាប់ពីការពិនិត្យ។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "client": "អតិថិជន",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "eligible-since": "មានសិទ្ធិតាំងពី",
            "owner": "ម្ចាស់",
            "notes": "កំណត់ចំណាំ"
          },
          "start-button": "ចាប់ផ្តើម",
          "started-toast": "បានចាប់ផ្តើមការចេញពីការងារ · {employee} — បានផ្លាស់ប្តូរទៅកំពុងដំណើរការ",
          "in-days": "ក្នុង {n} ថ្ងៃ",
          "today": "ថ្ងៃនេះ",
          "days-ago": "{n} ថ្ងៃមុន"
        },
        "process": {
          "search-placeholder": "ស្វែងរកករណី…",
          "chips": {
            "all": "ទាំងអស់",
            "active": "កំពុងដំណើរការ",
            "completed": "បានបញ្ចប់",
            "needs-attention": "ត្រូវការចាប់អារម្មណ៍"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "source": "ប្រភព",
            "last-day": "ថ្ងៃចុងក្រោយ",
            "progress": "វឌ្ឍនភាព",
            "owner": "ម្ចាស់",
            "attention": "ការចាប់អារម្មណ៍",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ករណី",
          "empty": {
            "title": "មិនមានករណី",
            "lede": "ចាប់ផ្តើមមួយពីសិទ្ធិចាកចេញ។"
          },
          "drawer": {
            "role": "តួនាទី",
            "dept": "នាយកដ្ឋាន",
            "client": "អតិថិជន",
            "source": "ប្រភព",
            "reason": "មូលហេតុ",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "owner": "ម្ចាស់",
            "progress": "វឌ្ឍនភាព",
            "status": "ស្ថានភាព",
            "attention": "ការចាប់អារម្មណ៍",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "templates": {
          "search-placeholder": "ស្វែងរកគំរូ…",
          "chips": {
            "all": "ទាំងអស់",
            "active": "សកម្ម",
            "inactive": "មិនសកម្ម",
            "direct": "ផ្ទាល់",
            "outsourced": "ការខ្ចីក្រៅ"
          },
          "cols": {
            "name": "គំរូ",
            "workforce": "កម្លាំងពលកម្ម",
            "role-type": "ប្រភេទតួនាទី",
            "handover": "ប្រគល់",
            "clearance": "ការអនុញ្ញាត",
            "lastday": "ថ្ងៃចុងក្រោយ",
            "exit": "បទសម្ភាស",
            "last-used": "ប្រើចុងក្រោយ",
            "usage": "ការប្រើប្រាស់",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} គំរូ",
          "empty": {
            "title": "មិនមានគំរូ",
            "lede": "សម្អាតតម្រង។"
          },
          "exit-required": "តម្រូវ",
          "exit-optional": "ស្រេចចិត្ត",
          "drawer": {
            "name": "ឈ្មោះគំរូ",
            "workforce": "កម្លាំងពលកម្ម",
            "role-type": "ប្រភេទតួនាទី",
            "handover": "ធាតុប្រគល់",
            "clearance": "ធាតុការអនុញ្ញាត",
            "lastday": "ធាតុថ្ងៃចុងក្រោយ",
            "exit": "បទសម្ភាសចេញ",
            "last-used": "ប្រើចុងក្រោយ",
            "usage": "ចំនួនប្រើ",
            "status": "ស្ថានភាព"
          }
        },
        "assets": {
          "search-placeholder": "ស្វែងរកទ្រព្យ…",
          "title": "ការប្រគល់ទ្រព្យសម្បត្តិ",
          "lede": "តាមដានកុំព្យូទ័រយួរដៃ ទូរស័ព្ទ កាតចូល និងឯកសណ្ឋាន ដែលត្រូវប្រគល់មកវិញ។",
          "chips": {
            "all": "ទាំងអស់",
            "pending": "រង់ចាំ",
            "received": "បានទទួល",
            "damaged": "ខូច",
            "lost": "បាត់"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "item": "របស់",
            "serial": "លេខស៊េរី",
            "condition": "ស្ថានភាព",
            "status": "ស្ថានភាព",
            "due": "ថ្ងៃកំណត់",
            "received-by": "ទទួលដោយ"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} ទ្រព្យ",
          "empty": {
            "title": "មិនមានទ្រព្យ",
            "lede": "សម្អាតតម្រង។"
          },
          "drawer": {
            "employee": "បុគ្គលិក",
            "item": "របស់",
            "serial": "លេខស៊េរី",
            "condition": "ស្ថានភាព",
            "status": "ស្ថានភាព",
            "due": "ថ្ងៃកំណត់",
            "received-by": "ទទួលដោយ",
            "notes": "កំណត់ចំណាំ"
          },
          "condition": {
            "new": "ថ្មី",
            "good": "ល្អ",
            "fair": "ធម្មតា",
            "damaged": "ខូច",
            "unknown": "មិនច្បាស់"
          }
        },
        "settlement": {
          "search-placeholder": "ស្វែងរក…",
          "title": "ការទូទាត់ចុងក្រោយ",
          "lede": "ការគណនាប្រាក់ខែចុងក្រោយ — មូលដ្ឋាន ឈប់សំរាកគួរ ថ្ងៃមិនបង់ ប្រាក់សំណង កាត់កង។",
          "chips": {
            "all": "ទាំងអស់",
            "not_created": "មិនបានបង្កើត",
            "created": "ព្រាង",
            "processing": "កំពុងដំណើរការ",
            "paid": "បានបង់",
            "disputed": "ជម្លោះ"
          },
          "cols": {
            "employee": "បុគ្គលិក",
            "last-day": "ថ្ងៃចុងក្រោយ",
            "base": "ប្រាក់ខែមូលដ្ឋាន",
            "accrued": "ឈប់សំរាកគួរ",
            "unpaid": "ថ្ងៃមិនបង់",
            "severance": "ប្រាក់សំណង",
            "deductions": "កាត់កង",
            "total": "សរុប",
            "status": "ស្ថានភាព"
          },
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "empty": {
            "title": "មិនមាន",
            "lede": "សម្អាតតម្រង។"
          },
          "drawer": {
            "employee": "បុគ្គលិក",
            "last-day": "ថ្ងៃធ្វើការចុងក្រោយ",
            "base": "ប្រាក់ខែមូលដ្ឋាន",
            "accrued": "ឈប់សំរាកគួរ",
            "unpaid": "ថ្ងៃមិនបង់",
            "severance": "ប្រាក់សំណង",
            "deductions": "កាត់កង",
            "total": "សរុប",
            "currency": "រូបិយប័ណ្ណ",
            "prepared-by": "រៀបចំដោយ",
            "status": "ស្ថានភាព",
            "notes": "កំណត់ចំណាំ"
          }
        },
        "source": {
          "ess_resignation": "លាលែងតាម ESS",
          "contract_end": "កិច្ចសន្យាបញ្ចប់",
          "probation_fail": "សាកល្បងបរាជ័យ",
          "retirement": "ចូលនិវត្តន៍",
          "termination": "បញ្ឈប់",
          "death": "ស្លាប់ក្នុងពេលធ្វើការ"
        },
        "status": {
          "new": "ថ្មី",
          "under_review": "កំពុងពិនិត្យ",
          "eligible": "មានសិទ្ធិ",
          "in_progress": "កំពុងដំណើរការ",
          "completed": "បានបញ្ចប់",
          "cancelled": "បានបោះបង់"
        },
        "final-pay": {
          "not_created": "មិនបានបង្កើត",
          "created": "ព្រាង",
          "processing": "កំពុងដំណើរការ",
          "paid": "បានបង់",
          "disputed": "ជម្លោះ"
        },
        "reports": {
          "title": "របាយការណ៍",
          "lede": "ការវិភាគការផ្លាស់ប្ដូរ — តាមមូលហេតុ ប្រភព រយៈពេលធ្វើការ នាយកដ្ឋាន ស្ម័គ្រចិត្ត vs មិនស្ម័គ្រចិត្ត។",
          "kpi": {
            "total": "ព្រឹត្តិការណ៍សរុប",
            "voluntary": "ស្ម័គ្រចិត្ត",
            "involuntary": "មិនស្ម័គ្រចិត្ត",
            "turnover": "% ផ្លាស់ប្តូរ",
            "rehire": "មានសិទ្ធិជួលឡើងវិញ",
            "clearance-sla": "SLA ការអនុញ្ញាត",
            "final-pay-sla": "SLA ប្រាក់ខែចុងក្រោយ"
          },
          "by-source": "តាមប្រភព",
          "by-reason": "តាមមូលហេតុ",
          "by-tenure": "តាមរយៈពេលធ្វើការ",
          "by-dept": "តាមនាយកដ្ឋាន",
          "voluntary-split": "ស្ម័គ្រចិត្ត vs មិនស្ម័គ្រចិត្ត"
        },
        "stub": {
          "title": "ការចាកចេញពីការងារ",
          "lede": "ការអនុវត្តលាលែងប្រតិបត្តិការជាមួយការតាមដាន workstream (លាលែង · លក្ខខណ្ឌ · ប្រាក់ខែចុងក្រោយ · បទសម្ភាស)។"
        }
      },
      "compliance": {
        "title": "ការអនុលោម",
        "subtitle": "ការអនុលោមតាមច្បាប់និងប្រតិបត្តិការកម្ពុជា · ថ្នាក់ទី១ កាលកំណត់រឹង (MOL, បសស, ពន្ធ) និងថ្នាក់ទី២ ការដាក់ស្នើប្រតិបត្តិការ ជាមួយផ្លូវដានសវនកម្មក្នុងប្រភេទនីមួយៗ។",
        "info-banner": {
          "title": "វិសាលភាពនៃការអនុលោម",
          "body": "តាមដាន​កាតព្វកិច្ច​និយោជក​គ្រប់​យ៉ាង​ដែល​ច្បាប់​កម្ពុជា​បង្គាប់ — ការប្រកាស MOL, វិភាគទាន បសស និងពន្ធលើប្រាក់ខែ, លិខិតការងារ និងទិដ្ឋាការបុគ្គលិកបរទេស, កូតាបុគ្គលិកបរទេស, ការត្រួតពិនិត្យសុខភាព, បទបញ្ជាការងារផ្ទៃក្នុង, សៀវភៅពលកម្ម, សុវត្ថិភាពអគ្គីភ័យ និងសំណងបុគ្គលិក។ កាលកំណត់អាចកំណត់រចនាសម្ព័ន្ធបានដោយអ្នកជួលនៅក្នុង Compliance Settings។"
        },
        "scores": {
          "healthy": "ល្អ",
          "attention": "ត្រូវការការយកចិត្តទុកដាក់",
          "critical": "សំខាន់"
        },
        "kpi": {
          "score": "ពិន្ទុការអនុលោម",
          "score-sub": "នៅទូទាំង {cats} ប្រភេទ · {items} ធាតុដែលត្រូវបានតាមដាន",
          "overdue-expiring": "ហួសកាលកំណត់ / ជិតផុតកំណត់",
          "overdue-expiring-sub": "{overdue} ហួសកាលកំណត់ · {expiring} ជិតផុតកំណត់",
          "pending-action": "សកម្មភាពរង់ចាំ",
          "pending-action-clear": "ល្អប្រសើរទាំងអស់",
          "pending-action-open": "ការប្រកាស និងការដាក់ស្នើដែលបើក"
        },
        "sidebar": {
          "overview": "ទិដ្ឋភាពទូទៅ",
          "tier1": "ថ្នាក់ទី១ — កាលកំណត់រឹង",
          "tier2": "ថ្នាក់ទី២ — ប្រតិបត្តិការ",
          "settings": "ការកំណត់"
        },
        "categories": {
          "mol-decl": {
            "label": "ការប្រកាស MOL",
            "description": "ការប្រកាសបុគ្គលិកថ្មី និងការបញ្ឈប់ទៅក្រសួងការងារ។ កាលកំណត់លំនាំដើម ១៥ ថ្ងៃធ្វើការ។"
          },
          "nssf": {
            "label": "វិភាគទាន បសស",
            "description": "វិភាគទានសន្តិសុខសង្គមប្រចាំខែ។ លំនាំដើមត្រូវដាក់ស្នើនៅថ្ងៃទី ១៥ នៃខែបន្ទាប់។"
          },
          "tax": {
            "label": "ពន្ធលើប្រាក់ខែ (TOS)",
            "description": "ការប្រកាសពន្ធលើប្រាក់ខែប្រចាំខែទៅអគ្គនាយកដ្ឋានពន្ធដារ។ លំនាំដើមត្រូវដាក់ស្នើនៅថ្ងៃទី ២០។"
          },
          "work-permit": {
            "label": "លិខិតការងារ",
            "description": "លិខិតការងារប្រចាំឆ្នាំសម្រាប់បុគ្គលិកបរទេស។ ការព្រមានបន្តលិខិត ៦០ ថ្ងៃមុនពេលផុតកំណត់។"
          },
          "visa": {
            "label": "ការបន្តទិដ្ឋាការ (Business E)",
            "description": "ការបន្តទិដ្ឋាការ Business E ប្រចាំឆ្នាំសម្រាប់បុគ្គលិកបរទេស។"
          },
          "quota": {
            "label": "កូតាបុគ្គលិកបរទេស",
            "description": "ការដាក់ពាក្យកូតាប្រចាំឆ្នាំសម្រាប់បុគ្គលិកបរទេស។ កម្រិត៖ បរទេស ≤ ១០% នៃសរុប (អាចកំណត់រចនាសម្ព័ន្ធបាន)។"
          },
          "health": {
            "label": "ការត្រួតពិនិត្យសុខភាព",
            "description": "ការត្រួតពិនិត្យសុខភាពជាកាតព្វកិច្ចប្រចាំឆ្នាំ។ តាមដានតាមបុគ្គលិក។"
          },
          "iwr": {
            "label": "បទបញ្ជាការងារផ្ទៃក្នុង",
            "description": "ត្រូវការសម្រាប់ក្រុមហ៊ុនដែលមានបុគ្គលិក ≥ ៨ នាក់។ ដាក់ស្នើទៅ MOL នៅពេលផ្លាស់ប្តូរគោលនយោបាយ។"
          },
          "labour-book": {
            "label": "សៀវភៅពលកម្ម",
            "description": "បញ្ជីបុគ្គលិក និងកំណត់ហេតុម៉ោងធ្វើការ។ មាននាំចេញប្រចាំខែសម្រាប់ការត្រួតពិនិត្យរបស់ MOL។"
          },
          "fire-safety": {
            "label": "វិញ្ញាបនបត្រសុវត្ថិភាពអគ្គីភ័យ",
            "description": "ការត្រួតពិនិត្យ និងវិញ្ញាបនបត្រសុវត្ថិភាពអគ្គីភ័យកន្លែងធ្វើការ។ បន្តប្រចាំឆ្នាំ។"
          },
          "workmen-comp": {
            "label": "សំណងបុគ្គលិក",
            "description": "ការចុះឈ្មោះធានារ៉ាប់រងហានិភ័យការងារតាមរយៈ បសស។"
          }
        },
        "filters": {
          "all": "ទាំងអស់",
          "ok": "ល្អ",
          "pending": "កំពុងរង់ចាំ",
          "submitted": "បានដាក់ស្នើ",
          "approved": "បានអនុម័ត",
          "overdue": "ហួសកាលកំណត់",
          "expiring-soon": "ជិតផុតកំណត់"
        },
        "status": {
          "OK": "ល្អ",
          "Pending": "កំពុងរង់ចាំ",
          "Submitted": "បានដាក់ស្នើ",
          "Approved": "បានអនុម័ត",
          "Overdue": "ហួសកាលកំណត់",
          "Expiring Soon": "ជិតផុតកំណត់",
          "N/A": "មិនពាក់ព័ន្ធ"
        },
        "actions": {
          "clear-filters": "សម្អាតការច្រោះ",
          "view": "មើល",
          "action": "សកម្មភាព →",
          "new-item": "ធាតុថ្មី"
        },
        "search-placeholder": "ស្វែងរក​លេខ​សម្គាល់ ប្រធានបទ រយៈពេល ព័ត៌មាន​លម្អិត…",
        "days": {
          "overdue": "ហួសកាលកំណត់ {n} ថ្ងៃ",
          "today": "ថ្ងៃនេះ",
          "in": "ក្នុង {n} ថ្ងៃ"
        },
        "action-items": {
          "title": "ធាតុ​សកម្មភាព",
          "lede": "តម្រៀបតាមភាពបន្ទាន់។ ចុចលើជួរណាមួយដើម្បីបើកប្រភេទរបស់វា។",
          "count": "{n} ធាតុ​ត្រូវការ​សកម្មភាព",
          "empty": "គ្មាន​ធាតុ​បន្ទាន់ — អ្នក​ល្អ​ប្រសើរ​ហើយ ✓"
        },
        "grid": {
          "all-categories": "ប្រភេទ​ទាំងអស់",
          "click-hint": "ចុចលើ​កាត​ណាមួយ​ដើម្បី​ស្វែងយល់​បន្ថែម",
          "healthy": "{n}% ល្អ",
          "items": "{n} ធាតុ",
          "overdue": "{n} ហួស​កាល​កំណត់"
        },
        "detail": {
          "authority": "អាជ្ញាធរ",
          "cadence": "ការ​កើត​ឡើង",
          "tier": "ថ្នាក់",
          "tier-1": "១ (កាល​កំណត់​រឹង)",
          "tier-2": "២ (ប្រតិបត្តិការ)",
          "score": "ពិន្ទុ",
          "settings": "ការ​កំណត់",
          "config-footnote": "តម្លៃ​លំនាំ​ដើម​ខាង​លើ​អាច​កំណត់​រចនា​សម្ព័ន្ធ​បាន​ដោយ​អ្នក​ជួល​នៅ Compliance Settings — ឧ. កាល​កំណត់​ប្រកាស MOL {mol} ថ្ងៃ​ធ្វើ​ការ (ការ​ជួល), បសស ថ្ងៃ​ទី {nssf}, TOS ថ្ងៃ​ទី {tax}។"
        },
        "table": {
          "tracked": "ធាតុ​ដែល​ត្រូវ​បាន​តាមដាន ({n})",
          "overdue": "{n} ហួស​កាល​កំណត់",
          "pending": "{n} កំពុង​រង់ចាំ",
          "expiring": "{n} ជិត​ផុត​កំណត់",
          "col": {
            "id": "លេខ​សម្គាល់",
            "subject": "ប្រធានបទ / ព័ត៌មាន​លម្អិត",
            "due": "កំណត់",
            "days": "ថ្ងៃ",
            "status": "ស្ថានភាព",
            "action": "សកម្មភាព"
          }
        },
        "quota": {
          "title": "សមាមាត្រ​បុគ្គលិក​បរទេស​បច្ចុប្បន្ន",
          "within": "ស្ថិត​ក្នុង​កម្រិត MOL {cap}%",
          "over": "លើស​កម្រិត MOL {cap}%"
        },
        "foreign": {
          "title": "បុគ្គលិក​បរទេស​មាន​នៅ​ក្នុង​បញ្ជី ({n})",
          "col": {
            "code": "លេខ​សម្គាល់",
            "name": "ឈ្មោះ",
            "nationality": "សញ្ជាតិ",
            "position": "មុខ​តំណែង",
            "joined": "ចូល​ធ្វើ​ការ"
          }
        },
        "empty": {
          "title": "គ្មាន​លទ្ធផល",
          "lede": "គ្មាន​ធាតុ​ត្រូវ​នឹង​តម្រង​ទាំង​នេះ​ទេ។ សាកល្បង​សម្អាត​មួយ​ដើម្បី​ពង្រីក​ការ​ស្វែងរក។"
        },
        "drawer": {
          "fields": {
            "due": "កំណត់",
            "days": "ថ្ងៃ​នៅ​សល់",
            "employee": "បុគ្គលិក",
            "details": "ព័ត៌មាន​លម្អិត",
            "audit": "ផ្លូវ​ដាន​សវនកម្ម"
          },
          "no-audit": "មិនទាន់​មាន​ព្រឹត្តិការណ៍​សវនកម្ម​ត្រូវ​បាន​កត់ត្រា​ទេ។"
        },
        "settings-placeholder": "Compliance Settings — កន្លែង​បម្រុង · តម្លៃ​លំនាំ​ដើម​អាច​កែ​បាន​នឹង​មក​ដល់​ជាមួយ​នឹង​ការ​សាងសង់ Settings"
      },
      "directory": {
        "subtitle": "មិនមានបុគ្គលិក | {n} នាក់ | {n} នាក់",
        "subtitle-empty": "រកមិនឃើញបុគ្គលិក",
        "add-person-cta": "បន្ថែមបុគ្គល",
        "add-person": {
          "wizard": {
            "title": {
              "employee": "បន្ថែមបុគ្គល",
              "outsourced": "បន្ថែមបុគ្គលិកជ្រើសរើសខាងក្រៅ",
              "vendor-lite": "បន្ថែមកំណត់ត្រា Vendor-lite",
              "external": "អញ្ជើញអ្នកអនុម័តពីខាងក្រៅ"
            },
            "subtitle": {
              "employee": "បុគ្គលិកផ្ទាល់ក្នុងប្រាក់ខែរបស់ក្រុមហ៊ុនអ្នក — កំណត់ត្រា HR កាលវិភាគ និងកិច្ចសន្យា។",
              "outsourced": "បុគ្គលិកដែលស្ថិតក្រោមភតិកៈនេះ ហើយត្រូវបានចាត់ឱ្យទៅគម្រោង / ទីតាំងរបស់អតិថិជន។",
              "vendor-lite": "តាមដានបុគ្គលិកដែលផ្គត់ផ្គង់ដោយក្រុមហ៊ុនផ្តល់សេវា — គ្មានប្រាក់ខែនៅខាងយើង។",
              "external": "សិទ្ធិមានកំណត់ — អនុម័តសំណើតែសម្រាប់បុគ្គលិកក្នុងគម្រោងមួយប៉ុណ្ណោះ។"
            },
            "kind": {
              "label": "ប្រភេទបុគ្គល",
              "employee": "បុគ្គលិកផ្ទាល់",
              "outsourced": "ជ្រើសរើសខាងក្រៅ (យើងគ្រប់គ្រងប្រាក់ខែ)",
              "vendor-lite": "Vendor-lite (ក្រុមហ៊ុនផ្តល់សេវាគ្រប់គ្រងប្រាក់ខែ)",
              "external": "អ្នកអនុម័តពីខាងក្រៅ"
            },
            "offer": {
              "title": "ចាប់ផ្តើមពីលិខិតផ្តល់ការងារ",
              "body": "ទាញទិន្នន័យពីលិខិតផ្តល់ការងារដែលចុះហត្ថលេខា — កាត់បន្ថយកំហុស និងការសរសេរម្តងទៀត។ ផ្ទាំងលិខិតផ្តល់ការងារនឹងមកជាមួយម៉ូឌុលជ្រើសរើស។",
              "cta": "មើលលិខិតផ្តល់",
              "coming-soon": "ឧបករណ៍ជ្រើសលិខិតផ្តល់ការងារ — នឹងមកជាមួយម៉ូឌុលជ្រើសរើស។"
            },
            "stepper": {
              "aria": "ដំណើរការនៃជំនួយការបន្ថែមបុគ្គល"
            },
            "steps": {
              "person": "បុគ្គល",
              "schedule": "កាលវិភាគ",
              "contract": "កិច្ចសន្យា",
              "leave": "ច្បាប់ឈប់សម្រាក",
              "project-access": "សិទ្ធិគម្រោង",
              "vendor": "ក្រុមហ៊ុនផ្តល់សេវា",
              "review": "ពិនិត្យឡើងវិញ"
            },
            "person": {
              "heading": "ព័ត៌មានបុគ្គល",
              "code": "លេខកូដបុគ្គលិក",
              "code-hint": "បង្កើតដោយស្វ័យប្រវត្តិតាមទម្រង់របស់ក្រុមហ៊ុន — អាចកែប្រែបាន",
              "code-hint-external": "លេខកូដបុគ្គលិកអតិថិជន — បង្កើតស្វ័យប្រវត្តិសម្រាប់ការយោងឆ្លងភាគី។",
              "name-latin": "ឈ្មោះពេញ (ឡាតាំង)",
              "name-latin-placeholder": "ឧ. Sok Pisey",
              "name-khmer": "ឈ្មោះពេញ (ខ្មែរ)",
              "gender": {
                "label": "ភេទ",
                "female": "ស្រី",
                "male": "ប្រុស",
                "other": "ផ្សេងទៀត",
                "placeholder": "ជ្រើសរើសភេទ"
              },
              "dob": "ថ្ងៃខែឆ្នាំកំណើត",
              "nid": "អត្តសញ្ញាណប័ណ្ណ",
              "nid-placeholder": "ឧ. 012345678",
              "title-at-client": "តួនាទីនៅអតិថិជន",
              "title-placeholder": "ឧ. អ្នកត្រួតពិនិត្យតំបន់",
              "email": "អ៊ីមែលការងារ",
              "email-placeholder": "you\\@company.com",
              "email-client": "អ៊ីមែលអតិថិជន",
              "email-client-placeholder": "approver\\@client.com",
              "phone": "លេខទូរស័ព្ទ",
              "vendor-lite-badge": "ការគ្រប់គ្រង Vendor-lite",
              "vendor-lite-help": "យើងនឹងមិនរក្សាទុកលេខអត្តសញ្ញាណច្បាប់ ឬប្រាក់ខែសម្រាប់បុគ្គលនេះទេ — ក្រុមហ៊ុនផ្តល់សេវាជាអ្នកគ្រប់គ្រងកំណត់ត្រាទាំងនោះ។",
              "help-employee": "បុគ្គលិកផ្ទាល់លេចឡើងគ្រប់ទីកន្លែង — បញ្ជី ប្រាក់ខែ ច្បាប់ឈប់សម្រាក ពេលវេលា និងវត្តមាន។",
              "help-outsourced": "បុគ្គលិកជ្រើសរើសខាងក្រៅលេចឡើងនៅក្នុងបញ្ជី និងផ្ទាំងជ្រើសរើសខាងក្រៅ។ ប្រាក់ខែ និងសិទ្ធិច្បាប់រដ្ឋដំណើរការដូចបុគ្គលិកផ្ទាល់។",
              "help-external": "អ្នកអនុម័តពីខាងក្រៅអាចមើល និងអនុម័តសំណើបានតែសម្រាប់បុគ្គលិកនៅគម្រោងដែលអ្នកកំណត់នៅជំហានបន្ទាប់ប៉ុណ្ណោះ។",
              "code-hint-loading": "កំពុងផ្ទុកលេខកូដបន្ទាប់តាមទម្រង់របស់ក្រុមហ៊ុន…",
              "code-hint-error": "មិនអាចផ្ទុកលេខកូដបន្ទាប់បានទេ — សូមបញ្ចូលលេខកូដ ឬព្យាយាមម្តងទៀត។",
              "code-hint-no-format": "ក្រុមហ៊ុននេះមិនដាក់លេខបុគ្គលិកដោយស្វ័យប្រវត្តិទេ — សូមបញ្ចូលលេខកូដ",
              "code-loading-placeholder": "កំពុងផ្ទុក…",
              "code-retry": "ព្យាយាមម្តងទៀត",
              "family-latin": "នាមត្រកូល (ឡាតាំង)",
              "family-latin-placeholder": "ឧ. Touch",
              "given-latin": "នាមខ្លួន (ឡាតាំង)",
              "given-latin-placeholder": "ឧ. Phally",
              "family-khmer": "ឈ្មោះខ្មែរ — នាមត្រកូល",
              "given-khmer": "ឈ្មោះខ្មែរ — នាមខ្លួន",
              "dob-hint": "YYYY-MM-DD · មិនបាច់បំពេញក៏បាន",
              "provider-badge": "បុគ្គលិកគ្រប់គ្រងដោយអ្នកផ្តល់សេវា",
              "provider-badge-help": "ភតិកៈនេះគ្រប់គ្រងប្រវត្តិរូប HR និងប្រាក់ខែ · អាចអញ្ជើញអ្នកអនុម័តរបស់អតិថិជនដាច់ដោយឡែក",
              "next-steps": "បន្ទាប់មកគឺ កាលវិភាគ កិច្ចសន្យា ច្បាប់ឈប់សម្រាក និងការពិនិត្យ។ ថ្ងៃខែឆ្នាំកំណើត អត្តសញ្ញាណប័ណ្ណ និងអ៊ីមែល មិនបាច់បំពេញក៏បាន។"
            },
            "schedule": {
              "heading": "កំណត់កាលវិភាគការងារ",
              "template": "គំរូកាលវិភាគ",
              "template-hint": "កំណត់ពេលវេលាចូលធ្វើការ ម៉ោងប្រចាំសប្តាហ៍ និងសិទ្ធិធ្វើការបន្ថែមម៉ោង។",
              "placeholder": "ជ្រើសរើសគំរូកាលវិភាគ",
              "details": "ព័ត៌មានកាលវិភាគ",
              "type": "ប្រភេទ",
              "loading": "កំពុងផ្ទុកកាលវិភាគ…",
              "error": "មិនអាចផ្ទុកកាលវិភាគបានទេ។",
              "retry": "ព្យាយាមម្ដងទៀត",
              "empty": "មិនទាន់មានកាលវិភាគការងារសម្រាប់ក្រុមហ៊ុននេះទេ។",
              "type-label": "ប្រភេទកាលវិភាគ",
              "kind": {
                "fixed": "ថេរ",
                "rotation": "វេនបង្វិល"
              },
              "templates-count": "គំរូ {n} | គំរូ {n} | គំរូ {n}",
              "type-hint": "ជ្រើសរើសប្រភេទម៉ោងធ្វើការជាមុនសិន — វេនបង្វិលដាក់បុគ្គលនេះក្នុងតារាងវេនបង្វិល។",
              "manage": "គ្រប់គ្រងនៅក្នុងការរៀបចំកាលវិភាគ →",
              "empty-kind": "មិនទាន់មានគំរូ {kind} នៅឡើយទេ។ សូមបង្កើតនៅ HR Ops › ការរៀបចំកាលវិភាគ ហើយកំណត់វានៅទីនេះ។",
              "optional-hint": "មិនបាច់ជ្រើសក៏បាន — ទុកឱ្យនៅទំនេរដើម្បីកំណត់នៅពេលក្រោយ។",
              "placeholder-kind": "— ជ្រើសរើសកាលវិភាគ {kind} —",
              "assign-later": "កំណត់នៅពេលក្រោយ",
              "pattern": "លំនាំវេនបង្វិល",
              "cycle": "វដ្ត",
              "cycle-days": "{n} ថ្ងៃ | {n} ថ្ងៃ | {n} ថ្ងៃ",
              "rotation-note": "ថ្ងៃធ្វើការបានមកពីតារាងវេនបង្វិល (HR Ops › ការរៀបចំកាលវិភាគ)។ បុគ្គលនេះចូលក្នុងវេនបង្វិលចាប់ពីថ្ងៃចាប់ផ្តើមការងារ។",
              "working-days": "ថ្ងៃធ្វើការប្រចាំសប្តាហ៍",
              "weekly-hours": "សរុប៖ {h} ម៉ោង/សប្តាហ៍។",
              "days": {
                "mon": "ច័ន្ទ",
                "tue": "អង្គារ",
                "wed": "ពុធ",
                "thu": "ព្រហស្បតិ៍",
                "fri": "សុក្រ",
                "sat": "សៅរ៍",
                "sun": "អាទិត្យ"
              }
            },
            "contract": {
              "heading": "កិច្ចសន្យា",
              "type": "ប្រភេទកិច្ចសន្យា",
              "vacancy": "មុខតំណែងទំនេរ",
              "vacancy-hint": "ការជួលផ្អែកលើមុខតំណែង — ជ្រើសរើសពីបញ្ជីសំណើរបើកចំហ។ មុខតំណែងថ្មីត្រូវបើកតាមរយៈផែនការកម្លាំងការងារ។",
              "vacancy-placeholder": "ជ្រើសរើសមុខតំណែងទំនេរ",
              "start-date": "ថ្ងៃចាប់ផ្តើម",
              "end-date": "ថ្ងៃបញ្ចប់",
              "with-probation": "រួមបញ្ចូលរយៈពេលសាកល្បង",
              "probation-end-date": "ថ្ងៃបញ្ចប់សាកល្បង",
              "vacancy-loading": "កំពុងផ្ទុកមុខតំណែងទំនេរ…",
              "vacancy-error": "មិនអាចផ្ទុកមុខតំណែងទំនេរបានទេ។",
              "vacancy-retry": "ព្យាយាមម្ដងទៀត",
              "vacancy-empty": "គ្មានមុខតំណែងទំនេរសម្រាប់ក្រុមហ៊ុននេះទេ។ សូមបើកមុខតំណែងនៅក្នុងផែនការកម្លាំងពលកម្មជាមុនសិន។",
              "types": {
                "udc": "UDC — កិច្ចសន្យាគ្មានថិរវេលាកំណត់",
                "fdc": "FDC — កិច្ចសន្យាមានថិរវេលាកំណត់",
                "probation": "កិច្ចសន្យាសាកល្បង",
                "internship": "កម្មសិក្សា"
              },
              "employment-type": "ប្រភេទការងារ",
              "employment-types": {
                "full-time": "ពេញម៉ោង",
                "part-time": "ក្រៅម៉ោង"
              },
              "mode": {
                "now": "បន្ថែមកិច្ចសន្យាឥឡូវនេះ",
                "now-help": "មុខតំណែង កាលបរិច្ឆេទ និងច្បាប់ឈប់សម្រាក — បុគ្គលនេះចាប់ផ្តើមតាមកិច្ចសន្យានេះ។",
                "later": "កត់ត្រាបុគ្គលជាមុនសិន",
                "later-help": "រំលងកិច្ចសន្យា និងច្បាប់ឈប់សម្រាកសិន — បុគ្គលនេះត្រូវបានរក្សាទុកជា «រង់ចាំ»។"
              },
              "date-hint": "YYYY-MM-DD"
            },
            "leave": {
              "heading": "ច្បាប់ឈប់សម្រាក",
              "policy": "ច្បាប់ឈប់សម្រាក",
              "policy-hint": "កំណត់សិទ្ធិឈប់សម្រាកប្រចាំឆ្នាំ + ឈឺ និងវដ្តគណនា។",
              "placeholder": "ជ្រើសរើសច្បាប់ឈប់សម្រាក",
              "vendor-title": "ក្រុមហ៊ុនផ្តល់សេវាជាអ្នកគ្រប់គ្រងសិទ្ធិឈប់សម្រាក",
              "vendor-body": "ច្បាប់ឈប់សម្រាកសម្រាប់កំណត់ត្រា Vendor-lite ត្រូវបានគ្រប់គ្រងដោយ {vendor}។ យើងគ្រាន់តែបង្ហាញសំណើឈប់សម្រាកប្រតិបត្តិការសម្រាប់ភាពច្បាស់លាស់នៅទីតាំង។",
              "vendor-fallback": "ក្រុមហ៊ុនផ្តល់សេវា",
              "company-title": "គោលការណ៍ឈប់សម្រាករបស់ក្រុមហ៊ុនត្រូវបានអនុវត្ត",
              "company-body": "បុគ្គលិកថ្មីនេះទទួលបានសិទ្ធិឈប់សម្រាក និងល្បឿនបង្គរតាមស្តង់ដាររបស់ក្រុមហ៊ុន។ ប្រើការកំណត់ខាងក្រោមតែសម្រាប់សិទ្ធិដែលបានចរចាជាលក្ខណៈបុគ្គលប៉ុណ្ណោះ។",
              "override-toggle": "កំណត់សិទ្ធិស្តង់ដារឡើងវិញសម្រាប់បុគ្គលិកនេះ",
              "override-annual": "ការឈប់សម្រាកប្រចាំឆ្នាំ (ថ្ងៃ/ឆ្នាំ)",
              "override-sick": "ការឈប់សម្រាកឈឺ (ថ្ងៃ/ឆ្នាំ)",
              "override-justification": "ហេតុផល",
              "override-justification-placeholder": "ហេតុអ្វីបានជាបុគ្គលិកនេះទទួលបានសិទ្ធិមិនស្តង់ដារ"
            },
            "project": {
              "heading": "សិទ្ធិគម្រោង",
              "project": "គម្រោង",
              "project-hint": "អ្នកអនុម័តពីខាងក្រៅអាចមើលសំណើបានតែសម្រាប់បុគ្គលិកដែលដាក់ឱ្យធ្វើការនៅគម្រោងនេះប៉ុណ្ណោះ។",
              "placeholder": "ជ្រើសរើសគម្រោង",
              "their-project": "គម្រោងរបស់ពួកគេ",
              "can-do-title": "អាចធ្វើបាន",
              "can-do-1": "អនុម័ត / បដិសេធសំណើច្បាប់ឈប់សម្រាក និងចំណាយសម្រាប់បុគ្គលិកនៅ {project}",
              "can-do-2": "មើលសេចក្តីសង្ខេបវត្តមានសម្រាប់គម្រោង",
              "can-do-3": "ទទួលបានការជូនដំណឹងសម្រាប់ការអនុម័តដែលរង់ចាំ",
              "cannot-do-title": "មិនអាចធ្វើបាន",
              "cannot-do-1": "មើលទិន្នន័យប្រាក់ខែ ប្រាក់បៀវត្ស ឬច្បាប់រដ្ឋ",
              "cannot-do-2": "កែសម្រួលកំណត់ត្រាបុគ្គលិក",
              "cannot-do-3": "ចូលប្រើគម្រោងផ្សេងទៀត ឬបញ្ជី"
            },
            "vendor": {
              "heading": "ក្រុមហ៊ុនផ្តល់សេវា",
              "name": "ឈ្មោះក្រុមហ៊ុនផ្តល់សេវា",
              "name-hint": "ប្រើនៅលើរបាយការណ៍វត្តមាន វិក្កយបត្រអ្នកផ្គត់ផ្គង់ និងផ្ទាំងជ្រើសរើសខាងក្រៅ។",
              "placeholder": "ឧ. ManpowerKH Co. Ltd.",
              "governance-title": "ការគ្រប់គ្រង Vendor-lite",
              "governance-body": "ក្រុមហ៊ុនផ្តល់សេវាទទួលខុសត្រូវចំពោះប្រាក់ខែ វិភាគទានច្បាប់រដ្ឋ និងសិទ្ធិឈប់សម្រាក។ យើងតាមដានបុគ្គលនេះតែខាងប្រតិបត្តិការប៉ុណ្ណោះ — គ្មានការគណនាប្រាក់ខែទាក់ទងនឹងពួកគេទេ។"
            },
            "review": {
              "heading": "ពិនិត្យ និងបង្កើត",
              "heading-external": "ពិនិត្យ និងអញ្ជើញ",
              "section-person": "បុគ្គល",
              "section-schedule": "កាលវិភាគ",
              "section-contract": "កិច្ចសន្យា",
              "section-leave": "ច្បាប់ឈប់សម្រាក",
              "section-vendor": "ក្រុមហ៊ុនផ្តល់សេវា",
              "section-project": "សិទ្ធិគម្រោង",
              "code": "លេខកូដ",
              "name": "ឈ្មោះ",
              "gender": "ភេទ",
              "dob": "ថ្ងៃខែឆ្នាំកំណើត",
              "nid": "អត្តសញ្ញាណប័ណ្ណ",
              "email": "អ៊ីមែល",
              "phone": "ទូរស័ព្ទ",
              "schedule": "កាលវិភាគ",
              "contract-type": "ប្រភេទកិច្ចសន្យា",
              "vacancy": "មុខតំណែងទំនេរ",
              "start-date": "ថ្ងៃចាប់ផ្តើម",
              "end-date": "ថ្ងៃបញ្ចប់",
              "leave-policy": "ច្បាប់ឈប់សម្រាក",
              "vendor": "ក្រុមហ៊ុនផ្តល់សេវា",
              "project": "គម្រោង",
              "edit": "កែសម្រួល",
              "footer": "ការចុចបង្កើតនឹងបញ្ចូលបុគ្គលនេះទៅក្នុងបញ្ជី និងបង្កើតភារកិច្ចបណ្តុះបណ្តាល។ អ្នកអាចកែសម្រួលព័ត៌មានពីទម្រង់ប្រវត្តិរូបក្រោយមកបាន។",
              "footer-external": "ការចុចអញ្ជើញនឹងផ្ញើតំណចូលដល់អ្នកអនុម័តតាមរយៈអ៊ីមែល។ ពួកគេមិនមើលឃើញប្រាក់ខែ ឬគម្រោងផ្សេងទៀតទេ។",
              "leave-company-default": "គោលការណ៍លំនាំដើមរបស់ក្រុមហ៊ុន",
              "leave-annual": "ការកំណត់ប្រចាំឆ្នាំ (ថ្ងៃ)",
              "leave-sick": "ការកំណត់ការឈឺ (ថ្ងៃ)",
              "name-khmer": "ឈ្មោះខ្មែរ",
              "employment-type": "ប្រភេទការងារ",
              "probation-end": "បញ្ចប់ការសាកល្បង",
              "schedule-later": "កំណត់នៅពេលក្រោយ",
              "problems-title": "មិនអាចរក្សាទុកបុគ្គលនេះបានទេ",
              "add-contract": "បន្ថែមកិច្ចសន្យា",
              "no-contract": "មិនទាន់មានកិច្ចសន្យា — បុគ្គលនេះត្រូវបានរក្សាទុកជា «រង់ចាំ»។ សូមបន្ថែមកិច្ចសន្យាពីប្រវត្តិរូបរបស់គាត់នៅពេលរួចរាល់។",
              "no-signin": "មិនបង្កើតគណនីចូលប្រើទេ។ សូមអញ្ជើញបុគ្គលនេះពី Admin › អ្នកប្រើប្រាស់ និងតួនាទី។"
            },
            "footer": {
              "cancel": "បោះបង់",
              "back": "ត្រឡប់ក្រោយ",
              "next": "រក្សាទុក និងបន្ត",
              "create-employee": "បង្កើតបុគ្គលិក",
              "create-vendor": "បង្កើតកំណត់ត្រា",
              "create-external": "ផ្ញើអញ្ជើញ",
              "step-of": "ជំហានទី {n} នៃ {total}"
            },
            "toast": {
              "created": "បានបង្កើតបុគ្គល។ បញ្ជីនឹងធ្វើបច្ចុប្បន្នភាពក្នុងពេលឆាប់ៗ។",
              "endpoint-pending": "ចំណុចបញ្ចប់បង្កើតបុគ្គលនៅកំពុងតភ្ជាប់នៅខាងក្រោយ។ ការបញ្ចូលរបស់អ្នកត្រូវបានរក្សាទុក — សូមព្យាយាមម្តងទៀតពេលក្រោយ។",
              "added": "បានបន្ថែម {name} · {code}",
              "added-no-code": "បានបន្ថែម {name}",
              "fix-fields": "ព័ត៌មានមួយចំនួនត្រូវការកែតម្រូវ — សូមមើលវាលដែលបានសម្គាល់។"
            },
            "errors": {
              "required": "ត្រូវតែបំពេញ",
              "code-required": "សូមបញ្ចូលលេខកូដបុគ្គលិក",
              "code-too-long": "ប្រើមិនលើសពី 30 តួអក្សរ",
              "code-colon": "លេខកូដមិនអាចមានសញ្ញាចុចពីរ (:) បានទេ",
              "email": "សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវ ឬទុកឱ្យនៅទំនេរ",
              "date": "សូមប្រើទម្រង់ YYYY-MM-DD",
              "dob-future": "ថ្ងៃខែឆ្នាំកំណើតមិនអាចនៅថ្ងៃអនាគតបានទេ",
              "start-too-early": "ថ្ងៃចាប់ផ្តើមត្រូវស្ថិតក្នុងរយៈពេល {days} ថ្ងៃមុនថ្ងៃនេះ",
              "end-required": "កិច្ចសន្យាមានថិរវេលាកំណត់ ត្រូវមានថ្ងៃបញ្ចប់",
              "end-before-start": "ថ្ងៃបញ្ចប់ត្រូវនៅក្រោយថ្ងៃចាប់ផ្តើម",
              "probation-range": "ថ្ងៃបញ្ចប់សាកល្បងត្រូវនៅចន្លោះថ្ងៃចាប់ផ្តើម និងថ្ងៃបញ្ចប់",
              "number": "សូមបញ្ចូលចំនួនថ្ងៃ (0 ឬច្រើនជាងនេះ)",
              "nid-taken": "អត្តសញ្ញាណប័ណ្ណនេះត្រូវបានប្រើដោយបុគ្គលម្នាក់ទៀតរួចហើយ",
              "code-taken": "លេខកូដនេះត្រូវបានប្រើក្នុងក្រុមហ៊ុននេះរួចហើយ",
              "seat-taken": "មុខតំណែងនេះលែងទំនេរហើយ — សូមជ្រើសរើសមុខតំណែងទំនេរផ្សេង",
              "server-field": "{message}",
              "retry": "មិនអាចភ្ជាប់ទៅម៉ាស៊ីនមេបានទេ។ ព័ត៌មានរបស់អ្នកនៅដដែល — សូមចុច «បង្កើតបុគ្គលិក» ម្តងទៀត។",
              "forbidden": "អ្នកមិនអាចបន្ថែមបុគ្គលិកទៅក្រុមហ៊ុននេះបានទេ។",
              "generic": "មិនអាចរក្សាទុកបុគ្គលនេះបានទេ។ សូមពិនិត្យព័ត៌មាន ហើយព្យាយាមម្តងទៀត។"
            }
          }
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "direct": "ផ្ទាល់",
          "outsourced": "ជួលពីខាងក្រៅ",
          "onboarding": "ចូលបំពេញការងារ",
          "probation": "កំពុងសាកល្បង",
          "pending": "រង់ចាំ",
          "on_leave": "ឈប់សម្រាក",
          "resigning": "លាលែង",
          "leaving": "ចាកចេញ",
          "inactive": "អសកម្ម",
          "client_staff": "បុគ្គលិកខាងក្រៅ"
        },
        "emp-type": {
          "label": "ប្រភេទ: ទាំងអស់",
          "all": "ប្រភេទ: ទាំងអស់",
          "Full-time": "ពេញម៉ោង",
          "Part-time": "ក្រៅម៉ោង",
          "not-set": "មិនទាន់កំណត់"
        },
        "contract": {
          "label": "កិច្ចសន្យា: ទាំងអស់",
          "all": "កិច្ចសន្យា: ទាំងអស់",
          "UDC": "UDC (រយៈពេលមិនកំណត់)",
          "FDC": "FDC (រយៈពេលកំណត់)",
          "PROBATION": "សាកល្បងការងារ",
          "INTERNSHIP": "កម្មសិក្សា",
          "OUTSOURCING_SERVICE": "សេវាផ្គត់ផ្គង់បុគ្គលិកខាងក្រៅ",
          "None": "គ្មានកិច្ចសន្យា",
          "Unknown": "មិនស្គាល់"
        },
        "search-placeholder": "ស្វែងរកឈ្មោះ លេខ អ៊ីមែល…",
        "columns": "ជួរឈរ",
        "export": "នាំចេញ",
        "import": "នាំចូល",
        "sort-by": "តម្រៀបតាម {column}",
        "table": {
          "employee": "បុគ្គលិក",
          "empCode": "លេខកូដបុគ្គលិក",
          "nameLatin": "ឈ្មោះពេញ (ឡាតាំង)",
          "nameKhmer": "ឈ្មោះពេញ (ខ្មែរ)",
          "gender": "ភេទ",
          "dob": "ថ្ងៃខែឆ្នាំកំណើត",
          "nid": "អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែន",
          "familyNameLatin": "ត្រកូល (ឡាតាំង)",
          "middleNameLatin": "ឈ្មោះកណ្តាល (ឡាតាំង)",
          "givenNameLatin": "នាមខ្លួន (ឡាតាំង)",
          "nicknameLatin": "ឈ្មោះហៅក្រៅ (ឡាតាំង)",
          "familyNameNative": "ត្រកូល (ខ្មែរ)",
          "middleNameNative": "ឈ្មោះកណ្តាល (ខ្មែរ)",
          "givenNameNative": "នាមខ្លួន (ខ្មែរ)",
          "nicknameNative": "ឈ្មោះហៅក្រៅ (ខ្មែរ)",
          "countryOfBirth": "ប្រទេសកំណើត",
          "cityProvinceOfBirth": "ទីក្រុង/ខេត្តកំណើត",
          "maritalStatus": "ស្ថានភាពគ្រួសារ",
          "nationality": "សញ្ជាតិ",
          "spouseName": "ឈ្មោះប្តី/ប្រពន្ធ",
          "numChildren": "ចំនួនកូន",
          "personalPhone": "លេខទូរស័ព្ទផ្ទាល់ខ្លួន",
          "personalEmail": "អ៊ីមែលផ្ទាល់ខ្លួន",
          "homeAddress": "អាសយដ្ឋានផ្ទះ",
          "email": "អ៊ីមែលការងារ",
          "phone": "លេខទូរស័ព្ទការងារ",
          "status": "ស្ថានភាពការងារ",
          "type": "ប្រភេទកម្លាំងពលកម្ម",
          "position": "តំណែង / ចំណងជើង",
          "department": "នាយកដ្ឋាន",
          "empType": "ប្រភេទការងារ",
          "joined": "កាលបរិច្ឆេទចូលបំរើការ",
          "contract": "ប្រភេទកិច្ចសន្យា",
          "contractStartDate": "កាលបរិច្ឆេទចាប់ផ្តើមកិច្ចសន្យា",
          "contractEndDate": "កាលបរិច្ឆេទបញ្ចប់កិច្ចសន្យា",
          "onProbation": "កំពុងសាកល្បង",
          "probationEndDate": "កាលបរិច្ឆេទបញ្ចប់ការសាកល្បង",
          "schedule": "កាលវិភាគការងារ",
          "weeklyHours": "ម៉ោងធ្វើការក្នុងមួយសប្តាហ៍",
          "availableAl": "ថ្ងៃឈប់សម្រាកប្រចាំឆ្នាំដែលនៅសល់",
          "project": "គម្រោង / អតិថិជន",
          "salary": "ប្រាក់ខែមូលដ្ឋាន",
          "costCenters": "មជ្ឈមណ្ឌលចំណាយ",
          "bank": "ធនាគារ",
          "account": "លេខគណនី",
          "bankAccountName": "ឈ្មោះគណនីធនាគារ",
          "nssfId": "លេខសម្គាល់ NSSF",
          "nssfScheme": "គម្រោង NSSF",
          "nssfEmployerType": "ប្រភេទនិយោជក NSSF",
          "nssfStatus": "ស្ថានភាព NSSF",
          "privateInsuranceProvider": "អ្នកផ្តល់ធានារ៉ាប់រងឯកជន",
          "privateInsurancePolicyId": "លេខសម្គាល់ធានារ៉ាប់រងឯកជន",
          "privateInsuranceScheme": "គម្រោងធានារ៉ាប់រងឯកជន",
          "lifecycle": "វដ្តជីវិត",
          "jobTitle": "ងារការងារ",
          "jobGrade": "កម្រិតការងារ",
          "seniorityLevel": "កម្រិតជាន់ខ្ពស់",
          "reportsToRole": "តួនាទីរបាយការណ៍ទៅ",
          "reportsToPerson": "រាយការណ៍ទៅបុគ្គល",
          "orgUnitType": "ប្រភេទអង្គភាព",
          "orgUnitLayer": "ស្រទាប់អង្គភាព",
          "locationName": "ឈ្មោះទីតាំង",
          "locationCode": "កូដទីតាំង",
          "locationLatLong": "កូអរដោនេទីតាំង (រយៈទទឹង/បណ្តោយ)",
          "locationAddress": "អាសយដ្ឋានទីតាំង",
          "resignationSubmittedDate": "កាលបរិច្ឆេទដាក់ពាក្យលាលែង",
          "resignationStatus": "ស្ថានភាពលាលែង",
          "requestedLastDay": "ថ្ងៃចុងក្រោយដែលបានស្នើសុំ",
          "resignationReason": "មូលហេតុលាលែង",
          "agreedLastDay": "ថ្ងៃចុងក្រោយដែលបានព្រមព្រៀង",
          "resignationDiscussedDate": "កាលបរិច្ឆេទពិភាក្សាការលាលែង",
          "discussReason": "មូលហេតុពិភាក្សា",
          "forwardToHrDate": "កាលបរិច្ឆេទបញ្ជូនទៅផ្នែកធនធានមនុស្ស",
          "leavingLastDate": "ថ្ងៃចុងក្រោយនៃការចាកចេញ",
          "leavingType": "ប្រភេទការចាកចេញ",
          "leavingReason": "មូលហេតុនៃការចាកចេញ",
          "client": "អតិថិជន",
          "externalManager": "អ្នកគ្រប់គ្រងខាងក្រៅ",
          "workforceSource": "ប្រភពកម្លាំងពលកម្ម",
          "vendor": "អ្នកផ្គត់ផ្គង់ / អ្នកផ្តល់សេវា",
          "providerEmpId": "លេខសម្គាល់និយោជិតរបស់អ្នកផ្តល់សេវា"
        },
        "col-panel": {
          "title": "កំណត់ជួរឈរតារាង",
          "subtitle": "ជ្រើសរើសប្រភេទព័ត៌មានបុគ្គលិកដើម្បីបង្ហាញក្នុងតារាង។ ជួរឈរដែលតម្រូវការមិនអាចលាក់បាន។",
          "hint": "{count} ជួរឈរត្រូវបានជ្រើស · អូសដើម្បីរៀបចំ · ចុចដើម្បីបើក/បិទ",
          "close": "បិទ",
          "reset": "កំណត់ឡើងវិញ",
          "apply": "អនុវត្ត",
          "required": "ចាំបាច់",
          "locked": "ចាក់សោ",
          "group": {
            "employee": "បុគ្គលិក",
            "basic-info": "ព័ត៌មានបុគ្គលិកមូលដ្ឋាន",
            "contact-info": "ព័ត៌មានទំនាក់ទំនង",
            "employment": "ការងារ និងតួនាទី",
            "contract": "ព័ត៌មានកិច្ចសន្យា",
            "schedule-leave": "កាលវិភាគ និងការឈប់សម្រាក",
            "payroll": "បើកប្រាក់ និងហិរញ្ញវត្ថុ",
            "insurance": "ការធានារ៉ាប់រង",
            "offboarding": "ការបញ្ចប់ការងារ",
            "other": "ផ្សេងៗ",
            "assignment": "ការចាត់តាំង",
            "provider": "ព័ត៌មានអ្នកផ្តល់សេវា"
          },
          "no-render": "មិនទាន់មានជាជួរឈរតារាង"
        },
        "loading": "កំពុងផ្ទុកជួរឈរ…",
        "showing": "បង្ហាញ {shown} នៃ {total} នាក់",
        "sorted-by": "តម្រៀបតាម {column} {dir}",
        "sort-dir-asc": "↑",
        "sort-dir-desc": "↓",
        "info-banner": {
          "title": "បញ្ជីបុគ្គលិក",
          "body": "ប្រភពទិន្នន័យតែមួយសម្រាប់បុគ្គលិកទាំងអស់ដែលធ្វើការនៅក្រុមហ៊ុនរបស់អ្នក — បុគ្គលិកផ្ទាល់ បុគ្គលិកខាងក្រៅ និងបុគ្គលិកក្រៅជាដៃគូ។ ប្រើផ្នែកស្ថានភាពដើម្បីត្រង ជួរឈរដើម្បីកំណត់ការបង្ហាញ ហើយចុចលើជួរណាមួយដើម្បីបើកប្រវត្តិរូបបុគ្គលិក។",
          "dismiss": "បិទ",
          "dismiss-aria": "បិទផ្ទាំងព័ត៌មាន Directory"
        },
        "filter-active": "ត្រង: {filter}",
        "type-active": "ប្រភេទ: {type}",
        "contract-active": "កិច្ចសន្យា: {contract}",
        "search-active": "ស្វែងរក: \"{q}\"",
        "clear-all": "លុបការត្រង",
        "empty": {
          "title": "រកមិនឃើញ",
          "with-search": "រកមិនឃើញបុគ្គលិក \"{q}\" នៅក្នុងការត្រង {filter}។",
          "no-search": "មិនមានបុគ្គលិកក្នុងការត្រង {filter}។",
          "clear": "លុបការត្រង",
          "first-title": "បន្ថែមបុគ្គលិកដំបូងរបស់អ្នក",
          "first-body": "កន្លែងធ្វើការនេះមិនទាន់មានបុគ្គលិកទេ។ បន្ថែមម្នាក់ដើម្បីចាប់ផ្តើមបង្កើតបញ្ជី ឬនាំចូលជាបាច់ពី Excel/CSV។",
          "first-cta-add": "បន្ថែមបុគ្គលិក",
          "first-cta-import": "នាំចូលពីឯកសារ"
        },
        "internal": "Optimal Internal",
        "error": "បរាជ័យក្នុងការផ្ទុកបុគ្គលិក។ សូមព្យាយាមឡើងវិញ។",
        "error-403": "អ្នកគ្មានសិទ្ធិមើលបុគ្គលិកទេ។",
        "error-500": "មានបញ្ហាខាងម្ខាងរបស់យើង។ សូមព្យាយាមឡើងវិញ។",
        "retry": "ព្យាយាមឡើងវិញ",
        "filter-remove": "លុបតម្រង {filter}",
        "sort-employee": "តម្រៀបតាមឈ្មោះបុគ្គលិក",
        "sort-position": "តម្រៀបតាមតួនាទី",
        "sort-department": "តម្រៀបតាមនាយកដ្ឋាន",
        "sort-project": "តម្រៀបតាមគម្រោង/អតិថិជន",
        "sort-type": "តម្រៀបតាមប្រភេទ",
        "sort-contract": "តម្រៀបតាមកិច្ចសន្យា",
        "sort-status": "តម្រៀបតាមស្ថានភាព",
        "delete": {
          "selected": "លុប {count} ដែលបានជ្រើស",
          "modal-title": "លុបបុគ្គលិក?",
          "modal-body": "{name} ({code}) នឹងត្រូវលុបចោលជាអចិន្ត្រៃយ៍។ សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
          "modal-body-many": "បុគ្គលិក {count} នាក់នឹងត្រូវលុបចោលជាអចិន្ត្រៃយ៍។ សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
          "confirm": "លុប",
          "cancel": "បោះបង់",
          "success": "{name} ត្រូវបានលុបរួចហើយ។",
          "success-many": "បុគ្គលិក {count} នាក់ត្រូវបានលុបរួចហើយ។",
          "error": "បរាជ័យក្នុងការលុបបុគ្គលិក។ សូមព្យាយាមឡើងវិញ។",
          "error-partial": "បានលុប {deleted} បរាជ័យ {failed} មិនអាចលុបបាន។ សូមព្យាយាម​ម្ដង​ទៀត។",
          "bulk-title": "លុបមនុស្ស {n} នាក់?",
          "bulk-body": "សកម្មភាពនេះលុបជាអចិន្ត្រៃយ៍នូវមនុស្ស {n} នាក់ដែលមិនទាន់ចាប់ផ្តើមការងារ រួមទាំងកំណត់ត្រាផ្ទាល់ខ្លួន និងឯកសាររបស់ពួកគេ។ មិនអាចត្រឡប់វិញបានទេ។",
          "and-more": "និង {n} នាក់ទៀត",
          "type-to-confirm": "វាយ {n} ដើម្បីបញ្ជាក់",
          "progress": "កំពុងលុប {done} នៃ {total}…",
          "result-deleted": "បានលុប {n} នាក់",
          "result-failed": "មិនបានលុប {n} នាក់",
          "close": "បិទ",
          "failure-forbidden": "មានតែអ្នកគ្រប់គ្រងប៉ុណ្ណោះដែលអាចលុបមនុស្សបាន។",
          "failure-not-found": "មនុស្សនេះលែងមានទៀតហើយ។",
          "failure-network": "បញ្ហាបណ្តាញ — មនុស្សនេះមិនត្រូវបានលុបទេ។ សូមព្យាយាមម្តងទៀត។",
          "failure-generic": "ម៉ាស៊ីនមេមិនបានលុបមនុស្សនេះទេ។",
          "code": {
            "NOT_DELETABLE_STATUS": "អាចលុបបានតែអ្នកដែលមិនទាន់ចាប់ផ្តើមការងារប៉ុណ្ណោះ។ សូមកំណត់ពួកគេជាអសកម្មជំនួសវិញ។",
            "HAS_CONTRACT": "មនុស្សនេះមានកិច្ចសន្យា។ សូមកំណត់ពួកគេជាអសកម្មជំនួសវិញ។",
            "TOO_MANY_ITEMS": "មនុស្សនេះមានកំណត់ត្រាច្រើនពេក មិនអាចលុបក្នុងពេលតែមួយបានទេ។"
          }
        },
        "bulkbar": {
          "count": "បានជ្រើស {n}",
          "in-view-all": "ទាំងអស់ក្នុងទិដ្ឋភាពបច្ចុប្បន្ន",
          "in-view-mixed": "{inView} ក្នុងទិដ្ឋភាពបច្ចុប្បន្ន · {offView} ក្រៅទិដ្ឋភាព",
          "export-selected": "នាំចេញដែលបានជ្រើស",
          "clear": "សម្អាត",
          "delete": "លុប",
          "delete-disabled": "អាចលុបបានតែអ្នកដែលមិនទាន់ចាប់ផ្តើមការងារ និងគ្មានកិច្ចសន្យាប៉ុណ្ណោះ។ សូមកំណត់អ្នកផ្សេងទៀតជាអសកម្ម។"
        },
        "coming-soon": "មកដល់ឆាប់ៗ",
        "download-excel": "ទាញយក Excel",
        "export-loading": "កំពុងនាំចេញ…",
        "export-success": "នាំចេញ {count} នាក់",
        "export-sheet": "បុគ្គលិក",
        "export-empty": "មិនមានបុគ្គលិកដើម្បីនាំចេញ",
        "export-error": "នាំចេញបរាជ័យ — សូមព្យាយាមម្ដងទៀត",
        "export-modal": {
          "title": "នាំចេញបុគ្គលិក",
          "description": "ជ្រើសរើសវិសាល ទ្រង់ទ្រាយ និងព័ត៌មានដែលត្រូវបញ្ចូល",
          "scope": {
            "label": "វិសាល — តើនាំចេញបុគ្គលិកណា",
            "filtered": "បញ្ជីដែលបានត្រង",
            "filtered-hint": "បុគ្គលិក {count} នាក់ដែលត្រូវនឹងតម្រង",
            "selected": "តែអ្នកដែលបានជ្រើស",
            "selected-hint": "បានជ្រើស {count} នាក់",
            "selected-empty": "អ្នកត្រូវជ្រើសជួរដេកនៅលើតារាងជាមុន",
            "full": "ឯកសារបុគ្គលិកទាំងមូល",
            "full-hint": "បុគ្គលិក {count} នាក់ — មិនអើពើតម្រង"
          },
          "format": {
            "label": "ទ្រង់ទ្រាយ",
            "xlsx": "Excel (.xlsx)",
            "xlsx-hint": "ណែនាំសម្រាប់ HR — បើកក្នុង Excel & Google Sheets ភ្លាម",
            "csv": "CSV (.csv)",
            "csv-hint": "អក្សរធម្មតា — ល្អបំផុតសម្រាប់ការនាំចូលឡើងវិញ"
          },
          "fields": {
            "label": "ជួរឈរបន្ថែម (លើសពីតារាងរបស់អ្នក)"
          },
          "sensitive-warning": "បុគ្គលិក {count} នាក់នឹងត្រូវនាំចេញ។ ព័ត៌មានប្រាក់ខែត្រូវបានបញ្ចូល — ប្រើប្រាស់ដោយប្រុងប្រយ័ត្ន។",
          "count": "បុគ្គលិក {count} នាក់នឹងត្រូវនាំចេញ",
          "cancel": "បោះបង់",
          "submit": "នាំចេញ {count} នាក់"
        },
        "workforce": {
          "label": "កម្លាំងពលកម្ម៖ ទាំងអស់",
          "all": "កម្លាំងពលកម្ម៖ ទាំងអស់",
          "Direct": "ផ្ទាល់",
          "Outsourced": "ជួលពីខាងក្រៅ"
        },
        "workforce-active": "កម្លាំងពលកម្ម៖ {workforce}",
        "colfilter-active": "តម្រងជួរ {count}",
        "facet-option": "{label} · {count}",
        "no-position": "គ្មានមុខតំណែង",
        "lifecycle": {
          "label": "វដ្តការងារ",
          "all": "ទាំងអស់",
          "preboarding": "មុនចូលបំពេញការងារ",
          "inservice": "កំពុងបម្រើការងារ",
          "inactive": "អសកម្ម"
        },
        "workforce-chips": {
          "label": "ប្រភេទកម្លាំងពលកម្ម",
          "all": "ទាំងអស់",
          "Direct": "ផ្ទាល់",
          "Outsourced": "ជួលពីខាងក្រៅ"
        },
        "scope": {
          "label": "វិសាលភាព",
          "client-label": "អតិថិជន",
          "all-clients": "អតិថិជនទាំងអស់",
          "project-label": "គម្រោង",
          "all-projects": "គម្រោងទាំងអស់"
        },
        "client-active": "អតិថិជន៖ {client}",
        "project-active": "គម្រោង៖ {project}",
        "colfilter-chip": "{column}៖ {values}",
        "column-filter": {
          "trigger": "ត្រង {column}",
          "clear": "សម្អាត",
          "empty": "គ្មានជម្រើស",
          "contains": "មានពាក្យ…"
        },
        "scroll-left": "រំកិលទៅឆ្វេង",
        "scroll-right": "រំកិលទៅស្តាំ",
        "export-done": "បាននាំចេញបុគ្គលិក {count} នាក់ · {file}",
        "status-value": {
          "active": "សកម្ម",
          "inactive": "អសកម្ម",
          "pending": "រង់ចាំ",
          "onboarding": "ចូលបំពេញការងារ",
          "probation": "កំពុងសាកល្បង",
          "on_leave": "ឈប់សម្រាក",
          "resigning": "លាលែង",
          "leaving": "ចាកចេញ"
        },
        "lifecycle-value": {
          "preboarding": "មុនចូលបំពេញការងារ",
          "inservice": "កំពុងបម្រើការងារ",
          "longleave": "ឈប់សម្រាករយៈពេលវែង",
          "offboarding": "កំពុងចាកចេញ",
          "inactive": "អសកម្ម",
          "unknown": "មិនស្គាល់"
        }
      },
      "outsourced": {
        "title": "កម្លាំងការងារជ្រើសរើសពីខាងក្រៅ",
        "subtitle": "បុគ្គលិកគ្រប់គ្រងដោយស្ថាប័ននេះ និងបានចាត់ឱ្យធ្វើការនៅគម្រោងអតិថិជន។ អ្នកអនុម័តរបស់អតិថិជនត្រូវបានអញ្ជើញតាមរយៈអ៊ីមែល និងទទួលបានការចូលដោយតំណមន្ត្រី — ពួកគេពុំមានគណនី Optimal HR ឡើយ។",
        "banner": {
          "title": "កម្លាំងការងារជ្រើសរើសពីខាងក្រៅ",
          "all": "បុគ្គលិកមិនមែនផ្ទាល់ទាំងអស់ដែលធ្វើការនៅទីតាំងរបស់យើង — ទាំងបុគ្គលិកដែលយើងជួល (UDC/FDC/Casual) និងបុគ្គលិកដែលអ្នកផ្ដល់សេវាបញ្ជូនមក។",
          "provider": "បុគ្គលិករបស់ Optimal P ដែលដាក់ឱ្យធ្វើការនៅទីតាំងអតិថិជន · យើងបង់ប្រាក់ខែ · LM អតិថិជនអនុម័តប្រចាំថ្ងៃ។",
          "service": "បុគ្គលិកដែលអ្នកផ្ដល់សេវាបញ្ជូនមក · ពួកគេគ្រប់គ្រងប្រាក់ខែ អត្ថប្រយោជន៍ និងបញ្ហាច្បាប់ · យើងគ្រាន់តែអនុម័តវត្តមាននិងការឈប់សម្រាក។",
          "detail-all": "នេះគឺជាការសិក្សាស៊ីជម្រៅប្រតិបត្តិការសម្រាប់ការចូលរួម EOR។ បញ្ជី Directory បង្ហាញបុគ្គលិកដូចគ្នាជាមួយបុគ្គលិកផ្ទាល់ · នៅទីនេះយើងបង្ហាញជួរឈរជាក់លាក់ EOR។",
          "detail-provider": "នេះគឺជាការសិក្សាស៊ីជម្រៅប្រតិបត្តិការសម្រាប់ការចូលរួម EOR។ បញ្ជី Directory បង្ហាញបុគ្គលិកដូចគ្នាជាមួយបុគ្គលិកផ្ទាល់ · នៅទីនេះយើងបង្ហាញជួរឈរជាក់លាក់ EOR។",
          "detail-service": "មិនបានកត់ត្រាប្រាក់ខែ — អ្នកលក់គ្រប់គ្រងការងារ។ យើងគ្រាន់តែឃើញអ្នកដែលគ្រប់គ្រងប្រតិបត្តិការ។"
        },
        "actions": {
          "invite-approver": "អញ្ជើញអ្នកអនុម័តរបស់អតិថិជន",
          "invite-toast": "លំហូរការអញ្ជើញ — នឹងមកដល់ក្នុងស្រាប់ៗ",
          "add-employee": "បន្ថែមបុគ្គលិកជ្រើសរើស",
          "add-toast": "លំហូរបន្ថែមបុគ្គលិក — នឹងមកដល់ក្នុងស្រាប់ៗ",
          "columns": "ជួរឈរ",
          "export": "នាំចេញ",
          "export-toast": "នាំចេញទៅ Excel · {count} ជួរ",
          "clear-filters": "សម្អាតតម្រង",
          "add-vendor-lite": "បន្ថែមកំណត់ត្រាអ្នកផ្គត់ផ្គង់ (Lite)"
        },
        "col-groups": {
          "identification": "អត្តសញ្ញាណ",
          "job-details": "ព័ត៌មានការងារ",
          "assignment": "ការចាត់តាំង",
          "contract": "កិច្ចសន្យា",
          "status": "ស្ថានភាព"
        },
        "view-mode": {
          "label": "ទិដ្ឋភាព",
          "all": "ទាំងអស់",
          "provider": "បុគ្គលិកអ្នកផ្ដល់",
          "provider-hint": "បុគ្គលិកដែលយើងជួល — UDC / FDC / Casual",
          "service": "កំណត់ត្រា Vendor Lite",
          "service-hint": "បុគ្គលិកដែលអ្នកលក់បញ្ជូនមក — មិនមានប្រាក់ខែខាងយើង",
          "assigned": "ចាត់តាំងដោយអ្នកផ្គត់ផ្គង់",
          "assigned-hint": "កម្មករដែលត្រូវបានចាត់តាំងទៅគម្រោងរបស់អ្នកដោយអ្នកផ្គត់ផ្គង់នៅលើ Optimal HR — អានតែប៉ុណ្ណោះ កម្មសិទ្ធិដោយអ្នកផ្គត់ផ្គង់"
        },
        "kpi": {
          "total-outsourced": "សរុបជ្រើសរើស",
          "total-provider": "សរុបបុគ្គលិកអ្នកផ្ដល់",
          "total-service": "សរុបបុគ្គលិកសេវាកម្ម",
          "active": "សកម្ម",
          "probation": "កំពុងសាកល្បង",
          "onboarding": "ការទទួល",
          "vendors": "អ្នកលក់",
          "expiring-fdc": "FDC ផុតកំណត់ ≤ ៣០ ថ្ងៃ",
          "expiring-service": "ការចូលរួមផុតកំណត់ ≤ ៣០ ថ្ងៃ"
        },
        "filters": {
          "all": "ទាំងអស់",
          "active": "សកម្ម",
          "probation": "កំពុងសាកល្បង",
          "onboarding": "ការទទួល",
          "onleave": "កំពុងឈប់សម្រាក",
          "resigning": "កំពុងលាឈប់",
          "leaving": "កំពុងចាកចេញ",
          "expiring": "ផុតកំណត់ ≤៣០ ថ្ងៃ",
          "all-projects": "គម្រោងទាំងអស់ · {count}",
          "all-managers": "LM អតិថិជនទាំងអស់"
        },
        "search-placeholder": "ស្វែងរកឈ្មោះ លេខ មុខងារ…",
        "table": {
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} បុគ្គលិកជ្រើសរើស",
          "sorted-by": "តម្រៀបតាម {col} {dir}",
          "click-hint": "ចុចជួរណាមួយដើម្បីបើកប្រវត្តិរូប",
          "code": "លេខកូដ",
          "person": "បុគ្គល",
          "kh-name": "ឈ្មោះខ្មែរ",
          "position": "មុខតំណែង",
          "dept": "ផ្នែក",
          "project": "គម្រោង / អតិថិជន",
          "ext-mgr": "អ្នកគ្រប់គ្រងខាងក្រៅ (LM)",
          "contract": "កិច្ចសន្យា",
          "contract-end": "ផុតកំណត់កិច្ចសន្យា",
          "vendor": "អ្នកលក់",
          "joined": "កាលបរិច្ឆេទចូលរួម",
          "status": "ស្ថានភាព",
          "actions": "សកម្មភាព",
          "row-actions": "សកម្មភាពជួរ",
          "open-profile": "បើកប្រវត្តិរូប",
          "open-profile-toast": "ប្រវត្តិរូប — កំពុងបើក {code}",
          "no-end": "—"
        },
        "drawer": {
          "tabs": {
            "overview": "ទិដ្ឋភាពទូទៅ",
            "contract": "កិច្ចសន្យា"
          },
          "fields": {
            "code": "លេខកូដបុគ្គលិក",
            "kh-name": "ឈ្មោះខ្មែរ",
            "position": "មុខតំណែង",
            "dept": "ផ្នែក",
            "project": "គម្រោង",
            "client": "អតិថិជន",
            "external-manager": "អ្នកគ្រប់គ្រងខាងក្រៅ (LM)",
            "contract": "ប្រភេទកិច្ចសន្យា",
            "contract-end": "ផុតកំណត់កិច្ចសន្យា",
            "joined": "ចូលរួម",
            "base-location": "ទីតាំងគោល",
            "phone": "ទូរស័ព្ទ",
            "email": "អ៊ីមែល",
            "vendor": "អ្នកលក់"
          },
          "no-value": "—"
        },
        "empty": {
          "title": "គ្មានលទ្ធផល",
          "lede": "គ្មានបុគ្គលិកជ្រើសរើសណាមួយដែលត្រូវនឹងតម្រងទាំងនេះ។"
        },
        "mode-subtitle": {
          "provider-off": "បុគ្គលិកជាកម្មសិទ្ធិរបស់អង្គភាពនេះ ហើយត្រូវបានចាត់តាំងទៅគម្រោងអតិថិជន។ អ្នកអនុម័តខាងអតិថិជនត្រូវបានអញ្ជើញតាមអ៊ីមែល និងទទួលការចូលតាមតំណ magic-link — ពួកគេមិនមានគណនី Optimal HR ទេ។",
          "provider-on": "បុគ្គលិកជាកម្មសិទ្ធិរបស់អង្គភាពនេះ ហើយត្រូវបានចាត់តាំងទៅគម្រោងអតិថិជន។ ពេលអញ្ជើញអ្នកអនុម័តអតិថិជន ប្រព័ន្ធភ្ជាប់ទៅគណនី Optimal HR ដែលមានស្រាប់របស់ពួកគេ — គ្មាន ESS ស្ទួនទេ។",
          "client-on": "បុគ្គលិកក្រៅផ្ទះដែលត្រូវបានចាត់តាំងទៅគម្រោងរបស់អ្នកដោយអ្នកផ្គត់ផ្គង់នៅលើវេទិកា។ អ្នកផ្គត់ផ្គង់គ្រប់គ្រងប្រវត្តិរូប HR របស់កម្មករនីមួយៗ — អ្នកឃើញតែស្រមោលនៃការចាត់តាំង និងអាចអនុម័តសំណើប្រតិបត្តិការ។",
          "client-off": "កំណត់ត្រា Lite សម្រាប់កម្មករដែលផ្គត់ផ្គង់ដោយអ្នកផ្គត់ផ្គង់ដែលមិននៅលើ Optimal HR។ តាមដានប្រតិបត្តិការតែប៉ុណ្ណោះ — គ្មានបើកប្រាក់ខែដោយអង្គភាពនេះទេ។",
          "none": "ការដាក់បុគ្គលិកក្រៅផ្ទះត្រូវបានបិទសម្រាប់អង្គភាពនេះ។"
        },
        "mode": {
          "label": "របៀបដាក់បុគ្គលិកក្រៅផ្ទះរបស់អង្គភាព",
          "demo-tools": "ឧបករណ៍សាកល្បង",
          "dev-only": "សម្រាប់គំរូប៉ុណ្ណោះ — មិនមែននៅក្នុងផលិតកម្ម",
          "prod-note": "ផលិតកម្ម៖ កំណត់នៅ Admin → Modules",
          "close": "បិទ",
          "option": {
            "provider-off": "១ · អ្នកផ្គត់ផ្គង់បុគ្គលិក · អតិថិជនមិននៅលើ Optimal HR",
            "provider-on": "២ · អ្នកផ្គត់ផ្គង់បុគ្គលិក · អតិថិជននៅលើ Optimal HR ដែរ",
            "client-on": "៣ · អតិថិជនក្រៅផ្ទះ · អ្នកផ្គត់ផ្គង់នៅលើ Optimal HR",
            "client-off": "៤ · អតិថិជនក្រៅផ្ទះ · អ្នកផ្គត់ផ្គង់មិននៅលើ Optimal HR",
            "none": "៥ · សហគ្រាសតូចមធ្យមទូទៅ (គ្មានការដាក់ក្រៅផ្ទះ)"
          },
          "pill": {
            "role-provider": "តួនាទីអ្នកផ្គត់ផ្គង់",
            "role-client": "តួនាទីអតិថិជន",
            "role-none": "គ្មានការដាក់ក្រៅផ្ទះ",
            "client-on": "អតិថិជននៅលើ OHR",
            "client-off": "អតិថិជនក្រៅវេទិកា",
            "provider-on": "អ្នកផ្គត់ផ្គង់នៅលើ OHR",
            "provider-off": "អ្នកផ្គត់ផ្គង់ក្រៅវេទិកា",
            "disabled": "បានបិទ"
          }
        },
        "assigned": {
          "banner-title": "ចាត់តាំងដោយអ្នកផ្គត់ផ្គង់",
          "banner-lead": "កម្មករក្រៅផ្ទះដែលមិនមែនជាកម្មសិទ្ធិរបស់អង្គភាពនេះ។ អង្គភាពអ្នកផ្គត់ផ្គង់នៅលើ Optimal HR គ្រប់គ្រងប្រវត្តិរូប HR ពេញលេញ (បើកប្រាក់ខែ កិច្ចសន្យា ESS សិទ្ធិឈប់សម្រាក)។ អង្គភាពនេះទទួលតែស្រមោលនៃការចាត់តាំង និងអាចអនុម័តសំណើប្រតិបត្តិការសម្រាប់អ្នកអនុម័តដែលបានកំណត់។",
          "banner-detail": "ទិន្នន័យកម្មករអានតែប៉ុណ្ណោះនៅទីនេះ — ដើម្បីផ្លាស់ប្ដូរព័ត៌មានផ្ទាល់ខ្លួន លក្ខខណ្ឌកិច្ចសន្យា ឬប្រាក់ខែ សូមទាក់ទងអង្គភាពអ្នកផ្គត់ផ្គង់។ (ទិន្នន័យគំរូ — ការធ្វើសមកាលកម្មឆ្លងអង្គភាពនឹងមកដល់ពេលក្រោយ។)",
          "empty-title": "គ្មានការចាត់តាំងចូលមក",
          "empty-lede": "គ្មានអ្នកផ្គត់ផ្គង់នៅលើវេទិកាបញ្ជូនកម្មករទៅអង្គភាពនេះក្នុងសេណារីយ៉ូនេះទេ។ ប្ដូរទៅកំណត់ត្រា Lite ដើម្បីបន្ថែមកំណត់ត្រាដោយដៃសម្រាប់អ្នកផ្គត់ផ្គង់ក្រៅវេទិកា។",
          "empty-cta": "ទៅកាន់កំណត់ត្រា Lite",
          "showing": "កំពុងបង្ហាញការចាត់តាំងចូលមក {count} · កម្មសិទ្ធិដោយអង្គភាពអ្នកផ្គត់ផ្គង់",
          "click-hint": "ប្រវត្តិរូបកម្មករស្ថិតនៅក្នុងអង្គភាពអ្នកផ្គត់ផ្គង់",
          "accept": "ទទួលយកការចាត់តាំង",
          "decline": "បដិសេធការចាត់តាំង",
          "view": "មើលវិសាលភាព (អានតែប៉ុណ្ណោះ)",
          "accept-toast": "ការទទួលយក — អ្នកផ្គត់ផ្គង់នឹងត្រូវបានជូនដំណឹង; ស្រមោលនៃការចាត់តាំងក្លាយជា សកម្ម",
          "decline-toast": "ការបដិសេធ — អ្នកផ្គត់ផ្គង់នឹងត្រូវបានជូនដំណឹង; ការចាត់តាំងផុតកំណត់",
          "view-toast": "អានតែប៉ុណ្ណោះ · ប្រវត្តិរូបកម្មករស្ថិតនៅក្នុងអង្គភាពអ្នកផ្គត់ផ្គង់ ({tenant})",
          "kpi": {
            "total": "ចូលមកសរុប",
            "active": "សកម្ម",
            "pending": "កំពុងរង់ចាំការទទួលយក",
            "ended": "បានបញ្ចប់ (បណ្ណសារ)"
          },
          "col": {
            "worker": "កម្មករ",
            "provider": "អ្នកផ្គត់ផ្គង់",
            "project": "គម្រោង",
            "approver": "អ្នកអនុម័ត",
            "scope": "វិសាលភាព",
            "dates": "ចាប់ផ្ដើម–បញ្ចប់",
            "status": "ស្ថានភាព",
            "actions": "សកម្មភាព"
          }
        }
      },
      "configuration": {
        "sub-nav": {
          "grades": "ថ្នាក់ការងារ",
          "job-titles": "ងារតួនាទី",
          "job-profiles": "កម្រងការងារ",
          "benefits": "អត្ថប្រយោជន៍"
        },
        "banner": {
          "lead": "ទិន្នន័យយោង។",
          "rest": "ថ្នាក់ការងារ ងារតួនាទី កម្រងការងារ និងបញ្ជីអត្ថប្រយោជន៍ គឺជាគ្រឹះរួមដែលរាល់មុខតំណែង លិខិតផ្តល់ការងារ និងកំណត់ត្រាបុគ្គលនីមួយៗយោងទៅរក។ ការកែប្រែនៅទីនេះនឹងផ្សព្វផ្សាយដល់អ្នកប្រើទាំងអស់ — សូមកែប្រែដោយចេតនា។"
        },
        "benefits": {
          "title": "បញ្ជីអត្ថប្រយោជន៍",
          "subtitle": "បញ្ជីមេទូទាំងក្រុមហ៊ុនសម្រាប់ការធានារ៉ាប់រង · កាតព្វកិច្ច · សុខភាព · អត្ថប្រយោជន៍ជាសម្ភារៈ។ កំណត់ម្តង · យោងដោយការចុះឈ្មោះបុគ្គលិកគ្រប់រូប។",
          "add": "អត្ថប្រយោជន៍ថ្មី",
          "add-toast": "អត្ថប្រយោជន៍ថ្មី · ផ្ទាំងបង្កើតនឹងមកដល់នៅផ្នែកបន្ទាប់ ពេលដែល API បញ្ជីត្រូវបានដាក់ឱ្យដំណើរការ។",
          "search-placeholder": "ស្វែងរកតាមឈ្មោះ អ្នកផ្តល់សេវា គម្រោង…",
          "clear-filters": "សម្អាតតម្រង",
          "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total}",
          "renewal-soon": "ឆាប់ៗ",
          "cost-family": "គ្រួសារ USD {amt}",
          "auto-enroll": "ចុះឈ្មោះស្វ័យប្រវត្តិពេលជួល",
          "footnote": "ដើម្បីចុះឈ្មោះបុគ្គលិកជាក់លាក់ សូមបើកប្រវត្តិរូបរបស់គាត់ → អត្ថប្រយោជន៍។ សម្រាប់ការចុះឈ្មោះច្រើនរូប សូមប្រើកំណត់ត្រាការងារ → អត្ថប្រយោជន៍។",
          "kpi": {
            "active": "អត្ថប្រយោជន៍សកម្ម",
            "enrollments": "ការចុះឈ្មោះសកម្ម",
            "monthly-cost": "ថ្លៃប្រចាំខែ (និយោជក)",
            "renewing": "ត្រូវបន្តក្នុង ≤៩០ ថ្ងៃ"
          },
          "chips": {
            "all": "ទាំងអស់",
            "statutory": "កាតព្វកិច្ច",
            "insurance": "ការធានារ៉ាប់រង",
            "wellness": "សុខភាព",
            "allowance": "ប្រាក់ឧបត្ថម្ភជាសម្ភារៈ",
            "other": "ផ្សេងៗ"
          },
          "cols": {
            "benefit": "អត្ថប្រយោជន៍",
            "kind": "ប្រភេទ",
            "eligibility": "លក្ខណៈសម្បត្តិ",
            "cost": "ថ្លៃ / ខែ",
            "enrolled": "បានចុះឈ្មោះ",
            "renewal": "ការបន្ត",
            "status": "ស្ថានភាព"
          },
          "status": {
            "Active": "សកម្ម",
            "Renewing": "កំពុងបន្ត",
            "Ended": "បានបញ្ចប់"
          },
          "empty": {
            "title": "គ្មានអត្ថប្រយោជន៍ត្រូវនឹងតម្រងបច្ចុប្បន្ន",
            "lede": "សូមសម្អាតតម្រង ឬស្វែងរកដោយពាក្យគន្លឹះផ្សេង។"
          },
          "drawer": {
            "scheme": "គម្រោង",
            "policy-pattern": "លំនាំលេខគោលនយោបាយ",
            "coverage": "ការគ្របដណ្តប់",
            "eligibility": "លក្ខណៈសម្បត្តិ",
            "cost-emp": "ថ្លៃ / បុគ្គលិក / ខែ",
            "cost-fam": "ថ្លៃ / គ្រួសារ / ខែ",
            "cost-note": "កំណត់ចំណាំថ្លៃ",
            "renewal": "ការបន្តបន្ទាប់",
            "enrolled": "ការចុះឈ្មោះសកម្ម"
          }
        },
        "job-titles": {
          "banner-lead": "ងារតួនាទី",
          "banner-rest": " គឺជាគំរូតួនាទីដែលត្រូវបានយោងដោយមុខតំណែងជាច្រើន។ ងារនីមួយៗកំណត់ក្រុមការងារ ថ្នាក់លំនាំដើម និងលក្ខណៈបញ្ជាក់ ០–២ (ហាង បន្ទាត់ វេន ។ល។) ដែលបែងចែកកៅអីនីមួយៗដែលប្រើងារដូចគ្នា។ ឧ. ងារ \"អ្នកប្រតិបត្តិការរោងចក្រ\" មួយអាចត្រូវបានយោងដោយមុខតំណែងជាច្រើននៅលើបន្ទាត់ផលិតកម្មផ្សេងៗ។",
          "kpi": {
            "active": "ងារសកម្ម",
            "with-specifiers": "មានលក្ខណៈបញ្ជាក់",
            "orphan-main": "ងារគ្មានមុខតំណែង",
            "orphan-sub": "(មុខតំណែង ០)",
            "broken-grade": "តំណថ្នាក់ខូច"
          },
          "families-label": "ក្រុមការងារ៖",
          "toolbar-summary": "សកម្ម {active} · អសកម្ម {inactive}",
          "show-inactive": "បង្ហាញអសកម្ម",
          "add": "បន្ថែមងារតួនាទី",
          "error": "មិនអាចផ្ទុកងារតួនាទីបានទេ — {message}",
          "retry": "ព្យាយាមម្តងទៀត",
          "footnote": "ចុចជួរណាមួយដើម្បីកែ។ ដើម្បីមើលមុខតំណែងរបស់ងារ សូមប្រើទំព័រមុខតំណែងជាមួយតម្រងងារតួនាទី។",
          "cols": {
            "id": "លេខសម្គាល់",
            "title": "ងារ",
            "family": "ក្រុមការងារ",
            "grade": "ថ្នាក់លំនាំដើម",
            "specifiers": "លក្ខណៈបញ្ជាក់",
            "positions": "មុខតំណែង",
            "filled": "បានបំពេញ",
            "open": "ទំនេរ",
            "status": "ស្ថានភាព"
          },
          "status": {
            "active": "សកម្ម",
            "inactive": "អសកម្ម"
          },
          "errors": {
            "conflict": "ងារតួនាទីដែលមានឈ្មោះនេះមានរួចហើយ។ សូមប្រើងារផ្សេង ឬបន្ថែមលក្ខណៈបញ្ជាក់។",
            "forbidden": "អ្នកគ្មានសិទ្ធិគ្រប់គ្រងងារតួនាទីសម្រាប់ក្រុមហ៊ុននេះទេ។",
            "generic": "មិនអាចរក្សាទុកងារតួនាទីបានទេ។ សូមព្យាយាមម្តងទៀត។"
          },
          "empty": {
            "title": "មិនទាន់មានងារតួនាទីទេ",
            "subtitle": "បង្កើតគំរូតួនាទីដំបូងរបស់អ្នកដើម្បីចាប់ផ្តើមបង្កើតបញ្ជីមុខតំណែង។"
          },
          "modal": {
            "title": "ងារតួនាទីថ្មី",
            "subtitle": "បង្កើតគំរូតួនាទីសម្រាប់មុខតំណែងយោង",
            "sections": {
              "identity": "អត្តសញ្ញាណ",
              "classification": "ការចាត់ថ្នាក់",
              "specifiers": "លក្ខណៈបញ្ជាក់",
              "description": "ការពិពណ៌នា"
            },
            "fields": {
              "id": {
                "label": "លេខសម្គាល់",
                "hint": "លេខកូដបន្ទាប់ដែលបានស្នើ — អ្នកអាចកែប្រែបាន។ លេខកូដត្រូវតែមិនជាន់គ្នា ហើយនឹងមិនអាចផ្លាស់ប្តូរបានទេ បន្ទាប់ពីបង្កើតងារតួនាទី។",
                "auto": "(ស្វ័យប្រវត្តិ)"
              },
              "title": {
                "label": "ងារ",
                "placeholder": "ឧ. វិស្វករជាន់ខ្ពស់"
              },
              "family": {
                "label": "ក្រុមការងារ",
                "placeholder": "ជ្រើសរើសក្រុមការងារ…"
              },
              "grade": {
                "label": "ថ្នាក់លំនាំដើម",
                "placeholder": "— ជ្រើសរើសថ្នាក់ —"
              },
              "specifiers": {
                "placeholder": "បន្ថែមលក្ខណៈបញ្ជាក់…"
              },
              "description": {
                "placeholder": "សង្ខេបតួនាទីខ្លី។ KSA លម្អិតគួរនៅលើកម្រងការងារវិញ។"
              }
            },
            "specifier-add": "បន្ថែម",
            "specifier-remove": "លុបលក្ខណៈបញ្ជាក់",
            "specifier-section-hint": "(អតិបរមា ២ — ប្រើដើម្បីបែងចែកមុខតំណែងដែលមានងារដូចគ្នា)",
            "specifier-empty": "គ្មានលក្ខណៈបញ្ជាក់។ មុខតំណែងនីមួយៗត្រូវបានកំណត់ដោយលេខសម្គាល់មុខតំណែងតែម្នាក់ឯង។ បន្ថែមមួយ (ឧ. ហាង បន្ទាត់ វេន) នៅពេលមុខតំណែងជាច្រើនប្រើងារដូចគ្នា។",
            "specifier-fields": {
              "name": "ឈ្មោះ",
              "name-placeholder": "ហាង / បន្ទាត់ / វេន",
              "source": "ប្រភព",
              "location-type": "ប្រភេទទីតាំង",
              "location-type-placeholder": "— ជ្រើសរើសប្រភេទ —",
              "free-text-hint": "វាយបញ្ចូលដោយ HR ពេលបំពេញមុខតំណែងនីមួយៗ",
              "projects-hint": "ប្រើបញ្ជីគម្រោងក្រៅ"
            },
            "note-before": "ងារថ្មីចាប់ផ្តើមជា ",
            "note-active": "សកម្ម",
            "note-after": " ហើយមានជាបន្ទាន់នៅក្នុងកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី។ បិទ / បើកឡើងវិញ / ប្រវត្តិ នឹងមាននៅទីនេះបន្ទាប់ពីបង្កើតងាររួច។",
            "errors": {
              "employer-missing": "គ្មាននិយោជកសកម្ម — សូមបើកទំព័រនេះឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
              "title-required": "ងារត្រូវបានទាមទារ។",
              "family-required": "ក្រុមការងារត្រូវបានទាមទារ។",
              "grade-required": "ថ្នាក់លំនាំដើមត្រូវបានទាមទារ។",
              "title-too-long": "ងារតួនាទីត្រូវមានមិនលើសពី ២០០ តួអក្សរ។",
              "description-too-long": "ការពិពណ៌នាត្រូវមានមិនលើសពី ៤,០០០ តួអក្សរ។",
              "code-required": "លេខកូដត្រូវបានទាមទារ។",
              "code-too-long": "លេខកូដត្រូវមានមិនលើសពី ២០០ តួអក្សរ។",
              "code-taken": "ងារតួនាទីផ្សេងទៀតកំពុងប្រើលេខកូដនេះរួចហើយ។ សូមជ្រើសរើសលេខកូដផ្សេង។"
            },
            "cancel": "បោះបង់",
            "create": "បង្កើតងារ",
            "creating": "កំពុងបង្កើត…",
            "success": "ងារតួនាទី \"{title}\" ត្រូវបានបង្កើត។",
            "specifier-empty-1": "គ្មានលក្ខណៈបញ្ជាក់។ មុខតំណែងនីមួយៗត្រូវបានកំណត់អត្តសញ្ញាណដោយ Position ID តែម្នាក់ឯង។",
            "specifier-empty-2": "បន្ថែមលក្ខណៈបញ្ជាក់ (ឧ. Outlet, Line, Shift) នៅពេលមុខតំណែងជាច្រើនប្រើងារដូចគ្នា។"
          },
          "edit": {
            "title": "កែងារតួនាទី · {code}",
            "success": "ងារតួនាទី \"{title}\" ត្រូវបានធ្វើបច្ចុប្បន្នភាព។",
            "history": "ប្រវត្តិ",
            "history-soon": "ប្រវត្តិ — នឹងមានឆាប់ៗ",
            "id-locked": "ចាក់សោបន្ទាប់ពីបង្កើត។",
            "usage-positions": "មុខតំណែងយោងតាមងារនេះ",
            "inactive-notice-lead": "ងារតួនាទីនេះគឺអសកម្ម",
            "inactive-notice-rest": "។ វាត្រូវបានលាក់ពីកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី ប៉ុន្តែត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោមដើម្បីនាំវាមកវិញ។",
            "inactive-notice-rest-dated": " (បានបិទ {date})។ វាត្រូវបានលាក់ពីកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី ប៉ុន្តែត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោមដើម្បីនាំវាមកវិញ។",
            "cancel": "បោះបង់",
            "save-changes": "រក្សាទុកការផ្លាស់ប្តូរ",
            "saving": "កំពុងរក្សាទុក…",
            "deactivate": {
              "heading": "បិទងារតួនាទី",
              "explanation": "ងារដែលបានបិទត្រូវបានលាក់ពីកម្មវិធីជ្រើសរើសមុខតំណែងថ្មី ប៉ុន្តែត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ការលុបជាអចិន្ត្រៃយ៍មិនត្រូវបានអនុញ្ញាតទេ — នៅពេលកំណត់រួច ងារតួនាទីតែងតែនៅ។",
              "cannot": "មិនអាចបិទបានទេ — ងារនេះនៅតែប្រើដោយមុខតំណែង {count} ({filled} បានបំពេញ {open} ទំនេរ)។",
              "reassign-note": "បោះបង់ ឬផ្ដល់ឱ្យឡើងវិញនូវមុខតំណែងទាំងនោះជាមុនសិន។ មុខតំណែងទំនេរអាចបោះបង់បាន; មុខតំណែងដែលបានបំពេញត្រូវប្ដូរងារតួនាទីរបស់វា (ឬងារត្រូវរក្សាដំណើរការ)។",
              "action": "បិទងារនេះ",
              "cannot-lead": "មិនអាចបិទដំណើរការ",
              "cannot-rest": " — ងារនេះនៅតែប្រើដោយ៖",
              "usage-count": "{count} មុខតំណែង",
              "usage-breakdown": " ({filled} បានបំពេញ, {open} ទំនេរ)",
              "explanation-v2": "ងារតួនាទីដែលបានបិទដំណើរការនឹងមិនបង្ហាញក្នុងជម្រើសមុខតំណែងថ្មីទេ ប៉ុន្តែត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ មុខតំណែងដែលមានងារតួនាទីនេះរួចហើយនៅតែរក្សាវា។",
              "in-use-lead": "នៅតែកំពុងប្រើ",
              "in-use-rest": " — ចំណងជើងនេះកំពុងប្រើដោយ៖",
              "in-use-note": "អ្នកនៅតែអាចបិទដំណើរការវាបាន។ មុខតំណែងទាំងនោះរក្សាចំណងជើងនេះដដែល គ្រាន់តែវានឹងមិនត្រូវបានផ្តល់ជូនសម្រាប់មុខតំណែងថ្មីទៀតទេ។",
              "confirm-in-use": "បិទដំណើរការ \"{title}\" ឬ?\n\nមុខតំណែង {count} នៅតែប្រើវា (បានបំពេញ {filled}, បើក {open})។ ពួកវារក្សាចំណងជើងនេះដដែល ប៉ុន្តែវានឹងមិនត្រូវបានផ្តល់ជូនសម្រាប់មុខតំណែងថ្មីទេ។"
            },
            "reactivate": {
              "heading": "បើកងារតួនាទីឡើងវិញ",
              "explanation": "ការបើកឡើងវិញនាំងារនេះត្រឡប់ទៅសកម្ម។ វានឹងបង្ហាញនៅក្នុងកម្មវិធីជ្រើសរើសមុខតំណែងថ្មីម្តងទៀត។",
              "action": "បើកងារនេះឡើងវិញ"
            }
          },
          "banner-line1": "<strong>ងារតួនាទី</strong> គឺជាគំរូតួនាទីដែលត្រូវបានយោងដោយមុខតំណែងជាច្រើន។ ងារនីមួយៗប្រកាសក្រុមការងារ ថ្នាក់លំនាំដើម និងលក្ខណៈបញ្ជាក់ ០–២ (Outlet, Line, Shift ។ល។) ដែលបែងចែកកៅអីនីមួយៗដែលប្រើងារដូចគ្នា។",
          "banner-line2": "ឧ. ងារ «Plant Operator» មួយត្រូវបានយោងដោយ ៥ មុខតំណែងនៅលើខ្សែរោងចក្រផ្សេងៗ។",
          "specifier": {
            "none": "គ្មាន",
            "free-text": "អត្ថបទសេរី",
            "locations": "ទីតាំង",
            "projects": "គម្រោង"
          },
          "footnote-pre": "ចុចជួរណាមួយដើម្បីកែ។ ដើម្បីមើលមុខតំណែងនៃងារ ប្រើទំព័រ ",
          "footnote-bold": "មុខតំណែង",
          "footnote-post": " ជាមួយតម្រងងារតួនាទី។",
          "search": {
            "label": "ស្វែងរកងារតួនាទី",
            "placeholder": "ស្វែងរកលេខកូដ ងារតួនាទី ក្រុមការងារ ថ្នាក់…"
          },
          "export": {
            "label": "នាំចេញ",
            "empty": "គ្មានអ្វីត្រូវនាំចេញ — គ្មានជួរណាត្រូវនឹងតម្រងទេ។"
          },
          "result-count": "{shown} ក្នុងចំណោម {total} ងារតួនាទី",
          "no-match": "គ្មានងារតួនាទីណាត្រូវនឹងតម្រងទាំងនេះទេ។",
          "filter-chip": {
            "family": "ក្រុមការងារ៖ {value}",
            "search": "ស្វែងរក៖ “{value}”",
            "remove": "ដកតម្រង {label}",
            "clear-all": "សម្អាតតម្រងទាំងអស់"
          },
          "history": {
            "deactivated-at": "បានបិទដំណើរការនៅ"
          },
          "delete": {
            "heading": "លុបងារតួនាទី",
            "explanation": "គ្មានមុខតំណែងណាប្រើងារតួនាទីនេះទេ ដូច្នេះអាចលុបបាន។ ការលុបគឺជាអចិន្ត្រៃយ៍ — សូមប្រើ បិទដំណើរការ ជំនួសវិញ ប្រសិនបើអ្នកអាចត្រូវការវាម្តងទៀត។",
            "action": "លុបងារតួនាទីនេះ",
            "confirm-title": "លុប “{title}” ជាអចិន្ត្រៃយ៍?",
            "confirm-body": "សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។ ងារតួនាទីនឹងបាត់ពីបញ្ជី និងជម្រើសទាំងអស់។",
            "cancel": "រក្សាទុក",
            "confirm": "លុបជាអចិន្ត្រៃយ៍",
            "deactivate-instead": "បិទដំណើរការជំនួសវិញ",
            "success": "បានលុបងារតួនាទី \"{title}\"។",
            "errors": {
              "in-use": "មិនអាចលុបងារតួនាទីនេះបានទេ ព្រោះនៅមានមុខតំណែងប្រើវា។ សូមបិទដំណើរការវាជំនួសវិញ។",
              "not-found": "ងារតួនាទីនេះត្រូវបានលុបរួចហើយ។ សូមបិទផ្ទាំងនេះដើម្បីធ្វើបច្ចុប្បន្នភាពបញ្ជី។",
              "forbidden": "អ្នកមិនមានសិទ្ធិលុបងារតួនាទីសម្រាប់ក្រុមហ៊ុននេះទេ។",
              "generic": "មិនអាចលុបងារតួនាទីបានទេ។ សូមព្យាយាមម្តងទៀត។"
            }
          }
        },
        "job-profiles": {
          "banner-lead": "កម្រងការងារ",
          "banner-rest": " គឺជាស្រទាប់ជ្រៅជាជម្រើសដែលភ្ជាប់ទៅងារតួនាទី — KSA (ចំណេះដឹង ជំនាញ សមត្ថភាព) វិញ្ញាបនបត្រដែលត្រូវការ កំណត់ចំណាំផែនការបន្តវេន ផ្លូវសិក្សា និងទង់តួនាទីសំខាន់។ ក្រុមហ៊ុនភាគច្រើនបំពេញទាំងនេះសម្រាប់តួនាទីជាន់ខ្ពស់ ឬសំខាន់ប៉ុណ្ណោះ។ កម្រងគឺជាមាតិកា (មិនមែនរចនាសម្ព័ន្ធ) ដូច្នេះសកម្មភាពគឺធ្វើបច្ចុប្បន្នភាពជាជាងកែ។ ការដកចេញអាចត្រឡប់វិញបាន — មាតិកានៅតែក្នុងមូលដ្ឋានទិន្នន័យសម្រាប់សវនកម្ម។",
          "kpi": {
            "active-titles": "ងារសកម្ម",
            "attached": "កម្រងបានភ្ជាប់",
            "critical": "តួនាទីសំខាន់",
            "without-succession": "គ្មានការបន្តវេន",
            "succession-unit": "តួនាទីសំខាន់"
          },
          "filters": {
            "label": "តម្រងកម្រង",
            "all": "ងារទាំងអស់",
            "with": "មានកម្រង",
            "no": "គ្មានកម្រង",
            "critical": "សំខាន់តែប៉ុណ្ណោះ"
          },
          "show-removed": "បង្ហាញកម្រងដែលបានដក ({count})",
          "error": "មិនអាចផ្ទុកកម្រងការងារបានទេ — {message}",
          "retry": "ព្យាយាមម្តងទៀត",
          "empty": {
            "title": "មិនទាន់មានងារតួនាទីទេ",
            "subtitle": "បង្កើតងារតួនាទីជាមុនសិន — កម្រងភ្ជាប់ទៅពួកវា។"
          },
          "cols": {
            "title": "ងារតួនាទី",
            "family": "ក្រុមការងារ",
            "grade": "ថ្នាក់លំនាំដើម",
            "profile": "កម្រង",
            "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
            "action": "សកម្មភាព",
            "hours": "ម៉ោង/សប្តាហ៍"
          },
          "profile-attached": "កម្រង",
          "profile-critical": "សំខាន់",
          "profile-none": "គ្មានកម្រង",
          "action-add": "បន្ថែមកម្រង",
          "action-update": "ធ្វើបច្ចុប្បន្នភាព",
          "action-restore": "ស្តារ",
          "removed-heading": "កម្រងដែលបានដក ({count})",
          "removed-subtitle": "មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ការស្តារនាំកម្រងត្រឡប់ទៅសកម្មដោយគ្មានការបាត់បង់ទិន្នន័យ។",
          "removed-cols": {
            "id": "លេខសម្គាល់កម្រង",
            "title": "ងារតួនាទី",
            "removed-on": "បានដកនៅ",
            "removed-by": "បានដកដោយ",
            "action": "សកម្មភាព"
          },
          "removed-toast": "កម្រងការងារត្រូវបានដក។ អ្នកអាចស្តារវាពីបញ្ជីដែលបានដក។",
          "status": {
            "removed": "បានដក"
          },
          "errors": {
            "conflict": "កម្រងមានរួចហើយសម្រាប់ងារតួនាទីនេះ។",
            "forbidden": "អ្នកគ្មានសិទ្ធិគ្រប់គ្រងកម្រងការងារសម្រាប់ក្រុមហ៊ុននេះទេ។",
            "generic": "មិនអាចរក្សាទុកកម្រងការងារបានទេ។ សូមព្យាយាមម្តងទៀត។"
          },
          "modal": {
            "add-title": "បន្ថែមកម្រងការងារ",
            "update-title": "ធ្វើបច្ចុប្បន្នភាពកម្រងការងារ",
            "add-note": "កំពុងបន្ថែមកម្រងថ្មី។ គ្រប់ផ្នែកជាជម្រើស — បំពេញអ្វីដែលមានប្រយោជន៍។ ក្រុមហ៊ុនភាគច្រើនចាប់ផ្តើមជាមួយតួនាទីជាន់ខ្ពស់/សំខាន់ ហើយពង្រីកតាមពេលវេលា។",
            "success": "កម្រងការងារត្រូវបានបង្កើត។",
            "sections": {
              "content": "មាតិកា",
              "certifications": "វិញ្ញាបនបត្រដែលត្រូវការ",
              "strategic": "ទង់យុទ្ធសាស្ត្រ",
              "overview": "ទិដ្ឋភាពទូទៅនៃតួនាទី"
            },
            "fields": {
              "knowledge": {
                "label": "ចំណេះដឹង",
                "hint": "អ្វីដែលត្រូវដឹង",
                "placeholder": "ឧ. ច្បាប់ការងារកម្ពុជា; នីតិវិធីដាក់ NSSF; គណនេយ្យចូលពីរ…"
              },
              "skills": {
                "label": "ជំនាញ",
                "hint": "អ្វីដែលត្រូវធ្វើ",
                "placeholder": "ឧ. ពិនិត្យកូដ; ការណែនាំ; សរសេរអាជីវកម្មខ្មែរ + អង់គ្លេស…"
              },
              "abilities": {
                "label": "សមត្ថភាព",
                "hint": "សមត្ថភាព",
                "placeholder": "ឧ. លើក ២៥ គីឡូ; ធ្វើការវេនយប់; វិភាគនិន្នាការពីទិន្នន័យលេខ…"
              },
              "certification": {
                "placeholder": "ឧ. SHRM-SCP ឬសមមូល"
              },
              "critical": {
                "label": "តួនាទីសំខាន់",
                "hint": "ផលប៉ះពាល់ខ្ពស់ប្រសិនបើមិនបានបំពេញ; ត្រូវការផែនការបន្តវេន + យុទ្ធសាស្ត្របន្ត"
              },
              "succession": {
                "label": "កំណត់ចំណាំការបន្តវេន",
                "placeholder": "តើនរណាជាអ្នកបន្តវេន? ពេលវេលា? គម្លាតការអភិវឌ្ឍន៍?",
                "hint": "ណែនាំសម្រាប់តួនាទីសំខាន់"
              },
              "learning": {
                "label": "ផ្លូវសិក្សា",
                "placeholder": "ការណែនាំផ្ទៃក្នុង; វគ្គសិក្សាខាងក្រៅ; ការបង្វិល…"
              },
              "performance": {
                "label": "វិមាត្រការអនុវត្ត",
                "placeholder": "តើម៉ែត្រិកណាវាស់ភាពជោគជ័យក្នុងតួនាទីនេះ?"
              },
              "hours": {
                "label": "ម៉ោងធ្វើការ / សប្តាហ៍",
                "placeholder": "ឧ. ៤០",
                "hint": "ជាជម្រើស។ ធំជាង ០ និងមិនលើស ១៦៨ មានទសភាគយ៉ាងច្រើន ២ ខ្ទង់។"
              },
              "job-summary": {
                "label": "សេចក្តីសង្ខេបការងារ",
                "placeholder": "សេចក្តីសង្ខេបខ្លីអំពីតួនាទី និងហេតុផលដែលវាមាន។"
              },
              "responsibilities": {
                "label": "ទំនួលខុសត្រូវ",
                "placeholder": "អ្វីដែលតួនាទីនេះទទួលខុសត្រូវ — មួយបន្ទាត់មួយ។"
              },
              "requirements": {
                "label": "លក្ខខណ្ឌតម្រូវ",
                "placeholder": "ការអប់រំ បទពិសោធន៍ និងអាជ្ញាប័ណ្ណដែលអ្នកកាន់តំណែងត្រូវការ។"
              },
              "core-competency": {
                "label": "សមត្ថភាពស្នូល",
                "placeholder": "អាកប្បកិរិយា និងសមត្ថភាពដែលតួនាទីនេះពឹងផ្អែក។"
              }
            },
            "cert-add": "បន្ថែម",
            "cert-empty": "មិនត្រូវការវិញ្ញាបនបត្រ។",
            "cert-remove": "លុបវិញ្ញាបនបត្រ",
            "succession-warning": "តួនាទីសំខាន់ដែលគ្មានកំណត់ចំណាំការបន្តវេន — បន្ថែមអ្នកបន្តវេន ឬផែនការអភិវឌ្ឍន៍។",
            "cancel": "បោះបង់",
            "create": "បង្កើតកម្រង",
            "creating": "កំពុងបង្កើត…",
            "errors": {
              "employer-missing": "គ្មាននិយោជកសកម្ម — សូមបើកទំព័រនេះឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
              "no-title": "មិនបានជ្រើសរើសងារតួនាទីទេ — សូមបើកឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
              "text-too-long": "វែងពេក — យ៉ាងច្រើន {max} តួអក្សរ។",
              "hours-number": "សូមបញ្ចូលលេខ ឧ. 40 ឬ 37.5។",
              "hours-range": "ត្រូវតែធំជាង 0 និងមិនលើស {max}។",
              "hours-decimals": "ប្រើទសភាគយ៉ាងច្រើន 2 ខ្ទង់។",
              "invalid-form": "សូមកែតម្រូវវាលដែលបានបន្លិច។"
            },
            "add-note-lead": "កំពុងបន្ថែមកម្រងថ្មី។",
            "add-note-rest": " គ្រប់ផ្នែកជាជម្រើស — បំពេញអ្វីដែលមានប្រយោជន៍។ ក្រុមហ៊ុនភាគច្រើនចាប់ផ្តើមជាមួយតួនាទីជាន់ខ្ពស់/សំខាន់ ហើយពង្រីកតាមពេលវេលា។",
            "confirm-critical": "ទង់តួនាទីសំខាន់ត្រូវបានកំណត់ ប៉ុន្តែកំណត់ចំណាំការបន្តវេនទទេ។\n\nវាត្រូវបានណែនាំយ៉ាងមុតមាំឱ្យកត់ត្រាអ្នកស្នងតំណែងសម្រាប់តួនាទីសំខាន់។ បន្តដែរឬទេ?",
            "counter": "{count} / {max}",
            "discard-confirm": "បោះបង់ការផ្លាស់ប្តូរឬ? ការកែសម្រួលកម្រងការងារនេះមិនទាន់បានរក្សាទុកទេ។"
          },
          "update": {
            "success": "កម្រងការងារត្រូវបានធ្វើបច្ចុប្បន្នភាព។",
            "history": "ប្រវត្តិ",
            "history-soon": "ប្រវត្តិ — នឹងមានឆាប់ៗ",
            "removed-notice": " នៅ {date} ដោយ {by}។ មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ប្រើប៊ូតុងស្តារនៅខាងក្រោមដើម្បីនាំវាត្រឡប់មកវិញ។",
            "save-changes": "ធ្វើបច្ចុប្បន្នភាពកម្រង",
            "saving": "កំពុងរក្សាទុក…",
            "remove": {
              "heading": "ដកកម្រង",
              "explanation": "ដកកម្រងនេះចេញពីងារតួនាទី។ មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម — នេះមិនមែនជាការលុបជាអចិន្ត្រៃយ៍ទេ។ អ្នកអាចស្តារវាពេលក្រោយពីបញ្ជីដែលបានដក។",
              "action": "ដកកម្រងនេះ",
              "explanation-pre": "ការដកចេញផ្តាច់កម្រងចេញពីងារតួនាទីរបស់វា។ ",
              "explanation-bold": "មាតិកាត្រូវបានរក្សាទុក",
              "explanation-post": " សម្រាប់សវនកម្ម — នេះមិនមែនជាការលុបទេ។ អ្នកអាចស្តារពី «បង្ហាញកម្រងដែលបានដក» នៅពេលក្រោយ។",
              "confirm": "ដកកម្រងការងារសម្រាប់ «{title}» ឬ?\n\nមាតិកាកម្រងត្រូវបានរក្សាទុកក្នុងមូលដ្ឋានទិន្នន័យសម្រាប់សវនកម្ម។ ងារតួនាទីនឹងបង្ហាញជា «គ្មានកម្រង» ប៉ុន្តែអ្នកអាចស្តារវានៅពេលក្រោយ។"
            },
            "restore": {
              "heading": "ស្តារកម្រង",
              "explanation": "ការស្តារនាំកម្រងនេះត្រឡប់ទៅសកម្មវិញ។ មាតិកាត្រូវបានរក្សាទុកអំឡុងពេលដកចេញ — គ្មានការបាត់បង់។",
              "action": "ស្តារកម្រងនេះ"
            },
            "removed-notice-lead": "កម្រងនេះត្រូវបានដក",
            "loading": "កំពុងផ្ទុកកម្រងការងារ…",
            "load-error": "មិនអាចផ្ទុកកម្រងការងារនេះបានទេ ដូច្នេះមិនទាន់អាចកែសម្រួលបាននៅឡើយ។"
          },
          "banner-line1": "<strong>កម្រងការងារ</strong> គឺជាស្រទាប់ជ្រៅ<em>ជាជម្រើស</em>ដែលភ្ជាប់ទៅងារតួនាទី — KSA (ចំណេះដឹង ជំនាញ សមត្ថភាព) វិញ្ញាបនបត្រដែលត្រូវការ កំណត់ចំណាំផែនការបន្តវេន ផ្លូវសិក្សា និងទង់តួនាទីសំខាន់។ ក្រុមហ៊ុនភាគច្រើនបំពេញទាំងនេះសម្រាប់តួនាទីជាន់ខ្ពស់ ឬសំខាន់ប៉ុណ្ណោះ។",
          "banner-line2": "កម្រងគឺជា<strong>មាតិកា</strong> (មិនមែនរចនាសម្ព័ន្ធ) ដូច្នេះសកម្មភាពគឺ<strong>ធ្វើបច្ចុប្បន្នភាព</strong>ជាជាងកែ។ ការដកចេញអាចត្រឡប់វិញបាន — មាតិកានៅតែក្នុងមូលដ្ឋានទិន្នន័យសម្រាប់សវនកម្ម។",
          "counts-active": "សកម្ម",
          "counts-removed": "បានដក",
          "show-removed-label": "បង្ហាញកម្រងដែលបានដក",
          "guide": {
            "title": "អ្វីដែលកម្រងការងារមាន",
            "k": {
              "head": "K · ចំណេះដឹង",
              "desc": "អ្វីដែលតួនាទីត្រូវដឹង។ ឧ.",
              "eg": "«ច្បាប់ការងារកម្ពុជា» «នីតិវិធីដាក់ NSSF» «គណនេយ្យពីរផ្នែក»"
            },
            "s": {
              "head": "S · ជំនាញ",
              "desc": "អ្វីដែលតួនាទីត្រូវធ្វើ។ ឧ.",
              "eg": "«តារាង Pivot ក្នុង Excel» «ផ្សារដែក TIG តាមស្តង់ដារ ASME» «សរសេរអាជីវកម្មខ្មែរ + អង់គ្លេស»"
            },
            "a": {
              "head": "A · សមត្ថភាព",
              "desc": "សមត្ថភាព។ ឧ.",
              "eg": "«លើកទម្ងន់ ២៥គក ដដែលៗ» «ធ្វើការវេនយប់» «វិភាគនិន្នាការពីទិន្នន័យលេខ»"
            },
            "other": {
              "head": "ផ្សេងៗ",
              "desc": "វិញ្ញាបនបត្រដែលត្រូវការ · ផ្លូវសិក្សា · ទង់តួនាទីសំខាន់ · បេក្ខជនបន្តវេន · វិមាត្រការអនុវត្ត។"
            }
          },
          "table-caption-lead": "ងារតួនាទី",
          "table-caption-rest": " ជាមួយស្ថានភាពកម្រងរបស់វា — ចុច «ធ្វើបច្ចុប្បន្នភាព» ដើម្បីកែលម្អ «បន្ថែម» ដើម្បីចាប់ផ្តើមកម្រងថ្មី",
          "table-count": "{shown} ក្នុងចំណោម {total} ងារ",
          "profile-active": "សកម្ម",
          "action-review-restore": "ពិនិត្យ និងស្តារ",
          "action-review": "ពិនិត្យ",
          "removed-caption-rest": " — មាតិកាត្រូវបានរក្សាទុកសម្រាប់សវនកម្ម។ ស្តារពីតារាងខាងលើ (ជួរបង្ហាញស្ថានភាព «បានដក») ឬចុចខាងក្រោម។",
          "profile-no-succession": "គ្មានការបន្តវេន",
          "action-view": "មើល",
          "view-label": "មើលកម្រងការងារសម្រាប់ {title}",
          "search": {
            "label": "ស្វែងរកកម្រងការងារ",
            "placeholder": "ស្វែងរកងារ ក្រុមការងារ ថ្នាក់…"
          },
          "filter-chip": {
            "search": "ស្វែងរក៖ “{value}”",
            "filter": "កំពុងបង្ហាញ៖ {value}",
            "remove": "ដកតម្រង {label}",
            "clear-all": "សម្អាតទាំងអស់"
          },
          "result-count": "{shown} ក្នុងចំណោម {total} ងារ",
          "no-match": "គ្មានងារតួនាទីណាត្រូវនឹងតម្រងទាំងនេះទេ។",
          "export": {
            "label": "នាំចេញ",
            "empty": "គ្មានអ្វីត្រូវនាំចេញ"
          },
          "export-cols": {
            "code": "លេខកូដ",
            "critical": "តួនាទីសំខាន់",
            "yes": "បាទ/ចាស",
            "no": "ទេ",
            "certifications": "វិញ្ញាបនបត្រដែលត្រូវការ"
          },
          "detail": {
            "title": "កម្រងការងារ · {title}",
            "loading": "កំពុងផ្ទុកកម្រងពេញលេញ…",
            "load-error": "មិនអាចផ្ទុកកម្រងពេញលេញបានទេ — កំពុងបង្ហាញច្បាប់សង្ខេប។",
            "job-title": "ងារតួនាទី",
            "family": "ក្រុមការងារ",
            "grade": "ថ្នាក់",
            "salary-band": "ចន្លោះប្រាក់ខែ",
            "hours": "ម៉ោងធ្វើការ / សប្តាហ៍",
            "hours-value": "{hours} ម៉ោង",
            "last-updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
            "status": "ស្ថានភាព",
            "active": "សកម្ម",
            "removed": "បានដកចេញនៅ {date}",
            "critical-yes": "តួនាទីសំខាន់",
            "critical-no": "មិនមែនជាតួនាទីសំខាន់",
            "empty-section": "មិនទាន់បំពេញ។",
            "none": "—",
            "ksa": "ចំណេះដឹង ជំនាញ និងសមត្ថភាព",
            "strategic": "ទង់យុទ្ធសាស្ត្រ",
            "close": "បិទ",
            "edit": "កែសម្រួលកម្រង",
            "print": "បោះពុម្ព / រក្សាទុកជា PDF",
            "history": "ប្រវត្តិ",
            "body-label": "មាតិកាកម្រងការងារ — {title}"
          },
          "print": {
            "heading": "កម្រងការងារ",
            "job-title": "ងារតួនាទី៖",
            "job-grade": "ថ្នាក់ការងារ៖",
            "last-update": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖",
            "job-summary": "សេចក្តីសង្ខេបការងារ",
            "responsibilities": "ទំនួលខុសត្រូវ",
            "requirements": "លក្ខខណ្ឌតម្រូវ",
            "core-competencies": "សមត្ថភាពស្នូល",
            "job-holder": "អ្នកកាន់តំណែង៖",
            "line-manager": "អ្នកគ្រប់គ្រងផ្ទាល់៖",
            "name": "ឈ្មោះ៖",
            "date": "កាលបរិច្ឆេទ៖"
          },
          "history": {
            "title": "ប្រវត្តិកម្រងការងារ",
            "job-summary": "សេចក្តីសង្ខេបការងារ",
            "responsibilities": "ទំនួលខុសត្រូវ",
            "requirements": "លក្ខខណ្ឌតម្រូវ",
            "core-competency": "សមត្ថភាពស្នូល",
            "hours": "ម៉ោងធ្វើការ / សប្តាហ៍",
            "knowledge": "ចំណេះដឹង",
            "skills": "ជំនាញ",
            "abilities": "សមត្ថភាព",
            "certifications": "វិញ្ញាបនបត្រដែលត្រូវការ",
            "critical": "តួនាទីសំខាន់",
            "succession": "កំណត់ចំណាំការបន្តវេន",
            "learning": "ផ្លូវសិក្សា",
            "performance": "វិមាត្រការអនុវត្ត",
            "status": "ស្ថានភាព",
            "removed-at": "បានដកចេញនៅ",
            "removed-by": "ដកចេញដោយ"
          },
          "inactive-title": "ងារតួនាទីអសកម្ម"
        },
        "grades": {
          "banner-lead": "ថ្នាក់ការងារ",
          "banner-mid": " កំណត់ក្រុមប្រាក់ខែ និងឋានានុក្រមអតីតភាព។ ងារតួនាទីនីមួយៗប្រកាស",
          "banner-emphasis": "ថ្នាក់លំនាំដើម",
          "banner-rest": " ហើយមុខតំណែងនីមួយៗទទួលថ្នាក់ពីងារតួនាទីរបស់ខ្លួន។ ប្រាក់ខែក្រៅក្រុមនៅពេលបន្ថែមបុគ្គលិក នឹងបង្ហាញការព្រមានស្រាល។",
          "kpi": {
            "active": "ថ្នាក់សកម្ម",
            "lowest-min": "ប្រាក់ខែអប្បបរមាទាបបំផុត",
            "highest-max": "ប្រាក់ខែអតិបរមាខ្ពស់បំផុត",
            "orphan-main": "ថ្នាក់គ្មានងារ",
            "orphan-sub": "(គ្មានងារតួនាទី)",
            "primary-currency-caption": "({currency} · ថ្នាក់ច្រើនបំផុត)"
          },
          "currency-filter-label": "រូបិយប័ណ្ណ",
          "currency-all": "ទាំងអស់",
          "toolbar-summary-head": "សកម្ម {active} · អសកម្ម {inactive}",
          "toolbar-summary-overlaps": "ក្រុមត្រួតគ្នា {overlaps}",
          "show-inactive": "បង្ហាញអសកម្ម",
          "add": "បន្ថែមថ្នាក់ការងារ",
          "cols": {
            "code": "កូដ",
            "grade": "ទម្ងន់ថ្នាក់",
            "title": "ងារ",
            "min": "ប្រាក់ខែអប្បបរមា",
            "max": "ប្រាក់ខែអតិបរមា",
            "currency": "រូបិយប័ណ្ណ",
            "titles": "ងារតួនាទី",
            "positions": "មុខតំណែងបានបំពេញ",
            "description": "ការពិពណ៌នា",
            "status": "ស្ថានភាព",
            "level": "កម្រិតអតីតភាព"
          },
          "status": {
            "active": "សកម្ម",
            "inactive": "អសកម្ម"
          },
          "loading": "កំពុងផ្ទុកថ្នាក់ការងារ…",
          "error": "មិនអាចផ្ទុកថ្នាក់ការងារបានទេ — {message}",
          "retry": "ព្យាយាមឡើងវិញ",
          "errors": {
            "conflict": "មានថ្នាក់ការងារដែលប្រើកូដ ឬទម្ងន់ថ្នាក់នេះរួចហើយ។ សូមប្រើកូដ ឬទម្ងន់ផ្សេង។",
            "forbidden": "អ្នកមិនមានសិទ្ធិគ្រប់គ្រងថ្នាក់ការងារសម្រាប់ក្រុមហ៊ុននេះទេ។",
            "generic": "មិនអាចរក្សាទុកថ្នាក់ការងារបានទេ។ សូមព្យាយាមម្តងទៀត។"
          },
          "empty": {
            "title": "មិនទាន់មានថ្នាក់ការងារ",
            "subtitle": "បង្កើតក្រុមអតីតភាពដំបូងរបស់អ្នក ដើម្បីចាប់ផ្តើមបង្កើតកាំជណ្តើរថ្នាក់។"
          },
          "modal": {
            "title": "ថ្នាក់ការងារថ្មី",
            "subtitle": "កំណត់ក្រុមអតីតភាពថ្មី",
            "sections": {
              "identity": "អត្តសញ្ញាណ",
              "salary": "ក្រុមប្រាក់ខែ (សរុប ប្រចាំខែ)",
              "description": "ការពិពណ៌នា"
            },
            "fields": {
              "code": {
                "label": "កូដ",
                "placeholder": "ឧ. L5",
                "hint": "កូដបង្ហាញខ្លី (ឧ. L5)"
              },
              "grade": {
                "label": "ថ្នាក់",
                "placeholder": "ឧ. 5",
                "hint": "ទម្ងន់ជាលេខសម្រាប់តម្រៀប — ខ្ពស់ជាង = ថ្នាក់ខ្ពស់ជាង"
              },
              "title": {
                "label": "ងារ",
                "placeholder": "ឧ. អ្នកគ្រប់គ្រងជាន់ខ្ពស់"
              },
              "min": {
                "label": "អប្បបរមា",
                "placeholder": "ឧ. 5000"
              },
              "max": {
                "label": "អតិបរមា",
                "placeholder": "ឧ. 8000"
              },
              "currency": {
                "label": "រូបិយប័ណ្ណ"
              },
              "description": {
                "placeholder": "អ្នកណាសមនឹងថ្នាក់នេះ? ឆ្នាំបទពិសោធន៍ វិសាលភាព កម្រិតសិទ្ធិអំណាច…"
              },
              "level": {
                "label": "កម្រិតអតីតភាព",
                "placeholder": "ឧ. ថ្នាក់គ្រប់គ្រងកណ្តាល",
                "hint": "ឋានៈដែលថ្នាក់នេះស្ថិតនៅ (ស្រេចចិត្ត)"
              }
            },
            "note-before": "ថ្នាក់ថ្មីចាប់ផ្តើមជា",
            "note-active": "សកម្ម",
            "note-after": " ហើយបង្ហាញក្នុងបញ្ជីជ្រើសរើសថ្នាក់ភ្លាមៗ។ បិទ / បើកឡើងវិញ / ប្រវត្តិ នឹងមាននៅទីនេះបន្ទាប់ពីបង្កើតថ្នាក់រួច។",
            "errors": {
              "grade-required": "តម្រូវឱ្យមានថ្នាក់។",
              "grade-numeric": "ថ្នាក់ត្រូវតែជាលេខត្រឹមត្រូវ។",
              "grade-taken": "ថ្នាក់នេះត្រូវបានប្រើរួចហើយ។",
              "code-taken": "កូដនេះត្រូវបានប្រើរួចហើយ។",
              "code-required": "តម្រូវឱ្យមានកូដ។",
              "title-required": "តម្រូវឱ្យមានងារ។",
              "salary-required": "តម្រូវឱ្យមានប្រាក់ខែអប្បបរមា និងអតិបរមា។",
              "numeric": "អប្បបរមា និងអតិបរមា ត្រូវតែជាលេខត្រឹមត្រូវ។",
              "max-below-min": "ប្រាក់ខែអតិបរមាត្រូវតែធំជាង ឬស្មើនឹងប្រាក់ខែអប្បបរមា។",
              "employer-missing": "មិនមាននិយោជកសកម្មទេ — សូមបើកទំព័រនេះឡើងវិញ ហើយព្យាយាមម្ដងទៀត។",
              "level-too-long": "កម្រិតអតីតភាពត្រូវមានមិនលើសពី 200 តួអក្សរ។",
              "level-cleared": "មិនអាចលុបកម្រិតអតីតភាពចោលបានទេ បន្ទាប់ពីបានកំណត់រួច — សូមបញ្ចូលតម្លៃជំនួសវិញ។"
            },
            "cancel": "បោះបង់",
            "create": "បង្កើតថ្នាក់",
            "creating": "កំពុងបង្កើត…",
            "success": "បានបង្កើតថ្នាក់ការងារ {code}។"
          },
          "edit": {
            "title": "កែថ្នាក់ការងារ · {code}",
            "history": "ប្រវត្តិ",
            "history-soon": "ប្រវត្តិ — នឹងមានឆាប់ៗ",
            "save-changes": "រក្សាទុកការផ្លាស់ប្តូរ",
            "saving": "កំពុងរក្សាទុក…",
            "cancel": "បោះបង់",
            "success": "បានកែថ្នាក់ការងារ {code}។",
            "code-locked": "កូដត្រូវបានចាក់សោបន្ទាប់ពីបង្កើត (យោងដោយងារតួនាទី)។",
            "code-editable": "មិនទាន់មានកូដ — បន្ថែមមួយ (យោងដោយងារតួនាទី រួចចាក់សោ)។",
            "inactive-notice-lead": "ថ្នាក់ការងារនេះអសកម្ម",
            "inactive-notice-rest": "។ ប្រវត្តិកែប្រែត្រូវបានរក្សាទុក។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោម ដើម្បីនាំវាត្រឡប់មកវិញ។",
            "inactive-notice-rest-dated": " (បានបិទនៅ {date})។ ប្រវត្តិកែប្រែត្រូវបានរក្សាទុក។ ប្រើប៊ូតុងបើកឡើងវិញខាងក្រោម ដើម្បីនាំវាត្រឡប់មកវិញ។",
            "overlap-lead": "ក្រុមត្រួតគ្នា",
            "overlap-detail": "ជាមួយ៖ {code} ({min}–{max})។ វាត្រូវបានអនុញ្ញាត (ការព្រមានស្រាល) ប៉ុន្តែជាទូទៅថ្នាក់មិនគួរត្រួតគ្នាទេ។",
            "usage": {
              "titles-suffix": "ងារតួនាទី យោងលើថ្នាក់នេះ",
              "positions-suffix": "មុខតំណែងបានបំពេញ នៅថ្នាក់នេះ"
            },
            "deactivate": {
              "heading": "បិទថ្នាក់ការងារ",
              "explanation": "ថ្នាក់ដែលបានបិទនឹងលាក់ពីបញ្ជីជ្រើសរើស ប៉ុន្តែរក្សាទុកសម្រាប់ការត្រួតពិនិត្យ។ ការលុបជាអចិន្ត្រៃយ៍មិនត្រូវបានអនុញ្ញាតទេ — បន្ទាប់ពីបានកំណត់ ថ្នាក់ការងារតែងតែនៅក្នុងមូលដ្ឋានទិន្នន័យ។",
              "cannot": "មិនអាចបិទបានទេ — ថ្នាក់នេះកំពុងត្រូវបានប្រើ៖",
              "reason-titles": "ងារតួនាទី {count} យោងវាជាថ្នាក់លំនាំដើម",
              "reason-positions": "មុខតំណែងបានបំពេញ {count} នៅថ្នាក់នេះ",
              "reassign-note": "សូមផ្ដល់ឱ្យពួកវាទៅថ្នាក់ផ្សេងជាមុនសិន រួចត្រឡប់មកទីនេះ។",
              "action": "បិទថ្នាក់នេះ",
              "cannot-lead": "មិនអាចបិទបានទេ",
              "cannot-rest": " — ថ្នាក់នេះកំពុងត្រូវបានប្រើ៖",
              "reason-titles-count": "ងារតួនាទី {count}",
              "reason-titles-rest": " យោងវាជាថ្នាក់លំនាំដើម",
              "reason-positions-count": "មុខតំណែងបានបំពេញ {count}",
              "reason-positions-rest": " នៅថ្នាក់នេះ"
            },
            "reactivate": {
              "heading": "បើកថ្នាក់ការងារឡើងវិញ",
              "explanation": "ការបើកឡើងវិញ ស្ដារថ្នាក់នេះទៅជាសកម្ម។ វានឹងបង្ហាញក្នុងបញ្ជីជ្រើសរើសថ្នាក់ម្តងទៀត។ ប្រវត្តិកែប្រែបន្តដោយមិនផ្លាស់ប្តូរ។",
              "action": "បើកថ្នាក់នេះឡើងវិញ"
            },
            "history-aria": "បង្ហាញប្រវត្តិកែប្រែសម្រាប់ថ្នាក់ {code}",
            "history-fields": {
              "salary-range": "ជួរប្រាក់ខែ",
              "deactivated-at": "បិទដំណើរការនៅ"
            }
          },
          "search": {
            "label": "ស្វែងរកថ្នាក់ការងារ",
            "placeholder": "ស្វែងរកកូដ ងារ កម្រិត…"
          },
          "export": "នាំចេញ",
          "export-aria": "នាំចេញថ្នាក់ការងារ {count} ដែលកំពុងបង្ហាញទៅ Excel",
          "export-empty": "គ្មានអ្វីត្រូវនាំចេញទេ — មិនមានថ្នាក់ការងារណាកំពុងបង្ហាញ។",
          "result-count": "{shown} ក្នុងចំណោម {total} ថ្នាក់",
          "chips": {
            "search": "ស្វែងរក៖ {q}",
            "currency": "រូបិយប័ណ្ណ៖ {currency}",
            "inactive": "រួមទាំងអសកម្ម",
            "remove": "ដកតម្រង៖ {label}",
            "clear-all": "សម្អាតទាំងអស់"
          },
          "no-match": {
            "title": "គ្មានថ្នាក់ការងារណាត្រូវនឹងតម្រងទាំងនេះទេ។",
            "clear": "សម្អាតតម្រង"
          },
          "sort-aria": "តម្រៀបតាម {column}"
        }
      },
      "salaryBatch": {
        "button": "បង្វិលប្រាក់ខែជាបាច់",
        "modal": {
          "title": "ការកែប្រាក់ខែជាបាច់",
          "subtitle": "ធ្វើបច្ចុប្បន្នភាពប្រាក់ខែបុគ្គលិកជាច្រើននាក់ពី Excel ជាមួយការផ្ទៀងផ្ទាត់ភ្លាមៗ។"
        },
        "steps": {
          "upload": "ផ្ទុកឯកសារ",
          "validation": "ការផ្ទៀងផ្ទាត់",
          "confirm": "ការបញ្ជាក់"
        },
        "tabs": {
          "batch": "បាច់ថ្មី",
          "history": "ប្រវត្តិបាច់"
        },
        "footer": {
          "cancel": "បោះបង់",
          "validate": "ផ្ទៀងផ្ទាត់",
          "confirmApply": "បញ្ជាក់ & អនុវត្ត",
          "nextValidation": "បន្ទាប់: ការផ្ទៀងផ្ទាត់",
          "nextConfirm": "បន្ទាប់: ការបញ្ជាក់",
          "back": "ថយក្រោយ"
        },
        "confirm": {
          "summaryTitle": "សង្ខេបការអនុវត្ត",
          "rowsToApply": "ជួរដែលត្រូវអនុវត្ត",
          "warningsOverridden": "ការព្រមានដែលបានជ្រួស",
          "noRowsToApply": "មិនមានជួរត្រឹមត្រូវសម្រាប់អនុវត្ត។ សូមត្រឡប់ក្រោយ ហើយពិនិត្យលទ្ធផលផ្ទៀងផ្ទាត់។",
          "note": "ការផ្លាស់ប្តូរប្រាក់ខែគឺជារៀងរហូត ហើយមិនអាចត្រឡប់វិញបាន។ សូមពិនិត្យលទ្ធផលផ្ទៀងផ្ទាត់មុនពេលបញ្ជាក់។"
        },
        "instructions": {
          "title": "ការណែនាំ & តម្រូវការ",
          "step1Title": "ជំហានទី ១ — បង្កើតពុម្ព",
          "step1Bullet1": "ជ្រើសតម្រងវិសាលភាព (នាយកដ្ឋាន, ទីតាំង) ប្រសិនចង់ ហើយចុចបង្កើតពុម្ព។",
          "step1Bullet2": "ដោយគ្មានតម្រង ពុម្ពរួមមានបុគ្គលិកសកម្មទាំងអស់។ មានតម្រង មានតែបុគ្គលិកដែលត្រូវគ្នាប៉ុណ្ណោះ។",
          "step1Bullet3": "ទាញយកឯកសារ ហើយបំពេញ: ប្រាក់ខែមូលដ្ឋានថ្មី (លេខវិជ្ជមាន), កាលបរិច្ឆេទចូលជាធរមាន (YYYY-MM-DD), ហេតុផល (ចាំបាច់)។",
          "step1Bullet4": "ជួរឈរដែលអានបាន — លេខកូដបុគ្គលិក ឈ្មោះពេញ ប្រាក់ខែបច្ចុប្បន្ន — កុំកែទាំងនេះ។",
          "step2Title": "ជំហានទី ២ — ផ្ទុកឡើង & ផ្ទៀងផ្ទាត់",
          "step2Bullet1": "ទទួលឯកសារ .xlsx ប៉ុណ្ណោះ។ ទំហំអតិបរមា: 5 MB។",
          "step2Bullet2": "កុំកែសន្លឹកទិន្នន័យលាក់ — វាត្រូវបានប្រើដើម្បីផ្ទៀងផ្ទាត់ភាពត្រឹមត្រូវនៃពុម្ព។",
          "step2Bullet3": "ការចុចផ្ទៀងផ្ទាត់គឺជាការសាកល្បង — គ្មានកំណត់ត្រាប្រាក់ខែត្រូវបានបង្កើត។",
          "step2Bullet4": "ជួរដែលមានកំហុសមិនអាចអនុវត្ត។ ជួរដែលមានការព្រមានអាចត្រូវបានជ្រួស។"
        },
        "scopeFilters": {
          "title": "វិសាលភាព & ពុម្ព",
          "optional": "(ស្រេចចិត្ត)",
          "orgUnit": "អង្គភាពស្ថាប័ន",
          "orgUnitPlaceholder": "អង្គភាពទាំងអស់",
          "baseLocation": "ទីតាំងមូលដ្ឋាន",
          "baseLocationPlaceholder": "ទីតាំងទាំងអស់",
          "downloadBtn": "ទាញយកពុម្ព",
          "downloading": "កំពុងទាញយក…",
          "descriptionAll": "និយោជិតសកម្មទាំងអស់",
          "descriptionFiltered": "និយោជិតដែលត្រូវបានត្រងតែប៉ុណ្ណោះ"
        },
        "upload": {
          "title": "ផ្ទុកឡើងពុម្ពដែលបានបំពេញ",
          "dropHint": "ទម្លាក់ឯកសារ ឬចុចដើម្បីរុករក",
          "fileTypeHint": "ឯកសារ .xlsx ប៉ុណ្ណោះ",
          "fileSizeLimit": "អតិបរមា {size} MB",
          "removeFile": "លុបឯកសារ"
        },
        "preview": {
          "title": "មើលជាមុនក្រោយផ្ទៀងផ្ទាត់",
          "statTotal": "សរុប:",
          "statValid": "ត្រឹមត្រូវ:",
          "statInvalid": "កំហុស:",
          "statWarnings": "ការព្រមាន:",
          "statPending": "រង់ចាំការផ្ទៀងផ្ទាត់",
          "colNum": "#",
          "colStatus": "ស្ថានភាព",
          "colEmployeeCode": "លេខកូដបុគ្គលិក",
          "colFullName": "ឈ្មោះពេញ",
          "colCurrentSalary": "ប្រាក់ខែបច្ចុប្បន្ន",
          "colNewSalary": "ប្រាក់ខែថ្មី",
          "colEffectiveDate": "កាលបរិច្ឆេទចូលជាធរមាន",
          "colReason": "ហេតុផល",
          "colRemark": "ចំណាំ",
          "colOverride": "ជ្រួស",
          "statusValid": "ត្រឹមត្រូវ",
          "statusError": "កំហុស",
          "statusWarning": "ការព្រមាន",
          "statusPending": "កំពុងរង់ចាំ",
          "statusUnknown": "មិនស្គាល់",
          "exportErrors": "នាំចេញកំហុស",
          "warningOverrideBanner": "ជួរខ្លះ​មានការ​ព្រមាន។ ធីក​ប្រអប់​ជ្រួស​ ដើម្បី​រួម​បញ្ចូល​ក្នុង​ការ​អនុវត្ត។",
          "csvColRow": "ជួរ",
          "csvColErrors": "កំហុស / ការព្រមាន"
        },
        "result": {
          "successTitle": "បានអនុវត្តការកែប្រាក់ខែ",
          "successSub": "{succeeded} កំណត់ត្រា​ត្រូវ​បាន​ធ្វើ​បច្ចុប្បន្ន​ភាព​ដោយ​ជោគ​ជ័យ។",
          "successSubFailed": " {failed} បរាជ័យ។",
          "downloadResult": "ទាញយកឯកសារលទ្ធផល",
          "downloadOriginal": "ទាញយកឯកសារដើម"
        },
        "history": {
          "description": "ការ​កែ​ប្រាក់​ខែ​ជា​បាច់​ពី​មុន​សម្រាប់​និយោជ​ករ​រូប​នេះ។",
          "loading": "កំពុងបង្ហាញប្រវត្តិ…",
          "empty": "មិន​ទាន់​មាន​ប្រវត្តិ​បាច់​នៅ​ឡើយ។",
          "unknown": "មិនស្គាល់",
          "batchId": "លេខ​បាច់",
          "validated": "បាន​ផ្ទៀង​ផ្ទាត់",
          "applied": "បាន​អនុវត្ត",
          "validateSummaryValue": "{valid} ត្រឹមត្រូវ / {total} សរុប",
          "applySummaryValue": "{succeeded} ជោគជ័យ, {failed} បរាជ័យ / {total} សរុប",
          "importedOf": "{succeeded} / {total} បាន​អនុវត្ត",
          "rowsCount": "{count} ជួរ",
          "downloadResult": "ទាញ​យក​លទ្ធ​ផល",
          "downloadOriginal": "ទាញ​យក​ប្រភព"
        },
        "errors": {
          "filterLoadFailed": "មិន​អាច​ផ្ទុក​ជម្រើស​ត្រង​បាន​ទេ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "generateFailed": "មិន​អាច​បង្កើត​ពុម្ព​បាន​ទេ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "invalidTemplateResponse": "ការ​ឆ្លើយ​តប​ពុម្ព​មិន​ត្រឹម​ត្រូវ​ពី​ម៉ាស៊ីន​បម្រើ។",
          "onlyXlsx": "ទទួល​យក​ឯក​សារ .xlsx ប៉ុណ្ណោះ។",
          "fileTooLarge": "ឯក​សារ​លើស {size} MB ។",
          "noDataRows": "ឯក​សារ​គ្មាន​ជួរ​ទិន្នន័យ​ទេ។",
          "parseError": "មិន​អាច​អាន​ឯក​សារ​បាន​ទេ។ សូម​ប្រាកដ​ថា​វា​ជា​ឯក​សារ .xlsx ត្រឹម​ត្រូវ។",
          "readError": "មិន​អាច​អាន​ឯក​សារ​ពី​ថា​ស​ក្បាល​បាន​ទេ។",
          "validateFailed": "ការ​ផ្ទៀង​ផ្ទាត់​បរាជ័យ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "applyFailed": "ការ​អនុវត្ត​បរាជ័យ។ សូម​ព្យា​យាម​ម្ដង​ទៀត។",
          "historyLoadFailed": "មិន​អាច​ផ្ទុក​ប្រវត្តិ​បាច់​បាន​ទេ។",
          "resultDownloadFailed": "មិន​អាច​ទាញ​យក​ឯក​សារ​លទ្ធ​ផល​បាន​ទេ។",
          "originalDownloadFailed": "មិន​អាច​ទាញ​យក​ឯក​សារ​ដើម​បាន​ទេ។"
        }
      },
      "profile": {
        "joined": "ចូលបម្រើការ",
        "message": "ទំនាក់ទំនង",
        "edit": "កែប្រែ",
        "coming-soon": "នឹងមានក្នុងការអាប់ដេតបន្ទាប់",
        "photo": {
          "upload-tooltip": "ផ្លាស់ប្ដូររូបថតប្រវត្តិ",
          "upload-success": "រូបថតប្រវត្តិត្រូវបានធ្វើបច្ចុប្បន្នភាព។",
          "upload-error": "ការធ្វើបច្ចុប្បន្នភាពរូបថតប្រវត្តិបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។",
          "remove": "លុបរូបថត"
        },
        "error": "បរាជ័យក្នុងការផ្ទុកប្រវត្តិបុគ្គលិក។",
        "retry": "ព្យាយាមម្ដងទៀត",
        "nav-label": "ផ្នែកប្រវត្តិ",
        "tabs": {
          "overview": "ទិដ្ឋភាពទូទៅ",
          "job": "ការងារ និងអង្គភាព",
          "contract": "កិច្ចសន្យា",
          "employment-actions": "សកម្មភាពការងារ",
          "compensation": "សំណង",
          "benefits": "អត្ថប្រយោជន៍",
          "payroll": "បើកប្រាក់ខែ",
          "attendance": "វត្តមាន",
          "documents": "ឯកសារ",
          "personal": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "journey": "ដំណើរការការងារ"
        },
        "contract": {
          "current-contract": "កិច្ចសន្យាបច្ចុប្បន្ន",
          "readonly-label": "អានបានតែ",
          "readonly-structural": "ការផ្លាស់ប្ដូររចនាសម្ព័ន្ធគឺជា ព្រឹត្តិការណ៍កិច្ចសន្យា",
          "readonly-pay": "ការផ្លាស់ប្ដូរប្រាក់ខែគឺជា ការកែប្រែប្រាក់ខែ",
          "contract-type": "ប្រភេទកិច្ចសន្យា",
          "status": "ស្ថានភាព",
          "start-date": "កាលបរិច្ឆេទចាប់ផ្ដើម",
          "end-date": "កាលបរិច្ឆេទបញ្ចប់",
          "ongoing": "កំពុងដំណើរការ",
          "end-date-ongoing": "— កំពុងដំណើរការ",
          "probation-end": "ថ្ងៃបញ្ចប់ការសាកល្បង",
          "base-salary-monthly": "ប្រាក់បៀវត្សមូលដ្ឋានកិច្ចសន្យា",
          "base-salary-hint": "/ ខែ — នៅពេលចុះហត្ថលេខា",
          "base-salary-no-adj": "គ្មានការកែប្រែប្រាក់ខែចាប់តាំងពីការចុះហត្ថលេខា — ប្រាក់ខែមូលដ្ឋានកិច្ចសន្យា = ប្រាក់ខែដែលមានប្រសិទ្ធភាពបច្ចុប្បន្ន។",
          "all-contracts": "កិច្ចសន្យាទាំងអស់",
          "all-contracts-desc": "រាល់ជួរគឺជាកិច្ចសន្យាដែលបានចុះហត្ថលេខាដាច់ដោយឡែក។ កិច្ចសន្យាថ្មីមកពី ព្រឹត្តិការណ៍កិច្ចសន្យា (ការបន្ត · ការពន្យារ · ការបម្លែង · ការកែប្រែ)។ ការកែប្រែប្រាក់ខែមិនបង្កើតជួរកិច្ចសន្យាថ្មីទេ។",
          "col-start": "ចាប់ផ្ដើម",
          "col-end": "បញ្ចប់",
          "col-type": "ប្រភេទ",
          "col-base-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "col-status": "ស្ថានភាព",
          "col-actions": "សកម្មភាព",
          "no-contracts": "មិនមានកិច្ចសន្យា",
          "add": "កិច្ចសន្យាថ្មី",
          "edit": "កែប្រែកិច្ចសន្យា",
          "delete": "លុបកិច្ចសន្យា",
          "confirm-delete": "លុបកិច្ចសន្យានេះ? វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-delete-yes": "បាទ/ចាស លុប",
          "confirm-delete-no": "បោះបង់",
          "events-title": "ព្រឹត្តិការណ៍កិច្ចសន្យា",
          "events-subtitle": "កត់ត្រាការផ្លាស់ប្ដូរវដ្ដជីវិតកិច្ចសន្យា: បន្ត · ពន្យារ · បម្លែង · កែប្រែ · ការជ្រើសរើស · បញ្ចប់។ ដំណាក់កាល ១ — ការកត់ត្រាតែប៉ុណ្ណោះ។",
          "events-add": "បន្ថែមព្រឹត្តិការណ៍កិច្ចសន្យា",
          "events-empty-title": "មិនទាន់មានព្រឹត្តិការណ៍កិច្ចសន្យា",
          "events-empty-hint": "ប្រើផ្ទៃនេះ នៅពេល HR ទទួលបានកិច្ចសន្យា / ការបន្ត / ការកែប្រែ / ការជ្រើសរើស ក្រៅបណ្ដាញ ហើយត្រូវការកត់ត្រា។",
          "events-col-effective": "ចូលជាធរមាន",
          "events-col-event": "ព្រឹត្តិការណ៍",
          "events-col-detail": "ព័ត៌មានលម្អិត",
          "events-col-status": "ស្ថានភាព",
          "salary-adj-title": "ប្រវត្តិការកែប្រែប្រាក់ខែ",
          "salary-adj-subtitle": "ព្រឹត្តិការណ៍ប្រាក់ចំណូលដែលផ្លាស់ប្ដូរប្រាក់ខែជាប់ពន្ធ ដោយមិនកែប្រែកិច្ចសន្យដែលបានចុះហត្ថលេខា។",
          "salary-adj-count": "ការកែប្រែ {n}",
          "salary-adj-col-effective-date": "កាលបរិច្ឆេទចូលជាធរមាន",
          "salary-adj-col-from": "ពី",
          "salary-adj-col-to": "ទៅ",
          "salary-adj-col-reason": "មូលហេតុ",
          "salary-adj-col-status": "ស្ថានភាព",
          "salary-adj-note": "ប្រាក់ខែមូលដ្ឋានកិច្ចសន្យាដែលបានចុះហត្ថលេខាខាងលើគឺចាក់ស្ថិតិ។ ការកែប្រែកិច្ចសន្យាផ្ទាល់ ទាមទារ ព្រឹត្តិការណ៍កិច្ចសន្យា (ការកែប្រែ / ការបន្ត / ការបម្លែង)។ ការកែប្រែប្រាក់ខែ ត្រូវបានកត់ត្រាតាម ផ្ទាំងប្រាក់ចំណូល → កំណត់ព្រឹត្តិការណ៍ប្រាក់ចំណូល → ការកែប្រែប្រាក់ខែ។"
        },
        "more-menu": {
          "label": "សកម្មភាពបន្ថែម",
          "section-contract": "សកម្មភាពកិច្ចសន្យា",
          "section-other": "ផ្សេងទៀត",
          "new-contract": "កិច្ចសន្យាថ្មី",
          "new-contract-sub": "បង្កើតកិច្ចសន្យាថ្មីសម្រាប់បុគ្គលិកនេះ",
          "renew-contract": "បន្តកិច្ចសន្យា",
          "renew-contract-sub": "ពន្យាររយៈពេលកិច្ចសន្យាបច្ចុប្បន្ន",
          "rehire": "ជ្រើសរើសមកវិញ",
          "rehire-sub": "ជួលបុគ្គលិកដែលធ្លាប់ចាកចេញឡើងវិញ",
          "download-pdf": "ទាញយកកិច្ចសន្យា PDF",
          "download-pdf-unavailable": "ការនាំចេញ PDF កិច្ចសន្យានៅមិនទាន់អាចធ្វើបានទេ។",
          "delete-employee": "លុបប្រវត្តិបុគ្គលិក",
          "delete-employee-confirm-title": "លុបប្រវត្តិបុគ្គលិក",
          "delete-employee-confirm-body": "សកម្មភាពនេះជាអចិន្ត្រៃយ៍ ហើយមិនអាចដកហូតវិញបាន។ តើអ្នកប្រាកដថាចង់លុបជាអចិន្ត្រៃយ៍",
          "delete-employee-confirm-yes": "បាទ/ចាស លុប",
          "delete-employee-confirm-no": "បោះបង់",
          "delete-employee-error": "ការលុបបុគ្គលិកបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។"
        },
        "contract-drawer": {
          "title": {
            "new": "កិច្ចសន្យាថ្មី",
            "renew": "បន្តកិច្ចសន្យា",
            "rehire": "ជ្រើសរើសបុគ្គលិកឡើងវិញ"
          },
          "subtitle": {
            "new": "បង្កើតកិច្ចសន្យាការងារថ្មី",
            "renew": "ពន្យារកិច្ចសន្យាបច្ចុប្បន្នជាមួយរយៈពេលថ្មី",
            "rehire": "ជ្រើសរើសបុគ្គលិកនេះឡើងវិញក្រោមកិច្ចសន្យាថ្មី"
          },
          "rehire-note": "វានឹងបង្កើតកិច្ចសន្យាថ្មី និងសម្គាល់បុគ្គលិកថាជ្រើសរើសឡើងវិញ។ ត្រូវប្រាកដថាឯកសារចាំបាច់ទាំងអស់ត្រូវបានបំពេញ មុនពេលបន្ត។",
          "field-type": "ប្រភេទកិច្ចសន្យា",
          "field-type-placeholder": "ជ្រើសប្រភេទកិច្ចសន្យា",
          "field-employment-type": "ប្រភេទការងារ",
          "field-start-date": "ថ្ងៃចាប់ផ្ដើម",
          "field-end-date": "ថ្ងៃបញ្ចប់",
          "field-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "field-salary-placeholder": "ឧ. 1200",
          "field-position": "មុខតំណែង (តារាងស្ថាប័ន)",
          "field-position-placeholder": "ជ្រើសរើសមុខតំណែងទំនេរ",
          "field-position-hint": "ស្រេចចិត្ត — ភ្ជាប់កិច្ចសន្យានេះទៅនឹងមុខតំណែងទំនេរក្នុងតារាងស្ថាប័ន។",
          "position-loading": "កំពុងផ្ទុកមុខតំណែង…",
          "position-empty": "មិនមានមុខតំណែងទំនេរ។",
          "field-reason": "មូលហេតុ",
          "field-reason-placeholder": "មូលហេតុសម្រាប់សកម្មភាពកិច្ចសន្យានេះ",
          "error-start-required": "ថ្ងៃចាប់ផ្ដើមត្រូវការ។",
          "error-end-required": "ថ្ងៃបញ្ចប់ត្រូវការសម្រាប់ប្រភេទកិច្ចសន្យានេះ។",
          "error-end-after-start": "ថ្ងៃបញ្ចប់ត្រូវនៅក្រោយថ្ងៃចាប់ផ្ដើម។",
          "error-reason-required": "មូលហេតុត្រូវការ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
          "cancel": "បោះបង់",
          "save": "រក្សាទុककិច្ចសន្យា",
          "saving": "កំពុងរក្សាទុក…"
        },
        "employment-actions": {
          "title": "សកម្មភាពការងារ",
          "subtitle": "កំណត់ EA ស្របតួនាទី · កាតាឡុក v1 ៣ សកម្មភាព · §9.6 រក្សាទុក · ស្លាកដែលទាញចេញត្រូវបានរក្សា",
          "frozen-chip": "CI Rev 3.2.1 · ជំហានដែលបានតម្កល់",
          "new-action": "+ សកម្មភាពការងារថ្មី",
          "error": "បរាជ័យក្នុងការផ្ទុកសកម្មភាពការងារ។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "phase1-bold": "ដំណាក់កាល ១ · ការកត់ត្រាតែប៉ុណ្ណោះ។",
          "phase1-notice": "HR កត់ត្រានូវអ្វីដែលបានយល់ព្រមក្រៅបណ្ដាញ (អំផ្លិត / លិខិត / ការអនុម័ត LM)។ ស្ថានភាពត្រូវបានទាញចេញពីថ្ងៃចូលជាធរមាន — កំណត (ពេលអនាគត) ឬ ជាធរមាន (ថ្ងៃនេះ/ពីមុន)។",
          "empty-title": "មិនទាន់មានសកម្មភាពការងារសម្រាប់ {name}",
          "empty-hint": "ចុច សកម្មភាពការងារថ្មី ខាងលើ ដើម្បីបង្កើតអំបូរដំបូង។",
          "confirm-cancel": "បោះបង់សកម្មភាពការងារនេះ? វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-cancel-yes": "បាទ/ចាស បោះបង់",
          "confirm-cancel-no": "រក្សាទុក",
          "cancel-action": "បោះបង់",
          "view-detail": "មើលព័ត៌មានលម្អិត",
          "kpi": {
            "current-position": "តួនាទីបច្ចុប្បន្ន",
            "reports-to": "រាយការណ៍ទៅ",
            "eas-employee": "EA (បុគ្គលិកនេះ)",
            "eas-tenant": "EA (រួមទាំងអស់)",
            "scheduled": "កំណត",
            "effective": "ជាធរមាន",
            "cancelled": "បានបោះបង់",
            "scheduled-future": "កំណត (ពេលអនាគត)"
          },
          "col": {
            "date": "កាលបរិច្ឆេទ",
            "type": "ប្រភេទ",
            "detail": "ព័ត៌មានលម្អិត",
            "label": "ស្លាកដែលរកឃើញ",
            "status": "ស្ថានភាព"
          },
          "info": {
            "current-position": "តួនាទីបច្ចុប្បន្ន",
            "reports-to": "រាយការណ៍ទៅ",
            "eas-employee": "EA (បុគ្គលិកនេះ)",
            "eas-tenant": "EA (រួមទាំងអស់)",
            "scheduled": "កំណត",
            "effective": "ជាធរមាន",
            "cancelled": "បានបោះបង់"
          },
          "status": {
            "scheduled": "កំណត",
            "effective": "ជាធរមាន",
            "cancelled": "បានបោះបង់",
            "unknown": "មិនស្គាល់"
          },
          "field": {
            "effective-date": "ថ្ងៃចូលជាធរមាន",
            "created-by": "បង្កើតដោយ",
            "reason": "មូលហេតុ"
          },
          "detail": {
            "col-from": "ពី",
            "col-to": "ទៅ",
            "job-profile": "តួនាទីការងារ",
            "job-grade": "ចំណាត់ថ្នាក់ការងារ",
            "org-unit": "អង្គភាព",
            "basic-salary": "ប្រាក់ខែមូលដ្ឋាន",
            "employment-type": "ប្រភេទការងារ",
            "no-changes": "មិនមានទិន្នន័យលម្អិតសម្រាប់ការផ្លាស់ប្ដូរនេះទេ។"
          },
          "change-type": {
            "PROMOTE": "ការបដិភូ",
            "TRANSFER": "ការផ្ទេរ",
            "REDESIGNATION": "ការប្តូរតួនាទី",
            "INVOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយបង្ខំ",
            "VOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយស្ម័គ្រ",
            "SALARY_CHANGE": "ការផ្លាស់ប្ដូរប្រាក់ខែ",
            "SALARY_INCREASE": "ការបង្កើនប្រាក់ខែ",
            "CHANGE_EMPLOYMENT_TYPE": "ការប្តូរប្រភេទការងារ",
            "RENEW": "ការបន្តកិច្ចសន្យា",
            "SUSPEND": "ការផ្អាក",
            "DEMOTE": "ការបន្ថយតួនាទី",
            "Unknown": "មិនស្គាល់"
          },
          "modal": {
            "title-step1": "សកម្មភាពការងារថ្មី · {name}",
            "title-step2": "សកម្មភាពការងារថ្មី · {name}",
            "step1-desc": "ជំហានទី ១ ក្នុង ២ – ជ្រើសរើសប្រភេទព្រឹត្តិការណ៍ការងារ",
            "step2-desc": "ជំហានទី ២ ក្នុង ២ – ព័ត៌មានលម្អិត {type}",
            "for-label": "សម្រាប់:",
            "locked-from-profile": "ចាក់សោពីប្រវត្តិ (ឃ្លាំងស្តុក)",
            "incoming-feature": "មុខងារបន្ទាប់",
            "upcoming-feature": "⏸ មុខងារបន្ទាប់",
            "not-actionable-banner": "ស្ថានភាពបុគ្គលិកនេះគឺ រង់ចាំ ឬ អសកម្ម — សកម្មភាពការងារត្រូវការកិច្ចសន្យាសកម្ម។ ប្រើ ជួលឡើងវិញ (កិច្ចសន្យា → ព្រឹត្តិការណ៍កិច្ចសន្យាថ្មី) ប្រសិនបើពួកគេត្រូវការវិលត្រឡប់មកវិញ។",
            "not-actionable-badge": "បុគ្គលិកមិនសកម្ម",
            "field-effective-date": "ថ្ងៃចូលជាធរមាន",
            "field-reason": "មូលហេតុ",
            "field-reason-placeholder": "ផ្ដល់មូលហេតុសម្រាប់ការផ្លាស់ប្ដូរនេះ",
            "field-org-unit": "អង្គភាព / នាយកដ្ឋានគោលដៅ",
            "field-org-unit-placeholder": "ឧ. Sales, Finance",
            "field-salary": "ប្រាក់បៀវត្សមូលដ្ឋានថ្មី",
            "field-salary-placeholder": "ឧ. 1200",
            "field-doc-ref": "ឯកសារយោង",
            "field-doc-ref-placeholder": "ឧ. MEMO-2026-001, ឯកសារយោង",
            "file-upload-phase2": "ភ្ជាប់ឯកសារ — មកក្នុងដំណាក់កាល ២",
            "field-offline-approval": "ការអនុម័តក្រៅបណ្ដាញ",
            "offline-approval-label": "ការអនុម័តក្រៅបណ្ដាញបានបញ្ចប់ (អំផ្លិត / លិខិត / ការអនុម័ត LM បានទទួល)",
            "field-offline-notes": "កំណត់ហេតុការអនុម័តក្រៅបណ្ដាញ",
            "field-offline-notes-placeholder": "កំណត់ហេតុអំពីដំណើរការការអនុម័តក្រៅបណ្ដាញ",
            "cancel": "បោះបង់",
            "back": "← ត្រឡប់",
            "submit": "រក្សាទុក",
            "saving": "កំពុងរក្សាទុក…",
            "error-type-required": "សូមជ្រើសរើសប្រភេទសកម្មភាព។",
            "error-date-required": "ថ្ងៃចូលជាធរមានត្រូវបានទាមទារ។",
            "error-reason-required": "មូលហេតុត្រូវបានទាមទារ។",
            "error-no-contract": "រកមិនឃើញកិច្ចសន្យាដែលមានសម្រាប់បុគ្គលិកនេះ។",
            "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខត្រឹមត្រូវ។",
            "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
            "field-effective-date-hint": "ថ្ងៃអនាគត → កំណត · ថ្ងៃនេះ ឬ ពីមុន → ជាធរមាន",
            "promotion": {
              "info-banner": "ការបដិភូ = ការរីកចម្រើនក្នុងអាជីព ២ របៀប។ ប្រសិនបើផ្លាស់ប្ដូរតែប្រាក់ខែ (គ្មានថ្នាក់ · គ្មានតួនាទី · គ្មានចំណងជើង) ប្រើផ្ទាំងសំណង → ការកែប្រែប្រាក់ខែ។ ប្រសិនបើផ្លាស់ប្ដូរតែចំណងជើងដោយគ្មានការបង្កើនថ្នាក់/ប្រាក់ខែ ប្រើ ការប្ដូរតួនាទី។",
              "mode-a-label": "របៀប A",
              "mode-a-sub": "កៅអីថ្មីក្នុងតារាងអង្គភាព",
              "mode-a-desc": "ផ្លាស់ទៅតួនាទីផ្សេងដែលមានក្នុងប្រចាំ",
              "mode-b-label": "របៀប B",
              "mode-b-sub": "កៅអីដដែល · ថ្នាក់ ឬ កម្រិតប្រសើរ",
              "mode-b-desc": "មិនផ្លាស់ទីតួនាទី · ថ្នាក់ត្រូវខ្ពស់ជាង · ការប្ដូរចំណងជើងអាច",
              "mode-b-hint": "របៀប B: មិនចាំបាច់ផ្លាស់ទីតួនាទី។ ត្រូវប្រាកដថាថ្នាក់ថ្មីខ្ពស់ជាថ្នាក់បច្ចុប្បន្ន មុននឹងរក្សាទុក។",
              "target-position": "តួនាទីគោលដៅ",
              "target-position-placeholder": "ជ្រើសតួនាទីគោលដៅ…",
              "target-position-hint": "លុបតួនាទីបច្ចុប្បន្នរបស់បុគ្គលិកចេញ។ បង្ហាញតែកៅអីអាចចាត់តាំងបាន។",
              "companion-label": "រួមបញ្ចូលការកែប្រែប្រាក់ខែក្នុងប្រតិបត្តិការតែមួយ",
              "companion-desc": "ដកធីក ដើម្បីកត់ត្រាការបដិភូដោយគ្មានការផ្លាស់ប្ដូរប្រាក់ខែ។",
              "base-salary-label": "ប្រាក់បៀវត្សមូលដ្ឋាន",
              "base-salary-source-of-truth": "ប្រភពពិត",
              "new-base-salary-label": "ប្រាក់បៀវត្សមូលដ្ឋានថ្មី",
              "delta": "ការផ្លាស់ប្ដូរ: USD {from} → USD {to} · {sign}USD {delta} · {sign}{pct}%",
              "error-target-required": "តួនាទីគោលដៅត្រូវបានទាមទារសម្រាប់របៀប A។",
              "loading-positions": "កំពុងផ្ទុកតួនាទី…",
              "no-positions-promote": "គ្មានតួនាទីទំនេរដែលអាចប្រើបានក្នុងថ្នាក់នេះ។",
              "no-positions-transfer": "គ្មានតួនាទីអាចប្រើបានក្នុងថ្នាក់ដូចគ្នា។"
            },
            "classification": {
              "PROMOTE": {
                "title": "ការបដិភូ",
                "desc": "ការរីកចម្រើនក្នុងអាជីព · របៀប A: កៅអីថ្មី · របៀប B: ថ្នាក់ប្រសើរ"
              },
              "TRANSFER": {
                "title": "ការផ្ទេរ",
                "desc": "ចលនាប្រតិបត្តិការ · នាយកដ្ឋាន / ទីតាំង / សាខា · ជាទូទៅគ្មានការផ្លាស់ប្ដូរថ្នាក់"
              },
              "REDESIGNATION": {
                "title": "ការប្ដូរតួនាទី",
                "desc": "ការប្ដូរចំណងជើងដោយគ្មានការរីកចម្រើន · គ្មានការបង្កើនប្រាក់ខែ ឬ ថ្នាក់"
              },
              "SALARY_CHANGE": {
                "title": "ការផ្លាស់ប្ដូរប្រាក់ខែ",
                "desc": "កែតម្រូវប្រាក់ខែមូលដ្ឋាន ឬ ប្រាក់ឧបត្ថម្ភ · មានប្រសិទ្ធភាពពីកាលបរិច្ឆេទ"
              },
              "INVOLUNTARY_TERMINATION": {
                "title": "ការបញ្ចប់ការងារដោយមិនស្ម័គ្រចិត្ត",
                "desc": "ការបណ្តេញ ការចូលនិវត្តន៍ ឬ អំពើខុសក្រម · បញ្ចប់ការងារជាអចិន្ត្រៃយ៍"
              },
              "VOLUNTARY_TERMINATION": {
                "title": "ការបញ្ចប់ការងារដោយស្ម័គ្រចិត្ត",
                "desc": "ការលាឈប់របស់បុគ្គលិក · បញ្ចប់ការងារជាអចិន្ត្រៃយ៍"
              }
            },
            "salary-change": {
              "info-banner": "ការផ្លាស់ប្ដូរប្រាក់ខែធ្វើបច្ចុប្បន្នភាពប្រាក់ខែមូលដ្ឋានរបស់បុគ្គលិក។ ការកត់ត្រាទាំងស្រុងត្រូវបានរក្សាទុកជាមួយកាលបរិច្ឆេទមានប្រសិទ្ធភាព។",
              "current-label": "ប្រាក់ខែមូលដ្ឋានបច្ចុប្បន្ន",
              "new-label": "ប្រាក់ខែមូលដ្ឋានថ្មី"
            },
            "termination": {
              "warning-title": "សកម្មភាពនេះបញ្ចប់ការងារជាអចិន្ត្រៃយ៍",
              "warning-desc": "ត្រូវប្រាកដថាការងារបញ្ចប់ការងារទាំងអស់ត្រូវបានបំពេញរួចរាល់មុននឹងរក្សាទុក។ វាមិនអាចត្រូវបានដកហូតពីអេក្រង់នេះទេ។",
              "voluntary-note": "ការបញ្ចប់ការងារដោយស្ម័គ្រចិត្ត — ការលាឈប់ដោយបុគ្គលិកផ្ទាល់។",
              "involuntary-note": "ការបញ្ចប់ការងារដោយមិនស្ម័គ្រចិត្ត — ការបណ្តេញ ការចូលនិវត្តន៍ ឬ អំពើខុសក្រម។",
              "confirm-label": "ខ្ញុំបញ្ជាក់សកម្មភាពនេះ ហើយយល់ថាវាបញ្ចប់ការងារជាអចិន្ត្រៃយ៍។"
            }
          }
        },
        "personal": {
          "not-set": "—",
          "edit": "កែប្រែ",
          "history": {
            "title": "ប្រវត្តិការផ្លាស់ប្តូរ",
            "empty": "មិនទាន់មានការផ្លាស់ប្តូរត្រូវបានកត់ត្រា។"
          },
          "identity": {
            "title": "អត្តសញ្ញាណ",
            "first-name": "នាម",
            "last-name": "គោត្តនាម",
            "preferred-name": "នាមដែលចូលចិត្ត",
            "gender": "ភេទ",
            "dob": "ថ្ងៃខែឆ្នាំកំណើត",
            "nationality": "សញ្ជាតិ",
            "marital-status": "ស្ថានភាពអាពាហ៍ពិពាហ៍",
            "national-id": "អត្តសញ្ញាណប័ណ្ណ",
            "blood-type": "ក្រុមឈាម"
          },
          "gov-ids": {
            "title": "អត្តសញ្ញាណប័ណ្ណរដ្ឋាភិបាល",
            "national-id": "អត្តសញ្ញាណប័ណ្ណ",
            "nssf": "NSSF",
            "tax-id": "លេខសម្គាល់ពន្ធ",
            "number": "លេខ",
            "issued": "ថ្ងៃចេញ",
            "expires": "ថ្ងៃផុតកំណត់",
            "authority": "អាជ្ញាធរ",
            "never": "មិនផុតកំណត់"
          },
          "contact": {
            "title": "ទំនាក់ទំនង & អាសយដ្ឋាន",
            "section-contact": "ទំនាក់ទំនង",
            "section-address": "អាសយដ្ឋាន",
            "email": "អ៊ីម៉ែលផ្ទាល់ខ្លួន",
            "mobile": "ទូរស័ព្ទដៃ",
            "alt-phone": "ទូរស័ព្ទបន្ទាប់",
            "telegram": "Telegram",
            "whatsapp": "WhatsApp",
            "linkedin": "LinkedIn",
            "current-address": "អាសយដ្ឋានបច្ចុប្បន្ន",
            "modal": {
              "title": "កែសម្រួលទំនាក់ទំនង & អាសយដ្ឋាន",
              "subtitle": "ការផ្លាស់ប្តូរត្រូវបានអនុវត្តភ្លាមៗ",
              "cancel": "បោះបង់",
              "save": "រក្សាទុក",
              "saving": "កំពុងរក្សាទុក…",
              "error-save-failed": "បានបរាជ័យក្នុងការរក្សាទុកព័ត៌មានទំនាក់ទំនង។ សូមព្យាយាមម្តងទៀត។"
            }
          },
          "family": {
            "title": "គ្រួសារ & អ្នកដែលពឹងផ្អែក",
            "col-name": "ឈ្មោះ",
            "col-relationship": "ទំនាក់ទំនង",
            "col-dob": "ថ្ងៃខែឆ្នាំកំណើត",
            "col-national-id": "អត្តសញ្ញាណប័ណ្ណ",
            "col-tax-dependent": "អ្នកពឹងផ្អែកពន្ធ",
            "col-status": "ស្ថានភាព",
            "col-actions": "សកម្មភាព",
            "tax-note": "អ្នកពឹងផ្អែកពន្ធជំរុញការគណនាការបន្ថយពន្ធ ToS នៅក្នុងប្រព័ន្ធប្រាក់ខែ។",
            "yes": "បាទ/ចាស",
            "no": "ទេ",
            "empty": "មិនទាន់មានការកត់ត្រាសមាជិកគ្រួសារ។",
            "btn-add": "បន្ថែមសមាជិក",
            "delete-confirm": "លុបសមាជិកគ្រួសារនេះ?",
            "modal": {
              "add-title": "បន្ថែមសមាជិកគ្រួសារ",
              "edit-title": "កែប្រែសមាជិកគ្រួសារ",
              "subtitle": "ការផ្លាស់ប្តូរត្រូវបានកត់ត្រាភ្លាម · មិនចាំបាច់ការអនុម័ត",
              "field-fullname": "ឈ្មោះពេញ",
              "field-relationship": "ទំនាក់ទំនង",
              "field-dob": "ថ្ងៃខែឆ្នាំកំណើត",
              "field-phone": "ទូរស័ព្ទ",
              "field-email": "អ៊ីម៉ែល",
              "field-dependent": "អ្នកពឹងផ្អែក (ការលើកលែងពន្ធ)",
              "field-emergency": "ទំនាក់ទំនងអាសន្ន",
              "field-occupation": "មុខរបរ",
              "field-note": "កំណត់ចំណាំ",
              "cancel": "បោះបង់",
              "save": "រក្សាទុក",
              "saving": "កំពុងរក្សាទុក…",
              "error-name-required": "ឈ្មោះពេញត្រូវការ។",
              "error-save-failed": "រក្សាទុកបានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។"
            }
          },
          "emergency": {
            "title": "ទំនាក់ទំនងអាសន្ន",
            "primary": "ចម្បង",
            "relationship": "ទំនាក់ទំនង",
            "phone": "ទូរស័ព្ទ",
            "empty": "មិនទាន់មានទំនាក់ទំនងអាសន្ន។",
            "btn-add": "បន្ថែមទំនាក់ទំនង",
            "delete-confirm": "លុបទំនាក់ទំនងអាសន្ននេះ?"
          },
          "bank": {
            "title": "ព័ត៌មានគណនីធនាគារ",
            "managed-note": "គ្រប់គ្រងដោយការដំឡើងប្រាក់ខែ — មើលបានតែប៉ុណ្ណោះ។",
            "bank": "ធនាគារ",
            "account-name": "ឈ្មោះគណនី",
            "account-number": "លេខគណនី",
            "status": "ស្ថានភាព",
            "empty": "មិនទាន់មានគណនីធនាគារ។",
            "cash-no-bank": "សាច់ប្រាក់ (គ្មានធនាគារ)"
          },
          "btn-history": "ប្រវត្តិ",
          "active": "សកម្ម"
        },
        "benefits": {
          "banner-intro": "ធានារ៉ាប់រង សិទ្ធិ និងកម្មវិធីបុគ្គលិកក្រៅសាច់ប្រាក់។",
          "banner": "ប្រាក់ខែ និងប្រាក់ឧបត្ថម្ភត្រូវបានគ្រប់គ្រងក្រោម",
          "banner-link": "ប្រាក់ខែ",
          "insurance-title": "ធានារ៉ាប់រង និងអត្ថប្រយោជន៍ច្បាប់",
          "add": "បន្ថែម",
          "no-benefits": "មិនមានធានារ៉ាប់រង ឬអត្ថប្រយោជន៍ច្បាប់ទេ។",
          "policy-id": "លេខកូដបណ្ណសន្យា",
          "scheme": "គម្រោង",
          "type": "ប្រភេទ",
          "enrolled": "ចុះឈ្មោះ",
          "status-active": "សកម្ម",
          "status-enrolled": "បានចុះឈ្មោះ",
          "nssf-title": "NSSF (មូលនិធិសន្តិសុខសង្គមជាតិ)",
          "nssf-subtitle": "កាតព្វកិច្ច · សុខភាព + សោធននិវត្តន៍",
          "nssf-id": "លេខ NSSF",
          "nssf-employment-type": "ប្រភេទការងារ",
          "nssf-employment-status": "ស្ថានភាពការងារ",
          "nssf-in-scheme": "ក្នុងគម្រោង",
          "dependents-title": "អ្នកពឹងផ្អែក",
          "no-dependents": "មិនមានអ្នកពឹងផ្អែកចុះឈ្មោះ។",
          "add-dependent": "បន្ថែមអ្នកពឹងផ្អែក",
          "delete-insurance": "លុបធានារ៉ាប់រង"
        },
        "documents": {
          "title": "ឯកសារ",
          "upload": "បញ្ចូលឯកសារ",
          "empty": "មិនទាន់មានឯកសារ។",
          "options": "ជម្រើសឯកសារ",
          "delete": "លុបឯកសារ",
          "confirm-delete": "លុប",
          "confirm-delete-warning": "វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-delete-yes": "បាទ/ចាស លុប",
          "confirm-delete-no": "បោះបង់"
        },
        "attendance": {
          "days-worked": "ថ្ងៃធ្វើការ (មេសា)",
          "overtime": "ម៉ោងបន្ថែម",
          "late-missed": "យឺត / អវត្តមាន",
          "on-leave": "ឈប់សម្រាក",
          "leave-balances": "សមតុល្យការឈប់សម្រាក",
          "annual-leave": "ការឈប់សម្រាកប្រចាំឆ្នាំ",
          "sick-leave": "ការឈប់សម្រាកជំងឺ",
          "special-leave": "ការឈប់សម្រាកពិសេស",
          "maternity": "ការឈប់សម្រាកសម្រាលកូន",
          "days": "ថ្ងៃ",
          "recent-attendance": "វត្តមានថ្មីៗ",
          "col-day": "ថ្ងៃ",
          "col-in": "ចូល",
          "col-out": "ចេញ",
          "col-hours": "ម៉ោង",
          "col-notes": "កំណត់ចំណាំ"
        },
        "job": {
          "current-job": "ការងារបច្ចុប្បន្ន",
          "modify": "បើក​សកម្មភាពការងារ",
          "position": "មុខតំណែង",
          "department": "នាយកដ្ឋាន",
          "employment-type": "ប្រភេទការងារ",
          "contract-type": "ប្រភេទកិច្ចសន្យា",
          "reports-to": "ស្ថិតក្រោម",
          "org-unit": "អង្គភាព",
          "project-client": "គម្រោង / អតិថិជន",
          "hire-date": "កាលបរិច្ឆេទចូលធ្វើការ",
          "subordinates": "អ្នកក្រោមបង្គាប់",
          "work-location": "ទីតាំងធ្វើការ",
          "working-hours": "ម៉ោងធ្វើការ",
          "employment-change-note": "ការផ្លាស់ប្ដូរមុខតំណែង នាយកដ្ឋាន និងកិច្ចសន្យា គ្រប់គ្រងដោយ {term} — ការកែប្រែគ្រប់យ៉ាងបង្កើតការកត់ត្រាដែលអាចត្រួតពិនិត្យបាន ជាមួយកាលបរិច្ឆេទ មូលហេតុ និងការអនុម័ត។",
          "employment-change-term": "Employment Change",
          "start-one": "ចាប់ផ្ដើម →",
          "gov-menu-title": "ជ្រើសប្រភេទ Employment Change",
          "gov-transfer": "ផ្ទេរ",
          "gov-transfer-sub": "ផ្លាស់ប្ដូរនាយកដ្ឋាន / ប្រធានផ្ទាល់ / ទីតាំង",
          "gov-promotion": "ឡើងលំដាប់",
          "gov-promotion-sub": "ផ្លាស់ប្ដូរទៅមុខតំណែង / ថ្នាក់ខ្ពស់ជាង",
          "gov-change-type": "ផ្លាស់ប្ដូរប្រភេទការងារ",
          "gov-change-type-sub": "ឧ. ពេញម៉ោង ↔ កន្លះម៉ោង / ខ្ចីប្រើ",
          "gov-salary": "ផ្លាស់ប្ដូរប្រាក់ខែ",
          "gov-salary-sub": "កែតម្រូវប្រាក់ខែមូលដ្ឋាន ឬប្រាក់ឧបត្ថម្ភ",
          "gov-renew": "បន្តកិច្ចសន្យា",
          "gov-renew-sub": "ពន្យារកាលបរិច្ឆេទបញ្ចប់កិច្ចសន្យាបច្ចុប្បន្ន",
          "gov-menu-title-danger": "ការបញ្ចប់ការងារ",
          "gov-suspend": "ព្យួរការងារ",
          "gov-suspend-sub": "ព្យួរការងារបណ្ដោះអាសន្ន",
          "gov-terminate-involuntary": "បញ្ចប់ការងារដោយបង្ខំ",
          "gov-terminate-involuntary-sub": "បណ្ដេញ ការបន្ថយ ឬការប្រព្រឹត្តខុស",
          "gov-terminate-voluntary": "លាឈប់ពីការងារ",
          "gov-terminate-voluntary-sub": "ការឈប់ស្ម័គ្រចិត្តរបស់និយោជិត",
          "emp-change-drawer": {
            "title": "ការផ្លាស់ប្ដូរការងារ",
            "subtitle": "កត់ត្រាការផ្លាស់ប្ដូរការងារផ្លូវការសម្រាប់និយោជិតនេះ",
            "field-type": "ប្រភេទការផ្លាស់ប្ដូរ",
            "field-type-placeholder": "ជ្រើសប្រភេទ",
            "field-effective-date": "កាលបរិច្ឆេទដែលមានប្រសិទ្ធភាព",
            "field-reason": "មូលហេតុ",
            "field-reason-placeholder": "ពណ៌នាមូលហេតុនៃការផ្លាស់ប្ដូរ",
            "field-to-org-unit": "នាយកដ្ឋាន / មុខតំណែងថ្មី",
            "field-to-org-unit-placeholder": "ឧ. ហិរញ្ញវត្ថុ – គណនេយ្យករជាន់ខ្ពស់",
            "field-to-salary": "ប្រាក់ខែមូលដ្ឋានថ្មី",
            "field-to-salary-placeholder": "ឧ. 1200",
            "field-new-employment-type": "ប្រភេទការងារថ្មី",
            "field-new-employment-type-placeholder": "ជ្រើសប្រភេទ",
            "field-suspend-until": "ព្យួរការងាររហូតដល់",
            "field-new-contract-end-date": "កាលបរិច្ឆេទបញ្ចប់កិច្ចសន្យាថ្មី",
            "warning-destructive-title": "សកម្មភាពនេះប៉ះពាល់ដល់ស្ថានភាពការងារ",
            "warning-destructive-body": "សូមពិនិត្យឡើងវិញដោយប្រុងប្រយ័ត្នមុនពេលរក្សាទុក។ ការផ្លាស់ប្ដូរនេះនឹងត្រូវបានកត់ត្រានៅក្នុងប្រវត្តិការងារ។",
            "confirm-destructive": "ខ្ញុំបញ្ជាក់ថាសកម្មភាពនេះត្រូវបានអនុម័ត និងកត់ត្រាត្រឹមត្រូវ",
            "error-type-required": "សូមជ្រើសប្រភេទការផ្លាស់ប្ដូរ",
            "error-date-required": "ត្រូវការកាលបរិច្ឆេទដែលមានប្រសិទ្ធភាព",
            "error-reason-required": "សូមផ្តល់មូលហេតុ",
            "error-confirm-required": "សូមបញ្ជាក់សកម្មភាពនេះមុនពេលរក្សាទុក",
            "error-no-contract": "រកមិនឃើញកិច្ចសន្យាសកម្ម — សូមបង្កើតកិច្ចសន្យាជាមុន",
            "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខត្រឹមត្រូវ",
            "error-save-failed": "រក្សាទុកបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។",
            "cancel": "បោះបង់",
            "save": "រក្សាទុកការផ្លាស់ប្ដូរ",
            "saving": "កំពុងរក្សាទុក…",
            "type": {
              "TRANSFER": "ផ្ទេរ",
              "PROMOTE": "ឡើងលំដាប់",
              "SALARY_CHANGE": "ផ្លាស់ប្ដូរប្រាក់ខែ",
              "SALARY_INCREASE": "បង្កើនប្រាក់ខែ",
              "CHANGE_EMPLOYMENT_TYPE": "ផ្លាស់ប្ដូរប្រភេទការងារ",
              "INVOLUNTARY_TERMINATION": "បញ្ចប់ការងារដោយបង្ខំ",
              "VOLUNTARY_TERMINATION": "លាឈប់ពីការងារ",
              "DEMOTE": "បញ្ចុះលំដាប់",
              "REDESIGNATION": "ប្ដូរអត្តសញ្ញាណ",
              "SUSPEND": "ព្យួរការងារ",
              "RENEW": "បន្តកិច្ចសន្យា",
              "Unknown": "ការផ្លាស់ប្ដូរមិនស្គាល់"
            }
          }
        },
        "overview": {
          "tenure": "អាយុការ",
          "status": "ស្ថានភាព",
          "current-package": "កញ្ចប់បច្ចុប្បន្ន",
          "recurring-month": "ប្រចាំខែ",
          "reports-to": "របាយការណ៍ទៅ",
          "no-manager": "មិនទាន់មានប្រធានផ្ទាល់",
          "compliance": "ការអនុលោម",
          "nssf-enrolled": "បានចុះឈ្មោះ NSSF",
          "not-enrolled": "មិនបានចុះឈ្មោះ",
          "tax-declaration": "បានប្រកាសពន្ធ (ToSI)",
          "contract-signed": "បានចុះហត្ថលេខាលើកិច្ចសន្យា",
          "health-check-due": "ការពិនិត្យសុខភាពប្រចាំឆ្នាំ",
          "quick-facts": "ព័ត៌មានសង្ខេប",
          "working-hours": "ម៉ោងធ្វើការ",
          "workspace": "កន្លែងធ្វើការ",
          "time-zone": "តំបន់ម៉ោង",
          "language": "ភាសា",
          "personal-info": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "view-full-personal": "មើលព័ត៌មានផ្ទាល់ខ្លួនពេញ →",
          "nationality": "សញ្ជាតិ",
          "personal-phone": "ទូរស័ព្ទផ្ទាល់ខ្លួន",
          "personal-email": "អ៊ីម៉ែលផ្ទាល់ខ្លួន",
          "emergency-contact": "ទំនាក់ទំនងអាសន្ន"
        },
        "external": {
          "chip": "បុគ្គលិកខាងក្រៅ",
          "personal-info": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "latin-name": "ឈ្មោះឡាតាំង",
          "native-name": "ឈ្មោះខ្មែរ",
          "gender": "ភេទ",
          "status": "ស្ថានភាព",
          "reporting-structure": "រចនាសម្ព័ន្ធរបាយការណ៍ និងក្រុម",
          "org-unit": "អង្គភាព",
          "role": "តួនាទី",
          "report-to-role": "រាយការណ៍ទៅតួនាទី",
          "subordinates": "អ្នកក្រោមបង្គាប់",
          "line-manager": "ប្រធានផ្ទាល់",
          "no-manager": "មិនទាន់មានប្រធានផ្ទាល់",
          "view-subordinates": "មើល"
        },
        "subordinates-modal": {
          "title": "អ្នកក្រោមបង្គាប់",
          "search-placeholder": "ស្វែងរកតាមពាក្យគន្លឹះ…",
          "col-name": "ឈ្មោះពេញ",
          "col-code": "លេខសម្គាល់បុគ្គលិក",
          "col-status": "ស្ថានភាព",
          "col-org-unit": "អង្គភាព",
          "col-position": "តំណែង",
          "empty": "រកមិនឃើញអ្នកក្រោមបង្គាប់ទេ។",
          "no-match": "រកមិនឃើញអ្នកក្រោមបង្គាប់ដែលត្រូវនឹង \"{query}\" ទេ។",
          "loading": "កំពុងផ្ទុកអ្នកក្រោមបង្គាប់…",
          "error": "បរាជ័យក្នុងការផ្ទុកអ្នកក្រោមបង្គាប់។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "showing-range": "បង្ហាញ {from}–{to} នៃ {total}",
          "rows-per-page": "ជួរដេកក្នុងមួយទំព័រ",
          "prev": "ទំព័រមុន",
          "next": "ទំព័របន្ទាប់"
        },
        "journey": {
          "title": "ដំណើរការការងារ",
          "subtitle": "ប្រវត្តិវិជ្ជមាននៃព្រឹត្តិការណ៍ការផ្លាស់ប្ដូរការងារ · ប្រព័ន្ធកត់ត្រាសម្រាប់ការត្រួតពិនិត្យ",
          "empty": "មិនមានព្រឹត្តិការណ៍ផ្លាស់ប្ដូរការងារ។",
          "reason-label": "មូលហេតុ",
          "doc-label": {
            "promote": "មើលលិខិតបដិភូ",
            "transfer": "មើលលិខិតផ្ទេរ",
            "salary": "មើលលិខិតកែប្រែប្រាក់ខែ",
            "change-employment-type": "មើលលិខិតកែប្រែប្រភេទការងារ",
            "termination": "មើលលិខិតបញ្ចប់ការងារ",
            "joined": "មើលកិច្ចសន្យាការងារ",
            "probation-passed": "មើលការបញ្ជាក់ការសាកល្បង",
            "default": "មើលលិខិតគាំទ្រ"
          },
          "kpi": {
            "total": "ព្រឹត្តិការណ៍ទាំងអស់",
            "years": "ឆ្នាំ",
            "pending": "កំពុងរង់ចាំ"
          },
          "state": {
            "applied": "បានអនុវត្ត",
            "pending": "កំពុងរង់ចាំ"
          },
          "event-type": {
            "joined": "ចូលក្រុមហ៊ុន",
            "probation-passed": "ឆ្លងកាត់ការសាកល្បង"
          },
          "event": {
            "hired-summary": "ការចូលធ្វើការដំបូង",
            "hired-reason": "ការជ្រើសរើសដំបូង",
            "probation-summary": "ការសាកល្បងបានបញ្ចប់ · បញ្ជាក់ក្នុងតួនាទី",
            "probation-reason": "ការត្រួតពិនិត្យការសាកល្បងជោគជ័យ"
          }
        },
        "identity-modal": {
          "title": "កែប្រែអត្តសញ្ញាណ",
          "subtitle": "ធ្វើបច្ចុប្បន្នភាពឈ្មោះ ភេទ និងព័ត៌មានទំនាក់ទំនងការងារ",
          "section-latin": "ឈ្មោះឡាតាំង",
          "section-native": "ឈ្មោះខ្មែរ",
          "section-work-contacts": "ទំនាក់ទំនងការងារ",
          "field-latin-first": "នាមដំបូង",
          "field-latin-last": "នាមត្រកូល",
          "field-nickname": "ឈ្មោះហៅ",
          "field-gender": "ភេទ",
          "field-native-first": "នាមដំបូង (ខ្មែរ)",
          "field-native-last": "នាមត្រកូល (ខ្មែរ)",
          "field-work-email": "អ៊ីមែលការងារ",
          "field-work-phone": "លេខទូរស័ព្ទការងារ",
          "section-personal": "ព័ត៌មានផ្ទាល់ខ្លួន",
          "field-dob": "ថ្ងៃខែឆ្នាំកំណើត",
          "field-nationality": "សញ្ជាតិ",
          "field-marital-status": "ស្ថានភាពអាពាហ៍ពិពាហ៍",
          "field-national-id": "អត្តសញ្ញាណប័ណ្ណ",
          "field-national-id-placeholder": "ឧ. 012345678",
          "field-blood-type": "ក្រុមឈាម",
          "loading": "កំពុងផ្ទុក…",
          "no-results": "មិនមានលទ្ធផល",
          "pim-note": "",
          "audit-note": "ការផ្លាស់ប្ដូរត្រូវបានកត់ត្រាសម្រាប់ការត្រួតពិនិត្យ។",
          "save": "រក្សាទុក",
          "cancel": "បោះបង់",
          "saving": "កំពុងរក្សាទុក…",
          "error-name-required": "ត្រូវការនាមដំបូង និងនាមត្រកូល។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្តងទៀត។"
        },
        "document-modal": {
          "title": "បញ្ចូលឯកសារ",
          "drop-zone-label": "ចុច ឬទាញ-ទម្លាក់ឯកសារ",
          "drop-zone-cta": "ទាញ-ទម្លាក់ឯកសារ",
          "drop-zone-hint": "ឬចុចដើម្បីរកមើល · PDF, DOC, JPG, PNG",
          "field-name": "ឈ្មោះឯកសារ",
          "field-name-placeholder": "ឧ. ការវាយតម្លៃការងារ 2026.pdf",
          "field-group": "ក្រុមឯកសារ",
          "field-group-placeholder": "ជ្រើសរើសក្រុម",
          "group-personal": "ផ្ទាល់ខ្លួន",
          "group-spouse": "ប្តី/ប្រពន្ធ",
          "group-children": "កូន",
          "field-description": "ការពិពណ៌នា",
          "field-description-placeholder": "កំណត់ចំណាំខ្លីអំពីឯកសារនេះ",
          "info-banner": "ត្រូវការឈ្មោះឯកសារ និងក្រុម ដើម្បីឱ្យ HR អាចរកឃើញ និងចាត់ថ្នាក់ក្រោយ។",
          "upload": "បញ្ចូល",
          "cancel": "បោះបង់",
          "uploading": "កំពុងបញ្ចូល…",
          "field-type": "ប្រភេទឯកសារ",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទ",
          "field-fam-member": "សមាជិកគ្រួសារ",
          "field-fam-member-placeholder": "ជ្រើសរើសកូន",
          "no-spouse": "មិនមានប្តី/ប្រពន្ធចុះឈ្មោះសម្រាប់បុគ្គលិកនេះ។",
          "no-children": "មិនមានកូនចុះឈ្មោះសម្រាប់បុគ្គលិកនេះ។",
          "error-file-required": "សូមជ្រើសរើសឯកសារ។",
          "error-name-required": "ត្រូវការឈ្មោះឯកសារ។",
          "error-group-required": "សូមជ្រើសរើសក្រុមឯកសារ។",
          "error-type-required": "សូមជ្រើសរើសប្រភេទឯកសារ។",
          "error-fam-required": "សូមជ្រើសរើសសមាជិកគ្រួសារ។",
          "error-upload-failed": "បរាជ័យក្នុងការបញ្ចូល។ សូមព្យាយាមម្តងទៀត។"
        },
        "contract-modal": {
          "title-create": "កិច្ចសន្យាថ្មី",
          "title-edit": "កែប្រែកិច្ចសន្យា",
          "subtitle": "កំណត់ប្រភេទកិច្ចសន្យា កាលបរិច្ឆេទ និងប្រាក់ខែ",
          "section-type": "ប្រភេទកិច្ចសន្យា",
          "section-dates": "កាលបរិច្ឆេទ",
          "section-compensation": "ប្រាក់ខែ",
          "field-type": "ប្រភេទកិច្ចសន្យា",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទ",
          "field-employment-type": "ប្រភេទការងារ",
          "field-employment-type-placeholder": "ជ្រើសរើសប្រភេទការងារ",
          "field-start": "កាលបរិច្ឆេទចាប់ផ្ដើម",
          "field-end": "កាលបរិច្ឆេទបញ្ចប់ (ទុកចោលប្រសិនបើគ្មានកំណត់)",
          "field-probation-start": "ចាប់ផ្ដើមការសាកល្បង",
          "field-probation-end": "បញ្ចប់ការសាកល្បង",
          "field-salary": "ប្រាក់បៀវត្សមូលដ្ឋាន",
          "field-salary-placeholder": "ចំនួនប្រចាំខែ",
          "save": "រក្សាទុក",
          "cancel": "បោះបង់",
          "saving": "កំពុងរក្សាទុក…",
          "error-type-required": "ត្រូវការប្រភេទកិច្ចសន្យា។",
          "error-start-required": "ត្រូវការកាលបរិច្ឆេទចាប់ផ្ដើម។",
          "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្តងទៀត។"
        },
        "insurance-modal": {
          "title-add": "បន្ថែមធានារ៉ាប់រង",
          "title-edit": "កែប្រែធានារ៉ាប់រង",
          "subtitle": "ផែនការធានារ៉ាប់រងសុខភាព ជីវិត និងបន្ថែម",
          "field-type": "ប្រភេទធានារ៉ាប់រង",
          "field-type-placeholder": "ជ្រើសប្រភេទ",
          "field-policy-id": "លេខគោលនយោបាយ",
          "field-policy-id-placeholder": "លេខយោងគោលនយោបាយ",
          "field-insurer": "ឈ្មោះក្រុមហ៊ុនធានារ៉ាប់រង",
          "field-insurer-placeholder": "ឧ. Prudential",
          "field-scheme": "គ្រោងការណ៍",
          "field-scheme-placeholder": "ឧ. ផែនការបុព្វលាភ",
          "loading": "កំពុងផ្ទុក…",
          "no-results": "មិនមានលទ្ធផល",
          "field-employment-type": "ប្រភេទការងារ",
          "field-employment-type-placeholder": "ជ្រើសប្រភេទការងារ",
          "field-employment-type-formal": "ក្នុងប្រព័ន្ធ (Formal)",
          "field-employment-type-informal": "ក្រៅប្រព័ន្ធ (Informal)",
          "field-employment-status": "ស្ថានភាពការងារ",
          "field-employment-status-placeholder": "ជ្រើសស្ថានភាពការងារ",
          "field-employment-status-active": "កំពុងធ្វើការ (Active)",
          "field-employment-status-maternity": "លំហែរមាតុភាព (Maternity Leave)",
          "field-employment-status-sickness": "កំពុងព្យាបាលជំងឺ (Sickness Treatment)",
          "save": "រក្សាទុក",
          "cancel": "បោះបង់",
          "saving": "កំពុងរក្សាទុក…",
          "confirm-delete": "លុបកំណត់ត្រាធានារ៉ាប់រងនេះ? វាមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-delete-yes": "បាទ/ចាស លុប",
          "confirm-delete-no": "បោះបង់",
          "error-type-required": "ត្រូវការប្រភេទធានារ៉ាប់រង។",
          "error-policy-required": "ត្រូវការលេខគោលនយោបាយ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្តងទៀត។"
        },
        "employment-action-modal": {
          "title": "ការផ្លាស់ប្ដូរការងារ",
          "subtitle": "ការផ្លាស់ប្ដូរទាំងអស់បង្កើតព្រឹត្តិការណ៍ដែលអាចត្រួតពិនិត្យបានក្នុងដំណើរការការងារ",
          "field-type": "ប្រភេទការផ្លាស់ប្ដូរ",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទ",
          "field-effective-date": "កាលបរិច្ឆេទអនុវត្ត",
          "field-reason": "មូលហេតុ",
          "field-reason-placeholder": "ពណ៌នាអំពីមូលហេតុ",
          "field-to-salary": "ប្រាក់បៀវត្សមូលដ្ឋានថ្មី",
          "field-to-salary-placeholder": "ចំនួនប្រចាំខែ",
          "field-to-org-unit": "ទៅ អង្គភាព / នាយកដ្ឋាន",
          "field-to-org-unit-placeholder": "ឧ. វិស្វកម្ម",
          "field-new-employment-type": "ប្រភេទការងារថ្មី",
          "type": {
            "PROMOTE": "ការដំឡើងតំណែង",
            "TRANSFER": "ការផ្ទេរ",
            "SALARY_CHANGE": "ការផ្លាស់ប្ដូរប្រាក់ខែ",
            "CHANGE_EMPLOYMENT_TYPE": "ការផ្លាស់ប្ដូរប្រភេទការងារ",
            "INVOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយមិនស្ម័គ្រចិត្ត",
            "VOLUNTARY_TERMINATION": "ការបញ្ចប់ការងារដោយស្ម័គ្រចិត្ត"
          },
          "save": "ដាក់ស្នើ",
          "cancel": "បោះបង់",
          "saving": "កំពុងដាក់ស្នើ…",
          "warning-destructive-title": "សកម្មភាពនេះប៉ះពាល់ដល់ស្ថានភាពការងារ",
          "confirm-destructive": "ខ្ញុំបញ្ជាក់ថាសកម្មភាពនេះត្រូវបានអនុម័ត និងកត់ត្រាឱ្យបានត្រឹមត្រូវ",
          "error-type-required": "សូមជ្រើសរើសប្រភេទការផ្លាស់ប្ដូរ។",
          "error-date-required": "ត្រូវការកាលបរិច្ឆេទអនុវត្ត។",
          "error-reason-required": "ត្រូវការមូលហេតុ។",
          "error-confirm-required": "សូមបញ្ជាក់សកម្មភាពនេះមុនពេលរក្សាទុក។",
          "error-no-contract": "រកមិនឃើញកិច្ចសន្យាសកម្មសម្រាប់បុគ្គលិកនេះ។",
          "error-salary-numeric": "ប្រាក់ខែត្រូវតែជាលេខ។",
          "error-save-failed": "បរាជ័យក្នុងការដាក់ស្នើ។ សូមព្យាយាមម្តងទៀត។"
        },
        "renew-contract-modal": {
          "title": "បន្តកិច្ចសន្យា",
          "subtitle": "{name} · កិច្ចសន្យាបច្ចុប្បន្ន: {type}",
          "banner": "វានឹងបង្កើតកំណត់ត្រាកិច្ចសន្យាថ្មី។ កិច្ចសន្យាមុននឹងនៅក្នុងប្រវត្តិ All Contracts។",
          "field-type": "ប្រភេទកិច្ចសន្យាថ្មី",
          "field-type-placeholder": "ជ្រើសរើសប្រភេទកិច្ចសន្យា",
          "field-employment-type": "ប្រភេទការងារ",
          "field-start-date": "ថ្ងៃចាប់ផ្ដើម",
          "field-start-date-hint": "កំណត់ដោយស្វ័យប្រវត្តិទៅជាថ្ងៃបន្ទាប់បន្ទាប់ពីកិច្ចសន្យាបច្ចុប្បន្នផុតកំណត់។",
          "field-end-date": "ថ្ងៃបញ្ចប់",
          "field-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "field-salary-placeholder": "ឧ. 1200",
          "field-position": "មុខតំណែង (តារាងស្ថាប័ន)",
          "field-position-placeholder": "ជ្រើសរើសមុខតំណែងទំនេរ",
          "field-position-hint": "ស្រេចចិត្ត — ភ្ជាប់កិច្ចសន្យានេះទៅនឹងមុខតំណែងទំនេរ។",
          "position-loading": "កំពុងផ្ទុកមុខតំណែង…",
          "position-empty": "មិនមានមុខតំណែងទំនេរ។",
          "field-reason": "មូលហេតុ",
          "field-reason-placeholder": "មូលហេតុនៃការបន្ត",
          "error-start-required": "ថ្ងៃចាប់ផ្ដើមត្រូវការ។",
          "error-end-required": "ថ្ងៃបញ្ចប់ត្រូវការសម្រាប់ប្រភេទកិច្ចសន្យានេះ។",
          "error-end-after-start": "ថ្ងៃបញ្ចប់ត្រូវនៅក្រោយថ្ងៃចាប់ផ្ដើម។",
          "error-reason-required": "មូលហេតុត្រូវការ។",
          "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
          "cancel": "បោះបង់",
          "back": "ត្រឡប់",
          "next": "បន្ទាប់",
          "confirm": "បញ្ជាក់ & បន្ត",
          "confirming": "កំពុងបន្ត…",
          "save": "បន្តកិច្ចសន្យា",
          "saving": "កំពុងរក្សាទុក…",
          "step-1": "កិច្ចសន្យា",
          "step-2": "ឈប់សម្រាក",
          "step-3": "ពិនិត្យ",
          "al-heading": "ការតំឡើងការឈប់សម្រាកប្រចាំឆ្នាំ",
          "al-description": "បញ្ជាក់ពីវិធីគ្រប់គ្រងសមតុល្យការឈប់សម្រាកដែលនៅសល់ពីកិច្ចសន្យាមុន។",
          "al-current-balance": "សមតុល្យការឈប់សម្រាកបច្ចុប្បន្ន",
          "al-current-taken": "ការឈប់សម្រាកដែលបានយក",
          "al-entitlement-preview-heading": "ការមើលជាមុននូវសិទ្ធិឈប់សម្រាកប្រចាំឆ្នាំ",
          "al-entitled-this-contract": "ថ្ងៃឈប់សម្រាកមានសិទ្ធិក្រោមកិច្ចសន្យានេះ",
          "al-seniority-bonus": "ប្រាក់រង្វាន់អតីតភាព",
          "al-entitlement-as-of": "គិតត្រឹមថ្ងៃទី {date} ដោយផ្អែកលើគោលការណ៍ឈប់សម្រាករបស់ក្រុមហ៊ុន",
          "al-days": "ថ្ងៃ",
          "al-carry-forward-label": "យកសមតុល្យការឈប់សម្រាកទៅបន្ត?",
          "al-carry-forward-yes": "បាទ/ចាស, យកទៅបន្ត",
          "al-carry-forward-no": "ទេ, កំណត់ជាសូន្យ",
          "al-prev-amount": "សមតុល្យការឈប់សម្រាកដែលត្រូវយកទៅបន្ត",
          "al-prev-amount-hint": "ចំនួនថ្ងៃឈប់សម្រាកដែលត្រូវបន្តទៅកិច្ចសន្យាថ្មី។",
          "al-taken": "ការឈប់សម្រាកដែលបានយករំដោះ",
          "al-taken-hint": "ចំនួនថ្ងៃឈប់សម្រាកដែលបានយករំដោះក្នុងអំឡុងពេលកិច្ចសន្យាបច្ចុប្បន្ន។",
          "review-heading": "ពិនិត្យ & បញ្ជាក់",
          "review-description": "សូមពិនិត្យព័ត៌មានលម្អិតការបន្តមុនពេលបញ្ជាក់។",
          "review-contract": "ព័ត៌មានលម្អិតកិច្ចសន្យា",
          "review-al": "ការតំឡើងការឈប់សម្រាកប្រចាំឆ្នាំ",
          "review-type": "ប្រភេទកិច្ចសន្យា",
          "review-employment-type": "ប្រភេទការងារ",
          "review-start-date": "ថ្ងៃចាប់ផ្ដើម",
          "review-end-date": "ថ្ងៃបញ្ចប់",
          "review-salary": "ប្រាក់ខែមូលដ្ឋាន",
          "review-position": "មុខតំណែង",
          "review-position-none": "មិនបានបញ្ជាក់",
          "review-reason": "មូលហេតុ",
          "review-carry-forward": "យកការឈប់សម្រាកទៅបន្ត",
          "review-carry-amount": "ចំនួនទៅបន្ត",
          "review-al-taken": "ការឈប់សម្រាកដែលបានយក",
          "error-al-setup-failed": "កិច្ចសន្យាត្រូវបានបង្កើត។ ការដំឡើងការឈប់សម្រាកប្រចាំឆ្នាំមិនអាចបញ្ចប់បានទេ — សូមកំណត់រចនាសម្ព័ន្ធវាដោយដៃក្នុងផ្ទាំងការទូទាត់ប្រាក់ខែ។"
        },
        "new-contract-modal": {
          "title": "កិច្ចសន្យាថ្មី",
          "subtitle": "{name} · ការបង្កើតកិច្ចសន្យាដំបូង",
          "confirm": "បញ្ជាក់ និងបង្កើត"
        },
        "rehire-contract-modal": {
          "title": "ជួលបុគ្គលិកចាស់ឡើងវិញ",
          "subtitle": "{name} · កិច្ចសន្យាមុន: {type}",
          "banner": "នេះនឹងបង្កើតកិច្ចសន្យាថ្មីសម្រាប់បុគ្គលិកដែលវិលត្រឡប់មកវិញ។ កិច្ចសន្យាមុននឹងនៅតែមាននៅក្នុងប្រវត្តិកិច្ចសន្យាទាំងអស់។",
          "error-start-overlaps": "កាលបរិច្ឆេទចាប់ផ្ដើមត្រូវតែក្រោយកាលបរិច្ឆេទបញ្ចប់នៃកិច្ចសន្យាមុនរបស់បុគ្គលិក។",
          "error-start-no-gap": "កាលបរិច្ឆេទចាប់ផ្ដើមនេះបន្តបន្ទាប់ពីកាលបរិច្ឆេទបញ្ចប់នៃកិច្ចសន្យាមុនភ្លាមៗ — នេះជា ការបន្តកិច្ចសន្យា មិនមែន ការជួលឡើងវិញ ទេ។ សូមប្រើ ការបន្តកិច្ចសន្យា ឬជ្រើសរើសកាលបរិច្ឆេទចាប់ផ្ដើមក្រោយបន្ថែមទៀត ប្រសិនបើមានគម្លាតការងារពិតប្រាកដ។",
          "confirm": "បញ្ជាក់ និងជួលឡើងវិញ"
        },
        "contract-event-modal": {
          "title": "ព្រឹត្តិការណ៍កិច្ចសន្យាថ្មី",
          "subtitle": "{name} · កិច្ចសន្យាបច្ចុប្បន្ន: {type} · ដំណាក់កាល ១ · ការកត់ត្រាតែប៉ុណ្ណោះ",
          "policy-banner-prefix": "កំពុងប្រើ",
          "policy-banner-suffix": "កិច្ចសន្យា។",
          "badge-not-terminated": "អាចប្រើបានបន្ទាប់ពីបញ្ចប់ការងារ",
          "badge-pending-contract": "មានកិច្ចសន្យារង់ចាំរួចហើយ",
          "cancel": "បោះបង់",
          "back": "ត្រឡប់ក្រោយ",
          "save": "រក្សាទុក",
          "saving": "កំពុងរក្សាទុក…",
          "policy-note": {
            "UDC": "UDC គ្មានកំណត់ · មិនអាចបន្ត ឬ ពង្រីកបាន។ ការកែប្រែសម្រាប់ការផ្លាស់ប្ដូរក្នុងពេលសន្យា; ការបញ្ចប់ដើម្បីបិទសន្យា។",
            "FDC": "FDC មានកំណត់ · អាចបន្ត ពង្រីក បំប្លែង កែប្រែ ឬ បញ្ចប់។ ច្បាប់ការងារកម្ពុជាកំណត់រយៈពេលសរុបFDCអតិបរមា ២ ឆ្នាំ។",
            "Probation": "ក្នុងអំឡុងពេលសាកល្បង · បញ្ជាក់ (ឆ្លងកាត់), ពន្យឺត (ត្រូវការពេលបន្ថែម), បំប្លែងទៅ FDC/UDC, ឬ បញ្ចប់។",
            "Internship": "កម្មសិក្សា · បំប្លែងទៅ FDC/UDC ប្រសិនបើជ្រើសរើស ឬ បញ្ចប់នៅចុងគ្រាកម្មសិក្សា។",
            "Outsourcing Service": "កិច្ចសន្យាម៉ៅការ · កែប្រែវិសាលភាព ឬ បញ្ចប់ការប្រាក់ការ។ ការបន្តគ្រប់គ្រងដោយ SOW ។",
            "none": "មិនមានកិច្ចសន្យា · តែ កិច្ចសន្យាថ្មី ប៉ុណ្ណោះ។ ប្រើសម្រាប់កិច្ចសន្យាដំបូងនៅពេលជ្រើសរើស។"
          },
          "type": {
            "new_contract": {
              "label": "កិច្ចសន្យាថ្មី",
              "desc": "កិច្ចសន្យាដំបូងនៅពេលជ្រើសរើស (ឬ ការចាប់ផ្ដើមឡើងវិញបន្ទាប់ពីចន្លោះ)",
              "date-label": "កាលបរិច្ឆេទចាប់ផ្ដើមកិច្ចសន្យា"
            },
            "contract_renewal": {
              "label": "ការបន្តកិច្ចសន្យា",
              "desc": "FDC ឬ UDC ត្រូវបានបន្តសម្រាប់អាណត្តិថ្មី",
              "date-label": "កាលបរិច្ឆេទចូលជាធរមានការបន្ត"
            },
            "rehire": {
              "label": "ជួលបុគ្គលិកចាស់ឡើងវិញ",
              "desc": "នាំយកអតីតបុគ្គលិកមកវិញក្រោមកិច្ចសន្យាថ្មី",
              "date-label": "កាលបរិច្ឆេទចាប់ផ្ដើមជួលឡើងវិញ"
            },
            "contract_extension": {
              "label": "ការពង្រីកកិច្ចសន្យា",
              "desc": "កិច្ចសន្យាដែលមានស្រាប់ត្រូវបានពង្រីកក្នុងអំឡុងពេលបច្ចុប្បន្ន",
              "date-label": "កាលបរិច្ឆេទចាប់ផ្ដើមការពង្រីក"
            },
            "contract_conversion": {
              "label": "ការបំប្លែងកិច្ចសន្យា",
              "desc": "ផ្លាស់ប្ដូរប្រភេទកិច្ចសន្យា (ឧ. FDC → UDC)",
              "date-label": "កាលបរិច្ឆេទចូលជាធរមានការបំប្លែង"
            },
            "contract_amendment": {
              "label": "ការកែប្រែកិច្ចសន្យា",
              "desc": "ការកែប្រែក្នុងពេលសន្យា (ម៉ោងការងារ, ទីតាំង, លក្ខខណ្ឌ, ប្រការ)",
              "date-label": "កាលបរិច្ឆេទចូលជាធរមានការកែប្រែ"
            },
            "probation_confirmation": {
              "label": "ការបញ្ជាក់ពេលសាកល្បង",
              "desc": "ពេលសាកល្បងកន្លងផុតហើយ · បុគ្គលិកត្រូវបានបញ្ជាក់",
              "date-label": "កាលបរិច្ឆេទបញ្ជាក់"
            },
            "probation_extension": {
              "label": "ការពន្យឺតពេលសាកល្បង",
              "desc": "ពេលសាកល្បងត្រូវបានពន្យឺតសម្រាប់រយៈពេលបន្ថែម",
              "date-label": "កាលបរិច្ឆេទបញ្ចប់ពេលសាកល្បងថ្មី"
            },
            "termination_record": {
              "label": "កំណត់ត្រាការបញ្ចប់",
              "desc": "កំណត់ត្រាការបញ្ចប់ការងារតាមរដ្ឋបាល",
              "date-label": "កាលបរិច្ឆេទបញ្ចប់ការងារ"
            }
          },
          "form": {
            "subtitle": "កត់ត្រាការផ្លាស់ប្ដូរកិច្ចសន្យានេះ · ដំណាក់កាល ១",
            "phase1-label": "ដំណាក់កាល ១ · ការកត់ត្រាតែប៉ុណ្ណោះ។",
            "phase1-desc": "កត់ត្រាការផ្លាស់ប្ដូរកិច្ចសន្យាក្រៅប្រព័ន្ធ (លិខិតស្នាម / លិខិត)។ លំហូរការអនុម័តនឹងមកក្នុងដំណាក់កាល ២។",
            "field-new-contract-type": "ប្រភេទកិច្ចសន្យាថ្មី",
            "field-new-end-date": "កាលបរិច្ឆេទបញ្ចប់ថ្មី",
            "field-new-end-date-hint": "ចាំបាច់សម្រាប់កិច្ចសន្យា FDC ។",
            "field-new-probation-end-date": "កាលបរិច្ឆេទបញ្ចប់ពេលសាកល្បងថ្មី",
            "field-probation-originally-ended": "ពេលសាកល្បងបានបញ្ចប់ដើម",
            "field-reason": "មូលហេតុ / កំណត់ចំណាំ",
            "field-reason-placeholder": "មូលហេតុនៃការផ្លាស់ប្ដូរកិច្ចសន្យានេះ?",
            "field-doc-ref": "ឯកសារយោង",
            "field-doc-ref-placeholder": "ឈ្មោះឯកសារ / យោង (ឧ. ContractRenewal-2026-007.pdf)",
            "file-upload-phase2": "ភ្ជាប់ឯកសារ — ដំណាក់កាល ២",
            "field-offline-approval": "ការអនុម័តក្រៅប្រព័ន្ធ",
            "offline-approval-label": "ការអនុម័តក្រៅប្រព័ន្ធបានបញ្ចប់ — ចុះហត្ថលេខាក្រៅប្រព័ន្ធ",
            "field-offline-notes": "កំណត់ចំណាំការអនុម័តក្រៅប្រព័ន្ធ",
            "field-offline-notes-placeholder": "កំណត់ចំណាំ — ឧ. ចុះហត្ថលេខាដោយបុគ្គលិក ២០២៦-០៦-២៨",
            "error-date-required": "ចាំបាច់ត្រូវបញ្ចូលកាលបរិច្ឆេទ។",
            "error-reason-required": "ចាំបាច់ត្រូវបញ្ចូលមូលហេតុ។",
            "error-save-failed": "បរាជ័យក្នុងការរក្សាទុក។ សូមព្យាយាមម្ដងទៀត។",
            "validation-summary-invalid": "✗ ចាំបាច់ត្រូវបញ្ចូលកាលបរិច្ឆេទ និង មូលហេតុ",
            "validation-summary-ok": "✓ រួចរាល់ · ស្ថានភាពនឹងជា {status}",
            "status-scheduled": "កំណត់ពេល",
            "status-effective": "ចូលជាធរមាន"
          }
        },
        "schedule": {
          "title": "កាលវិភាគការងារ",
          "none": "មិនទាន់មានកាលវិភាគការងារទេ",
          "assign": "ចាត់តាំង",
          "change": "ផ្លាស់ប្ដូរ",
          "end": "បញ្ចប់",
          "history": "មើលប្រវត្តិ",
          "hide-history": "លាក់ប្រវត្តិ",
          "hours": "{h} ម៉ោង/សប្ដាហ៍",
          "since": "ចាប់ពី {date}",
          "history-title": "កាលវិភាគមុនៗ",
          "history-empty": "គ្មានកាលវិភាគមុនៗទេ។",
          "loading": "កំពុងផ្ទុកកាលវិភាគការងារ…",
          "error": "មិនអាចផ្ទុកកាលវិភាគការងារបានទេ។",
          "retry": "ព្យាយាមម្ដងទៀត",
          "unknown-template": "កាលវិភាគដែលបានលុប",
          "from": "ចាប់ផ្ដើម {date}",
          "until": "រហូតដល់ {date}",
          "upcoming-label": "នាពេលខាងមុខ៖",
          "upcoming-from": "ចាប់ពី {date}"
        }
      },
      "batch-import": {
        "title": "នាំចូលបុគ្គលិក",
        "subtitle": "នាំចូលបុគ្គលិកជាបាច់ពី Excel ដោយមានការផ្ទៀងផ្ទាត់ និងការរកឃើញការស្ទួន។",
        "tab": {
          "new-import": "នាំចូលថ្មី",
          "history": "ប្រវត្តិការនាំចូល"
        },
        "steps": {
          "upload": "ផ្ទុកឯកសារ",
          "validation": "ការផ្ទៀងផ្ទាត់",
          "confirm": "បញ្ជាក់"
        },
        "mode": {
          "label": "របៀបនាំចូល",
          "add-label": "បន្ថែមថ្មីតែប៉ុណ្ណោះ",
          "add-desc": "បង្កើតកំណត់ត្រាបុគ្គលិកថ្មី។ ទុកលេខកូដបុគ្គលិកទទេ ដើម្បីឱ្យប្រព័ន្ធផ្តល់លេខកូដ។ លេខកូដដែលមានរួចហើយក្នុងក្រុមហ៊ុននេះនឹងត្រូវបដិសេធ។",
          "update-label": "ធ្វើបច្ចុប្បន្នភាពដែលមានស្រាប់",
          "update-desc": "ធ្វើបច្ចុប្បន្នភាពកំណត់ត្រាដែលមានស្រាប់ដោយប្រើលេខកូដបុគ្គលិក។ ជួរដេកដែលគ្មានលេខកូដបុគ្គលិកត្រឹមត្រូវមិនអាចធ្វើបច្ចុប្បន្នភាពបានទេ។",
          "note": "សម្រាប់ការធ្វើបច្ចុប្បន្នភាព លេខកូដបុគ្គលិកជាគន្លឹះភ្ជាប់តែមួយ។ ប្រព័ន្ធនឹងមិនផ្ទៀងផ្ទាត់តាមឈ្មោះ អ៊ីមែល ឬទូរស័ព្ទ ដើម្បីជៀសវាងការធ្វើបច្ចុប្បន្នភាពខុស។",
          "replace-label": "បន្ថែម ឬធ្វើបច្ចុប្បន្នភាព",
          "replace-desc": "ត្រូវការលេខកូដបុគ្គលិកនៅគ្រប់ជួរដេក។ ជួរដេកដែលលេខកូដមានរួចហើយ នឹងធ្វើបច្ចុប្បន្នភាពបុគ្គលិកនោះ។ ជួរដេកដែលមានលេខកូដថ្មី នឹងបន្ថែមបុគ្គលិកថ្មី។ គ្មាននរណាម្នាក់ត្រូវបានដកចេញទេ។"
        },
        "upload": {
          "tip": "ថ្មីនៅទីនេះ? ទាញយកគំរូជាមុនសិន ដើម្បីមើលជួរឈរដែលត្រូវការ រួចបំពេញព័ត៌មានបុគ្គលិក ហើយទម្លាក់ឯកសារត្រឡប់មកវិញ។",
          "tip-link": "ទាញយកគំរូ",
          "download-template": "ទាញយកគំរូ",
          "export-existing": "នាំចេញបុគ្គលិកដែលមានស្រាប់",
          "drop-label": "ទម្លាក់ឯកសារនៅទីនេះ ឬចុចដើម្បីរក",
          "drop-hint": "Excel (.xlsx) · រហូតដល់ 5 MB · អតិបរមា 5,000 ជួរ · មើលជាមុន 500 ជួរដំបូង",
          "remove": "លុបឯកសារ",
          "preview-truncated": "មើលជាមុន {cap} ជួរ ចេញពី {total} — ឯកសារពេញលេញនឹងត្រូវផ្ទៀងផ្ទាត់ដោយម៉ាស៊ីនបម្រើ។"
        },
        "validation": {
          "col-errors": "កំហុសជួរឈរ",
          "total": "សរុប: {n}",
          "valid": "ត្រឹមត្រូវ: {n}",
          "invalid": "មិនត្រឹមត្រូវ: {n}",
          "warnings": "ការព្រមាន: {n}",
          "status": "ស្ថានភាព",
          "issues": "បញ្ហា",
          "export-result": "នាំចេញលទ្ធផល",
          "required": "ចាំបាច់",
          "issues-expand": "{n} បញ្ហា — ចុចដើម្បីពង្រីក",
          "show-less": "បង្ហាញតិចជាង"
        },
        "confirm": {
          "summary": "ត្រៀមខ្លួននាំចូល",
          "mode": "របៀប",
          "rows": "ជួរដេកសរុប",
          "valid": "ត្រឹមត្រូវ",
          "invalid": "មិនត្រឹមត្រូវ (នឹងត្រូវរំលង)",
          "dl-results": "លទ្ធផលការនាំចូល",
          "dl-original": "ឯកសារដើម",
          "errors-label": "កំហុសការនាំចូល ({n})",
          "dl-sign-ins": "ការស្នើសុំគណនីចូលប្រើ",
          "blocked-no-valid": "គ្មានជួរដេកត្រឹមត្រូវសម្រាប់នាំចូលទេ។ សូមកែឯកសារ ហើយផ្ទៀងផ្ទាត់ម្តងទៀត។",
          "blocked-has-errors": "មាន {n} ជួរដេកមានកំហុស។ សូមកែវា ហើយផ្ទៀងផ្ទាត់ម្តងទៀតមុននាំចូល។"
        },
        "progress": {
          "completed": "ការនាំចូលបានបញ្ចប់",
          "completed-errors": "ការនាំចូលបានបញ្ចប់ប៉ុន្តែមានកំហុស",
          "failed": "ការនាំចូលបានបរាជ័យ",
          "in-progress": "កំពុងនាំចូលបុគ្គលិក…",
          "detail": "បាននាំចូល {succeeded} ចេញពី {total} ដោយជោគជ័យ",
          "error-msg": "ការនាំចូលបានជួបបញ្ហា។",
          "processing": "កំពុងដំណើរការ {done} ចេញពី {total}…",
          "detail-failed-suffix": ", {failed} បានបរាជ័យ"
        },
        "row": {
          "pending": "រង់ចាំ",
          "valid": "ត្រឹមត្រូវ",
          "invalid": "មិនត្រឹមត្រូវ",
          "warning": "ការព្រមាន"
        },
        "history": {
          "loading": "កំពុងផ្ទុកប្រវត្តិ…",
          "empty": "មិនមានប្រវត្តិការនាំចូលទេ។",
          "completed": "បានបញ្ចប់",
          "completed-errors": "បានបញ្ចប់ប៉ុន្តែមានកំហុស",
          "failed": "បានបរាជ័យ",
          "imported": "បាននាំចូល",
          "failed-rows": "បានបរាជ័យ",
          "batch-id": "លេខបាច់",
          "results": "លទ្ធផល",
          "dl-original": "ឯកសារផ្ទុកដើម",
          "dl-results": "លទ្ធផលការនាំចូល",
          "processing": "កំពុងដំណើរការ",
          "processing-note": "ការនាំចូលកំពុងដំណើរការ — ឯកសារនឹងមានបន្ទាប់ពីបញ្ចប់។",
          "results-detail": "បានជោគជ័យ {succeeded}, បានបរាជ័យ {failed} / សរុប {total}",
          "dl-sign-ins": "ការស្នើសុំគណនីចូលប្រើ"
        },
        "btn": {
          "back": "ត្រឡប់ក្រោយ",
          "done": "រួចរាល់"
        },
        "next": {
          "validation": "បន្ទាប់: ការផ្ទៀងផ្ទាត់",
          "confirm": "បន្ទាប់: បញ្ជាក់",
          "import": "នាំចូល"
        },
        "error": {
          "invalid-format": "សូមជ្រើសរើសឯកសារ .xlsx ត្រឹមត្រូវ។",
          "file-too-large": "ឯកសារធំជាង 5 MB។ សូមជ្រើសរើសឯកសារតូចជាងនេះ។",
          "empty-file": "ឯកសារដែលផ្ទុកឡើងមានទម្រង់ត្រឹមត្រូវ ប៉ុន្តែមិនមានកំណត់ត្រាបុគ្គលិកទេ។",
          "template-mismatch": "ឯកសារដែលផ្ទុកឡើងមិនត្រូវនឹងទម្រង់គំរូដែលរំពឹង។",
          "missing-columns": "ជួរឈរខ្វះ",
          "unexpected-columns": "ជួរឈរមិនរំពឹង",
          "read-failed": "មិនអាចអានឯកសារបានទេ។ សូមពិនិត្យទម្រង់ឯកសារ។",
          "validation-failed": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។",
          "import-failed": "ការនាំចូលបានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។",
          "download-failed": "មិនអាចទាញយកឯកសារបានទេ។ ឯកសារអាចមិនទាន់មានឡើយ។",
          "template-failed": "មិនអាចទាញយកគំរូបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "export-failed": "មិនអាចនាំចេញបុគ្គលិកបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "import-timeout": "ការនាំចូលចំណាយពេលយូរជាងការរំពឹង។ សូមពិនិត្យប្រវត្តិការនាំចូលសម្រាប់លទ្ធផលចុងក្រោយ។"
        },
        "instructions": {
          "title": "ការណែនាំ & តម្រូវការ",
          "general": "ទូទៅ",
          "no-delete-headers": "កុំលុបជួរដេកខាងលើ ឬកែប្រែចំណងជើងជួរឈរ — ប្រព័ន្ធអាចមិនយល់ទម្រង់ឯកសារដែលអ្នកផ្ទុក",
          "required-cols": "ជួរឈរដែលមានសញ្ញា (*) ចាំបាច់ត្រូវបំពេញ។ ការផ្ទៀងផ្ទាត់នឹងត្រូតពិនិត្យភាពពេញលេញ ប្រភេទទិន្នន័យ និងទម្រង់",
          "max-size": "ទំហំឯកសារអតិបរមា: 5 MB",
          "unique-note": "Employee_code, National_ID និង NSSF_ID មិនត្រូវស្ទួនគ្នាក្នុងឯកសារទេ។ Employee_code និង National_ID ក៏ត្រូវបានផ្ទៀងផ្ទាត់ជាមួយបុគ្គលិកដែលមានស្រាប់ក្នុងក្រុមហ៊ុននេះផងដែរ។",
          "dates": "ជួរឈរកាលបរិច្ឆេទ",
          "date-format": "បញ្ចូលកាលបរិច្ឆេទទាំងអស់ក្នុងទម្រង់ ISO: YYYY-MM-DD (ឧ. 2022-10-25)",
          "key-cols": "ចំណាំជួរឈរចំណុចសំខាន់",
          "employee-code": "Employee_code — ក្នុងរបៀប \"បន្ថែមថ្មីតែប៉ុណ្ណោះ\" ទុកទទេ ដើម្បីឱ្យប្រព័ន្ធផ្តល់លេខកូដ ឬបញ្ចូលលេខកូដដែលមិនទាន់មាននរណាប្រើក្នុងក្រុមហ៊ុននេះ។ ក្នុងរបៀប \"ធ្វើបច្ចុប្បន្នភាពដែលមានស្រាប់\" និង \"បន្ថែម ឬធ្វើបច្ចុប្បន្នភាព\" ត្រូវតែបំពេញ។ លេខកូដមិនអាចចាប់ផ្តើមដោយ G: បានទេ។",
          "contract-type": "Contract_type — បញ្ចូល UDC, FDC, PROBATION ឬ INTERNSHIP។",
          "contract-end-date": "Contract_end_date — ជាជម្រើស។ បញ្ចូលសម្រាប់កិច្ចសន្យាដែលមានថ្ងៃបញ្ចប់ (FDC, PROBATION, INTERNSHIP) ហើយទុកទទេសម្រាប់ UDC។ ការនាំចូលមិនតម្រូវឱ្យមានទេ ដូច្នេះសូមពិនិត្យមុនពេលផ្ទុកឡើង។",
          "report-to": "Report_to — Employee_code របស់អ្នកគ្រប់គ្រងផ្ទាល់៖ បុគ្គលិកដែលមានស្រាប់ ឬនរណាម្នាក់ក្នុងឯកសារតែមួយ។ ទុកទទេសម្រាប់តែបុគ្គលម្នាក់ដែលនៅកំពូលក្រុមហ៊ុនប៉ុណ្ណោះ។ លេខកូដបេសកកម្មក្រុម (G:SHORT:001) ដាក់ជួរដេកនោះនៅក្រោមតំណែងរបស់អ្នកគ្រប់គ្រងនោះ។",
          "username": "Username / User_email — ចាំបាច់។ ពួកវាត្រូវបានកត់ត្រាជាការស្នើសុំគណនីចូលប្រើ ហើយបង្ហាញក្នុងឯកសារ \"ការស្នើសុំគណនីចូលប្រើ\" បន្ទាប់ពីការនាំចូល។ គ្មានគណនីត្រូវបានបង្កើត ហើយគ្មានអ៊ីមែលត្រូវបានផ្ញើទេ។ ដើម្បីផ្តល់គណនីចូលប្រើដល់នរណាម្នាក់ សូមប្រើ បន្ថែមអ្នកប្រើ ក្នុង Admin › អ្នកប្រើ និងតួនាទី។ User_email ក៏ត្រូវបានប្រើជាអ៊ីមែលការងារ នៅពេល Work_contact_email ទទេ។",
          "repeatable": "ឈុតជួរឈរដែលអាចធ្វើម្ដងទៀត",
          "repeatable-note": "ជួរឈរខ្លះអាចធ្វើម្តងទៀតបាន។ បន្ថែមច្បាប់ចម្លងនៃចំណងជើងជួរឈរ ដែលបញ្ចប់ដោយ _2, _3 ជាដើម (ឧ. Child_full_name_2)៖",
          "not-saved": "ជួរឈរទាំងនេះ និងជួរឈរ NSSF ធនាគារ ប្តីឬប្រពន្ធ Available_AL_balance និង Remark ត្រូវបានពិនិត្យទម្រង់ ប៉ុន្តែការនាំចូលមិនទាន់រក្សាទុកពួកវានៅឡើយទេ។"
        }
      },
      "add-person": {
        "prefill": {
          "banner": "កំពុងបំពេញ {position}",
          "change": "ប្ដូរ",
          "not-found": "មុខតំណែងនោះមិនមែនជាកន្លែងទំនេរក្នុងក្រុមហ៊ុននេះទេ។ សូមជ្រើសរើសកន្លែងទំនេរនៅជំហានកិច្ចសន្យា។",
          "filled": "មុខតំណែងនោះលែងទំនេរហើយ — មានអ្នកកាន់រួចហើយ។ សូមជ្រើសរើសកន្លែងទំនេរផ្សេងនៅជំហានកិច្ចសន្យា។",
          "frozen": "មុខតំណែងនោះត្រូវបានបង្កក។ សូមឈប់បង្កកវានៅលើតារាងរចនាសម្ព័ន្ធ ឬជ្រើសរើសកន្លែងទំនេរផ្សេងនៅជំហានកិច្ចសន្យា។",
          "cancelled": "មុខតំណែងនោះត្រូវបានលុបចោល។ សូមជ្រើសរើសកន្លែងទំនេរផ្សេងនៅជំហានកិច្ចសន្យា។",
          "load-failed": "មិនអាចពិនិត្យមុខតំណែងនោះបានទេនៅពេលនេះ។ សូមជ្រើសរើសកន្លែងទំនេរនៅជំហានកិច្ចសន្យា។"
        }
      }
    },
    "common": {
      "cancel": "បោះបង់",
      "save": "រក្សាទុក",
      "edit": "កែសម្រួល",
      "retry": "ព្យាយាមម្តងទៀត",
      "confirm": "បញ្ជាក់",
      "yes": "បាទ/ចាស",
      "no": "ទេ",
      "remove": "លុបចេញ",
      "create": "បង្កើត",
      "clear": "សម្អាត",
      "clear-all": "សម្អាតទាំងអស់",
      "previous": "មុន",
      "next": "បន្ទាប់"
    },
    "organization": {
      "title": "អង្គភាព",
      "tabs": {
        "profile": "ប្រវត្តិរូប",
        "structure": "រចនាសម្ព័ន្ធ",
        "sites": "ទីតាំង",
        "outsourcing": "ការផ្គត់ផ្គង់ខាងក្រៅ"
      },
      "kind": {
        "company": "ក្រុមហ៊ុន",
        "os_client": "អតិថិជន",
        "os_vendor": "អ្នកផ្គត់ផ្គង់",
        "os_project": "គម្រោង",
        "unknown": "មិនស្គាល់"
      },
      "structure": {
        "org-units": "អង្គភាពរង",
        "org-chart": "តារាងរចនាសម្ព័ន្ធ",
        "positions": "មុខតំណែង",
        "workforce-plan": "ផែនការកម្លាំងពលកម្ម",
        "grades": "កម្រិតការងារ",
        "job-titles": "ឈ្មោះមុខតំណែង",
        "job-profiles": "ប្រវត្តិរូបការងារ"
      },
      "profile": {
        "edit": "កែសម្រួល",
        "edit-title": "កែសម្រួលក្រុមហ៊ុន",
        "industry": "វិស័យ",
        "employee-id-format": "ទម្រង់លេខសម្គាល់បុគ្គលិក",
        "website": "គេហទំព័រ",
        "address": "អាសយដ្ឋាន",
        "primary-contact": "ទំនាក់ទំនងចម្បង"
      },
      "form": {
        "company-full-name": "ឈ្មោះពេញរបស់ក្រុមហ៊ុន",
        "company-short-name": "ឈ្មោះខ្លីរបស់ក្រុមហ៊ុន",
        "project-full-name": "ឈ្មោះពេញរបស់គម្រោង",
        "project-short-name": "ឈ្មោះខ្លីរបស់គម្រោង",
        "short-name-hint": "ប្រើជាស្លាកខ្លី និងជាបុព្វបទលេខសម្គាល់បុគ្គលិក។",
        "client": "អតិថិជន",
        "client-none": "គ្មានអតិថិជនមេ",
        "employee-id-format": "ទម្រង់លេខសម្គាល់បុគ្គលិក",
        "employee-id-format-hint": "តម្លៃលំនាំដើម <ឈ្មោះខ្លី>-000000។ អាចកែបាន។",
        "industry": "វិស័យ",
        "website": "គេហទំព័រ",
        "address": "អាសយដ្ឋាន",
        "primary-contact": "ទំនាក់ទំនងចម្បង",
        "contact-name": "ឈ្មោះ",
        "contact-email": "អ៊ីមែល",
        "contact-phone": "ទូរស័ព្ទ",
        "notes": "កំណត់ចំណាំ",
        "create": "បង្កើត",
        "errors": {
          "full-name": "តម្រូវឱ្យមានឈ្មោះ។",
          "email": "សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ។"
        },
        "outsourcing-client-flag": "តើនេះជាអតិថិជនការផ្តល់សេវាបុគ្គលិកមែនទេ?",
        "outsourcing-client-hint": "សម្គាល់ក្រុមហ៊ុននេះជាអតិថិជនការផ្តល់សេវាបុគ្គលិក។ អ្នកគ្រប់គ្រងគម្រោង បុគ្គលិក និងអ្នកអនុម័តខាងក្រៅរបស់ពួកគេ។",
        "outsourcing-vendor-flag": "តើនេះជាអ្នកផ្គត់ផ្គង់ការផ្តល់សេវាបុគ្គលិកមែនទេ?",
        "outsourcing-vendor-hint": "សម្គាល់ក្រុមហ៊ុននេះជាអ្នកផ្គត់ផ្គង់ការផ្តល់សេវាបុគ្គលិក។ អ្នកតាមដានកម្មករប្រតិបត្តិការ ឯអ្នកផ្គត់ផ្គង់ដំណើរការប្រាក់ខែ។"
      },
      "outsourcing": {
        "shell-title": "ការផ្គត់ផ្គង់ខាងក្រៅ",
        "shell-desc": "គ្រប់គ្រងអតិថិជន ឬអ្នកផ្គត់ផ្គង់ខាងក្រៅ គម្រោងរបស់ពួកគេ និងអ្នកអនុម័តខាងក្រៅ ពីទីនេះ។",
        "shell-note": "នឹងមកដល់ឆាប់ៗ។",
        "clients-title": "អតិថិជន",
        "clients-section-desc": "អតិថិជនការផ្តល់សេវាដែលអ្នកផ្គត់ផ្គង់បុគ្គលិកឱ្យ។ បន្ថែមអតិថិជននៅពេលអ្នកទទួលយកកិច្ចការផ្តល់សេវាថ្មី។",
        "vendors-title": "អ្នកផ្គត់ផ្គង់",
        "vendors-section-desc": "អ្នកផ្គត់ផ្គង់ការផ្តល់សេវាដែលផ្គត់ផ្គង់បុគ្គលិកដល់អ្នក។ បន្ថែមអ្នកផ្គត់ផ្គង់នៅពេលអ្នកចាប់ផ្តើមទទួលបុគ្គលិកពីអ្នកផ្គត់ផ្គង់ថ្មី។",
        "add-client": "បន្ថែមអតិថិជន",
        "add-vendor": "បន្ថែមអ្នកផ្គត់ផ្គង់",
        "create-subtitle": "ព័ត៌មានលម្អិតផ្តល់ការកំណត់រចនាសម្ព័ន្ធពេញលេញដោយស្វ័យប្រវត្តិ។",
        "search-label": "ស្វែងរក",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះ ទំនាក់ទំនង វិស័យ…",
        "showing-clients": "បង្ហាញ {filtered} ក្នុងចំណោម {total} អតិថិជន",
        "showing-vendors": "បង្ហាញ {filtered} ក្នុងចំណោម {total} អ្នកផ្គត់ផ្គង់",
        "empty-clients": "មិនទាន់មានអតិថិជន។ បន្ថែមអតិថិជនដំបូងរបស់អ្នក។",
        "empty-vendors": "មិនទាន់មានអ្នកផ្គត់ផ្គង់។ បន្ថែមអ្នកផ្គត់ផ្គង់ដំបូងរបស់អ្នក។",
        "empty-filtered": "គ្មានដៃគូត្រូវនឹងការស្វែងរកបច្ចុប្បន្ន។",
        "error": "បរាជ័យក្នុងការផ្ទុកបញ្ជីនេះ។",
        "error-403": "អ្នកមិនមានសិទ្ធិចូលប្រើបញ្ជីនេះទេ។",
        "back-clients": "ត្រឡប់ទៅអតិថិជន",
        "back-vendors": "ត្រឡប់ទៅអ្នកផ្គត់ផ្គង់",
        "projects-title": "គម្រោង",
        "approvers-title": "អ្នកអនុម័ត",
        "projects-empty": "មិនទាន់មានគម្រោងក្រោមដៃគូនេះទេ។",
        "projects-error": "បរាជ័យក្នុងការផ្ទុកគម្រោង។",
        "back-to-projects": "ត្រឡប់ទៅគម្រោង",
        "project-under": "ក្រោម {parent}",
        "positions-title": "មុខតំណែង",
        "positions-count": "{filled} មាន · {vacant} ទំនេរ · {total} សរុប",
        "positions-empty": "ប្លង់អង្គភាពរបស់គម្រោងនេះមិនទាន់មានមុខតំណែងទេ។",
        "positions-error-title": "មិនអាចផ្ទុកមុខតំណែង",
        "positions-error-desc": "មានបញ្ហាក្នុងការផ្ទុកប្លង់អង្គភាពរបស់គម្រោងនេះ។",
        "position-vacant": "ទំនេរ",
        "position-untitled": "មុខតំណែងគ្មានចំណងជើង",
        "add-project": "បន្ថែមគម្រោង",
        "edit-project": "កែសម្រួលគម្រោង",
        "detail-error-title": "មិនអាចផ្ទុកដៃគូនេះបានទេ",
        "detail-error-desc": "មានបញ្ហាក្នុងការទាញយកព័ត៌មានលម្អិត។ សូមព្យាយាមម្តងទៀត។",
        "toasts": {
          "created": "\"{name}\" ត្រូវបានបង្កើត។",
          "create-failed": "មិនអាចបង្កើតបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "saved": "បានរក្សាទុកការផ្លាស់ប្តូរ។",
          "save-failed": "មិនអាចរក្សាទុកបានទេ។ សូមព្យាយាមម្តងទៀត។",
          "project-created": "គម្រោង \"{name}\" ត្រូវបានបង្កើត។",
          "project-saved": "បានរក្សាទុកគម្រោង។",
          "project-failed": "មិនអាចរក្សាទុកគម្រោងបានទេ។ សូមព្យាយាមម្តងទៀត។"
        },
        "oversight-title": "ការត្រួតពិនិត្យប្រតិបត្តិ"
      },
      "approvers": {
        "title": "អ្នកអនុម័តខាងក្រៅ",
        "invite": "អញ្ជើញអ្នកអនុម័ត",
        "explainer": "អ្នកអនុម័តខាងក្រៅ គឺជាប្រធានផ្នែករបស់អតិថិជន ដែលត្រូវបានដាក់ចូលក្នុងតួនាទីទំនេរនៅក្នុងតារាងអង្គភាពរបស់គម្រោងនេះ។ ពួកគេអនុម័តការច្បាប់ និងវត្តមានសម្រាប់បុគ្គលិករបស់គម្រោង។ ការអញ្ជើញពួកគេនឹងផ្ញើតំណភ្ជាប់ទទួលយកតាមអ៊ីមែល ហើយការទទួលយកនឹងបង្កើតការចូលប្រើ ESS ដែលកំណត់ត្រឹមគម្រោងនេះ។",
        "counterparty-explainer": "អ្នកអនុម័តខាងក្រៅ គឺជាប្រធានផ្នែករបស់អតិថិជន ដែលត្រូវបានដាក់ចូលក្នុងតួនាទីទំនេរនៅក្នុងតារាងអង្គភាពនៃគម្រោងរបស់អ្នក។ ពួកគេអនុម័តការច្បាប់ និងវត្តមានសម្រាប់បុគ្គលិកគម្រោង។ មនុស្សតែម្នាក់អាចគ្រប់គ្រងគម្រោងច្រើន ដោយការដាក់ចូលនីមួយៗត្រូវរៀបចំតាមគម្រោង។ ការអញ្ជើញនឹងផ្ញើតំណភ្ជាប់ទទួលយកតាមអ៊ីមែល ដែលបង្កើតការចូលប្រើ ESS កំណត់ត្រឹមគម្រោងនោះ។",
        "oversees": "គ្រប់គ្រងគម្រោង {n}",
        "edit-in-project": "កែសម្រួលការដាក់ចូលក្នុង {project}",
        "target-project": "គម្រោង",
        "target-project-placeholder": "ជ្រើសរើសគម្រោងដែលត្រូវដាក់អ្នកអនុម័តចូល",
        "empty-no-projects": "សូមបន្ថែមគម្រោងជាមុនសិន បន្ទាប់មកអញ្ជើញអ្នកអនុម័តឱ្យគ្រប់គ្រងវា។",
        "search-placeholder": "ស្វែងរកតាមឈ្មោះ លេខកូដ អ៊ីមែល លេខទូរស័ព្ទ…",
        "showing": "អ្នកអនុម័ត {n} នាក់",
        "empty": "មិនទាន់មានអ្នកអនុម័តខាងក្រៅទេ។ អញ្ជើញម្នាក់ដើម្បីអនុម័តសំណើសម្រាប់គម្រោងរបស់ដៃគូនេះ។",
        "empty-filtered": "គ្មានអ្នកអនុម័តត្រូវនឹងតម្រងរបស់អ្នកទេ។",
        "error": "មិនអាចផ្ទុកអ្នកអនុម័តបានទេ។",
        "filters": {
          "all": "ទាំងអស់"
        },
        "status": {
          "active": "សកម្ម",
          "invited": "បានអញ្ជើញ",
          "inactive": "អសកម្ម",
          "unknown": "មិនស្គាល់"
        },
        "invite-modal": {
          "title": "អញ្ជើញអ្នកអនុម័តខាងក្រៅ"
        },
        "edit": {
          "title": "កែសម្រួលអ្នកអនុម័តខាងក្រៅ",
          "status": "ស្ថានភាព"
        },
        "form": {
          "latin-name": "ឈ្មោះឡាតាំង",
          "latin-name-placeholder": "ឧ. Sok Somnang",
          "native-name": "ឈ្មោះជាតិ",
          "native-name-placeholder": "ឧ. សុខ សំណាង",
          "gender": "ភេទ",
          "gender-male": "ប្រុស",
          "gender-female": "ស្រី",
          "email": "អ៊ីមែលការងារ",
          "email-placeholder": "ឧ. name\\@client.com",
          "phone": "លេខទូរស័ព្ទ",
          "phone-placeholder": "ឧ. 012 345 678",
          "placement-heading": "ការដាក់ក្នុងតារាងអង្គភាព",
          "org-unit": "អង្គភាពរៀបចំ",
          "org-unit-placeholder": "ជ្រើសរើសអង្គភាព",
          "report-to": "តួនាទីរាយការណ៍ទៅ",
          "report-to-placeholder": "ជ្រើសរើសអ្នកដែលពួកគេរាយការណ៍ទៅ",
          "report-to-none": "(មិនរាយការណ៍ទៅអ្នកណាទេ)",
          "position": "តួនាទី",
          "position-placeholder": "ជ្រើសរើសតួនាទីទំនេរ",
          "position-hint": "ទាំងនេះជាតួនាទីទំនេរនៅក្នុងតារាងអង្គភាពរបស់គម្រោងនេះ។ បើតួនាទីមិនមាន សូមបង្កើតវាជាមុននៅអេក្រង់តារាងអង្គភាព។",
          "create": "បង្កើត"
        },
        "toasts": {
          "invite-sent": "បានបង្កើតអ្នកអនុម័តខាងក្រៅ — បានផ្ញើការអញ្ជើញតាមអ៊ីមែល។",
          "invite-failed": "មិនអាចបង្កើតអ្នកអនុម័តបានទេ។ សូមព្យាយាមម្ដងទៀត។",
          "saved": "បានរក្សាទុកការផ្លាស់ប្តូរ។",
          "save-failed": "មិនអាចរក្សាទុកបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        }
      },
      "error": {
        "title": "មិនអាចផ្ទុកក្រុមហ៊ុននេះបានទេ",
        "desc": "មានបញ្ហាក្នុងការទាញយកព័ត៌មានលម្អិតរបស់ក្រុមហ៊ុន។ សូមព្យាយាមម្តងទៀត។"
      },
      "no-company": {
        "title": "មិនបានជ្រើសរើសក្រុមហ៊ុន",
        "desc": "ជ្រើសរើសក្រុមហ៊ុនពីប្រអប់ប្តូរ ដើម្បីមើលប្រវត្តិរូប គោលការណ៍ និងរចនាសម្ព័ន្ធរបស់វា។"
      },
      "company-form": {
        "drawer-title": "បង្កើតក្រុមហ៊ុនថ្មី",
        "drawer-subtitle": "បន្ថែមក្រុមហ៊ុនថ្មីក្រោមអ្នកជួល។ វានឹងបង្ហាញនៅក្នុងកម្មវិធីប្ដូរវិសាលភាពនៅពេលបង្កើតរួច។",
        "emails": "អាសយដ្ឋានអ៊ីមែល",
        "email-n": "អ៊ីមែល #{n}",
        "add-email": "បន្ថែមអ៊ីមែលមួយទៀត",
        "phones": "លេខទូរស័ព្ទ",
        "phone-n": "ទូរស័ព្ទ #{n}",
        "add-phone": "បន្ថែមលេខទូរស័ព្ទមួយទៀត",
        "representatives": "អ្នកតំណាង",
        "representative-n": "អ្នកតំណាង #{n}",
        "add-representative": "បន្ថែមអ្នកតំណាងម្នាក់ទៀត",
        "toasts": {
          "created": "\"{name}\" ត្រូវបានបង្កើត។",
          "create-failed": "មិនអាចបង្កើតក្រុមហ៊ុនបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        },
        "base-location": {
          "legend": "ទីតាំងគោលចម្បង",
          "name": "ឈ្មោះទីតាំង",
          "name-placeholder": "ឧ. ការិយាល័យកណ្ដាល",
          "address": "អាសយដ្ឋាន",
          "address-placeholder": "ផ្លូវ អគារ ស្រុក…",
          "coordinates": "កូអរដោនេ (រយៈទទឹង, រយៈបណ្ដោយ)",
          "coordinates-hint": "កំណត់ដោយចុច ឬអូសម្ជុលលើផែនទី ឬវាយបញ្ចូលដោយផ្ទាល់។",
          "map-label": "ផែនទី — ចុច ឬអូសម្ជុលដើម្បីកំណត់ទីតាំង",
          "error": "ត្រូវការឈ្មោះទីតាំង និងកូអរដោនេត្រឹមត្រូវ។"
        }
      },
      "org-chart-editor": {
        "title": "ប្លង់អង្គភាព",
        "subtitle": "បង្កើត និងកែសម្រួលមុខតំណែង និងខ្សែរាយការណ៍សម្រាប់ក្រុមហ៊ុននេះ។",
        "canvas-title": "ប្លង់អង្គភាព",
        "layer-1": "ស្រទាប់ ១",
        "info-banner": "បង្ហាញគ្រប់មុខតំណែង និងខ្សែរាយការណ៍។ ប្រើម៉ឺនុយរបស់មុខតំណែងដើម្បីបំពេញ កែ ផ្លាស់ ប្ដូរ បង្កក ឬលុបចោល។ អូសផ្ទាំងដើម្បីផ្លាស់ទី ប្រើកង់ ឬរបារឧបករណ៍ដើម្បីពង្រីក។",
        "vacant": "ទំនេរ",
        "untitled": "មុខតំណែងគ្មានឈ្មោះ",
        "actions-menu": "សកម្មភាពមុខតំណែង",
        "actions-for": "សកម្មភាពមុខតំណែង",
        "expand": "ពង្រីក",
        "collapse": "បង្រួម",
        "search-ph": "ស្វែងរកមុខតំណែង អង្គភាព ឬបុគ្គល…",
        "error-header": "ប្លង់អង្គភាព",
        "status": {
          "active": "សកម្ម",
          "pending": "រង់ចាំ",
          "probation": "សាកល្បង",
          "on-leave": "ឈប់សម្រាក",
          "inactive-vacant": "អសកម្ម / ទំនេរ"
        },
        "counter": {
          "vacant": "ទំនេរ {n}",
          "disabled": "បិទ {n}"
        },
        "nav": {
          "title": "ការរុករកមុខតំណែង",
          "hint": "ចុចដើម្បីផ្ដោតលើសាខា",
          "hide": "លាក់ការរុករក",
          "show": "បង្ហាញការរុករក",
          "short": "រុករក",
          "empty": "គ្មានមុខតំណែងត្រូវនឹងការស្វែងរករបស់អ្នក។"
        },
        "toolbar": {
          "show-vacancies": "បង្ហាញមុខតំណែងទំនេរ",
          "default-view": "ទិដ្ឋភាពលំនាំដើម",
          "expand-all": "ពង្រីកទាំងអស់",
          "collapse-all": "បង្រួមទាំងអស់",
          "zoom-out": "បន្ថយ",
          "zoom-in": "ពង្រីក",
          "zoom-100": "កំណត់ ១០០%",
          "zoom-fit": "សមនឹងអេក្រង់",
          "reset-zoom": "កំណត់ផ្លាស់ទី និងពង្រីកឡើងវិញ",
          "reset-focus": "ត្រឡប់ទៅប្លង់ពេញ"
        },
        "chart": {
          "showing-focused": "កំពុងបង្ហាញសាខាក្រោម {name}។ ប្រើ «ត្រឡប់ទៅប្លង់ពេញ» ដើម្បីចេញ។"
        },
        "action": {
          "edit": "កែមុខតំណែង",
          "add-child": "បន្ថែមមុខតំណែងក្រោម",
          "move": "ផ្លាស់មុខតំណែង",
          "delete": "លុបមុខតំណែង",
          "disable": "បិទមុខតំណែង",
          "enable": "បើកមុខតំណែង",
          "swap": "ប្ដូរតួនាទី",
          "manage-roles": "គ្រប់គ្រងតួនាទីបន្ថែម",
          "temp-oversight-on": "បើកការត្រួតពិនិត្យបណ្ដោះអាសន្ន",
          "temp-oversight-off": "បិទការត្រួតពិនិត្យបណ្ដោះអាសន្ន"
        },
        "form": {
          "add-title": "បន្ថែមមុខតំណែងក្រោម",
          "edit-title": "កែមុខតំណែង",
          "org-unit": "អង្គភាពអង្គការ",
          "org-unit-ph": "ឧ. នាយកដ្ឋានទីផ្សារ",
          "reports-to": "រាយការណ៍ទៅ",
          "top-most": "មុខតំណែងកំពូល",
          "job-title": "ងារការងារ",
          "job-title-ph": "ឧ. វិស្វករសូហ្វវែរ",
          "base-location": "ទីតាំងមូលដ្ឋាន",
          "base-location-ph": "ជ្រើសរើសទីតាំងមូលដ្ឋាន",
          "base-location-loading": "កំពុងផ្ទុកទីតាំង…",
          "base-location-empty": "មិនមានទីតាំងមូលដ្ឋានត្រូវបានកំណត់",
          "advanced": "ជម្រើសកែសម្រួលកម្រិតខ្ពស់",
          "cascade-org-unit": "អនុវត្តអង្គភាពនេះទៅគ្រប់មុខតំណែងក្រោមផងដែរ។",
          "cascade-title": "ធ្វើបច្ចុប្បន្នភាពមុខតំណែងផ្សេងដែលប្រើងារការងារដូចគ្នាផងដែរ។",
          "required": "ត្រូវការ",
          "create": "បង្កើត",
          "code": "លេខកូដមុខតំណែង",
          "org-unit-layer": "{name} — ស្រទាប់ {layer}",
          "job-title-grade": "{title} — ថ្នាក់ {grade}",
          "job-title-below": "ងារការងារសកម្មដែលទាបជាងថ្នាក់ {grade} (ថ្នាក់នៃមុខតំណែងប្រធាន)។",
          "assistant": "ជំនួយការរបស់ប្រធានផ្ទាល់",
          "assistant-yes": "បាទ/ចាស",
          "assistant-no": "ទេ",
          "back": "ថយក្រោយ",
          "confirm-title": "បញ្ជាក់ការកែប្រែ",
          "confirm-ou": "ការនេះក៏ផ្លាស់មុខតំណែង {n} នៅក្រោមមុខតំណែងនេះទៅអង្គភាពថ្មីដែរ។",
          "confirm-title-count": "ការនេះក៏ប្ដូរងារការងារលើមុខតំណែងផ្សេងទៀតចំនួន {n} ដែរ។",
          "confirm-hint": "ថយក្រោយដើម្បីប្ដូរជម្រើស ឬបញ្ជាក់ដើម្បីរក្សាទុក។"
        },
        "move": {
          "title": "ផ្លាស់មុខតំណែង",
          "current": "ខ្សែរាយការណ៍បច្ចុប្បន្ន",
          "new": "ខ្សែរាយការណ៍ថ្មី",
          "new-ph": "ស្វែងរកមុខតំណែង",
          "warning": "ការផ្លាស់ខ្សែរាយការណ៍នឹងធ្វើបច្ចុប្បន្នភាពឋានានុក្រមភ្លាមៗ។",
          "position": "មុខតំណែង",
          "new-hint": "មិនអាចជ្រើសមុខតំណែងនៅក្រោមមុខតំណែងនេះ ប្រធានបច្ចុប្បន្ន ឬមុខតំណែងដែលបានបង្កក ឬលុបចោលបានទេ។",
          "no-results": "គ្មានមុខតំណែងដែលត្រូវគ្នា",
          "empty": "គ្មានមុខតំណែងផ្សេងទៀតដែលមុខតំណែងនេះអាចរាយការណ៍ទៅបានទេ។",
          "continue": "បន្ត",
          "confirm-title": "បញ្ជាក់ការប្ដូរខ្សែរាយការណ៍",
          "confirm-body": "{position} នឹងរាយការណ៍ទៅ {to} ជំនួសឱ្យ {from}។",
          "confirm-reports": "មុខតំណែង {n} នៅក្រោមវានឹងផ្លាស់ទៅជាមួយដែរ។",
          "confirm-cta": "ផ្លាស់មុខតំណែង"
        },
        "swap": {
          "title": "ប្ដូរមុខតំណែង",
          "current": "អ្នកកាន់តួនាទីបច្ចុប្បន្ន",
          "with": "ប្ដូរជាមួយ",
          "with-ph": "ជ្រើសរើសមុខតំណែង",
          "reason": "មូលហេតុ",
          "reason-ph": "ហេតុអ្វីបានជាប្ដូរតួនាទីទាំងនេះ?",
          "submit": "ប្ដូរ",
          "with-hint": "តែថ្នាក់ដូចគ្នាប៉ុណ្ណោះ។ មុខតំណែងដែលបានបង្កក ឬលុបចោល និងមុខតំណែងដែលកាន់ដោយបុគ្គលពីក្រុមហ៊ុនផ្សេង មិនត្រូវបានផ្ដល់ជូនទេ។",
          "empty": "គ្មានមុខតំណែងនៅថ្នាក់ដូចគ្នាដែលបុគ្គលនេះអាចប្ដូរជាមួយបានទេ។",
          "reason-too-long": "សូមសរសេរមូលហេតុមិនឱ្យលើស {max} តួអក្សរ។"
        },
        "manage-roles": {
          "title": "គ្រប់គ្រងមុខតំណែងបន្ថែម",
          "lede": "កំពុងគ្រប់គ្រងតួនាទីស្របគ្នាសម្រាប់ {name}។",
          "primary": "មុខតំណែងចម្បង",
          "additional": "មុខតំណែងបន្ថែម",
          "no-candidates": "គ្មានមុខតំណែងទំនេរសមរម្យដើម្បីត្រួតពិនិត្យ។",
          "vacant-only": "តែមុខតំណែងទំនេរប៉ុណ្ណោះ",
          "reason": "មូលហេតុ / ការបញ្ជាក់",
          "remove-title": "ដកមុខតំណែងបន្ថែមទាំងអស់",
          "remove-body": "{name} នឹងឈប់ដឹកនាំមុខតំណែងបន្ថែមចំនួន {n}។",
          "remove-all": "ដកមុខតំណែងបន្ថែមទាំងអស់",
          "remove-cta": "ដកទាំងអស់",
          "pick-one": "សូមជ្រើសយ៉ាងហោចណាស់មុខតំណែងមួយ។",
          "search-ph": "ស្វែងរកមុខតំណែង"
        },
        "vacant-drawer": {
          "open": "ទំនេរ",
          "title": "មុខតំណែងទំនេរ",
          "reports-to": "រាយការណ៍ទៅ",
          "subtitle": "មុខតំណែងដែលគ្មាននរណាកាន់។ បំពេញ ឬកែវា។",
          "title-scoped": "មុខតំណែងទំនេរក្នុង {name}",
          "search-ph": "ស្វែងរកតាមមុខតំណែង លេខកូដ អង្គភាព ឬទីតាំង",
          "count": "មុខតំណែងទំនេរ {count}",
          "count-filtered": "មុខតំណែងទំនេរ {count} ក្នុងចំណោម {total}",
          "download": "ទាញយក Excel",
          "reports-to-line": "រាយការណ៍ទៅ {name}",
          "fill": "បំពេញ",
          "fill-aria": "បំពេញ {name}",
          "edit": "កែ",
          "edit-aria": "កែ {name}",
          "empty": "គ្មានមុខតំណែងទំនេរទេ។",
          "empty-search": "គ្មានមុខតំណែងទំនេរដែលត្រូវនឹងការស្វែងរកនេះទេ។",
          "clear-search": "សម្អាតការស្វែងរក",
          "load-error": "យើងមិនអាចផ្ទុកមុខតំណែងបានទេ។",
          "retry": "ព្យាយាមម្ដងទៀត"
        },
        "disabled-drawer": {
          "open": "បានបង្កក",
          "title": "មុខតំណែងដែលបានបង្កក",
          "subtitle": "មុខតំណែងដែលបានបង្កកត្រូវបានលាក់ពីតារាងរចនាសម្ព័ន្ធ និងពីបញ្ជីជ្រើសរើសមុខតំណែងទាំងអស់។ ឈប់បង្កកវា ដើម្បីនាំវាត្រឡប់មកវិញ។",
          "title-scoped": "មុខតំណែងដែលបានបង្កកក្នុង {name}",
          "search-ph": "ស្វែងរកតាមមុខតំណែង លេខកូដ អង្គភាព ទីតាំង ឬអ្នកកាន់ចុងក្រោយ",
          "count": "មុខតំណែងដែលបានបង្កក {count}",
          "count-filtered": "មុខតំណែងដែលបានបង្កក {count} ក្នុងចំណោម {total}",
          "download": "ទាញយក Excel",
          "last-occupant": "អ្នកកាន់ចុងក្រោយ៖ {name}",
          "frozen-at-by": "បានបង្កកនៅ {date} ដោយ {who}",
          "frozen-at": "បានបង្កកនៅ {date}",
          "frozen-by": "បានបង្កកដោយ {who}",
          "frozen-unknown": "បានបង្កក (មិនបានកត់ត្រាកាលបរិច្ឆេទ)",
          "unfreeze": "ឈប់បង្កក",
          "unfreeze-aria": "ឈប់បង្កក {name}",
          "empty": "គ្មានមុខតំណែងដែលបានបង្កកទេ។",
          "empty-search": "គ្មានមុខតំណែងដែលបានបង្កកដែលត្រូវនឹងការស្វែងរកនេះទេ។",
          "clear-search": "សម្អាតការស្វែងរក",
          "load-error": "យើងមិនអាចផ្ទុកមុខតំណែងបានទេ។",
          "retry": "ព្យាយាមម្ដងទៀត"
        },
        "drawer": {
          "count": "មុខតំណែង {count}",
          "empty": "មិនទាន់មានអ្វីនៅទីនេះទេ។"
        },
        "export": "នាំចេញ",
        "toast": {
          "added": "បានបន្ថែមមុខតំណែង។",
          "updated": "បានធ្វើបច្ចុប្បន្នភាពមុខតំណែង។",
          "moved": "បានធ្វើបច្ចុប្បន្នភាពខ្សែរាយការណ៍។",
          "swapped": "បានប្ដូរតួនាទី។",
          "deleted": "បានលុបមុខតំណែង។",
          "disabled": "បានបិទមុខតំណែង។",
          "enabled": "បានបើកមុខតំណែង។",
          "oversight-disabled": "បានបិទការត្រួតពិនិត្យបណ្ដោះអាសន្ន។",
          "oversight-soon": "ការបើកការត្រួតពិនិត្យបណ្ដោះអាសន្ននឹងមកដល់ពេលក្រោយ។",
          "save-failed": "មិនអាចរក្សាទុកបានទេ។ សូមព្យាយាមម្ដងទៀត។",
          "cancelled": "បានលុបចោលមុខតំណែង។",
          "frozen": "បានបង្កកមុខតំណែង។",
          "unfrozen": "បានឈប់បង្កកមុខតំណែង។",
          "roles-removed": "បានដកមុខតំណែងបន្ថែម។",
          "oversight-on": "បានបើកការត្រួតពិនិត្យបណ្ដោះអាសន្ន។",
          "oversight-off": "បានបិទការត្រួតពិនិត្យបណ្ដោះអាសន្ន។",
          "acting-elsewhere": "{name} ធ្វើការឱ្យក្រុមហ៊ុនផ្សេង ដូច្នេះប្រវត្តិរូបរបស់គាត់បើកពីក្រុមហ៊ុននោះ។",
          "acting-unknown": "ប្រវត្តិរូបរបស់អ្នកស្ដីទីមិនមាននៅទីនេះទេ។"
        },
        "confirm": {
          "delete-title": "លុបមុខតំណែងនេះ?",
          "delete-body": "វានឹងលុបមុខតំណែងចេញពីប្លង់អង្គភាពជាអចិន្ត្រៃយ៍។ មានតែមុខតំណែងទំនេរគ្មានក្រោមប៉ុណ្ណោះអាចលុបបាន។",
          "disable-title": "បិទមុខតំណែងនេះ?",
          "disable-body": "មុខតំណែងនឹងត្រូវលាក់ពីប្លង់ និងគ្រប់បញ្ជីជ្រើស។ អ្នកអាចបើកវាឡើងវិញនៅពេលក្រោយ។",
          "enable-title": "បើកមុខតំណែងនេះ?",
          "enable-body": "មុខតំណែងនឹងបង្ហាញនៅក្នុងប្លង់ និងអាចជ្រើសរើសបានម្ដងទៀត។",
          "cancel-title": "លុបចោលមុខតំណែងនេះ?",
          "cancel-body": "មុខតំណែងនឹងចេញពីប្លង់ ការរាប់ និងគ្រប់បញ្ជីជ្រើស។ វានៅតែមានក្នុងមុខតំណែងជាស្ថានភាពបានលុបចោល ដែលអ្នកអាចស្ដារវាវិញបាន។",
          "freeze-title": "បង្កកមុខតំណែងនេះ?",
          "freeze-body": "មុខតំណែងនឹងត្រូវលាក់ពីប្លង់ និងគ្រប់បញ្ជីជ្រើស រហូតដល់អ្នកឈប់បង្កកវា។",
          "unfreeze-title": "ឈប់បង្កកមុខតំណែងនេះ?",
          "unfreeze-body": "មុខតំណែងនឹងបង្ហាញនៅលើប្លង់ ហើយអាចជ្រើសរើសបានម្ដងទៀត។",
          "oversight-off-title": "បិទការត្រួតពិនិត្យបណ្ដោះអាសន្ន?",
          "oversight-off-body": "{name} នឹងលែងមានអ្នកត្រួតពិនិត្យស្ដីទីទៀតហើយ។"
        },
        "error": {
          "title": "មិនអាចផ្ទុកប្លង់អង្គភាពបានទេ",
          "desc": "មានបញ្ហាពេលទាញយកមុខតំណែង។ សូមព្យាយាមម្ដងទៀត។"
        },
        "empty": {
          "title": "មិនទាន់មានប្លង់អង្គភាពទេ",
          "desc": "ក្រុមហ៊ុននេះគ្មានមុខតំណែង។ បន្ថែមមុខតំណែងកំពូលដើម្បីចាប់ផ្ដើម។"
        },
        "list-export": {
          "code": "លេខកូដ",
          "title": "ចំណងជើងមុខតំណែង",
          "orgUnit": "អង្គភាព",
          "baseLocation": "ទីតាំងមូលដ្ឋាន",
          "occupant": "អ្នកកាន់",
          "lastOccupant": "អ្នកកាន់ចុងក្រោយ",
          "status": "ស្ថានភាព",
          "reportsTo": "រាយការណ៍ទៅ",
          "frozenAt": "បានបង្កកនៅ",
          "frozenBy": "បានបង្កកដោយ",
          "failed": "មិនអាចបង្កើតឯកសារបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        },
        "menu": {
          "label": "សកម្មភាពសម្រាប់ {name}",
          "section": {
            "position": "មុខតំណែង",
            "position-vacant": "មុខតំណែង (ទំនេរ)",
            "employee": "បុគ្គលិក",
            "acting": "អ្នកស្ដីទី"
          },
          "item": {
            "fill": "បំពេញមុខតំណែង",
            "edit": "កែមុខតំណែង",
            "add-child": "បន្ថែមមុខតំណែងក្រោម",
            "move": "ផ្លាស់មុខតំណែង",
            "manage-roles": "គ្រប់គ្រងមុខតំណែងបន្ថែម",
            "remove-additional-roles": "ដកមុខតំណែងបន្ថែមទាំងអស់",
            "oversight-on": "បើកការត្រួតពិនិត្យបណ្ដោះអាសន្ន",
            "oversight-off": "បិទការត្រួតពិនិត្យបណ្ដោះអាសន្ន",
            "freeze": "បង្កកមុខតំណែង",
            "unfreeze": "ឈប់បង្កកមុខតំណែង",
            "cancel": "លុបចោលមុខតំណែង",
            "history": "ប្រវត្តិកែប្រែ",
            "view-profile": "មើលប្រវត្តិរូប",
            "promote": "តម្លើងឋានៈ",
            "transfer": "ផ្ទេរ",
            "redesignate": "ប្ដូរតួនាទី",
            "swap": "ប្ដូរមុខតំណែង",
            "view-acting": "មើលប្រវត្តិរូបអ្នកស្ដីទី"
          },
          "reason": {
            "init-root": "សូមរៀបចំមុខតំណែងនេះជាមុនសិន។",
            "top-move": "មុខតំណែងកំពូលគ្មានអ្នកគ្រប់គ្រងដែលត្រូវប្ដូរទេ។",
            "needs-active": "ត្រូវការបុគ្គលិកសកម្មនៅក្នុងមុខតំណែងនេះ។",
            "oversight-vacant": "មានតែមុខតំណែងទំនេរប៉ុណ្ណោះដែលអាចដាក់ក្រោមការត្រួតពិនិត្យបណ្ដោះអាសន្នបាន។",
            "no-grant": "សូមកំណត់ការត្រួតពិនិត្យប្រតិបត្តិសម្រាប់គម្រោងនេះជាមុនសិន។",
            "top-freeze": "មិនអាចបង្កកមុខតំណែងកំពូលបានទេ។",
            "top-cancel": "មិនអាចលុបចោលមុខតំណែងកំពូលបានទេ។",
            "vacate-first": "សូមធ្វើឱ្យមុខតំណែងនេះទំនេរជាមុនសិន។",
            "has-reports": "នៅមានមុខតំណែងរាយការណ៍មកវា។",
            "oversight-first": "សូមបិទការត្រួតពិនិត្យបណ្ដោះអាសន្នជាមុនសិន។",
            "acting-first": "សូមដកអ្នកស្ដីទី និងមុខតំណែងបន្ថែមជាមុនសិន។",
            "external": "កាន់កាប់ដោយអ្នកមកពីក្រុមហ៊ុនផ្សេង។",
            "acting-fill": "មានអ្នកកំពុងស្ដីទីក្នុងមុខតំណែងនេះ។"
          },
          "grant-link": "បើកការត្រួតពិនិត្យប្រតិបត្តិ"
        },
        "card": {
          "acting": "{name} (ត្រួតពិនិត្យបណ្ដោះអាសន្ន)",
          "assistant": "ជំនួយការ",
          "headcount": "អ្នករាយការណ៍ផ្ទាល់ {n} នាក់",
          "double-hat": "ក៏ដឹកនាំមុខតំណែង {n} ផងដែរ — បន្លិចវា",
          "orphan": {
            "missing": "រាយការណ៍ទៅមុខតំណែងដែលបាត់ — សូមផ្លាស់វា",
            "cancelled": "រាយការណ៍ទៅមុខតំណែងដែលបានលុបចោល — សូមផ្លាស់វា",
            "cycle": "ខ្សែរាយការណ៍របស់វាវិលត្រឡប់មកខ្លួនឯង — សូមផ្លាស់វា"
          },
          "orphan-move": "ផ្លាស់",
          "manager-frozen": "មុខតំណែងអ្នកគ្រប់គ្រងរបស់វាត្រូវបានបង្កក",
          "super-root": "មុខតំណែងកំពូល {n}",
          "super-root-aria": "{company} — ប្លង់ទាំងមូល មិនមែនជាមុខតំណែងទេ"
        },
        "summary": {
          "label": "សង្ខេបមុខតំណែង",
          "active": "សកម្ម {n}",
          "vacant": "ទំនេរ {n}",
          "frozen": "បានបង្កក {n}",
          "within": "ក្នុង {name}",
          "why-btn": "ហេតុអ្វីមានមុខតំណែងសកម្ម {n}?",
          "why-title": "ហេតុអ្វីមានមុខតំណែងសកម្ម {n}?",
          "why-people": "មនុស្ស {people} នាក់កាន់មុខតំណែងសកម្ម {n}។",
          "multi": "នៅក្នុងមុខតំណែង {n}៖",
          "acting": "មានអ្នកគ្រាន់តែស្ដីទីក្នុងមុខតំណែង {n}៖",
          "external": "កាន់កាប់ដោយអ្នកមកពីក្រុមហ៊ុនផ្សេង ({n})៖",
          "cancelled-link": "បានលុបចោល {n} — មើលក្នុងមុខតំណែង",
          "refresh": "ផ្ទុកឡើងវិញ",
          "close": "បិទ",
          "frozen-btn": "បានបង្កក"
        },
        "oversight": {
          "title": "បើកការត្រួតពិនិត្យបណ្ដោះអាសន្ន",
          "lede": "ជ្រើសរើសអ្នកត្រួតពិនិត្យ {position} ខណៈវានៅទំនេរ។",
          "overseer": "អ្នកត្រួតពិនិត្យ",
          "search-ph": "ស្វែងរកអ្នកត្រួតពិនិត្យ…",
          "loading": "កំពុងផ្ទុកអ្នកត្រួតពិនិត្យ…",
          "error": "មិនអាចផ្ទុកអ្នកត្រួតពិនិត្យបានទេ។",
          "empty": "ការត្រួតពិនិត្យប្រតិបត្តិរបស់គម្រោងនេះមិនមានអ្នកត្រួតពិនិត្យទេ។",
          "no-match": "គ្មានអ្នកត្រួតពិនិត្យត្រូវនឹងការស្វែងរករបស់អ្នកទេ។",
          "no-grant": "សូមកំណត់ការត្រួតពិនិត្យប្រតិបត្តិសម្រាប់គម្រោងនេះជាមុនសិន។",
          "save": "បើក",
          "pick-one": "សូមជ្រើសរើសអ្នកត្រួតពិនិត្យ។"
        },
        "history": {
          "title": "ប្រវត្តិកែប្រែ",
          "fields": {
            "assistant": "ជំនួយការ",
            "double-head": "មុខតំណែងបន្ថែម",
            "oversight": "ការត្រួតពិនិត្យបណ្ដោះអាសន្ន",
            "disabled": "បានបង្កក",
            "employee": "បុគ្គលិក",
            "code": "លេខកូដ"
          }
        }
      },
      "oversight": {
        "showing": "បង្ហាញ {filtered} ក្នុងចំណោម {total} កិច្ចការ",
        "confirm-remove": "លុប {name} ចេញពីអ្នកត្រួតពិនិត្យ?",
        "error": "មិនអាចផ្ទុកការចាត់តាំងត្រួតពិនិត្យបានទេ។",
        "toasts": {
          "overseer-removed": "អ្នកត្រួតពិនិត្យត្រូវបានលុប។",
          "remove-failed": "មិនអាចលុបអ្នកត្រួតពិនិត្យបានទេ។ សូមព្យាយាមមើលទិត។",
          "assigned": "ការចាត់តាំងត្រួតពិនិត្យត្រូវបានរក្សាទុក។",
          "assign-failed": "មិនអាចរក្សាទុកការចាត់តាំង។ សូមព្យាយាមមើលទិត។"
        }
      },
      "company": {
        "status": {
          "active": "សកម្ម",
          "inactive": "អសកម្ម",
          "unknown": "ស្ថានភាពមិនស្គាល់"
        },
        "parent": "ក្រុមហ៊ុនមេ",
        "parent-none": "គ្មាន (កម្រិតកំពូល)",
        "parent-hint": "មានតែអ្នកគ្រប់គ្រងអង្គភាពទេ ដែលអាចផ្លាស់ក្រុមហ៊ុនទៅក្រោមក្រុមហ៊ុនមេផ្សេង។",
        "emails": "អាសយដ្ឋានអ៊ីមែល",
        "phones": "លេខទូរស័ព្ទ",
        "representatives": "អ្នកតំណាង",
        "notes": "កំណត់ចំណាំ",
        "created": "បានបង្កើត",
        "updated": "បានកែប្រែចុងក្រោយ",
        "never-updated": "មិនទាន់បានកែប្រែតាំងពីបង្កើតមក",
        "by-at": "{who} · {when}",
        "history": "ប្រវត្តិកែប្រែ",
        "history-title": "ប្រវត្តិកែប្រែ — {name}",
        "id-format-locked": "ត្រូវបានចាក់សោ៖ លេខសម្គាល់បុគ្គលិកត្រូវបានចេញតាមទម្រង់នេះរួចហើយ ដូច្នេះមិនអាចប្ដូរបានទៀតទេ។",
        "id-format-open": "អាចប្ដូរបាន រហូតដល់មានបុគ្គលិកដំបូង។",
        "id-format-checking": "កំពុងពិនិត្យថាតើមានលេខសម្គាល់បុគ្គលិកត្រូវបានចេញហើយឬនៅ…",
        "id-format-unverified": "មិនអាចពិនិត្យថាតើលេខសម្គាល់បុគ្គលិកត្រូវបានចេញហើយឬនៅទេ ដូច្នេះទម្រង់នៅតែជាប់សោសិន។",
        "save-failed": "មិនអាចរក្សាទុកក្រុមហ៊ុនបានទេ។ សូមព្យាយាមម្ដងទៀត។",
        "forbidden": "អ្នកមិនមានសិទ្ធិកែប្រែក្រុមហ៊ុននេះទេ។",
        "parent-errors": {
          "SELF_PARENT": "ក្រុមហ៊ុនមិនអាចជាក្រុមហ៊ុនមេរបស់ខ្លួនឯងបានទេ។",
          "PARENT_NOT_FOUND": "ក្រុមហ៊ុនមេដែលបានជ្រើសលែងមានទៀតហើយ។ សូមផ្ទុកឡើងវិញ ហើយព្យាយាមម្ដងទៀត។",
          "PARENT_KIND_INVALID": "ក្រុមហ៊ុនដែលបានជ្រើសមិនអាចជាក្រុមហ៊ុនមេបានទេ (មិនអនុញ្ញាតអតិថិជន អ្នកផ្គត់ផ្គង់ ឬគម្រោងជួលបន្ត)។",
          "TENANT_ROOT_IMMUTABLE": "ក្រុមហ៊ុនផ្ទាល់របស់អង្គភាព មិនអាចផ្លាស់ទៅក្រោមក្រុមហ៊ុនផ្សេងបានទេ។",
          "CYCLE_DETECTED": "ការផ្លាស់ប្ដូរនេះនឹងបង្កើតរង្វង់នៅក្នុងរចនាសម្ព័ន្ធក្រុមហ៊ុន។",
          "DEPTH_EXCEEDED": "ការផ្លាស់ប្ដូរនេះនឹងធ្វើឱ្យរចនាសម្ព័ន្ធក្រុមហ៊ុនជ្រៅជាងកម្រិតអនុញ្ញាត។"
        },
        "fields": {
          "Organization": "ឈ្មោះ",
          "ParentId": "ក្រុមហ៊ុនមេ",
          "Industry": "វិស័យ",
          "EmployeeIdFormat": "ទម្រង់លេខសម្គាល់បុគ្គលិក",
          "Website": "គេហទំព័រ",
          "Emails": "អាសយដ្ឋានអ៊ីមែល",
          "PhoneNumbers": "លេខទូរស័ព្ទ",
          "Representatives": "អ្នកតំណាង",
          "Address": "អាសយដ្ឋាន",
          "Notes": "កំណត់ចំណាំ",
          "PrimaryContact": "អ្នកទំនាក់ទំនងចម្បង",
          "Status": "ស្ថានភាព",
          "LogoUpdatedAt": "ឡូហ្គោ"
        },
        "logo": {
          "title": "ឡូហ្គោក្រុមហ៊ុន",
          "alt": "ឡូហ្គោ {name}",
          "add": "បន្ថែមឡូហ្គោក្រុមហ៊ុន",
          "change": "ប្ដូរឡូហ្គោក្រុមហ៊ុន",
          "pick": "ជ្រើសរើសរូបភាព",
          "choose-other": "ជ្រើសរើសរូបភាពផ្សេង",
          "rules": "PNG, JPEG ឬ WEBP ទំហំមិនលើស 2 MB។ រូបភាពនឹងត្រូវកាត់ជាការ៉េ។",
          "crop-label": "ផ្ទៃកាត់រូប។ អូស ឬប្រើគ្រាប់ចុចព្រួញ ដើម្បីដាក់ទីតាំងរូបភាព; + និង − សម្រាប់ពង្រីក ឬបង្រួម។",
          "crop-hint": "អូសរូបភាព ដើម្បីដាក់វានៅក្នុងការ៉េ។",
          "zoom": "ពង្រីក/បង្រួម",
          "zoom-in": "ពង្រីក",
          "zoom-out": "បង្រួម",
          "save": "រក្សាទុកឡូហ្គោ",
          "remove": "ដកឡូហ្គោចេញ",
          "remove-confirm-title": "ដកឡូហ្គោក្រុមហ៊ុនចេញ?",
          "remove-confirm-body": "ក្រុមហ៊ុននឹងបង្ហាញអក្សរកាត់ជំនួសឱ្យឡូហ្គោ។",
          "errors": {
            "type": "អាចប្រើបានតែរូបភាព PNG, JPEG និង WEBP ប៉ុណ្ណោះ។",
            "size": "រូបភាពត្រូវតែតូចជាង 2 MB។",
            "empty": "ឯកសារនេះទទេ។",
            "read": "មិនអាចអានរូបភាពនេះបានទេ។ សូមសាកល្បងឯកសារផ្សេង។",
            "storage": "ការផ្ទុកឡើងមិនបានទៅដល់កន្លែងរក្សាទុកទេ។ សូមព្យាយាមម្ដងទៀត។",
            "generic": "មិនអាចរក្សាទុកឡូហ្គោបានទេ។ សូមព្យាយាមម្ដងទៀត។"
          },
          "toasts": {
            "saved": "បានរក្សាទុកឡូហ្គោ។",
            "removed": "បានដកឡូហ្គោចេញ។"
          }
        },
        "danger": {
          "title": "តំបន់គ្រោះថ្នាក់",
          "body": "លុបក្រុមហ៊ុននេះ និងអ្វីៗទាំងអស់ដែលវាមាន — បុគ្គលិក កិច្ចសន្យា មុខតំណែង ទីតាំង គោលការណ៍ មជ្ឈមណ្ឌលចំណាយ និងឡូហ្គោរបស់វា។ សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
          "delete": "លុបក្រុមហ៊ុន"
        },
        "purge": {
          "title": "លុបក្រុមហ៊ុន",
          "loading": "កំពុងពិនិត្យមើលអ្វីដែលនឹងត្រូវលុប…",
          "preview-failed": "មិនអាចផ្ទុកបញ្ជីអ្វីដែលនឹងត្រូវលុបបានទេ។",
          "blocked-title": "មិនទាន់អាចលុបក្រុមហ៊ុននេះបានទេ",
          "blockers": {
            "TENANT_EMPLOYER": "ក្រុមហ៊ុនផ្ទាល់របស់អង្គភាព មិនអាចលុបបានឡើយ។",
            "HAS_CHILD_EMPLOYERS": "នៅមានក្រុមហ៊ុន អតិថិជន អ្នកផ្គត់ផ្គង់ ឬគម្រោងផ្សេងទៀតនៅក្រោមក្រុមហ៊ុននេះ។ សូមលុប ឬផ្លាស់ពួកវាជាមុនសិន។"
          },
          "summary": "ការលុប {name} នឹងដកចេញធាតុចំនួន {total}៖",
          "family-col": "ប្រភេទ",
          "count-col": "ចំនួន",
          "logo-line": "ឡូហ្គោក្រុមហ៊ុន",
          "irreversible": "សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
          "confirm-label": "វាយលេខសម្គាល់ក្រុមហ៊ុន ដើម្បីបញ្ជាក់",
          "confirm-help": "វាយលេខសម្គាល់នេះឱ្យបានត្រឹមត្រូវ៖",
          "mismatch": "លេខសម្គាល់មិនត្រូវគ្នាទេ។",
          "delete": "លុបជាអចិន្ត្រៃយ៍",
          "progress-start": "កំពុងលុប…",
          "progress": "កំពុងលុប… នៅសល់ {remaining} ធាតុ (ជុំទី {pass})។",
          "stalled": "ការលុបបានឈប់ដំណើរការ ដោយនៅសល់ {remaining} ធាតុ។ សូមបិទប្រអប់នេះ ហើយព្យាយាមម្ដងទៀត ដើម្បីបន្ត។",
          "failed": "មិនអាចលុបក្រុមហ៊ុនបានទេ។",
          "toasts": {
            "done": "បានលុប \"{name}\"។"
          },
          "families": {
            "Employer": "កំណត់ត្រាក្រុមហ៊ុន បញ្ជីរាប់ និងគោលការណ៍",
            "Employee": "បុគ្គលិក",
            "EmployeeCode": "លេខកូដបុគ្គលិក",
            "Person": "កំណត់ត្រាផ្ទាល់ខ្លួន",
            "FamilyMember": "សមាជិកគ្រួសារ",
            "PersonDocument": "ឯកសារផ្ទាល់ខ្លួន",
            "BankDetail": "ព័ត៌មានធនាគារ",
            "EmployeeDocument": "ឯកសារបុគ្គលិក",
            "Insurance": "កំណត់ត្រាធានារ៉ាប់រង",
            "EmployeeSetting": "ការកំណត់បុគ្គលិក",
            "Contract": "កិច្ចសន្យា",
            "ContractEvent": "ព្រឹត្តិការណ៍កិច្ចសន្យា",
            "EmploymentChange": "ការផ្លាស់ប្ដូរការងារ",
            "EmploymentAction": "សកម្មភាពការងារ",
            "CompensationEvent": "ព្រឹត្តិការណ៍ប្រាក់បំណាច់",
            "Position": "មុខតំណែង",
            "OrgUnit": "អង្គភាពរង",
            "JobProfile": "ប្រវត្តិរូបការងារ",
            "JobGrade": "កម្រិតការងារ",
            "JobDescription": "ចំណងជើងការងារ",
            "BaseLocation": "ទីតាំង",
            "WorkZoneBatch": "បណ្ដុំតំបន់ការងារ",
            "Oversight": "ការត្រួតពិនិត្យថ្នាក់ប្រតិបត្តិ",
            "CostCenter": "មជ្ឈមណ្ឌលចំណាយ",
            "CostCenterCode": "លេខកូដមជ្ឈមណ្ឌលចំណាយ",
            "EmployeeBatch": "បណ្ដុំបុគ្គលិក",
            "Event": "ព្រឹត្តិការណ៍",
            "ActionRegistry": "បញ្ជីសកម្មភាព"
          }
        }
      }
    },
    "tenant-settings": {
      "title": "ការកំណត់កន្លែងធ្វើការ និងអ្នកជួល",
      "subtitle": "គ្រប់គ្រងប្រភេទអាជីវកម្ម វិក្កយបត្រ និងការកំណត់វេទិការបស់អង្គភាពអ្នក",
      "back": "ត្រឡប់ទៅ Admin",
      "live": "សកម្ម",
      "coming-soon": "នឹងមកដល់ឆាប់ៗ",
      "coming-soon-tag": "ឆាប់ៗ",
      "stub-toast": "{name} នឹងមកដល់ឆាប់ៗ",
      "denied": {
        "title": "ត្រូវការសិទ្ធិអ្នកគ្រប់គ្រងកំពូល",
        "body": "មានតែអ្នកគ្រប់គ្រងទូទាំងអ្នកជួលប៉ុណ្ណោះអាចគ្រប់គ្រងការកំណត់កន្លែងធ្វើការ។"
      },
      "business-type": {
        "title": "ប្រភេទអាជីវកម្ម",
        "desc": "ដំឡើងកន្លែងធ្វើការរបស់អ្នកទៅជាអ្នកផ្តល់សេវា EOR / ការផ្តល់សេវាបុគ្គលិក ឬត្រឡប់ទៅអង្គភាពធម្មតា។ អ្នកជួលជាអ្នកផ្តល់សេវាគ្រប់គ្រងអតិថិជន និងគម្រោង; អ្នកជួលធម្មតាគ្រប់គ្រងអ្នកផ្គត់ផ្គង់។",
        "provider-label": "អ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក",
        "status-provider": "អ្នកផ្តល់សេវា",
        "status-standard": "ធម្មតា",
        "hint-provider": "កន្លែងធ្វើការរបស់អ្នកត្រូវបានរៀបចំសម្រាប់ការផ្តល់សេវាបុគ្គលិក — អ្នកគ្រប់គ្រងអតិថិជន គម្រោង និងអ្នកអនុម័តខាងក្រៅ។",
        "hint-standard": "អង្គភាពធម្មតា។ បើកដើម្បីដំណើរការអាជីវកម្មការផ្តល់សេវាបុគ្គលិក (គ្រប់គ្រងអតិថិជន និងគម្រោង)។",
        "toggle-aria": "បិទ/បើកអ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក",
        "promoted": "កន្លែងធ្វើការត្រូវបានដំឡើងទៅជាអ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក។",
        "demoted": "កន្លែងធ្វើការត្រូវបានត្រឡប់ទៅអង្គភាពធម្មតា។",
        "error": "មិនអាចធ្វើបច្ចុប្បន្នភាពប្រភេទអាជីវកម្មបានទេ។ សូមព្យាយាមម្តងទៀត។",
        "demote-confirm-title": "បិទអ្នកផ្តល់សេវាការផ្តល់សេវាបុគ្គលិក?",
        "demote-confirm-desc": "វានឹងត្រឡប់កន្លែងធ្វើការរបស់អ្នកទៅអង្គភាពធម្មតា។",
        "demote-confirm-body": "អតិថិជន គម្រោង និងបុគ្គលិករបស់ពួកគេដែលមានស្រាប់ត្រូវបានរក្សាទុក — គ្រាន់តែលែងបង្ហាញជាការផ្តល់សេវាបុគ្គលិករហូតដល់អ្នកបើកវាឡើងវិញ។ អ្នកអាចបើកវាឡើងវិញនៅពេលណាក៏បាន។",
        "demote-confirm-cta": "បិទ"
      },
      "sections": {
        "billing": {
          "title": "វិក្កយបត្រ",
          "desc": "វិធីបង់ប្រាក់ វិក្កយបត្រ និងប្រវត្តិវិក្កយបត្រ។"
        },
        "address": {
          "title": "អាសយដ្ឋាន និងព័ត៌មានក្រុមហ៊ុន",
          "desc": "អាសយដ្ឋានចុះបញ្ជី និងព័ត៌មានច្បាប់។"
        },
        "subscription": {
          "title": "ការជាវ និងគម្រោង",
          "desc": "គម្រោងបច្ចុប្បន្ន កៅអី និងការបន្ត។"
        },
        "contacts": {
          "title": "ទំនាក់ទំនង",
          "desc": "ទំនាក់ទំនងចម្បង និងវិក្កយបត្រ។"
        }
      }
    },
    "errors": {
      "dialog": {
        "close": "បិទ",
        "badRequest": {
          "header": "មិនអាចបញ្ចប់សំណើបានទេ",
          "message": "យើងមិនអាចបញ្ចប់សំណើនោះបានទេ។ សូមពិនិត្យឡើងវិញ ហើយព្យាយាមម្តងទៀត។"
        },
        "forbidden": {
          "header": "អ្នកមិនមានសិទ្ធិចូលប្រើទេ",
          "message": "គណនីរបស់អ្នកមិនត្រូវបានអនុញ្ញាតឱ្យធ្វើបែបនេះទេ។ ប្រសិនបើអ្នកគិតថានេះជាកំហុស សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។"
        },
        "notFound": {
          "header": "រកមិនឃើញ",
          "message": "យើងរកមិនឃើញអ្វីដែលអ្នកកំពុងស្វែងរកទេ។ វាប្រហែលជាត្រូវបានផ្លាស់ទី ឬលុបចេញ។"
        },
        "server": {
          "header": "មានបញ្ហាកើតឡើងនៅខាងយើង",
          "message": "នេះជាបញ្ហារបស់យើង មិនមែនរបស់អ្នកទេ។ សូមព្យាយាមម្តងទៀតក្នុងពេលបន្តិចទៀត — ប្រសិនបើវានៅតែកើតឡើង សូមប្រាប់យើង។"
        },
        "network": {
          "header": "មិនអាចភ្ជាប់ទៅម៉ាស៊ីនមេបានទេ",
          "message": "យើងមិនអាចភ្ជាប់នៅពេលនេះបានទេ។ សូមពិនិត្យការតភ្ជាប់អ៊ីនធឺណិតរបស់អ្នក ហើយព្យាយាមម្តងទៀត។"
        }
      }
    },
    "admin": {
      "users": {
        "title": "អ្នកប្រើ និងតួនាទី",
        "subtitle": "គ្រប់គ្រងគណនីអ្នកប្រើ ការតភ្ជាប់បុគ្គលិក និងសិទ្ធិគ្រប់គ្រងក្រុមហ៊ុន។",
        "add": "បន្ថែមអ្នកប្រើ",
        "search-placeholder": "ស្វែងរកឈ្មោះអ្នកប្រើ ឈ្មោះ ឬអ៊ីមែល",
        "result-count": "អ្នកប្រើ {count} នាក់",
        "clear-filter": "សម្អាតតម្រង {name}",
        "clear-search": "សម្អាតការស្វែងរក",
        "clear-all": "សម្អាតទាំងអស់",
        "select-all": "ជ្រើសរើសអ្នកប្រើទាំងអស់",
        "select-row": "ជ្រើសរើស {name}",
        "row-actions": "សកម្មភាពសម្រាប់ {name}",
        "retry": "ព្យាយាមម្តងទៀត",
        "error": "មិនអាចផ្ទុកអ្នកប្រើបានទេ។ សូមព្យាយាមម្តងទៀត។",
        "error-403": "អ្នកមិនមានសិទ្ធិមើលអ្នកប្រើសម្រាប់ក្រុមហ៊ុននេះទេ។",
        "kpi": {
          "enabled": "បានបើក",
          "disabled": "បានបិទ",
          "admin": "អ្នកគ្រប់គ្រងក្រុមហ៊ុន",
          "temporary": "ពាក្យសម្ងាត់បណ្តោះអាសន្ន"
        },
        "cols": {
          "username": "ឈ្មោះអ្នកប្រើ",
          "employee": "បុគ្គលិក",
          "email": "អ៊ីមែល",
          "admin-companies": "ក្រុមហ៊ុនដែលគ្រប់គ្រង",
          "access": "ស្ថានភាពចូលប្រើ",
          "password": "ស្ថានភាពពាក្យសម្ងាត់",
          "actions": "សកម្មភាព",
          "role": "តួនាទី"
        },
        "access": {
          "enabled": "បានបើក",
          "disabled": "បានបិទ"
        },
        "password": {
          "temporary": "បណ្តោះអាសន្ន",
          "confirmed": "បានបញ្ជាក់",
          "unknown": "មិនស្គាល់"
        },
        "actions": {
          "edit-email": "កែអ៊ីមែល",
          "admin-company": "សិទ្ធិគ្រប់គ្រងក្រុមហ៊ុន",
          "enable": "បើកការចូលប្រើ",
          "disable": "បិទការចូលប្រើ",
          "delete": "លុបអ្នកប្រើ",
          "change-role": "ប្ដូរតួនាទី"
        },
        "empty": {
          "title": "មិនទាន់មានអ្នកប្រើទេ",
          "subtitle": "បន្ថែមអ្នកប្រើដើម្បីតភ្ជាប់គណនីចូលប្រើទៅបុគ្គលិក។"
        },
        "empty-filtered": {
          "title": "គ្មានអ្នកប្រើដែលត្រូវគ្នា",
          "subtitle": "សូមសាកល្បងស្វែងរកផ្សេង ឬសម្អាតតម្រង។"
        },
        "form": {
          "create-title": "បង្កើតអ្នកប្រើ",
          "create-subtitle": "តភ្ជាប់គណនីចូលប្រើទៅបុគ្គលិកដែលមានស្រាប់។",
          "edit-email-title": "កែអ៊ីមែលអ្នកប្រើ",
          "edit-email-subtitle": "ផ្លាស់ប្តូរអ៊ីមែលនៅលើគណនីរបស់អ្នកប្រើនេះ។",
          "admin-company-title": "សិទ្ធិគ្រប់គ្រងក្រុមហ៊ុន",
          "admin-company-subtitle": "ជ្រើសរើសក្រុមហ៊ុនណាដែលអ្នកប្រើនេះអាចគ្រប់គ្រងបាន។",
          "employee": "បុគ្គលិក",
          "employee-placeholder": "ជ្រើសរើសបុគ្គលិកដើម្បីតភ្ជាប់ទៅអ្នកប្រើនេះ",
          "employee-required": "សូមជ្រើសរើសបុគ្គលិកដើម្បីតភ្ជាប់។",
          "loading-employees": "កំពុងផ្ទុកបុគ្គលិក…",
          "username": "ឈ្មោះអ្នកប្រើ",
          "first-name": "នាមខ្លួន",
          "last-name": "នាមត្រកូល",
          "email": "អ៊ីមែល",
          "phone": "លេខទូរស័ព្ទ",
          "invalid-email": "អាសយដ្ឋានអ៊ីមែលមិនត្រឹមត្រូវ។",
          "new-email": "អ៊ីមែលថ្មី",
          "new-email-placeholder": "បញ្ចូលអ៊ីមែលថ្មី",
          "selected-user": "ព័ត៌មានអ្នកប្រើដែលបានជ្រើស",
          "managed-companies": "ក្រុមហ៊ុនកំពុងគ្រប់គ្រង",
          "managed-companies-desc": "ទាំងនេះគឺជាក្រុមហ៊ុនដែលអ្នកប្រើនេះកំពុងគ្រប់គ្រង។ លុបសិទ្ធិដោយប្រើប៊ូតុងនៅជួរនីមួយៗ។",
          "grant-more": "ផ្តល់សិទ្ធិគ្រប់គ្រងដល់ក្រុមហ៊ុនបន្ថែម",
          "grant-more-desc": "ជ្រើសរើសក្រុមហ៊ុនមួយ ឬច្រើនដើម្បីផ្តល់សិទ្ធិគ្រប់គ្រង។ បន្ទាប់មកអ្នកប្រើអាចគ្រប់គ្រងបុគ្គលិក ការកំណត់ និងវត្តមានសម្រាប់ពួកវា។",
          "remove-company": "ដកចេញ {name}",
          "no-companies": "គ្មានក្រុមហ៊ុនបានកំណត់",
          "no-more-companies": "គ្មានក្រុមហ៊ុនបន្ថែមទេ",
          "add": "បន្ថែម",
          "new": "ថ្មី",
          "create": "បង្កើត",
          "update": "ធ្វើបច្ចុប្បន្នភាព",
          "cancel": "បោះបង់"
        },
        "confirm": {
          "enable-title": "បើកអ្នកប្រើ?",
          "enable-message": "អ្នកប្រើនេះនឹងអាចចូលប្រើម្តងទៀត។",
          "enable": "បើក",
          "disable-title": "បិទអ្នកប្រើ?",
          "disable-message": "អ្នកប្រើនេះនឹងមិនអាចចូលប្រើបានទៀតទេ។",
          "disable": "បិទ",
          "delete-title": "លុបអ្នកប្រើ?",
          "delete-message": "នេះនឹងលុបគណនីចូលប្រើរបស់អ្នកប្រើជាអចិន្ត្រៃយ៍។ វាមិនអាចត្រឡប់វិញបានទេ។",
          "delete": "លុប",
          "cancel": "បោះបង់"
        },
        "toast": {
          "created": "បានបង្កើតអ្នកប្រើ {name}។",
          "create-error": "មិនអាចបង្កើតអ្នកប្រើបានទេ។",
          "updated": "បានធ្វើបច្ចុប្បន្នភាពអ្នកប្រើ។",
          "update-error": "មិនអាចធ្វើបច្ចុប្បន្នភាពអ្នកប្រើបានទេ។",
          "enabled": "បានបើក {name}។",
          "disabled": "បានបិទ {name}។",
          "deleted": "បានលុប {name}។",
          "action-error": "សកម្មភាពបានបរាជ័យ។ សូមព្យាយាមម្តងទៀត។"
        },
        "role": {
          "TenantAdmin": "អ្នកគ្រប់គ្រង",
          "TenantHR": "ធនធានមនុស្ស",
          "TenantUser": "អ្នកប្រើប្រាស់",
          "Unknown": "មិនស្គាល់"
        },
        "change-role": {
          "title": "ប្ដូរតួនាទី",
          "subtitle": "ជ្រើសរើសអ្វីដែលគណនីនេះអាចធ្វើបាន។",
          "role-label": "តួនាទី",
          "role-placeholder": "ជ្រើសរើសតួនាទី",
          "save": "រក្សាទុក",
          "saving": "កំពុងរក្សាទុក…",
          "done": "រួចរាល់",
          "sign-in-again": "ពួកគេត្រូវចាកចេញ ហើយចូលម្ដងទៀត ដើម្បីឱ្យតួនាទីថ្មីមានប្រសិទ្ធភាព។",
          "toast-changed": "{name} ឥឡូវជា {role}។",
          "toast-unchanged": "{name} មានតួនាទី {role} រួចហើយ។",
          "error-400": "តួនាទីនោះមិនមែនជាតួនាទីដែលគណនីនេះអាចមានបានទេ។",
          "error-403": "មានតែអ្នកគ្រប់គ្រងស្ថាប័នទេ ដែលអាចផ្ដល់ ឬដកតួនាទីអ្នកគ្រប់គ្រងបាន។",
          "error-404": "គណនីនេះមិនត្រូវបានភ្ជាប់ទៅក្រុមហ៊ុននេះទេ។",
          "error-409": "អ្នកមិនអាចប្ដូរតួនាទីផ្ទាល់ខ្លួនរបស់អ្នកបានទេ។",
          "error": "មិនអាចប្ដូរតួនាទីបានទេ។ សូមព្យាយាមម្ដងទៀត។"
        }
      },
      "costCenters": {
        "title": "មជ្ឈមណ្ឌលថ្លៃដើម",
        "subtitle": "លេខកូដដែលផ្នែកហិរញ្ញវត្ថុប្រើកត់ត្រាចំណាយ សម្រាប់ក្រុមហ៊ុនដែលកំពុងជ្រើស",
        "back": "ត្រឡប់ទៅរដ្ឋបាល",
        "add": "បន្ថែមមជ្ឈមណ្ឌលថ្លៃដើម",
        "retry": "ព្យាយាមម្តងទៀត",
        "no-match": "គ្មានមជ្ឈមណ្ឌលថ្លៃដើមត្រូវនឹងតម្រងទាំងនេះទេ។",
        "result-count": "បង្ហាញ {shown} ក្នុងចំណោម {total} មជ្ឈមណ្ឌលថ្លៃដើម",
        "status-filter": {
          "label": "ស្ថានភាព",
          "active": "សកម្ម",
          "inactive": "អសកម្ម",
          "all": "ទាំងអស់"
        },
        "search": {
          "label": "ស្វែងរកមជ្ឈមណ្ឌលថ្លៃដើម",
          "placeholder": "ស្វែងរកលេខកូដ ឈ្មោះ ឬការពិពណ៌នា"
        },
        "filter-chip": {
          "search": "ស្វែងរក៖ {value}",
          "remove": "ដកតម្រង {label}",
          "clear-all": "សម្អាតទាំងអស់"
        },
        "export": {
          "label": "នាំចេញ",
          "empty": "គ្មានអ្វីត្រូវនាំចេញទេ"
        },
        "cols": {
          "code": "លេខកូដ",
          "name": "ឈ្មោះ",
          "description": "ការពិពណ៌នា",
          "status": "ស្ថានភាព",
          "updated": "កែប្រែចុងក្រោយ",
          "actions": "សកម្មភាព"
        },
        "status": {
          "active": "សកម្ម",
          "inactive": "អសកម្ម",
          "unknown": "មិនស្គាល់"
        },
        "empty": {
          "title": "មិនទាន់មានមជ្ឈមណ្ឌលថ្លៃដើមនៅឡើយទេ",
          "desc": "បន្ថែមមជ្ឈមណ្ឌលថ្លៃដើមដែលក្រុមហ៊ុននេះប្រើកត់ត្រាចំណាយ។"
        },
        "actions": {
          "edit": "កែសម្រួល",
          "edit-aria": "កែសម្រួល {name}",
          "deactivate": "បិទដំណើរការ",
          "deactivate-aria": "បិទដំណើរការ {name}",
          "reactivate": "បើកដំណើរការឡើងវិញ",
          "reactivate-aria": "បើកដំណើរការ {name} ឡើងវិញ",
          "history": "ប្រវត្តិ",
          "history-aria": "ប្រវត្តិកែសម្រួលរបស់ {name}"
        },
        "confirm": {
          "deactivate-title": "បិទដំណើរការមជ្ឈមណ្ឌលថ្លៃដើម?",
          "deactivate-body": "{name} ({code}) នឹងលែងផ្តល់ជូនសម្រាប់ការកត់ត្រាថ្មីទៀតហើយ។ វានៅរក្សាលេខកូដរបស់វា ហើយអ្នកអាចបើកវាឡើងវិញបានគ្រប់ពេល។",
          "reactivate-title": "បើកដំណើរការមជ្ឈមណ្ឌលថ្លៃដើមឡើងវិញ?",
          "reactivate-body": "{name} ({code}) នឹងត្រូវផ្តល់ជូនសម្រាប់ការកត់ត្រាម្តងទៀត។"
        },
        "history": {
          "title": "ប្រវត្តិមជ្ឈមណ្ឌលថ្លៃដើម"
        },
        "form": {
          "add-title": "បន្ថែមមជ្ឈមណ្ឌលថ្លៃដើម",
          "add-desc": "មជ្ឈមណ្ឌលថ្លៃដើមថ្មីនឹងសកម្មភ្លាមៗ។",
          "edit-title": "កែសម្រួលមជ្ឈមណ្ឌលថ្លៃដើម",
          "name": "ឈ្មោះ",
          "name-placeholder": "ឧ. ចំណាយធនធានមនុស្ស និងរដ្ឋបាល",
          "code": "លេខកូដ",
          "code-placeholder": "ឧ. HRADMIN",
          "code-hint": "មិនត្រូវស្ទួនក្នុងក្រុមហ៊ុននេះ។ អក្សរធំ/តូច និងដកឃ្លាលើសមិនត្រូវបានគិតពេលប្រៀបធៀបទេ។",
          "description": "ការពិពណ៌នា",
          "description-placeholder": "ស្រេចចិត្ត",
          "cancel": "បោះបង់",
          "save": "រក្សាទុកការផ្លាស់ប្តូរ",
          "create": "បន្ថែមមជ្ឈមណ្ឌលថ្លៃដើម",
          "reload": "ផ្ទុកឡើងវិញ",
          "errors": {
            "name-required": "សូមបញ្ចូលឈ្មោះ។",
            "name-too-long": "ប្រើមិនលើសពី {max} តួអក្សរ។",
            "code-required": "សូមបញ្ចូលលេខកូដ។",
            "code-too-long": "ប្រើមិនលើសពី {max} តួអក្សរ។",
            "code-hash": "លេខកូដមិនអាចមានសញ្ញា \"#\" បានទេ។",
            "description-too-long": "ប្រើមិនលើសពី {max} តួអក្សរ។",
            "code-taken": "មជ្ឈមណ្ឌលថ្លៃដើមផ្សេងទៀតរបស់ក្រុមហ៊ុននេះកំពុងប្រើលេខកូដនេះរួចហើយ។",
            "version-conflict": "មាននរណាម្នាក់បានកែប្រែមជ្ឈមណ្ឌលថ្លៃដើមនេះ ចាប់តាំងពីអ្នកបានបើកវា។ សូមផ្ទុកវាឡើងវិញ ហើយធ្វើការផ្លាស់ប្តូររបស់អ្នកម្តងទៀត។"
          }
        },
        "errors": {
          "load": "មិនអាចផ្ទុកមជ្ឈមណ្ឌលថ្លៃដើមបានទេ។",
          "forbidden": "អ្នកមិនមានសិទ្ធិកែប្រែមជ្ឈមណ្ឌលថ្លៃដើមសម្រាប់ក្រុមហ៊ុននេះទេ។",
          "not-found": "មជ្ឈមណ្ឌលថ្លៃដើមនេះលែងមានទៀតហើយ។",
          "no-company": "សូមជ្រើសរើសក្រុមហ៊ុនជាមុនសិន។",
          "generic": "មិនអាចរក្សាទុកការផ្លាស់ប្តូរបានទេ។ សូមព្យាយាមម្តងទៀត។"
        }
      }
    },
    "scope": {
      "all-scopes": "គ្រប់វិសាលភាព",
      "all-companies": "គ្រប់ក្រុមហ៊ុន",
      "this-company": "ក្រុមហ៊ុននេះ",
      "tenant-fallback": "អង្គភាព",
      "hint": "បរិបទកម្មសិទ្ធិ",
      "breadcrumb-label": "វិសាលភាពសកម្ម",
      "kind": {
        "oversight": "គ្រប់វិសាលភាព · ត្រួតពិនិត្យ",
        "company": "ក្រុមហ៊ុន",
        "client": "អតិថិជន",
        "vendor": "អ្នកផ្គត់ផ្គង់",
        "project": "គម្រោង",
        "direct": "ផ្ទាល់"
      },
      "empty-notice": "គ្មានកំណត់ត្រា {label} សម្រាប់ {company} ទេ។ ទាំងនេះត្រូវបានកត់ត្រាតាមក្រុមហ៊ុនប្រតិបត្តិការនីមួយៗ — ក្រុមហ៊ុននេះគ្មាននៅក្នុងទិន្នន័យគំរូ។ សូមប្តូរទៅក្រុមហ៊ុនប្រតិបត្តិការ ឬ គ្រប់វិសាលភាព។",
      "direct-workforce": "កម្លាំងពលកម្មផ្ទាល់",
      "direct-path-label": "{company} (ផ្ទាល់)"
    },
    "legal": {
      "back-to-sign-in": "ត្រឡប់ទៅចូលគណនី",
      "terms": {
        "title": "លក្ខខណ្ឌប្រើប្រាស់",
        "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖ ថ្ងៃទី 16 ខែមិថុនា ឆ្នាំ 2026",
        "contact": "មានសំណួរអំពីលក្ខខណ្ឌទាំងនេះឬ? សូមទាក់ទងយើងតាម {email}។",
        "sections": [
          {
            "heading": "1. សេចក្ដីផ្ដើម",
            "body": "លក្ខខណ្ឌប្រើប្រាស់ទាំងនេះគ្រប់គ្រងការចូលប្រើ និងការប្រើប្រាស់វេទិកា OptimalHR ដែលជាសេវាគ្រប់គ្រងធនធានមនុស្សពហុអតិថិជន ដំណើរការដោយក្រុមហ៊ុន Optimal P HR Strategic Partner Co., Ltd។ ដោយចូលគណនី ឬប្រើប្រាស់សេវានេះ អ្នកយល់ព្រមនឹងលក្ខខណ្ឌទាំងនេះក្នុងនាមអង្គភាពរបស់អ្នក។"
          },
          {
            "heading": "2. គណនី និងការចូលប្រើ",
            "body": "ការចូលប្រើត្រូវបានផ្ដល់ដោយអ្នកគ្រប់គ្រង HR នៃអង្គភាពរបស់អ្នក។ អ្នកទទួលខុសត្រូវក្នុងការរក្សាការសម្ងាត់នៃព័ត៌មានសម្គាល់ខ្លួន និងសកម្មភាពទាំងអស់ក្រោមគណនីរបស់អ្នក។ សូមជូនដំណឹងដល់អ្នកគ្រប់គ្រងភ្លាមៗ ប្រសិនបើអ្នកសង្ស័យថាមានការចូលប្រើដោយគ្មានការអនុញ្ញាត។"
          },
          {
            "heading": "3. ការប្រើប្រាស់ដែលអាចទទួលយកបាន",
            "body": "អ្នកយល់ព្រមមិនប្រើប្រាស់សេវាខុស មិនព្យាយាមចូលប្រើទិន្នន័យរបស់អតិថិជនផ្សេង មិនរំខានដល់ដំណើរការធម្មតា ឬប្រើវេទិកាក្នុងការបំពានច្បាប់កម្ពុជា ឬបទប្បញ្ញត្តិការងារដែលគ្រប់គ្រងអង្គភាពរបស់អ្នក។"
          },
          {
            "heading": "4. ទិន្នន័យអតិថិជន",
            "body": "អង្គភាពរបស់អ្នកជាម្ចាស់ទិន្នន័យបុគ្គលិក និងបៀវត្សដែលបានបញ្ជូន។ យើងដំណើរការទិន្នន័យនោះតែដើម្បីផ្ដល់សេវា ក្រោមការគ្រប់គ្រងការបំបែកទិន្នន័យដែលបានពិពណ៌នាក្នុងគោលនយោបាយឯកជនភាពរបស់យើង។ យើងមិនលក់ទិន្នន័យអតិថិជនទេ។"
          },
          {
            "heading": "5. ភាពអាចរកបាននៃសេវា",
            "body": "យើងព្យាយាមរក្សាភាពអាចរកបានខ្ពស់ ប៉ុន្តែមិនធានាសេវាដែលគ្មានការរំខានទេ។ ការថែទាំ និងការធ្វើបច្ចុប្បន្នភាពតាមកាលវិភាគអាចប៉ះពាល់ការចូលប្រើជាបណ្ដោះអាសន្ន។ ឧប្បត្តិហេតុសំខាន់ៗត្រូវបានជូនដំណឹងដល់អ្នកគ្រប់គ្រងអតិថិជន។"
          },
          {
            "heading": "6. ការផ្លាស់ប្ដូរលក្ខខណ្ឌ",
            "body": "យើងអាចធ្វើបច្ចុប្បន្នភាពលក្ខខណ្ឌទាំងនេះពីពេលមួយទៅពេលមួយ។ ការផ្លាស់ប្ដូរសំខាន់ៗនឹងត្រូវជូនដំណឹងដល់អ្នកគ្រប់គ្រងអតិថិជនមុនពេលមានប្រសិទ្ធភាព។ ការបន្តប្រើបន្ទាប់ពីការផ្លាស់ប្ដូរ ចាត់ទុកជាការយល់ព្រម។"
          }
        ]
      },
      "privacy": {
        "title": "គោលនយោបាយឯកជនភាព",
        "updated": "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ៖ ថ្ងៃទី 16 ខែមិថុនា ឆ្នាំ 2026",
        "contact": "សម្រាប់សំណើ ឬសំណួរអំពីឯកជនភាព សូមទាក់ទងយើងតាម {email}។",
        "sections": [
          {
            "heading": "សេចក្ដីផ្ដើម",
            "body": "គោលនយោបាយឯកជនភាពនេះពន្យល់ពីរបៀបដែល OptimalHR ប្រមូល ប្រើ រក្សាទុក និងការពារព័ត៌មានផ្ទាល់ខ្លួនដែលដំណើរការតាមរយៈវេទិកា។ វាអនុវត្តចំពោះគ្រប់បរិស្ថាន (Dev, Staging, Prod) ដែលដំណើរការសម្រាប់អង្គភាពរបស់អ្នក។"
          },
          {
            "heading": "ទិន្នន័យដែលយើងប្រមូល",
            "body": "យើងដំណើរការទិន្នន័យប្រវត្តិរូបបុគ្គលិក ព័ត៌មានទំនាក់ទំនង កំណត់ត្រាការងារ និងកិច្ចសន្យា វត្តមាន ការឈប់សម្រាក ម៉ោងបន្ថែម និងព័ត៌មានបៀវត្ស ដែលអង្គភាពរបស់អ្នកបញ្ចូល ឬផ្ទុកឡើង។ ទិន្នន័យផ្ទៀងផ្ទាត់ត្រូវបានគ្រប់គ្រងដោយ Amazon Cognito។"
          },
          {
            "heading": "របៀបដែលយើងប្រើទិន្នន័យ",
            "body": "ទិន្នន័យផ្ទាល់ខ្លួនត្រូវបានប្រើតែដើម្បីផ្ដល់សេវា HR ដែលអង្គភាពរបស់អ្នកបានកំណត់ — ដំណើរការបៀវត្ស តាមដានវត្តមាន និងការឈប់សម្រាក នាំផ្លូវការអនុម័ត និងបង្កើតរបាយការណ៍។ យើងមិនប្រើវាសម្រាប់ការផ្សាយពាណិជ្ជកម្មទេ។"
          },
          {
            "heading": "ការបំបែកទិន្នន័យ និងសុវត្ថិភាព",
            "body": "OptimalHR ប្រើស្ថាបត្យកម្មពហុអតិថិជន ដោយការបំបែកត្រូវបានអនុវត្តនៅកម្រិតមូលដ្ឋានទិន្នន័យ (គោលការណ៍ IAM)។ ទិន្នន័យរបស់អតិថិជននីមួយៗត្រូវបានបែងចែក និងគ្រប់គ្រងការចូលប្រើ ដូច្នេះវាមិនអាចត្រូវបានអានដោយអតិថិជនផ្សេងទេ។ លេខសម្គាល់រសើបមិនដែលត្រូវបានសរសេរទៅក្នុងកំណត់ហេតុប្រតិបត្តិការទេ។"
          },
          {
            "heading": "ការរក្សាទុកទិន្នន័យ",
            "body": "យើងរក្សាទុកទិន្នន័យផ្ទាល់ខ្លួនរយៈពេលដែលអង្គភាពរបស់អ្នករក្សាការជាវ និងតាមតម្រូវការនៃច្បាប់ការងារ និងពន្ធកម្ពុជា។ នៅពេលបញ្ចប់ ទិន្នន័យត្រូវបានលុប ឬប្រគល់មកវិញតាមការណែនាំរបស់អង្គភាពអ្នក។"
          },
          {
            "heading": "សិទ្ធិរបស់អ្នក",
            "body": "បុគ្គលិកអាចស្នើសុំការចូលប្រើ ឬកែតម្រូវទិន្នន័យផ្ទាល់ខ្លួនរបស់ខ្លួនតាមរយៈអ្នកគ្រប់គ្រង HR។ អ្នកគ្រប់គ្រងអាចដោះស្រាយសំណើទាំងនេះក្នុងវេទិកា ឬដោយទាក់ទងក្រុមជំនួយរបស់យើង។"
          },
          {
            "heading": "ទំនាក់ទំនង",
            "body": "សំណួរអំពីឯកជនភាពត្រូវបានដោះស្រាយដោយអ្នកទំនាក់ទំនងការពារទិន្នន័យរបស់យើងខាងក្រោម។ យើងឆ្លើយតបទៅសំណើដែលបានផ្ទៀងផ្ទាត់ក្នុងរយៈពេលសមរម្យ។"
          }
        ]
      }
    },
    "own": {
      "direct-workforce": "កម្លាំងពលកម្មផ្ទាល់",
      "company-root": "{name} · ឫសក្រុមហ៊ុន",
      "commercial-owner": "{name} · ម្ចាស់ពាណិជ្ជកម្ម",
      "these-operations": "ប្រតិបត្តិការទាំងនេះ",
      "refusal": {
        "unit": "{label} ធ្វើឡើងនៅវិសាលភាពម្ចាស់កម្មសិទ្ធិ (កម្លាំងពលកម្មផ្ទាល់ / គម្រោង) — ការត្រួតពិនិត្យគឺសម្រាប់តែការពិនិត្យមើលប៉ុណ្ណោះ។",
        "company": "{label} ជាទិន្នន័យយោងដែលក្រុមហ៊ុនជាម្ចាស់ — សូមគ្រប់គ្រងវានៅក្នុងបរិបទក្រុមហ៊ុន (ឫសក្រុមហ៊ុន)។",
        "governance": "{label} ជាអភិបាលកិច្ចកម្រិតក្រុមហ៊ុន — សូមគ្រប់គ្រងវានៅក្នុងបរិបទក្រុមហ៊ុន (ឫសក្រុមហ៊ុន)។",
        "commercial": "{label} ជាកម្មសិទ្ធិរបស់ម្ចាស់ពាណិជ្ជកម្មនៅឫសក្រុមហ៊ុនអ្នកផ្តល់សេវា — វិសាលភាពនេះជាទិដ្ឋភាពពាណិជ្ជកម្មសម្រាប់អានតែប៉ុណ្ណោះ។"
      }
    },
    "demo": {
      "reset": {
        "button": "កំណត់ទិន្នន័យសាកល្បង {module} ឡើងវិញ",
        "title": "ស្ដារទិន្នន័យមូលដ្ឋានសាកល្បង {module} ដែលកំណត់ជាមុន",
        "ask": "កំណត់ទិន្នន័យសាកល្បង {module} ទាំងអស់ត្រឡប់ទៅមូលដ្ឋានវិញ?",
        "keep": "រក្សាទុក",
        "go": "កំណត់ទិន្នន័យសាកល្បងឡើងវិញ",
        "flash": "ទិន្នន័យសាកល្បង {module} ត្រូវបានកំណត់ត្រឡប់ទៅមូលដ្ឋានដែលកំណត់ជាមុនវិញ។"
      }
    }
  }
}
